!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AirDatepicker=t():e.AirDatepicker=t()}(this,(function(){return function(){"use strict";var e={d:function(t,i){for(var s in i)e.o(i,s)&&!e.o(t,s)&&Object.defineProperty(t,s,{enumerable:!0,get:i[s]})},o:function(e,t){return Object.prototype.hasOwnProperty.call(e,t)}},t={};e.d(t,{default:function(){return K}});var i={days:"days",months:"months",years:"years",day:"day",month:"month",year:"year",eventChangeViewDate:"changeViewDate",eventChangeCurrentView:"changeCurrentView",eventChangeFocusDate:"changeFocusDate",eventChangeSelectedDate:"changeSelectedDate",eventChangeTime:"changeTime",eventChangeLastSelectedDate:"changeLastSelectedDate",actionSelectDate:"selectDate",actionUnselectDate:"unselectDate",cssClassWeekend:"-weekend-"},s={classes:"",inline:!1,locale:{days:["Воскресенье","Понедельник","Вторник","Среда","Четверг","Пятница","Суббота"],daysShort:["Вос","Пон","Вто","Сре","Чет","Пят","Суб"],daysMin:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthsShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],today:"Сегодня",clear:"Очистить",dateFormat:"dd.MM.yyyy",timeFormat:"HH:mm",firstDay:1},startDate:new Date,firstDay:"",weekends:[6,0],dateFormat:"",altField:"",altFieldDateFormat:"T",toggleSelected:!0,keyboardNav:!0,selectedDates:!1,container:"",isMobile:!1,visible:!1,position:"bottom left",offset:12,view:i.days,minView:i.days,showOtherMonths:!0,selectOtherMonths:!0,moveToOtherMonthsOnSelect:!0,showOtherYears:!0,selectOtherYears:!0,moveToOtherYearsOnSelect:!0,minDate:"",maxDate:"",disableNavWhenOutOfRange:!0,multipleDates:!1,multipleDatesSeparator:", ",range:!1,dynamicRange:!0,buttons:!1,monthsField:"monthsShort",showEvent:"focus",autoClose:!1,prevHtml:'<svg><path d="M 17,12 l -5,5 l 5,5"></path></svg>',nextHtml:'<svg><path d="M 14,12 l 5,5 l -5,5"></path></svg>',navTitles:{days:"MMMM, <i>yyyy</i>",months:"yyyy",years:"yyyy1 - yyyy2"},timepicker:!1,onlyTimepicker:!1,dateTimeSeparator:" ",timeFormat:"",minHours:0,maxHours:24,minMinutes:0,maxMinutes:59,hoursStep:1,minutesStep:1,onSelect:!1,onChangeViewDate:!1,onChangeView:!1,onRenderCell:!1,onShow:!1,onHide:!1,onClickDayName:!1};function a(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:document;return"string"==typeof e?t.querySelector(e):e}function n(){let{tagName:e="div",className:t="",innerHtml:i="",id:s="",attrs:a={}}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=document.createElement(e);return t&&n.classList.add(...t.split(" ")),s&&(n.id=s),i&&(n.innerHTML=i),a&&r(n,a),n}function r(e,t){for(let[i,s]of Object.entries(t))void 0!==s&&e.setAttribute(i,s);return e}function h(e){return new Date(e.getFullYear(),e.getMonth()+1,0).getDate()}function o(e){let t=e.getHours(),{hours:i,dayPeriod:s}=l(t);return{year:e.getFullYear(),month:e.getMonth(),fullMonth:e.getMonth()+1<10?"0"+(e.getMonth()+1):e.getMonth()+1,date:e.getDate(),fullDate:e.getDate()<10?"0"+e.getDate():e.getDate(),day:e.getDay(),hours:t,fullHours:d(t),hours12:i,dayPeriod:s,fullHours12:d(i),minutes:e.getMinutes(),fullMinutes:e.getMinutes()<10?"0"+e.getMinutes():e.getMinutes()}}function l(e){return{dayPeriod:e>11?"pm":"am",hours:e%12==0?12:e%12}}function d(e){return e<10?"0"+e:e}function c(e){let t=10*Math.floor(e.getFullYear()/10);return[t,t+9]}function u(){let e=[];for(var t=arguments.length,i=new Array(t),s=0;s<t;s++)i[s]=arguments[s];return i.forEach((t=>{if("object"==typeof t)for(let i in t)t[i]&&e.push(i);else t&&e.push(t)})),e.join(" ")}function p(e,t){let s=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.days;if(!e||!t)return!1;let a=o(e),n=o(t),r={[i.days]:a.date===n.date&&a.month===n.month&&a.year===n.year,[i.months]:a.month===n.month&&a.year===n.year,[i.years]:a.year===n.year};return r[s]}function m(e,t,i){let s=g(e,!1).getTime(),a=g(t,!1).getTime();return i?s>=a:s>a}function v(e,t){return!m(e,t,!0)}function g(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=new Date(e.getTime());return"boolean"!=typeof t||t||D(i),i}function D(e){return e.setHours(0,0,0,0),e}function y(e,t,i){e.length?e.forEach((e=>{e.addEventListener(t,i)})):e.addEventListener(t,i)}function f(e,t){return!(!e||e===document||e instanceof DocumentFragment)&&(e.matches(t)?e:f(e.parentNode,t))}function w(e,t,i){return e>i?i:e<t?t:e}function b(e){for(var t=arguments.length,i=new Array(t>1?t-1:0),s=1;s<t;s++)i[s-1]=arguments[s];return i.filter((e=>e)).forEach((t=>{for(let[i,s]of Object.entries(t))if(void 0!==s&&"[object Object]"===s.toString()){let t=void 0!==e[i]?e[i].toString():void 0,a=s.toString(),n=Array.isArray(s)?[]:{};e[i]=e[i]?t!==a?n:e[i]:n,b(e[i],s)}else e[i]=s})),e}function k(e){let t=e;return e instanceof Date||(t=new Date(e)),isNaN(t.getTime())&&(console.log(`Unable to convert value "${e}" to Date object`),t=!1),t}function C(e){let t="\\s|\\.|-|/|\\\\|,|\\$|\\!|\\?|:|;";return new RegExp("(^|>|"+t+")("+e+")($|<|"+t+")","g")}function $(e,t,i){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,t);if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}class _{constructor(){let{type:e,date:t,dp:i,opts:s,body:a}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};$(this,"focus",(()=>{this.$cell.classList.add("-focus-"),this.focused=!0})),$(this,"removeFocus",(()=>{this.$cell.classList.remove("-focus-"),this.focused=!1})),$(this,"select",(()=>{this.$cell.classList.add("-selected-"),this.selected=!0})),$(this,"removeSelect",(()=>{this.$cell.classList.remove("-selected-","-range-from-","-range-to-"),this.selected=!1})),$(this,"onChangeSelectedDate",(()=>{this.isDisabled||(this._handleSelectedStatus(),this.opts.range&&this._handleRangeStatus())})),$(this,"onChangeFocusDate",(e=>{if(!e)return void(this.focused&&this.removeFocus());let t=p(e,this.date,this.type);t?this.focus():!t&&this.focused&&this.removeFocus(),this.opts.range&&this._handleRangeStatus()})),$(this,"render",(()=>(this.$cell.innerHTML=this._getHtml(),this.$cell.adpCell=this,this.$cell))),this.type=e,this.singleType=this.type.slice(0,-1),this.date=t,this.dp=i,this.opts=s,this.body=a,this.customData=!1,this.init()}init(){let{range:e,onRenderCell:t}=this.opts;t&&(this.customData=t({date:this.date,cellType:this.singleType,datepicker:this.dp})),this._createElement(),this._bindDatepickerEvents(),this._handleInitialFocusStatus(),this.dp.hasSelectedDates&&(this._handleSelectedStatus(),e&&this._handleRangeStatus())}_bindDatepickerEvents(){this.dp.on(i.eventChangeSelectedDate,this.onChangeSelectedDate),this.dp.on(i.eventChangeFocusDate,this.onChangeFocusDate)}unbindDatepickerEvents(){this.dp.off(i.eventChangeSelectedDate,this.onChangeSelectedDate),this.dp.off(i.eventChangeFocusDate,this.onChangeFocusDate)}_createElement(){var e;let{year:t,month:i,date:s}=o(this.date),a=(null===(e=this.customData)||void 0===e?void 0:e.attrs)||{};this.$cell=n({className:this._getClassName(),attrs:{"data-year":t,"data-month":i,"data-date":s,...a}})}_getClassName(){var e,t;let s=new Date,{selectOtherMonths:a,selectOtherYears:n}=this.opts,{minDate:r,maxDate:h}=this.dp,{day:l}=o(this.date),d=this._isOutOfMinMaxRange(),c=null===(e=this.customData)||void 0===e?void 0:e.disabled,m=u("air-datepicker-cell",`-${this.singleType}-`,{"-current-":p(s,this.date,this.type),"-min-date-":r&&p(r,this.date,this.type),"-max-date-":h&&p(h,this.date,this.type)}),v="";switch(this.type){case i.days:v=u({"-weekend-":this.dp.isWeekend(l),"-other-month-":this.isOtherMonth,"-disabled-":this.isOtherMonth&&!a||d||c});break;case i.months:v=u({"-disabled-":d||c});break;case i.years:v=u({"-other-decade-":this.isOtherDecade,"-disabled-":d||this.isOtherDecade&&!n||c})}return u(m,v,null===(t=this.customData)||void 0===t?void 0:t.classes)}_getHtml(){var e;let{year:t,month:s,date:a}=o(this.date),{showOtherMonths:n,showOtherYears:r}=this.opts;if(null!==(e=this.customData)&&void 0!==e&&e.html)return this.customData.html;switch(this.type){case i.days:return!n&&this.isOtherMonth?"":a;case i.months:return this.dp.locale[this.opts.monthsField][s];case i.years:return!r&&this.isOtherDecade?"":t}}_isOutOfMinMaxRange(){let{minDate:e,maxDate:t}=this.dp,{type:s,date:a}=this,{month:n,year:r,date:h}=o(a),l=s===i.days,d=s===i.years,c=!!e&&new Date(r,d?e.getMonth():n,l?h:e.getDate()),u=!!t&&new Date(r,d?t.getMonth():n,l?h:t.getDate());return e&&t?v(c,e)||m(u,t):e?v(c,e):t?m(u,t):void 0}destroy(){this.unbindDatepickerEvents()}_handleRangeStatus(){let{rangeDateFrom:e,rangeDateTo:t}=this.dp,i=u({"-in-range-":e&&t&&(s=this.date,a=e,n=t,m(s,a)&&v(s,n)),"-range-from-":e&&p(this.date,e,this.type),"-range-to-":t&&p(this.date,t,this.type)});var s,a,n;this.$cell.classList.remove("-range-from-","-range-to-","-in-range-"),i&&this.$cell.classList.add(...i.split(" "))}_handleSelectedStatus(){let e=this.dp._checkIfDateIsSelected(this.date,this.type);e?this.select():!e&&this.selected&&this.removeSelect()}_handleInitialFocusStatus(){p(this.dp.focusDate,this.date,this.type)&&this.focus()}get isDisabled(){return this.$cell.matches(".-disabled-")}get isOtherMonth(){return this.dp.isOtherMonth(this.date)}get isOtherDecade(){return this.dp.isOtherDecade(this.date)}}function M(e,t,i){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,t);if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}let S={[i.days]:`<div class="air-datepicker-body--day-names"></div><div class="air-datepicker-body--cells -${i.days}-"></div>`,[i.months]:`<div class="air-datepicker-body--cells -${i.months}-"></div>`,[i.years]:`<div class="air-datepicker-body--cells -${i.years}-"></div>`};const T=".air-datepicker-cell";class F{constructor(e){let{dp:t,type:s,opts:a}=e;M(this,"handleClick",(e=>{let t=e.target.closest(T).adpCell;if(t.isDisabled)return;if(!this.dp.isMinViewReached)return void this.dp.down();let i=this.dp._checkIfDateIsSelected(t.date,t.type);i?this.dp._handleAlreadySelectedDates(i,t.date):this.dp.selectDate(t.date)})),M(this,"handleDayNameClick",(e=>{let t=e.target.getAttribute("data-day-index");this.opts.onClickDayName({dayIndex:Number(t),datepicker:this.dp})})),M(this,"onChangeCurrentView",(e=>{e!==this.type?this.hide():(this.show(),this.render())})),M(this,"onMouseOverCell",(e=>{let t=f(e.target,T);this.dp.setFocusDate(!!t&&t.adpCell.date)})),M(this,"onMouseOutCell",(()=>{this.dp.setFocusDate(!1)})),M(this,"onClickBody",(e=>{let{onClickDayName:t}=this.opts,i=e.target;i.closest(T)&&this.handleClick(e),t&&i.closest(".air-datepicker-body--day-name")&&this.handleDayNameClick(e)})),M(this,"onMouseDown",(e=>{this.pressed=!0;let t=f(e.target,T),i=t&&t.adpCell;p(i.date,this.dp.rangeDateFrom)&&(this.rangeFromFocused=!0),p(i.date,this.dp.rangeDateTo)&&(this.rangeToFocused=!0)})),M(this,"onMouseMove",(e=>{if(!this.pressed||!this.dp.isMinViewReached)return;e.preventDefault();let t=f(e.target,T),i=t&&t.adpCell,{selectedDates:s,rangeDateTo:a,rangeDateFrom:n}=this.dp;if(!i||i.isDisabled)return;let{date:r}=i;if(2===s.length){if(this.rangeFromFocused&&!m(r,a)){let{hours:e,minutes:t}=o(n);r.setHours(e),r.setMinutes(t),this.dp.rangeDateFrom=r,this.dp.replaceDate(n,r)}if(this.rangeToFocused&&!v(r,n)){let{hours:e,minutes:t}=o(a);r.setHours(e),r.setMinutes(t),this.dp.rangeDateTo=r,this.dp.replaceDate(a,r)}}})),M(this,"onMouseUp",(()=>{this.pressed=!1,this.rangeFromFocused=!1,this.rangeToFocused=!1})),M(this,"onChangeViewDate",((e,t)=>{if(!this.isVisible)return;let s=c(e),a=c(t);switch(this.dp.currentView){case i.days:if(p(e,t,i.months))return;break;case i.months:if(p(e,t,i.years))return;break;case i.years:if(s[0]===a[0]&&s[1]===a[1])return}this.render()})),M(this,"render",(()=>{this.destroyCells(),this._generateCells(),this.cells.forEach((e=>{this.$cells.appendChild(e.render())}))})),this.dp=t,this.type=s,this.opts=a,this.cells=[],this.$el="",this.pressed=!1,this.isVisible=!0,this.init()}init(){this._buildBaseHtml(),this.type===i.days&&this.renderDayNames(),this.render(),this._bindEvents(),this._bindDatepickerEvents()}_bindEvents(){let{range:e,dynamicRange:t}=this.opts;y(this.$el,"mouseover",this.onMouseOverCell),y(this.$el,"mouseout",this.onMouseOutCell),y(this.$el,"click",this.onClickBody),e&&t&&(y(this.$el,"mousedown",this.onMouseDown),y(this.$el,"mousemove",this.onMouseMove),y(window.document,"mouseup",this.onMouseUp))}_bindDatepickerEvents(){this.dp.on(i.eventChangeViewDate,this.onChangeViewDate),this.dp.on(i.eventChangeCurrentView,this.onChangeCurrentView)}_buildBaseHtml(){this.$el=n({className:`air-datepicker-body -${this.type}-`,innerHtml:S[this.type]}),this.$names=a(".air-datepicker-body--day-names",this.$el),this.$cells=a(".air-datepicker-body--cells",this.$el)}_getDayNamesHtml(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.dp.locale.firstDay,t="",s=this.dp.isWeekend,{onClickDayName:a}=this.opts,n=e,r=0;for(;r<7;){let e=n%7;t+=`<div class="${u("air-datepicker-body--day-name",{[i.cssClassWeekend]:s(e),"-clickable-":!!a})}" data-day-index='${e}'>${this.dp.locale.daysMin[e]}</div>`,r++,n++}return t}_getDaysCells(){let{viewDate:e,locale:{firstDay:t}}=this.dp,i=h(e),{year:s,month:a}=o(e),n=new Date(s,a,1),r=new Date(s,a,i),l=n.getDay()-t,d=6-r.getDay()+t;l=l<0?l+7:l,d=d>6?d-7:d;let c=function(e,t){let{year:i,month:s,date:a}=o(e);return new Date(i,s,a-t)}(n,l),u=i+l+d,p=c.getDate(),{year:m,month:v}=o(c),g=0;for(;g<u;){let e=new Date(m,v,p+g);this._generateCell(e),g++}}_generateCell(e){let{type:t,dp:i,opts:s}=this,a=new _({type:t,dp:i,opts:s,date:e,body:this});return this.cells.push(a),a}_generateDayCells(){this._getDaysCells()}_generateMonthCells(){let{year:e}=this.dp.parsedViewDate,t=0;for(;t<12;)this.cells.push(this._generateCell(new Date(e,t))),t++}_generateYearCells(){let e=c(this.dp.viewDate),t=e[0]-1,i=e[1]+1,s=t;for(;s<=i;)this.cells.push(this._generateCell(new Date(s,0))),s++}renderDayNames(){this.$names.innerHTML=this._getDayNamesHtml()}_generateCells(){switch(this.type){case i.days:this._generateDayCells();break;case i.months:this._generateMonthCells();break;case i.years:this._generateYearCells()}}show(){this.isVisible=!0,this.$el.classList.remove("-hidden-")}hide(){this.isVisible=!1,this.$el.classList.add("-hidden-")}destroyCells(){this.cells.forEach((e=>e.destroy())),this.cells=[],this.$cells.innerHTML=""}destroy(){this.destroyCells(),this.dp.off(i.eventChangeViewDate,this.onChangeViewDate),this.dp.off(i.eventChangeCurrentView,this.onChangeCurrentView)}}function V(e,t,i){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,t);if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}class x{constructor(e){let{dp:t,opts:i}=e;V(this,"onClickNav",(e=>{let t=f(e.target,".air-datepicker-nav--action");if(!t)return;let i=t.dataset.action;this.dp[i]()})),V(this,"onChangeViewDate",(()=>{this.render(),this._resetNavStatus(),this.handleNavStatus()})),V(this,"onChangeCurrentView",(()=>{this.render(),this._resetNavStatus(),this.handleNavStatus()})),V(this,"onClickNavTitle",(()=>{this.dp.isFinalView||this.dp.up()})),V(this,"update",(()=>{let{prevHtml:e,nextHtml:t}=this.opts;this.$prev.innerHTML=e,this.$next.innerHTML=t,this._resetNavStatus(),this.render(),this.handleNavStatus()})),V(this,"renderDelay",(()=>{setTimeout(this.render)})),V(this,"render",(()=>{this.$title.innerHTML=this._getTitle(),function(e,t){for(let i in t)t[i]?e.classList.add(i):e.classList.remove(i)}(this.$title,{"-disabled-":this.dp.isFinalView})})),this.dp=t,this.opts=i,this.init()}init(){this._createElement(),this._buildBaseHtml(),this._defineDOM(),this.render(),this.handleNavStatus(),this._bindEvents(),this._bindDatepickerEvents()}_defineDOM(){this.$title=a(".air-datepicker-nav--title",this.$el),this.$prev=a('[data-action="prev"]',this.$el),this.$next=a('[data-action="next"]',this.$el)}_bindEvents(){this.$el.addEventListener("click",this.onClickNav),this.$title.addEventListener("click",this.onClickNavTitle)}_bindDatepickerEvents(){this.dp.on(i.eventChangeViewDate,this.onChangeViewDate),this.dp.on(i.eventChangeCurrentView,this.onChangeCurrentView),this.isNavIsFunction&&(this.dp.on(i.eventChangeSelectedDate,this.renderDelay),this.dp.opts.timepicker&&this.dp.on(i.eventChangeTime,this.render))}destroy(){this.dp.off(i.eventChangeViewDate,this.onChangeViewDate),this.dp.off(i.eventChangeCurrentView,this.onChangeCurrentView),this.isNavIsFunction&&(this.dp.off(i.eventChangeSelectedDate,this.renderDelay),this.dp.opts.timepicker&&this.dp.off(i.eventChangeTime,this.render))}_createElement(){this.$el=n({tagName:"nav",className:"air-datepicker-nav"})}_getTitle(){let{dp:e,opts:t}=this,i=t.navTitles[e.currentView];return"function"==typeof i?i(e):e.formatDate(e.viewDate,i)}handleNavStatus(){let{disableNavWhenOutOfRange:e}=this.opts,{minDate:t,maxDate:s}=this.dp;if(!t&&!s||!e)return;let{year:a,month:n}=this.dp.parsedViewDate,r=!!t&&o(t),h=!!s&&o(s);switch(this.dp.currentView){case i.days:t&&r.month>=n&&r.year>=a&&this._disableNav("prev"),s&&h.month<=n&&h.year<=a&&this._disableNav("next");break;case i.months:t&&r.year>=a&&this._disableNav("prev"),s&&h.year<=a&&this._disableNav("next");break;case i.years:{let e=c(this.dp.viewDate);t&&r.year>=e[0]&&this._disableNav("prev"),s&&h.year<=e[1]&&this._disableNav("next");break}}}_disableNav(e){a('[data-action="'+e+'"]',this.$el).classList.add("-disabled-")}_resetNavStatus(){!function(e){for(var t=arguments.length,i=new Array(t>1?t-1:0),s=1;s<t;s++)i[s-1]=arguments[s];e.length?e.forEach((e=>{e.classList.remove(...i)})):e.classList.remove(...i)}(this.$el.querySelectorAll(".air-datepicker-nav--action"),"-disabled-")}_buildBaseHtml(){let{prevHtml:e,nextHtml:t}=this.opts;this.$el.innerHTML=`<div class="air-datepicker-nav--action" data-action="prev">${e}</div><div class="air-datepicker-nav--title"></div><div class="air-datepicker-nav--action" data-action="next">${t}</div>`}get isNavIsFunction(){let{navTitles:e}=this.opts;return Object.keys(e).find((t=>"function"==typeof e[t]))}}var H={today:{content:e=>e.locale.today,onClick:e=>e.setViewDate(new Date)},clear:{content:e=>e.locale.clear,onClick:e=>e.clear()}};class E{constructor(e){let{dp:t,opts:i}=e;this.dp=t,this.opts=i,this.init()}init(){this.createElement(),this.render()}createElement(){this.$el=n({className:"air-datepicker-buttons"})}destroy(){this.$el.parentNode.removeChild(this.$el)}clearHtml(){return this.$el.innerHTML="",this}generateButtons(){let{buttons:e}=this.opts;Array.isArray(e)||(e=[e]),e.forEach((e=>{let t=e;"string"==typeof e&&H[e]&&(t=H[e]);let i=this.createButton(t);t.onClick&&this.attachEventToButton(i,t.onClick),this.$el.appendChild(i)}))}attachEventToButton(e,t){e.addEventListener("click",(()=>{t(this.dp)}))}createButton(e){let{content:t,className:i,tagName:s="button",attrs:a={}}=e;return n({tagName:s,innerHtml:`<span tabindex='-1'>${"function"==typeof t?t(this.dp):t}</span>`,className:u("air-datepicker-button",i),attrs:a})}render(){this.generateButtons()}}function L(e,t,i){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,t);if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}class O{constructor(){let{opts:e,dp:t}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};L(this,"toggleTimepickerIsActive",(e=>{this.dp.timepickerIsActive=e})),L(this,"onChangeSelectedDate",(e=>{let{date:t,updateTime:i=!1}=e;t&&(this.setMinMaxTime(t),this.setCurrentTime(!!i&&t),this.addTimeToDate(t))})),L(this,"onChangeLastSelectedDate",(e=>{e&&(this.setTime(e),this.render())})),L(this,"onChangeInputRange",(e=>{let t=e.target;this[t.getAttribute("name")]=t.value,this.updateText(),this.dp.trigger(i.eventChangeTime,{hours:this.hours,minutes:this.minutes})})),L(this,"onMouseEnterLeave",(e=>{let t=e.target.getAttribute("name"),i=this.$minutesText;"hours"===t&&(i=this.$hoursText),i.classList.toggle("-focus-")})),L(this,"onFocus",(()=>{this.toggleTimepickerIsActive(!0)})),L(this,"onBlur",(()=>{this.toggleTimepickerIsActive(!1)})),this.opts=e,this.dp=t;let{timeFormat:s}=this.dp.locale;s&&(s.match(C("h"))||s.match(C("hh")))&&(this.ampm=!0),this.init()}init(){this.setTime(this.dp.lastSelectedDate||this.dp.viewDate),this.createElement(),this.buildHtml(),this.defineDOM(),this.render(),this.bindDatepickerEvents(),this.bindDOMEvents()}bindDatepickerEvents(){this.dp.on(i.eventChangeSelectedDate,this.onChangeSelectedDate),this.dp.on(i.eventChangeLastSelectedDate,this.onChangeLastSelectedDate)}bindDOMEvents(){let e="input";navigator.userAgent.match(/trident/gi)&&(e="change"),y(this.$ranges,e,this.onChangeInputRange),y(this.$ranges,"mouseenter",this.onMouseEnterLeave),y(this.$ranges,"mouseleave",this.onMouseEnterLeave),y(this.$ranges,"focus",this.onFocus),y(this.$ranges,"mousedown",this.onFocus),y(this.$ranges,"blur",this.onBlur)}createElement(){this.$el=n({className:u("air-datepicker-time",{"-am-pm-":this.dp.ampm})})}destroy(){this.dp.off(i.eventChangeSelectedDate,this.onChangeSelectedDate),this.dp.off(i.eventChangeLastSelectedDate,this.onChangeLastSelectedDate),this.$el.parentNode.removeChild(this.$el)}buildHtml(){let{ampm:e,hours:t,displayHours:i,minutes:s,minHours:a,minMinutes:n,maxHours:r,maxMinutes:h,dayPeriod:o,opts:{hoursStep:l,minutesStep:c}}=this;this.$el.innerHTML=`<div class="air-datepicker-time--current">   <span class="air-datepicker-time--current-hours">${d(i)}</span>   <span class="air-datepicker-time--current-colon">:</span>   <span class="air-datepicker-time--current-minutes">${d(s)}</span>   `+(e?`<span class='air-datepicker-time--current-ampm'>${o}</span>`:"")+'</div><div class="air-datepicker-time--sliders">   <div class="air-datepicker-time--row">'+`      <input type="range" name="hours" value="${t}" min="${a}" max="${r}" step="${l}"/>   </div>   <div class="air-datepicker-time--row">`+`      <input type="range" name="minutes" value="${s}" min="${n}" max="${h}" step="${c}"/>   </div></div>`}defineDOM(){let e=e=>a(e,this.$el);this.$ranges=this.$el.querySelectorAll('[type="range"]'),this.$hours=e('[name="hours"]'),this.$minutes=e('[name="minutes"]'),this.$hoursText=e(".air-datepicker-time--current-hours"),this.$minutesText=e(".air-datepicker-time--current-minutes"),this.$ampm=e(".air-datepicker-time--current-ampm")}setTime(e){this.setMinMaxTime(e),this.setCurrentTime(e)}addTimeToDate(e){e&&(e.setHours(this.hours),e.setMinutes(this.minutes))}setMinMaxTime(e){if(this.setMinMaxTimeFromOptions(),e){let{minDate:t,maxDate:i}=this.dp;t&&p(e,t)&&this.setMinTimeFromMinDate(t),i&&p(e,i)&&this.setMaxTimeFromMaxDate(i)}}setCurrentTime(e){let{hours:t,minutes:i}=e?o(e):this;this.hours=w(t,this.minHours,this.maxHours),this.minutes=w(i,this.minMinutes,this.maxMinutes)}setMinMaxTimeFromOptions(){let{minHours:e,minMinutes:t,maxHours:i,maxMinutes:s}=this.opts;this.minHours=w(e,0,23),this.minMinutes=w(t,0,59),this.maxHours=w(i,0,23),this.maxMinutes=w(s,0,59)}setMinTimeFromMinDate(e){let{lastSelectedDate:t}=this.dp;this.minHours=e.getHours(),t&&t.getHours()>e.getHours()?this.minMinutes=this.opts.minMinutes:this.minMinutes=e.getMinutes()}setMaxTimeFromMaxDate(e){let{lastSelectedDate:t}=this.dp;this.maxHours=e.getHours(),t&&t.getHours()<e.getHours()?this.maxMinutes=this.opts.maxMinutes:this.maxMinutes=e.getMinutes()}updateSliders(){r(this.$hours,{min:this.minHours,max:this.maxHours}).value=this.hours,r(this.$minutes,{min:this.minMinutes,max:this.maxMinutes}).value=this.minutes}updateText(){this.$hoursText.innerHTML=d(this.displayHours),this.$minutesText.innerHTML=d(this.minutes),this.ampm&&(this.$ampm.innerHTML=this.dayPeriod)}set hours(e){this._hours=e;let{hours:t,dayPeriod:i}=l(e);this.displayHours=this.ampm?t:e,this.dayPeriod=i}get hours(){return this._hours}render(){this.updateSliders(),this.updateText()}}function A(e,t,i){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,t);if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}class N{constructor(e){let{dp:t,opts:i}=e;A(this,"pressedKeys",new Set),A(this,"hotKeys",new Map([[[["Control","ArrowRight"],["Control","ArrowUp"]],e=>e.month++],[[["Control","ArrowLeft"],["Control","ArrowDown"]],e=>e.month--],[[["Shift","ArrowRight"],["Shift","ArrowUp"]],e=>e.year++],[[["Shift","ArrowLeft"],["Shift","ArrowDown"]],e=>e.year--],[[["Alt","ArrowRight"],["Alt","ArrowUp"]],e=>e.year+=10],[[["Alt","ArrowLeft"],["Alt","ArrowDown"]],e=>e.year-=10],[["Control","Shift","ArrowUp"],(e,t)=>t.up()]])),A(this,"handleHotKey",(e=>{let t=this.hotKeys.get(e),i=o(this.getInitialFocusDate());t(i,this.dp);let{year:s,month:a,date:n}=i,r=h(new Date(s,a));r<n&&(n=r);let l=this.dp.getClampedDate(new Date(s,a,n));this.dp.setFocusDate(l,{viewDateTransition:!0})})),A(this,"isHotKeyPressed",(()=>{let e=!1,t=this.pressedKeys.size,i=e=>this.pressedKeys.has(e);for(let[s]of this.hotKeys){if(e)break;if(Array.isArray(s[0]))s.forEach((a=>{e||t!==a.length||(e=a.every(i)&&s)}));else{if(t!==s.length)continue;e=s.every(i)&&s}}return e})),A(this,"isArrow",(e=>e>=37&&e<=40)),A(this,"onKeyDown",(e=>{let{key:t,which:i}=e,{dp:s,dp:{focusDate:a},opts:n}=this;this.registerKey(t);let r=this.isHotKeyPressed();if(r)return e.preventDefault(),void this.handleHotKey(r);if(this.isArrow(i))return e.preventDefault(),void this.focusNextCell(t);if("Enter"===t){if(s.currentView!==n.minView)return void s.down();if(a){let e=s._checkIfDateIsSelected(a);return void(e?s._handleAlreadySelectedDates(e,a):s.selectDate(a))}}"Escape"===t&&this.dp.hide()})),A(this,"onKeyUp",(e=>{this.removeKey(e.key)})),this.dp=t,this.opts=i,this.init()}init(){this.bindKeyboardEvents()}bindKeyboardEvents(){let{$el:e}=this.dp;e.addEventListener("keydown",this.onKeyDown),e.addEventListener("keyup",this.onKeyUp)}destroy(){let{$el:e}=this.dp;e.removeEventListener("keydown",this.onKeyDown),e.removeEventListener("keyup",this.onKeyUp),this.hotKeys=null,this.pressedKeys=null}getInitialFocusDate(){let{focusDate:e,currentView:t,selectedDates:s,parsedViewDate:{year:a,month:n}}=this.dp,r=e||s[s.length-1];if(!r)switch(t){case i.days:r=new Date(a,n,(new Date).getDate());break;case i.months:r=new Date(a,n,1);break;case i.years:r=new Date(a,0,1)}return r}focusNextCell(e){let t=this.getInitialFocusDate(),{currentView:s}=this.dp,{days:a,months:n,years:r}=i,h=o(t),l=h.year,d=h.month,c=h.date;switch(e){case"ArrowLeft":s===a&&(c-=1),s===n&&(d-=1),s===r&&(l-=1);break;case"ArrowUp":s===a&&(c-=7),s===n&&(d-=3),s===r&&(l-=4);break;case"ArrowRight":s===a&&(c+=1),s===n&&(d+=1),s===r&&(l+=1);break;case"ArrowDown":s===a&&(c+=7),s===n&&(d+=3),s===r&&(l+=4)}let u=this.dp.getClampedDate(new Date(l,d,c));this.dp.setFocusDate(u,{viewDateTransition:!0})}registerKey(e){this.pressedKeys.add(e)}removeKey(e){this.pressedKeys.delete(e)}}let I={on(e,t){this.__events||(this.__events={}),this.__events[e]?this.__events[e].push(t):this.__events[e]=[t]},off(e,t){this.__events&&this.__events[e]&&(this.__events[e]=this.__events[e].filter((e=>e!==t)))},removeAllEvents(){this.__events={}},trigger(e){for(var t=arguments.length,i=new Array(t>1?t-1:0),s=1;s<t;s++)i[s-1]=arguments[s];this.__events&&this.__events[e]&&this.__events[e].forEach((e=>{e(...i)}))}};function P(e,t,i){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,t);if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}let j="",R="",B=!1;class K{static buildGlobalContainer(e){B=!0,j=n({className:e,id:e}),a("body").appendChild(j)}constructor(e,t){var r=this;if(P(this,"viewIndexes",[i.days,i.months,i.years]),P(this,"next",(()=>{let{year:e,month:t}=this.parsedViewDate;switch(this.currentView){case i.days:this.setViewDate(new Date(e,t+1,1));break;case i.months:this.setViewDate(new Date(e+1,t,1));break;case i.years:this.setViewDate(new Date(e+10,0,1))}})),P(this,"prev",(()=>{let{year:e,month:t}=this.parsedViewDate;switch(this.currentView){case i.days:this.setViewDate(new Date(e,t-1,1));break;case i.months:this.setViewDate(new Date(e-1,t,1));break;case i.years:this.setViewDate(new Date(e-10,0,1))}})),P(this,"_finishHide",(()=>{this.hideAnimation=!1,this._destroyComponents(),this.$container.removeChild(this.$datepicker)})),P(this,"setPosition",(function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if("function"==typeof(e=e||r.opts.position))return void(r.customHide=e({$datepicker:r.$datepicker,$target:r.$el,$pointer:r.$pointer,isViewChange:t,done:r._finishHide}));let i,s,{isMobile:a}=r.opts,n=r.$el.getBoundingClientRect(),h=r.$el.getBoundingClientRect(),o=r.$datepicker.offsetParent,l=r.$el.offsetParent,d=r.$datepicker.getBoundingClientRect(),c=e.split(" "),u=window.scrollY,p=window.scrollX,m=r.opts.offset,v=c[0],g=c[1];if(a)r.$datepicker.style.cssText="left: 50%; top: 50%";else{if(o===l&&o!==document.body&&(h={top:r.$el.offsetTop,left:r.$el.offsetLeft,width:n.width,height:r.$el.offsetHeight},u=0,p=0),o!==l&&o!==document.body){let e=o.getBoundingClientRect();h={top:n.top-e.top,left:n.left-e.left,width:n.width,height:n.height},u=0,p=0}switch(v){case"top":i=h.top-d.height-m;break;case"right":s=h.left+h.width+m;break;case"bottom":i=h.top+h.height+m;break;case"left":s=h.left-d.width-m}switch(g){case"top":i=h.top;break;case"right":s=h.left+h.width-d.width;break;case"bottom":i=h.top+h.height-d.height;break;case"left":s=h.left;break;case"center":/left|right/.test(v)?i=h.top+h.height/2-d.height/2:s=h.left+h.width/2-d.width/2}r.$datepicker.style.cssText=`left: ${s+p}px; top: ${i+u}px`}})),P(this,"_setInputValue",(()=>{let{opts:e,$altField:t,locale:{dateFormat:i}}=this,{altFieldDateFormat:s,altField:a}=e;a&&t&&(t.value=this._getInputValue(s)),this.$el.value=this._getInputValue(i)})),P(this,"_getInputValue",(e=>{let{selectedDates:t,opts:i}=this,{multipleDates:s,multipleDatesSeparator:a}=i;if(!t.length)return"";let n="function"==typeof e,r=n?e(s?t:t[0]):t.map((t=>this.formatDate(t,e)));return r=n?r:r.join(a),r})),P(this,"_checkIfDateIsSelected",(function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i.days,s=!1;return r.selectedDates.some((i=>{let a=p(e,i,t);return s=a&&i,a})),s})),P(this,"_scheduleCallAfterTransition",(e=>{this._cancelScheduledCall(),e&&e(!1),this._onTransitionEnd=()=>{e&&e(!0)},this.$datepicker.addEventListener("transitionend",this._onTransitionEnd,{once:!0})})),P(this,"_cancelScheduledCall",(()=>{this.$datepicker.removeEventListener("transitionend",this._onTransitionEnd)})),P(this,"setViewDate",(e=>{if(!((e=k(e))instanceof Date))return;if(p(e,this.viewDate))return;let t=this.viewDate;this.viewDate=e;let{onChangeViewDate:s}=this.opts;if(s){let{month:e,year:t}=this.parsedViewDate;s({month:e,year:t,decade:this.curDecade})}this.trigger(i.eventChangeViewDate,e,t)})),P(this,"setFocusDate",(function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(!e||(e=k(e))instanceof Date)&&(r.focusDate=e,r.opts.range&&e&&r._handleRangeOnFocus(),r.trigger(i.eventChangeFocusDate,e,t))})),P(this,"setCurrentView",(e=>{if(this.viewIndexes.includes(e)){if(this.currentView=e,this.elIsInput&&this.visible&&this.setPosition(void 0,!0),this.trigger(i.eventChangeCurrentView,e),!this.views[e]){let t=this.views[e]=new F({dp:this,opts:this.opts,type:e});this.shouldUpdateDOM&&this.$content.appendChild(t.$el)}this.opts.onChangeView&&this.opts.onChangeView(e)}})),P(this,"_updateLastSelectedDate",(e=>{this.lastSelectedDate=e,this.trigger(i.eventChangeLastSelectedDate,e)})),P(this,"destroy",(()=>{let{showEvent:e,isMobile:t}=this.opts,i=this.$datepicker.parentNode;i&&i.removeChild(this.$datepicker),this.$el.removeEventListener(e,this._onFocus),this.$el.removeEventListener("blur",this._onBlur),window.removeEventListener("resize",this._onResize),t&&this._removeMobileAttributes(),this.keyboardNav&&this.keyboardNav.destroy(),this.views=null,this.nav=null,this.$datepicker=null,this.opts=null,this.$customContainer=null,this.viewDate=null,this.focusDate=null,this.selectedDates=null,this.rangeDateFrom=null,this.rangeDateTo=null})),P(this,"update",(e=>{let t=b({},this.opts);b(this.opts,e);let{timepicker:s,buttons:a,range:n,selectedDates:r,isMobile:h}=this.opts,o=this.visible||this.treatAsInline;this._createMinMaxDates(),this._limitViewDateByMaxMinDates(),this._handleLocale(),!t.selectedDates&&r&&this.selectDate(r),e.view&&this.setCurrentView(e.view),this._setInputValue(),t.range&&!n?(this.rangeDateTo=!1,this.rangeDateFrom=!1):!t.range&&n&&this.selectedDates.length&&(this.rangeDateFrom=this.selectedDates[0],this.rangeDateTo=this.selectedDates[1]),t.timepicker&&!s?(o&&this.timepicker.destroy(),this.timepicker=!1,this.$timepicker.parentNode.removeChild(this.$timepicker)):!t.timepicker&&s&&this._addTimepicker(),!t.buttons&&a?this._addButtons():t.buttons&&!a?(this.buttons.destroy(),this.$buttons.parentNode.removeChild(this.$buttons)):o&&t.buttons&&a&&this.buttons.clearHtml().render(),!t.isMobile&&h?(this.treatAsInline||R||this._createMobileOverlay(),this._addMobileAttributes(),this.visible&&this._showMobileOverlay()):t.isMobile&&!h&&(this._removeMobileAttributes(),this.visible&&(R.classList.remove("-active-"),"function"!=typeof this.opts.position&&this.setPosition())),o&&(this.nav.update(),this.views[this.currentView].render(),this.currentView===i.days&&this.views[this.currentView].renderDayNames())})),P(this,"isOtherMonth",(e=>{let{month:t}=o(e);return t!==this.parsedViewDate.month})),P(this,"isOtherYear",(e=>{let{year:t}=o(e);return t!==this.parsedViewDate.year})),P(this,"isOtherDecade",(e=>{let{year:t}=o(e),[i,s]=c(this.viewDate);return t<i||t>s})),P(this,"_onChangeSelectedDate",(e=>{let{silent:t}=e;setTimeout((()=>{this._setInputValue(),this.opts.onSelect&&!t&&this._triggerOnSelect()}))})),P(this,"_onChangeFocusedDate",(function(e){let{viewDateTransition:t}=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!e)return;let i=!1;t&&(i=r.isOtherMonth(e)||r.isOtherYear(e)||r.isOtherDecade(e)),i&&r.setViewDate(e)})),P(this,"_onChangeTime",(e=>{let{hours:t,minutes:i}=e,s=new Date,{lastSelectedDate:a,opts:{onSelect:n}}=this,r=a;a||(r=s);let h=this.getCell(r,this.currentViewSingular),o=h&&h.adpCell;o&&o.isDisabled||(r.setHours(t),r.setMinutes(i),a?(this._setInputValue(),n&&this._triggerOnSelect()):this.selectDate(r))})),P(this,"_onFocus",(e=>{this.visible||this.show()})),P(this,"_onBlur",(e=>{this.inFocus||!this.visible||this.opts.isMobile||this.hide()})),P(this,"_onMouseDown",(e=>{this.inFocus=!0})),P(this,"_onMouseUp",(e=>{this.inFocus=!1,this.$el.focus()})),P(this,"_onResize",(()=>{this.visible&&"function"!=typeof this.opts.position&&this.setPosition()})),P(this,"_onClickOverlay",(()=>{this.visible&&this.hide()})),P(this,"isWeekend",(e=>this.opts.weekends.includes(e))),P(this,"getClampedDate",(e=>{let{minDate:t,maxDate:i}=this,s=e;return i&&m(e,i)?s=i:t&&v(e,t)&&(s=t),s})),this.$el=a(e),!this.$el)return;this.$datepicker=n({className:"air-datepicker"}),this.opts=b({},s,t),this.$customContainer=!!this.opts.container&&a(this.opts.container),this.$altField=a(this.opts.altField||!1);let{view:h,startDate:l}=this.opts;l||(this.opts.startDate=new Date),"INPUT"===this.$el.nodeName&&(this.elIsInput=!0),this.inited=!1,this.visible=!1,this.viewDate=k(this.opts.startDate),this.focusDate=!1,this.initialReadonly=this.$el.getAttribute("readonly"),this.customHide=!1,this.currentView=h,this.selectedDates=[],this.views={},this.keys=[],this.rangeDateFrom="",this.rangeDateTo="",this.timepickerIsActive=!1,this.treatAsInline=this.opts.inline||!this.elIsInput,this.init()}init(){let{opts:e,treatAsInline:t,opts:{inline:i,isMobile:s,selectedDates:n,keyboardNav:r,onlyTimepicker:h}}=this,o=a("body");(!B||B&&j&&!o.contains(j))&&!i&&this.elIsInput&&!this.$customContainer&&K.buildGlobalContainer(K.defaultGlobalContainerId),!s||R||t||this._createMobileOverlay(),this._handleLocale(),this._bindSubEvents(),this._createMinMaxDates(),this._limitViewDateByMaxMinDates(),this.elIsInput&&(i||this._bindEvents(),r&&!h&&(this.keyboardNav=new N({dp:this,opts:e}))),n&&this.selectDate(n,{silent:!0}),this.opts.visible&&!t&&this.show(),s&&!t&&this.$el.setAttribute("readonly",!0),t&&this._createComponents()}_createMobileOverlay(){R=n({className:"air-datepicker-overlay"}),j.appendChild(R)}_createComponents(){let{opts:e,treatAsInline:t,opts:{inline:i,buttons:s,timepicker:a,position:n,classes:r,onlyTimepicker:h,isMobile:o}}=this;this._buildBaseHtml(),this.elIsInput&&(i||this._setPositionClasses(n)),!i&&this.elIsInput||this.$datepicker.classList.add("-inline-"),r&&this.$datepicker.classList.add(...r.split(" ")),h&&this.$datepicker.classList.add("-only-timepicker-"),o&&!t&&this._addMobileAttributes(),this.views[this.currentView]=new F({dp:this,type:this.currentView,opts:e}),this.nav=new x({dp:this,opts:e}),a&&this._addTimepicker(),s&&this._addButtons(),this.$content.appendChild(this.views[this.currentView].$el),this.$nav.appendChild(this.nav.$el)}_destroyComponents(){for(let e in this.views)this.views[e].destroy();this.views={},this.nav.destroy(),this.timepicker&&this.timepicker.destroy()}_addMobileAttributes(){R.addEventListener("click",this._onClickOverlay),this.$datepicker.classList.add("-is-mobile-"),this.$el.setAttribute("readonly",!0)}_removeMobileAttributes(){R.removeEventListener("click",this._onClickOverlay),this.$datepicker.classList.remove("-is-mobile-"),this.initialReadonly||""===this.initialReadonly||this.$el.removeAttribute("readonly")}_createMinMaxDates(){let{minDate:e,maxDate:t}=this.opts;this.minDate=!!e&&k(e),this.maxDate=!!t&&k(t)}_addTimepicker(){this.$timepicker=n({className:"air-datepicker--time"}),this.$datepicker.appendChild(this.$timepicker),this.timepicker=new O({dp:this,opts:this.opts}),this.$timepicker.appendChild(this.timepicker.$el)}_addButtons(){this.$buttons=n({className:"air-datepicker--buttons"}),this.$datepicker.appendChild(this.$buttons),this.buttons=new E({dp:this,opts:this.opts}),this.$buttons.appendChild(this.buttons.$el)}_bindSubEvents(){this.on(i.eventChangeSelectedDate,this._onChangeSelectedDate),this.on(i.eventChangeFocusDate,this._onChangeFocusedDate),this.on(i.eventChangeTime,this._onChangeTime)}_buildBaseHtml(){let{inline:e}=this.opts;var t,i;this.elIsInput?e?(t=this.$datepicker,(i=this.$el).parentNode.insertBefore(t,i.nextSibling)):this.$container.appendChild(this.$datepicker):this.$el.appendChild(this.$datepicker),this.$datepicker.innerHTML='<i class="air-datepicker--pointer"></i><div class="air-datepicker--navigation"></div><div class="air-datepicker--content"></div>',this.$content=a(".air-datepicker--content",this.$datepicker),this.$pointer=a(".air-datepicker--pointer",this.$datepicker),this.$nav=a(".air-datepicker--navigation",this.$datepicker)}_handleLocale(){let{locale:e,dateFormat:t,firstDay:i,timepicker:s,onlyTimepicker:a,timeFormat:n,dateTimeSeparator:r}=this.opts;var h;this.locale=(h=e,JSON.parse(JSON.stringify(h))),t&&(this.locale.dateFormat=t),void 0!==n&&""!==n&&(this.locale.timeFormat=n);let{timeFormat:o}=this.locale;if(""!==i&&(this.locale.firstDay=i),s&&"function"!=typeof t){let e=o?r:"";this.locale.dateFormat=[this.locale.dateFormat,o||""].join(e)}a&&"function"!=typeof t&&(this.locale.dateFormat=this.locale.timeFormat)}_setPositionClasses(e){if("function"==typeof e)return void this.$datepicker.classList.add("-custom-position-");let t=(e=e.split(" "))[0],i=`air-datepicker -${t}-${e[1]}- -from-${t}-`;this.$datepicker.classList.add(...i.split(" "))}_bindEvents(){this.$el.addEventListener(this.opts.showEvent,this._onFocus),this.$el.addEventListener("blur",this._onBlur),this.$datepicker.addEventListener("mousedown",this._onMouseDown),this.$datepicker.addEventListener("mouseup",this._onMouseUp),window.addEventListener("resize",this._onResize)}_limitViewDateByMaxMinDates(){let{viewDate:e,minDate:t,maxDate:i}=this;i&&m(e,i)&&this.setViewDate(i),t&&v(e,t)&&this.setViewDate(t)}formatDate(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.viewDate,t=arguments.length>1?arguments[1]:void 0;if(e=k(e),!(e instanceof Date))return;let i=t,s=this.locale,a=o(e),n=a.dayPeriod,r=c(e),h=K.replacer,l={T:e.getTime(),m:a.minutes,mm:a.fullMinutes,h:a.hours12,hh:a.fullHours12,H:a.hours,HH:a.fullHours,aa:n,AA:n.toUpperCase(),E:s.daysShort[a.day],EEEE:s.days[a.day],d:a.date,dd:a.fullDate,M:a.month+1,MM:a.fullMonth,MMM:s.monthsShort[a.month],MMMM:s.months[a.month],yy:a.year.toString().slice(-2),yyyy:a.year,yyyy1:r[0],yyyy2:r[1]};for(let[e,t]of Object.entries(l))i=h(i,C(e),t);return i}down(e){this._handleUpDownActions(e,"down")}up(e){this._handleUpDownActions(e,"up")}selectDate(e){let t,s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{currentView:a,parsedViewDate:n,selectedDates:r}=this,{updateTime:h}=s,{moveToOtherMonthsOnSelect:o,moveToOtherYearsOnSelect:l,multipleDates:d,range:c,autoClose:u}=this.opts,p=r.length;if(Array.isArray(e))return e.forEach((e=>{this.selectDate(e,s)})),new Promise((e=>{setTimeout(e)}));if((e=k(e))instanceof Date){if(a===i.days&&e.getMonth()!==n.month&&o&&(t=new Date(e.getFullYear(),e.getMonth(),1)),a===i.years&&e.getFullYear()!==n.year&&l&&(t=new Date(e.getFullYear(),0,1)),t&&this.setViewDate(t),d&&!c){if(p===d)return;this._checkIfDateIsSelected(e)||r.push(e)}else if(c)switch(p){case 1:r.push(e),this.rangeDateTo||(this.rangeDateTo=e),m(this.rangeDateFrom,this.rangeDateTo)&&(this.rangeDateTo=this.rangeDateFrom,this.rangeDateFrom=e),this.selectedDates=[this.rangeDateFrom,this.rangeDateTo];break;case 2:this.selectedDates=[e],this.rangeDateFrom=e,this.rangeDateTo="";break;default:this.selectedDates=[e],this.rangeDateFrom=e}else this.selectedDates=[e];return this.trigger(i.eventChangeSelectedDate,{action:i.actionSelectDate,silent:null==s?void 0:s.silent,date:e,updateTime:h}),this._updateLastSelectedDate(e),u&&!this.timepickerIsActive&&this.visible&&(d||c?c&&1===p&&this.hide():this.hide()),new Promise((e=>{setTimeout(e)}))}}unselectDate(e){let t=this.selectedDates,s=this;if((e=k(e))instanceof Date)return t.some(((a,n)=>{if(p(a,e))return t.splice(n,1),s.selectedDates.length?s._updateLastSelectedDate(s.selectedDates[s.selectedDates.length-1]):(s.rangeDateFrom="",s.rangeDateTo="",s._updateLastSelectedDate(!1)),this.trigger(i.eventChangeSelectedDate,{action:i.actionUnselectDate,date:e}),!0}))}replaceDate(e,t){let s=this.selectedDates.find((t=>p(t,e,this.currentView))),a=this.selectedDates.indexOf(s);a<0||p(this.selectedDates[a],t,this.currentView)||(this.selectedDates[a]=t,this.trigger(i.eventChangeSelectedDate,{action:i.actionSelectDate,date:t,updateTime:!0}),this._updateLastSelectedDate(t))}clear(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.selectedDates=[],this.rangeDateFrom=!1,this.rangeDateTo=!1,this.trigger(i.eventChangeSelectedDate,{action:i.actionUnselectDate,silent:e.silent}),new Promise((e=>{setTimeout(e)}))}show(){let{onShow:e,isMobile:t}=this.opts;this._cancelScheduledCall(),this.visible||this.hideAnimation||this._createComponents(),this.setPosition(this.opts.position),this.$datepicker.classList.add("-active-"),this.visible=!0,e&&this._scheduleCallAfterTransition(e),t&&this._showMobileOverlay()}hide(){let{onHide:e,isMobile:t}=this.opts,i=this._hasTransition();this.visible=!1,this.hideAnimation=!0,this.$datepicker.classList.remove("-active-"),this.customHide&&this.customHide(),this.elIsInput&&this.$el.blur(),this._scheduleCallAfterTransition((t=>{!this.customHide&&(t&&i||!t&&!i)&&this._finishHide(),e&&e(t)})),t&&R.classList.remove("-active-")}_triggerOnSelect(){let e=[],t=[],{selectedDates:i,locale:s,opts:{onSelect:a,multipleDates:n,range:r}}=this,h=n||r,o="function"==typeof s.dateFormat;i.length&&(e=i.map(g),t=o?n?s.dateFormat(e):e.map((e=>s.dateFormat(e))):e.map((e=>this.formatDate(e,s.dateFormat)))),a({date:h?e:e[0],formattedDate:h?t:t[0],datepicker:this})}_handleAlreadySelectedDates(e,t){let{range:i,toggleSelected:s}=this.opts;i?s?this.unselectDate(t):2!==this.selectedDates.length&&this.selectDate(t):s&&this.unselectDate(t),s||this._updateLastSelectedDate(e)}_handleUpDownActions(e,t){if(!((e=k(e||this.focusDate||this.viewDate))instanceof Date))return;let i="up"===t?this.viewIndex+1:this.viewIndex-1;i>2&&(i=2),i<0&&(i=0),this.setViewDate(new Date(e.getFullYear(),e.getMonth(),1)),this.setCurrentView(this.viewIndexes[i])}_handleRangeOnFocus(){1===this.selectedDates.length&&(m(this.selectedDates[0],this.focusDate)?(this.rangeDateTo=this.selectedDates[0],this.rangeDateFrom=this.focusDate):(this.rangeDateTo=this.focusDate,this.rangeDateFrom=this.selectedDates[0]))}getCell(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i.day;if(!((e=k(e))instanceof Date))return;let{year:s,month:a,date:n}=o(e),r=`[data-year="${s}"]`,h=`[data-month="${a}"]`,l={[i.day]:`${r}${h}[data-date="${n}"]`,[i.month]:`${r}${h}`,[i.year]:`${r}`};return this.views[this.currentView].$el.querySelector(l[t])}_showMobileOverlay(){R.classList.add("-active-")}_hasTransition(){return window.getComputedStyle(this.$datepicker).getPropertyValue("transition-duration").split(", ").reduce(((e,t)=>parseFloat(t)+e),0)>0}get shouldUpdateDOM(){return this.visible||this.treatAsInline}get parsedViewDate(){return o(this.viewDate)}get currentViewSingular(){return this.currentView.slice(0,-1)}get curDecade(){return c(this.viewDate)}get viewIndex(){return this.viewIndexes.indexOf(this.currentView)}get isFinalView(){return this.currentView===i.years}get hasSelectedDates(){return this.selectedDates.length>0}get isMinViewReached(){return this.currentView===this.opts.minView||this.currentView===i.days}get $container(){return this.$customContainer||j}static replacer(e,t,i){return e.replace(t,(function(e,t,s,a){return t+i+a}))}}var U;return P(K,"defaults",s),P(K,"version","3.3.5"),P(K,"defaultGlobalContainerId","air-datepicker-global-container"),U=K.prototype,Object.assign(U,I),t.default}()}));
/*!
* Clamp.js 0.5.1
*
* Copyright 2011-2013, Joseph Schmitt http://joe.sh
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*/
(function(){window.$clamp=function(c,d){function s(a,b){n.getComputedStyle||(n.getComputedStyle=function(a,b){this.el=a;this.getPropertyValue=function(b){var c=/(\-([a-z]){1})/g;"float"==b&&(b="styleFloat");c.test(b)&&(b=b.replace(c,function(a,b,c){return c.toUpperCase()}));return a.currentStyle&&a.currentStyle[b]?a.currentStyle[b]:null};return this});return n.getComputedStyle(a,null).getPropertyValue(b)}function t(a){a=a||c.clientHeight;var b=u(c);return Math.max(Math.floor(a/b),0)}function x(a){return u(c)*
a}function u(a){var b=s(a,"line-height");"normal"==b&&(b=1.2*parseInt(s(a,"font-size")));return parseInt(b)}function l(a){if(a.lastChild.children&&0<a.lastChild.children.length)return l(Array.prototype.slice.call(a.children).pop());if(a.lastChild&&a.lastChild.nodeValue&&""!=a.lastChild.nodeValue&&a.lastChild.nodeValue!=b.truncationChar)return a.lastChild;a.lastChild.parentNode.removeChild(a.lastChild);return l(c)}function p(a,d){if(d){var e=a.nodeValue.replace(b.truncationChar,"");f||(h=0<k.length?
k.shift():"",f=e.split(h));1<f.length?(q=f.pop(),r(a,f.join(h))):f=null;m&&(a.nodeValue=a.nodeValue.replace(b.truncationChar,""),c.innerHTML=a.nodeValue+" "+m.innerHTML+b.truncationChar);if(f){if(c.clientHeight<=d)if(0<=k.length&&""!=h)r(a,f.join(h)+h+q),f=null;else return c.innerHTML}else""==h&&(r(a,""),a=l(c),k=b.splitOnChars.slice(0),h=k[0],q=f=null);if(b.animate)setTimeout(function(){p(a,d)},!0===b.animate?10:b.animate);else return p(a,d)}}function r(a,c){a.nodeValue=c+b.truncationChar}d=d||{};
var n=window,b={clamp:d.clamp||2,useNativeClamp:"undefined"!=typeof d.useNativeClamp?d.useNativeClamp:!0,splitOnChars:d.splitOnChars||[".","-","\u2013","\u2014"," "],animate:d.animate||!1,truncationChar:d.truncationChar||"\u2026",truncationHTML:d.truncationHTML},e=c.style,y=c.innerHTML,z="undefined"!=typeof c.style.webkitLineClamp,g=b.clamp,v=g.indexOf&&(-1<g.indexOf("px")||-1<g.indexOf("em")),m;b.truncationHTML&&(m=document.createElement("span"),m.innerHTML=b.truncationHTML);var k=b.splitOnChars.slice(0),
h=k[0],f,q;"auto"==g?g=t():v&&(g=t(parseInt(g)));var w;z&&b.useNativeClamp?(e.overflow="hidden",e.textOverflow="ellipsis",e.webkitBoxOrient="vertical",e.display="-webkit-box",e.webkitLineClamp=g,v&&(e.height=b.clamp+"px")):(e=x(g),e<=c.clientHeight&&(w=p(l(c),e)));return{original:y,clamped:w}}})();

/*!
 * GSAP 3.9.1
 * https://greensock.com
 * 
 * @license Copyright 2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t=t||self).window=t.window||{})}(this,function(e){"use strict";function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _assertThisInitialized(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function o(t){return"string"==typeof t}function p(t){return"function"==typeof t}function q(t){return"number"==typeof t}function r(t){return void 0===t}function s(t){return"object"==typeof t}function t(t){return!1!==t}function u(){return"undefined"!=typeof window}function v(t){return p(t)||o(t)}function M(t){return(h=mt(t,ot))&&oe}function N(t,e){return console.warn("Invalid property",t,"set to",e,"Missing plugin? gsap.registerPlugin()")}function O(t,e){return!e&&console.warn(t)}function P(t,e){return t&&(ot[t]=e)&&h&&(h[t]=e)||ot}function Q(){return 0}function $(t){var e,r,i=t[0];if(s(i)||p(i)||(t=[t]),!(e=(i._gsap||{}).harness)){for(r=ct.length;r--&&!ct[r].targetTest(i););e=ct[r]}for(r=t.length;r--;)t[r]&&(t[r]._gsap||(t[r]._gsap=new Lt(t[r],e)))||t.splice(r,1);return t}function _(t){return t._gsap||$(xt(t))[0]._gsap}function aa(t,e,i){return(i=t[e])&&p(i)?t[e]():r(i)&&t.getAttribute&&t.getAttribute(e)||i}function ba(t,e){return(t=t.split(",")).forEach(e)||t}function ca(t){return Math.round(1e5*t)/1e5||0}function da(t){return Math.round(1e7*t)/1e7||0}function ea(t,e){for(var r=e.length,i=0;t.indexOf(e[i])<0&&++i<r;);return i<r}function fa(){var t,e,r=ht.length,i=ht.slice(0);for(lt={},t=ht.length=0;t<r;t++)(e=i[t])&&e._lazy&&(e.render(e._lazy[0],e._lazy[1],!0)._lazy=0)}function ga(t,e,r,i){ht.length&&fa(),t.render(e,r,i),ht.length&&fa()}function ha(t){var e=parseFloat(t);return(e||0===e)&&(t+"").match(at).length<2?e:o(t)?t.trim():t}function ia(t){return t}function ja(t,e){for(var r in e)r in t||(t[r]=e[r]);return t}function ma(t,e){for(var r in e)"__proto__"!==r&&"constructor"!==r&&"prototype"!==r&&(t[r]=s(e[r])?ma(t[r]||(t[r]={}),e[r]):e[r]);return t}function na(t,e){var r,i={};for(r in t)r in e||(i[r]=t[r]);return i}function oa(e){var r=e.parent||I,i=e.keyframes?function _setKeyframeDefaults(i){return function(t,e){for(var r in e)r in t||"duration"===r&&i||"ease"===r||(t[r]=e[r])}}(W(e.keyframes)):ja;if(t(e.inherit))for(;r;)i(e,r.vars.defaults),r=r.parent||r._dp;return e}function ra(t,e,r,i){void 0===r&&(r="_first"),void 0===i&&(i="_last");var n=e._prev,a=e._next;n?n._next=a:t[r]===e&&(t[r]=a),a?a._prev=n:t[i]===e&&(t[i]=n),e._next=e._prev=e.parent=null}function sa(t,e){!t.parent||e&&!t.parent.autoRemoveChildren||t.parent.remove(t),t._act=0}function ta(t,e){if(t&&(!e||e._end>t._dur||e._start<0))for(var r=t;r;)r._dirty=1,r=r.parent;return t}function wa(t){return t._repeat?gt(t._tTime,t=t.duration()+t._rDelay)*t:0}function ya(t,e){return(t-e._start)*e._ts+(0<=e._ts?0:e._dirty?e.totalDuration():e._tDur)}function za(t){return t._end=da(t._start+(t._tDur/Math.abs(t._ts||t._rts||X)||0))}function Aa(t,e){var r=t._dp;return r&&r.smoothChildTiming&&t._ts&&(t._start=da(r._time-(0<t._ts?e/t._ts:((t._dirty?t.totalDuration():t._tDur)-e)/-t._ts)),za(t),r._dirty||ta(r,t)),t}function Ba(t,e){var r;if((e._time||e._initted&&!e._dur)&&(r=ya(t.rawTime(),e),(!e._dur||Tt(0,e.totalDuration(),r)-e._tTime>X)&&e.render(r,!0)),ta(t,e)._dp&&t._initted&&t._time>=t._dur&&t._ts){if(t._dur<t.duration())for(r=t;r._dp;)0<=r.rawTime()&&r.totalTime(r._tTime),r=r._dp;t._zTime=-X}}function Ca(t,e,r,i){return e.parent&&sa(e),e._start=da((q(r)?r:r||t!==I?bt(t,r,e):t._time)+e._delay),e._end=da(e._start+(e.totalDuration()/Math.abs(e.timeScale())||0)),function _addLinkedListItem(t,e,r,i,n){void 0===r&&(r="_first"),void 0===i&&(i="_last");var a,s=t[i];if(n)for(a=e[n];s&&s[n]>a;)s=s._prev;s?(e._next=s._next,s._next=e):(e._next=t[r],t[r]=e),e._next?e._next._prev=e:t[i]=e,e._prev=s,e.parent=e._dp=t}(t,e,"_first","_last",t._sort?"_start":0),vt(e)||(t._recent=e),i||Ba(t,e),t}function Da(t,e){return(ot.ScrollTrigger||N("scrollTrigger",e))&&ot.ScrollTrigger.create(e,t)}function Ea(t,e,r,i){return jt(t,e),t._initted?!r&&t._pt&&(t._dur&&!1!==t.vars.lazy||!t._dur&&t.vars.lazy)&&f!==St.frame?(ht.push(t),t._lazy=[e,i],1):void 0:1}function Ja(t,e,r,i){var n=t._repeat,a=da(e)||0,s=t._tTime/t._tDur;return s&&!i&&(t._time*=a/t._dur),t._dur=a,t._tDur=n?n<0?1e10:da(a*(n+1)+t._rDelay*n):a,0<s&&!i?Aa(t,t._tTime=t._tDur*s):t.parent&&za(t),r||ta(t.parent,t),t}function Ka(t){return t instanceof Nt?ta(t):Ja(t,t._dur)}function Na(e,r,i){var n,a,s=q(r[1]),o=(s?2:1)+(e<2?0:1),u=r[o];if(s&&(u.duration=r[1]),u.parent=i,e){for(n=u,a=i;a&&!("immediateRender"in n);)n=a.vars.defaults||{},a=t(a.vars.inherit)&&a.parent;u.immediateRender=t(n.immediateRender),e<2?u.runBackwards=1:u.startAt=r[o-1]}return new Jt(r[0],u,r[1+o])}function Oa(t,e){return t||0===t?e(t):e}function Qa(t,e){return o(t)&&(e=st.exec(t))?t.substr(e.index+e[0].length):""}function Ta(t,e){return t&&s(t)&&"length"in t&&(!e&&!t.length||t.length-1 in t&&s(t[0]))&&!t.nodeType&&t!==i}function Xa(t){return t.sort(function(){return.5-Math.random()})}function Ya(t){if(p(t))return t;var c=s(t)?t:{each:t},_=Rt(c.ease),m=c.from||0,g=parseFloat(c.base)||0,v={},e=0<m&&m<1,y=isNaN(m)||e,b=c.axis,T=m,w=m;return o(m)?T=w={center:.5,edges:.5,end:1}[m]||0:!e&&y&&(T=m[0],w=m[1]),function(t,e,r){var i,n,a,s,o,u,h,l,f,d=(r||c).length,p=v[d];if(!p){if(!(f="auto"===c.grid?0:(c.grid||[1,j])[1])){for(h=-j;h<(h=r[f++].getBoundingClientRect().left)&&f<d;);f--}for(p=v[d]=[],i=y?Math.min(f,d)*T-.5:m%f,n=f===j?0:y?d*w/f-.5:m/f|0,l=j,u=h=0;u<d;u++)a=u%f-i,s=n-(u/f|0),p[u]=o=b?Math.abs("y"===b?s:a):G(a*a+s*s),h<o&&(h=o),o<l&&(l=o);"random"===m&&Xa(p),p.max=h-l,p.min=l,p.v=d=(parseFloat(c.amount)||parseFloat(c.each)*(d<f?d-1:b?"y"===b?d/f:f:Math.max(f,d/f))||0)*("edges"===m?-1:1),p.b=d<0?g-d:g,p.u=Qa(c.amount||c.each)||0,_=_&&d<0?Bt(_):_}return d=(p[t]-p.min)/p.max||0,da(p.b+(_?_(d):d)*p.v)+p.u}}function Za(r){var i=Math.pow(10,((r+"").split(".")[1]||"").length);return function(t){var e=Math.round(parseFloat(t)/r)*r*i;return(e-e%1)/i+(q(t)?0:Qa(t))}}function $a(u,t){var h,l,e=W(u);return!e&&s(u)&&(h=e=u.radius||j,u.values?(u=xt(u.values),(l=!q(u[0]))&&(h*=h)):u=Za(u.increment)),Oa(t,e?p(u)?function(t){return l=u(t),Math.abs(l-t)<=h?l:t}:function(t){for(var e,r,i=parseFloat(l?t.x:t),n=parseFloat(l?t.y:0),a=j,s=0,o=u.length;o--;)(e=l?(e=u[o].x-i)*e+(r=u[o].y-n)*r:Math.abs(u[o]-i))<a&&(a=e,s=o);return s=!h||a<=h?u[s]:t,l||s===t||q(t)?s:s+Qa(t)}:Za(u))}function _a(t,e,r,i){return Oa(W(t)?!e:!0===r?!!(r=0):!i,function(){return W(t)?t[~~(Math.random()*t.length)]:(r=r||1e-5)&&(i=r<1?Math.pow(10,(r+"").length-2):1)&&Math.floor(Math.round((t-r/2+Math.random()*(e-t+.99*r))/r)*r*i)/i})}function db(e,r,t){return Oa(t,function(t){return e[~~r(t)]})}function gb(t){for(var e,r,i,n,a=0,s="";~(e=t.indexOf("random(",a));)i=t.indexOf(")",e),n="["===t.charAt(e+7),r=t.substr(e+7,i-e-7).match(n?at:tt),s+=t.substr(a,e-a)+_a(n?r:+r[0],n?0:+r[1],+r[2]||1e-5),a=i+1;return s+t.substr(a,t.length-a)}function jb(t,e,r){var i,n,a,s=t.labels,o=j;for(i in s)(n=s[i]-e)<0==!!r&&n&&o>(n=Math.abs(n))&&(a=i,o=n);return a}function lb(t){return sa(t),t.scrollTrigger&&t.scrollTrigger.kill(!1),t.progress()<1&&Mt(t,"onInterrupt"),t}function qb(t,e,r){return(6*(t+=t<0?1:1<t?-1:0)<1?e+(r-e)*t*6:t<.5?r:3*t<2?e+(r-e)*(2/3-t)*6:e)*kt+.5|0}function rb(t,e,r){var i,n,a,s,o,u,h,l,f,d,p=t?q(t)?[t>>16,t>>8&kt,t&kt]:0:Ct.black;if(!p){if(","===t.substr(-1)&&(t=t.substr(0,t.length-1)),Ct[t])p=Ct[t];else if("#"===t.charAt(0)){if(t.length<6&&(t="#"+(i=t.charAt(1))+i+(n=t.charAt(2))+n+(a=t.charAt(3))+a+(5===t.length?t.charAt(4)+t.charAt(4):"")),9===t.length)return[(p=parseInt(t.substr(1,6),16))>>16,p>>8&kt,p&kt,parseInt(t.substr(7),16)/255];p=[(t=parseInt(t.substr(1),16))>>16,t>>8&kt,t&kt]}else if("hsl"===t.substr(0,3))if(p=d=t.match(tt),e){if(~t.indexOf("="))return p=t.match(et),r&&p.length<4&&(p[3]=1),p}else s=+p[0]%360/360,o=p[1]/100,i=2*(u=p[2]/100)-(n=u<=.5?u*(o+1):u+o-u*o),3<p.length&&(p[3]*=1),p[0]=qb(s+1/3,i,n),p[1]=qb(s,i,n),p[2]=qb(s-1/3,i,n);else p=t.match(tt)||Ct.transparent;p=p.map(Number)}return e&&!d&&(i=p[0]/kt,n=p[1]/kt,a=p[2]/kt,u=((h=Math.max(i,n,a))+(l=Math.min(i,n,a)))/2,h===l?s=o=0:(f=h-l,o=.5<u?f/(2-h-l):f/(h+l),s=h===i?(n-a)/f+(n<a?6:0):h===n?(a-i)/f+2:(i-n)/f+4,s*=60),p[0]=~~(s+.5),p[1]=~~(100*o+.5),p[2]=~~(100*u+.5)),r&&p.length<4&&(p[3]=1),p}function sb(t){var r=[],i=[],n=-1;return t.split(Pt).forEach(function(t){var e=t.match(rt)||[];r.push.apply(r,e),i.push(n+=e.length+1)}),r.c=i,r}function tb(t,e,r){var i,n,a,s,o="",u=(t+o).match(Pt),h=e?"hsla(":"rgba(",l=0;if(!u)return t;if(u=u.map(function(t){return(t=rb(t,e,1))&&h+(e?t[0]+","+t[1]+"%,"+t[2]+"%,"+t[3]:t.join(","))+")"}),r&&(a=sb(t),(i=r.c).join(o)!==a.c.join(o)))for(s=(n=t.replace(Pt,"1").split(rt)).length-1;l<s;l++)o+=n[l]+(~i.indexOf(l)?u.shift()||h+"0,0,0,0)":(a.length?a:u.length?u:r).shift());if(!n)for(s=(n=t.split(Pt)).length-1;l<s;l++)o+=n[l]+u[l];return o+n[s]}function wb(t){var e,r=t.join(" ");if(Pt.lastIndex=0,Pt.test(r))return e=At.test(r),t[1]=tb(t[1],e),t[0]=tb(t[0],e,sb(t[1])),!0}function Fb(t){var e=(t+"").split("("),r=zt[e[0]];return r&&1<e.length&&r.config?r.config.apply(null,~t.indexOf("{")?[function _parseObjectInString(t){for(var e,r,i,n={},a=t.substr(1,t.length-3).split(":"),s=a[0],o=1,u=a.length;o<u;o++)r=a[o],e=o!==u-1?r.lastIndexOf(","):r.length,i=r.substr(0,e),n[s]=isNaN(i)?i.replace(Et,"").trim():+i,s=r.substr(e+1).trim();return n}(e[1])]:function _valueInParentheses(t){var e=t.indexOf("(")+1,r=t.indexOf(")"),i=t.indexOf("(",e);return t.substring(e,~i&&i<r?t.indexOf(")",r+1):r)}(t).split(",").map(ha)):zt._CE&&Ft.test(t)?zt._CE("",t):r}function Hb(t,e){for(var r,i=t._first;i;)i instanceof Nt?Hb(i,e):!i.vars.yoyoEase||i._yoyo&&i._repeat||i._yoyo===e||(i.timeline?Hb(i.timeline,e):(r=i._ease,i._ease=i._yEase,i._yEase=r,i._yoyo=e)),i=i._next}function Jb(t,e,r,i){void 0===r&&(r=function easeOut(t){return 1-e(1-t)}),void 0===i&&(i=function easeInOut(t){return t<.5?e(2*t)/2:1-e(2*(1-t))/2});var n,a={easeIn:e,easeOut:r,easeInOut:i};return ba(t,function(t){for(var e in zt[t]=ot[t]=a,zt[n=t.toLowerCase()]=r,a)zt[n+("easeIn"===e?".in":"easeOut"===e?".out":".inOut")]=zt[t+"."+e]=a[e]}),a}function Kb(e){return function(t){return t<.5?(1-e(1-2*t))/2:.5+e(2*(t-.5))/2}}function Lb(r,t,e){function Sl(t){return 1===t?1:i*Math.pow(2,-10*t)*K((t-a)*n)+1}var i=1<=t?t:1,n=(e||(r?.3:.45))/(t<1?t:1),a=n/U*(Math.asin(1/i)||0),s="out"===r?Sl:"in"===r?function(t){return 1-Sl(1-t)}:Kb(Sl);return n=U/n,s.config=function(t,e){return Lb(r,t,e)},s}function Mb(e,r){function $l(t){return t?--t*t*((r+1)*t+r)+1:0}void 0===r&&(r=1.70158);var t="out"===e?$l:"in"===e?function(t){return 1-$l(1-t)}:Kb($l);return t.config=function(t){return Mb(e,t)},t}var R,I,i,n,a,h,l,f,d,c,m,g,y,b,T,w,x,k,C,A,S,D,z,F,E,B,Y={autoSleep:120,force3D:"auto",nullTargetWarn:1,units:{lineHeight:""}},L={duration:.5,overwrite:!1,delay:0},j=1e8,X=1/j,U=2*Math.PI,V=U/4,J=0,G=Math.sqrt,Z=Math.cos,K=Math.sin,H="function"==typeof ArrayBuffer&&ArrayBuffer.isView||function(){},W=Array.isArray,tt=/(?:-?\.?\d|\.)+/gi,et=/[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,rt=/[-+=.]*\d+[.e-]*\d*[a-z%]*/g,it=/[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,nt=/[+-]=-?[.\d]+/,at=/[^,'"\[\]\s]+/gi,st=/[\d.+\-=]+(?:e[-+]\d*)*/i,ot={},ut={},ht=[],lt={},ft={},dt={},pt=30,ct=[],_t="",mt=function _merge(t,e){for(var r in e)t[r]=e[r];return t},gt=function _animationCycle(t,e){var r=Math.floor(t/=e);return t&&r===t?r-1:r},vt=function _isFromOrFromStart(t){var e=t.data;return"isFromStart"===e||"isStart"===e},yt={_start:0,endTime:Q,totalDuration:Q},bt=function _parsePosition(t,e,r){var i,n,a,s=t.labels,u=t._recent||yt,h=t.duration()>=j?u.endTime(!1):t._dur;return o(e)&&(isNaN(e)||e in s)?(n=e.charAt(0),a="%"===e.substr(-1),i=e.indexOf("="),"<"===n||">"===n?(0<=i&&(e=e.replace(/=/,"")),("<"===n?u._start:u.endTime(0<=u._repeat))+(parseFloat(e.substr(1))||0)*(a?(i<0?u:r).totalDuration()/100:1)):i<0?(e in s||(s[e]=h),s[e]):(n=parseFloat(e.charAt(i-1)+e.substr(i+1)),a&&r&&(n=n/100*(W(r)?r[0]:r).totalDuration()),1<i?_parsePosition(t,e.substr(0,i-1),r)+n:h+n)):null==e?h:+e},Tt=function _clamp(t,e,r){return r<t?t:e<r?e:r},wt=[].slice,xt=function toArray(t,e,r){return!o(t)||r||!n&&Dt()?W(t)?function _flatten(t,e,r){return void 0===r&&(r=[]),t.forEach(function(t){return o(t)&&!e||Ta(t,1)?r.push.apply(r,xt(t)):r.push(t)})||r}(t,r):Ta(t)?wt.call(t,0):t?[t]:[]:wt.call((e||a).querySelectorAll(t),0)},Ot=function mapRange(e,t,r,i,n){var a=t-e,s=i-r;return Oa(n,function(t){return r+((t-e)/a*s||0)})},Mt=function _callback(t,e,r){var i,n,a=t.vars,s=a[e];if(s)return i=a[e+"Params"],n=a.callbackScope||t,r&&ht.length&&fa(),i?s.apply(n,i):s.call(n)},kt=255,Ct={aqua:[0,kt,kt],lime:[0,kt,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,kt],navy:[0,0,128],white:[kt,kt,kt],olive:[128,128,0],yellow:[kt,kt,0],orange:[kt,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[kt,0,0],pink:[kt,192,203],cyan:[0,kt,kt],transparent:[kt,kt,kt,0]},Pt=function(){var t,e="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";for(t in Ct)e+="|"+t+"\\b";return new RegExp(e+")","gi")}(),At=/hsl[a]?\(/,St=(x=Date.now,k=500,C=33,A=x(),S=A,z=D=1e3/240,b={time:0,frame:0,tick:function tick(){Ok(!0)},deltaRatio:function deltaRatio(t){return T/(1e3/(t||60))},wake:function wake(){l&&(!n&&u()&&(i=n=window,a=i.document||{},ot.gsap=oe,(i.gsapVersions||(i.gsapVersions=[])).push(oe.version),M(h||i.GreenSockGlobals||!i.gsap&&i||{}),y=i.requestAnimationFrame),m&&b.sleep(),g=y||function(t){return setTimeout(t,z-1e3*b.time+1|0)},c=1,Ok(2))},sleep:function sleep(){(y?i.cancelAnimationFrame:clearTimeout)(m),c=0,g=Q},lagSmoothing:function lagSmoothing(t,e){k=t||1e8,C=Math.min(e,k,0)},fps:function fps(t){D=1e3/(t||240),z=1e3*b.time+D},add:function add(t){F.indexOf(t)<0&&F.push(t),Dt()},remove:function remove(t,e){~(e=F.indexOf(t))&&F.splice(e,1)&&e<=w&&w--},_listeners:F=[]}),Dt=function _wake(){return!c&&St.wake()},zt={},Ft=/^[\d.\-M][\d.\-,\s]/,Et=/["']/g,Bt=function _invertEase(e){return function(t){return 1-e(1-t)}},Rt=function _parseEase(t,e){return t&&(p(t)?t:zt[t]||Fb(t))||e};function Ok(t){var e,r,i,n,a=x()-S,s=!0===t;if(k<a&&(A+=a-C),(0<(e=(i=(S+=a)-A)-z)||s)&&(n=++b.frame,T=i-1e3*b.time,b.time=i/=1e3,z+=e+(D<=e?4:D-e),r=1),s||(m=g(Ok)),r)for(w=0;w<F.length;w++)F[w](i,T,n,t)}function pm(t){return t<B?E*t*t:t<.7272727272727273?E*Math.pow(t-1.5/2.75,2)+.75:t<.9090909090909092?E*(t-=2.25/2.75)*t+.9375:E*Math.pow(t-2.625/2.75,2)+.984375}ba("Linear,Quad,Cubic,Quart,Quint,Strong",function(t,e){var r=e<5?e+1:e;Jb(t+",Power"+(r-1),e?function(t){return Math.pow(t,r)}:function(t){return t},function(t){return 1-Math.pow(1-t,r)},function(t){return t<.5?Math.pow(2*t,r)/2:1-Math.pow(2*(1-t),r)/2})}),zt.Linear.easeNone=zt.none=zt.Linear.easeIn,Jb("Elastic",Lb("in"),Lb("out"),Lb()),E=7.5625,B=1/2.75,Jb("Bounce",function(t){return 1-pm(1-t)},pm),Jb("Expo",function(t){return t?Math.pow(2,10*(t-1)):0}),Jb("Circ",function(t){return-(G(1-t*t)-1)}),Jb("Sine",function(t){return 1===t?1:1-Z(t*V)}),Jb("Back",Mb("in"),Mb("out"),Mb()),zt.SteppedEase=zt.steps=ot.SteppedEase={config:function config(t,e){void 0===t&&(t=1);var r=1/t,i=t+(e?0:1),n=e?1:0;return function(t){return((i*Tt(0,.99999999,t)|0)+n)*r}}},L.ease=zt["quad.out"],ba("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",function(t){return _t+=t+","+t+"Params,"});var It,Lt=function GSCache(t,e){this.id=J++,(t._gsap=this).target=t,this.harness=e,this.get=e?e.get:aa,this.set=e?e.getSetter:Kt},qt=((It=Animation.prototype).delay=function delay(t){return t||0===t?(this.parent&&this.parent.smoothChildTiming&&this.startTime(this._start+t-this._delay),this._delay=t,this):this._delay},It.duration=function duration(t){return arguments.length?this.totalDuration(0<this._repeat?t+(t+this._rDelay)*this._repeat:t):this.totalDuration()&&this._dur},It.totalDuration=function totalDuration(t){return arguments.length?(this._dirty=0,Ja(this,this._repeat<0?t:(t-this._repeat*this._rDelay)/(this._repeat+1))):this._tDur},It.totalTime=function totalTime(t,e){if(Dt(),!arguments.length)return this._tTime;var r=this._dp;if(r&&r.smoothChildTiming&&this._ts){for(Aa(this,t),!r._dp||r.parent||Ba(r,this);r&&r.parent;)r.parent._time!==r._start+(0<=r._ts?r._tTime/r._ts:(r.totalDuration()-r._tTime)/-r._ts)&&r.totalTime(r._tTime,!0),r=r.parent;!this.parent&&this._dp.autoRemoveChildren&&(0<this._ts&&t<this._tDur||this._ts<0&&0<t||!this._tDur&&!t)&&Ca(this._dp,this,this._start-this._delay)}return(this._tTime!==t||!this._dur&&!e||this._initted&&Math.abs(this._zTime)===X||!t&&!this._initted&&(this.add||this._ptLookup))&&(this._ts||(this._pTime=t),ga(this,t,e)),this},It.time=function time(t,e){return arguments.length?this.totalTime(Math.min(this.totalDuration(),t+wa(this))%(this._dur+this._rDelay)||(t?this._dur:0),e):this._time},It.totalProgress=function totalProgress(t,e){return arguments.length?this.totalTime(this.totalDuration()*t,e):this.totalDuration()?Math.min(1,this._tTime/this._tDur):this.ratio},It.progress=function progress(t,e){return arguments.length?this.totalTime(this.duration()*(!this._yoyo||1&this.iteration()?t:1-t)+wa(this),e):this.duration()?Math.min(1,this._time/this._dur):this.ratio},It.iteration=function iteration(t,e){var r=this.duration()+this._rDelay;return arguments.length?this.totalTime(this._time+(t-1)*r,e):this._repeat?gt(this._tTime,r)+1:1},It.timeScale=function timeScale(t){if(!arguments.length)return this._rts===-X?0:this._rts;if(this._rts===t)return this;var e=this.parent&&this._ts?ya(this.parent._time,this):this._tTime;return this._rts=+t||0,this._ts=this._ps||t===-X?0:this._rts,function _recacheAncestors(t){for(var e=t.parent;e&&e.parent;)e._dirty=1,e.totalDuration(),e=e.parent}(this.totalTime(Tt(-this._delay,this._tDur,e),!0)),za(this),this},It.paused=function paused(t){return arguments.length?(this._ps!==t&&((this._ps=t)?(this._pTime=this._tTime||Math.max(-this._delay,this.rawTime()),this._ts=this._act=0):(Dt(),this._ts=this._rts,this.totalTime(this.parent&&!this.parent.smoothChildTiming?this.rawTime():this._tTime||this._pTime,1===this.progress()&&Math.abs(this._zTime)!==X&&(this._tTime-=X)))),this):this._ps},It.startTime=function startTime(t){if(arguments.length){this._start=t;var e=this.parent||this._dp;return!e||!e._sort&&this.parent||Ca(e,this,t-this._delay),this}return this._start},It.endTime=function endTime(e){return this._start+(t(e)?this.totalDuration():this.duration())/Math.abs(this._ts||1)},It.rawTime=function rawTime(t){var e=this.parent||this._dp;return e?t&&(!this._ts||this._repeat&&this._time&&this.totalProgress()<1)?this._tTime%(this._dur+this._rDelay):this._ts?ya(e.rawTime(t),this):this._tTime:this._tTime},It.globalTime=function globalTime(t){for(var e=this,r=arguments.length?t:e.rawTime();e;)r=e._start+r/(e._ts||1),e=e._dp;return r},It.repeat=function repeat(t){return arguments.length?(this._repeat=t===1/0?-2:t,Ka(this)):-2===this._repeat?1/0:this._repeat},It.repeatDelay=function repeatDelay(t){if(arguments.length){var e=this._time;return this._rDelay=t,Ka(this),e?this.time(e):this}return this._rDelay},It.yoyo=function yoyo(t){return arguments.length?(this._yoyo=t,this):this._yoyo},It.seek=function seek(e,r){return this.totalTime(bt(this,e),t(r))},It.restart=function restart(e,r){return this.play().totalTime(e?-this._delay:0,t(r))},It.play=function play(t,e){return null!=t&&this.seek(t,e),this.reversed(!1).paused(!1)},It.reverse=function reverse(t,e){return null!=t&&this.seek(t||this.totalDuration(),e),this.reversed(!0).paused(!1)},It.pause=function pause(t,e){return null!=t&&this.seek(t,e),this.paused(!0)},It.resume=function resume(){return this.paused(!1)},It.reversed=function reversed(t){return arguments.length?(!!t!==this.reversed()&&this.timeScale(-this._rts||(t?-X:0)),this):this._rts<0},It.invalidate=function invalidate(){return this._initted=this._act=0,this._zTime=-X,this},It.isActive=function isActive(){var t,e=this.parent||this._dp,r=this._start;return!(e&&!(this._ts&&this._initted&&e.isActive()&&(t=e.rawTime(!0))>=r&&t<this.endTime(!0)-X))},It.eventCallback=function eventCallback(t,e,r){var i=this.vars;return 1<arguments.length?(e?(i[t]=e,r&&(i[t+"Params"]=r),"onUpdate"===t&&(this._onUpdate=e)):delete i[t],this):i[t]},It.then=function then(t){var i=this;return new Promise(function(e){function Gn(){var t=i.then;i.then=null,p(r)&&(r=r(i))&&(r.then||r===i)&&(i.then=t),e(r),i.then=t}var r=p(t)?t:ia;i._initted&&1===i.totalProgress()&&0<=i._ts||!i._tTime&&i._ts<0?Gn():i._prom=Gn})},It.kill=function kill(){lb(this)},Animation);function Animation(t){this.vars=t,this._delay=+t.delay||0,(this._repeat=t.repeat===1/0?-2:t.repeat||0)&&(this._rDelay=t.repeatDelay||0,this._yoyo=!!t.yoyo||!!t.yoyoEase),this._ts=1,Ja(this,+t.duration,1,1),this.data=t.data,c||St.wake()}ja(qt.prototype,{_time:0,_start:0,_end:0,_tTime:0,_tDur:0,_dirty:0,_repeat:0,_yoyo:!1,parent:null,_initted:!1,_rDelay:0,_ts:1,_dp:0,ratio:0,_zTime:-X,_prom:0,_ps:!1,_rts:1});var Nt=function(n){function Timeline(e,r){var i;return void 0===e&&(e={}),(i=n.call(this,e)||this).labels={},i.smoothChildTiming=!!e.smoothChildTiming,i.autoRemoveChildren=!!e.autoRemoveChildren,i._sort=t(e.sortChildren),I&&Ca(e.parent||I,_assertThisInitialized(i),r),e.reversed&&i.reverse(),e.paused&&i.paused(!0),e.scrollTrigger&&Da(_assertThisInitialized(i),e.scrollTrigger),i}_inheritsLoose(Timeline,n);var e=Timeline.prototype;return e.to=function to(t,e,r){return Na(0,arguments,this),this},e.from=function from(t,e,r){return Na(1,arguments,this),this},e.fromTo=function fromTo(t,e,r,i){return Na(2,arguments,this),this},e.set=function set(t,e,r){return e.duration=0,e.parent=this,oa(e).repeatDelay||(e.repeat=0),e.immediateRender=!!e.immediateRender,new Jt(t,e,bt(this,r),1),this},e.call=function call(t,e,r){return Ca(this,Jt.delayedCall(0,t,e),r)},e.staggerTo=function staggerTo(t,e,r,i,n,a,s){return r.duration=e,r.stagger=r.stagger||i,r.onComplete=a,r.onCompleteParams=s,r.parent=this,new Jt(t,r,bt(this,n)),this},e.staggerFrom=function staggerFrom(e,r,i,n,a,s,o){return i.runBackwards=1,oa(i).immediateRender=t(i.immediateRender),this.staggerTo(e,r,i,n,a,s,o)},e.staggerFromTo=function staggerFromTo(e,r,i,n,a,s,o,u){return n.startAt=i,oa(n).immediateRender=t(n.immediateRender),this.staggerTo(e,r,n,a,s,o,u)},e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d,p,c,_=this._time,m=this._dirty?this.totalDuration():this._tDur,g=this._dur,v=t<=0?0:da(t),y=this._zTime<0!=t<0&&(this._initted||!g);if(this!==I&&m<v&&0<=t&&(v=m),v!==this._tTime||r||y){if(_!==this._time&&g&&(v+=this._time-_,t+=this._time-_),i=v,f=this._start,u=!(l=this._ts),y&&(g||(_=this._zTime),!t&&e||(this._zTime=t)),this._repeat){if(p=this._yoyo,o=g+this._rDelay,this._repeat<-1&&t<0)return this.totalTime(100*o+t,e,r);if(i=da(v%o),v===m?(s=this._repeat,i=g):((s=~~(v/o))&&s===v/o&&(i=g,s--),g<i&&(i=g)),d=gt(this._tTime,o),!_&&this._tTime&&d!==s&&(d=s),p&&1&s&&(i=g-i,c=1),s!==d&&!this._lock){var b=p&&1&d,T=b===(p&&1&s);if(s<d&&(b=!b),_=b?0:g,this._lock=1,this.render(_||(c?0:da(s*o)),e,!g)._lock=0,this._tTime=v,!e&&this.parent&&Mt(this,"onRepeat"),this.vars.repeatRefresh&&!c&&(this.invalidate()._lock=1),_&&_!==this._time||u!=!this._ts||this.vars.onRepeat&&!this.parent&&!this._act)return this;if(g=this._dur,m=this._tDur,T&&(this._lock=2,_=b?g:-1e-4,this.render(_,!0),this.vars.repeatRefresh&&!c&&this.invalidate()),this._lock=0,!this._ts&&!u)return this;Hb(this,c)}}if(this._hasPause&&!this._forcing&&this._lock<2&&(h=function _findNextPauseTween(t,e,r){var i;if(e<r)for(i=t._first;i&&i._start<=r;){if("isPause"===i.data&&i._start>e)return i;i=i._next}else for(i=t._last;i&&i._start>=r;){if("isPause"===i.data&&i._start<e)return i;i=i._prev}}(this,da(_),da(i)))&&(v-=i-(i=h._start)),this._tTime=v,this._time=i,this._act=!l,this._initted||(this._onUpdate=this.vars.onUpdate,this._initted=1,this._zTime=t,_=0),!_&&i&&!e&&(Mt(this,"onStart"),this._tTime!==v))return this;if(_<=i&&0<=t)for(n=this._first;n;){if(a=n._next,(n._act||i>=n._start)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(i-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(i-n._start)*n._ts,e,r),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=-X);break}}n=a}else{n=this._last;for(var w=t<0?t:i;n;){if(a=n._prev,(n._act||w<=n._end)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(w-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(w-n._start)*n._ts,e,r),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=w?-X:X);break}}n=a}}if(h&&!e&&(this.pause(),h.render(_<=i?0:-X)._zTime=_<=i?1:-1,this._ts))return this._start=f,za(this),this.render(t,e,r);this._onUpdate&&!e&&Mt(this,"onUpdate",!0),(v===m&&m>=this.totalDuration()||!v&&_)&&(f!==this._start&&Math.abs(l)===Math.abs(this._ts)||this._lock||(!t&&g||!(v===m&&0<this._ts||!v&&this._ts<0)||sa(this,1),e||t<0&&!_||!v&&!_&&m||(Mt(this,v===m&&0<=t?"onComplete":"onReverseComplete",!0),!this._prom||v<m&&0<this.timeScale()||this._prom())))}return this},e.add=function add(t,e){var r=this;if(q(e)||(e=bt(this,e,t)),!(t instanceof qt)){if(W(t))return t.forEach(function(t){return r.add(t,e)}),this;if(o(t))return this.addLabel(t,e);if(!p(t))return this;t=Jt.delayedCall(0,t)}return this!==t?Ca(this,t,e):this},e.getChildren=function getChildren(t,e,r,i){void 0===t&&(t=!0),void 0===e&&(e=!0),void 0===r&&(r=!0),void 0===i&&(i=-j);for(var n=[],a=this._first;a;)a._start>=i&&(a instanceof Jt?e&&n.push(a):(r&&n.push(a),t&&n.push.apply(n,a.getChildren(!0,e,r)))),a=a._next;return n},e.getById=function getById(t){for(var e=this.getChildren(1,1,1),r=e.length;r--;)if(e[r].vars.id===t)return e[r]},e.remove=function remove(t){return o(t)?this.removeLabel(t):p(t)?this.killTweensOf(t):(ra(this,t),t===this._recent&&(this._recent=this._last),ta(this))},e.totalTime=function totalTime(t,e){return arguments.length?(this._forcing=1,!this._dp&&this._ts&&(this._start=da(St.time-(0<this._ts?t/this._ts:(this.totalDuration()-t)/-this._ts))),n.prototype.totalTime.call(this,t,e),this._forcing=0,this):this._tTime},e.addLabel=function addLabel(t,e){return this.labels[t]=bt(this,e),this},e.removeLabel=function removeLabel(t){return delete this.labels[t],this},e.addPause=function addPause(t,e,r){var i=Jt.delayedCall(0,e||Q,r);return i.data="isPause",this._hasPause=1,Ca(this,i,bt(this,t))},e.removePause=function removePause(t){var e=this._first;for(t=bt(this,t);e;)e._start===t&&"isPause"===e.data&&sa(e),e=e._next},e.killTweensOf=function killTweensOf(t,e,r){for(var i=this.getTweensOf(t,r),n=i.length;n--;)Qt!==i[n]&&i[n].kill(t,e);return this},e.getTweensOf=function getTweensOf(t,e){for(var r,i=[],n=xt(t),a=this._first,s=q(e);a;)a instanceof Jt?ea(a._targets,n)&&(s?(!Qt||a._initted&&a._ts)&&a.globalTime(0)<=e&&a.globalTime(a.totalDuration())>e:!e||a.isActive())&&i.push(a):(r=a.getTweensOf(n,e)).length&&i.push.apply(i,r),a=a._next;return i},e.tweenTo=function tweenTo(t,e){e=e||{};var r,i=this,n=bt(i,t),a=e.startAt,s=e.onStart,o=e.onStartParams,u=e.immediateRender,h=Jt.to(i,ja({ease:e.ease||"none",lazy:!1,immediateRender:!1,time:n,overwrite:"auto",duration:e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale())||X,onStart:function onStart(){if(i.pause(),!r){var t=e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale());h._dur!==t&&Ja(h,t,0,1).render(h._time,!0,!0),r=1}s&&s.apply(h,o||[])}},e));return u?h.render(0):h},e.tweenFromTo=function tweenFromTo(t,e,r){return this.tweenTo(e,ja({startAt:{time:bt(this,t)}},r))},e.recent=function recent(){return this._recent},e.nextLabel=function nextLabel(t){return void 0===t&&(t=this._time),jb(this,bt(this,t))},e.previousLabel=function previousLabel(t){return void 0===t&&(t=this._time),jb(this,bt(this,t),1)},e.currentLabel=function currentLabel(t){return arguments.length?this.seek(t,!0):this.previousLabel(this._time+X)},e.shiftChildren=function shiftChildren(t,e,r){void 0===r&&(r=0);for(var i,n=this._first,a=this.labels;n;)n._start>=r&&(n._start+=t,n._end+=t),n=n._next;if(e)for(i in a)a[i]>=r&&(a[i]+=t);return ta(this)},e.invalidate=function invalidate(){var t=this._first;for(this._lock=0;t;)t.invalidate(),t=t._next;return n.prototype.invalidate.call(this)},e.clear=function clear(t){void 0===t&&(t=!0);for(var e,r=this._first;r;)e=r._next,this.remove(r),r=e;return this._dp&&(this._time=this._tTime=this._pTime=0),t&&(this.labels={}),ta(this)},e.totalDuration=function totalDuration(t){var e,r,i,n=0,a=this,s=a._last,o=j;if(arguments.length)return a.timeScale((a._repeat<0?a.duration():a.totalDuration())/(a.reversed()?-t:t));if(a._dirty){for(i=a.parent;s;)e=s._prev,s._dirty&&s.totalDuration(),o<(r=s._start)&&a._sort&&s._ts&&!a._lock?(a._lock=1,Ca(a,s,r-s._delay,1)._lock=0):o=r,r<0&&s._ts&&(n-=r,(!i&&!a._dp||i&&i.smoothChildTiming)&&(a._start+=r/a._ts,a._time-=r,a._tTime-=r),a.shiftChildren(-r,!1,-Infinity),o=0),s._end>n&&s._ts&&(n=s._end),s=e;Ja(a,a===I&&a._time>n?a._time:n,1,1),a._dirty=0}return a._tDur},Timeline.updateRoot=function updateRoot(t){if(I._ts&&(ga(I,ya(t,I)),f=St.frame),St.frame>=pt){pt+=Y.autoSleep||120;var e=I._first;if((!e||!e._ts)&&Y.autoSleep&&St._listeners.length<2){for(;e&&!e._ts;)e=e._next;e||St.sleep()}}},Timeline}(qt);ja(Nt.prototype,{_lock:0,_hasPause:0,_forcing:0});function Tb(t,e,r,i,n,a){var u,h,l,f;if(ft[t]&&!1!==(u=new ft[t]).init(n,u.rawVars?e[t]:function _processVars(t,e,r,i,n){if(p(t)&&(t=Xt(t,n,e,r,i)),!s(t)||t.style&&t.nodeType||W(t)||H(t))return o(t)?Xt(t,n,e,r,i):t;var a,u={};for(a in t)u[a]=Xt(t[a],n,e,r,i);return u}(e[t],i,n,a,r),r,i,a)&&(r._pt=h=new ae(r._pt,n,t,0,1,u.render,u,0,u.priority),r!==d))for(l=r._ptLookup[r._targets.indexOf(n)],f=u._props.length;f--;)l[u._props[f]]=h;return u}function Xb(t,r,e,i){var n,a,s=r.ease||i||"power1.inOut";if(W(r))a=e[t]||(e[t]=[]),r.forEach(function(t,e){return a.push({t:e/(r.length-1)*100,v:t,e:s})});else for(n in r)a=e[n]||(e[n]=[]),"ease"===n||a.push({t:parseFloat(t),v:r[n],e:s})}var Qt,Yt=function _addPropTween(t,e,r,i,n,a,s,u,h){p(i)&&(i=i(n||0,t,a));var l,f=t[e],d="get"!==r?r:p(f)?h?t[e.indexOf("set")||!p(t["get"+e.substr(3)])?e:"get"+e.substr(3)](h):t[e]():f,c=p(f)?h?Zt:$t:Gt;if(o(i)&&(~i.indexOf("random(")&&(i=gb(i)),"="===i.charAt(1)&&(!(l=parseFloat(d)+parseFloat(i.substr(2))*("-"===i.charAt(0)?-1:1)+(Qa(d)||0))&&0!==l||(i=l))),d!==i)return isNaN(d*i)||""===i?(f||e in t||N(e,i),function _addComplexStringPropTween(t,e,r,i,n,a,s){var o,u,h,l,f,d,p,c,_=new ae(this._pt,t,e,0,1,te,null,n),m=0,g=0;for(_.b=r,_.e=i,r+="",(p=~(i+="").indexOf("random("))&&(i=gb(i)),a&&(a(c=[r,i],t,e),r=c[0],i=c[1]),u=r.match(it)||[];o=it.exec(i);)l=o[0],f=i.substring(m,o.index),h?h=(h+1)%5:"rgba("===f.substr(-5)&&(h=1),l!==u[g++]&&(d=parseFloat(u[g-1])||0,_._pt={_next:_._pt,p:f||1===g?f:",",s:d,c:"="===l.charAt(1)?parseFloat(l.substr(2))*("-"===l.charAt(0)?-1:1):parseFloat(l)-d,m:h&&h<4?Math.round:0},m=it.lastIndex);return _.c=m<i.length?i.substring(m,i.length):"",_.fp=s,(nt.test(i)||p)&&(_.e=0),this._pt=_}.call(this,t,e,d,i,c,u||Y.stringFilter,h)):(l=new ae(this._pt,t,e,+d||0,i-(d||0),"boolean"==typeof f?Wt:Ht,0,c),h&&(l.fp=h),s&&l.modifier(s,this,t),this._pt=l)},jt=function _initTween(e,r){var i,n,a,s,o,u,h,l,f,d,p,c,m,g=e.vars,v=g.ease,y=g.startAt,b=g.immediateRender,T=g.lazy,w=g.onUpdate,x=g.onUpdateParams,O=g.callbackScope,M=g.runBackwards,k=g.yoyoEase,C=g.keyframes,P=g.autoRevert,A=e._dur,S=e._startAt,D=e._targets,z=e.parent,F=z&&"nested"===z.data?z.parent._targets:D,E="auto"===e._overwrite&&!R,B=e.timeline;if(!B||C&&v||(v="none"),e._ease=Rt(v,L.ease),e._yEase=k?Bt(Rt(!0===k?v:k,L.ease)):0,k&&e._yoyo&&!e._repeat&&(k=e._yEase,e._yEase=e._ease,e._ease=k),e._from=!B&&!!g.runBackwards,!B||C&&!g.stagger){if(c=(l=D[0]?_(D[0]).harness:0)&&g[l.prop],i=na(g,ut),S&&sa(S.render(-1,!0)),y)if(sa(e._startAt=Jt.set(D,ja({data:"isStart",overwrite:!1,parent:z,immediateRender:!0,lazy:t(T),startAt:null,delay:0,onUpdate:w,onUpdateParams:x,callbackScope:O,stagger:0},y))),r<0&&!b&&!P&&e._startAt.render(-1,!0),b){if(0<r&&!P&&(e._startAt=0),A&&r<=0)return void(r&&(e._zTime=r))}else!1===P&&(e._startAt=0);else if(M&&A)if(S)P||(e._startAt=0);else if(r&&(b=!1),a=ja({overwrite:!1,data:"isFromStart",lazy:b&&t(T),immediateRender:b,stagger:0,parent:z},i),c&&(a[l.prop]=c),sa(e._startAt=Jt.set(D,a)),r<0&&e._startAt.render(-1,!0),e._zTime=r,b){if(!r)return}else _initTween(e._startAt,X);for(e._pt=0,T=A&&t(T)||T&&!A,n=0;n<D.length;n++){if(h=(o=D[n])._gsap||$(D)[n]._gsap,e._ptLookup[n]=d={},lt[h.id]&&ht.length&&fa(),p=F===D?n:F.indexOf(o),l&&!1!==(f=new l).init(o,c||i,e,p,F)&&(e._pt=s=new ae(e._pt,o,f.name,0,1,f.render,f,0,f.priority),f._props.forEach(function(t){d[t]=s}),f.priority&&(u=1)),!l||c)for(a in i)ft[a]&&(f=Tb(a,i,e,p,o,F))?f.priority&&(u=1):d[a]=s=Yt.call(e,o,a,"get",i[a],p,F,0,g.stringFilter);e._op&&e._op[n]&&e.kill(o,e._op[n]),E&&e._pt&&(Qt=e,I.killTweensOf(o,d,e.globalTime(r)),m=!e.parent,Qt=0),e._pt&&T&&(lt[h.id]=1)}u&&ne(e),e._onInit&&e._onInit(e)}e._onUpdate=w,e._initted=(!e._op||e._pt)&&!m,C&&r<=0&&B.render(j,!0,!0)},Xt=function _parseFuncOrString(t,e,r,i,n){return p(t)?t.call(e,r,i,n):o(t)&&~t.indexOf("random(")?gb(t):t},Ut=_t+"repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase",Vt={};ba(Ut+",id,stagger,delay,duration,paused,scrollTrigger",function(t){return Vt[t]=1});var Jt=function(F){function Tween(e,r,i,n){var a;"number"==typeof r&&(i.duration=r,r=i,i=null);var o,u,h,l,f,d,p,c,_=(a=F.call(this,n?r:oa(r))||this).vars,m=_.duration,g=_.delay,y=_.immediateRender,b=_.stagger,T=_.overwrite,w=_.keyframes,x=_.defaults,M=_.scrollTrigger,k=_.yoyoEase,C=r.parent||I,P=(W(e)||H(e)?q(e[0]):"length"in r)?[e]:xt(e);if(a._targets=P.length?$(P):O("GSAP target "+e+" not found. https://greensock.com",!Y.nullTargetWarn)||[],a._ptLookup=[],a._overwrite=T,w||b||v(m)||v(g)){if(r=a.vars,(o=a.timeline=new Nt({data:"nested",defaults:x||{}})).kill(),o.parent=o._dp=_assertThisInitialized(a),o._start=0,b||v(m)||v(g)){if(l=P.length,p=b&&Ya(b),s(b))for(f in b)~Ut.indexOf(f)&&((c=c||{})[f]=b[f]);for(u=0;u<l;u++)(h=na(r,Vt)).stagger=0,k&&(h.yoyoEase=k),c&&mt(h,c),d=P[u],h.duration=+Xt(m,_assertThisInitialized(a),u,d,P),h.delay=(+Xt(g,_assertThisInitialized(a),u,d,P)||0)-a._delay,!b&&1===l&&h.delay&&(a._delay=g=h.delay,a._start+=g,h.delay=0),o.to(d,h,p?p(u,d,P):0),o._ease=zt.none;o.duration()?m=g=0:a.timeline=0}else if(w){oa(ja(o.vars.defaults,{ease:"none"})),o._ease=Rt(w.ease||r.ease||"none");var A,S,D,z=0;if(W(w))w.forEach(function(t){return o.to(P,t,">")});else{for(f in h={},w)"ease"===f||"easeEach"===f||Xb(f,w[f],h,w.easeEach);for(f in h)for(A=h[f].sort(function(t,e){return t.t-e.t}),u=z=0;u<A.length;u++)(D={ease:(S=A[u]).e,duration:(S.t-(u?A[u-1].t:0))/100*m})[f]=S.v,o.to(P,D,z),z+=D.duration;o.duration()<m&&o.to({},{duration:m-o.duration()})}}m||a.duration(m=o.duration())}else a.timeline=0;return!0!==T||R||(Qt=_assertThisInitialized(a),I.killTweensOf(P),Qt=0),Ca(C,_assertThisInitialized(a),i),r.reversed&&a.reverse(),r.paused&&a.paused(!0),(y||!m&&!w&&a._start===da(C._time)&&t(y)&&function _hasNoPausedAncestors(t){return!t||t._ts&&_hasNoPausedAncestors(t.parent)}(_assertThisInitialized(a))&&"nested"!==C.data)&&(a._tTime=-X,a.render(Math.max(0,-g))),M&&Da(_assertThisInitialized(a),M),a}_inheritsLoose(Tween,F);var e=Tween.prototype;return e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d=this._time,p=this._tDur,c=this._dur,_=p-X<t&&0<=t?p:t<X?0:t;if(c){if(_!==this._tTime||!t||r||!this._initted&&this._tTime||this._startAt&&this._zTime<0!=t<0){if(i=_,l=this.timeline,this._repeat){if(s=c+this._rDelay,this._repeat<-1&&t<0)return this.totalTime(100*s+t,e,r);if(i=da(_%s),_===p?(a=this._repeat,i=c):((a=~~(_/s))&&a===_/s&&(i=c,a--),c<i&&(i=c)),(u=this._yoyo&&1&a)&&(f=this._yEase,i=c-i),o=gt(this._tTime,s),i===d&&!r&&this._initted)return this;a!==o&&(l&&this._yEase&&Hb(l,u),!this.vars.repeatRefresh||u||this._lock||(this._lock=r=1,this.render(da(s*a),!0).invalidate()._lock=0))}if(!this._initted){if(Ea(this,t<0?t:i,r,e))return this._tTime=0,this;if(c!==this._dur)return this.render(t,e,r)}if(this._tTime=_,this._time=i,!this._act&&this._ts&&(this._act=1,this._lazy=0),this.ratio=h=(f||this._ease)(i/c),this._from&&(this.ratio=h=1-h),i&&!d&&!e&&(Mt(this,"onStart"),this._tTime!==_))return this;for(n=this._pt;n;)n.r(h,n.d),n=n._next;l&&l.render(t<0?t:!i&&u?-X:l._dur*l._ease(i/this._dur),e,r)||this._startAt&&(this._zTime=t),this._onUpdate&&!e&&(t<0&&this._startAt&&this._startAt.render(t,!0,r),Mt(this,"onUpdate")),this._repeat&&a!==o&&this.vars.onRepeat&&!e&&this.parent&&Mt(this,"onRepeat"),_!==this._tDur&&_||this._tTime!==_||(t<0&&this._startAt&&!this._onUpdate&&this._startAt.render(t,!0,!0),!t&&c||!(_===this._tDur&&0<this._ts||!_&&this._ts<0)||sa(this,1),e||t<0&&!d||!_&&!d||(Mt(this,_===p?"onComplete":"onReverseComplete",!0),!this._prom||_<p&&0<this.timeScale()||this._prom()))}}else!function _renderZeroDurationTween(t,e,r,i){var n,a,s,o=t.ratio,u=e<0||!e&&(!t._start&&function _parentPlayheadIsBeforeStart(t){var e=t.parent;return e&&e._ts&&e._initted&&!e._lock&&(e.rawTime()<0||_parentPlayheadIsBeforeStart(e))}(t)&&(t._initted||!vt(t))||(t._ts<0||t._dp._ts<0)&&!vt(t))?0:1,h=t._rDelay,l=0;if(h&&t._repeat&&(l=Tt(0,t._tDur,e),a=gt(l,h),t._yoyo&&1&a&&(u=1-u),a!==gt(t._tTime,h)&&(o=1-u,t.vars.repeatRefresh&&t._initted&&t.invalidate())),u!==o||i||t._zTime===X||!e&&t._zTime){if(!t._initted&&Ea(t,e,i,r))return;for(s=t._zTime,t._zTime=e||(r?X:0),r=r||e&&!s,t.ratio=u,t._from&&(u=1-u),t._time=0,t._tTime=l,n=t._pt;n;)n.r(u,n.d),n=n._next;t._startAt&&e<0&&t._startAt.render(e,!0,!0),t._onUpdate&&!r&&Mt(t,"onUpdate"),l&&t._repeat&&!r&&t.parent&&Mt(t,"onRepeat"),(e>=t._tDur||e<0)&&t.ratio===u&&(u&&sa(t,1),r||(Mt(t,u?"onComplete":"onReverseComplete",!0),t._prom&&t._prom()))}else t._zTime||(t._zTime=e)}(this,t,e,r);return this},e.targets=function targets(){return this._targets},e.invalidate=function invalidate(){return this._pt=this._op=this._startAt=this._onUpdate=this._lazy=this.ratio=0,this._ptLookup=[],this.timeline&&this.timeline.invalidate(),F.prototype.invalidate.call(this)},e.kill=function kill(t,e){if(void 0===e&&(e="all"),!(t||e&&"all"!==e))return this._lazy=this._pt=0,this.parent?lb(this):this;if(this.timeline){var r=this.timeline.totalDuration();return this.timeline.killTweensOf(t,e,Qt&&!0!==Qt.vars.overwrite)._first||lb(this),this.parent&&r!==this.timeline.totalDuration()&&Ja(this,this._dur*this.timeline._tDur/r,0,1),this}var i,n,a,s,u,h,l,f=this._targets,d=t?xt(t):f,p=this._ptLookup,c=this._pt;if((!e||"all"===e)&&function _arraysMatch(t,e){for(var r=t.length,i=r===e.length;i&&r--&&t[r]===e[r];);return r<0}(f,d))return"all"===e&&(this._pt=0),lb(this);for(i=this._op=this._op||[],"all"!==e&&(o(e)&&(u={},ba(e,function(t){return u[t]=1}),e=u),e=function _addAliasesToVars(t,e){var r,i,n,a,s=t[0]?_(t[0]).harness:0,o=s&&s.aliases;if(!o)return e;for(i in r=mt({},e),o)if(i in r)for(n=(a=o[i].split(",")).length;n--;)r[a[n]]=r[i];return r}(f,e)),l=f.length;l--;)if(~d.indexOf(f[l]))for(u in n=p[l],"all"===e?(i[l]=e,s=n,a={}):(a=i[l]=i[l]||{},s=e),s)(h=n&&n[u])&&("kill"in h.d&&!0!==h.d.kill(u)||ra(this,h,"_pt"),delete n[u]),"all"!==a&&(a[u]=1);return this._initted&&!this._pt&&c&&lb(this),this},Tween.to=function to(t,e,r){return new Tween(t,e,r)},Tween.from=function from(t,e){return Na(1,arguments)},Tween.delayedCall=function delayedCall(t,e,r,i){return new Tween(e,0,{immediateRender:!1,lazy:!1,overwrite:!1,delay:t,onComplete:e,onReverseComplete:e,onCompleteParams:r,onReverseCompleteParams:r,callbackScope:i})},Tween.fromTo=function fromTo(t,e,r){return Na(2,arguments)},Tween.set=function set(t,e){return e.duration=0,e.repeatDelay||(e.repeat=0),new Tween(t,e)},Tween.killTweensOf=function killTweensOf(t,e,r){return I.killTweensOf(t,e,r)},Tween}(qt);ja(Jt.prototype,{_targets:[],_lazy:0,_startAt:0,_op:0,_onInit:0}),ba("staggerTo,staggerFrom,staggerFromTo",function(r){Jt[r]=function(){var t=new Nt,e=wt.call(arguments,0);return e.splice("staggerFromTo"===r?5:4,0,0),t[r].apply(t,e)}});function dc(t,e,r){return t.setAttribute(e,r)}function lc(t,e,r,i){i.mSet(t,e,i.m.call(i.tween,r,i.mt),i)}var Gt=function _setterPlain(t,e,r){return t[e]=r},$t=function _setterFunc(t,e,r){return t[e](r)},Zt=function _setterFuncWithParam(t,e,r,i){return t[e](i.fp,r)},Kt=function _getSetter(t,e){return p(t[e])?$t:r(t[e])&&t.setAttribute?dc:Gt},Ht=function _renderPlain(t,e){return e.set(e.t,e.p,Math.round(1e6*(e.s+e.c*t))/1e6,e)},Wt=function _renderBoolean(t,e){return e.set(e.t,e.p,!!(e.s+e.c*t),e)},te=function _renderComplexString(t,e){var r=e._pt,i="";if(!t&&e.b)i=e.b;else if(1===t&&e.e)i=e.e;else{for(;r;)i=r.p+(r.m?r.m(r.s+r.c*t):Math.round(1e4*(r.s+r.c*t))/1e4)+i,r=r._next;i+=e.c}e.set(e.t,e.p,i,e)},ee=function _renderPropTweens(t,e){for(var r=e._pt;r;)r.r(t,r.d),r=r._next},re=function _addPluginModifier(t,e,r,i){for(var n,a=this._pt;a;)n=a._next,a.p===i&&a.modifier(t,e,r),a=n},ie=function _killPropTweensOf(t){for(var e,r,i=this._pt;i;)r=i._next,i.p===t&&!i.op||i.op===t?ra(this,i,"_pt"):i.dep||(e=1),i=r;return!e},ne=function _sortPropTweensByPriority(t){for(var e,r,i,n,a=t._pt;a;){for(e=a._next,r=i;r&&r.pr>a.pr;)r=r._next;(a._prev=r?r._prev:n)?a._prev._next=a:i=a,(a._next=r)?r._prev=a:n=a,a=e}t._pt=i},ae=(PropTween.prototype.modifier=function modifier(t,e,r){this.mSet=this.mSet||this.set,this.set=lc,this.m=t,this.mt=r,this.tween=e},PropTween);function PropTween(t,e,r,i,n,a,s,o,u){this.t=e,this.s=i,this.c=n,this.p=r,this.r=a||Ht,this.d=s||this,this.set=o||Gt,this.pr=u||0,(this._next=t)&&(t._prev=this)}ba(_t+"parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",function(t){return ut[t]=1}),ot.TweenMax=ot.TweenLite=Jt,ot.TimelineLite=ot.TimelineMax=Nt,I=new Nt({sortChildren:!1,defaults:L,autoRemoveChildren:!0,id:"root",smoothChildTiming:!0}),Y.stringFilter=wb;var se={registerPlugin:function registerPlugin(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];e.forEach(function(t){return function _createPlugin(t){var e=(t=!t.name&&t.default||t).name,r=p(t),i=e&&!r&&t.init?function(){this._props=[]}:t,n={init:Q,render:ee,add:Yt,kill:ie,modifier:re,rawVars:0},a={targetTest:0,get:0,getSetter:Kt,aliases:{},register:0};if(Dt(),t!==i){if(ft[e])return;ja(i,ja(na(t,n),a)),mt(i.prototype,mt(n,na(t,a))),ft[i.prop=e]=i,t.targetTest&&(ct.push(i),ut[e]=1),e=("css"===e?"CSS":e.charAt(0).toUpperCase()+e.substr(1))+"Plugin"}P(e,i),t.register&&t.register(oe,i,ae)}(t)})},timeline:function timeline(t){return new Nt(t)},getTweensOf:function getTweensOf(t,e){return I.getTweensOf(t,e)},getProperty:function getProperty(i,t,e,r){o(i)&&(i=xt(i)[0]);var n=_(i||{}).get,a=e?ia:ha;return"native"===e&&(e=""),i?t?a((ft[t]&&ft[t].get||n)(i,t,e,r)):function(t,e,r){return a((ft[t]&&ft[t].get||n)(i,t,e,r))}:i},quickSetter:function quickSetter(r,e,i){if(1<(r=xt(r)).length){var n=r.map(function(t){return oe.quickSetter(t,e,i)}),a=n.length;return function(t){for(var e=a;e--;)n[e](t)}}r=r[0]||{};var s=ft[e],o=_(r),u=o.harness&&(o.harness.aliases||{})[e]||e,h=s?function(t){var e=new s;d._pt=0,e.init(r,i?t+i:t,d,0,[r]),e.render(1,e),d._pt&&ee(1,d)}:o.set(r,u);return s?h:function(t){return h(r,u,i?t+i:t,o,1)}},isTweening:function isTweening(t){return 0<I.getTweensOf(t,!0).length},defaults:function defaults(t){return t&&t.ease&&(t.ease=Rt(t.ease,L.ease)),ma(L,t||{})},config:function config(t){return ma(Y,t||{})},registerEffect:function registerEffect(t){var i=t.name,n=t.effect,e=t.plugins,a=t.defaults,r=t.extendTimeline;(e||"").split(",").forEach(function(t){return t&&!ft[t]&&!ot[t]&&O(i+" effect requires "+t+" plugin.")}),dt[i]=function(t,e,r){return n(xt(t),ja(e||{},a),r)},r&&(Nt.prototype[i]=function(t,e,r){return this.add(dt[i](t,s(e)?e:(r=e)&&{},this),r)})},registerEase:function registerEase(t,e){zt[t]=Rt(e)},parseEase:function parseEase(t,e){return arguments.length?Rt(t,e):zt},getById:function getById(t){return I.getById(t)},exportRoot:function exportRoot(e,r){void 0===e&&(e={});var i,n,a=new Nt(e);for(a.smoothChildTiming=t(e.smoothChildTiming),I.remove(a),a._dp=0,a._time=a._tTime=I._time,i=I._first;i;)n=i._next,!r&&!i._dur&&i instanceof Jt&&i.vars.onComplete===i._targets[0]||Ca(a,i,i._start-i._delay),i=n;return Ca(I,a,0),a},utils:{wrap:function wrap(e,t,r){var i=t-e;return W(e)?db(e,wrap(0,e.length),t):Oa(r,function(t){return(i+(t-e)%i)%i+e})},wrapYoyo:function wrapYoyo(e,t,r){var i=t-e,n=2*i;return W(e)?db(e,wrapYoyo(0,e.length-1),t):Oa(r,function(t){return e+(i<(t=(n+(t-e)%n)%n||0)?n-t:t)})},distribute:Ya,random:_a,snap:$a,normalize:function normalize(t,e,r){return Ot(t,e,0,1,r)},getUnit:Qa,clamp:function clamp(e,r,t){return Oa(t,function(t){return Tt(e,r,t)})},splitColor:rb,toArray:xt,selector:function selector(r){return r=xt(r)[0]||O("Invalid scope")||{},function(t){var e=r.current||r.nativeElement||r;return xt(t,e.querySelectorAll?e:e===r?O("Invalid scope")||a.createElement("div"):r)}},mapRange:Ot,pipe:function pipe(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];return function(t){return e.reduce(function(t,e){return e(t)},t)}},unitize:function unitize(e,r){return function(t){return e(parseFloat(t))+(r||Qa(t))}},interpolate:function interpolate(e,r,t,i){var n=isNaN(e+r)?0:function(t){return(1-t)*e+t*r};if(!n){var a,s,u,h,l,f=o(e),d={};if(!0===t&&(i=1)&&(t=null),f)e={p:e},r={p:r};else if(W(e)&&!W(r)){for(u=[],h=e.length,l=h-2,s=1;s<h;s++)u.push(interpolate(e[s-1],e[s]));h--,n=function func(t){t*=h;var e=Math.min(l,~~t);return u[e](t-e)},t=r}else i||(e=mt(W(e)?[]:{},e));if(!u){for(a in r)Yt.call(d,e,a,"get",r[a]);n=function func(t){return ee(t,d)||(f?e.p:e)}}}return Oa(t,n)},shuffle:Xa},install:M,effects:dt,ticker:St,updateRoot:Nt.updateRoot,plugins:ft,globalTimeline:I,core:{PropTween:ae,globals:P,Tween:Jt,Timeline:Nt,Animation:qt,getCache:_,_removeLinkedListItem:ra,suppressOverwrites:function suppressOverwrites(t){return R=t}}};ba("to,from,fromTo,delayedCall,set,killTweensOf",function(t){return se[t]=Jt[t]}),St.add(Nt.updateRoot),d=se.to({},{duration:0});function pc(t,e){for(var r=t._pt;r&&r.p!==e&&r.op!==e&&r.fp!==e;)r=r._next;return r}function rc(t,n){return{name:t,rawVars:1,init:function init(t,i,e){e._onInit=function(t){var e,r;if(o(i)&&(e={},ba(i,function(t){return e[t]=1}),i=e),n){for(r in e={},i)e[r]=n(i[r]);i=e}!function _addModifiers(t,e){var r,i,n,a=t._targets;for(r in e)for(i=a.length;i--;)(n=(n=t._ptLookup[i][r])&&n.d)&&(n._pt&&(n=pc(n,r)),n&&n.modifier&&n.modifier(e[r],t,a[i],r))}(t,i)}}}}var oe=se.registerPlugin({name:"attr",init:function init(t,e,r,i,n){var a,s;for(a in e)(s=this.add(t,"setAttribute",(t.getAttribute(a)||0)+"",e[a],i,n,0,0,a))&&(s.op=a),this._props.push(a)}},{name:"endArray",init:function init(t,e){for(var r=e.length;r--;)this.add(t,r,t[r]||0,e[r])}},rc("roundProps",Za),rc("modifiers"),rc("snap",$a))||se;Jt.version=Nt.version=oe.version="3.9.1",l=1,u()&&Dt();function ad(t,e){return e.set(e.t,e.p,Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function bd(t,e){return e.set(e.t,e.p,1===t?e.e:Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function cd(t,e){return e.set(e.t,e.p,t?Math.round(1e4*(e.s+e.c*t))/1e4+e.u:e.b,e)}function dd(t,e){var r=e.s+e.c*t;e.set(e.t,e.p,~~(r+(r<0?-.5:.5))+e.u,e)}function ed(t,e){return e.set(e.t,e.p,t?e.e:e.b,e)}function fd(t,e){return e.set(e.t,e.p,1!==t?e.b:e.e,e)}function gd(t,e,r){return t.style[e]=r}function hd(t,e,r){return t.style.setProperty(e,r)}function id(t,e,r){return t._gsap[e]=r}function jd(t,e,r){return t._gsap.scaleX=t._gsap.scaleY=r}function kd(t,e,r,i,n){var a=t._gsap;a.scaleX=a.scaleY=r,a.renderTransform(n,a)}function ld(t,e,r,i,n){var a=t._gsap;a[e]=r,a.renderTransform(n,a)}function pd(t,e){var r=he.createElementNS?he.createElementNS((e||"http://www.w3.org/1999/xhtml").replace(/^https/,"http"),t):he.createElement(t);return r.style?r:he.createElement(t)}function qd(t,e,r){var i=getComputedStyle(t);return i[e]||i.getPropertyValue(e.replace(Ie,"-$1").toLowerCase())||i.getPropertyValue(e)||!r&&qd(t,Xe(e)||e,1)||""}function td(){(function _windowExists(){return"undefined"!=typeof window})()&&window.document&&(ue=window,he=ue.document,le=he.documentElement,de=pd("div")||{style:{}},pd("div"),Qe=Xe(Qe),Ye=Qe+"Origin",de.style.cssText="border-width:0;line-height:0;position:absolute;padding:0",ce=!!Xe("perspective"),fe=1)}function ud(t){var e,r=pd("svg",this.ownerSVGElement&&this.ownerSVGElement.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),i=this.parentNode,n=this.nextSibling,a=this.style.cssText;if(le.appendChild(r),r.appendChild(this),this.style.display="block",t)try{e=this.getBBox(),this._gsapBBox=this.getBBox,this.getBBox=ud}catch(t){}else this._gsapBBox&&(e=this._gsapBBox());return i&&(n?i.insertBefore(this,n):i.appendChild(this)),le.removeChild(r),this.style.cssText=a,e}function vd(t,e){for(var r=e.length;r--;)if(t.hasAttribute(e[r]))return t.getAttribute(e[r])}function wd(e){var r;try{r=e.getBBox()}catch(t){r=ud.call(e,!0)}return r&&(r.width||r.height)||e.getBBox===ud||(r=ud.call(e,!0)),!r||r.width||r.x||r.y?r:{x:+vd(e,["x","cx","x1"])||0,y:+vd(e,["y","cy","y1"])||0,width:0,height:0}}function xd(t){return!(!t.getCTM||t.parentNode&&!t.ownerSVGElement||!wd(t))}function yd(t,e){if(e){var r=t.style;e in Fe&&e!==Ye&&(e=Qe),r.removeProperty?("ms"!==e.substr(0,2)&&"webkit"!==e.substr(0,6)||(e="-"+e),r.removeProperty(e.replace(Ie,"-$1").toLowerCase())):r.removeAttribute(e)}}function zd(t,e,r,i,n,a){var s=new ae(t._pt,e,r,0,1,a?fd:ed);return(t._pt=s).b=i,s.e=n,t._props.push(r),s}function Bd(t,e,r,i){var n,a,s,o,u=parseFloat(r)||0,h=(r+"").trim().substr((u+"").length)||"px",l=de.style,f=Le.test(e),d="svg"===t.tagName.toLowerCase(),p=(d?"client":"offset")+(f?"Width":"Height"),c="px"===i,m="%"===i;return i===h||!u||Ue[i]||Ue[h]?u:("px"===h||c||(u=Bd(t,e,r,"px")),o=t.getCTM&&xd(t),!m&&"%"!==h||!Fe[e]&&!~e.indexOf("adius")?(l[f?"width":"height"]=100+(c?h:i),a=~e.indexOf("adius")||"em"===i&&t.appendChild&&!d?t:t.parentNode,o&&(a=(t.ownerSVGElement||{}).parentNode),a&&a!==he&&a.appendChild||(a=he.body),(s=a._gsap)&&m&&s.width&&f&&s.time===St.time?ca(u/s.width*100):(!m&&"%"!==h||(l.position=qd(t,"position")),a===t&&(l.position="static"),a.appendChild(de),n=de[p],a.removeChild(de),l.position="absolute",f&&m&&((s=_(a)).time=St.time,s.width=a[p]),ca(c?n*u/100:n&&u?100/n*u:0))):(n=o?t.getBBox()[f?"width":"height"]:t[p],ca(m?u/n*100:u/100*n)))}function Cd(t,e,r,i){var n;return fe||td(),e in Ne&&"transform"!==e&&~(e=Ne[e]).indexOf(",")&&(e=e.split(",")[0]),Fe[e]&&"transform"!==e?(n=Ze(t,i),n="transformOrigin"!==e?n[e]:n.svg?n.origin:Ke(qd(t,Ye))+" "+n.zOrigin+"px"):(n=t.style[e])&&"auto"!==n&&!i&&!~(n+"").indexOf("calc(")||(n=Je[e]&&Je[e](t,e,r)||qd(t,e)||aa(t,e)||("opacity"===e?1:0)),r&&!~(n+"").trim().indexOf(" ")?Bd(t,e,n,r)+r:n}function Dd(t,e,r,i){if(!r||"none"===r){var n=Xe(e,t,1),a=n&&qd(t,n,1);a&&a!==r?(e=n,r=a):"borderColor"===e&&(r=qd(t,"borderTopColor"))}var s,o,u,h,l,f,d,p,c,_,m,g,v=new ae(this._pt,t.style,e,0,1,te),y=0,b=0;if(v.b=r,v.e=i,r+="","auto"===(i+="")&&(t.style[e]=i,i=qd(t,e)||i,t.style[e]=r),wb(s=[r,i]),i=s[1],u=(r=s[0]).match(rt)||[],(i.match(rt)||[]).length){for(;o=rt.exec(i);)d=o[0],c=i.substring(y,o.index),l?l=(l+1)%5:"rgba("!==c.substr(-5)&&"hsla("!==c.substr(-5)||(l=1),d!==(f=u[b++]||"")&&(h=parseFloat(f)||0,m=f.substr((h+"").length),(g="="===d.charAt(1)?+(d.charAt(0)+"1"):0)&&(d=d.substr(2)),p=parseFloat(d),_=d.substr((p+"").length),y=rt.lastIndex-_.length,_||(_=_||Y.units[e]||m,y===i.length&&(i+=_,v.e+=_)),m!==_&&(h=Bd(t,e,f,_)||0),v._pt={_next:v._pt,p:c||1===b?c:",",s:h,c:g?g*p:p-h,m:l&&l<4||"zIndex"===e?Math.round:0});v.c=y<i.length?i.substring(y,i.length):""}else v.r="display"===e&&"none"===i?fd:ed;return nt.test(i)&&(v.e=0),this._pt=v}function Fd(t){var e=t.split(" "),r=e[0],i=e[1]||"50%";return"top"!==r&&"bottom"!==r&&"left"!==i&&"right"!==i||(t=r,r=i,i=t),e[0]=Ve[r]||r,e[1]=Ve[i]||i,e.join(" ")}function Gd(t,e){if(e.tween&&e.tween._time===e.tween._dur){var r,i,n,a=e.t,s=a.style,o=e.u,u=a._gsap;if("all"===o||!0===o)s.cssText="",i=1;else for(n=(o=o.split(",")).length;-1<--n;)r=o[n],Fe[r]&&(i=1,r="transformOrigin"===r?Ye:Qe),yd(a,r);i&&(yd(a,Qe),u&&(u.svg&&a.removeAttribute("transform"),Ze(a,1),u.uncache=1))}}function Kd(t){return"matrix(1, 0, 0, 1, 0, 0)"===t||"none"===t||!t}function Ld(t){var e=qd(t,Qe);return Kd(e)?Ge:e.substr(7).match(et).map(ca)}function Md(t,e){var r,i,n,a,s=t._gsap||_(t),o=t.style,u=Ld(t);return s.svg&&t.getAttribute("transform")?"1,0,0,1,0,0"===(u=[(n=t.transform.baseVal.consolidate().matrix).a,n.b,n.c,n.d,n.e,n.f]).join(",")?Ge:u:(u!==Ge||t.offsetParent||t===le||s.svg||(n=o.display,o.display="block",(r=t.parentNode)&&t.offsetParent||(a=1,i=t.nextSibling,le.appendChild(t)),u=Ld(t),n?o.display=n:yd(t,"display"),a&&(i?r.insertBefore(t,i):r?r.appendChild(t):le.removeChild(t))),e&&6<u.length?[u[0],u[1],u[4],u[5],u[12],u[13]]:u)}function Nd(t,e,r,i,n,a){var s,o,u,h=t._gsap,l=n||Md(t,!0),f=h.xOrigin||0,d=h.yOrigin||0,p=h.xOffset||0,c=h.yOffset||0,_=l[0],m=l[1],g=l[2],v=l[3],y=l[4],b=l[5],T=e.split(" "),w=parseFloat(T[0])||0,x=parseFloat(T[1])||0;r?l!==Ge&&(o=_*v-m*g)&&(u=w*(-m/o)+x*(_/o)-(_*b-m*y)/o,w=w*(v/o)+x*(-g/o)+(g*b-v*y)/o,x=u):(w=(s=wd(t)).x+(~T[0].indexOf("%")?w/100*s.width:w),x=s.y+(~(T[1]||T[0]).indexOf("%")?x/100*s.height:x)),i||!1!==i&&h.smooth?(y=w-f,b=x-d,h.xOffset=p+(y*_+b*g)-y,h.yOffset=c+(y*m+b*v)-b):h.xOffset=h.yOffset=0,h.xOrigin=w,h.yOrigin=x,h.smooth=!!i,h.origin=e,h.originIsAbsolute=!!r,t.style[Ye]="0px 0px",a&&(zd(a,h,"xOrigin",f,w),zd(a,h,"yOrigin",d,x),zd(a,h,"xOffset",p,h.xOffset),zd(a,h,"yOffset",c,h.yOffset)),t.setAttribute("data-svg-origin",w+" "+x)}function Qd(t,e,r){var i=Qa(e);return ca(parseFloat(e)+parseFloat(Bd(t,"x",r+"px",i)))+i}function Xd(t,e,r,i,n,a){var s,u,h=360,l=o(n),f=parseFloat(n)*(l&&~n.indexOf("rad")?Ee:1),d=a?f*a:f-i,p=i+d+"deg";return l&&("short"===(s=n.split("_")[1])&&(d%=h)!==d%180&&(d+=d<0?h:-h),"cw"===s&&d<0?d=(d+36e9)%h-~~(d/h)*h:"ccw"===s&&0<d&&(d=(d-36e9)%h-~~(d/h)*h)),t._pt=u=new ae(t._pt,e,r,i,d,bd),u.e=p,u.u="deg",t._props.push(r),u}function Yd(t,e){for(var r in e)t[r]=e[r];return t}function Zd(t,e,r){var i,n,a,s,o,u,h,l=Yd({},r._gsap),f=r.style;for(n in l.svg?(a=r.getAttribute("transform"),r.setAttribute("transform",""),f[Qe]=e,i=Ze(r,1),yd(r,Qe),r.setAttribute("transform",a)):(a=getComputedStyle(r)[Qe],f[Qe]=e,i=Ze(r,1),f[Qe]=a),Fe)(a=l[n])!==(s=i[n])&&"perspective,force3D,transformOrigin,svgOrigin".indexOf(n)<0&&(o=Qa(a)!==(h=Qa(s))?Bd(r,n,a,h):parseFloat(a),u=parseFloat(s),t._pt=new ae(t._pt,i,n,o,u-o,ad),t._pt.u=h||0,t._props.push(n));Yd(i,l)}var ue,he,le,fe,de,pe,ce,_e=zt.Power0,me=zt.Power1,ge=zt.Power2,ve=zt.Power3,ye=zt.Power4,be=zt.Linear,Te=zt.Quad,we=zt.Cubic,xe=zt.Quart,Oe=zt.Quint,Me=zt.Strong,ke=zt.Elastic,Ce=zt.Back,Pe=zt.SteppedEase,Ae=zt.Bounce,Se=zt.Sine,De=zt.Expo,ze=zt.Circ,Fe={},Ee=180/Math.PI,Be=Math.PI/180,Re=Math.atan2,Ie=/([A-Z])/g,Le=/(?:left|right|width|margin|padding|x)/i,qe=/[\s,\(]\S/,Ne={autoAlpha:"opacity,visibility",scale:"scaleX,scaleY",alpha:"opacity"},Qe="transform",Ye=Qe+"Origin",je="O,Moz,ms,Ms,Webkit".split(","),Xe=function _checkPropPrefix(t,e,r){var i=(e||de).style,n=5;if(t in i&&!r)return t;for(t=t.charAt(0).toUpperCase()+t.substr(1);n--&&!(je[n]+t in i););return n<0?null:(3===n?"ms":0<=n?je[n]:"")+t},Ue={deg:1,rad:1,turn:1},Ve={top:"0%",bottom:"100%",left:"0%",right:"100%",center:"50%"},Je={clearProps:function clearProps(t,e,r,i,n){if("isFromStart"!==n.data){var a=t._pt=new ae(t._pt,e,r,0,0,Gd);return a.u=i,a.pr=-10,a.tween=n,t._props.push(r),1}}},Ge=[1,0,0,1,0,0],$e={},Ze=function _parseTransform(t,e){var r=t._gsap||new Lt(t);if("x"in r&&!e&&!r.uncache)return r;var i,n,a,s,o,u,h,l,f,d,p,c,_,m,g,v,y,b,T,w,x,O,M,k,C,P,A,S,D,z,F,E,B=t.style,R=r.scaleX<0,I="deg",L=qd(t,Ye)||"0";return i=n=a=u=h=l=f=d=p=0,s=o=1,r.svg=!(!t.getCTM||!xd(t)),m=Md(t,r.svg),r.svg&&(k=(!r.uncache||"0px 0px"===L)&&!e&&t.getAttribute("data-svg-origin"),Nd(t,k||L,!!k||r.originIsAbsolute,!1!==r.smooth,m)),c=r.xOrigin||0,_=r.yOrigin||0,m!==Ge&&(b=m[0],T=m[1],w=m[2],x=m[3],i=O=m[4],n=M=m[5],6===m.length?(s=Math.sqrt(b*b+T*T),o=Math.sqrt(x*x+w*w),u=b||T?Re(T,b)*Ee:0,(f=w||x?Re(w,x)*Ee+u:0)&&(o*=Math.abs(Math.cos(f*Be))),r.svg&&(i-=c-(c*b+_*w),n-=_-(c*T+_*x))):(E=m[6],z=m[7],A=m[8],S=m[9],D=m[10],F=m[11],i=m[12],n=m[13],a=m[14],h=(g=Re(E,D))*Ee,g&&(k=O*(v=Math.cos(-g))+A*(y=Math.sin(-g)),C=M*v+S*y,P=E*v+D*y,A=O*-y+A*v,S=M*-y+S*v,D=E*-y+D*v,F=z*-y+F*v,O=k,M=C,E=P),l=(g=Re(-w,D))*Ee,g&&(v=Math.cos(-g),F=x*(y=Math.sin(-g))+F*v,b=k=b*v-A*y,T=C=T*v-S*y,w=P=w*v-D*y),u=(g=Re(T,b))*Ee,g&&(k=b*(v=Math.cos(g))+T*(y=Math.sin(g)),C=O*v+M*y,T=T*v-b*y,M=M*v-O*y,b=k,O=C),h&&359.9<Math.abs(h)+Math.abs(u)&&(h=u=0,l=180-l),s=ca(Math.sqrt(b*b+T*T+w*w)),o=ca(Math.sqrt(M*M+E*E)),g=Re(O,M),f=2e-4<Math.abs(g)?g*Ee:0,p=F?1/(F<0?-F:F):0),r.svg&&(k=t.getAttribute("transform"),r.forceCSS=t.setAttribute("transform","")||!Kd(qd(t,Qe)),k&&t.setAttribute("transform",k))),90<Math.abs(f)&&Math.abs(f)<270&&(R?(s*=-1,f+=u<=0?180:-180,u+=u<=0?180:-180):(o*=-1,f+=f<=0?180:-180)),r.x=i-((r.xPercent=i&&(r.xPercent||(Math.round(t.offsetWidth/2)===Math.round(-i)?-50:0)))?t.offsetWidth*r.xPercent/100:0)+"px",r.y=n-((r.yPercent=n&&(r.yPercent||(Math.round(t.offsetHeight/2)===Math.round(-n)?-50:0)))?t.offsetHeight*r.yPercent/100:0)+"px",r.z=a+"px",r.scaleX=ca(s),r.scaleY=ca(o),r.rotation=ca(u)+I,r.rotationX=ca(h)+I,r.rotationY=ca(l)+I,r.skewX=f+I,r.skewY=d+I,r.transformPerspective=p+"px",(r.zOrigin=parseFloat(L.split(" ")[2])||0)&&(B[Ye]=Ke(L)),r.xOffset=r.yOffset=0,r.force3D=Y.force3D,r.renderTransform=r.svg?ir:ce?rr:He,r.uncache=0,r},Ke=function _firstTwoOnly(t){return(t=t.split(" "))[0]+" "+t[1]},He=function _renderNon3DTransforms(t,e){e.z="0px",e.rotationY=e.rotationX="0deg",e.force3D=0,rr(t,e)},We="0deg",tr="0px",er=") ",rr=function _renderCSSTransforms(t,e){var r=e||this,i=r.xPercent,n=r.yPercent,a=r.x,s=r.y,o=r.z,u=r.rotation,h=r.rotationY,l=r.rotationX,f=r.skewX,d=r.skewY,p=r.scaleX,c=r.scaleY,_=r.transformPerspective,m=r.force3D,g=r.target,v=r.zOrigin,y="",b="auto"===m&&t&&1!==t||!0===m;if(v&&(l!==We||h!==We)){var T,w=parseFloat(h)*Be,x=Math.sin(w),O=Math.cos(w);w=parseFloat(l)*Be,T=Math.cos(w),a=Qd(g,a,x*T*-v),s=Qd(g,s,-Math.sin(w)*-v),o=Qd(g,o,O*T*-v+v)}_!==tr&&(y+="perspective("+_+er),(i||n)&&(y+="translate("+i+"%, "+n+"%) "),!b&&a===tr&&s===tr&&o===tr||(y+=o!==tr||b?"translate3d("+a+", "+s+", "+o+") ":"translate("+a+", "+s+er),u!==We&&(y+="rotate("+u+er),h!==We&&(y+="rotateY("+h+er),l!==We&&(y+="rotateX("+l+er),f===We&&d===We||(y+="skew("+f+", "+d+er),1===p&&1===c||(y+="scale("+p+", "+c+er),g.style[Qe]=y||"translate(0, 0)"},ir=function _renderSVGTransforms(t,e){var r,i,n,a,s,o=e||this,u=o.xPercent,h=o.yPercent,l=o.x,f=o.y,d=o.rotation,p=o.skewX,c=o.skewY,_=o.scaleX,m=o.scaleY,g=o.target,v=o.xOrigin,y=o.yOrigin,b=o.xOffset,T=o.yOffset,w=o.forceCSS,x=parseFloat(l),O=parseFloat(f);d=parseFloat(d),p=parseFloat(p),(c=parseFloat(c))&&(p+=c=parseFloat(c),d+=c),d||p?(d*=Be,p*=Be,r=Math.cos(d)*_,i=Math.sin(d)*_,n=Math.sin(d-p)*-m,a=Math.cos(d-p)*m,p&&(c*=Be,s=Math.tan(p-c),n*=s=Math.sqrt(1+s*s),a*=s,c&&(s=Math.tan(c),r*=s=Math.sqrt(1+s*s),i*=s)),r=ca(r),i=ca(i),n=ca(n),a=ca(a)):(r=_,a=m,i=n=0),(x&&!~(l+"").indexOf("px")||O&&!~(f+"").indexOf("px"))&&(x=Bd(g,"x",l,"px"),O=Bd(g,"y",f,"px")),(v||y||b||T)&&(x=ca(x+v-(v*r+y*n)+b),O=ca(O+y-(v*i+y*a)+T)),(u||h)&&(s=g.getBBox(),x=ca(x+u/100*s.width),O=ca(O+h/100*s.height)),s="matrix("+r+","+i+","+n+","+a+","+x+","+O+")",g.setAttribute("transform",s),w&&(g.style[Qe]=s)};ba("padding,margin,Width,Radius",function(e,r){var t="Right",i="Bottom",n="Left",o=(r<3?["Top",t,i,n]:["Top"+n,"Top"+t,i+t,i+n]).map(function(t){return r<2?e+t:"border"+t+e});Je[1<r?"border"+e:e]=function(e,t,r,i,n){var a,s;if(arguments.length<4)return a=o.map(function(t){return Cd(e,t,r)}),5===(s=a.join(" ")).split(a[0]).length?a[0]:s;a=(i+"").split(" "),s={},o.forEach(function(t,e){return s[t]=a[e]=a[e]||a[(e-1)/2|0]}),e.init(t,s,n)}});var nr,ar,sr,or={name:"css",register:td,targetTest:function targetTest(t){return t.style&&t.nodeType},init:function init(t,e,r,i,n){var a,s,u,h,l,f,d,p,c,_,m,g,v,y,b,T=this._props,w=t.style,x=r.vars.startAt;for(d in fe||td(),e)if("autoRound"!==d&&(s=e[d],!ft[d]||!Tb(d,e,r,i,t,n)))if(l=typeof s,f=Je[d],"function"===l&&(l=typeof(s=s.call(r,i,t,n))),"string"===l&&~s.indexOf("random(")&&(s=gb(s)),f)f(this,t,d,s,r)&&(b=1);else if("--"===d.substr(0,2))a=(getComputedStyle(t).getPropertyValue(d)+"").trim(),s+="",Pt.lastIndex=0,Pt.test(a)||(p=Qa(a),c=Qa(s)),c?p!==c&&(a=Bd(t,d,a,c)+c):p&&(s+=p),this.add(w,"setProperty",a,s,i,n,0,0,d),T.push(d);else if("undefined"!==l){if(x&&d in x?(a="function"==typeof x[d]?x[d].call(r,i,t,n):x[d],o(a)&&~a.indexOf("random(")&&(a=gb(a)),Qa(a+"")||(a+=Y.units[d]||Qa(Cd(t,d))||""),"="===(a+"").charAt(1)&&(a=Cd(t,d))):a=Cd(t,d),h=parseFloat(a),(_="string"===l&&"="===s.charAt(1)?+(s.charAt(0)+"1"):0)&&(s=s.substr(2)),u=parseFloat(s),d in Ne&&("autoAlpha"===d&&(1===h&&"hidden"===Cd(t,"visibility")&&u&&(h=0),zd(this,w,"visibility",h?"inherit":"hidden",u?"inherit":"hidden",!u)),"scale"!==d&&"transform"!==d&&~(d=Ne[d]).indexOf(",")&&(d=d.split(",")[0])),m=d in Fe)if(g||((v=t._gsap).renderTransform&&!e.parseTransform||Ze(t,e.parseTransform),y=!1!==e.smoothOrigin&&v.smooth,(g=this._pt=new ae(this._pt,w,Qe,0,1,v.renderTransform,v,0,-1)).dep=1),"scale"===d)this._pt=new ae(this._pt,v,"scaleY",v.scaleY,(_?_*u:u-v.scaleY)||0),T.push("scaleY",d),d+="X";else{if("transformOrigin"===d){s=Fd(s),v.svg?Nd(t,s,0,y,0,this):((c=parseFloat(s.split(" ")[2])||0)!==v.zOrigin&&zd(this,v,"zOrigin",v.zOrigin,c),zd(this,w,d,Ke(a),Ke(s)));continue}if("svgOrigin"===d){Nd(t,s,1,y,0,this);continue}if(d in $e){Xd(this,v,d,h,s,_);continue}if("smoothOrigin"===d){zd(this,v,"smooth",v.smooth,s);continue}if("force3D"===d){v[d]=s;continue}if("transform"===d){Zd(this,s,t);continue}}else d in w||(d=Xe(d)||d);if(m||(u||0===u)&&(h||0===h)&&!qe.test(s)&&d in w)u=u||0,(p=(a+"").substr((h+"").length))!==(c=Qa(s)||(d in Y.units?Y.units[d]:p))&&(h=Bd(t,d,a,c)),this._pt=new ae(this._pt,m?v:w,d,h,_?_*u:u-h,m||"px"!==c&&"zIndex"!==d||!1===e.autoRound?ad:dd),this._pt.u=c||0,p!==c&&"%"!==c&&(this._pt.b=a,this._pt.r=cd);else if(d in w)Dd.call(this,t,d,a,s);else{if(!(d in t)){N(d,s);continue}this.add(t,d,a||t[d],s,i,n)}T.push(d)}b&&ne(this)},get:Cd,aliases:Ne,getSetter:function getSetter(t,e,i){var n=Ne[e];return n&&n.indexOf(",")<0&&(e=n),e in Fe&&e!==Ye&&(t._gsap.x||Cd(t,"x"))?i&&pe===i?"scale"===e?jd:id:(pe=i||{})&&("scale"===e?kd:ld):t.style&&!r(t.style[e])?gd:~e.indexOf("-")?hd:Kt(t,e)},core:{_removeProperty:yd,_getMatrix:Md}};oe.utils.checkPrefix=Xe,sr=ba((nr="x,y,z,scale,scaleX,scaleY,xPercent,yPercent")+","+(ar="rotation,rotationX,rotationY,skewX,skewY")+",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",function(t){Fe[t]=1}),ba(ar,function(t){Y.units[t]="deg",$e[t]=1}),Ne[sr[13]]=nr+","+ar,ba("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",function(t){var e=t.split(":");Ne[e[1]]=sr[e[0]]}),ba("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",function(t){Y.units[t]="px"}),oe.registerPlugin(or);var ur=oe.registerPlugin(or)||oe,hr=ur.core.Tween;e.Back=Ce,e.Bounce=Ae,e.CSSPlugin=or,e.Circ=ze,e.Cubic=we,e.Elastic=ke,e.Expo=De,e.Linear=be,e.Power0=_e,e.Power1=me,e.Power2=ge,e.Power3=ve,e.Power4=ye,e.Quad=Te,e.Quart=xe,e.Quint=Oe,e.Sine=Se,e.SteppedEase=Pe,e.Strong=Me,e.TimelineLite=Nt,e.TimelineMax=Nt,e.TweenLite=Jt,e.TweenMax=hr,e.default=ur,e.gsap=ur;if (typeof(window)==="undefined"||window!==e){Object.defineProperty(e,"__esModule",{value:!0})} else {delete e.default}});


/*! lazysizes - v5.3.2 */

!function(e){var t=function(u,D,f){"use strict";var k,H;if(function(){var e;var t={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",fastLoadedClass:"ls-is-cached",iframeLoadMode:0,srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:true,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:true,ricTimeout:0,throttleDelay:125};H=u.lazySizesConfig||u.lazysizesConfig||{};for(e in t){if(!(e in H)){H[e]=t[e]}}}(),!D||!D.getElementsByClassName){return{init:function(){},cfg:H,noSupport:true}}var O=D.documentElement,i=u.HTMLPictureElement,P="addEventListener",$="getAttribute",q=u[P].bind(u),I=u.setTimeout,U=u.requestAnimationFrame||I,o=u.requestIdleCallback,j=/^picture$/i,r=["load","error","lazyincluded","_lazyloaded"],a={},G=Array.prototype.forEach,J=function(e,t){if(!a[t]){a[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")}return a[t].test(e[$]("class")||"")&&a[t]},K=function(e,t){if(!J(e,t)){e.setAttribute("class",(e[$]("class")||"").trim()+" "+t)}},Q=function(e,t){var a;if(a=J(e,t)){e.setAttribute("class",(e[$]("class")||"").replace(a," "))}},V=function(t,a,e){var i=e?P:"removeEventListener";if(e){V(t,a)}r.forEach(function(e){t[i](e,a)})},X=function(e,t,a,i,r){var n=D.createEvent("Event");if(!a){a={}}a.instance=k;n.initEvent(t,!i,!r);n.detail=a;e.dispatchEvent(n);return n},Y=function(e,t){var a;if(!i&&(a=u.picturefill||H.pf)){if(t&&t.src&&!e[$]("srcset")){e.setAttribute("srcset",t.src)}a({reevaluate:true,elements:[e]})}else if(t&&t.src){e.src=t.src}},Z=function(e,t){return(getComputedStyle(e,null)||{})[t]},s=function(e,t,a){a=a||e.offsetWidth;while(a<H.minSize&&t&&!e._lazysizesWidth){a=t.offsetWidth;t=t.parentNode}return a},ee=function(){var a,i;var t=[];var r=[];var n=t;var s=function(){var e=n;n=t.length?r:t;a=true;i=false;while(e.length){e.shift()()}a=false};var e=function(e,t){if(a&&!t){e.apply(this,arguments)}else{n.push(e);if(!i){i=true;(D.hidden?I:U)(s)}}};e._lsFlush=s;return e}(),te=function(a,e){return e?function(){ee(a)}:function(){var e=this;var t=arguments;ee(function(){a.apply(e,t)})}},ae=function(e){var a;var i=0;var r=H.throttleDelay;var n=H.ricTimeout;var t=function(){a=false;i=f.now();e()};var s=o&&n>49?function(){o(t,{timeout:n});if(n!==H.ricTimeout){n=H.ricTimeout}}:te(function(){I(t)},true);return function(e){var t;if(e=e===true){n=33}if(a){return}a=true;t=r-(f.now()-i);if(t<0){t=0}if(e||t<9){s()}else{I(s,t)}}},ie=function(e){var t,a;var i=99;var r=function(){t=null;e()};var n=function(){var e=f.now()-a;if(e<i){I(n,i-e)}else{(o||r)(r)}};return function(){a=f.now();if(!t){t=I(n,i)}}},e=function(){var v,m,c,h,e;var y,z,g,p,C,b,A;var n=/^img$/i;var d=/^iframe$/i;var E="onscroll"in u&&!/(gle|ing)bot/.test(navigator.userAgent);var _=0;var w=0;var M=0;var N=-1;var L=function(e){M--;if(!e||M<0||!e.target){M=0}};var x=function(e){if(A==null){A=Z(D.body,"visibility")=="hidden"}return A||!(Z(e.parentNode,"visibility")=="hidden"&&Z(e,"visibility")=="hidden")};var W=function(e,t){var a;var i=e;var r=x(e);g-=t;b+=t;p-=t;C+=t;while(r&&(i=i.offsetParent)&&i!=D.body&&i!=O){r=(Z(i,"opacity")||1)>0;if(r&&Z(i,"overflow")!="visible"){a=i.getBoundingClientRect();r=C>a.left&&p<a.right&&b>a.top-1&&g<a.bottom+1}}return r};var t=function(){var e,t,a,i,r,n,s,o,l,u,f,c;var d=k.elements;if((h=H.loadMode)&&M<8&&(e=d.length)){t=0;N++;for(;t<e;t++){if(!d[t]||d[t]._lazyRace){continue}if(!E||k.prematureUnveil&&k.prematureUnveil(d[t])){R(d[t]);continue}if(!(o=d[t][$]("data-expand"))||!(n=o*1)){n=w}if(!u){u=!H.expand||H.expand<1?O.clientHeight>500&&O.clientWidth>500?500:370:H.expand;k._defEx=u;f=u*H.expFactor;c=H.hFac;A=null;if(w<f&&M<1&&N>2&&h>2&&!D.hidden){w=f;N=0}else if(h>1&&N>1&&M<6){w=u}else{w=_}}if(l!==n){y=innerWidth+n*c;z=innerHeight+n;s=n*-1;l=n}a=d[t].getBoundingClientRect();if((b=a.bottom)>=s&&(g=a.top)<=z&&(C=a.right)>=s*c&&(p=a.left)<=y&&(b||C||p||g)&&(H.loadHidden||x(d[t]))&&(m&&M<3&&!o&&(h<3||N<4)||W(d[t],n))){R(d[t]);r=true;if(M>9){break}}else if(!r&&m&&!i&&M<4&&N<4&&h>2&&(v[0]||H.preloadAfterLoad)&&(v[0]||!o&&(b||C||p||g||d[t][$](H.sizesAttr)!="auto"))){i=v[0]||d[t]}}if(i&&!r){R(i)}}};var a=ae(t);var S=function(e){var t=e.target;if(t._lazyCache){delete t._lazyCache;return}L(e);K(t,H.loadedClass);Q(t,H.loadingClass);V(t,B);X(t,"lazyloaded")};var i=te(S);var B=function(e){i({target:e.target})};var T=function(e,t){var a=e.getAttribute("data-load-mode")||H.iframeLoadMode;if(a==0){e.contentWindow.location.replace(t)}else if(a==1){e.src=t}};var F=function(e){var t;var a=e[$](H.srcsetAttr);if(t=H.customMedia[e[$]("data-media")||e[$]("media")]){e.setAttribute("media",t)}if(a){e.setAttribute("srcset",a)}};var s=te(function(t,e,a,i,r){var n,s,o,l,u,f;if(!(u=X(t,"lazybeforeunveil",e)).defaultPrevented){if(i){if(a){K(t,H.autosizesClass)}else{t.setAttribute("sizes",i)}}s=t[$](H.srcsetAttr);n=t[$](H.srcAttr);if(r){o=t.parentNode;l=o&&j.test(o.nodeName||"")}f=e.firesLoad||"src"in t&&(s||n||l);u={target:t};K(t,H.loadingClass);if(f){clearTimeout(c);c=I(L,2500);V(t,B,true)}if(l){G.call(o.getElementsByTagName("source"),F)}if(s){t.setAttribute("srcset",s)}else if(n&&!l){if(d.test(t.nodeName)){T(t,n)}else{t.src=n}}if(r&&(s||l)){Y(t,{src:n})}}if(t._lazyRace){delete t._lazyRace}Q(t,H.lazyClass);ee(function(){var e=t.complete&&t.naturalWidth>1;if(!f||e){if(e){K(t,H.fastLoadedClass)}S(u);t._lazyCache=true;I(function(){if("_lazyCache"in t){delete t._lazyCache}},9)}if(t.loading=="lazy"){M--}},true)});var R=function(e){if(e._lazyRace){return}var t;var a=n.test(e.nodeName);var i=a&&(e[$](H.sizesAttr)||e[$]("sizes"));var r=i=="auto";if((r||!m)&&a&&(e[$]("src")||e.srcset)&&!e.complete&&!J(e,H.errorClass)&&J(e,H.lazyClass)){return}t=X(e,"lazyunveilread").detail;if(r){re.updateElem(e,true,e.offsetWidth)}e._lazyRace=true;M++;s(e,t,r,i,a)};var r=ie(function(){H.loadMode=3;a()});var o=function(){if(H.loadMode==3){H.loadMode=2}r()};var l=function(){if(m){return}if(f.now()-e<999){I(l,999);return}m=true;H.loadMode=3;a();q("scroll",o,true)};return{_:function(){e=f.now();k.elements=D.getElementsByClassName(H.lazyClass);v=D.getElementsByClassName(H.lazyClass+" "+H.preloadClass);q("scroll",a,true);q("resize",a,true);q("pageshow",function(e){if(e.persisted){var t=D.querySelectorAll("."+H.loadingClass);if(t.length&&t.forEach){U(function(){t.forEach(function(e){if(e.complete){R(e)}})})}}});if(u.MutationObserver){new MutationObserver(a).observe(O,{childList:true,subtree:true,attributes:true})}else{O[P]("DOMNodeInserted",a,true);O[P]("DOMAttrModified",a,true);setInterval(a,999)}q("hashchange",a,true);["focus","mouseover","click","load","transitionend","animationend"].forEach(function(e){D[P](e,a,true)});if(/d$|^c/.test(D.readyState)){l()}else{q("load",l);D[P]("DOMContentLoaded",a);I(l,2e4)}if(k.elements.length){t();ee._lsFlush()}else{a()}},checkElems:a,unveil:R,_aLSL:o}}(),re=function(){var a;var n=te(function(e,t,a,i){var r,n,s;e._lazysizesWidth=i;i+="px";e.setAttribute("sizes",i);if(j.test(t.nodeName||"")){r=t.getElementsByTagName("source");for(n=0,s=r.length;n<s;n++){r[n].setAttribute("sizes",i)}}if(!a.detail.dataAttr){Y(e,a.detail)}});var i=function(e,t,a){var i;var r=e.parentNode;if(r){a=s(e,r,a);i=X(e,"lazybeforesizes",{width:a,dataAttr:!!t});if(!i.defaultPrevented){a=i.detail.width;if(a&&a!==e._lazysizesWidth){n(e,r,i,a)}}}};var e=function(){var e;var t=a.length;if(t){e=0;for(;e<t;e++){i(a[e])}}};var t=ie(e);return{_:function(){a=D.getElementsByClassName(H.autosizesClass);q("resize",t)},checkElems:t,updateElem:i}}(),t=function(){if(!t.i&&D.getElementsByClassName){t.i=true;re._();e._()}};return I(function(){H.init&&t()}),k={cfg:H,autoSizer:re,loader:e,init:t,uP:Y,aC:K,rC:Q,hC:J,fire:X,gW:s,rAF:ee}}(e,e.document,Date);e.lazySizes=t,"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:{});

"undefined" != typeof navigator &&
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define(e)
      : ((t =
          "undefined" != typeof globalThis ? globalThis : t || self).lottie =
          e());
  })(this, function () {
    "use strict";
    var svgNS = "http://www.w3.org/2000/svg",
      locationHref = "",
      _useWebWorker = !1,
      initialDefaultFrame = -999999,
      setWebWorker = function (t) {
        _useWebWorker = !!t;
      },
      getWebWorker = function () {
        return _useWebWorker;
      },
      setLocationHref = function (t) {
        locationHref = t;
      },
      getLocationHref = function () {
        return locationHref;
      };
    function createTag(t) {
      return document.createElement(t);
    }
    function extendPrototype(t, e) {
      var i,
        r,
        s = t.length;
      for (i = 0; i < s; i += 1)
        for (var a in (r = t[i].prototype))
          Object.prototype.hasOwnProperty.call(r, a) && (e.prototype[a] = r[a]);
    }
    function getDescriptor(t, e) {
      return Object.getOwnPropertyDescriptor(t, e);
    }
    function createProxyFunction(t) {
      function e() {}
      return (e.prototype = t), e;
    }
    var audioControllerFactory = (function () {
        function t(t) {
          (this.audios = []),
            (this.audioFactory = t),
            (this._volume = 1),
            (this._isMuted = !1);
        }
        return (
          (t.prototype = {
            addAudio: function (t) {
              this.audios.push(t);
            },
            pause: function () {
              var t,
                e = this.audios.length;
              for (t = 0; t < e; t += 1) this.audios[t].pause();
            },
            resume: function () {
              var t,
                e = this.audios.length;
              for (t = 0; t < e; t += 1) this.audios[t].resume();
            },
            setRate: function (t) {
              var e,
                i = this.audios.length;
              for (e = 0; e < i; e += 1) this.audios[e].setRate(t);
            },
            createAudio: function (t) {
              return this.audioFactory
                ? this.audioFactory(t)
                : window.Howl
                ? new window.Howl({ src: [t] })
                : {
                    isPlaying: !1,
                    play: function () {
                      this.isPlaying = !0;
                    },
                    seek: function () {
                      this.isPlaying = !1;
                    },
                    playing: function () {},
                    rate: function () {},
                    setVolume: function () {},
                  };
            },
            setAudioFactory: function (t) {
              this.audioFactory = t;
            },
            setVolume: function (t) {
              (this._volume = t), this._updateVolume();
            },
            mute: function () {
              (this._isMuted = !0), this._updateVolume();
            },
            unmute: function () {
              (this._isMuted = !1), this._updateVolume();
            },
            getVolume: function () {
              return this._volume;
            },
            _updateVolume: function () {
              var t,
                e = this.audios.length;
              for (t = 0; t < e; t += 1)
                this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
            },
          }),
          function () {
            return new t();
          }
        );
      })(),
      createTypedArray = (function () {
        function t(t, e) {
          var i,
            r = 0,
            s = [];
          switch (t) {
            case "int16":
            case "uint8c":
              i = 1;
              break;
            default:
              i = 1.1;
          }
          for (r = 0; r < e; r += 1) s.push(i);
          return s;
        }
        return "function" == typeof Uint8ClampedArray &&
          "function" == typeof Float32Array
          ? function (e, i) {
              return "float32" === e
                ? new Float32Array(i)
                : "int16" === e
                ? new Int16Array(i)
                : "uint8c" === e
                ? new Uint8ClampedArray(i)
                : t(e, i);
            }
          : t;
      })();
    function createSizedArray(t) {
      return Array.apply(null, { length: t });
    }
    function _typeof$6(t) {
      return (
        (_typeof$6 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$6(t)
      );
    }
    var subframeEnabled = !0,
      expressionsPlugin = null,
      expressionsInterfaces = null,
      idPrefix$1 = "",
      isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      _shouldRoundValues = !1,
      bmPow = Math.pow,
      bmSqrt = Math.sqrt,
      bmFloor = Math.floor,
      bmMax = Math.max,
      bmMin = Math.min,
      BMMath = {};
    function ProjectInterface$1() {
      return {};
    }
    !(function () {
      var t,
        e = [
          "abs",
          "acos",
          "acosh",
          "asin",
          "asinh",
          "atan",
          "atanh",
          "atan2",
          "ceil",
          "cbrt",
          "expm1",
          "clz32",
          "cos",
          "cosh",
          "exp",
          "floor",
          "fround",
          "hypot",
          "imul",
          "log",
          "log1p",
          "log2",
          "log10",
          "max",
          "min",
          "pow",
          "random",
          "round",
          "sign",
          "sin",
          "sinh",
          "sqrt",
          "tan",
          "tanh",
          "trunc",
          "E",
          "LN10",
          "LN2",
          "LOG10E",
          "LOG2E",
          "PI",
          "SQRT1_2",
          "SQRT2",
        ],
        i = e.length;
      for (t = 0; t < i; t += 1) BMMath[e[t]] = Math[e[t]];
    })(),
      (BMMath.random = Math.random),
      (BMMath.abs = function (t) {
        if ("object" === _typeof$6(t) && t.length) {
          var e,
            i = createSizedArray(t.length),
            r = t.length;
          for (e = 0; e < r; e += 1) i[e] = Math.abs(t[e]);
          return i;
        }
        return Math.abs(t);
      });
    var defaultCurveSegments = 150,
      degToRads = Math.PI / 180,
      roundCorner = 0.5519;
    function roundValues(t) {
      _shouldRoundValues = !!t;
    }
    function bmRnd(t) {
      return _shouldRoundValues ? Math.round(t) : t;
    }
    function styleDiv(t) {
      (t.style.position = "absolute"),
        (t.style.top = 0),
        (t.style.left = 0),
        (t.style.display = "block"),
        (t.style.transformOrigin = "0 0"),
        (t.style.webkitTransformOrigin = "0 0"),
        (t.style.backfaceVisibility = "visible"),
        (t.style.webkitBackfaceVisibility = "visible"),
        (t.style.transformStyle = "preserve-3d"),
        (t.style.webkitTransformStyle = "preserve-3d"),
        (t.style.mozTransformStyle = "preserve-3d");
    }
    function BMEnterFrameEvent(t, e, i, r) {
      (this.type = t),
        (this.currentTime = e),
        (this.totalTime = i),
        (this.direction = r < 0 ? -1 : 1);
    }
    function BMCompleteEvent(t, e) {
      (this.type = t), (this.direction = e < 0 ? -1 : 1);
    }
    function BMCompleteLoopEvent(t, e, i, r) {
      (this.type = t),
        (this.currentLoop = i),
        (this.totalLoops = e),
        (this.direction = r < 0 ? -1 : 1);
    }
    function BMSegmentStartEvent(t, e, i) {
      (this.type = t), (this.firstFrame = e), (this.totalFrames = i);
    }
    function BMDestroyEvent(t, e) {
      (this.type = t), (this.target = e);
    }
    function BMRenderFrameErrorEvent(t, e) {
      (this.type = "renderFrameError"),
        (this.nativeError = t),
        (this.currentTime = e);
    }
    function BMConfigErrorEvent(t) {
      (this.type = "configError"), (this.nativeError = t);
    }
    function BMAnimationConfigErrorEvent(t, e) {
      (this.type = t), (this.nativeError = e);
    }
    var createElementID =
        ((_count = 0),
        function () {
          return idPrefix$1 + "__lottie_element_" + (_count += 1);
        }),
      _count;
    function HSVtoRGB(t, e, i) {
      var r, s, a, n, o, h, l, p;
      switch (
        ((h = i * (1 - e)),
        (l = i * (1 - (o = 6 * t - (n = Math.floor(6 * t))) * e)),
        (p = i * (1 - (1 - o) * e)),
        n % 6)
      ) {
        case 0:
          (r = i), (s = p), (a = h);
          break;
        case 1:
          (r = l), (s = i), (a = h);
          break;
        case 2:
          (r = h), (s = i), (a = p);
          break;
        case 3:
          (r = h), (s = l), (a = i);
          break;
        case 4:
          (r = p), (s = h), (a = i);
          break;
        case 5:
          (r = i), (s = h), (a = l);
      }
      return [r, s, a];
    }
    function RGBtoHSV(t, e, i) {
      var r,
        s = Math.max(t, e, i),
        a = Math.min(t, e, i),
        n = s - a,
        o = 0 === s ? 0 : n / s,
        h = s / 255;
      switch (s) {
        case a:
          r = 0;
          break;
        case t:
          (r = e - i + n * (e < i ? 6 : 0)), (r /= 6 * n);
          break;
        case e:
          (r = i - t + 2 * n), (r /= 6 * n);
          break;
        case i:
          (r = t - e + 4 * n), (r /= 6 * n);
      }
      return [r, o, h];
    }
    function addSaturationToRGB(t, e) {
      var i = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return (
        (i[1] += e),
        i[1] > 1 ? (i[1] = 1) : i[1] <= 0 && (i[1] = 0),
        HSVtoRGB(i[0], i[1], i[2])
      );
    }
    function addBrightnessToRGB(t, e) {
      var i = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return (
        (i[2] += e),
        i[2] > 1 ? (i[2] = 1) : i[2] < 0 && (i[2] = 0),
        HSVtoRGB(i[0], i[1], i[2])
      );
    }
    function addHueToRGB(t, e) {
      var i = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return (
        (i[0] += e / 360),
        i[0] > 1 ? (i[0] -= 1) : i[0] < 0 && (i[0] += 1),
        HSVtoRGB(i[0], i[1], i[2])
      );
    }
    var rgbToHex = (function () {
        var t,
          e,
          i = [];
        for (t = 0; t < 256; t += 1)
          (e = t.toString(16)), (i[t] = 1 === e.length ? "0" + e : e);
        return function (t, e, r) {
          return (
            t < 0 && (t = 0),
            e < 0 && (e = 0),
            r < 0 && (r = 0),
            "#" + i[t] + i[e] + i[r]
          );
        };
      })(),
      setSubframeEnabled = function (t) {
        subframeEnabled = !!t;
      },
      getSubframeEnabled = function () {
        return subframeEnabled;
      },
      setExpressionsPlugin = function (t) {
        expressionsPlugin = t;
      },
      getExpressionsPlugin = function () {
        return expressionsPlugin;
      },
      setExpressionInterfaces = function (t) {
        expressionsInterfaces = t;
      },
      getExpressionInterfaces = function () {
        return expressionsInterfaces;
      },
      setDefaultCurveSegments = function (t) {
        defaultCurveSegments = t;
      },
      getDefaultCurveSegments = function () {
        return defaultCurveSegments;
      },
      setIdPrefix = function (t) {
        idPrefix$1 = t;
      },
      getIdPrefix = function () {
        return idPrefix$1;
      };
    function createNS(t) {
      return document.createElementNS(svgNS, t);
    }
    function _typeof$5(t) {
      return (
        (_typeof$5 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$5(t)
      );
    }
    var dataManager = (function () {
        var t,
          e,
          i = 1,
          r = [],
          s = {
            onmessage: function () {},
            postMessage: function (e) {
              t({ data: e });
            },
          },
          a = {
            postMessage: function (t) {
              s.onmessage({ data: t });
            },
          };
        function n() {
          e ||
            ((e = (function (e) {
              if (window.Worker && window.Blob && getWebWorker()) {
                var i = new Blob(
                    ["var _workerSelf = self; self.onmessage = ", e.toString()],
                    { type: "text/javascript" }
                  ),
                  r = URL.createObjectURL(i);
                return new Worker(r);
              }
              return (t = e), s;
            })(function (t) {
              if (
                (a.dataManager ||
                  (a.dataManager = (function () {
                    function t(s, a) {
                      var n,
                        o,
                        h,
                        l,
                        p,
                        m,
                        c = s.length;
                      for (o = 0; o < c; o += 1)
                        if ("ks" in (n = s[o]) && !n.completed) {
                          if (((n.completed = !0), n.hasMask)) {
                            var d = n.masksProperties;
                            for (l = d.length, h = 0; h < l; h += 1)
                              if (d[h].pt.k.i) r(d[h].pt.k);
                              else
                                for (m = d[h].pt.k.length, p = 0; p < m; p += 1)
                                  d[h].pt.k[p].s && r(d[h].pt.k[p].s[0]),
                                    d[h].pt.k[p].e && r(d[h].pt.k[p].e[0]);
                          }
                          0 === n.ty
                            ? ((n.layers = e(n.refId, a)), t(n.layers, a))
                            : 4 === n.ty
                            ? i(n.shapes)
                            : 5 === n.ty && f(n);
                        }
                    }
                    function e(t, e) {
                      var i = (function (t, e) {
                        for (var i = 0, r = e.length; i < r; ) {
                          if (e[i].id === t) return e[i];
                          i += 1;
                        }
                        return null;
                      })(t, e);
                      return i
                        ? i.layers.__used
                          ? JSON.parse(JSON.stringify(i.layers))
                          : ((i.layers.__used = !0), i.layers)
                        : null;
                    }
                    function i(t) {
                      var e, s, a;
                      for (e = t.length - 1; e >= 0; e -= 1)
                        if ("sh" === t[e].ty)
                          if (t[e].ks.k.i) r(t[e].ks.k);
                          else
                            for (a = t[e].ks.k.length, s = 0; s < a; s += 1)
                              t[e].ks.k[s].s && r(t[e].ks.k[s].s[0]),
                                t[e].ks.k[s].e && r(t[e].ks.k[s].e[0]);
                        else "gr" === t[e].ty && i(t[e].it);
                    }
                    function r(t) {
                      var e,
                        i = t.i.length;
                      for (e = 0; e < i; e += 1)
                        (t.i[e][0] += t.v[e][0]),
                          (t.i[e][1] += t.v[e][1]),
                          (t.o[e][0] += t.v[e][0]),
                          (t.o[e][1] += t.v[e][1]);
                    }
                    function s(t, e) {
                      var i = e ? e.split(".") : [100, 100, 100];
                      return (
                        t[0] > i[0] ||
                        (!(i[0] > t[0]) &&
                          (t[1] > i[1] ||
                            (!(i[1] > t[1]) &&
                              (t[2] > i[2] || (!(i[2] > t[2]) && null)))))
                      );
                    }
                    var a,
                      n = (function () {
                        var t = [4, 4, 14];
                        function e(t) {
                          var e,
                            i,
                            r,
                            s = t.length;
                          for (e = 0; e < s; e += 1)
                            5 === t[e].ty &&
                              ((r = void 0),
                              (r = (i = t[e]).t.d),
                              (i.t.d = { k: [{ s: r, t: 0 }] }));
                        }
                        return function (i) {
                          if (s(t, i.v) && (e(i.layers), i.assets)) {
                            var r,
                              a = i.assets.length;
                            for (r = 0; r < a; r += 1)
                              i.assets[r].layers && e(i.assets[r].layers);
                          }
                        };
                      })(),
                      o =
                        ((a = [4, 7, 99]),
                        function (t) {
                          if (t.chars && !s(a, t.v)) {
                            var e,
                              r = t.chars.length;
                            for (e = 0; e < r; e += 1) {
                              var n = t.chars[e];
                              n.data &&
                                n.data.shapes &&
                                (i(n.data.shapes),
                                (n.data.ip = 0),
                                (n.data.op = 99999),
                                (n.data.st = 0),
                                (n.data.sr = 1),
                                (n.data.ks = {
                                  p: { k: [0, 0], a: 0 },
                                  s: { k: [100, 100], a: 0 },
                                  a: { k: [0, 0], a: 0 },
                                  r: { k: 0, a: 0 },
                                  o: { k: 100, a: 0 },
                                }),
                                t.chars[e].t ||
                                  (n.data.shapes.push({ ty: "no" }),
                                  n.data.shapes[0].it.push({
                                    p: { k: [0, 0], a: 0 },
                                    s: { k: [100, 100], a: 0 },
                                    a: { k: [0, 0], a: 0 },
                                    r: { k: 0, a: 0 },
                                    o: { k: 100, a: 0 },
                                    sk: { k: 0, a: 0 },
                                    sa: { k: 0, a: 0 },
                                    ty: "tr",
                                  })));
                            }
                          }
                        }),
                      h = (function () {
                        var t = [5, 7, 15];
                        function e(t) {
                          var e,
                            i,
                            r = t.length;
                          for (e = 0; e < r; e += 1)
                            5 === t[e].ty &&
                              ((i = void 0),
                              "number" == typeof (i = t[e].t.p).a &&
                                (i.a = { a: 0, k: i.a }),
                              "number" == typeof i.p &&
                                (i.p = { a: 0, k: i.p }),
                              "number" == typeof i.r &&
                                (i.r = { a: 0, k: i.r }));
                        }
                        return function (i) {
                          if (s(t, i.v) && (e(i.layers), i.assets)) {
                            var r,
                              a = i.assets.length;
                            for (r = 0; r < a; r += 1)
                              i.assets[r].layers && e(i.assets[r].layers);
                          }
                        };
                      })(),
                      l = (function () {
                        var t = [4, 1, 9];
                        function e(t) {
                          var i,
                            r,
                            s,
                            a = t.length;
                          for (i = 0; i < a; i += 1)
                            if ("gr" === t[i].ty) e(t[i].it);
                            else if ("fl" === t[i].ty || "st" === t[i].ty)
                              if (t[i].c.k && t[i].c.k[0].i)
                                for (s = t[i].c.k.length, r = 0; r < s; r += 1)
                                  t[i].c.k[r].s &&
                                    ((t[i].c.k[r].s[0] /= 255),
                                    (t[i].c.k[r].s[1] /= 255),
                                    (t[i].c.k[r].s[2] /= 255),
                                    (t[i].c.k[r].s[3] /= 255)),
                                    t[i].c.k[r].e &&
                                      ((t[i].c.k[r].e[0] /= 255),
                                      (t[i].c.k[r].e[1] /= 255),
                                      (t[i].c.k[r].e[2] /= 255),
                                      (t[i].c.k[r].e[3] /= 255));
                              else
                                (t[i].c.k[0] /= 255),
                                  (t[i].c.k[1] /= 255),
                                  (t[i].c.k[2] /= 255),
                                  (t[i].c.k[3] /= 255);
                        }
                        function i(t) {
                          var i,
                            r = t.length;
                          for (i = 0; i < r; i += 1)
                            4 === t[i].ty && e(t[i].shapes);
                        }
                        return function (e) {
                          if (s(t, e.v) && (i(e.layers), e.assets)) {
                            var r,
                              a = e.assets.length;
                            for (r = 0; r < a; r += 1)
                              e.assets[r].layers && i(e.assets[r].layers);
                          }
                        };
                      })(),
                      p = (function () {
                        var t = [4, 4, 18];
                        function e(t) {
                          var i, r, s;
                          for (i = t.length - 1; i >= 0; i -= 1)
                            if ("sh" === t[i].ty)
                              if (t[i].ks.k.i) t[i].ks.k.c = t[i].closed;
                              else
                                for (s = t[i].ks.k.length, r = 0; r < s; r += 1)
                                  t[i].ks.k[r].s &&
                                    (t[i].ks.k[r].s[0].c = t[i].closed),
                                    t[i].ks.k[r].e &&
                                      (t[i].ks.k[r].e[0].c = t[i].closed);
                            else "gr" === t[i].ty && e(t[i].it);
                        }
                        function i(t) {
                          var i,
                            r,
                            s,
                            a,
                            n,
                            o,
                            h = t.length;
                          for (r = 0; r < h; r += 1) {
                            if ((i = t[r]).hasMask) {
                              var l = i.masksProperties;
                              for (a = l.length, s = 0; s < a; s += 1)
                                if (l[s].pt.k.i) l[s].pt.k.c = l[s].cl;
                                else
                                  for (
                                    o = l[s].pt.k.length, n = 0;
                                    n < o;
                                    n += 1
                                  )
                                    l[s].pt.k[n].s &&
                                      (l[s].pt.k[n].s[0].c = l[s].cl),
                                      l[s].pt.k[n].e &&
                                        (l[s].pt.k[n].e[0].c = l[s].cl);
                            }
                            4 === i.ty && e(i.shapes);
                          }
                        }
                        return function (e) {
                          if (s(t, e.v) && (i(e.layers), e.assets)) {
                            var r,
                              a = e.assets.length;
                            for (r = 0; r < a; r += 1)
                              e.assets[r].layers && i(e.assets[r].layers);
                          }
                        };
                      })();
                    function f(t) {
                      0 === t.t.a.length && t.t.p;
                    }
                    var m = {
                      completeData: function (i) {
                        i.__complete ||
                          (l(i),
                          n(i),
                          o(i),
                          h(i),
                          p(i),
                          t(i.layers, i.assets),
                          (function (i, r) {
                            if (i) {
                              var s = 0,
                                a = i.length;
                              for (s = 0; s < a; s += 1)
                                1 === i[s].t &&
                                  ((i[s].data.layers = e(i[s].data.refId, r)),
                                  t(i[s].data.layers, r));
                            }
                          })(i.chars, i.assets),
                          (i.__complete = !0));
                      },
                    };
                    return (
                      (m.checkColors = l),
                      (m.checkChars = o),
                      (m.checkPathProperties = h),
                      (m.checkShapes = p),
                      (m.completeLayers = t),
                      m
                    );
                  })()),
                a.assetLoader ||
                  (a.assetLoader = (function () {
                    function t(t) {
                      var e = t.getResponseHeader("content-type");
                      return (e &&
                        "json" === t.responseType &&
                        -1 !== e.indexOf("json")) ||
                        (t.response && "object" === _typeof$5(t.response))
                        ? t.response
                        : t.response && "string" == typeof t.response
                        ? JSON.parse(t.response)
                        : t.responseText
                        ? JSON.parse(t.responseText)
                        : null;
                    }
                    return {
                      load: function (e, i, r, s) {
                        var a,
                          n = new XMLHttpRequest();
                        try {
                          n.responseType = "json";
                        } catch (t) {}
                        n.onreadystatechange = function () {
                          if (4 === n.readyState)
                            if (200 === n.status) (a = t(n)), r(a);
                            else
                              try {
                                (a = t(n)), r(a);
                              } catch (t) {
                                s && s(t);
                              }
                        };
                        try {
                          n.open(["G", "E", "T"].join(""), e, !0);
                        } catch (t) {
                          n.open(["G", "E", "T"].join(""), i + "/" + e, !0);
                        }
                        n.send();
                      },
                    };
                  })()),
                "loadAnimation" === t.data.type)
              )
                a.assetLoader.load(
                  t.data.path,
                  t.data.fullPath,
                  function (e) {
                    a.dataManager.completeData(e),
                      a.postMessage({
                        id: t.data.id,
                        payload: e,
                        status: "success",
                      });
                  },
                  function () {
                    a.postMessage({ id: t.data.id, status: "error" });
                  }
                );
              else if ("complete" === t.data.type) {
                var e = t.data.animation;
                a.dataManager.completeData(e),
                  a.postMessage({
                    id: t.data.id,
                    payload: e,
                    status: "success",
                  });
              } else
                "loadData" === t.data.type &&
                  a.assetLoader.load(
                    t.data.path,
                    t.data.fullPath,
                    function (e) {
                      a.postMessage({
                        id: t.data.id,
                        payload: e,
                        status: "success",
                      });
                    },
                    function () {
                      a.postMessage({ id: t.data.id, status: "error" });
                    }
                  );
            })),
            (e.onmessage = function (t) {
              var e = t.data,
                i = e.id,
                s = r[i];
              (r[i] = null),
                "success" === e.status
                  ? s.onComplete(e.payload)
                  : s.onError && s.onError();
            }));
        }
        function o(t, e) {
          var s = "processId_" + (i += 1);
          return (r[s] = { onComplete: t, onError: e }), s;
        }
        return {
          loadAnimation: function (t, i, r) {
            n();
            var s = o(i, r);
            e.postMessage({
              type: "loadAnimation",
              path: t,
              fullPath: window.location.origin + window.location.pathname,
              id: s,
            });
          },
          loadData: function (t, i, r) {
            n();
            var s = o(i, r);
            e.postMessage({
              type: "loadData",
              path: t,
              fullPath: window.location.origin + window.location.pathname,
              id: s,
            });
          },
          completeAnimation: function (t, i, r) {
            n();
            var s = o(i, r);
            e.postMessage({ type: "complete", animation: t, id: s });
          },
        };
      })(),
      ImagePreloader = (function () {
        var t = (function () {
          var t = createTag("canvas");
          (t.width = 1), (t.height = 1);
          var e = t.getContext("2d");
          return (e.fillStyle = "rgba(0,0,0,0)"), e.fillRect(0, 0, 1, 1), t;
        })();
        function e() {
          (this.loadedAssets += 1),
            this.loadedAssets === this.totalImages &&
              this.loadedFootagesCount === this.totalFootages &&
              this.imagesLoadedCb &&
              this.imagesLoadedCb(null);
        }
        function i() {
          (this.loadedFootagesCount += 1),
            this.loadedAssets === this.totalImages &&
              this.loadedFootagesCount === this.totalFootages &&
              this.imagesLoadedCb &&
              this.imagesLoadedCb(null);
        }
        function r(t, e, i) {
          var r = "";
          if (t.e) r = t.p;
          else if (e) {
            var s = t.p;
            -1 !== s.indexOf("images/") && (s = s.split("/")[1]), (r = e + s);
          } else (r = i), (r += t.u ? t.u : ""), (r += t.p);
          return r;
        }
        function s(t) {
          var e = 0,
            i = setInterval(
              function () {
                (t.getBBox().width || e > 500) &&
                  (this._imageLoaded(), clearInterval(i)),
                  (e += 1);
              }.bind(this),
              50
            );
        }
        function a(t) {
          var e = { assetData: t },
            i = r(t, this.assetsPath, this.path);
          return (
            dataManager.loadData(
              i,
              function (t) {
                (e.img = t), this._footageLoaded();
              }.bind(this),
              function () {
                (e.img = {}), this._footageLoaded();
              }.bind(this)
            ),
            e
          );
        }
        function n() {
          (this._imageLoaded = e.bind(this)),
            (this._footageLoaded = i.bind(this)),
            (this.testImageLoaded = s.bind(this)),
            (this.createFootageData = a.bind(this)),
            (this.assetsPath = ""),
            (this.path = ""),
            (this.totalImages = 0),
            (this.totalFootages = 0),
            (this.loadedAssets = 0),
            (this.loadedFootagesCount = 0),
            (this.imagesLoadedCb = null),
            (this.images = []);
        }
        return (
          (n.prototype = {
            loadAssets: function (t, e) {
              var i;
              this.imagesLoadedCb = e;
              var r = t.length;
              for (i = 0; i < r; i += 1)
                t[i].layers ||
                  (t[i].t && "seq" !== t[i].t
                    ? 3 === t[i].t &&
                      ((this.totalFootages += 1),
                      this.images.push(this.createFootageData(t[i])))
                    : ((this.totalImages += 1),
                      this.images.push(this._createImageData(t[i]))));
            },
            setAssetsPath: function (t) {
              this.assetsPath = t || "";
            },
            setPath: function (t) {
              this.path = t || "";
            },
            loadedImages: function () {
              return this.totalImages === this.loadedAssets;
            },
            loadedFootages: function () {
              return this.totalFootages === this.loadedFootagesCount;
            },
            destroy: function () {
              (this.imagesLoadedCb = null), (this.images.length = 0);
            },
            getAsset: function (t) {
              for (var e = 0, i = this.images.length; e < i; ) {
                if (this.images[e].assetData === t) return this.images[e].img;
                e += 1;
              }
              return null;
            },
            createImgData: function (e) {
              var i = r(e, this.assetsPath, this.path),
                s = createTag("img");
              (s.crossOrigin = "anonymous"),
                s.addEventListener("load", this._imageLoaded, !1),
                s.addEventListener(
                  "error",
                  function () {
                    (a.img = t), this._imageLoaded();
                  }.bind(this),
                  !1
                ),
                (s.src = i);
              var a = { img: s, assetData: e };
              return a;
            },
            createImageData: function (e) {
              var i = r(e, this.assetsPath, this.path),
                s = createNS("image");
              isSafari
                ? this.testImageLoaded(s)
                : s.addEventListener("load", this._imageLoaded, !1),
                s.addEventListener(
                  "error",
                  function () {
                    (a.img = t), this._imageLoaded();
                  }.bind(this),
                  !1
                ),
                s.setAttributeNS("http://www.w3.org/1999/xlink", "href", i),
                this._elementHelper.append
                  ? this._elementHelper.append(s)
                  : this._elementHelper.appendChild(s);
              var a = { img: s, assetData: e };
              return a;
            },
            imageLoaded: e,
            footageLoaded: i,
            setCacheType: function (t, e) {
              "svg" === t
                ? ((this._elementHelper = e),
                  (this._createImageData = this.createImageData.bind(this)))
                : (this._createImageData = this.createImgData.bind(this));
            },
          }),
          n
        );
      })();
    function BaseEvent() {}
    BaseEvent.prototype = {
      triggerEvent: function (t, e) {
        if (this._cbs[t])
          for (var i = this._cbs[t], r = 0; r < i.length; r += 1) i[r](e);
      },
      addEventListener: function (t, e) {
        return (
          this._cbs[t] || (this._cbs[t] = []),
          this._cbs[t].push(e),
          function () {
            this.removeEventListener(t, e);
          }.bind(this)
        );
      },
      removeEventListener: function (t, e) {
        if (e) {
          if (this._cbs[t]) {
            for (var i = 0, r = this._cbs[t].length; i < r; )
              this._cbs[t][i] === e &&
                (this._cbs[t].splice(i, 1), (i -= 1), (r -= 1)),
                (i += 1);
            this._cbs[t].length || (this._cbs[t] = null);
          }
        } else this._cbs[t] = null;
      },
    };
    var markerParser = (function () {
        function t(t) {
          for (
            var e, i = t.split("\r\n"), r = {}, s = 0, a = 0;
            a < i.length;
            a += 1
          )
            2 === (e = i[a].split(":")).length &&
              ((r[e[0]] = e[1].trim()), (s += 1));
          if (0 === s) throw new Error();
          return r;
        }
        return function (e) {
          for (var i = [], r = 0; r < e.length; r += 1) {
            var s = e[r],
              a = { time: s.tm, duration: s.dr };
            try {
              a.payload = JSON.parse(e[r].cm);
            } catch (i) {
              try {
                a.payload = t(e[r].cm);
              } catch (t) {
                a.payload = { name: e[r].cm };
              }
            }
            i.push(a);
          }
          return i;
        };
      })(),
      ProjectInterface = (function () {
        function t(t) {
          this.compositions.push(t);
        }
        return function () {
          function e(t) {
            for (var e = 0, i = this.compositions.length; e < i; ) {
              if (
                this.compositions[e].data &&
                this.compositions[e].data.nm === t
              )
                return (
                  this.compositions[e].prepareFrame &&
                    this.compositions[e].data.xt &&
                    this.compositions[e].prepareFrame(this.currentFrame),
                  this.compositions[e].compInterface
                );
              e += 1;
            }
            return null;
          }
          return (
            (e.compositions = []),
            (e.currentFrame = 0),
            (e.registerComposition = t),
            e
          );
        };
      })(),
      renderers = {},
      registerRenderer = function (t, e) {
        renderers[t] = e;
      };
    function getRenderer(t) {
      return renderers[t];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas) return "canvas";
      for (var t in renderers) if (renderers[t]) return t;
      return "";
    }
    function _typeof$4(t) {
      return (
        (_typeof$4 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$4(t)
      );
    }
    var AnimationItem = function () {
      (this._cbs = []),
        (this.name = ""),
        (this.path = ""),
        (this.isLoaded = !1),
        (this.currentFrame = 0),
        (this.currentRawFrame = 0),
        (this.firstFrame = 0),
        (this.totalFrames = 0),
        (this.frameRate = 0),
        (this.frameMult = 0),
        (this.playSpeed = 1),
        (this.playDirection = 1),
        (this.playCount = 0),
        (this.animationData = {}),
        (this.assets = []),
        (this.isPaused = !0),
        (this.autoplay = !1),
        (this.loop = !0),
        (this.renderer = null),
        (this.animationID = createElementID()),
        (this.assetsPath = ""),
        (this.timeCompleted = 0),
        (this.segmentPos = 0),
        (this.isSubframeEnabled = getSubframeEnabled()),
        (this.segments = []),
        (this._idle = !0),
        (this._completedLoop = !1),
        (this.projectInterface = ProjectInterface()),
        (this.imagePreloader = new ImagePreloader()),
        (this.audioController = audioControllerFactory()),
        (this.markers = []),
        (this.configAnimation = this.configAnimation.bind(this)),
        (this.onSetupError = this.onSetupError.bind(this)),
        (this.onSegmentComplete = this.onSegmentComplete.bind(this)),
        (this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0)),
        (this.expressionsPlugin = getExpressionsPlugin());
    };
    extendPrototype([BaseEvent], AnimationItem),
      (AnimationItem.prototype.setParams = function (t) {
        (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
        var e = "svg";
        t.animType ? (e = t.animType) : t.renderer && (e = t.renderer);
        var i = getRenderer(e);
        (this.renderer = new i(this, t.rendererSettings)),
          this.imagePreloader.setCacheType(e, this.renderer.globalData.defs),
          this.renderer.setProjectInterface(this.projectInterface),
          (this.animType = e),
          "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop
            ? (this.loop = !0)
            : !1 === t.loop
            ? (this.loop = !1)
            : (this.loop = parseInt(t.loop, 10)),
          (this.autoplay = !("autoplay" in t) || t.autoplay),
          (this.name = t.name ? t.name : ""),
          (this.autoloadSegments =
            !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") ||
            t.autoloadSegments),
          (this.assetsPath = t.assetsPath),
          (this.initialSegment = t.initialSegment),
          t.audioFactory &&
            this.audioController.setAudioFactory(t.audioFactory),
          t.animationData
            ? this.setupAnimation(t.animationData)
            : t.path &&
              (-1 !== t.path.lastIndexOf("\\")
                ? (this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1))
                : (this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1)),
              (this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1)),
              (this.fileName = this.fileName.substr(
                0,
                this.fileName.lastIndexOf(".json")
              )),
              dataManager.loadAnimation(
                t.path,
                this.configAnimation,
                this.onSetupError
              ));
      }),
      (AnimationItem.prototype.onSetupError = function () {
        this.trigger("data_failed");
      }),
      (AnimationItem.prototype.setupAnimation = function (t) {
        dataManager.completeAnimation(t, this.configAnimation);
      }),
      (AnimationItem.prototype.setData = function (t, e) {
        e && "object" !== _typeof$4(e) && (e = JSON.parse(e));
        var i = { wrapper: t, animationData: e },
          r = t.attributes;
        (i.path = r.getNamedItem("data-animation-path")
          ? r.getNamedItem("data-animation-path").value
          : r.getNamedItem("data-bm-path")
          ? r.getNamedItem("data-bm-path").value
          : r.getNamedItem("bm-path")
          ? r.getNamedItem("bm-path").value
          : ""),
          (i.animType = r.getNamedItem("data-anim-type")
            ? r.getNamedItem("data-anim-type").value
            : r.getNamedItem("data-bm-type")
            ? r.getNamedItem("data-bm-type").value
            : r.getNamedItem("bm-type")
            ? r.getNamedItem("bm-type").value
            : r.getNamedItem("data-bm-renderer")
            ? r.getNamedItem("data-bm-renderer").value
            : r.getNamedItem("bm-renderer")
            ? r.getNamedItem("bm-renderer").value
            : getRegisteredRenderer() || "canvas");
        var s = r.getNamedItem("data-anim-loop")
          ? r.getNamedItem("data-anim-loop").value
          : r.getNamedItem("data-bm-loop")
          ? r.getNamedItem("data-bm-loop").value
          : r.getNamedItem("bm-loop")
          ? r.getNamedItem("bm-loop").value
          : "";
        "false" === s
          ? (i.loop = !1)
          : "true" === s
          ? (i.loop = !0)
          : "" !== s && (i.loop = parseInt(s, 10));
        var a = r.getNamedItem("data-anim-autoplay")
          ? r.getNamedItem("data-anim-autoplay").value
          : r.getNamedItem("data-bm-autoplay")
          ? r.getNamedItem("data-bm-autoplay").value
          : !r.getNamedItem("bm-autoplay") ||
            r.getNamedItem("bm-autoplay").value;
        (i.autoplay = "false" !== a),
          (i.name = r.getNamedItem("data-name")
            ? r.getNamedItem("data-name").value
            : r.getNamedItem("data-bm-name")
            ? r.getNamedItem("data-bm-name").value
            : r.getNamedItem("bm-name")
            ? r.getNamedItem("bm-name").value
            : ""),
          "false" ===
            (r.getNamedItem("data-anim-prerender")
              ? r.getNamedItem("data-anim-prerender").value
              : r.getNamedItem("data-bm-prerender")
              ? r.getNamedItem("data-bm-prerender").value
              : r.getNamedItem("bm-prerender")
              ? r.getNamedItem("bm-prerender").value
              : "") && (i.prerender = !1),
          i.path ? this.setParams(i) : this.trigger("destroy");
      }),
      (AnimationItem.prototype.includeLayers = function (t) {
        t.op > this.animationData.op &&
          ((this.animationData.op = t.op),
          (this.totalFrames = Math.floor(t.op - this.animationData.ip)));
        var e,
          i,
          r = this.animationData.layers,
          s = r.length,
          a = t.layers,
          n = a.length;
        for (i = 0; i < n; i += 1)
          for (e = 0; e < s; ) {
            if (r[e].id === a[i].id) {
              r[e] = a[i];
              break;
            }
            e += 1;
          }
        if (
          ((t.chars || t.fonts) &&
            (this.renderer.globalData.fontManager.addChars(t.chars),
            this.renderer.globalData.fontManager.addFonts(
              t.fonts,
              this.renderer.globalData.defs
            )),
          t.assets)
        )
          for (s = t.assets.length, e = 0; e < s; e += 1)
            this.animationData.assets.push(t.assets[e]);
        (this.animationData.__complete = !1),
          dataManager.completeAnimation(
            this.animationData,
            this.onSegmentComplete
          );
      }),
      (AnimationItem.prototype.onSegmentComplete = function (t) {
        this.animationData = t;
        var e = getExpressionsPlugin();
        e && e.initExpressions(this), this.loadNextSegment();
      }),
      (AnimationItem.prototype.loadNextSegment = function () {
        var t = this.animationData.segments;
        if (!t || 0 === t.length || !this.autoloadSegments)
          return (
            this.trigger("data_ready"),
            void (this.timeCompleted = this.totalFrames)
          );
        var e = t.shift();
        this.timeCompleted = e.time * this.frameRate;
        var i = this.path + this.fileName + "_" + this.segmentPos + ".json";
        (this.segmentPos += 1),
          dataManager.loadData(
            i,
            this.includeLayers.bind(this),
            function () {
              this.trigger("data_failed");
            }.bind(this)
          );
      }),
      (AnimationItem.prototype.loadSegments = function () {
        this.animationData.segments || (this.timeCompleted = this.totalFrames),
          this.loadNextSegment();
      }),
      (AnimationItem.prototype.imagesLoaded = function () {
        this.trigger("loaded_images"), this.checkLoaded();
      }),
      (AnimationItem.prototype.preloadImages = function () {
        this.imagePreloader.setAssetsPath(this.assetsPath),
          this.imagePreloader.setPath(this.path),
          this.imagePreloader.loadAssets(
            this.animationData.assets,
            this.imagesLoaded.bind(this)
          );
      }),
      (AnimationItem.prototype.configAnimation = function (t) {
        if (this.renderer)
          try {
            (this.animationData = t),
              this.initialSegment
                ? ((this.totalFrames = Math.floor(
                    this.initialSegment[1] - this.initialSegment[0]
                  )),
                  (this.firstFrame = Math.round(this.initialSegment[0])))
                : ((this.totalFrames = Math.floor(
                    this.animationData.op - this.animationData.ip
                  )),
                  (this.firstFrame = Math.round(this.animationData.ip))),
              this.renderer.configAnimation(t),
              t.assets || (t.assets = []),
              (this.assets = this.animationData.assets),
              (this.frameRate = this.animationData.fr),
              (this.frameMult = this.animationData.fr / 1e3),
              this.renderer.searchExtraCompositions(t.assets),
              (this.markers = markerParser(t.markers || [])),
              this.trigger("config_ready"),
              this.preloadImages(),
              this.loadSegments(),
              this.updaFrameModifier(),
              this.waitForFontsLoaded(),
              this.isPaused && this.audioController.pause();
          } catch (t) {
            this.triggerConfigError(t);
          }
      }),
      (AnimationItem.prototype.waitForFontsLoaded = function () {
        this.renderer &&
          (this.renderer.globalData.fontManager.isLoaded
            ? this.checkLoaded()
            : setTimeout(this.waitForFontsLoaded.bind(this), 20));
      }),
      (AnimationItem.prototype.checkLoaded = function () {
        if (
          !this.isLoaded &&
          this.renderer.globalData.fontManager.isLoaded &&
          (this.imagePreloader.loadedImages() ||
            "canvas" !== this.renderer.rendererType) &&
          this.imagePreloader.loadedFootages()
        ) {
          this.isLoaded = !0;
          var t = getExpressionsPlugin();
          t && t.initExpressions(this),
            this.renderer.initItems(),
            setTimeout(
              function () {
                this.trigger("DOMLoaded");
              }.bind(this),
              0
            ),
            this.gotoFrame(),
            this.autoplay && this.play();
        }
      }),
      (AnimationItem.prototype.resize = function (t, e) {
        var i = "number" == typeof t ? t : void 0,
          r = "number" == typeof e ? e : void 0;
        this.renderer.updateContainerSize(i, r);
      }),
      (AnimationItem.prototype.setSubframe = function (t) {
        this.isSubframeEnabled = !!t;
      }),
      (AnimationItem.prototype.gotoFrame = function () {
        (this.currentFrame = this.isSubframeEnabled
          ? this.currentRawFrame
          : ~~this.currentRawFrame),
          this.timeCompleted !== this.totalFrames &&
            this.currentFrame > this.timeCompleted &&
            (this.currentFrame = this.timeCompleted),
          this.trigger("enterFrame"),
          this.renderFrame(),
          this.trigger("drawnFrame");
      }),
      (AnimationItem.prototype.renderFrame = function () {
        if (!1 !== this.isLoaded && this.renderer)
          try {
            this.expressionsPlugin && this.expressionsPlugin.resetFrame(),
              this.renderer.renderFrame(this.currentFrame + this.firstFrame);
          } catch (t) {
            this.triggerRenderFrameError(t);
          }
      }),
      (AnimationItem.prototype.play = function (t) {
        (t && this.name !== t) ||
          (!0 === this.isPaused &&
            ((this.isPaused = !1),
            this.trigger("_play"),
            this.audioController.resume(),
            this._idle && ((this._idle = !1), this.trigger("_active"))));
      }),
      (AnimationItem.prototype.pause = function (t) {
        (t && this.name !== t) ||
          (!1 === this.isPaused &&
            ((this.isPaused = !0),
            this.trigger("_pause"),
            (this._idle = !0),
            this.trigger("_idle"),
            this.audioController.pause()));
      }),
      (AnimationItem.prototype.togglePause = function (t) {
        (t && this.name !== t) ||
          (!0 === this.isPaused ? this.play() : this.pause());
      }),
      (AnimationItem.prototype.stop = function (t) {
        (t && this.name !== t) ||
          (this.pause(),
          (this.playCount = 0),
          (this._completedLoop = !1),
          this.setCurrentRawFrameValue(0));
      }),
      (AnimationItem.prototype.getMarkerData = function (t) {
        for (var e, i = 0; i < this.markers.length; i += 1)
          if ((e = this.markers[i]).payload && e.payload.name === t) return e;
        return null;
      }),
      (AnimationItem.prototype.goToAndStop = function (t, e, i) {
        if (!i || this.name === i) {
          var r = Number(t);
          if (isNaN(r)) {
            var s = this.getMarkerData(t);
            s && this.goToAndStop(s.time, !0);
          } else
            e
              ? this.setCurrentRawFrameValue(t)
              : this.setCurrentRawFrameValue(t * this.frameModifier);
          this.pause();
        }
      }),
      (AnimationItem.prototype.goToAndPlay = function (t, e, i) {
        if (!i || this.name === i) {
          var r = Number(t);
          if (isNaN(r)) {
            var s = this.getMarkerData(t);
            s &&
              (s.duration
                ? this.playSegments([s.time, s.time + s.duration], !0)
                : this.goToAndStop(s.time, !0));
          } else this.goToAndStop(r, e, i);
          this.play();
        }
      }),
      (AnimationItem.prototype.advanceTime = function (t) {
        if (!0 !== this.isPaused && !1 !== this.isLoaded) {
          var e = this.currentRawFrame + t * this.frameModifier,
            i = !1;
          e >= this.totalFrames - 1 && this.frameModifier > 0
            ? this.loop && this.playCount !== this.loop
              ? e >= this.totalFrames
                ? ((this.playCount += 1),
                  this.checkSegments(e % this.totalFrames) ||
                    (this.setCurrentRawFrameValue(e % this.totalFrames),
                    (this._completedLoop = !0),
                    this.trigger("loopComplete")))
                : this.setCurrentRawFrameValue(e)
              : this.checkSegments(
                  e > this.totalFrames ? e % this.totalFrames : 0
                ) || ((i = !0), (e = this.totalFrames - 1))
            : e < 0
            ? this.checkSegments(e % this.totalFrames) ||
              (!this.loop || (this.playCount-- <= 0 && !0 !== this.loop)
                ? ((i = !0), (e = 0))
                : (this.setCurrentRawFrameValue(
                    this.totalFrames + (e % this.totalFrames)
                  ),
                  this._completedLoop
                    ? this.trigger("loopComplete")
                    : (this._completedLoop = !0)))
            : this.setCurrentRawFrameValue(e),
            i &&
              (this.setCurrentRawFrameValue(e),
              this.pause(),
              this.trigger("complete"));
        }
      }),
      (AnimationItem.prototype.adjustSegment = function (t, e) {
        (this.playCount = 0),
          t[1] < t[0]
            ? (this.frameModifier > 0 &&
                (this.playSpeed < 0
                  ? this.setSpeed(-this.playSpeed)
                  : this.setDirection(-1)),
              (this.totalFrames = t[0] - t[1]),
              (this.timeCompleted = this.totalFrames),
              (this.firstFrame = t[1]),
              this.setCurrentRawFrameValue(this.totalFrames - 0.001 - e))
            : t[1] > t[0] &&
              (this.frameModifier < 0 &&
                (this.playSpeed < 0
                  ? this.setSpeed(-this.playSpeed)
                  : this.setDirection(1)),
              (this.totalFrames = t[1] - t[0]),
              (this.timeCompleted = this.totalFrames),
              (this.firstFrame = t[0]),
              this.setCurrentRawFrameValue(0.001 + e)),
          this.trigger("segmentStart");
      }),
      (AnimationItem.prototype.setSegment = function (t, e) {
        var i = -1;
        this.isPaused &&
          (this.currentRawFrame + this.firstFrame < t
            ? (i = t)
            : this.currentRawFrame + this.firstFrame > e && (i = e - t)),
          (this.firstFrame = t),
          (this.totalFrames = e - t),
          (this.timeCompleted = this.totalFrames),
          -1 !== i && this.goToAndStop(i, !0);
      }),
      (AnimationItem.prototype.playSegments = function (t, e) {
        if ((e && (this.segments.length = 0), "object" === _typeof$4(t[0]))) {
          var i,
            r = t.length;
          for (i = 0; i < r; i += 1) this.segments.push(t[i]);
        } else this.segments.push(t);
        this.segments.length &&
          e &&
          this.adjustSegment(this.segments.shift(), 0),
          this.isPaused && this.play();
      }),
      (AnimationItem.prototype.resetSegments = function (t) {
        (this.segments.length = 0),
          this.segments.push([this.animationData.ip, this.animationData.op]),
          t && this.checkSegments(0);
      }),
      (AnimationItem.prototype.checkSegments = function (t) {
        return (
          !!this.segments.length &&
          (this.adjustSegment(this.segments.shift(), t), !0)
        );
      }),
      (AnimationItem.prototype.destroy = function (t) {
        (t && this.name !== t) ||
          !this.renderer ||
          (this.renderer.destroy(),
          this.imagePreloader.destroy(),
          this.trigger("destroy"),
          (this._cbs = null),
          (this.onEnterFrame = null),
          (this.onLoopComplete = null),
          (this.onComplete = null),
          (this.onSegmentStart = null),
          (this.onDestroy = null),
          (this.renderer = null),
          (this.expressionsPlugin = null),
          (this.imagePreloader = null),
          (this.projectInterface = null));
      }),
      (AnimationItem.prototype.setCurrentRawFrameValue = function (t) {
        (this.currentRawFrame = t), this.gotoFrame();
      }),
      (AnimationItem.prototype.setSpeed = function (t) {
        (this.playSpeed = t), this.updaFrameModifier();
      }),
      (AnimationItem.prototype.setDirection = function (t) {
        (this.playDirection = t < 0 ? -1 : 1), this.updaFrameModifier();
      }),
      (AnimationItem.prototype.setLoop = function (t) {
        this.loop = t;
      }),
      (AnimationItem.prototype.setVolume = function (t, e) {
        (e && this.name !== e) || this.audioController.setVolume(t);
      }),
      (AnimationItem.prototype.getVolume = function () {
        return this.audioController.getVolume();
      }),
      (AnimationItem.prototype.mute = function (t) {
        (t && this.name !== t) || this.audioController.mute();
      }),
      (AnimationItem.prototype.unmute = function (t) {
        (t && this.name !== t) || this.audioController.unmute();
      }),
      (AnimationItem.prototype.updaFrameModifier = function () {
        (this.frameModifier =
          this.frameMult * this.playSpeed * this.playDirection),
          this.audioController.setRate(this.playSpeed * this.playDirection);
      }),
      (AnimationItem.prototype.getPath = function () {
        return this.path;
      }),
      (AnimationItem.prototype.getAssetsPath = function (t) {
        var e = "";
        if (t.e) e = t.p;
        else if (this.assetsPath) {
          var i = t.p;
          -1 !== i.indexOf("images/") && (i = i.split("/")[1]),
            (e = this.assetsPath + i);
        } else (e = this.path), (e += t.u ? t.u : ""), (e += t.p);
        return e;
      }),
      (AnimationItem.prototype.getAssetData = function (t) {
        for (var e = 0, i = this.assets.length; e < i; ) {
          if (t === this.assets[e].id) return this.assets[e];
          e += 1;
        }
        return null;
      }),
      (AnimationItem.prototype.hide = function () {
        this.renderer.hide();
      }),
      (AnimationItem.prototype.show = function () {
        this.renderer.show();
      }),
      (AnimationItem.prototype.getDuration = function (t) {
        return t ? this.totalFrames : this.totalFrames / this.frameRate;
      }),
      (AnimationItem.prototype.updateDocumentData = function (t, e, i) {
        try {
          this.renderer.getElementByPath(t).updateDocumentData(e, i);
        } catch (t) {}
      }),
      (AnimationItem.prototype.trigger = function (t) {
        if (this._cbs && this._cbs[t])
          switch (t) {
            case "enterFrame":
              this.triggerEvent(
                t,
                new BMEnterFrameEvent(
                  t,
                  this.currentFrame,
                  this.totalFrames,
                  this.frameModifier
                )
              );
              break;
            case "drawnFrame":
              (this.drawnFrameEvent.currentTime = this.currentFrame),
                (this.drawnFrameEvent.totalTime = this.totalFrames),
                (this.drawnFrameEvent.direction = this.frameModifier),
                this.triggerEvent(t, this.drawnFrameEvent);
              break;
            case "loopComplete":
              this.triggerEvent(
                t,
                new BMCompleteLoopEvent(
                  t,
                  this.loop,
                  this.playCount,
                  this.frameMult
                )
              );
              break;
            case "complete":
              this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
              break;
            case "segmentStart":
              this.triggerEvent(
                t,
                new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)
              );
              break;
            case "destroy":
              this.triggerEvent(t, new BMDestroyEvent(t, this));
              break;
            default:
              this.triggerEvent(t);
          }
        "enterFrame" === t &&
          this.onEnterFrame &&
          this.onEnterFrame.call(
            this,
            new BMEnterFrameEvent(
              t,
              this.currentFrame,
              this.totalFrames,
              this.frameMult
            )
          ),
          "loopComplete" === t &&
            this.onLoopComplete &&
            this.onLoopComplete.call(
              this,
              new BMCompleteLoopEvent(
                t,
                this.loop,
                this.playCount,
                this.frameMult
              )
            ),
          "complete" === t &&
            this.onComplete &&
            this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)),
          "segmentStart" === t &&
            this.onSegmentStart &&
            this.onSegmentStart.call(
              this,
              new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)
            ),
          "destroy" === t &&
            this.onDestroy &&
            this.onDestroy.call(this, new BMDestroyEvent(t, this));
      }),
      (AnimationItem.prototype.triggerRenderFrameError = function (t) {
        var e = new BMRenderFrameErrorEvent(t, this.currentFrame);
        this.triggerEvent("error", e),
          this.onError && this.onError.call(this, e);
      }),
      (AnimationItem.prototype.triggerConfigError = function (t) {
        var e = new BMConfigErrorEvent(t, this.currentFrame);
        this.triggerEvent("error", e),
          this.onError && this.onError.call(this, e);
      });
    var animationManager = (function () {
        var t = {},
          e = [],
          i = 0,
          r = 0,
          s = 0,
          a = !0,
          n = !1;
        function o(t) {
          for (var i = 0, s = t.target; i < r; )
            e[i].animation === s &&
              (e.splice(i, 1), (i -= 1), (r -= 1), s.isPaused || p()),
              (i += 1);
        }
        function h(t, i) {
          if (!t) return null;
          for (var s = 0; s < r; ) {
            if (e[s].elem === t && null !== e[s].elem) return e[s].animation;
            s += 1;
          }
          var a = new AnimationItem();
          return f(a, t), a.setData(t, i), a;
        }
        function l() {
          (s += 1), d();
        }
        function p() {
          s -= 1;
        }
        function f(t, i) {
          t.addEventListener("destroy", o),
            t.addEventListener("_active", l),
            t.addEventListener("_idle", p),
            e.push({ elem: i, animation: t }),
            (r += 1);
        }
        function m(t) {
          var o,
            h = t - i;
          for (o = 0; o < r; o += 1) e[o].animation.advanceTime(h);
          (i = t), s && !n ? window.requestAnimationFrame(m) : (a = !0);
        }
        function c(t) {
          (i = t), window.requestAnimationFrame(m);
        }
        function d() {
          !n && s && a && (window.requestAnimationFrame(c), (a = !1));
        }
        return (
          (t.registerAnimation = h),
          (t.loadAnimation = function (t) {
            var e = new AnimationItem();
            return f(e, null), e.setParams(t), e;
          }),
          (t.setSpeed = function (t, i) {
            var s;
            for (s = 0; s < r; s += 1) e[s].animation.setSpeed(t, i);
          }),
          (t.setDirection = function (t, i) {
            var s;
            for (s = 0; s < r; s += 1) e[s].animation.setDirection(t, i);
          }),
          (t.play = function (t) {
            var i;
            for (i = 0; i < r; i += 1) e[i].animation.play(t);
          }),
          (t.pause = function (t) {
            var i;
            for (i = 0; i < r; i += 1) e[i].animation.pause(t);
          }),
          (t.stop = function (t) {
            var i;
            for (i = 0; i < r; i += 1) e[i].animation.stop(t);
          }),
          (t.togglePause = function (t) {
            var i;
            for (i = 0; i < r; i += 1) e[i].animation.togglePause(t);
          }),
          (t.searchAnimations = function (t, e, i) {
            var r,
              s = [].concat(
                [].slice.call(document.getElementsByClassName("lottie")),
                [].slice.call(document.getElementsByClassName("bodymovin"))
              ),
              a = s.length;
            for (r = 0; r < a; r += 1)
              i && s[r].setAttribute("data-bm-type", i), h(s[r], t);
            if (e && 0 === a) {
              i || (i = "svg");
              var n = document.getElementsByTagName("body")[0];
              n.innerText = "";
              var o = createTag("div");
              (o.style.width = "100%"),
                (o.style.height = "100%"),
                o.setAttribute("data-bm-type", i),
                n.appendChild(o),
                h(o, t);
            }
          }),
          (t.resize = function () {
            var t;
            for (t = 0; t < r; t += 1) e[t].animation.resize();
          }),
          (t.goToAndStop = function (t, i, s) {
            var a;
            for (a = 0; a < r; a += 1) e[a].animation.goToAndStop(t, i, s);
          }),
          (t.destroy = function (t) {
            var i;
            for (i = r - 1; i >= 0; i -= 1) e[i].animation.destroy(t);
          }),
          (t.freeze = function () {
            n = !0;
          }),
          (t.unfreeze = function () {
            (n = !1), d();
          }),
          (t.setVolume = function (t, i) {
            var s;
            for (s = 0; s < r; s += 1) e[s].animation.setVolume(t, i);
          }),
          (t.mute = function (t) {
            var i;
            for (i = 0; i < r; i += 1) e[i].animation.mute(t);
          }),
          (t.unmute = function (t) {
            var i;
            for (i = 0; i < r; i += 1) e[i].animation.unmute(t);
          }),
          (t.getRegisteredAnimations = function () {
            var t,
              i = e.length,
              r = [];
            for (t = 0; t < i; t += 1) r.push(e[t].animation);
            return r;
          }),
          t
        );
      })(),
      BezierFactory = (function () {
        var t = {
            getBezierEasing: function (t, i, r, s, a) {
              var n =
                a ||
                ("bez_" + t + "_" + i + "_" + r + "_" + s).replace(/\./g, "p");
              if (e[n]) return e[n];
              var o = new l([t, i, r, s]);
              return (e[n] = o), o;
            },
          },
          e = {};
        var i = 0.1,
          r = "function" == typeof Float32Array;
        function s(t, e) {
          return 1 - 3 * e + 3 * t;
        }
        function a(t, e) {
          return 3 * e - 6 * t;
        }
        function n(t) {
          return 3 * t;
        }
        function o(t, e, i) {
          return ((s(e, i) * t + a(e, i)) * t + n(e)) * t;
        }
        function h(t, e, i) {
          return 3 * s(e, i) * t * t + 2 * a(e, i) * t + n(e);
        }
        function l(t) {
          (this._p = t),
            (this._mSampleValues = r ? new Float32Array(11) : new Array(11)),
            (this._precomputed = !1),
            (this.get = this.get.bind(this));
        }
        return (
          (l.prototype = {
            get: function (t) {
              var e = this._p[0],
                i = this._p[1],
                r = this._p[2],
                s = this._p[3];
              return (
                this._precomputed || this._precompute(),
                e === i && r === s
                  ? t
                  : 0 === t
                  ? 0
                  : 1 === t
                  ? 1
                  : o(this._getTForX(t), i, s)
              );
            },
            _precompute: function () {
              var t = this._p[0],
                e = this._p[1],
                i = this._p[2],
                r = this._p[3];
              (this._precomputed = !0),
                (t === e && i === r) || this._calcSampleValues();
            },
            _calcSampleValues: function () {
              for (var t = this._p[0], e = this._p[2], r = 0; r < 11; ++r)
                this._mSampleValues[r] = o(r * i, t, e);
            },
            _getTForX: function (t) {
              for (
                var e = this._p[0],
                  r = this._p[2],
                  s = this._mSampleValues,
                  a = 0,
                  n = 1;
                10 !== n && s[n] <= t;
                ++n
              )
                a += i;
              var l = a + ((t - s[--n]) / (s[n + 1] - s[n])) * i,
                p = h(l, e, r);
              return p >= 0.001
                ? (function (t, e, i, r) {
                    for (var s = 0; s < 4; ++s) {
                      var a = h(e, i, r);
                      if (0 === a) return e;
                      e -= (o(e, i, r) - t) / a;
                    }
                    return e;
                  })(t, l, e, r)
                : 0 === p
                ? l
                : (function (t, e, i, r, s) {
                    var a,
                      n,
                      h = 0;
                    do {
                      (a = o((n = e + (i - e) / 2), r, s) - t) > 0
                        ? (i = n)
                        : (e = n);
                    } while (Math.abs(a) > 1e-7 && ++h < 10);
                    return n;
                  })(t, a, a + i, e, r);
            },
          }),
          t
        );
      })(),
      pooling = {
        double: function (t) {
          return t.concat(createSizedArray(t.length));
        },
      },
      poolFactory = function (t, e, i) {
        var r = 0,
          s = t,
          a = createSizedArray(s);
        return {
          newElement: function () {
            return r ? a[(r -= 1)] : e();
          },
          release: function (t) {
            r === s && ((a = pooling.double(a)), (s *= 2)),
              i && i(t),
              (a[r] = t),
              (r += 1);
          },
        };
      },
      bezierLengthPool = poolFactory(8, function () {
        return {
          addedLength: 0,
          percents: createTypedArray("float32", getDefaultCurveSegments()),
          lengths: createTypedArray("float32", getDefaultCurveSegments()),
        };
      }),
      segmentsLengthPool = poolFactory(
        8,
        function () {
          return { lengths: [], totalLength: 0 };
        },
        function (t) {
          var e,
            i = t.lengths.length;
          for (e = 0; e < i; e += 1) bezierLengthPool.release(t.lengths[e]);
          t.lengths.length = 0;
        }
      );
    function bezFunction() {
      var t = Math;
      function e(t, e, i, r, s, a) {
        var n = t * r + e * s + i * a - s * r - a * t - i * e;
        return n > -0.001 && n < 0.001;
      }
      var i = function (t, e, i, r) {
        var s,
          a,
          n,
          o,
          h,
          l,
          p = getDefaultCurveSegments(),
          f = 0,
          m = [],
          c = [],
          d = bezierLengthPool.newElement();
        for (n = i.length, s = 0; s < p; s += 1) {
          for (h = s / (p - 1), l = 0, a = 0; a < n; a += 1)
            (o =
              bmPow(1 - h, 3) * t[a] +
              3 * bmPow(1 - h, 2) * h * i[a] +
              3 * (1 - h) * bmPow(h, 2) * r[a] +
              bmPow(h, 3) * e[a]),
              (m[a] = o),
              null !== c[a] && (l += bmPow(m[a] - c[a], 2)),
              (c[a] = m[a]);
          l && (f += l = bmSqrt(l)), (d.percents[s] = h), (d.lengths[s] = f);
        }
        return (d.addedLength = f), d;
      };
      function r(t) {
        (this.segmentLength = 0), (this.points = new Array(t));
      }
      function s(t, e) {
        (this.partialLength = t), (this.point = e);
      }
      var a,
        n =
          ((a = {}),
          function (t, i, n, o) {
            var h = (
              t[0] +
              "_" +
              t[1] +
              "_" +
              i[0] +
              "_" +
              i[1] +
              "_" +
              n[0] +
              "_" +
              n[1] +
              "_" +
              o[0] +
              "_" +
              o[1]
            ).replace(/\./g, "p");
            if (!a[h]) {
              var l,
                p,
                f,
                m,
                c,
                d,
                u,
                y = getDefaultCurveSegments(),
                g = 0,
                v = null;
              2 === t.length &&
                (t[0] !== i[0] || t[1] !== i[1]) &&
                e(t[0], t[1], i[0], i[1], t[0] + n[0], t[1] + n[1]) &&
                e(t[0], t[1], i[0], i[1], i[0] + o[0], i[1] + o[1]) &&
                (y = 2);
              var b = new r(y);
              for (f = n.length, l = 0; l < y; l += 1) {
                for (
                  u = createSizedArray(f), c = l / (y - 1), d = 0, p = 0;
                  p < f;
                  p += 1
                )
                  (m =
                    bmPow(1 - c, 3) * t[p] +
                    3 * bmPow(1 - c, 2) * c * (t[p] + n[p]) +
                    3 * (1 - c) * bmPow(c, 2) * (i[p] + o[p]) +
                    bmPow(c, 3) * i[p]),
                    (u[p] = m),
                    null !== v && (d += bmPow(u[p] - v[p], 2));
                (g += d = bmSqrt(d)), (b.points[l] = new s(d, u)), (v = u);
              }
              (b.segmentLength = g), (a[h] = b);
            }
            return a[h];
          });
      function o(t, e) {
        var i = e.percents,
          r = e.lengths,
          s = i.length,
          a = bmFloor((s - 1) * t),
          n = t * e.addedLength,
          o = 0;
        if (a === s - 1 || 0 === a || n === r[a]) return i[a];
        for (var h = r[a] > n ? -1 : 1, l = !0; l; )
          if (
            (r[a] <= n && r[a + 1] > n
              ? ((o = (n - r[a]) / (r[a + 1] - r[a])), (l = !1))
              : (a += h),
            a < 0 || a >= s - 1)
          ) {
            if (a === s - 1) return i[a];
            l = !1;
          }
        return i[a] + (i[a + 1] - i[a]) * o;
      }
      var h = createTypedArray("float32", 8);
      return {
        getSegmentsLength: function (t) {
          var e,
            r = segmentsLengthPool.newElement(),
            s = t.c,
            a = t.v,
            n = t.o,
            o = t.i,
            h = t._length,
            l = r.lengths,
            p = 0;
          for (e = 0; e < h - 1; e += 1)
            (l[e] = i(a[e], a[e + 1], n[e], o[e + 1])), (p += l[e].addedLength);
          return (
            s &&
              h &&
              ((l[e] = i(a[e], a[0], n[e], o[0])), (p += l[e].addedLength)),
            (r.totalLength = p),
            r
          );
        },
        getNewSegment: function (e, i, r, s, a, n, l) {
          a < 0 ? (a = 0) : a > 1 && (a = 1);
          var p,
            f = o(a, l),
            m = o((n = n > 1 ? 1 : n), l),
            c = e.length,
            d = 1 - f,
            u = 1 - m,
            y = d * d * d,
            g = f * d * d * 3,
            v = f * f * d * 3,
            b = f * f * f,
            x = d * d * u,
            P = f * d * u + d * f * u + d * d * m,
            E = f * f * u + d * f * m + f * d * m,
            S = f * f * m,
            C = d * u * u,
            _ = f * u * u + d * m * u + d * u * m,
            A = f * m * u + d * m * m + f * u * m,
            T = f * m * m,
            M = u * u * u,
            k = m * u * u + u * m * u + u * u * m,
            D = m * m * u + u * m * m + m * u * m,
            F = m * m * m;
          for (p = 0; p < c; p += 1)
            (h[4 * p] =
              t.round(1e3 * (y * e[p] + g * r[p] + v * s[p] + b * i[p])) / 1e3),
              (h[4 * p + 1] =
                t.round(1e3 * (x * e[p] + P * r[p] + E * s[p] + S * i[p])) /
                1e3),
              (h[4 * p + 2] =
                t.round(1e3 * (C * e[p] + _ * r[p] + A * s[p] + T * i[p])) /
                1e3),
              (h[4 * p + 3] =
                t.round(1e3 * (M * e[p] + k * r[p] + D * s[p] + F * i[p])) /
                1e3);
          return h;
        },
        getPointInSegment: function (e, i, r, s, a, n) {
          var h = o(a, n),
            l = 1 - h;
          return [
            t.round(
              1e3 *
                (l * l * l * e[0] +
                  (h * l * l + l * h * l + l * l * h) * r[0] +
                  (h * h * l + l * h * h + h * l * h) * s[0] +
                  h * h * h * i[0])
            ) / 1e3,
            t.round(
              1e3 *
                (l * l * l * e[1] +
                  (h * l * l + l * h * l + l * l * h) * r[1] +
                  (h * h * l + l * h * h + h * l * h) * s[1] +
                  h * h * h * i[1])
            ) / 1e3,
          ];
        },
        buildBezierData: n,
        pointOnLine2D: e,
        pointOnLine3D: function (i, r, s, a, n, o, h, l, p) {
          if (0 === s && 0 === o && 0 === p) return e(i, r, a, n, h, l);
          var f,
            m = t.sqrt(t.pow(a - i, 2) + t.pow(n - r, 2) + t.pow(o - s, 2)),
            c = t.sqrt(t.pow(h - i, 2) + t.pow(l - r, 2) + t.pow(p - s, 2)),
            d = t.sqrt(t.pow(h - a, 2) + t.pow(l - n, 2) + t.pow(p - o, 2));
          return (
            (f =
              m > c
                ? m > d
                  ? m - c - d
                  : d - c - m
                : d > c
                ? d - c - m
                : c - m - d) > -1e-4 && f < 1e-4
          );
        },
      };
    }
    var bez = bezFunction(),
      initFrame = initialDefaultFrame,
      mathAbs = Math.abs;
    function interpolateValue(t, e) {
      var i,
        r = this.offsetTime;
      "multidimensional" === this.propType &&
        (i = createTypedArray("float32", this.pv.length));
      for (
        var s,
          a,
          n,
          o,
          h,
          l,
          p,
          f,
          m,
          c = e.lastIndex,
          d = c,
          u = this.keyframes.length - 1,
          y = !0;
        y;

      ) {
        if (
          ((s = this.keyframes[d]),
          (a = this.keyframes[d + 1]),
          d === u - 1 && t >= a.t - r)
        ) {
          s.h && (s = a), (c = 0);
          break;
        }
        if (a.t - r > t) {
          c = d;
          break;
        }
        d < u - 1 ? (d += 1) : ((c = 0), (y = !1));
      }
      n = this.keyframesMetadata[d] || {};
      var g,
        v = a.t - r,
        b = s.t - r;
      if (s.to) {
        n.bezierData ||
          (n.bezierData = bez.buildBezierData(s.s, a.s || s.e, s.to, s.ti));
        var x = n.bezierData;
        if (t >= v || t < b) {
          var P = t >= v ? x.points.length - 1 : 0;
          for (h = x.points[P].point.length, o = 0; o < h; o += 1)
            i[o] = x.points[P].point[o];
        } else {
          n.__fnct
            ? (m = n.__fnct)
            : ((m = BezierFactory.getBezierEasing(
                s.o.x,
                s.o.y,
                s.i.x,
                s.i.y,
                s.n
              ).get),
              (n.__fnct = m)),
            (l = m((t - b) / (v - b)));
          var E,
            S = x.segmentLength * l,
            C =
              e.lastFrame < t && e._lastKeyframeIndex === d
                ? e._lastAddedLength
                : 0;
          for (
            f =
              e.lastFrame < t && e._lastKeyframeIndex === d ? e._lastPoint : 0,
              y = !0,
              p = x.points.length;
            y;

          ) {
            if (
              ((C += x.points[f].partialLength),
              0 === S || 0 === l || f === x.points.length - 1)
            ) {
              for (h = x.points[f].point.length, o = 0; o < h; o += 1)
                i[o] = x.points[f].point[o];
              break;
            }
            if (S >= C && S < C + x.points[f + 1].partialLength) {
              for (
                E = (S - C) / x.points[f + 1].partialLength,
                  h = x.points[f].point.length,
                  o = 0;
                o < h;
                o += 1
              )
                i[o] =
                  x.points[f].point[o] +
                  (x.points[f + 1].point[o] - x.points[f].point[o]) * E;
              break;
            }
            f < p - 1 ? (f += 1) : (y = !1);
          }
          (e._lastPoint = f),
            (e._lastAddedLength = C - x.points[f].partialLength),
            (e._lastKeyframeIndex = d);
        }
      } else {
        var _, A, T, M, k;
        if (((u = s.s.length), (g = a.s || s.e), this.sh && 1 !== s.h))
          if (t >= v) (i[0] = g[0]), (i[1] = g[1]), (i[2] = g[2]);
          else if (t <= b) (i[0] = s.s[0]), (i[1] = s.s[1]), (i[2] = s.s[2]);
          else {
            quaternionToEuler(
              i,
              slerp(
                createQuaternion(s.s),
                createQuaternion(g),
                (t - b) / (v - b)
              )
            );
          }
        else
          for (d = 0; d < u; d += 1)
            1 !== s.h &&
              (t >= v
                ? (l = 1)
                : t < b
                ? (l = 0)
                : (s.o.x.constructor === Array
                    ? (n.__fnct || (n.__fnct = []),
                      n.__fnct[d]
                        ? (m = n.__fnct[d])
                        : ((_ = void 0 === s.o.x[d] ? s.o.x[0] : s.o.x[d]),
                          (A = void 0 === s.o.y[d] ? s.o.y[0] : s.o.y[d]),
                          (T = void 0 === s.i.x[d] ? s.i.x[0] : s.i.x[d]),
                          (M = void 0 === s.i.y[d] ? s.i.y[0] : s.i.y[d]),
                          (m = BezierFactory.getBezierEasing(_, A, T, M).get),
                          (n.__fnct[d] = m)))
                    : n.__fnct
                    ? (m = n.__fnct)
                    : ((_ = s.o.x),
                      (A = s.o.y),
                      (T = s.i.x),
                      (M = s.i.y),
                      (m = BezierFactory.getBezierEasing(_, A, T, M).get),
                      (s.keyframeMetadata = m)),
                  (l = m((t - b) / (v - b))))),
              (g = a.s || s.e),
              (k = 1 === s.h ? s.s[d] : s.s[d] + (g[d] - s.s[d]) * l),
              "multidimensional" === this.propType ? (i[d] = k) : (i = k);
      }
      return (e.lastIndex = c), i;
    }
    function slerp(t, e, i) {
      var r,
        s,
        a,
        n,
        o,
        h = [],
        l = t[0],
        p = t[1],
        f = t[2],
        m = t[3],
        c = e[0],
        d = e[1],
        u = e[2],
        y = e[3];
      return (
        (s = l * c + p * d + f * u + m * y) < 0 &&
          ((s = -s), (c = -c), (d = -d), (u = -u), (y = -y)),
        1 - s > 1e-6
          ? ((r = Math.acos(s)),
            (a = Math.sin(r)),
            (n = Math.sin((1 - i) * r) / a),
            (o = Math.sin(i * r) / a))
          : ((n = 1 - i), (o = i)),
        (h[0] = n * l + o * c),
        (h[1] = n * p + o * d),
        (h[2] = n * f + o * u),
        (h[3] = n * m + o * y),
        h
      );
    }
    function quaternionToEuler(t, e) {
      var i = e[0],
        r = e[1],
        s = e[2],
        a = e[3],
        n = Math.atan2(2 * r * a - 2 * i * s, 1 - 2 * r * r - 2 * s * s),
        o = Math.asin(2 * i * r + 2 * s * a),
        h = Math.atan2(2 * i * a - 2 * r * s, 1 - 2 * i * i - 2 * s * s);
      (t[0] = n / degToRads), (t[1] = o / degToRads), (t[2] = h / degToRads);
    }
    function createQuaternion(t) {
      var e = t[0] * degToRads,
        i = t[1] * degToRads,
        r = t[2] * degToRads,
        s = Math.cos(e / 2),
        a = Math.cos(i / 2),
        n = Math.cos(r / 2),
        o = Math.sin(e / 2),
        h = Math.sin(i / 2),
        l = Math.sin(r / 2);
      return [
        o * h * n + s * a * l,
        o * a * n + s * h * l,
        s * h * n - o * a * l,
        s * a * n - o * h * l,
      ];
    }
    function getValueAtCurrentTime() {
      var t = this.comp.renderedFrame - this.offsetTime,
        e = this.keyframes[0].t - this.offsetTime,
        i = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (
        !(
          t === this._caching.lastFrame ||
          (this._caching.lastFrame !== initFrame &&
            ((this._caching.lastFrame >= i && t >= i) ||
              (this._caching.lastFrame < e && t < e)))
        )
      ) {
        this._caching.lastFrame >= t &&
          ((this._caching._lastKeyframeIndex = -1),
          (this._caching.lastIndex = 0));
        var r = this.interpolateValue(t, this._caching);
        this.pv = r;
      }
      return (this._caching.lastFrame = t), this.pv;
    }
    function setVValue(t) {
      var e;
      if ("unidimensional" === this.propType)
        (e = t * this.mult),
          mathAbs(this.v - e) > 1e-5 && ((this.v = e), (this._mdf = !0));
      else
        for (var i = 0, r = this.v.length; i < r; )
          (e = t[i] * this.mult),
            mathAbs(this.v[i] - e) > 1e-5 &&
              ((this.v[i] = e), (this._mdf = !0)),
            (i += 1);
    }
    function processEffectsSequence() {
      if (
        this.elem.globalData.frameId !== this.frameId &&
        this.effectsSequence.length
      )
        if (this.lock) this.setVValue(this.pv);
        else {
          var t;
          (this.lock = !0), (this._mdf = this._isFirstFrame);
          var e = this.effectsSequence.length,
            i = this.kf ? this.pv : this.data.k;
          for (t = 0; t < e; t += 1) i = this.effectsSequence[t](i);
          this.setVValue(i),
            (this._isFirstFrame = !1),
            (this.lock = !1),
            (this.frameId = this.elem.globalData.frameId);
        }
    }
    function addEffect(t) {
      this.effectsSequence.push(t), this.container.addDynamicProperty(this);
    }
    function ValueProperty(t, e, i, r) {
      (this.propType = "unidimensional"),
        (this.mult = i || 1),
        (this.data = e),
        (this.v = i ? e.k * i : e.k),
        (this.pv = e.k),
        (this._mdf = !1),
        (this.elem = t),
        (this.container = r),
        (this.comp = t.comp),
        (this.k = !1),
        (this.kf = !1),
        (this.vel = 0),
        (this.effectsSequence = []),
        (this._isFirstFrame = !0),
        (this.getValue = processEffectsSequence),
        (this.setVValue = setVValue),
        (this.addEffect = addEffect);
    }
    function MultiDimensionalProperty(t, e, i, r) {
      var s;
      (this.propType = "multidimensional"),
        (this.mult = i || 1),
        (this.data = e),
        (this._mdf = !1),
        (this.elem = t),
        (this.container = r),
        (this.comp = t.comp),
        (this.k = !1),
        (this.kf = !1),
        (this.frameId = -1);
      var a = e.k.length;
      for (
        this.v = createTypedArray("float32", a),
          this.pv = createTypedArray("float32", a),
          this.vel = createTypedArray("float32", a),
          s = 0;
        s < a;
        s += 1
      )
        (this.v[s] = e.k[s] * this.mult), (this.pv[s] = e.k[s]);
      (this._isFirstFrame = !0),
        (this.effectsSequence = []),
        (this.getValue = processEffectsSequence),
        (this.setVValue = setVValue),
        (this.addEffect = addEffect);
    }
    function KeyframedValueProperty(t, e, i, r) {
      (this.propType = "unidimensional"),
        (this.keyframes = e.k),
        (this.keyframesMetadata = []),
        (this.offsetTime = t.data.st),
        (this.frameId = -1),
        (this._caching = {
          lastFrame: initFrame,
          lastIndex: 0,
          value: 0,
          _lastKeyframeIndex: -1,
        }),
        (this.k = !0),
        (this.kf = !0),
        (this.data = e),
        (this.mult = i || 1),
        (this.elem = t),
        (this.container = r),
        (this.comp = t.comp),
        (this.v = initFrame),
        (this.pv = initFrame),
        (this._isFirstFrame = !0),
        (this.getValue = processEffectsSequence),
        (this.setVValue = setVValue),
        (this.interpolateValue = interpolateValue),
        (this.effectsSequence = [getValueAtCurrentTime.bind(this)]),
        (this.addEffect = addEffect);
    }
    function KeyframedMultidimensionalProperty(t, e, i, r) {
      var s;
      this.propType = "multidimensional";
      var a,
        n,
        o,
        h,
        l = e.k.length;
      for (s = 0; s < l - 1; s += 1)
        e.k[s].to &&
          e.k[s].s &&
          e.k[s + 1] &&
          e.k[s + 1].s &&
          ((a = e.k[s].s),
          (n = e.k[s + 1].s),
          (o = e.k[s].to),
          (h = e.k[s].ti),
          ((2 === a.length &&
            (a[0] !== n[0] || a[1] !== n[1]) &&
            bez.pointOnLine2D(
              a[0],
              a[1],
              n[0],
              n[1],
              a[0] + o[0],
              a[1] + o[1]
            ) &&
            bez.pointOnLine2D(
              a[0],
              a[1],
              n[0],
              n[1],
              n[0] + h[0],
              n[1] + h[1]
            )) ||
            (3 === a.length &&
              (a[0] !== n[0] || a[1] !== n[1] || a[2] !== n[2]) &&
              bez.pointOnLine3D(
                a[0],
                a[1],
                a[2],
                n[0],
                n[1],
                n[2],
                a[0] + o[0],
                a[1] + o[1],
                a[2] + o[2]
              ) &&
              bez.pointOnLine3D(
                a[0],
                a[1],
                a[2],
                n[0],
                n[1],
                n[2],
                n[0] + h[0],
                n[1] + h[1],
                n[2] + h[2]
              ))) &&
            ((e.k[s].to = null), (e.k[s].ti = null)),
          a[0] === n[0] &&
            a[1] === n[1] &&
            0 === o[0] &&
            0 === o[1] &&
            0 === h[0] &&
            0 === h[1] &&
            (2 === a.length || (a[2] === n[2] && 0 === o[2] && 0 === h[2])) &&
            ((e.k[s].to = null), (e.k[s].ti = null)));
      (this.effectsSequence = [getValueAtCurrentTime.bind(this)]),
        (this.data = e),
        (this.keyframes = e.k),
        (this.keyframesMetadata = []),
        (this.offsetTime = t.data.st),
        (this.k = !0),
        (this.kf = !0),
        (this._isFirstFrame = !0),
        (this.mult = i || 1),
        (this.elem = t),
        (this.container = r),
        (this.comp = t.comp),
        (this.getValue = processEffectsSequence),
        (this.setVValue = setVValue),
        (this.interpolateValue = interpolateValue),
        (this.frameId = -1);
      var p = e.k[0].s.length;
      for (
        this.v = createTypedArray("float32", p),
          this.pv = createTypedArray("float32", p),
          s = 0;
        s < p;
        s += 1
      )
        (this.v[s] = initFrame), (this.pv[s] = initFrame);
      (this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: createTypedArray("float32", p),
      }),
        (this.addEffect = addEffect);
    }
    var PropertyFactory = {
      getProp: function (t, e, i, r, s) {
        var a;
        if ((e.sid && (e = t.globalData.slotManager.getProp(e)), e.k.length))
          if ("number" == typeof e.k[0])
            a = new MultiDimensionalProperty(t, e, r, s);
          else
            switch (i) {
              case 0:
                a = new KeyframedValueProperty(t, e, r, s);
                break;
              case 1:
                a = new KeyframedMultidimensionalProperty(t, e, r, s);
            }
        else a = new ValueProperty(t, e, r, s);
        return a.effectsSequence.length && s.addDynamicProperty(a), a;
      },
    };
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
      addDynamicProperty: function (t) {
        -1 === this.dynamicProperties.indexOf(t) &&
          (this.dynamicProperties.push(t),
          this.container.addDynamicProperty(this),
          (this._isAnimated = !0));
      },
      iterateDynamicProperties: function () {
        var t;
        this._mdf = !1;
        var e = this.dynamicProperties.length;
        for (t = 0; t < e; t += 1)
          this.dynamicProperties[t].getValue(),
            this.dynamicProperties[t]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function (t) {
        (this.container = t),
          (this.dynamicProperties = []),
          (this._mdf = !1),
          (this._isAnimated = !1);
      },
    };
    var pointPool = poolFactory(8, function () {
      return createTypedArray("float32", 2);
    });
    function ShapePath() {
      (this.c = !1),
        (this._length = 0),
        (this._maxLength = 8),
        (this.v = createSizedArray(this._maxLength)),
        (this.o = createSizedArray(this._maxLength)),
        (this.i = createSizedArray(this._maxLength));
    }
    (ShapePath.prototype.setPathData = function (t, e) {
      (this.c = t), this.setLength(e);
      for (var i = 0; i < e; )
        (this.v[i] = pointPool.newElement()),
          (this.o[i] = pointPool.newElement()),
          (this.i[i] = pointPool.newElement()),
          (i += 1);
    }),
      (ShapePath.prototype.setLength = function (t) {
        for (; this._maxLength < t; ) this.doubleArrayLength();
        this._length = t;
      }),
      (ShapePath.prototype.doubleArrayLength = function () {
        (this.v = this.v.concat(createSizedArray(this._maxLength))),
          (this.i = this.i.concat(createSizedArray(this._maxLength))),
          (this.o = this.o.concat(createSizedArray(this._maxLength))),
          (this._maxLength *= 2);
      }),
      (ShapePath.prototype.setXYAt = function (t, e, i, r, s) {
        var a;
        switch (
          ((this._length = Math.max(this._length, r + 1)),
          this._length >= this._maxLength && this.doubleArrayLength(),
          i)
        ) {
          case "v":
            a = this.v;
            break;
          case "i":
            a = this.i;
            break;
          case "o":
            a = this.o;
            break;
          default:
            a = [];
        }
        (!a[r] || (a[r] && !s)) && (a[r] = pointPool.newElement()),
          (a[r][0] = t),
          (a[r][1] = e);
      }),
      (ShapePath.prototype.setTripleAt = function (t, e, i, r, s, a, n, o) {
        this.setXYAt(t, e, "v", n, o),
          this.setXYAt(i, r, "o", n, o),
          this.setXYAt(s, a, "i", n, o);
      }),
      (ShapePath.prototype.reverse = function () {
        var t = new ShapePath();
        t.setPathData(this.c, this._length);
        var e = this.v,
          i = this.o,
          r = this.i,
          s = 0;
        this.c &&
          (t.setTripleAt(
            e[0][0],
            e[0][1],
            r[0][0],
            r[0][1],
            i[0][0],
            i[0][1],
            0,
            !1
          ),
          (s = 1));
        var a,
          n = this._length - 1,
          o = this._length;
        for (a = s; a < o; a += 1)
          t.setTripleAt(
            e[n][0],
            e[n][1],
            r[n][0],
            r[n][1],
            i[n][0],
            i[n][1],
            a,
            !1
          ),
            (n -= 1);
        return t;
      }),
      (ShapePath.prototype.length = function () {
        return this._length;
      });
    var shapePool =
        ((factory = poolFactory(
          4,
          function () {
            return new ShapePath();
          },
          function (t) {
            var e,
              i = t._length;
            for (e = 0; e < i; e += 1)
              pointPool.release(t.v[e]),
                pointPool.release(t.i[e]),
                pointPool.release(t.o[e]),
                (t.v[e] = null),
                (t.i[e] = null),
                (t.o[e] = null);
            (t._length = 0), (t.c = !1);
          }
        )),
        (factory.clone = function (t) {
          var e,
            i = factory.newElement(),
            r = void 0 === t._length ? t.v.length : t._length;
          for (i.setLength(r), i.c = t.c, e = 0; e < r; e += 1)
            i.setTripleAt(
              t.v[e][0],
              t.v[e][1],
              t.o[e][0],
              t.o[e][1],
              t.i[e][0],
              t.i[e][1],
              e
            );
          return i;
        }),
        factory),
      factory;
    function ShapeCollection() {
      (this._length = 0),
        (this._maxLength = 4),
        (this.shapes = createSizedArray(this._maxLength));
    }
    (ShapeCollection.prototype.addShape = function (t) {
      this._length === this._maxLength &&
        ((this.shapes = this.shapes.concat(createSizedArray(this._maxLength))),
        (this._maxLength *= 2)),
        (this.shapes[this._length] = t),
        (this._length += 1);
    }),
      (ShapeCollection.prototype.releaseShapes = function () {
        var t;
        for (t = 0; t < this._length; t += 1) shapePool.release(this.shapes[t]);
        this._length = 0;
      });
    var shapeCollectionPool =
        ((ob = {
          newShapeCollection: function () {
            return _length ? pool[(_length -= 1)] : new ShapeCollection();
          },
          release: function (t) {
            var e,
              i = t._length;
            for (e = 0; e < i; e += 1) shapePool.release(t.shapes[e]);
            (t._length = 0),
              _length === _maxLength &&
                ((pool = pooling.double(pool)), (_maxLength *= 2)),
              (pool[_length] = t),
              (_length += 1);
          },
        }),
        (_length = 0),
        (_maxLength = 4),
        (pool = createSizedArray(_maxLength)),
        ob),
      ob,
      _length,
      _maxLength,
      pool,
      ShapePropertyFactory = (function () {
        var t = -999999;
        function e(t, e, i) {
          var r,
            s,
            a,
            n,
            o,
            h,
            l,
            p,
            f,
            m = i.lastIndex,
            c = this.keyframes;
          if (t < c[0].t - this.offsetTime) (r = c[0].s[0]), (a = !0), (m = 0);
          else if (t >= c[c.length - 1].t - this.offsetTime)
            (r = c[c.length - 1].s
              ? c[c.length - 1].s[0]
              : c[c.length - 2].e[0]),
              (a = !0);
          else {
            for (
              var d, u, y, g = m, v = c.length - 1, b = !0;
              b && ((d = c[g]), !((u = c[g + 1]).t - this.offsetTime > t));

            )
              g < v - 1 ? (g += 1) : (b = !1);
            if (
              ((y = this.keyframesMetadata[g] || {}), (m = g), !(a = 1 === d.h))
            ) {
              if (t >= u.t - this.offsetTime) p = 1;
              else if (t < d.t - this.offsetTime) p = 0;
              else {
                var x;
                y.__fnct
                  ? (x = y.__fnct)
                  : ((x = BezierFactory.getBezierEasing(
                      d.o.x,
                      d.o.y,
                      d.i.x,
                      d.i.y
                    ).get),
                    (y.__fnct = x)),
                  (p = x(
                    (t - (d.t - this.offsetTime)) /
                      (u.t - this.offsetTime - (d.t - this.offsetTime))
                  ));
              }
              s = u.s ? u.s[0] : d.e[0];
            }
            r = d.s[0];
          }
          for (
            h = e._length, l = r.i[0].length, i.lastIndex = m, n = 0;
            n < h;
            n += 1
          )
            for (o = 0; o < l; o += 1)
              (f = a ? r.i[n][o] : r.i[n][o] + (s.i[n][o] - r.i[n][o]) * p),
                (e.i[n][o] = f),
                (f = a ? r.o[n][o] : r.o[n][o] + (s.o[n][o] - r.o[n][o]) * p),
                (e.o[n][o] = f),
                (f = a ? r.v[n][o] : r.v[n][o] + (s.v[n][o] - r.v[n][o]) * p),
                (e.v[n][o] = f);
        }
        function i() {
          var e = this.comp.renderedFrame - this.offsetTime,
            i = this.keyframes[0].t - this.offsetTime,
            r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime,
            s = this._caching.lastFrame;
          return (
            (s !== t && ((s < i && e < i) || (s > r && e > r))) ||
              ((this._caching.lastIndex = s < e ? this._caching.lastIndex : 0),
              this.interpolateShape(e, this.pv, this._caching)),
            (this._caching.lastFrame = e),
            this.pv
          );
        }
        function r() {
          this.paths = this.localShapeCollection;
        }
        function s(t) {
          (function (t, e) {
            if (t._length !== e._length || t.c !== e.c) return !1;
            var i,
              r = t._length;
            for (i = 0; i < r; i += 1)
              if (
                t.v[i][0] !== e.v[i][0] ||
                t.v[i][1] !== e.v[i][1] ||
                t.o[i][0] !== e.o[i][0] ||
                t.o[i][1] !== e.o[i][1] ||
                t.i[i][0] !== e.i[i][0] ||
                t.i[i][1] !== e.i[i][1]
              )
                return !1;
            return !0;
          })(this.v, t) ||
            ((this.v = shapePool.clone(t)),
            this.localShapeCollection.releaseShapes(),
            this.localShapeCollection.addShape(this.v),
            (this._mdf = !0),
            (this.paths = this.localShapeCollection));
        }
        function a() {
          if (this.elem.globalData.frameId !== this.frameId)
            if (this.effectsSequence.length)
              if (this.lock) this.setVValue(this.pv);
              else {
                var t, e;
                (this.lock = !0),
                  (this._mdf = !1),
                  (t = this.kf
                    ? this.pv
                    : this.data.ks
                    ? this.data.ks.k
                    : this.data.pt.k);
                var i = this.effectsSequence.length;
                for (e = 0; e < i; e += 1) t = this.effectsSequence[e](t);
                this.setVValue(t),
                  (this.lock = !1),
                  (this.frameId = this.elem.globalData.frameId);
              }
            else this._mdf = !1;
        }
        function n(t, e, i) {
          (this.propType = "shape"),
            (this.comp = t.comp),
            (this.container = t),
            (this.elem = t),
            (this.data = e),
            (this.k = !1),
            (this.kf = !1),
            (this._mdf = !1);
          var s = 3 === i ? e.pt.k : e.ks.k;
          (this.v = shapePool.clone(s)),
            (this.pv = shapePool.clone(this.v)),
            (this.localShapeCollection =
              shapeCollectionPool.newShapeCollection()),
            (this.paths = this.localShapeCollection),
            this.paths.addShape(this.v),
            (this.reset = r),
            (this.effectsSequence = []);
        }
        function o(t) {
          this.effectsSequence.push(t), this.container.addDynamicProperty(this);
        }
        function h(e, s, a) {
          (this.propType = "shape"),
            (this.comp = e.comp),
            (this.elem = e),
            (this.container = e),
            (this.offsetTime = e.data.st),
            (this.keyframes = 3 === a ? s.pt.k : s.ks.k),
            (this.keyframesMetadata = []),
            (this.k = !0),
            (this.kf = !0);
          var n = this.keyframes[0].s[0].i.length;
          (this.v = shapePool.newElement()),
            this.v.setPathData(this.keyframes[0].s[0].c, n),
            (this.pv = shapePool.clone(this.v)),
            (this.localShapeCollection =
              shapeCollectionPool.newShapeCollection()),
            (this.paths = this.localShapeCollection),
            this.paths.addShape(this.v),
            (this.lastFrame = t),
            (this.reset = r),
            (this._caching = { lastFrame: t, lastIndex: 0 }),
            (this.effectsSequence = [i.bind(this)]);
        }
        (n.prototype.interpolateShape = e),
          (n.prototype.getValue = a),
          (n.prototype.setVValue = s),
          (n.prototype.addEffect = o),
          (h.prototype.getValue = a),
          (h.prototype.interpolateShape = e),
          (h.prototype.setVValue = s),
          (h.prototype.addEffect = o);
        var l = (function () {
            var t = roundCorner;
            function e(t, e) {
              (this.v = shapePool.newElement()),
                this.v.setPathData(!0, 4),
                (this.localShapeCollection =
                  shapeCollectionPool.newShapeCollection()),
                (this.paths = this.localShapeCollection),
                this.localShapeCollection.addShape(this.v),
                (this.d = e.d),
                (this.elem = t),
                (this.comp = t.comp),
                (this.frameId = -1),
                this.initDynamicPropertyContainer(t),
                (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                (this.s = PropertyFactory.getProp(t, e.s, 1, 0, this)),
                this.dynamicProperties.length
                  ? (this.k = !0)
                  : ((this.k = !1), this.convertEllToPath());
            }
            return (
              (e.prototype = {
                reset: r,
                getValue: function () {
                  this.elem.globalData.frameId !== this.frameId &&
                    ((this.frameId = this.elem.globalData.frameId),
                    this.iterateDynamicProperties(),
                    this._mdf && this.convertEllToPath());
                },
                convertEllToPath: function () {
                  var e = this.p.v[0],
                    i = this.p.v[1],
                    r = this.s.v[0] / 2,
                    s = this.s.v[1] / 2,
                    a = 3 !== this.d,
                    n = this.v;
                  (n.v[0][0] = e),
                    (n.v[0][1] = i - s),
                    (n.v[1][0] = a ? e + r : e - r),
                    (n.v[1][1] = i),
                    (n.v[2][0] = e),
                    (n.v[2][1] = i + s),
                    (n.v[3][0] = a ? e - r : e + r),
                    (n.v[3][1] = i),
                    (n.i[0][0] = a ? e - r * t : e + r * t),
                    (n.i[0][1] = i - s),
                    (n.i[1][0] = a ? e + r : e - r),
                    (n.i[1][1] = i - s * t),
                    (n.i[2][0] = a ? e + r * t : e - r * t),
                    (n.i[2][1] = i + s),
                    (n.i[3][0] = a ? e - r : e + r),
                    (n.i[3][1] = i + s * t),
                    (n.o[0][0] = a ? e + r * t : e - r * t),
                    (n.o[0][1] = i - s),
                    (n.o[1][0] = a ? e + r : e - r),
                    (n.o[1][1] = i + s * t),
                    (n.o[2][0] = a ? e - r * t : e + r * t),
                    (n.o[2][1] = i + s),
                    (n.o[3][0] = a ? e - r : e + r),
                    (n.o[3][1] = i - s * t);
                },
              }),
              extendPrototype([DynamicPropertyContainer], e),
              e
            );
          })(),
          p = (function () {
            function t(t, e) {
              (this.v = shapePool.newElement()),
                this.v.setPathData(!0, 0),
                (this.elem = t),
                (this.comp = t.comp),
                (this.data = e),
                (this.frameId = -1),
                (this.d = e.d),
                this.initDynamicPropertyContainer(t),
                1 === e.sy
                  ? ((this.ir = PropertyFactory.getProp(t, e.ir, 0, 0, this)),
                    (this.is = PropertyFactory.getProp(t, e.is, 0, 0.01, this)),
                    (this.convertToPath = this.convertStarToPath))
                  : (this.convertToPath = this.convertPolygonToPath),
                (this.pt = PropertyFactory.getProp(t, e.pt, 0, 0, this)),
                (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                (this.r = PropertyFactory.getProp(t, e.r, 0, degToRads, this)),
                (this.or = PropertyFactory.getProp(t, e.or, 0, 0, this)),
                (this.os = PropertyFactory.getProp(t, e.os, 0, 0.01, this)),
                (this.localShapeCollection =
                  shapeCollectionPool.newShapeCollection()),
                this.localShapeCollection.addShape(this.v),
                (this.paths = this.localShapeCollection),
                this.dynamicProperties.length
                  ? (this.k = !0)
                  : ((this.k = !1), this.convertToPath());
            }
            return (
              (t.prototype = {
                reset: r,
                getValue: function () {
                  this.elem.globalData.frameId !== this.frameId &&
                    ((this.frameId = this.elem.globalData.frameId),
                    this.iterateDynamicProperties(),
                    this._mdf && this.convertToPath());
                },
                convertStarToPath: function () {
                  var t,
                    e,
                    i,
                    r,
                    s = 2 * Math.floor(this.pt.v),
                    a = (2 * Math.PI) / s,
                    n = !0,
                    o = this.or.v,
                    h = this.ir.v,
                    l = this.os.v,
                    p = this.is.v,
                    f = (2 * Math.PI * o) / (2 * s),
                    m = (2 * Math.PI * h) / (2 * s),
                    c = -Math.PI / 2;
                  c += this.r.v;
                  var d = 3 === this.data.d ? -1 : 1;
                  for (this.v._length = 0, t = 0; t < s; t += 1) {
                    (i = n ? l : p), (r = n ? f : m);
                    var u = (e = n ? o : h) * Math.cos(c),
                      y = e * Math.sin(c),
                      g = 0 === u && 0 === y ? 0 : y / Math.sqrt(u * u + y * y),
                      v =
                        0 === u && 0 === y ? 0 : -u / Math.sqrt(u * u + y * y);
                    (u += +this.p.v[0]),
                      (y += +this.p.v[1]),
                      this.v.setTripleAt(
                        u,
                        y,
                        u - g * r * i * d,
                        y - v * r * i * d,
                        u + g * r * i * d,
                        y + v * r * i * d,
                        t,
                        !0
                      ),
                      (n = !n),
                      (c += a * d);
                  }
                },
                convertPolygonToPath: function () {
                  var t,
                    e = Math.floor(this.pt.v),
                    i = (2 * Math.PI) / e,
                    r = this.or.v,
                    s = this.os.v,
                    a = (2 * Math.PI * r) / (4 * e),
                    n = 0.5 * -Math.PI,
                    o = 3 === this.data.d ? -1 : 1;
                  for (
                    n += this.r.v, this.v._length = 0, t = 0;
                    t < e;
                    t += 1
                  ) {
                    var h = r * Math.cos(n),
                      l = r * Math.sin(n),
                      p = 0 === h && 0 === l ? 0 : l / Math.sqrt(h * h + l * l),
                      f =
                        0 === h && 0 === l ? 0 : -h / Math.sqrt(h * h + l * l);
                    (h += +this.p.v[0]),
                      (l += +this.p.v[1]),
                      this.v.setTripleAt(
                        h,
                        l,
                        h - p * a * s * o,
                        l - f * a * s * o,
                        h + p * a * s * o,
                        l + f * a * s * o,
                        t,
                        !0
                      ),
                      (n += i * o);
                  }
                  (this.paths.length = 0), (this.paths[0] = this.v);
                },
              }),
              extendPrototype([DynamicPropertyContainer], t),
              t
            );
          })(),
          f = (function () {
            function t(t, e) {
              (this.v = shapePool.newElement()),
                (this.v.c = !0),
                (this.localShapeCollection =
                  shapeCollectionPool.newShapeCollection()),
                this.localShapeCollection.addShape(this.v),
                (this.paths = this.localShapeCollection),
                (this.elem = t),
                (this.comp = t.comp),
                (this.frameId = -1),
                (this.d = e.d),
                this.initDynamicPropertyContainer(t),
                (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                (this.s = PropertyFactory.getProp(t, e.s, 1, 0, this)),
                (this.r = PropertyFactory.getProp(t, e.r, 0, 0, this)),
                this.dynamicProperties.length
                  ? (this.k = !0)
                  : ((this.k = !1), this.convertRectToPath());
            }
            return (
              (t.prototype = {
                convertRectToPath: function () {
                  var t = this.p.v[0],
                    e = this.p.v[1],
                    i = this.s.v[0] / 2,
                    r = this.s.v[1] / 2,
                    s = bmMin(i, r, this.r.v),
                    a = s * (1 - roundCorner);
                  (this.v._length = 0),
                    2 === this.d || 1 === this.d
                      ? (this.v.setTripleAt(
                          t + i,
                          e - r + s,
                          t + i,
                          e - r + s,
                          t + i,
                          e - r + a,
                          0,
                          !0
                        ),
                        this.v.setTripleAt(
                          t + i,
                          e + r - s,
                          t + i,
                          e + r - a,
                          t + i,
                          e + r - s,
                          1,
                          !0
                        ),
                        0 !== s
                          ? (this.v.setTripleAt(
                              t + i - s,
                              e + r,
                              t + i - s,
                              e + r,
                              t + i - a,
                              e + r,
                              2,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - i + s,
                              e + r,
                              t - i + a,
                              e + r,
                              t - i + s,
                              e + r,
                              3,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - i,
                              e + r - s,
                              t - i,
                              e + r - s,
                              t - i,
                              e + r - a,
                              4,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - i,
                              e - r + s,
                              t - i,
                              e - r + a,
                              t - i,
                              e - r + s,
                              5,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - i + s,
                              e - r,
                              t - i + s,
                              e - r,
                              t - i + a,
                              e - r,
                              6,
                              !0
                            ),
                            this.v.setTripleAt(
                              t + i - s,
                              e - r,
                              t + i - a,
                              e - r,
                              t + i - s,
                              e - r,
                              7,
                              !0
                            ))
                          : (this.v.setTripleAt(
                              t - i,
                              e + r,
                              t - i + a,
                              e + r,
                              t - i,
                              e + r,
                              2
                            ),
                            this.v.setTripleAt(
                              t - i,
                              e - r,
                              t - i,
                              e - r + a,
                              t - i,
                              e - r,
                              3
                            )))
                      : (this.v.setTripleAt(
                          t + i,
                          e - r + s,
                          t + i,
                          e - r + a,
                          t + i,
                          e - r + s,
                          0,
                          !0
                        ),
                        0 !== s
                          ? (this.v.setTripleAt(
                              t + i - s,
                              e - r,
                              t + i - s,
                              e - r,
                              t + i - a,
                              e - r,
                              1,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - i + s,
                              e - r,
                              t - i + a,
                              e - r,
                              t - i + s,
                              e - r,
                              2,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - i,
                              e - r + s,
                              t - i,
                              e - r + s,
                              t - i,
                              e - r + a,
                              3,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - i,
                              e + r - s,
                              t - i,
                              e + r - a,
                              t - i,
                              e + r - s,
                              4,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - i + s,
                              e + r,
                              t - i + s,
                              e + r,
                              t - i + a,
                              e + r,
                              5,
                              !0
                            ),
                            this.v.setTripleAt(
                              t + i - s,
                              e + r,
                              t + i - a,
                              e + r,
                              t + i - s,
                              e + r,
                              6,
                              !0
                            ),
                            this.v.setTripleAt(
                              t + i,
                              e + r - s,
                              t + i,
                              e + r - s,
                              t + i,
                              e + r - a,
                              7,
                              !0
                            ))
                          : (this.v.setTripleAt(
                              t - i,
                              e - r,
                              t - i + a,
                              e - r,
                              t - i,
                              e - r,
                              1,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - i,
                              e + r,
                              t - i,
                              e + r - a,
                              t - i,
                              e + r,
                              2,
                              !0
                            ),
                            this.v.setTripleAt(
                              t + i,
                              e + r,
                              t + i - a,
                              e + r,
                              t + i,
                              e + r,
                              3,
                              !0
                            )));
                },
                getValue: function () {
                  this.elem.globalData.frameId !== this.frameId &&
                    ((this.frameId = this.elem.globalData.frameId),
                    this.iterateDynamicProperties(),
                    this._mdf && this.convertRectToPath());
                },
                reset: r,
              }),
              extendPrototype([DynamicPropertyContainer], t),
              t
            );
          })();
        var m = {
          getShapeProp: function (t, e, i) {
            var r;
            return (
              3 === i || 4 === i
                ? (r = (3 === i ? e.pt : e.ks).k.length
                    ? new h(t, e, i)
                    : new n(t, e, i))
                : 5 === i
                ? (r = new f(t, e))
                : 6 === i
                ? (r = new l(t, e))
                : 7 === i && (r = new p(t, e)),
              r.k && t.addDynamicProperty(r),
              r
            );
          },
          getConstructorFunction: function () {
            return n;
          },
          getKeyframedConstructorFunction: function () {
            return h;
          },
        };
        return m;
      })(),
      Matrix = (function () {
        var t = Math.cos,
          e = Math.sin,
          i = Math.tan,
          r = Math.round;
        function s() {
          return (
            (this.props[0] = 1),
            (this.props[1] = 0),
            (this.props[2] = 0),
            (this.props[3] = 0),
            (this.props[4] = 0),
            (this.props[5] = 1),
            (this.props[6] = 0),
            (this.props[7] = 0),
            (this.props[8] = 0),
            (this.props[9] = 0),
            (this.props[10] = 1),
            (this.props[11] = 0),
            (this.props[12] = 0),
            (this.props[13] = 0),
            (this.props[14] = 0),
            (this.props[15] = 1),
            this
          );
        }
        function a(i) {
          if (0 === i) return this;
          var r = t(i),
            s = e(i);
          return this._t(r, -s, 0, 0, s, r, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function n(i) {
          if (0 === i) return this;
          var r = t(i),
            s = e(i);
          return this._t(1, 0, 0, 0, 0, r, -s, 0, 0, s, r, 0, 0, 0, 0, 1);
        }
        function o(i) {
          if (0 === i) return this;
          var r = t(i),
            s = e(i);
          return this._t(r, 0, s, 0, 0, 1, 0, 0, -s, 0, r, 0, 0, 0, 0, 1);
        }
        function h(i) {
          if (0 === i) return this;
          var r = t(i),
            s = e(i);
          return this._t(r, -s, 0, 0, s, r, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function l(t, e) {
          return this._t(1, e, t, 1, 0, 0);
        }
        function p(t, e) {
          return this.shear(i(t), i(e));
        }
        function f(r, s) {
          var a = t(s),
            n = e(s);
          return this._t(a, n, 0, 0, -n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
            ._t(1, 0, 0, 0, i(r), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
            ._t(a, -n, 0, 0, n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function m(t, e, i) {
          return (
            i || 0 === i || (i = 1),
            1 === t && 1 === e && 1 === i
              ? this
              : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1)
          );
        }
        function c(t, e, i, r, s, a, n, o, h, l, p, f, m, c, d, u) {
          return (
            (this.props[0] = t),
            (this.props[1] = e),
            (this.props[2] = i),
            (this.props[3] = r),
            (this.props[4] = s),
            (this.props[5] = a),
            (this.props[6] = n),
            (this.props[7] = o),
            (this.props[8] = h),
            (this.props[9] = l),
            (this.props[10] = p),
            (this.props[11] = f),
            (this.props[12] = m),
            (this.props[13] = c),
            (this.props[14] = d),
            (this.props[15] = u),
            this
          );
        }
        function d(t, e, i) {
          return (
            (i = i || 0),
            0 !== t || 0 !== e || 0 !== i
              ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, i, 1)
              : this
          );
        }
        function u(t, e, i, r, s, a, n, o, h, l, p, f, m, c, d, u) {
          var y = this.props;
          if (
            1 === t &&
            0 === e &&
            0 === i &&
            0 === r &&
            0 === s &&
            1 === a &&
            0 === n &&
            0 === o &&
            0 === h &&
            0 === l &&
            1 === p &&
            0 === f
          )
            return (
              (y[12] = y[12] * t + y[15] * m),
              (y[13] = y[13] * a + y[15] * c),
              (y[14] = y[14] * p + y[15] * d),
              (y[15] *= u),
              (this._identityCalculated = !1),
              this
            );
          var g = y[0],
            v = y[1],
            b = y[2],
            x = y[3],
            P = y[4],
            E = y[5],
            S = y[6],
            C = y[7],
            _ = y[8],
            A = y[9],
            T = y[10],
            M = y[11],
            k = y[12],
            D = y[13],
            F = y[14],
            w = y[15];
          return (
            (y[0] = g * t + v * s + b * h + x * m),
            (y[1] = g * e + v * a + b * l + x * c),
            (y[2] = g * i + v * n + b * p + x * d),
            (y[3] = g * r + v * o + b * f + x * u),
            (y[4] = P * t + E * s + S * h + C * m),
            (y[5] = P * e + E * a + S * l + C * c),
            (y[6] = P * i + E * n + S * p + C * d),
            (y[7] = P * r + E * o + S * f + C * u),
            (y[8] = _ * t + A * s + T * h + M * m),
            (y[9] = _ * e + A * a + T * l + M * c),
            (y[10] = _ * i + A * n + T * p + M * d),
            (y[11] = _ * r + A * o + T * f + M * u),
            (y[12] = k * t + D * s + F * h + w * m),
            (y[13] = k * e + D * a + F * l + w * c),
            (y[14] = k * i + D * n + F * p + w * d),
            (y[15] = k * r + D * o + F * f + w * u),
            (this._identityCalculated = !1),
            this
          );
        }
        function y(t) {
          var e = t.props;
          return this.transform(
            e[0],
            e[1],
            e[2],
            e[3],
            e[4],
            e[5],
            e[6],
            e[7],
            e[8],
            e[9],
            e[10],
            e[11],
            e[12],
            e[13],
            e[14],
            e[15]
          );
        }
        function g() {
          return (
            this._identityCalculated ||
              ((this._identity = !(
                1 !== this.props[0] ||
                0 !== this.props[1] ||
                0 !== this.props[2] ||
                0 !== this.props[3] ||
                0 !== this.props[4] ||
                1 !== this.props[5] ||
                0 !== this.props[6] ||
                0 !== this.props[7] ||
                0 !== this.props[8] ||
                0 !== this.props[9] ||
                1 !== this.props[10] ||
                0 !== this.props[11] ||
                0 !== this.props[12] ||
                0 !== this.props[13] ||
                0 !== this.props[14] ||
                1 !== this.props[15]
              )),
              (this._identityCalculated = !0)),
            this._identity
          );
        }
        function v(t) {
          for (var e = 0; e < 16; ) {
            if (t.props[e] !== this.props[e]) return !1;
            e += 1;
          }
          return !0;
        }
        function b(t) {
          var e;
          for (e = 0; e < 16; e += 1) t.props[e] = this.props[e];
          return t;
        }
        function x(t) {
          var e;
          for (e = 0; e < 16; e += 1) this.props[e] = t[e];
        }
        function P(t, e, i) {
          return {
            x:
              t * this.props[0] +
              e * this.props[4] +
              i * this.props[8] +
              this.props[12],
            y:
              t * this.props[1] +
              e * this.props[5] +
              i * this.props[9] +
              this.props[13],
            z:
              t * this.props[2] +
              e * this.props[6] +
              i * this.props[10] +
              this.props[14],
          };
        }
        function E(t, e, i) {
          return (
            t * this.props[0] +
            e * this.props[4] +
            i * this.props[8] +
            this.props[12]
          );
        }
        function S(t, e, i) {
          return (
            t * this.props[1] +
            e * this.props[5] +
            i * this.props[9] +
            this.props[13]
          );
        }
        function C(t, e, i) {
          return (
            t * this.props[2] +
            e * this.props[6] +
            i * this.props[10] +
            this.props[14]
          );
        }
        function _() {
          var t = this.props[0] * this.props[5] - this.props[1] * this.props[4],
            e = this.props[5] / t,
            i = -this.props[1] / t,
            r = -this.props[4] / t,
            s = this.props[0] / t,
            a =
              (this.props[4] * this.props[13] -
                this.props[5] * this.props[12]) /
              t,
            n =
              -(
                this.props[0] * this.props[13] -
                this.props[1] * this.props[12]
              ) / t,
            o = new Matrix();
          return (
            (o.props[0] = e),
            (o.props[1] = i),
            (o.props[4] = r),
            (o.props[5] = s),
            (o.props[12] = a),
            (o.props[13] = n),
            o
          );
        }
        function A(t) {
          return this.getInverseMatrix().applyToPointArray(
            t[0],
            t[1],
            t[2] || 0
          );
        }
        function T(t) {
          var e,
            i = t.length,
            r = [];
          for (e = 0; e < i; e += 1) r[e] = A(t[e]);
          return r;
        }
        function M(t, e, i) {
          var r = createTypedArray("float32", 6);
          if (this.isIdentity())
            (r[0] = t[0]),
              (r[1] = t[1]),
              (r[2] = e[0]),
              (r[3] = e[1]),
              (r[4] = i[0]),
              (r[5] = i[1]);
          else {
            var s = this.props[0],
              a = this.props[1],
              n = this.props[4],
              o = this.props[5],
              h = this.props[12],
              l = this.props[13];
            (r[0] = t[0] * s + t[1] * n + h),
              (r[1] = t[0] * a + t[1] * o + l),
              (r[2] = e[0] * s + e[1] * n + h),
              (r[3] = e[0] * a + e[1] * o + l),
              (r[4] = i[0] * s + i[1] * n + h),
              (r[5] = i[0] * a + i[1] * o + l);
          }
          return r;
        }
        function k(t, e, i) {
          return this.isIdentity()
            ? [t, e, i]
            : [
                t * this.props[0] +
                  e * this.props[4] +
                  i * this.props[8] +
                  this.props[12],
                t * this.props[1] +
                  e * this.props[5] +
                  i * this.props[9] +
                  this.props[13],
                t * this.props[2] +
                  e * this.props[6] +
                  i * this.props[10] +
                  this.props[14],
              ];
        }
        function D(t, e) {
          if (this.isIdentity()) return t + "," + e;
          var i = this.props;
          return (
            Math.round(100 * (t * i[0] + e * i[4] + i[12])) / 100 +
            "," +
            Math.round(100 * (t * i[1] + e * i[5] + i[13])) / 100
          );
        }
        function F() {
          for (var t = 0, e = this.props, i = "matrix3d("; t < 16; )
            (i += r(1e4 * e[t]) / 1e4), (i += 15 === t ? ")" : ","), (t += 1);
          return i;
        }
        function w(t) {
          return (t < 1e-6 && t > 0) || (t > -1e-6 && t < 0)
            ? r(1e4 * t) / 1e4
            : t;
        }
        function I() {
          var t = this.props;
          return (
            "matrix(" +
            w(t[0]) +
            "," +
            w(t[1]) +
            "," +
            w(t[4]) +
            "," +
            w(t[5]) +
            "," +
            w(t[12]) +
            "," +
            w(t[13]) +
            ")"
          );
        }
        return function () {
          (this.reset = s),
            (this.rotate = a),
            (this.rotateX = n),
            (this.rotateY = o),
            (this.rotateZ = h),
            (this.skew = p),
            (this.skewFromAxis = f),
            (this.shear = l),
            (this.scale = m),
            (this.setTransform = c),
            (this.translate = d),
            (this.transform = u),
            (this.multiply = y),
            (this.applyToPoint = P),
            (this.applyToX = E),
            (this.applyToY = S),
            (this.applyToZ = C),
            (this.applyToPointArray = k),
            (this.applyToTriplePoints = M),
            (this.applyToPointStringified = D),
            (this.toCSS = F),
            (this.to2dCSS = I),
            (this.clone = b),
            (this.cloneFromProps = x),
            (this.equals = v),
            (this.inversePoints = T),
            (this.inversePoint = A),
            (this.getInverseMatrix = _),
            (this._t = this.transform),
            (this.isIdentity = g),
            (this._identity = !0),
            (this._identityCalculated = !1),
            (this.props = createTypedArray("float32", 16)),
            this.reset();
        };
      })();
    function _typeof$3(t) {
      return (
        (_typeof$3 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$3(t)
      );
    }
    var lottie = {},
      standalone = "__[STANDALONE]__",
      animationData = "__[ANIMATIONDATA]__",
      renderer = "";
    function setLocation(t) {
      setLocationHref(t);
    }
    function searchAnimations() {
      !0 === standalone
        ? animationManager.searchAnimations(animationData, standalone, renderer)
        : animationManager.searchAnimations();
    }
    function setSubframeRendering(t) {
      setSubframeEnabled(t);
    }
    function setPrefix(t) {
      setIdPrefix(t);
    }
    function loadAnimation(t) {
      return (
        !0 === standalone && (t.animationData = JSON.parse(animationData)),
        animationManager.loadAnimation(t)
      );
    }
    function setQuality(t) {
      if ("string" == typeof t)
        switch (t) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
        }
      else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
      getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
    }
    function inBrowser() {
      return "undefined" != typeof navigator;
    }
    function installPlugin(t, e) {
      "expressions" === t && setExpressionsPlugin(e);
    }
    function getFactory(t) {
      switch (t) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    function checkReady() {
      "complete" === document.readyState &&
        (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(t) {
      for (var e = queryString.split("&"), i = 0; i < e.length; i += 1) {
        var r = e[i].split("=");
        if (decodeURIComponent(r[0]) == t) return decodeURIComponent(r[1]);
      }
      return null;
    }
    (lottie.play = animationManager.play),
      (lottie.pause = animationManager.pause),
      (lottie.setLocationHref = setLocation),
      (lottie.togglePause = animationManager.togglePause),
      (lottie.setSpeed = animationManager.setSpeed),
      (lottie.setDirection = animationManager.setDirection),
      (lottie.stop = animationManager.stop),
      (lottie.searchAnimations = searchAnimations),
      (lottie.registerAnimation = animationManager.registerAnimation),
      (lottie.loadAnimation = loadAnimation),
      (lottie.setSubframeRendering = setSubframeRendering),
      (lottie.resize = animationManager.resize),
      (lottie.goToAndStop = animationManager.goToAndStop),
      (lottie.destroy = animationManager.destroy),
      (lottie.setQuality = setQuality),
      (lottie.inBrowser = inBrowser),
      (lottie.installPlugin = installPlugin),
      (lottie.freeze = animationManager.freeze),
      (lottie.unfreeze = animationManager.unfreeze),
      (lottie.setVolume = animationManager.setVolume),
      (lottie.mute = animationManager.mute),
      (lottie.unmute = animationManager.unmute),
      (lottie.getRegisteredAnimations =
        animationManager.getRegisteredAnimations),
      (lottie.useWebWorker = setWebWorker),
      (lottie.setIDPrefix = setPrefix),
      (lottie.__getFactory = getFactory),
      (lottie.version = "5.12.2");
    var queryString = "";
    if (standalone) {
      var scripts = document.getElementsByTagName("script"),
        index = scripts.length - 1,
        myScript = scripts[index] || { src: "" };
      (queryString = myScript.src
        ? myScript.src.replace(/^[^\?]+\??/, "")
        : ""),
        (renderer = getQueryVariable("renderer"));
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      ("object" ===
        ("undefined" == typeof exports ? "undefined" : _typeof$3(exports)) &&
        "undefined" != typeof module) ||
        ("function" == typeof define && define.amd) ||
        (window.bodymovin = lottie);
    } catch (t) {}
    var ShapeModifiers = (function () {
      var t = {},
        e = {};
      return (
        (t.registerModifier = function (t, i) {
          e[t] || (e[t] = i);
        }),
        (t.getModifier = function (t, i, r) {
          return new e[t](i, r);
        }),
        t
      );
    })();
    function ShapeModifier() {}
    function TrimModifier() {}
    function PuckerAndBloatModifier() {}
    (ShapeModifier.prototype.initModifierProperties = function () {}),
      (ShapeModifier.prototype.addShapeToModifier = function () {}),
      (ShapeModifier.prototype.addShape = function (t) {
        if (!this.closed) {
          t.sh.container.addDynamicProperty(t.sh);
          var e = {
            shape: t.sh,
            data: t,
            localShapeCollection: shapeCollectionPool.newShapeCollection(),
          };
          this.shapes.push(e),
            this.addShapeToModifier(e),
            this._isAnimated && t.setAsAnimated();
        }
      }),
      (ShapeModifier.prototype.init = function (t, e) {
        (this.shapes = []),
          (this.elem = t),
          this.initDynamicPropertyContainer(t),
          this.initModifierProperties(t, e),
          (this.frameId = initialDefaultFrame),
          (this.closed = !1),
          (this.k = !1),
          this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
      }),
      (ShapeModifier.prototype.processKeys = function () {
        this.elem.globalData.frameId !== this.frameId &&
          ((this.frameId = this.elem.globalData.frameId),
          this.iterateDynamicProperties());
      }),
      extendPrototype([DynamicPropertyContainer], ShapeModifier),
      extendPrototype([ShapeModifier], TrimModifier),
      (TrimModifier.prototype.initModifierProperties = function (t, e) {
        (this.s = PropertyFactory.getProp(t, e.s, 0, 0.01, this)),
          (this.e = PropertyFactory.getProp(t, e.e, 0, 0.01, this)),
          (this.o = PropertyFactory.getProp(t, e.o, 0, 0, this)),
          (this.sValue = 0),
          (this.eValue = 0),
          (this.getValue = this.processKeys),
          (this.m = e.m),
          (this._isAnimated =
            !!this.s.effectsSequence.length ||
            !!this.e.effectsSequence.length ||
            !!this.o.effectsSequence.length);
      }),
      (TrimModifier.prototype.addShapeToModifier = function (t) {
        t.pathsData = [];
      }),
      (TrimModifier.prototype.calculateShapeEdges = function (t, e, i, r, s) {
        var a = [];
        e <= 1
          ? a.push({ s: t, e: e })
          : t >= 1
          ? a.push({ s: t - 1, e: e - 1 })
          : (a.push({ s: t, e: 1 }), a.push({ s: 0, e: e - 1 }));
        var n,
          o,
          h = [],
          l = a.length;
        for (n = 0; n < l; n += 1) {
          var p, f;
          if (!((o = a[n]).e * s < r || o.s * s > r + i))
            (p = o.s * s <= r ? 0 : (o.s * s - r) / i),
              (f = o.e * s >= r + i ? 1 : (o.e * s - r) / i),
              h.push([p, f]);
        }
        return h.length || h.push([0, 0]), h;
      }),
      (TrimModifier.prototype.releasePathsData = function (t) {
        var e,
          i = t.length;
        for (e = 0; e < i; e += 1) segmentsLengthPool.release(t[e]);
        return (t.length = 0), t;
      }),
      (TrimModifier.prototype.processShapes = function (t) {
        var e, i, r, s;
        if (this._mdf || t) {
          var a = (this.o.v % 360) / 360;
          if (
            (a < 0 && (a += 1),
            (e = this.s.v > 1 ? 1 + a : this.s.v < 0 ? 0 + a : this.s.v + a) >
              (i = this.e.v > 1 ? 1 + a : this.e.v < 0 ? 0 + a : this.e.v + a))
          ) {
            var n = e;
            (e = i), (i = n);
          }
          (e = 1e-4 * Math.round(1e4 * e)),
            (i = 1e-4 * Math.round(1e4 * i)),
            (this.sValue = e),
            (this.eValue = i);
        } else (e = this.sValue), (i = this.eValue);
        var o,
          h,
          l,
          p,
          f,
          m = this.shapes.length,
          c = 0;
        if (i === e)
          for (s = 0; s < m; s += 1)
            this.shapes[s].localShapeCollection.releaseShapes(),
              (this.shapes[s].shape._mdf = !0),
              (this.shapes[s].shape.paths =
                this.shapes[s].localShapeCollection),
              this._mdf && (this.shapes[s].pathsData.length = 0);
        else if ((1 === i && 0 === e) || (0 === i && 1 === e)) {
          if (this._mdf)
            for (s = 0; s < m; s += 1)
              (this.shapes[s].pathsData.length = 0),
                (this.shapes[s].shape._mdf = !0);
        } else {
          var d,
            u,
            y = [];
          for (s = 0; s < m; s += 1)
            if (
              (d = this.shapes[s]).shape._mdf ||
              this._mdf ||
              t ||
              2 === this.m
            ) {
              if (
                ((h = (r = d.shape.paths)._length),
                (f = 0),
                !d.shape._mdf && d.pathsData.length)
              )
                f = d.totalShapeLength;
              else {
                for (
                  l = this.releasePathsData(d.pathsData), o = 0;
                  o < h;
                  o += 1
                )
                  (p = bez.getSegmentsLength(r.shapes[o])),
                    l.push(p),
                    (f += p.totalLength);
                (d.totalShapeLength = f), (d.pathsData = l);
              }
              (c += f), (d.shape._mdf = !0);
            } else d.shape.paths = d.localShapeCollection;
          var g,
            v = e,
            b = i,
            x = 0;
          for (s = m - 1; s >= 0; s -= 1)
            if ((d = this.shapes[s]).shape._mdf) {
              for (
                (u = d.localShapeCollection).releaseShapes(),
                  2 === this.m && m > 1
                    ? ((g = this.calculateShapeEdges(
                        e,
                        i,
                        d.totalShapeLength,
                        x,
                        c
                      )),
                      (x += d.totalShapeLength))
                    : (g = [[v, b]]),
                  h = g.length,
                  o = 0;
                o < h;
                o += 1
              ) {
                (v = g[o][0]),
                  (b = g[o][1]),
                  (y.length = 0),
                  b <= 1
                    ? y.push({
                        s: d.totalShapeLength * v,
                        e: d.totalShapeLength * b,
                      })
                    : v >= 1
                    ? y.push({
                        s: d.totalShapeLength * (v - 1),
                        e: d.totalShapeLength * (b - 1),
                      })
                    : (y.push({
                        s: d.totalShapeLength * v,
                        e: d.totalShapeLength,
                      }),
                      y.push({ s: 0, e: d.totalShapeLength * (b - 1) }));
                var P = this.addShapes(d, y[0]);
                if (y[0].s !== y[0].e) {
                  if (y.length > 1)
                    if (d.shape.paths.shapes[d.shape.paths._length - 1].c) {
                      var E = P.pop();
                      this.addPaths(P, u), (P = this.addShapes(d, y[1], E));
                    } else this.addPaths(P, u), (P = this.addShapes(d, y[1]));
                  this.addPaths(P, u);
                }
              }
              d.shape.paths = u;
            }
        }
      }),
      (TrimModifier.prototype.addPaths = function (t, e) {
        var i,
          r = t.length;
        for (i = 0; i < r; i += 1) e.addShape(t[i]);
      }),
      (TrimModifier.prototype.addSegment = function (t, e, i, r, s, a, n) {
        s.setXYAt(e[0], e[1], "o", a),
          s.setXYAt(i[0], i[1], "i", a + 1),
          n && s.setXYAt(t[0], t[1], "v", a),
          s.setXYAt(r[0], r[1], "v", a + 1);
      }),
      (TrimModifier.prototype.addSegmentFromArray = function (t, e, i, r) {
        e.setXYAt(t[1], t[5], "o", i),
          e.setXYAt(t[2], t[6], "i", i + 1),
          r && e.setXYAt(t[0], t[4], "v", i),
          e.setXYAt(t[3], t[7], "v", i + 1);
      }),
      (TrimModifier.prototype.addShapes = function (t, e, i) {
        var r,
          s,
          a,
          n,
          o,
          h,
          l,
          p,
          f = t.pathsData,
          m = t.shape.paths.shapes,
          c = t.shape.paths._length,
          d = 0,
          u = [],
          y = !0;
        for (
          i
            ? ((o = i._length), (p = i._length))
            : ((i = shapePool.newElement()), (o = 0), (p = 0)),
            u.push(i),
            r = 0;
          r < c;
          r += 1
        ) {
          for (
            h = f[r].lengths,
              i.c = m[r].c,
              a = m[r].c ? h.length : h.length + 1,
              s = 1;
            s < a;
            s += 1
          )
            if (d + (n = h[s - 1]).addedLength < e.s)
              (d += n.addedLength), (i.c = !1);
            else {
              if (d > e.e) {
                i.c = !1;
                break;
              }
              e.s <= d && e.e >= d + n.addedLength
                ? (this.addSegment(
                    m[r].v[s - 1],
                    m[r].o[s - 1],
                    m[r].i[s],
                    m[r].v[s],
                    i,
                    o,
                    y
                  ),
                  (y = !1))
                : ((l = bez.getNewSegment(
                    m[r].v[s - 1],
                    m[r].v[s],
                    m[r].o[s - 1],
                    m[r].i[s],
                    (e.s - d) / n.addedLength,
                    (e.e - d) / n.addedLength,
                    h[s - 1]
                  )),
                  this.addSegmentFromArray(l, i, o, y),
                  (y = !1),
                  (i.c = !1)),
                (d += n.addedLength),
                (o += 1);
            }
          if (m[r].c && h.length) {
            if (((n = h[s - 1]), d <= e.e)) {
              var g = h[s - 1].addedLength;
              e.s <= d && e.e >= d + g
                ? (this.addSegment(
                    m[r].v[s - 1],
                    m[r].o[s - 1],
                    m[r].i[0],
                    m[r].v[0],
                    i,
                    o,
                    y
                  ),
                  (y = !1))
                : ((l = bez.getNewSegment(
                    m[r].v[s - 1],
                    m[r].v[0],
                    m[r].o[s - 1],
                    m[r].i[0],
                    (e.s - d) / g,
                    (e.e - d) / g,
                    h[s - 1]
                  )),
                  this.addSegmentFromArray(l, i, o, y),
                  (y = !1),
                  (i.c = !1));
            } else i.c = !1;
            (d += n.addedLength), (o += 1);
          }
          if (
            (i._length &&
              (i.setXYAt(i.v[p][0], i.v[p][1], "i", p),
              i.setXYAt(
                i.v[i._length - 1][0],
                i.v[i._length - 1][1],
                "o",
                i._length - 1
              )),
            d > e.e)
          )
            break;
          r < c - 1 &&
            ((i = shapePool.newElement()), (y = !0), u.push(i), (o = 0));
        }
        return u;
      }),
      extendPrototype([ShapeModifier], PuckerAndBloatModifier),
      (PuckerAndBloatModifier.prototype.initModifierProperties = function (
        t,
        e
      ) {
        (this.getValue = this.processKeys),
          (this.amount = PropertyFactory.getProp(t, e.a, 0, null, this)),
          (this._isAnimated = !!this.amount.effectsSequence.length);
      }),
      (PuckerAndBloatModifier.prototype.processPath = function (t, e) {
        var i = e / 100,
          r = [0, 0],
          s = t._length,
          a = 0;
        for (a = 0; a < s; a += 1) (r[0] += t.v[a][0]), (r[1] += t.v[a][1]);
        (r[0] /= s), (r[1] /= s);
        var n,
          o,
          h,
          l,
          p,
          f,
          m = shapePool.newElement();
        for (m.c = t.c, a = 0; a < s; a += 1)
          (n = t.v[a][0] + (r[0] - t.v[a][0]) * i),
            (o = t.v[a][1] + (r[1] - t.v[a][1]) * i),
            (h = t.o[a][0] + (r[0] - t.o[a][0]) * -i),
            (l = t.o[a][1] + (r[1] - t.o[a][1]) * -i),
            (p = t.i[a][0] + (r[0] - t.i[a][0]) * -i),
            (f = t.i[a][1] + (r[1] - t.i[a][1]) * -i),
            m.setTripleAt(n, o, h, l, p, f, a);
        return m;
      }),
      (PuckerAndBloatModifier.prototype.processShapes = function (t) {
        var e,
          i,
          r,
          s,
          a,
          n,
          o = this.shapes.length,
          h = this.amount.v;
        if (0 !== h)
          for (i = 0; i < o; i += 1) {
            if (
              ((n = (a = this.shapes[i]).localShapeCollection),
              a.shape._mdf || this._mdf || t)
            )
              for (
                n.releaseShapes(),
                  a.shape._mdf = !0,
                  e = a.shape.paths.shapes,
                  s = a.shape.paths._length,
                  r = 0;
                r < s;
                r += 1
              )
                n.addShape(this.processPath(e[r], h));
            a.shape.paths = a.localShapeCollection;
          }
        this.dynamicProperties.length || (this._mdf = !1);
      });
    var TransformPropertyFactory = (function () {
      var t = [0, 0];
      function e(t, e, i) {
        if (
          ((this.elem = t),
          (this.frameId = -1),
          (this.propType = "transform"),
          (this.data = e),
          (this.v = new Matrix()),
          (this.pre = new Matrix()),
          (this.appliedTransformations = 0),
          this.initDynamicPropertyContainer(i || t),
          e.p && e.p.s
            ? ((this.px = PropertyFactory.getProp(t, e.p.x, 0, 0, this)),
              (this.py = PropertyFactory.getProp(t, e.p.y, 0, 0, this)),
              e.p.z &&
                (this.pz = PropertyFactory.getProp(t, e.p.z, 0, 0, this)))
            : (this.p = PropertyFactory.getProp(
                t,
                e.p || { k: [0, 0, 0] },
                1,
                0,
                this
              )),
          e.rx)
        ) {
          if (
            ((this.rx = PropertyFactory.getProp(t, e.rx, 0, degToRads, this)),
            (this.ry = PropertyFactory.getProp(t, e.ry, 0, degToRads, this)),
            (this.rz = PropertyFactory.getProp(t, e.rz, 0, degToRads, this)),
            e.or.k[0].ti)
          ) {
            var r,
              s = e.or.k.length;
            for (r = 0; r < s; r += 1)
              (e.or.k[r].to = null), (e.or.k[r].ti = null);
          }
          (this.or = PropertyFactory.getProp(t, e.or, 1, degToRads, this)),
            (this.or.sh = !0);
        } else
          this.r = PropertyFactory.getProp(
            t,
            e.r || { k: 0 },
            0,
            degToRads,
            this
          );
        e.sk &&
          ((this.sk = PropertyFactory.getProp(t, e.sk, 0, degToRads, this)),
          (this.sa = PropertyFactory.getProp(t, e.sa, 0, degToRads, this))),
          (this.a = PropertyFactory.getProp(
            t,
            e.a || { k: [0, 0, 0] },
            1,
            0,
            this
          )),
          (this.s = PropertyFactory.getProp(
            t,
            e.s || { k: [100, 100, 100] },
            1,
            0.01,
            this
          )),
          e.o
            ? (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, t))
            : (this.o = { _mdf: !1, v: 1 }),
          (this._isDirty = !0),
          this.dynamicProperties.length || this.getValue(!0);
      }
      return (
        (e.prototype = {
          applyToMatrix: function (t) {
            var e = this._mdf;
            this.iterateDynamicProperties(),
              (this._mdf = this._mdf || e),
              this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
              this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
              this.sk && t.skewFromAxis(-this.sk.v, this.sa.v),
              this.r
                ? t.rotate(-this.r.v)
                : t
                    .rotateZ(-this.rz.v)
                    .rotateY(this.ry.v)
                    .rotateX(this.rx.v)
                    .rotateZ(-this.or.v[2])
                    .rotateY(this.or.v[1])
                    .rotateX(this.or.v[0]),
              this.data.p.s
                ? this.data.p.z
                  ? t.translate(this.px.v, this.py.v, -this.pz.v)
                  : t.translate(this.px.v, this.py.v, 0)
                : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          },
          getValue: function (e) {
            if (this.elem.globalData.frameId !== this.frameId) {
              if (
                (this._isDirty &&
                  (this.precalculateMatrix(), (this._isDirty = !1)),
                this.iterateDynamicProperties(),
                this._mdf || e)
              ) {
                var i;
                if (
                  (this.v.cloneFromProps(this.pre.props),
                  this.appliedTransformations < 1 &&
                    this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                  this.appliedTransformations < 2 &&
                    this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                  this.sk &&
                    this.appliedTransformations < 3 &&
                    this.v.skewFromAxis(-this.sk.v, this.sa.v),
                  this.r && this.appliedTransformations < 4
                    ? this.v.rotate(-this.r.v)
                    : !this.r &&
                      this.appliedTransformations < 4 &&
                      this.v
                        .rotateZ(-this.rz.v)
                        .rotateY(this.ry.v)
                        .rotateX(this.rx.v)
                        .rotateZ(-this.or.v[2])
                        .rotateY(this.or.v[1])
                        .rotateX(this.or.v[0]),
                  this.autoOriented)
                ) {
                  var r, s;
                  if (
                    ((i = this.elem.globalData.frameRate),
                    this.p && this.p.keyframes && this.p.getValueAtTime)
                  )
                    this.p._caching.lastFrame + this.p.offsetTime <=
                    this.p.keyframes[0].t
                      ? ((r = this.p.getValueAtTime(
                          (this.p.keyframes[0].t + 0.01) / i,
                          0
                        )),
                        (s = this.p.getValueAtTime(
                          this.p.keyframes[0].t / i,
                          0
                        )))
                      : this.p._caching.lastFrame + this.p.offsetTime >=
                        this.p.keyframes[this.p.keyframes.length - 1].t
                      ? ((r = this.p.getValueAtTime(
                          this.p.keyframes[this.p.keyframes.length - 1].t / i,
                          0
                        )),
                        (s = this.p.getValueAtTime(
                          (this.p.keyframes[this.p.keyframes.length - 1].t -
                            0.05) /
                            i,
                          0
                        )))
                      : ((r = this.p.pv),
                        (s = this.p.getValueAtTime(
                          (this.p._caching.lastFrame +
                            this.p.offsetTime -
                            0.01) /
                            i,
                          this.p.offsetTime
                        )));
                  else if (
                    this.px &&
                    this.px.keyframes &&
                    this.py.keyframes &&
                    this.px.getValueAtTime &&
                    this.py.getValueAtTime
                  ) {
                    (r = []), (s = []);
                    var a = this.px,
                      n = this.py;
                    a._caching.lastFrame + a.offsetTime <= a.keyframes[0].t
                      ? ((r[0] = a.getValueAtTime(
                          (a.keyframes[0].t + 0.01) / i,
                          0
                        )),
                        (r[1] = n.getValueAtTime(
                          (n.keyframes[0].t + 0.01) / i,
                          0
                        )),
                        (s[0] = a.getValueAtTime(a.keyframes[0].t / i, 0)),
                        (s[1] = n.getValueAtTime(n.keyframes[0].t / i, 0)))
                      : a._caching.lastFrame + a.offsetTime >=
                        a.keyframes[a.keyframes.length - 1].t
                      ? ((r[0] = a.getValueAtTime(
                          a.keyframes[a.keyframes.length - 1].t / i,
                          0
                        )),
                        (r[1] = n.getValueAtTime(
                          n.keyframes[n.keyframes.length - 1].t / i,
                          0
                        )),
                        (s[0] = a.getValueAtTime(
                          (a.keyframes[a.keyframes.length - 1].t - 0.01) / i,
                          0
                        )),
                        (s[1] = n.getValueAtTime(
                          (n.keyframes[n.keyframes.length - 1].t - 0.01) / i,
                          0
                        )))
                      : ((r = [a.pv, n.pv]),
                        (s[0] = a.getValueAtTime(
                          (a._caching.lastFrame + a.offsetTime - 0.01) / i,
                          a.offsetTime
                        )),
                        (s[1] = n.getValueAtTime(
                          (n._caching.lastFrame + n.offsetTime - 0.01) / i,
                          n.offsetTime
                        )));
                  } else r = s = t;
                  this.v.rotate(-Math.atan2(r[1] - s[1], r[0] - s[0]));
                }
                this.data.p && this.data.p.s
                  ? this.data.p.z
                    ? this.v.translate(this.px.v, this.py.v, -this.pz.v)
                    : this.v.translate(this.px.v, this.py.v, 0)
                  : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
              }
              this.frameId = this.elem.globalData.frameId;
            }
          },
          precalculateMatrix: function () {
            if (
              ((this.appliedTransformations = 0),
              this.pre.reset(),
              !this.a.effectsSequence.length &&
                (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                (this.appliedTransformations = 1),
                !this.s.effectsSequence.length))
            ) {
              if (
                (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                (this.appliedTransformations = 2),
                this.sk)
              ) {
                if (
                  this.sk.effectsSequence.length ||
                  this.sa.effectsSequence.length
                )
                  return;
                this.pre.skewFromAxis(-this.sk.v, this.sa.v),
                  (this.appliedTransformations = 3);
              }
              this.r
                ? this.r.effectsSequence.length ||
                  (this.pre.rotate(-this.r.v),
                  (this.appliedTransformations = 4))
                : this.rz.effectsSequence.length ||
                  this.ry.effectsSequence.length ||
                  this.rx.effectsSequence.length ||
                  this.or.effectsSequence.length ||
                  (this.pre
                    .rotateZ(-this.rz.v)
                    .rotateY(this.ry.v)
                    .rotateX(this.rx.v)
                    .rotateZ(-this.or.v[2])
                    .rotateY(this.or.v[1])
                    .rotateX(this.or.v[0]),
                  (this.appliedTransformations = 4));
            }
          },
          autoOrient: function () {},
        }),
        extendPrototype([DynamicPropertyContainer], e),
        (e.prototype.addDynamicProperty = function (t) {
          this._addDynamicProperty(t),
            this.elem.addDynamicProperty(t),
            (this._isDirty = !0);
        }),
        (e.prototype._addDynamicProperty =
          DynamicPropertyContainer.prototype.addDynamicProperty),
        {
          getTransformProperty: function (t, i, r) {
            return new e(t, i, r);
          },
        }
      );
    })();
    function RepeaterModifier() {}
    function RoundCornersModifier() {}
    function floatEqual(t, e) {
      return 1e5 * Math.abs(t - e) <= Math.min(Math.abs(t), Math.abs(e));
    }
    function floatZero(t) {
      return Math.abs(t) <= 1e-5;
    }
    function lerp(t, e, i) {
      return t * (1 - i) + e * i;
    }
    function lerpPoint(t, e, i) {
      return [lerp(t[0], e[0], i), lerp(t[1], e[1], i)];
    }
    function quadRoots(t, e, i) {
      if (0 === t) return [];
      var r = e * e - 4 * t * i;
      if (r < 0) return [];
      var s = -e / (2 * t);
      if (0 === r) return [s];
      var a = Math.sqrt(r) / (2 * t);
      return [s - a, s + a];
    }
    function polynomialCoefficients(t, e, i, r) {
      return [3 * e - t - 3 * i + r, 3 * t - 6 * e + 3 * i, -3 * t + 3 * e, t];
    }
    function singlePoint(t) {
      return new PolynomialBezier(t, t, t, t, !1);
    }
    function PolynomialBezier(t, e, i, r, s) {
      s && pointEqual(t, e) && (e = lerpPoint(t, r, 1 / 3)),
        s && pointEqual(i, r) && (i = lerpPoint(t, r, 2 / 3));
      var a = polynomialCoefficients(t[0], e[0], i[0], r[0]),
        n = polynomialCoefficients(t[1], e[1], i[1], r[1]);
      (this.a = [a[0], n[0]]),
        (this.b = [a[1], n[1]]),
        (this.c = [a[2], n[2]]),
        (this.d = [a[3], n[3]]),
        (this.points = [t, e, i, r]);
    }
    function extrema(t, e) {
      var i = t.points[0][e],
        r = t.points[t.points.length - 1][e];
      if (i > r) {
        var s = r;
        (r = i), (i = s);
      }
      for (
        var a = quadRoots(3 * t.a[e], 2 * t.b[e], t.c[e]), n = 0;
        n < a.length;
        n += 1
      )
        if (a[n] > 0 && a[n] < 1) {
          var o = t.point(a[n])[e];
          o < i ? (i = o) : o > r && (r = o);
        }
      return { min: i, max: r };
    }
    function intersectData(t, e, i) {
      var r = t.boundingBox();
      return {
        cx: r.cx,
        cy: r.cy,
        width: r.width,
        height: r.height,
        bez: t,
        t: (e + i) / 2,
        t1: e,
        t2: i,
      };
    }
    function splitData(t) {
      var e = t.bez.split(0.5);
      return [intersectData(e[0], t.t1, t.t), intersectData(e[1], t.t, t.t2)];
    }
    function boxIntersect(t, e) {
      return (
        2 * Math.abs(t.cx - e.cx) < t.width + e.width &&
        2 * Math.abs(t.cy - e.cy) < t.height + e.height
      );
    }
    function intersectsImpl(t, e, i, r, s, a) {
      if (boxIntersect(t, e))
        if (
          i >= a ||
          (t.width <= r && t.height <= r && e.width <= r && e.height <= r)
        )
          s.push([t.t, e.t]);
        else {
          var n = splitData(t),
            o = splitData(e);
          intersectsImpl(n[0], o[0], i + 1, r, s, a),
            intersectsImpl(n[0], o[1], i + 1, r, s, a),
            intersectsImpl(n[1], o[0], i + 1, r, s, a),
            intersectsImpl(n[1], o[1], i + 1, r, s, a);
        }
    }
    function crossProduct(t, e) {
      return [
        t[1] * e[2] - t[2] * e[1],
        t[2] * e[0] - t[0] * e[2],
        t[0] * e[1] - t[1] * e[0],
      ];
    }
    function lineIntersection(t, e, i, r) {
      var s = [t[0], t[1], 1],
        a = [e[0], e[1], 1],
        n = [i[0], i[1], 1],
        o = [r[0], r[1], 1],
        h = crossProduct(crossProduct(s, a), crossProduct(n, o));
      return floatZero(h[2]) ? null : [h[0] / h[2], h[1] / h[2]];
    }
    function polarOffset(t, e, i) {
      return [t[0] + Math.cos(e) * i, t[1] - Math.sin(e) * i];
    }
    function pointDistance(t, e) {
      return Math.hypot(t[0] - e[0], t[1] - e[1]);
    }
    function pointEqual(t, e) {
      return floatEqual(t[0], e[0]) && floatEqual(t[1], e[1]);
    }
    function ZigZagModifier() {}
    function setPoint(t, e, i, r, s, a, n) {
      var o = i - Math.PI / 2,
        h = i + Math.PI / 2,
        l = e[0] + Math.cos(i) * r * s,
        p = e[1] - Math.sin(i) * r * s;
      t.setTripleAt(
        l,
        p,
        l + Math.cos(o) * a,
        p - Math.sin(o) * a,
        l + Math.cos(h) * n,
        p - Math.sin(h) * n,
        t.length()
      );
    }
    function getPerpendicularVector(t, e) {
      var i = [e[0] - t[0], e[1] - t[1]],
        r = 0.5 * -Math.PI;
      return [
        Math.cos(r) * i[0] - Math.sin(r) * i[1],
        Math.sin(r) * i[0] + Math.cos(r) * i[1],
      ];
    }
    function getProjectingAngle(t, e) {
      var i = 0 === e ? t.length() - 1 : e - 1,
        r = (e + 1) % t.length(),
        s = getPerpendicularVector(t.v[i], t.v[r]);
      return Math.atan2(0, 1) - Math.atan2(s[1], s[0]);
    }
    function zigZagCorner(t, e, i, r, s, a, n) {
      var o = getProjectingAngle(e, i),
        h = e.v[i % e._length],
        l = e.v[0 === i ? e._length - 1 : i - 1],
        p = e.v[(i + 1) % e._length],
        f =
          2 === a
            ? Math.sqrt(Math.pow(h[0] - l[0], 2) + Math.pow(h[1] - l[1], 2))
            : 0,
        m =
          2 === a
            ? Math.sqrt(Math.pow(h[0] - p[0], 2) + Math.pow(h[1] - p[1], 2))
            : 0;
      setPoint(
        t,
        e.v[i % e._length],
        o,
        n,
        r,
        m / (2 * (s + 1)),
        f / (2 * (s + 1)),
        a
      );
    }
    function zigZagSegment(t, e, i, r, s, a) {
      for (var n = 0; n < r; n += 1) {
        var o = (n + 1) / (r + 1),
          h =
            2 === s
              ? Math.sqrt(
                  Math.pow(e.points[3][0] - e.points[0][0], 2) +
                    Math.pow(e.points[3][1] - e.points[0][1], 2)
                )
              : 0,
          l = e.normalAngle(o);
        setPoint(
          t,
          e.point(o),
          l,
          a,
          i,
          h / (2 * (r + 1)),
          h / (2 * (r + 1)),
          s
        ),
          (a = -a);
      }
      return a;
    }
    function linearOffset(t, e, i) {
      var r = Math.atan2(e[0] - t[0], e[1] - t[1]);
      return [polarOffset(t, r, i), polarOffset(e, r, i)];
    }
    function offsetSegment(t, e) {
      var i, r, s, a, n, o, h;
      (i = (h = linearOffset(t.points[0], t.points[1], e))[0]),
        (r = h[1]),
        (s = (h = linearOffset(t.points[1], t.points[2], e))[0]),
        (a = h[1]),
        (n = (h = linearOffset(t.points[2], t.points[3], e))[0]),
        (o = h[1]);
      var l = lineIntersection(i, r, s, a);
      null === l && (l = r);
      var p = lineIntersection(n, o, s, a);
      return null === p && (p = n), new PolynomialBezier(i, l, p, o);
    }
    function joinLines(t, e, i, r, s) {
      var a = e.points[3],
        n = i.points[0];
      if (3 === r) return a;
      if (pointEqual(a, n)) return a;
      if (2 === r) {
        var o = -e.tangentAngle(1),
          h = -i.tangentAngle(0) + Math.PI,
          l = lineIntersection(
            a,
            polarOffset(a, o + Math.PI / 2, 100),
            n,
            polarOffset(n, o + Math.PI / 2, 100)
          ),
          p = l ? pointDistance(l, a) : pointDistance(a, n) / 2,
          f = polarOffset(a, o, 2 * p * roundCorner);
        return (
          t.setXYAt(f[0], f[1], "o", t.length() - 1),
          (f = polarOffset(n, h, 2 * p * roundCorner)),
          t.setTripleAt(n[0], n[1], n[0], n[1], f[0], f[1], t.length()),
          n
        );
      }
      var m = lineIntersection(
        pointEqual(a, e.points[2]) ? e.points[0] : e.points[2],
        a,
        n,
        pointEqual(n, i.points[1]) ? i.points[3] : i.points[1]
      );
      return m && pointDistance(m, a) < s
        ? (t.setTripleAt(m[0], m[1], m[0], m[1], m[0], m[1], t.length()), m)
        : a;
    }
    function getIntersection(t, e) {
      var i = t.intersections(e);
      return (
        i.length && floatEqual(i[0][0], 1) && i.shift(), i.length ? i[0] : null
      );
    }
    function pruneSegmentIntersection(t, e) {
      var i = t.slice(),
        r = e.slice(),
        s = getIntersection(t[t.length - 1], e[0]);
      return (
        s &&
          ((i[t.length - 1] = t[t.length - 1].split(s[0])[0]),
          (r[0] = e[0].split(s[1])[1])),
        t.length > 1 &&
        e.length > 1 &&
        (s = getIntersection(t[0], e[e.length - 1]))
          ? [[t[0].split(s[0])[0]], [e[e.length - 1].split(s[1])[1]]]
          : [i, r]
      );
    }
    function pruneIntersections(t) {
      for (var e, i = 1; i < t.length; i += 1)
        (e = pruneSegmentIntersection(t[i - 1], t[i])),
          (t[i - 1] = e[0]),
          (t[i] = e[1]);
      return (
        t.length > 1 &&
          ((e = pruneSegmentIntersection(t[t.length - 1], t[0])),
          (t[t.length - 1] = e[0]),
          (t[0] = e[1])),
        t
      );
    }
    function offsetSegmentSplit(t, e) {
      var i,
        r,
        s,
        a,
        n = t.inflectionPoints();
      if (0 === n.length) return [offsetSegment(t, e)];
      if (1 === n.length || floatEqual(n[1], 1))
        return (
          (i = (s = t.split(n[0]))[0]),
          (r = s[1]),
          [offsetSegment(i, e), offsetSegment(r, e)]
        );
      i = (s = t.split(n[0]))[0];
      var o = (n[1] - n[0]) / (1 - n[0]);
      return (
        (a = (s = s[1].split(o))[0]),
        (r = s[1]),
        [offsetSegment(i, e), offsetSegment(a, e), offsetSegment(r, e)]
      );
    }
    function OffsetPathModifier() {}
    function getFontProperties(t) {
      for (
        var e = t.fStyle ? t.fStyle.split(" ") : [],
          i = "normal",
          r = "normal",
          s = e.length,
          a = 0;
        a < s;
        a += 1
      )
        switch (e[a].toLowerCase()) {
          case "italic":
            r = "italic";
            break;
          case "bold":
            i = "700";
            break;
          case "black":
            i = "900";
            break;
          case "medium":
            i = "500";
            break;
          case "regular":
          case "normal":
            i = "400";
            break;
          case "light":
          case "thin":
            i = "200";
        }
      return { style: r, weight: t.fWeight || i };
    }
    extendPrototype([ShapeModifier], RepeaterModifier),
      (RepeaterModifier.prototype.initModifierProperties = function (t, e) {
        (this.getValue = this.processKeys),
          (this.c = PropertyFactory.getProp(t, e.c, 0, null, this)),
          (this.o = PropertyFactory.getProp(t, e.o, 0, null, this)),
          (this.tr = TransformPropertyFactory.getTransformProperty(
            t,
            e.tr,
            this
          )),
          (this.so = PropertyFactory.getProp(t, e.tr.so, 0, 0.01, this)),
          (this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, 0.01, this)),
          (this.data = e),
          this.dynamicProperties.length || this.getValue(!0),
          (this._isAnimated = !!this.dynamicProperties.length),
          (this.pMatrix = new Matrix()),
          (this.rMatrix = new Matrix()),
          (this.sMatrix = new Matrix()),
          (this.tMatrix = new Matrix()),
          (this.matrix = new Matrix());
      }),
      (RepeaterModifier.prototype.applyTransforms = function (
        t,
        e,
        i,
        r,
        s,
        a
      ) {
        var n = a ? -1 : 1,
          o = r.s.v[0] + (1 - r.s.v[0]) * (1 - s),
          h = r.s.v[1] + (1 - r.s.v[1]) * (1 - s);
        t.translate(r.p.v[0] * n * s, r.p.v[1] * n * s, r.p.v[2]),
          e.translate(-r.a.v[0], -r.a.v[1], r.a.v[2]),
          e.rotate(-r.r.v * n * s),
          e.translate(r.a.v[0], r.a.v[1], r.a.v[2]),
          i.translate(-r.a.v[0], -r.a.v[1], r.a.v[2]),
          i.scale(a ? 1 / o : o, a ? 1 / h : h),
          i.translate(r.a.v[0], r.a.v[1], r.a.v[2]);
      }),
      (RepeaterModifier.prototype.init = function (t, e, i, r) {
        for (
          this.elem = t,
            this.arr = e,
            this.pos = i,
            this.elemsData = r,
            this._currentCopies = 0,
            this._elements = [],
            this._groups = [],
            this.frameId = -1,
            this.initDynamicPropertyContainer(t),
            this.initModifierProperties(t, e[i]);
          i > 0;

        )
          (i -= 1), this._elements.unshift(e[i]);
        this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
      }),
      (RepeaterModifier.prototype.resetElements = function (t) {
        var e,
          i = t.length;
        for (e = 0; e < i; e += 1)
          (t[e]._processed = !1),
            "gr" === t[e].ty && this.resetElements(t[e].it);
      }),
      (RepeaterModifier.prototype.cloneElements = function (t) {
        var e = JSON.parse(JSON.stringify(t));
        return this.resetElements(e), e;
      }),
      (RepeaterModifier.prototype.changeGroupRender = function (t, e) {
        var i,
          r = t.length;
        for (i = 0; i < r; i += 1)
          (t[i]._render = e),
            "gr" === t[i].ty && this.changeGroupRender(t[i].it, e);
      }),
      (RepeaterModifier.prototype.processShapes = function (t) {
        var e,
          i,
          r,
          s,
          a,
          n = !1;
        if (this._mdf || t) {
          var o,
            h = Math.ceil(this.c.v);
          if (this._groups.length < h) {
            for (; this._groups.length < h; ) {
              var l = { it: this.cloneElements(this._elements), ty: "gr" };
              l.it.push({
                a: { a: 0, ix: 1, k: [0, 0] },
                nm: "Transform",
                o: { a: 0, ix: 7, k: 100 },
                p: { a: 0, ix: 2, k: [0, 0] },
                r: {
                  a: 1,
                  ix: 6,
                  k: [
                    { s: 0, e: 0, t: 0 },
                    { s: 0, e: 0, t: 1 },
                  ],
                },
                s: { a: 0, ix: 3, k: [100, 100] },
                sa: { a: 0, ix: 5, k: 0 },
                sk: { a: 0, ix: 4, k: 0 },
                ty: "tr",
              }),
                this.arr.splice(0, 0, l),
                this._groups.splice(0, 0, l),
                (this._currentCopies += 1);
            }
            this.elem.reloadShapes(), (n = !0);
          }
          for (a = 0, r = 0; r <= this._groups.length - 1; r += 1) {
            if (
              ((o = a < h),
              (this._groups[r]._render = o),
              this.changeGroupRender(this._groups[r].it, o),
              !o)
            ) {
              var p = this.elemsData[r].it,
                f = p[p.length - 1];
              0 !== f.transform.op.v
                ? ((f.transform.op._mdf = !0), (f.transform.op.v = 0))
                : (f.transform.op._mdf = !1);
            }
            a += 1;
          }
          this._currentCopies = h;
          var m = this.o.v,
            c = m % 1,
            d = m > 0 ? Math.floor(m) : Math.ceil(m),
            u = this.pMatrix.props,
            y = this.rMatrix.props,
            g = this.sMatrix.props;
          this.pMatrix.reset(),
            this.rMatrix.reset(),
            this.sMatrix.reset(),
            this.tMatrix.reset(),
            this.matrix.reset();
          var v,
            b,
            x = 0;
          if (m > 0) {
            for (; x < d; )
              this.applyTransforms(
                this.pMatrix,
                this.rMatrix,
                this.sMatrix,
                this.tr,
                1,
                !1
              ),
                (x += 1);
            c &&
              (this.applyTransforms(
                this.pMatrix,
                this.rMatrix,
                this.sMatrix,
                this.tr,
                c,
                !1
              ),
              (x += c));
          } else if (m < 0) {
            for (; x > d; )
              this.applyTransforms(
                this.pMatrix,
                this.rMatrix,
                this.sMatrix,
                this.tr,
                1,
                !0
              ),
                (x -= 1);
            c &&
              (this.applyTransforms(
                this.pMatrix,
                this.rMatrix,
                this.sMatrix,
                this.tr,
                -c,
                !0
              ),
              (x -= c));
          }
          for (
            r = 1 === this.data.m ? 0 : this._currentCopies - 1,
              s = 1 === this.data.m ? 1 : -1,
              a = this._currentCopies;
            a;

          ) {
            if (
              ((b = (i = (e = this.elemsData[r].it)[e.length - 1].transform
                .mProps.v.props).length),
              (e[e.length - 1].transform.mProps._mdf = !0),
              (e[e.length - 1].transform.op._mdf = !0),
              (e[e.length - 1].transform.op.v =
                1 === this._currentCopies
                  ? this.so.v
                  : this.so.v +
                    (this.eo.v - this.so.v) * (r / (this._currentCopies - 1))),
              0 !== x)
            ) {
              for (
                ((0 !== r && 1 === s) ||
                  (r !== this._currentCopies - 1 && -1 === s)) &&
                  this.applyTransforms(
                    this.pMatrix,
                    this.rMatrix,
                    this.sMatrix,
                    this.tr,
                    1,
                    !1
                  ),
                  this.matrix.transform(
                    y[0],
                    y[1],
                    y[2],
                    y[3],
                    y[4],
                    y[5],
                    y[6],
                    y[7],
                    y[8],
                    y[9],
                    y[10],
                    y[11],
                    y[12],
                    y[13],
                    y[14],
                    y[15]
                  ),
                  this.matrix.transform(
                    g[0],
                    g[1],
                    g[2],
                    g[3],
                    g[4],
                    g[5],
                    g[6],
                    g[7],
                    g[8],
                    g[9],
                    g[10],
                    g[11],
                    g[12],
                    g[13],
                    g[14],
                    g[15]
                  ),
                  this.matrix.transform(
                    u[0],
                    u[1],
                    u[2],
                    u[3],
                    u[4],
                    u[5],
                    u[6],
                    u[7],
                    u[8],
                    u[9],
                    u[10],
                    u[11],
                    u[12],
                    u[13],
                    u[14],
                    u[15]
                  ),
                  v = 0;
                v < b;
                v += 1
              )
                i[v] = this.matrix.props[v];
              this.matrix.reset();
            } else
              for (this.matrix.reset(), v = 0; v < b; v += 1)
                i[v] = this.matrix.props[v];
            (x += 1), (a -= 1), (r += s);
          }
        } else
          for (a = this._currentCopies, r = 0, s = 1; a; )
            (i = (e = this.elemsData[r].it)[e.length - 1].transform.mProps.v
              .props),
              (e[e.length - 1].transform.mProps._mdf = !1),
              (e[e.length - 1].transform.op._mdf = !1),
              (a -= 1),
              (r += s);
        return n;
      }),
      (RepeaterModifier.prototype.addShape = function () {}),
      extendPrototype([ShapeModifier], RoundCornersModifier),
      (RoundCornersModifier.prototype.initModifierProperties = function (t, e) {
        (this.getValue = this.processKeys),
          (this.rd = PropertyFactory.getProp(t, e.r, 0, null, this)),
          (this._isAnimated = !!this.rd.effectsSequence.length);
      }),
      (RoundCornersModifier.prototype.processPath = function (t, e) {
        var i,
          r = shapePool.newElement();
        r.c = t.c;
        var s,
          a,
          n,
          o,
          h,
          l,
          p,
          f,
          m,
          c,
          d,
          u,
          y = t._length,
          g = 0;
        for (i = 0; i < y; i += 1)
          (s = t.v[i]),
            (n = t.o[i]),
            (a = t.i[i]),
            s[0] === n[0] && s[1] === n[1] && s[0] === a[0] && s[1] === a[1]
              ? (0 !== i && i !== y - 1) || t.c
                ? ((o = 0 === i ? t.v[y - 1] : t.v[i - 1]),
                  (l = (h = Math.sqrt(
                    Math.pow(s[0] - o[0], 2) + Math.pow(s[1] - o[1], 2)
                  ))
                    ? Math.min(h / 2, e) / h
                    : 0),
                  (p = d = s[0] + (o[0] - s[0]) * l),
                  (f = u = s[1] - (s[1] - o[1]) * l),
                  (m = p - (p - s[0]) * roundCorner),
                  (c = f - (f - s[1]) * roundCorner),
                  r.setTripleAt(p, f, m, c, d, u, g),
                  (g += 1),
                  (o = i === y - 1 ? t.v[0] : t.v[i + 1]),
                  (l = (h = Math.sqrt(
                    Math.pow(s[0] - o[0], 2) + Math.pow(s[1] - o[1], 2)
                  ))
                    ? Math.min(h / 2, e) / h
                    : 0),
                  (p = m = s[0] + (o[0] - s[0]) * l),
                  (f = c = s[1] + (o[1] - s[1]) * l),
                  (d = p - (p - s[0]) * roundCorner),
                  (u = f - (f - s[1]) * roundCorner),
                  r.setTripleAt(p, f, m, c, d, u, g),
                  (g += 1))
                : (r.setTripleAt(s[0], s[1], n[0], n[1], a[0], a[1], g),
                  (g += 1))
              : (r.setTripleAt(
                  t.v[i][0],
                  t.v[i][1],
                  t.o[i][0],
                  t.o[i][1],
                  t.i[i][0],
                  t.i[i][1],
                  g
                ),
                (g += 1));
        return r;
      }),
      (RoundCornersModifier.prototype.processShapes = function (t) {
        var e,
          i,
          r,
          s,
          a,
          n,
          o = this.shapes.length,
          h = this.rd.v;
        if (0 !== h)
          for (i = 0; i < o; i += 1) {
            if (
              ((n = (a = this.shapes[i]).localShapeCollection),
              a.shape._mdf || this._mdf || t)
            )
              for (
                n.releaseShapes(),
                  a.shape._mdf = !0,
                  e = a.shape.paths.shapes,
                  s = a.shape.paths._length,
                  r = 0;
                r < s;
                r += 1
              )
                n.addShape(this.processPath(e[r], h));
            a.shape.paths = a.localShapeCollection;
          }
        this.dynamicProperties.length || (this._mdf = !1);
      }),
      (PolynomialBezier.prototype.point = function (t) {
        return [
          ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
          ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1],
        ];
      }),
      (PolynomialBezier.prototype.derivative = function (t) {
        return [
          (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
          (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1],
        ];
      }),
      (PolynomialBezier.prototype.tangentAngle = function (t) {
        var e = this.derivative(t);
        return Math.atan2(e[1], e[0]);
      }),
      (PolynomialBezier.prototype.normalAngle = function (t) {
        var e = this.derivative(t);
        return Math.atan2(e[0], e[1]);
      }),
      (PolynomialBezier.prototype.inflectionPoints = function () {
        var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(t)) return [];
        var e = (-0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1])) / t,
          i =
            e * e -
            ((1 / 3) * (this.b[1] * this.c[0] - this.b[0] * this.c[1])) / t;
        if (i < 0) return [];
        var r = Math.sqrt(i);
        return floatZero(r)
          ? r > 0 && r < 1
            ? [e]
            : []
          : [e - r, e + r].filter(function (t) {
              return t > 0 && t < 1;
            });
      }),
      (PolynomialBezier.prototype.split = function (t) {
        if (t <= 0) return [singlePoint(this.points[0]), this];
        if (t >= 1)
          return [this, singlePoint(this.points[this.points.length - 1])];
        var e = lerpPoint(this.points[0], this.points[1], t),
          i = lerpPoint(this.points[1], this.points[2], t),
          r = lerpPoint(this.points[2], this.points[3], t),
          s = lerpPoint(e, i, t),
          a = lerpPoint(i, r, t),
          n = lerpPoint(s, a, t);
        return [
          new PolynomialBezier(this.points[0], e, s, n, !0),
          new PolynomialBezier(n, a, r, this.points[3], !0),
        ];
      }),
      (PolynomialBezier.prototype.bounds = function () {
        return { x: extrema(this, 0), y: extrema(this, 1) };
      }),
      (PolynomialBezier.prototype.boundingBox = function () {
        var t = this.bounds();
        return {
          left: t.x.min,
          right: t.x.max,
          top: t.y.min,
          bottom: t.y.max,
          width: t.x.max - t.x.min,
          height: t.y.max - t.y.min,
          cx: (t.x.max + t.x.min) / 2,
          cy: (t.y.max + t.y.min) / 2,
        };
      }),
      (PolynomialBezier.prototype.intersections = function (t, e, i) {
        void 0 === e && (e = 2), void 0 === i && (i = 7);
        var r = [];
        return (
          intersectsImpl(
            intersectData(this, 0, 1),
            intersectData(t, 0, 1),
            0,
            e,
            r,
            i
          ),
          r
        );
      }),
      (PolynomialBezier.shapeSegment = function (t, e) {
        var i = (e + 1) % t.length();
        return new PolynomialBezier(t.v[e], t.o[e], t.i[i], t.v[i], !0);
      }),
      (PolynomialBezier.shapeSegmentInverted = function (t, e) {
        var i = (e + 1) % t.length();
        return new PolynomialBezier(t.v[i], t.i[i], t.o[e], t.v[e], !0);
      }),
      extendPrototype([ShapeModifier], ZigZagModifier),
      (ZigZagModifier.prototype.initModifierProperties = function (t, e) {
        (this.getValue = this.processKeys),
          (this.amplitude = PropertyFactory.getProp(t, e.s, 0, null, this)),
          (this.frequency = PropertyFactory.getProp(t, e.r, 0, null, this)),
          (this.pointsType = PropertyFactory.getProp(t, e.pt, 0, null, this)),
          (this._isAnimated =
            0 !== this.amplitude.effectsSequence.length ||
            0 !== this.frequency.effectsSequence.length ||
            0 !== this.pointsType.effectsSequence.length);
      }),
      (ZigZagModifier.prototype.processPath = function (t, e, i, r) {
        var s = t._length,
          a = shapePool.newElement();
        if (((a.c = t.c), t.c || (s -= 1), 0 === s)) return a;
        var n = -1,
          o = PolynomialBezier.shapeSegment(t, 0);
        zigZagCorner(a, t, 0, e, i, r, n);
        for (var h = 0; h < s; h += 1)
          (n = zigZagSegment(a, o, e, i, r, -n)),
            (o =
              h !== s - 1 || t.c
                ? PolynomialBezier.shapeSegment(t, (h + 1) % s)
                : null),
            zigZagCorner(a, t, h + 1, e, i, r, n);
        return a;
      }),
      (ZigZagModifier.prototype.processShapes = function (t) {
        var e,
          i,
          r,
          s,
          a,
          n,
          o = this.shapes.length,
          h = this.amplitude.v,
          l = Math.max(0, Math.round(this.frequency.v)),
          p = this.pointsType.v;
        if (0 !== h)
          for (i = 0; i < o; i += 1) {
            if (
              ((n = (a = this.shapes[i]).localShapeCollection),
              a.shape._mdf || this._mdf || t)
            )
              for (
                n.releaseShapes(),
                  a.shape._mdf = !0,
                  e = a.shape.paths.shapes,
                  s = a.shape.paths._length,
                  r = 0;
                r < s;
                r += 1
              )
                n.addShape(this.processPath(e[r], h, l, p));
            a.shape.paths = a.localShapeCollection;
          }
        this.dynamicProperties.length || (this._mdf = !1);
      }),
      extendPrototype([ShapeModifier], OffsetPathModifier),
      (OffsetPathModifier.prototype.initModifierProperties = function (t, e) {
        (this.getValue = this.processKeys),
          (this.amount = PropertyFactory.getProp(t, e.a, 0, null, this)),
          (this.miterLimit = PropertyFactory.getProp(t, e.ml, 0, null, this)),
          (this.lineJoin = e.lj),
          (this._isAnimated = 0 !== this.amount.effectsSequence.length);
      }),
      (OffsetPathModifier.prototype.processPath = function (t, e, i, r) {
        var s = shapePool.newElement();
        s.c = t.c;
        var a,
          n,
          o,
          h = t.length();
        t.c || (h -= 1);
        var l = [];
        for (a = 0; a < h; a += 1)
          (o = PolynomialBezier.shapeSegment(t, a)),
            l.push(offsetSegmentSplit(o, e));
        if (!t.c)
          for (a = h - 1; a >= 0; a -= 1)
            (o = PolynomialBezier.shapeSegmentInverted(t, a)),
              l.push(offsetSegmentSplit(o, e));
        l = pruneIntersections(l);
        var p = null,
          f = null;
        for (a = 0; a < l.length; a += 1) {
          var m = l[a];
          for (
            f && (p = joinLines(s, f, m[0], i, r)), f = m[m.length - 1], n = 0;
            n < m.length;
            n += 1
          )
            (o = m[n]),
              p && pointEqual(o.points[0], p)
                ? s.setXYAt(o.points[1][0], o.points[1][1], "o", s.length() - 1)
                : s.setTripleAt(
                    o.points[0][0],
                    o.points[0][1],
                    o.points[1][0],
                    o.points[1][1],
                    o.points[0][0],
                    o.points[0][1],
                    s.length()
                  ),
              s.setTripleAt(
                o.points[3][0],
                o.points[3][1],
                o.points[3][0],
                o.points[3][1],
                o.points[2][0],
                o.points[2][1],
                s.length()
              ),
              (p = o.points[3]);
        }
        return l.length && joinLines(s, f, l[0][0], i, r), s;
      }),
      (OffsetPathModifier.prototype.processShapes = function (t) {
        var e,
          i,
          r,
          s,
          a,
          n,
          o = this.shapes.length,
          h = this.amount.v,
          l = this.miterLimit.v,
          p = this.lineJoin;
        if (0 !== h)
          for (i = 0; i < o; i += 1) {
            if (
              ((n = (a = this.shapes[i]).localShapeCollection),
              a.shape._mdf || this._mdf || t)
            )
              for (
                n.releaseShapes(),
                  a.shape._mdf = !0,
                  e = a.shape.paths.shapes,
                  s = a.shape.paths._length,
                  r = 0;
                r < s;
                r += 1
              )
                n.addShape(this.processPath(e[r], h, p, l));
            a.shape.paths = a.localShapeCollection;
          }
        this.dynamicProperties.length || (this._mdf = !1);
      });
    var FontManager = (function () {
      var t = { w: 0, size: 0, shapes: [], data: { shapes: [] } },
        e = [];
      e = e.concat([
        2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369,
        2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381,
        2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403,
      ]);
      var i = 127988,
        r = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function s(t, e) {
        var i = createTag("span");
        i.setAttribute("aria-hidden", !0), (i.style.fontFamily = e);
        var r = createTag("span");
        (r.innerText = "giItT1WQy@!-/#"),
          (i.style.position = "absolute"),
          (i.style.left = "-10000px"),
          (i.style.top = "-10000px"),
          (i.style.fontSize = "300px"),
          (i.style.fontVariant = "normal"),
          (i.style.fontStyle = "normal"),
          (i.style.fontWeight = "normal"),
          (i.style.letterSpacing = "0"),
          i.appendChild(r),
          document.body.appendChild(i);
        var s = r.offsetWidth;
        return (
          (r.style.fontFamily =
            (function (t) {
              var e,
                i = t.split(","),
                r = i.length,
                s = [];
              for (e = 0; e < r; e += 1)
                "sans-serif" !== i[e] && "monospace" !== i[e] && s.push(i[e]);
              return s.join(",");
            })(t) +
            ", " +
            e),
          { node: r, w: s, parent: i }
        );
      }
      function a(t, e) {
        var i,
          r = document.body && e ? "svg" : "canvas",
          s = getFontProperties(t);
        if ("svg" === r) {
          var a = createNS("text");
          (a.style.fontSize = "100px"),
            a.setAttribute("font-family", t.fFamily),
            a.setAttribute("font-style", s.style),
            a.setAttribute("font-weight", s.weight),
            (a.textContent = "1"),
            t.fClass
              ? ((a.style.fontFamily = "inherit"),
                a.setAttribute("class", t.fClass))
              : (a.style.fontFamily = t.fFamily),
            e.appendChild(a),
            (i = a);
        } else {
          var n = new OffscreenCanvas(500, 500).getContext("2d");
          (n.font = s.style + " " + s.weight + " 100px " + t.fFamily), (i = n);
        }
        return {
          measureText: function (t) {
            return "svg" === r
              ? ((i.textContent = t), i.getComputedTextLength())
              : i.measureText(t).width;
          },
        };
      }
      function n(t) {
        var e = 0,
          i = t.charCodeAt(0);
        if (i >= 55296 && i <= 56319) {
          var r = t.charCodeAt(1);
          r >= 56320 &&
            r <= 57343 &&
            (e = 1024 * (i - 55296) + r - 56320 + 65536);
        }
        return e;
      }
      function o(t) {
        var e = n(t);
        return e >= 127462 && e <= 127487;
      }
      var h = function () {
        (this.fonts = []),
          (this.chars = null),
          (this.typekitLoaded = 0),
          (this.isLoaded = !1),
          (this._warned = !1),
          (this.initTime = Date.now()),
          (this.setIsLoadedBinded = this.setIsLoaded.bind(this)),
          (this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this));
      };
      (h.isModifier = function (t, e) {
        var i = t.toString(16) + e.toString(16);
        return -1 !== r.indexOf(i);
      }),
        (h.isZeroWidthJoiner = function (t) {
          return 8205 === t;
        }),
        (h.isFlagEmoji = function (t) {
          return o(t.substr(0, 2)) && o(t.substr(2, 2));
        }),
        (h.isRegionalCode = o),
        (h.isCombinedCharacter = function (t) {
          return -1 !== e.indexOf(t);
        }),
        (h.isRegionalFlag = function (t, e) {
          var r = n(t.substr(e, 2));
          if (r !== i) return !1;
          var s = 0;
          for (e += 2; s < 5; ) {
            if ((r = n(t.substr(e, 2))) < 917601 || r > 917626) return !1;
            (s += 1), (e += 2);
          }
          return 917631 === n(t.substr(e, 2));
        }),
        (h.isVariationSelector = function (t) {
          return 65039 === t;
        }),
        (h.BLACK_FLAG_CODE_POINT = i);
      var l = {
        addChars: function (t) {
          if (t) {
            var e;
            this.chars || (this.chars = []);
            var i,
              r,
              s = t.length,
              a = this.chars.length;
            for (e = 0; e < s; e += 1) {
              for (i = 0, r = !1; i < a; )
                this.chars[i].style === t[e].style &&
                  this.chars[i].fFamily === t[e].fFamily &&
                  this.chars[i].ch === t[e].ch &&
                  (r = !0),
                  (i += 1);
              r || (this.chars.push(t[e]), (a += 1));
            }
          }
        },
        addFonts: function (t, e) {
          if (t) {
            if (this.chars)
              return (this.isLoaded = !0), void (this.fonts = t.list);
            if (!document.body)
              return (
                (this.isLoaded = !0),
                t.list.forEach(function (t) {
                  (t.helper = a(t)), (t.cache = {});
                }),
                void (this.fonts = t.list)
              );
            var i,
              r = t.list,
              n = r.length,
              o = n;
            for (i = 0; i < n; i += 1) {
              var h,
                l,
                p = !0;
              if (
                ((r[i].loaded = !1),
                (r[i].monoCase = s(r[i].fFamily, "monospace")),
                (r[i].sansCase = s(r[i].fFamily, "sans-serif")),
                r[i].fPath)
              ) {
                if ("p" === r[i].fOrigin || 3 === r[i].origin) {
                  if (
                    ((h = document.querySelectorAll(
                      'style[f-forigin="p"][f-family="' +
                        r[i].fFamily +
                        '"], style[f-origin="3"][f-family="' +
                        r[i].fFamily +
                        '"]'
                    )).length > 0 && (p = !1),
                    p)
                  ) {
                    var f = createTag("style");
                    f.setAttribute("f-forigin", r[i].fOrigin),
                      f.setAttribute("f-origin", r[i].origin),
                      f.setAttribute("f-family", r[i].fFamily),
                      (f.type = "text/css"),
                      (f.innerText =
                        "@font-face {font-family: " +
                        r[i].fFamily +
                        "; font-style: normal; src: url('" +
                        r[i].fPath +
                        "');}"),
                      e.appendChild(f);
                  }
                } else if ("g" === r[i].fOrigin || 1 === r[i].origin) {
                  for (
                    h = document.querySelectorAll(
                      'link[f-forigin="g"], link[f-origin="1"]'
                    ),
                      l = 0;
                    l < h.length;
                    l += 1
                  )
                    -1 !== h[l].href.indexOf(r[i].fPath) && (p = !1);
                  if (p) {
                    var m = createTag("link");
                    m.setAttribute("f-forigin", r[i].fOrigin),
                      m.setAttribute("f-origin", r[i].origin),
                      (m.type = "text/css"),
                      (m.rel = "stylesheet"),
                      (m.href = r[i].fPath),
                      document.body.appendChild(m);
                  }
                } else if ("t" === r[i].fOrigin || 2 === r[i].origin) {
                  for (
                    h = document.querySelectorAll(
                      'script[f-forigin="t"], script[f-origin="2"]'
                    ),
                      l = 0;
                    l < h.length;
                    l += 1
                  )
                    r[i].fPath === h[l].src && (p = !1);
                  if (p) {
                    var c = createTag("link");
                    c.setAttribute("f-forigin", r[i].fOrigin),
                      c.setAttribute("f-origin", r[i].origin),
                      c.setAttribute("rel", "stylesheet"),
                      c.setAttribute("href", r[i].fPath),
                      e.appendChild(c);
                  }
                }
              } else (r[i].loaded = !0), (o -= 1);
              (r[i].helper = a(r[i], e)),
                (r[i].cache = {}),
                this.fonts.push(r[i]);
            }
            0 === o
              ? (this.isLoaded = !0)
              : setTimeout(this.checkLoadedFonts.bind(this), 100);
          } else this.isLoaded = !0;
        },
        getCharData: function (e, i, r) {
          for (var s = 0, a = this.chars.length; s < a; ) {
            if (
              this.chars[s].ch === e &&
              this.chars[s].style === i &&
              this.chars[s].fFamily === r
            )
              return this.chars[s];
            s += 1;
          }
          return (
            (("string" == typeof e && 13 !== e.charCodeAt(0)) || !e) &&
              console &&
              console.warn &&
              !this._warned &&
              ((this._warned = !0),
              console.warn(
                "Missing character from exported characters list: ",
                e,
                i,
                r
              )),
            t
          );
        },
        getFontByName: function (t) {
          for (var e = 0, i = this.fonts.length; e < i; ) {
            if (this.fonts[e].fName === t) return this.fonts[e];
            e += 1;
          }
          return this.fonts[0];
        },
        measureText: function (t, e, i) {
          var r = this.getFontByName(e),
            s = t;
          if (!r.cache[s]) {
            var a = r.helper;
            if (" " === t) {
              var n = a.measureText("|" + t + "|"),
                o = a.measureText("||");
              r.cache[s] = (n - o) / 100;
            } else r.cache[s] = a.measureText(t) / 100;
          }
          return r.cache[s] * i;
        },
        checkLoadedFonts: function () {
          var t,
            e,
            i,
            r = this.fonts.length,
            s = r;
          for (t = 0; t < r; t += 1)
            this.fonts[t].loaded
              ? (s -= 1)
              : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin
              ? (this.fonts[t].loaded = !0)
              : ((e = this.fonts[t].monoCase.node),
                (i = this.fonts[t].monoCase.w),
                e.offsetWidth !== i
                  ? ((s -= 1), (this.fonts[t].loaded = !0))
                  : ((e = this.fonts[t].sansCase.node),
                    (i = this.fonts[t].sansCase.w),
                    e.offsetWidth !== i &&
                      ((s -= 1), (this.fonts[t].loaded = !0))),
                this.fonts[t].loaded &&
                  (this.fonts[t].sansCase.parent.parentNode.removeChild(
                    this.fonts[t].sansCase.parent
                  ),
                  this.fonts[t].monoCase.parent.parentNode.removeChild(
                    this.fonts[t].monoCase.parent
                  )));
          0 !== s && Date.now() - this.initTime < 5e3
            ? setTimeout(this.checkLoadedFontsBinded, 20)
            : setTimeout(this.setIsLoadedBinded, 10);
        },
        setIsLoaded: function () {
          this.isLoaded = !0;
        },
      };
      return (h.prototype = l), h;
    })();
    function SlotManager(t) {
      this.animationData = t;
    }
    function slotFactory(t) {
      return new SlotManager(t);
    }
    function RenderableElement() {}
    (SlotManager.prototype.getProp = function (t) {
      return this.animationData.slots && this.animationData.slots[t.sid]
        ? Object.assign(t, this.animationData.slots[t.sid].p)
        : t;
    }),
      (RenderableElement.prototype = {
        initRenderable: function () {
          (this.isInRange = !1),
            (this.hidden = !1),
            (this.isTransparent = !1),
            (this.renderableComponents = []);
        },
        addRenderableComponent: function (t) {
          -1 === this.renderableComponents.indexOf(t) &&
            this.renderableComponents.push(t);
        },
        removeRenderableComponent: function (t) {
          -1 !== this.renderableComponents.indexOf(t) &&
            this.renderableComponents.splice(
              this.renderableComponents.indexOf(t),
              1
            );
        },
        prepareRenderableFrame: function (t) {
          this.checkLayerLimits(t);
        },
        checkTransparency: function () {
          this.finalTransform.mProp.o.v <= 0
            ? !this.isTransparent &&
              this.globalData.renderConfig.hideOnTransparent &&
              ((this.isTransparent = !0), this.hide())
            : this.isTransparent && ((this.isTransparent = !1), this.show());
        },
        checkLayerLimits: function (t) {
          this.data.ip - this.data.st <= t && this.data.op - this.data.st > t
            ? !0 !== this.isInRange &&
              ((this.globalData._mdf = !0),
              (this._mdf = !0),
              (this.isInRange = !0),
              this.show())
            : !1 !== this.isInRange &&
              ((this.globalData._mdf = !0), (this.isInRange = !1), this.hide());
        },
        renderRenderable: function () {
          var t,
            e = this.renderableComponents.length;
          for (t = 0; t < e; t += 1)
            this.renderableComponents[t].renderFrame(this._isFirstFrame);
        },
        sourceRectAtTime: function () {
          return { top: 0, left: 0, width: 100, height: 100 };
        },
        getLayerSize: function () {
          return 5 === this.data.ty
            ? { w: this.data.textData.width, h: this.data.textData.height }
            : { w: this.data.width, h: this.data.height };
        },
      });
    var getBlendMode =
        ((blendModeEnums = {
          0: "source-over",
          1: "multiply",
          2: "screen",
          3: "overlay",
          4: "darken",
          5: "lighten",
          6: "color-dodge",
          7: "color-burn",
          8: "hard-light",
          9: "soft-light",
          10: "difference",
          11: "exclusion",
          12: "hue",
          13: "saturation",
          14: "color",
          15: "luminosity",
        }),
        function (t) {
          return blendModeEnums[t] || "";
        }),
      blendModeEnums;
    function SliderEffect(t, e, i) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, i);
    }
    function AngleEffect(t, e, i) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, i);
    }
    function ColorEffect(t, e, i) {
      this.p = PropertyFactory.getProp(e, t.v, 1, 0, i);
    }
    function PointEffect(t, e, i) {
      this.p = PropertyFactory.getProp(e, t.v, 1, 0, i);
    }
    function LayerIndexEffect(t, e, i) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, i);
    }
    function MaskIndexEffect(t, e, i) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, i);
    }
    function CheckboxEffect(t, e, i) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, i);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(t, e) {
      var i,
        r = t.ef || [];
      this.effectElements = [];
      var s,
        a = r.length;
      for (i = 0; i < a; i += 1)
        (s = new GroupEffect(r[i], e)), this.effectElements.push(s);
    }
    function GroupEffect(t, e) {
      this.init(t, e);
    }
    function BaseElement() {}
    function FrameElement() {}
    function FootageElement(t, e, i) {
      this.initFrame(),
        this.initRenderable(),
        (this.assetData = e.getAssetData(t.refId)),
        (this.footageData = e.imageLoader.getAsset(this.assetData)),
        this.initBaseData(t, e, i);
    }
    function AudioElement(t, e, i) {
      this.initFrame(),
        this.initRenderable(),
        (this.assetData = e.getAssetData(t.refId)),
        this.initBaseData(t, e, i),
        (this._isPlaying = !1),
        (this._canPlay = !1);
      var r = this.globalData.getAssetsPath(this.assetData);
      (this.audio = this.globalData.audioController.createAudio(r)),
        (this._currentTime = 0),
        this.globalData.audioController.addAudio(this),
        (this._volumeMultiplier = 1),
        (this._volume = 1),
        (this._previousVolume = null),
        (this.tm = t.tm
          ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
          : { _placeholder: !0 }),
        (this.lv = PropertyFactory.getProp(
          this,
          t.au && t.au.lv ? t.au.lv : { k: [100] },
          1,
          0.01,
          this
        ));
    }
    function BaseRenderer() {}
    extendPrototype([DynamicPropertyContainer], GroupEffect),
      (GroupEffect.prototype.getValue =
        GroupEffect.prototype.iterateDynamicProperties),
      (GroupEffect.prototype.init = function (t, e) {
        var i;
        (this.data = t),
          (this.effectElements = []),
          this.initDynamicPropertyContainer(e);
        var r,
          s = this.data.ef.length,
          a = this.data.ef;
        for (i = 0; i < s; i += 1) {
          switch (((r = null), a[i].ty)) {
            case 0:
              r = new SliderEffect(a[i], e, this);
              break;
            case 1:
              r = new AngleEffect(a[i], e, this);
              break;
            case 2:
              r = new ColorEffect(a[i], e, this);
              break;
            case 3:
              r = new PointEffect(a[i], e, this);
              break;
            case 4:
            case 7:
              r = new CheckboxEffect(a[i], e, this);
              break;
            case 10:
              r = new LayerIndexEffect(a[i], e, this);
              break;
            case 11:
              r = new MaskIndexEffect(a[i], e, this);
              break;
            case 5:
              r = new EffectsManager(a[i], e, this);
              break;
            default:
              r = new NoValueEffect(a[i], e, this);
          }
          r && this.effectElements.push(r);
        }
      }),
      (BaseElement.prototype = {
        checkMasks: function () {
          if (!this.data.hasMask) return !1;
          for (var t = 0, e = this.data.masksProperties.length; t < e; ) {
            if (
              "n" !== this.data.masksProperties[t].mode &&
              !1 !== this.data.masksProperties[t].cl
            )
              return !0;
            t += 1;
          }
          return !1;
        },
        initExpressions: function () {
          var t = getExpressionInterfaces();
          if (t) {
            var e = t("layer"),
              i = t("effects"),
              r = t("shape"),
              s = t("text"),
              a = t("comp");
            (this.layerInterface = e(this)),
              this.data.hasMask &&
                this.maskManager &&
                this.layerInterface.registerMaskInterface(this.maskManager);
            var n = i.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(n),
              0 === this.data.ty || this.data.xt
                ? (this.compInterface = a(this))
                : 4 === this.data.ty
                ? ((this.layerInterface.shapeInterface = r(
                    this.shapesData,
                    this.itemsData,
                    this.layerInterface
                  )),
                  (this.layerInterface.content =
                    this.layerInterface.shapeInterface))
                : 5 === this.data.ty &&
                  ((this.layerInterface.textInterface = s(this)),
                  (this.layerInterface.text =
                    this.layerInterface.textInterface));
          }
        },
        setBlendMode: function () {
          var t = getBlendMode(this.data.bm);
          (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
        },
        initBaseData: function (t, e, i) {
          (this.globalData = e),
            (this.comp = i),
            (this.data = t),
            (this.layerId = createElementID()),
            this.data.sr || (this.data.sr = 1),
            (this.effectsManager = new EffectsManager(
              this.data,
              this,
              this.dynamicProperties
            ));
        },
        getType: function () {
          return this.type;
        },
        sourceRectAtTime: function () {},
      }),
      (FrameElement.prototype = {
        initFrame: function () {
          (this._isFirstFrame = !1),
            (this.dynamicProperties = []),
            (this._mdf = !1);
        },
        prepareProperties: function (t, e) {
          var i,
            r = this.dynamicProperties.length;
          for (i = 0; i < r; i += 1)
            (e ||
              (this._isParent &&
                "transform" === this.dynamicProperties[i].propType)) &&
              (this.dynamicProperties[i].getValue(),
              this.dynamicProperties[i]._mdf &&
                ((this.globalData._mdf = !0), (this._mdf = !0)));
        },
        addDynamicProperty: function (t) {
          -1 === this.dynamicProperties.indexOf(t) &&
            this.dynamicProperties.push(t);
        },
      }),
      (FootageElement.prototype.prepareFrame = function () {}),
      extendPrototype(
        [RenderableElement, BaseElement, FrameElement],
        FootageElement
      ),
      (FootageElement.prototype.getBaseElement = function () {
        return null;
      }),
      (FootageElement.prototype.renderFrame = function () {}),
      (FootageElement.prototype.destroy = function () {}),
      (FootageElement.prototype.initExpressions = function () {
        var t = getExpressionInterfaces();
        if (t) {
          var e = t("footage");
          this.layerInterface = e(this);
        }
      }),
      (FootageElement.prototype.getFootageData = function () {
        return this.footageData;
      }),
      (AudioElement.prototype.prepareFrame = function (t) {
        if (
          (this.prepareRenderableFrame(t, !0),
          this.prepareProperties(t, !0),
          this.tm._placeholder)
        )
          this._currentTime = t / this.data.sr;
        else {
          var e = this.tm.v;
          this._currentTime = e;
        }
        this._volume = this.lv.v[0];
        var i = this._volume * this._volumeMultiplier;
        this._previousVolume !== i &&
          ((this._previousVolume = i), this.audio.volume(i));
      }),
      extendPrototype(
        [RenderableElement, BaseElement, FrameElement],
        AudioElement
      ),
      (AudioElement.prototype.renderFrame = function () {
        this.isInRange &&
          this._canPlay &&
          (this._isPlaying
            ? (!this.audio.playing() ||
                Math.abs(
                  this._currentTime / this.globalData.frameRate -
                    this.audio.seek()
                ) > 0.1) &&
              this.audio.seek(this._currentTime / this.globalData.frameRate)
            : (this.audio.play(),
              this.audio.seek(this._currentTime / this.globalData.frameRate),
              (this._isPlaying = !0)));
      }),
      (AudioElement.prototype.show = function () {}),
      (AudioElement.prototype.hide = function () {
        this.audio.pause(), (this._isPlaying = !1);
      }),
      (AudioElement.prototype.pause = function () {
        this.audio.pause(), (this._isPlaying = !1), (this._canPlay = !1);
      }),
      (AudioElement.prototype.resume = function () {
        this._canPlay = !0;
      }),
      (AudioElement.prototype.setRate = function (t) {
        this.audio.rate(t);
      }),
      (AudioElement.prototype.volume = function (t) {
        (this._volumeMultiplier = t),
          (this._previousVolume = t * this._volume),
          this.audio.volume(this._previousVolume);
      }),
      (AudioElement.prototype.getBaseElement = function () {
        return null;
      }),
      (AudioElement.prototype.destroy = function () {}),
      (AudioElement.prototype.sourceRectAtTime = function () {}),
      (AudioElement.prototype.initExpressions = function () {}),
      (BaseRenderer.prototype.checkLayers = function (t) {
        var e,
          i,
          r = this.layers.length;
        for (this.completeLayers = !0, e = r - 1; e >= 0; e -= 1)
          this.elements[e] ||
            ((i = this.layers[e]).ip - i.st <= t - this.layers[e].st &&
              i.op - i.st > t - this.layers[e].st &&
              this.buildItem(e)),
            (this.completeLayers = !!this.elements[e] && this.completeLayers);
        this.checkPendingElements();
      }),
      (BaseRenderer.prototype.createItem = function (t) {
        switch (t.ty) {
          case 2:
            return this.createImage(t);
          case 0:
            return this.createComp(t);
          case 1:
            return this.createSolid(t);
          case 3:
          default:
            return this.createNull(t);
          case 4:
            return this.createShape(t);
          case 5:
            return this.createText(t);
          case 6:
            return this.createAudio(t);
          case 13:
            return this.createCamera(t);
          case 15:
            return this.createFootage(t);
        }
      }),
      (BaseRenderer.prototype.createCamera = function () {
        throw new Error("You're using a 3d camera. Try the html renderer.");
      }),
      (BaseRenderer.prototype.createAudio = function (t) {
        return new AudioElement(t, this.globalData, this);
      }),
      (BaseRenderer.prototype.createFootage = function (t) {
        return new FootageElement(t, this.globalData, this);
      }),
      (BaseRenderer.prototype.buildAllItems = function () {
        var t,
          e = this.layers.length;
        for (t = 0; t < e; t += 1) this.buildItem(t);
        this.checkPendingElements();
      }),
      (BaseRenderer.prototype.includeLayers = function (t) {
        var e;
        this.completeLayers = !1;
        var i,
          r = t.length,
          s = this.layers.length;
        for (e = 0; e < r; e += 1)
          for (i = 0; i < s; ) {
            if (this.layers[i].id === t[e].id) {
              this.layers[i] = t[e];
              break;
            }
            i += 1;
          }
      }),
      (BaseRenderer.prototype.setProjectInterface = function (t) {
        this.globalData.projectInterface = t;
      }),
      (BaseRenderer.prototype.initItems = function () {
        this.globalData.progressiveLoad || this.buildAllItems();
      }),
      (BaseRenderer.prototype.buildElementParenting = function (t, e, i) {
        for (
          var r = this.elements, s = this.layers, a = 0, n = s.length;
          a < n;

        )
          s[a].ind == e &&
            (r[a] && !0 !== r[a]
              ? (i.push(r[a]),
                r[a].setAsParent(),
                void 0 !== s[a].parent
                  ? this.buildElementParenting(t, s[a].parent, i)
                  : t.setHierarchy(i))
              : (this.buildItem(a), this.addPendingElement(t))),
            (a += 1);
      }),
      (BaseRenderer.prototype.addPendingElement = function (t) {
        this.pendingElements.push(t);
      }),
      (BaseRenderer.prototype.searchExtraCompositions = function (t) {
        var e,
          i = t.length;
        for (e = 0; e < i; e += 1)
          if (t[e].xt) {
            var r = this.createComp(t[e]);
            r.initExpressions(),
              this.globalData.projectInterface.registerComposition(r);
          }
      }),
      (BaseRenderer.prototype.getElementById = function (t) {
        var e,
          i = this.elements.length;
        for (e = 0; e < i; e += 1)
          if (this.elements[e].data.ind === t) return this.elements[e];
        return null;
      }),
      (BaseRenderer.prototype.getElementByPath = function (t) {
        var e,
          i = t.shift();
        if ("number" == typeof i) e = this.elements[i];
        else {
          var r,
            s = this.elements.length;
          for (r = 0; r < s; r += 1)
            if (this.elements[r].data.nm === i) {
              e = this.elements[r];
              break;
            }
        }
        return 0 === t.length ? e : e.getElementByPath(t);
      }),
      (BaseRenderer.prototype.setupGlobalData = function (t, e) {
        (this.globalData.fontManager = new FontManager()),
          (this.globalData.slotManager = slotFactory(t)),
          this.globalData.fontManager.addChars(t.chars),
          this.globalData.fontManager.addFonts(t.fonts, e),
          (this.globalData.getAssetData = this.animationItem.getAssetData.bind(
            this.animationItem
          )),
          (this.globalData.getAssetsPath =
            this.animationItem.getAssetsPath.bind(this.animationItem)),
          (this.globalData.imageLoader = this.animationItem.imagePreloader),
          (this.globalData.audioController =
            this.animationItem.audioController),
          (this.globalData.frameId = 0),
          (this.globalData.frameRate = t.fr),
          (this.globalData.nm = t.nm),
          (this.globalData.compSize = { w: t.w, h: t.h });
      });
    var effectTypes = { TRANSFORM_EFFECT: "transformEFfect" };
    function TransformElement() {}
    function MaskElement(t, e, i) {
      (this.data = t),
        (this.element = e),
        (this.globalData = i),
        (this.storedData = []),
        (this.masksProperties = this.data.masksProperties || []),
        (this.maskElement = null);
      var r,
        s,
        a = this.globalData.defs,
        n = this.masksProperties ? this.masksProperties.length : 0;
      (this.viewData = createSizedArray(n)), (this.solidPath = "");
      var o,
        h,
        l,
        p,
        f,
        m,
        c = this.masksProperties,
        d = 0,
        u = [],
        y = createElementID(),
        g = "clipPath",
        v = "clip-path";
      for (r = 0; r < n; r += 1)
        if (
          ((("a" !== c[r].mode && "n" !== c[r].mode) ||
            c[r].inv ||
            100 !== c[r].o.k ||
            c[r].o.x) &&
            ((g = "mask"), (v = "mask")),
          ("s" !== c[r].mode && "i" !== c[r].mode) || 0 !== d
            ? (l = null)
            : ((l = createNS("rect")).setAttribute("fill", "#ffffff"),
              l.setAttribute("width", this.element.comp.data.w || 0),
              l.setAttribute("height", this.element.comp.data.h || 0),
              u.push(l)),
          (s = createNS("path")),
          "n" === c[r].mode)
        )
          (this.viewData[r] = {
            op: PropertyFactory.getProp(
              this.element,
              c[r].o,
              0,
              0.01,
              this.element
            ),
            prop: ShapePropertyFactory.getShapeProp(this.element, c[r], 3),
            elem: s,
            lastPath: "",
          }),
            a.appendChild(s);
        else {
          var b;
          if (
            ((d += 1),
            s.setAttribute("fill", "s" === c[r].mode ? "#000000" : "#ffffff"),
            s.setAttribute("clip-rule", "nonzero"),
            0 !== c[r].x.k
              ? ((g = "mask"),
                (v = "mask"),
                (m = PropertyFactory.getProp(
                  this.element,
                  c[r].x,
                  0,
                  null,
                  this.element
                )),
                (b = createElementID()),
                (p = createNS("filter")).setAttribute("id", b),
                (f = createNS("feMorphology")).setAttribute(
                  "operator",
                  "erode"
                ),
                f.setAttribute("in", "SourceGraphic"),
                f.setAttribute("radius", "0"),
                p.appendChild(f),
                a.appendChild(p),
                s.setAttribute(
                  "stroke",
                  "s" === c[r].mode ? "#000000" : "#ffffff"
                ))
              : ((f = null), (m = null)),
            (this.storedData[r] = {
              elem: s,
              x: m,
              expan: f,
              lastPath: "",
              lastOperator: "",
              filterId: b,
              lastRadius: 0,
            }),
            "i" === c[r].mode)
          ) {
            h = u.length;
            var x = createNS("g");
            for (o = 0; o < h; o += 1) x.appendChild(u[o]);
            var P = createNS("mask");
            P.setAttribute("mask-type", "alpha"),
              P.setAttribute("id", y + "_" + d),
              P.appendChild(s),
              a.appendChild(P),
              x.setAttribute(
                "mask",
                "url(" + getLocationHref() + "#" + y + "_" + d + ")"
              ),
              (u.length = 0),
              u.push(x);
          } else u.push(s);
          c[r].inv &&
            !this.solidPath &&
            (this.solidPath = this.createLayerSolidPath()),
            (this.viewData[r] = {
              elem: s,
              lastPath: "",
              op: PropertyFactory.getProp(
                this.element,
                c[r].o,
                0,
                0.01,
                this.element
              ),
              prop: ShapePropertyFactory.getShapeProp(this.element, c[r], 3),
              invRect: l,
            }),
            this.viewData[r].prop.k ||
              this.drawPath(c[r], this.viewData[r].prop.v, this.viewData[r]);
        }
      for (this.maskElement = createNS(g), n = u.length, r = 0; r < n; r += 1)
        this.maskElement.appendChild(u[r]);
      d > 0 &&
        (this.maskElement.setAttribute("id", y),
        this.element.maskedElement.setAttribute(
          v,
          "url(" + getLocationHref() + "#" + y + ")"
        ),
        a.appendChild(this.maskElement)),
        this.viewData.length && this.element.addRenderableComponent(this);
    }
    (TransformElement.prototype = {
      initTransform: function () {
        var t = new Matrix();
        (this.finalTransform = {
          mProp: this.data.ks
            ? TransformPropertyFactory.getTransformProperty(
                this,
                this.data.ks,
                this
              )
            : { o: 0 },
          _matMdf: !1,
          _localMatMdf: !1,
          _opMdf: !1,
          mat: t,
          localMat: t,
          localOpacity: 1,
        }),
          this.data.ao && (this.finalTransform.mProp.autoOriented = !0),
          this.data.ty;
      },
      renderTransform: function () {
        if (
          ((this.finalTransform._opMdf =
            this.finalTransform.mProp.o._mdf || this._isFirstFrame),
          (this.finalTransform._matMdf =
            this.finalTransform.mProp._mdf || this._isFirstFrame),
          this.hierarchy)
        ) {
          var t,
            e = this.finalTransform.mat,
            i = 0,
            r = this.hierarchy.length;
          if (!this.finalTransform._matMdf)
            for (; i < r; ) {
              if (this.hierarchy[i].finalTransform.mProp._mdf) {
                this.finalTransform._matMdf = !0;
                break;
              }
              i += 1;
            }
          if (this.finalTransform._matMdf)
            for (
              t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), i = 0;
              i < r;
              i += 1
            )
              e.multiply(this.hierarchy[i].finalTransform.mProp.v);
        }
        this.finalTransform._matMdf &&
          (this.finalTransform._localMatMdf = this.finalTransform._matMdf),
          this.finalTransform._opMdf &&
            (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
      },
      renderLocalTransform: function () {
        if (this.localTransforms) {
          var t = 0,
            e = this.localTransforms.length;
          if (
            ((this.finalTransform._localMatMdf = this.finalTransform._matMdf),
            !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
          )
            for (; t < e; )
              this.localTransforms[t]._mdf &&
                (this.finalTransform._localMatMdf = !0),
                this.localTransforms[t]._opMdf &&
                  !this.finalTransform._opMdf &&
                  ((this.finalTransform.localOpacity =
                    this.finalTransform.mProp.o.v),
                  (this.finalTransform._opMdf = !0)),
                (t += 1);
          if (this.finalTransform._localMatMdf) {
            var i = this.finalTransform.localMat;
            for (
              this.localTransforms[0].matrix.clone(i), t = 1;
              t < e;
              t += 1
            ) {
              var r = this.localTransforms[t].matrix;
              i.multiply(r);
            }
            i.multiply(this.finalTransform.mat);
          }
          if (this.finalTransform._opMdf) {
            var s = this.finalTransform.localOpacity;
            for (t = 0; t < e; t += 1)
              s *= 0.01 * this.localTransforms[t].opacity;
            this.finalTransform.localOpacity = s;
          }
        }
      },
      searchEffectTransforms: function () {
        if (this.renderableEffectsManager) {
          var t = this.renderableEffectsManager.getEffects(
            effectTypes.TRANSFORM_EFFECT
          );
          if (t.length) {
            (this.localTransforms = []),
              (this.finalTransform.localMat = new Matrix());
            var e = 0,
              i = t.length;
            for (e = 0; e < i; e += 1) this.localTransforms.push(t[e]);
          }
        }
      },
      globalToLocal: function (t) {
        var e = [];
        e.push(this.finalTransform);
        for (var i, r = !0, s = this.comp; r; )
          s.finalTransform
            ? (s.data.hasMask && e.splice(0, 0, s.finalTransform), (s = s.comp))
            : (r = !1);
        var a,
          n = e.length;
        for (i = 0; i < n; i += 1)
          (a = e[i].mat.applyToPointArray(0, 0, 0)),
            (t = [t[0] - a[0], t[1] - a[1], 0]);
        return t;
      },
      mHelper: new Matrix(),
    }),
      (MaskElement.prototype.getMaskProperty = function (t) {
        return this.viewData[t].prop;
      }),
      (MaskElement.prototype.renderFrame = function (t) {
        var e,
          i = this.element.finalTransform.mat,
          r = this.masksProperties.length;
        for (e = 0; e < r; e += 1)
          if (
            ((this.viewData[e].prop._mdf || t) &&
              this.drawPath(
                this.masksProperties[e],
                this.viewData[e].prop.v,
                this.viewData[e]
              ),
            (this.viewData[e].op._mdf || t) &&
              this.viewData[e].elem.setAttribute(
                "fill-opacity",
                this.viewData[e].op.v
              ),
            "n" !== this.masksProperties[e].mode &&
              (this.viewData[e].invRect &&
                (this.element.finalTransform.mProp._mdf || t) &&
                this.viewData[e].invRect.setAttribute(
                  "transform",
                  i.getInverseMatrix().to2dCSS()
                ),
              this.storedData[e].x && (this.storedData[e].x._mdf || t)))
          ) {
            var s = this.storedData[e].expan;
            this.storedData[e].x.v < 0
              ? ("erode" !== this.storedData[e].lastOperator &&
                  ((this.storedData[e].lastOperator = "erode"),
                  this.storedData[e].elem.setAttribute(
                    "filter",
                    "url(" +
                      getLocationHref() +
                      "#" +
                      this.storedData[e].filterId +
                      ")"
                  )),
                s.setAttribute("radius", -this.storedData[e].x.v))
              : ("dilate" !== this.storedData[e].lastOperator &&
                  ((this.storedData[e].lastOperator = "dilate"),
                  this.storedData[e].elem.setAttribute("filter", null)),
                this.storedData[e].elem.setAttribute(
                  "stroke-width",
                  2 * this.storedData[e].x.v
                ));
          }
      }),
      (MaskElement.prototype.getMaskelement = function () {
        return this.maskElement;
      }),
      (MaskElement.prototype.createLayerSolidPath = function () {
        var t = "M0,0 ";
        return (
          (t += " h" + this.globalData.compSize.w),
          (t += " v" + this.globalData.compSize.h),
          (t += " h-" + this.globalData.compSize.w),
          (t += " v-" + this.globalData.compSize.h + " ")
        );
      }),
      (MaskElement.prototype.drawPath = function (t, e, i) {
        var r,
          s,
          a = " M" + e.v[0][0] + "," + e.v[0][1];
        for (s = e._length, r = 1; r < s; r += 1)
          a +=
            " C" +
            e.o[r - 1][0] +
            "," +
            e.o[r - 1][1] +
            " " +
            e.i[r][0] +
            "," +
            e.i[r][1] +
            " " +
            e.v[r][0] +
            "," +
            e.v[r][1];
        if (
          (e.c &&
            s > 1 &&
            (a +=
              " C" +
              e.o[r - 1][0] +
              "," +
              e.o[r - 1][1] +
              " " +
              e.i[0][0] +
              "," +
              e.i[0][1] +
              " " +
              e.v[0][0] +
              "," +
              e.v[0][1]),
          i.lastPath !== a)
        ) {
          var n = "";
          i.elem &&
            (e.c && (n = t.inv ? this.solidPath + a : a),
            i.elem.setAttribute("d", n)),
            (i.lastPath = a);
        }
      }),
      (MaskElement.prototype.destroy = function () {
        (this.element = null),
          (this.globalData = null),
          (this.maskElement = null),
          (this.data = null),
          (this.masksProperties = null);
      });
    var filtersFactory = (function () {
        var t = {};
        return (
          (t.createFilter = function (t, e) {
            var i = createNS("filter");
            i.setAttribute("id", t),
              !0 !== e &&
                (i.setAttribute("filterUnits", "objectBoundingBox"),
                i.setAttribute("x", "0%"),
                i.setAttribute("y", "0%"),
                i.setAttribute("width", "100%"),
                i.setAttribute("height", "100%"));
            return i;
          }),
          (t.createAlphaToLuminanceFilter = function () {
            var t = createNS("feColorMatrix");
            return (
              t.setAttribute("type", "matrix"),
              t.setAttribute("color-interpolation-filters", "sRGB"),
              t.setAttribute(
                "values",
                "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"
              ),
              t
            );
          }),
          t
        );
      })(),
      featureSupport = (function () {
        var t = {
          maskType: !0,
          svgLumaHidden: !0,
          offscreenCanvas: "undefined" != typeof OffscreenCanvas,
        };
        return (
          (/MSIE 10/i.test(navigator.userAgent) ||
            /MSIE 9/i.test(navigator.userAgent) ||
            /rv:11.0/i.test(navigator.userAgent) ||
            /Edge\/\d./i.test(navigator.userAgent)) &&
            (t.maskType = !1),
          /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1),
          t
        );
      })(),
      registeredEffects$1 = {},
      idPrefix = "filter_result_";
    function SVGEffects(t) {
      var e,
        i,
        r = "SourceGraphic",
        s = t.data.ef ? t.data.ef.length : 0,
        a = createElementID(),
        n = filtersFactory.createFilter(a, !0),
        o = 0;
      for (this.filters = [], e = 0; e < s; e += 1) {
        i = null;
        var h = t.data.ef[e].ty;
        if (registeredEffects$1[h])
          (i = new (0, registeredEffects$1[h].effect)(
            n,
            t.effectsManager.effectElements[e],
            t,
            idPrefix + o,
            r
          )),
            (r = idPrefix + o),
            registeredEffects$1[h].countsAsEffect && (o += 1);
        i && this.filters.push(i);
      }
      o &&
        (t.globalData.defs.appendChild(n),
        t.layerElement.setAttribute(
          "filter",
          "url(" + getLocationHref() + "#" + a + ")"
        )),
        this.filters.length && t.addRenderableComponent(this);
    }
    function registerEffect$1(t, e, i) {
      registeredEffects$1[t] = { effect: e, countsAsEffect: i };
    }
    function SVGBaseElement() {}
    function HierarchyElement() {}
    function RenderableDOMElement() {}
    function IImageElement(t, e, i) {
      (this.assetData = e.getAssetData(t.refId)),
        this.assetData &&
          this.assetData.sid &&
          (this.assetData = e.slotManager.getProp(this.assetData)),
        this.initElement(t, e, i),
        (this.sourceRect = {
          top: 0,
          left: 0,
          width: this.assetData.w,
          height: this.assetData.h,
        });
    }
    function ProcessedElement(t, e) {
      (this.elem = t), (this.pos = e);
    }
    function IShapeElement() {}
    (SVGEffects.prototype.renderFrame = function (t) {
      var e,
        i = this.filters.length;
      for (e = 0; e < i; e += 1) this.filters[e].renderFrame(t);
    }),
      (SVGEffects.prototype.getEffects = function (t) {
        var e,
          i = this.filters.length,
          r = [];
        for (e = 0; e < i; e += 1)
          this.filters[e].type === t && r.push(this.filters[e]);
        return r;
      }),
      (SVGBaseElement.prototype = {
        initRendererElement: function () {
          this.layerElement = createNS("g");
        },
        createContainerElements: function () {
          (this.matteElement = createNS("g")),
            (this.transformedElement = this.layerElement),
            (this.maskedElement = this.layerElement),
            (this._sizeChanged = !1);
          var t = null;
          if (this.data.td) {
            this.matteMasks = {};
            var e = createNS("g");
            e.setAttribute("id", this.layerId),
              e.appendChild(this.layerElement),
              (t = e),
              this.globalData.defs.appendChild(e);
          } else
            this.data.tt
              ? (this.matteElement.appendChild(this.layerElement),
                (t = this.matteElement),
                (this.baseElement = this.matteElement))
              : (this.baseElement = this.layerElement);
          if (
            (this.data.ln && this.layerElement.setAttribute("id", this.data.ln),
            this.data.cl &&
              this.layerElement.setAttribute("class", this.data.cl),
            0 === this.data.ty && !this.data.hd)
          ) {
            var i = createNS("clipPath"),
              r = createNS("path");
            r.setAttribute(
              "d",
              "M0,0 L" +
                this.data.w +
                ",0 L" +
                this.data.w +
                "," +
                this.data.h +
                " L0," +
                this.data.h +
                "z"
            );
            var s = createElementID();
            if (
              (i.setAttribute("id", s),
              i.appendChild(r),
              this.globalData.defs.appendChild(i),
              this.checkMasks())
            ) {
              var a = createNS("g");
              a.setAttribute(
                "clip-path",
                "url(" + getLocationHref() + "#" + s + ")"
              ),
                a.appendChild(this.layerElement),
                (this.transformedElement = a),
                t
                  ? t.appendChild(this.transformedElement)
                  : (this.baseElement = this.transformedElement);
            } else
              this.layerElement.setAttribute(
                "clip-path",
                "url(" + getLocationHref() + "#" + s + ")"
              );
          }
          0 !== this.data.bm && this.setBlendMode();
        },
        renderElement: function () {
          this.finalTransform._localMatMdf &&
            this.transformedElement.setAttribute(
              "transform",
              this.finalTransform.localMat.to2dCSS()
            ),
            this.finalTransform._opMdf &&
              this.transformedElement.setAttribute(
                "opacity",
                this.finalTransform.localOpacity
              );
        },
        destroyBaseElement: function () {
          (this.layerElement = null),
            (this.matteElement = null),
            this.maskManager.destroy();
        },
        getBaseElement: function () {
          return this.data.hd ? null : this.baseElement;
        },
        createRenderableComponents: function () {
          (this.maskManager = new MaskElement(
            this.data,
            this,
            this.globalData
          )),
            (this.renderableEffectsManager = new SVGEffects(this)),
            this.searchEffectTransforms();
        },
        getMatte: function (t) {
          if (
            (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t])
          ) {
            var e,
              i,
              r,
              s,
              a = this.layerId + "_" + t;
            if (1 === t || 3 === t) {
              var n = createNS("mask");
              n.setAttribute("id", a),
                n.setAttribute("mask-type", 3 === t ? "luminance" : "alpha"),
                (r = createNS("use")).setAttributeNS(
                  "http://www.w3.org/1999/xlink",
                  "href",
                  "#" + this.layerId
                ),
                n.appendChild(r),
                this.globalData.defs.appendChild(n),
                featureSupport.maskType ||
                  1 !== t ||
                  (n.setAttribute("mask-type", "luminance"),
                  (e = createElementID()),
                  (i = filtersFactory.createFilter(e)),
                  this.globalData.defs.appendChild(i),
                  i.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                  (s = createNS("g")).appendChild(r),
                  n.appendChild(s),
                  s.setAttribute(
                    "filter",
                    "url(" + getLocationHref() + "#" + e + ")"
                  ));
            } else if (2 === t) {
              var o = createNS("mask");
              o.setAttribute("id", a), o.setAttribute("mask-type", "alpha");
              var h = createNS("g");
              o.appendChild(h),
                (e = createElementID()),
                (i = filtersFactory.createFilter(e));
              var l = createNS("feComponentTransfer");
              l.setAttribute("in", "SourceGraphic"), i.appendChild(l);
              var p = createNS("feFuncA");
              p.setAttribute("type", "table"),
                p.setAttribute("tableValues", "1.0 0.0"),
                l.appendChild(p),
                this.globalData.defs.appendChild(i);
              var f = createNS("rect");
              f.setAttribute("width", this.comp.data.w),
                f.setAttribute("height", this.comp.data.h),
                f.setAttribute("x", "0"),
                f.setAttribute("y", "0"),
                f.setAttribute("fill", "#ffffff"),
                f.setAttribute("opacity", "0"),
                h.setAttribute(
                  "filter",
                  "url(" + getLocationHref() + "#" + e + ")"
                ),
                h.appendChild(f),
                (r = createNS("use")).setAttributeNS(
                  "http://www.w3.org/1999/xlink",
                  "href",
                  "#" + this.layerId
                ),
                h.appendChild(r),
                featureSupport.maskType ||
                  (o.setAttribute("mask-type", "luminance"),
                  i.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                  (s = createNS("g")),
                  h.appendChild(f),
                  s.appendChild(this.layerElement),
                  h.appendChild(s)),
                this.globalData.defs.appendChild(o);
            }
            this.matteMasks[t] = a;
          }
          return this.matteMasks[t];
        },
        setMatte: function (t) {
          this.matteElement &&
            this.matteElement.setAttribute(
              "mask",
              "url(" + getLocationHref() + "#" + t + ")"
            );
        },
      }),
      (HierarchyElement.prototype = {
        initHierarchy: function () {
          (this.hierarchy = []), (this._isParent = !1), this.checkParenting();
        },
        setHierarchy: function (t) {
          this.hierarchy = t;
        },
        setAsParent: function () {
          this._isParent = !0;
        },
        checkParenting: function () {
          void 0 !== this.data.parent &&
            this.comp.buildElementParenting(this, this.data.parent, []);
        },
      }),
      extendPrototype(
        [
          RenderableElement,
          createProxyFunction({
            initElement: function (t, e, i) {
              this.initFrame(),
                this.initBaseData(t, e, i),
                this.initTransform(t, e, i),
                this.initHierarchy(),
                this.initRenderable(),
                this.initRendererElement(),
                this.createContainerElements(),
                this.createRenderableComponents(),
                this.createContent(),
                this.hide();
            },
            hide: function () {
              this.hidden ||
                (this.isInRange && !this.isTransparent) ||
                (((this.baseElement || this.layerElement).style.display =
                  "none"),
                (this.hidden = !0));
            },
            show: function () {
              this.isInRange &&
                !this.isTransparent &&
                (this.data.hd ||
                  ((this.baseElement || this.layerElement).style.display =
                    "block"),
                (this.hidden = !1),
                (this._isFirstFrame = !0));
            },
            renderFrame: function () {
              this.data.hd ||
                this.hidden ||
                (this.renderTransform(),
                this.renderRenderable(),
                this.renderLocalTransform(),
                this.renderElement(),
                this.renderInnerContent(),
                this._isFirstFrame && (this._isFirstFrame = !1));
            },
            renderInnerContent: function () {},
            prepareFrame: function (t) {
              (this._mdf = !1),
                this.prepareRenderableFrame(t),
                this.prepareProperties(t, this.isInRange),
                this.checkTransparency();
            },
            destroy: function () {
              (this.innerElem = null), this.destroyBaseElement();
            },
          }),
        ],
        RenderableDOMElement
      ),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          SVGBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableDOMElement,
        ],
        IImageElement
      ),
      (IImageElement.prototype.createContent = function () {
        var t = this.globalData.getAssetsPath(this.assetData);
        (this.innerElem = createNS("image")),
          this.innerElem.setAttribute("width", this.assetData.w + "px"),
          this.innerElem.setAttribute("height", this.assetData.h + "px"),
          this.innerElem.setAttribute(
            "preserveAspectRatio",
            this.assetData.pr ||
              this.globalData.renderConfig.imagePreserveAspectRatio
          ),
          this.innerElem.setAttributeNS(
            "http://www.w3.org/1999/xlink",
            "href",
            t
          ),
          this.layerElement.appendChild(this.innerElem);
      }),
      (IImageElement.prototype.sourceRectAtTime = function () {
        return this.sourceRect;
      }),
      (IShapeElement.prototype = {
        addShapeToModifiers: function (t) {
          var e,
            i = this.shapeModifiers.length;
          for (e = 0; e < i; e += 1) this.shapeModifiers[e].addShape(t);
        },
        isShapeInAnimatedModifiers: function (t) {
          for (var e = this.shapeModifiers.length; 0 < e; )
            if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
          return !1;
        },
        renderModifiers: function () {
          if (this.shapeModifiers.length) {
            var t,
              e = this.shapes.length;
            for (t = 0; t < e; t += 1) this.shapes[t].sh.reset();
            for (
              t = (e = this.shapeModifiers.length) - 1;
              t >= 0 &&
              !this.shapeModifiers[t].processShapes(this._isFirstFrame);
              t -= 1
            );
          }
        },
        searchProcessedElement: function (t) {
          for (var e = this.processedElements, i = 0, r = e.length; i < r; ) {
            if (e[i].elem === t) return e[i].pos;
            i += 1;
          }
          return 0;
        },
        addProcessedElement: function (t, e) {
          for (var i = this.processedElements, r = i.length; r; )
            if (i[(r -= 1)].elem === t) return void (i[r].pos = e);
          i.push(new ProcessedElement(t, e));
        },
        prepareFrame: function (t) {
          this.prepareRenderableFrame(t),
            this.prepareProperties(t, this.isInRange);
        },
      });
    var lineCapEnum = { 1: "butt", 2: "round", 3: "square" },
      lineJoinEnum = { 1: "miter", 2: "round", 3: "bevel" };
    function SVGShapeData(t, e, i) {
      (this.caches = []),
        (this.styles = []),
        (this.transformers = t),
        (this.lStr = ""),
        (this.sh = i),
        (this.lvl = e),
        (this._isAnimated = !!i.k);
      for (var r = 0, s = t.length; r < s; ) {
        if (t[r].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        r += 1;
      }
    }
    function SVGStyleData(t, e) {
      (this.data = t),
        (this.type = t.ty),
        (this.d = ""),
        (this.lvl = e),
        (this._mdf = !1),
        (this.closed = !0 === t.hd),
        (this.pElem = createNS("path")),
        (this.msElem = null);
    }
    function DashProperty(t, e, i, r) {
      var s;
      (this.elem = t),
        (this.frameId = -1),
        (this.dataProps = createSizedArray(e.length)),
        (this.renderer = i),
        (this.k = !1),
        (this.dashStr = ""),
        (this.dashArray = createTypedArray(
          "float32",
          e.length ? e.length - 1 : 0
        )),
        (this.dashoffset = createTypedArray("float32", 1)),
        this.initDynamicPropertyContainer(r);
      var a,
        n = e.length || 0;
      for (s = 0; s < n; s += 1)
        (a = PropertyFactory.getProp(t, e[s].v, 0, 0, this)),
          (this.k = a.k || this.k),
          (this.dataProps[s] = { n: e[s].n, p: a });
      this.k || this.getValue(!0), (this._isAnimated = this.k);
    }
    function SVGStrokeStyleData(t, e, i) {
      this.initDynamicPropertyContainer(t),
        (this.getValue = this.iterateDynamicProperties),
        (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
        (this.w = PropertyFactory.getProp(t, e.w, 0, null, this)),
        (this.d = new DashProperty(t, e.d || {}, "svg", this)),
        (this.c = PropertyFactory.getProp(t, e.c, 1, 255, this)),
        (this.style = i),
        (this._isAnimated = !!this._isAnimated);
    }
    function SVGFillStyleData(t, e, i) {
      this.initDynamicPropertyContainer(t),
        (this.getValue = this.iterateDynamicProperties),
        (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
        (this.c = PropertyFactory.getProp(t, e.c, 1, 255, this)),
        (this.style = i);
    }
    function SVGNoStyleData(t, e, i) {
      this.initDynamicPropertyContainer(t),
        (this.getValue = this.iterateDynamicProperties),
        (this.style = i);
    }
    function GradientProperty(t, e, i) {
      (this.data = e), (this.c = createTypedArray("uint8c", 4 * e.p));
      var r = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
      (this.o = createTypedArray("float32", r)),
        (this._cmdf = !1),
        (this._omdf = !1),
        (this._collapsable = this.checkCollapsable()),
        (this._hasOpacity = r),
        this.initDynamicPropertyContainer(i),
        (this.prop = PropertyFactory.getProp(t, e.k, 1, null, this)),
        (this.k = this.prop.k),
        this.getValue(!0);
    }
    function SVGGradientFillStyleData(t, e, i) {
      this.initDynamicPropertyContainer(t),
        (this.getValue = this.iterateDynamicProperties),
        this.initGradientData(t, e, i);
    }
    function SVGGradientStrokeStyleData(t, e, i) {
      this.initDynamicPropertyContainer(t),
        (this.getValue = this.iterateDynamicProperties),
        (this.w = PropertyFactory.getProp(t, e.w, 0, null, this)),
        (this.d = new DashProperty(t, e.d || {}, "svg", this)),
        this.initGradientData(t, e, i),
        (this._isAnimated = !!this._isAnimated);
    }
    function ShapeGroupData() {
      (this.it = []), (this.prevViewData = []), (this.gr = createNS("g"));
    }
    function SVGTransformData(t, e, i) {
      (this.transform = { mProps: t, op: e, container: i }),
        (this.elements = []),
        (this._isAnimated =
          this.transform.mProps.dynamicProperties.length ||
          this.transform.op.effectsSequence.length);
    }
    (SVGShapeData.prototype.setAsAnimated = function () {
      this._isAnimated = !0;
    }),
      (SVGStyleData.prototype.reset = function () {
        (this.d = ""), (this._mdf = !1);
      }),
      (DashProperty.prototype.getValue = function (t) {
        if (
          (this.elem.globalData.frameId !== this.frameId || t) &&
          ((this.frameId = this.elem.globalData.frameId),
          this.iterateDynamicProperties(),
          (this._mdf = this._mdf || t),
          this._mdf)
        ) {
          var e = 0,
            i = this.dataProps.length;
          for (
            "svg" === this.renderer && (this.dashStr = ""), e = 0;
            e < i;
            e += 1
          )
            "o" !== this.dataProps[e].n
              ? "svg" === this.renderer
                ? (this.dashStr += " " + this.dataProps[e].p.v)
                : (this.dashArray[e] = this.dataProps[e].p.v)
              : (this.dashoffset[0] = this.dataProps[e].p.v);
        }
      }),
      extendPrototype([DynamicPropertyContainer], DashProperty),
      extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData),
      extendPrototype([DynamicPropertyContainer], SVGFillStyleData),
      extendPrototype([DynamicPropertyContainer], SVGNoStyleData),
      (GradientProperty.prototype.comparePoints = function (t, e) {
        for (var i = 0, r = this.o.length / 2; i < r; ) {
          if (Math.abs(t[4 * i] - t[4 * e + 2 * i]) > 0.01) return !1;
          i += 1;
        }
        return !0;
      }),
      (GradientProperty.prototype.checkCollapsable = function () {
        if (this.o.length / 2 != this.c.length / 4) return !1;
        if (this.data.k.k[0].s)
          for (var t = 0, e = this.data.k.k.length; t < e; ) {
            if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
            t += 1;
          }
        else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
        return !0;
      }),
      (GradientProperty.prototype.getValue = function (t) {
        if (
          (this.prop.getValue(),
          (this._mdf = !1),
          (this._cmdf = !1),
          (this._omdf = !1),
          this.prop._mdf || t)
        ) {
          var e,
            i,
            r,
            s = 4 * this.data.p;
          for (e = 0; e < s; e += 1)
            (i = e % 4 == 0 ? 100 : 255),
              (r = Math.round(this.prop.v[e] * i)),
              this.c[e] !== r && ((this.c[e] = r), (this._cmdf = !t));
          if (this.o.length)
            for (s = this.prop.v.length, e = 4 * this.data.p; e < s; e += 1)
              (i = e % 2 == 0 ? 100 : 1),
                (r =
                  e % 2 == 0
                    ? Math.round(100 * this.prop.v[e])
                    : this.prop.v[e]),
                this.o[e - 4 * this.data.p] !== r &&
                  ((this.o[e - 4 * this.data.p] = r), (this._omdf = !t));
          this._mdf = !t;
        }
      }),
      extendPrototype([DynamicPropertyContainer], GradientProperty),
      (SVGGradientFillStyleData.prototype.initGradientData = function (
        t,
        e,
        i
      ) {
        (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
          (this.s = PropertyFactory.getProp(t, e.s, 1, null, this)),
          (this.e = PropertyFactory.getProp(t, e.e, 1, null, this)),
          (this.h = PropertyFactory.getProp(t, e.h || { k: 0 }, 0, 0.01, this)),
          (this.a = PropertyFactory.getProp(
            t,
            e.a || { k: 0 },
            0,
            degToRads,
            this
          )),
          (this.g = new GradientProperty(t, e.g, this)),
          (this.style = i),
          (this.stops = []),
          this.setGradientData(i.pElem, e),
          this.setGradientOpacity(e, i),
          (this._isAnimated = !!this._isAnimated);
      }),
      (SVGGradientFillStyleData.prototype.setGradientData = function (t, e) {
        var i = createElementID(),
          r = createNS(1 === e.t ? "linearGradient" : "radialGradient");
        r.setAttribute("id", i),
          r.setAttribute("spreadMethod", "pad"),
          r.setAttribute("gradientUnits", "userSpaceOnUse");
        var s,
          a,
          n,
          o = [];
        for (n = 4 * e.g.p, a = 0; a < n; a += 4)
          (s = createNS("stop")), r.appendChild(s), o.push(s);
        t.setAttribute(
          "gf" === e.ty ? "fill" : "stroke",
          "url(" + getLocationHref() + "#" + i + ")"
        ),
          (this.gf = r),
          (this.cst = o);
      }),
      (SVGGradientFillStyleData.prototype.setGradientOpacity = function (t, e) {
        if (this.g._hasOpacity && !this.g._collapsable) {
          var i,
            r,
            s,
            a = createNS("mask"),
            n = createNS("path");
          a.appendChild(n);
          var o = createElementID(),
            h = createElementID();
          a.setAttribute("id", h);
          var l = createNS(1 === t.t ? "linearGradient" : "radialGradient");
          l.setAttribute("id", o),
            l.setAttribute("spreadMethod", "pad"),
            l.setAttribute("gradientUnits", "userSpaceOnUse"),
            (s = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length);
          var p = this.stops;
          for (r = 4 * t.g.p; r < s; r += 2)
            (i = createNS("stop")).setAttribute(
              "stop-color",
              "rgb(255,255,255)"
            ),
              l.appendChild(i),
              p.push(i);
          n.setAttribute(
            "gf" === t.ty ? "fill" : "stroke",
            "url(" + getLocationHref() + "#" + o + ")"
          ),
            "gs" === t.ty &&
              (n.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]),
              n.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]),
              1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)),
            (this.of = l),
            (this.ms = a),
            (this.ost = p),
            (this.maskId = h),
            (e.msElem = n);
        }
      }),
      extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData),
      extendPrototype(
        [SVGGradientFillStyleData, DynamicPropertyContainer],
        SVGGradientStrokeStyleData
      );
    var buildShapeString = function (t, e, i, r) {
        if (0 === e) return "";
        var s,
          a = t.o,
          n = t.i,
          o = t.v,
          h = " M" + r.applyToPointStringified(o[0][0], o[0][1]);
        for (s = 1; s < e; s += 1)
          h +=
            " C" +
            r.applyToPointStringified(a[s - 1][0], a[s - 1][1]) +
            " " +
            r.applyToPointStringified(n[s][0], n[s][1]) +
            " " +
            r.applyToPointStringified(o[s][0], o[s][1]);
        return (
          i &&
            e &&
            ((h +=
              " C" +
              r.applyToPointStringified(a[s - 1][0], a[s - 1][1]) +
              " " +
              r.applyToPointStringified(n[0][0], n[0][1]) +
              " " +
              r.applyToPointStringified(o[0][0], o[0][1])),
            (h += "z")),
          h
        );
      },
      SVGElementsRenderer = (function () {
        var t = new Matrix(),
          e = new Matrix();
        function i(t, e, i) {
          (i || e.transform.op._mdf) &&
            e.transform.container.setAttribute("opacity", e.transform.op.v),
            (i || e.transform.mProps._mdf) &&
              e.transform.container.setAttribute(
                "transform",
                e.transform.mProps.v.to2dCSS()
              );
        }
        function r() {}
        function s(i, r, s) {
          var a,
            n,
            o,
            h,
            l,
            p,
            f,
            m,
            c,
            d,
            u = r.styles.length,
            y = r.lvl;
          for (p = 0; p < u; p += 1) {
            if (((h = r.sh._mdf || s), r.styles[p].lvl < y)) {
              for (
                m = e.reset(),
                  c = y - r.styles[p].lvl,
                  d = r.transformers.length - 1;
                !h && c > 0;

              )
                (h = r.transformers[d].mProps._mdf || h), (c -= 1), (d -= 1);
              if (h)
                for (
                  c = y - r.styles[p].lvl, d = r.transformers.length - 1;
                  c > 0;

                )
                  m.multiply(r.transformers[d].mProps.v), (c -= 1), (d -= 1);
            } else m = t;
            if (((n = (f = r.sh.paths)._length), h)) {
              for (o = "", a = 0; a < n; a += 1)
                (l = f.shapes[a]) &&
                  l._length &&
                  (o += buildShapeString(l, l._length, l.c, m));
              r.caches[p] = o;
            } else o = r.caches[p];
            (r.styles[p].d += !0 === i.hd ? "" : o),
              (r.styles[p]._mdf = h || r.styles[p]._mdf);
          }
        }
        function a(t, e, i) {
          var r = e.style;
          (e.c._mdf || i) &&
            r.pElem.setAttribute(
              "fill",
              "rgb(" +
                bmFloor(e.c.v[0]) +
                "," +
                bmFloor(e.c.v[1]) +
                "," +
                bmFloor(e.c.v[2]) +
                ")"
            ),
            (e.o._mdf || i) && r.pElem.setAttribute("fill-opacity", e.o.v);
        }
        function n(t, e, i) {
          o(t, e, i), h(t, e, i);
        }
        function o(t, e, i) {
          var r,
            s,
            a,
            n,
            o,
            h = e.gf,
            l = e.g._hasOpacity,
            p = e.s.v,
            f = e.e.v;
          if (e.o._mdf || i) {
            var m = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
            e.style.pElem.setAttribute(m, e.o.v);
          }
          if (e.s._mdf || i) {
            var c = 1 === t.t ? "x1" : "cx",
              d = "x1" === c ? "y1" : "cy";
            h.setAttribute(c, p[0]),
              h.setAttribute(d, p[1]),
              l &&
                !e.g._collapsable &&
                (e.of.setAttribute(c, p[0]), e.of.setAttribute(d, p[1]));
          }
          if (e.g._cmdf || i) {
            r = e.cst;
            var u = e.g.c;
            for (a = r.length, s = 0; s < a; s += 1)
              (n = r[s]).setAttribute("offset", u[4 * s] + "%"),
                n.setAttribute(
                  "stop-color",
                  "rgb(" +
                    u[4 * s + 1] +
                    "," +
                    u[4 * s + 2] +
                    "," +
                    u[4 * s + 3] +
                    ")"
                );
          }
          if (l && (e.g._omdf || i)) {
            var y = e.g.o;
            for (
              a = (r = e.g._collapsable ? e.cst : e.ost).length, s = 0;
              s < a;
              s += 1
            )
              (n = r[s]),
                e.g._collapsable || n.setAttribute("offset", y[2 * s] + "%"),
                n.setAttribute("stop-opacity", y[2 * s + 1]);
          }
          if (1 === t.t)
            (e.e._mdf || i) &&
              (h.setAttribute("x2", f[0]),
              h.setAttribute("y2", f[1]),
              l &&
                !e.g._collapsable &&
                (e.of.setAttribute("x2", f[0]), e.of.setAttribute("y2", f[1])));
          else if (
            ((e.s._mdf || e.e._mdf || i) &&
              ((o = Math.sqrt(
                Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)
              )),
              h.setAttribute("r", o),
              l && !e.g._collapsable && e.of.setAttribute("r", o)),
            e.e._mdf || e.h._mdf || e.a._mdf || i)
          ) {
            o ||
              (o = Math.sqrt(
                Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)
              ));
            var g = Math.atan2(f[1] - p[1], f[0] - p[0]),
              v = e.h.v;
            v >= 1 ? (v = 0.99) : v <= -1 && (v = -0.99);
            var b = o * v,
              x = Math.cos(g + e.a.v) * b + p[0],
              P = Math.sin(g + e.a.v) * b + p[1];
            h.setAttribute("fx", x),
              h.setAttribute("fy", P),
              l &&
                !e.g._collapsable &&
                (e.of.setAttribute("fx", x), e.of.setAttribute("fy", P));
          }
        }
        function h(t, e, i) {
          var r = e.style,
            s = e.d;
          s &&
            (s._mdf || i) &&
            s.dashStr &&
            (r.pElem.setAttribute("stroke-dasharray", s.dashStr),
            r.pElem.setAttribute("stroke-dashoffset", s.dashoffset[0])),
            e.c &&
              (e.c._mdf || i) &&
              r.pElem.setAttribute(
                "stroke",
                "rgb(" +
                  bmFloor(e.c.v[0]) +
                  "," +
                  bmFloor(e.c.v[1]) +
                  "," +
                  bmFloor(e.c.v[2]) +
                  ")"
              ),
            (e.o._mdf || i) && r.pElem.setAttribute("stroke-opacity", e.o.v),
            (e.w._mdf || i) &&
              (r.pElem.setAttribute("stroke-width", e.w.v),
              r.msElem && r.msElem.setAttribute("stroke-width", e.w.v));
        }
        return {
          createRenderFunction: function (t) {
            switch (t.ty) {
              case "fl":
                return a;
              case "gf":
                return o;
              case "gs":
                return n;
              case "st":
                return h;
              case "sh":
              case "el":
              case "rc":
              case "sr":
                return s;
              case "tr":
                return i;
              case "no":
                return r;
              default:
                return null;
            }
          },
        };
      })();
    function SVGShapeElement(t, e, i) {
      (this.shapes = []),
        (this.shapesData = t.shapes),
        (this.stylesList = []),
        (this.shapeModifiers = []),
        (this.itemsData = []),
        (this.processedElements = []),
        (this.animatedContents = []),
        this.initElement(t, e, i),
        (this.prevViewData = []);
    }
    function LetterProps(t, e, i, r, s, a) {
      (this.o = t),
        (this.sw = e),
        (this.sc = i),
        (this.fc = r),
        (this.m = s),
        (this.p = a),
        (this._mdf = { o: !0, sw: !!e, sc: !!i, fc: !!r, m: !0, p: !0 });
    }
    function TextProperty(t, e) {
      (this._frameId = initialDefaultFrame),
        (this.pv = ""),
        (this.v = ""),
        (this.kf = !1),
        (this._isFirstFrame = !0),
        (this._mdf = !1),
        e.d && e.d.sid && (e.d = t.globalData.slotManager.getProp(e.d)),
        (this.data = e),
        (this.elem = t),
        (this.comp = this.elem.comp),
        (this.keysIndex = 0),
        (this.canResize = !1),
        (this.minimumFontSize = 1),
        (this.effectsSequence = []),
        (this.currentData = {
          ascent: 0,
          boxWidth: this.defaultBoxWidth,
          f: "",
          fStyle: "",
          fWeight: "",
          fc: "",
          j: "",
          justifyOffset: "",
          l: [],
          lh: 0,
          lineWidths: [],
          ls: "",
          of: "",
          s: "",
          sc: "",
          sw: 0,
          t: 0,
          tr: 0,
          sz: 0,
          ps: null,
          fillColorAnim: !1,
          strokeColorAnim: !1,
          strokeWidthAnim: !1,
          yOffset: 0,
          finalSize: 0,
          finalText: [],
          finalLineHeight: 0,
          __complete: !1,
        }),
        this.copyData(this.currentData, this.data.d.k[0].s),
        this.searchProperty() || this.completeTextData(this.currentData);
    }
    extendPrototype(
      [
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
      ],
      SVGShapeElement
    ),
      (SVGShapeElement.prototype.initSecondaryElement = function () {}),
      (SVGShapeElement.prototype.identityMatrix = new Matrix()),
      (SVGShapeElement.prototype.buildExpressionInterface = function () {}),
      (SVGShapeElement.prototype.createContent = function () {
        this.searchShapes(
          this.shapesData,
          this.itemsData,
          this.prevViewData,
          this.layerElement,
          0,
          [],
          !0
        ),
          this.filterUniqueShapes();
      }),
      (SVGShapeElement.prototype.filterUniqueShapes = function () {
        var t,
          e,
          i,
          r,
          s = this.shapes.length,
          a = this.stylesList.length,
          n = [],
          o = !1;
        for (i = 0; i < a; i += 1) {
          for (
            r = this.stylesList[i], o = !1, n.length = 0, t = 0;
            t < s;
            t += 1
          )
            -1 !== (e = this.shapes[t]).styles.indexOf(r) &&
              (n.push(e), (o = e._isAnimated || o));
          n.length > 1 && o && this.setShapesAsAnimated(n);
        }
      }),
      (SVGShapeElement.prototype.setShapesAsAnimated = function (t) {
        var e,
          i = t.length;
        for (e = 0; e < i; e += 1) t[e].setAsAnimated();
      }),
      (SVGShapeElement.prototype.createStyleElement = function (t, e) {
        var i,
          r = new SVGStyleData(t, e),
          s = r.pElem;
        if ("st" === t.ty) i = new SVGStrokeStyleData(this, t, r);
        else if ("fl" === t.ty) i = new SVGFillStyleData(this, t, r);
        else if ("gf" === t.ty || "gs" === t.ty) {
          (i = new (
            "gf" === t.ty
              ? SVGGradientFillStyleData
              : SVGGradientStrokeStyleData
          )(this, t, r)),
            this.globalData.defs.appendChild(i.gf),
            i.maskId &&
              (this.globalData.defs.appendChild(i.ms),
              this.globalData.defs.appendChild(i.of),
              s.setAttribute(
                "mask",
                "url(" + getLocationHref() + "#" + i.maskId + ")"
              ));
        } else "no" === t.ty && (i = new SVGNoStyleData(this, t, r));
        return (
          ("st" !== t.ty && "gs" !== t.ty) ||
            (s.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]),
            s.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]),
            s.setAttribute("fill-opacity", "0"),
            1 === t.lj && s.setAttribute("stroke-miterlimit", t.ml)),
          2 === t.r && s.setAttribute("fill-rule", "evenodd"),
          t.ln && s.setAttribute("id", t.ln),
          t.cl && s.setAttribute("class", t.cl),
          t.bm && (s.style["mix-blend-mode"] = getBlendMode(t.bm)),
          this.stylesList.push(r),
          this.addToAnimatedContents(t, i),
          i
        );
      }),
      (SVGShapeElement.prototype.createGroupElement = function (t) {
        var e = new ShapeGroupData();
        return (
          t.ln && e.gr.setAttribute("id", t.ln),
          t.cl && e.gr.setAttribute("class", t.cl),
          t.bm && (e.gr.style["mix-blend-mode"] = getBlendMode(t.bm)),
          e
        );
      }),
      (SVGShapeElement.prototype.createTransformElement = function (t, e) {
        var i = TransformPropertyFactory.getTransformProperty(this, t, this),
          r = new SVGTransformData(i, i.o, e);
        return this.addToAnimatedContents(t, r), r;
      }),
      (SVGShapeElement.prototype.createShapeElement = function (t, e, i) {
        var r = 4;
        "rc" === t.ty
          ? (r = 5)
          : "el" === t.ty
          ? (r = 6)
          : "sr" === t.ty && (r = 7);
        var s = new SVGShapeData(
          e,
          i,
          ShapePropertyFactory.getShapeProp(this, t, r, this)
        );
        return (
          this.shapes.push(s),
          this.addShapeToModifiers(s),
          this.addToAnimatedContents(t, s),
          s
        );
      }),
      (SVGShapeElement.prototype.addToAnimatedContents = function (t, e) {
        for (var i = 0, r = this.animatedContents.length; i < r; ) {
          if (this.animatedContents[i].element === e) return;
          i += 1;
        }
        this.animatedContents.push({
          fn: SVGElementsRenderer.createRenderFunction(t),
          element: e,
          data: t,
        });
      }),
      (SVGShapeElement.prototype.setElementStyles = function (t) {
        var e,
          i = t.styles,
          r = this.stylesList.length;
        for (e = 0; e < r; e += 1)
          this.stylesList[e].closed || i.push(this.stylesList[e]);
      }),
      (SVGShapeElement.prototype.reloadShapes = function () {
        var t;
        this._isFirstFrame = !0;
        var e = this.itemsData.length;
        for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
        for (
          this.searchShapes(
            this.shapesData,
            this.itemsData,
            this.prevViewData,
            this.layerElement,
            0,
            [],
            !0
          ),
            this.filterUniqueShapes(),
            e = this.dynamicProperties.length,
            t = 0;
          t < e;
          t += 1
        )
          this.dynamicProperties[t].getValue();
        this.renderModifiers();
      }),
      (SVGShapeElement.prototype.searchShapes = function (t, e, i, r, s, a, n) {
        var o,
          h,
          l,
          p,
          f,
          m,
          c = [].concat(a),
          d = t.length - 1,
          u = [],
          y = [];
        for (o = d; o >= 0; o -= 1) {
          if (
            ((m = this.searchProcessedElement(t[o]))
              ? (e[o] = i[m - 1])
              : (t[o]._render = n),
            "fl" === t[o].ty ||
              "st" === t[o].ty ||
              "gf" === t[o].ty ||
              "gs" === t[o].ty ||
              "no" === t[o].ty)
          )
            m
              ? (e[o].style.closed = !1)
              : (e[o] = this.createStyleElement(t[o], s)),
              t[o]._render &&
                e[o].style.pElem.parentNode !== r &&
                r.appendChild(e[o].style.pElem),
              u.push(e[o].style);
          else if ("gr" === t[o].ty) {
            if (m)
              for (l = e[o].it.length, h = 0; h < l; h += 1)
                e[o].prevViewData[h] = e[o].it[h];
            else e[o] = this.createGroupElement(t[o]);
            this.searchShapes(
              t[o].it,
              e[o].it,
              e[o].prevViewData,
              e[o].gr,
              s + 1,
              c,
              n
            ),
              t[o]._render &&
                e[o].gr.parentNode !== r &&
                r.appendChild(e[o].gr);
          } else
            "tr" === t[o].ty
              ? (m || (e[o] = this.createTransformElement(t[o], r)),
                (p = e[o].transform),
                c.push(p))
              : "sh" === t[o].ty ||
                "rc" === t[o].ty ||
                "el" === t[o].ty ||
                "sr" === t[o].ty
              ? (m || (e[o] = this.createShapeElement(t[o], c, s)),
                this.setElementStyles(e[o]))
              : "tm" === t[o].ty ||
                "rd" === t[o].ty ||
                "ms" === t[o].ty ||
                "pb" === t[o].ty ||
                "zz" === t[o].ty ||
                "op" === t[o].ty
              ? (m
                  ? ((f = e[o]).closed = !1)
                  : ((f = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]),
                    (e[o] = f),
                    this.shapeModifiers.push(f)),
                y.push(f))
              : "rp" === t[o].ty &&
                (m
                  ? ((f = e[o]).closed = !0)
                  : ((f = ShapeModifiers.getModifier(t[o].ty)),
                    (e[o] = f),
                    f.init(this, t, o, e),
                    this.shapeModifiers.push(f),
                    (n = !1)),
                y.push(f));
          this.addProcessedElement(t[o], o + 1);
        }
        for (d = u.length, o = 0; o < d; o += 1) u[o].closed = !0;
        for (d = y.length, o = 0; o < d; o += 1) y[o].closed = !0;
      }),
      (SVGShapeElement.prototype.renderInnerContent = function () {
        var t;
        this.renderModifiers();
        var e = this.stylesList.length;
        for (t = 0; t < e; t += 1) this.stylesList[t].reset();
        for (this.renderShape(), t = 0; t < e; t += 1)
          (this.stylesList[t]._mdf || this._isFirstFrame) &&
            (this.stylesList[t].msElem &&
              (this.stylesList[t].msElem.setAttribute(
                "d",
                this.stylesList[t].d
              ),
              (this.stylesList[t].d = "M0 0" + this.stylesList[t].d)),
            this.stylesList[t].pElem.setAttribute(
              "d",
              this.stylesList[t].d || "M0 0"
            ));
      }),
      (SVGShapeElement.prototype.renderShape = function () {
        var t,
          e,
          i = this.animatedContents.length;
        for (t = 0; t < i; t += 1)
          (e = this.animatedContents[t]),
            (this._isFirstFrame || e.element._isAnimated) &&
              !0 !== e.data &&
              e.fn(e.data, e.element, this._isFirstFrame);
      }),
      (SVGShapeElement.prototype.destroy = function () {
        this.destroyBaseElement(),
          (this.shapesData = null),
          (this.itemsData = null);
      }),
      (LetterProps.prototype.update = function (t, e, i, r, s, a) {
        (this._mdf.o = !1),
          (this._mdf.sw = !1),
          (this._mdf.sc = !1),
          (this._mdf.fc = !1),
          (this._mdf.m = !1),
          (this._mdf.p = !1);
        var n = !1;
        return (
          this.o !== t && ((this.o = t), (this._mdf.o = !0), (n = !0)),
          this.sw !== e && ((this.sw = e), (this._mdf.sw = !0), (n = !0)),
          this.sc !== i && ((this.sc = i), (this._mdf.sc = !0), (n = !0)),
          this.fc !== r && ((this.fc = r), (this._mdf.fc = !0), (n = !0)),
          this.m !== s && ((this.m = s), (this._mdf.m = !0), (n = !0)),
          !a.length ||
            (this.p[0] === a[0] &&
              this.p[1] === a[1] &&
              this.p[4] === a[4] &&
              this.p[5] === a[5] &&
              this.p[12] === a[12] &&
              this.p[13] === a[13]) ||
            ((this.p = a), (this._mdf.p = !0), (n = !0)),
          n
        );
      }),
      (TextProperty.prototype.defaultBoxWidth = [0, 0]),
      (TextProperty.prototype.copyData = function (t, e) {
        for (var i in e)
          Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        return t;
      }),
      (TextProperty.prototype.setCurrentData = function (t) {
        t.__complete || this.completeTextData(t),
          (this.currentData = t),
          (this.currentData.boxWidth =
            this.currentData.boxWidth || this.defaultBoxWidth),
          (this._mdf = !0);
      }),
      (TextProperty.prototype.searchProperty = function () {
        return this.searchKeyframes();
      }),
      (TextProperty.prototype.searchKeyframes = function () {
        return (
          (this.kf = this.data.d.k.length > 1),
          this.kf && this.addEffect(this.getKeyframeValue.bind(this)),
          this.kf
        );
      }),
      (TextProperty.prototype.addEffect = function (t) {
        this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
      }),
      (TextProperty.prototype.getValue = function (t) {
        if (
          (this.elem.globalData.frameId !== this.frameId &&
            this.effectsSequence.length) ||
          t
        ) {
          this.currentData.t = this.data.d.k[this.keysIndex].s.t;
          var e = this.currentData,
            i = this.keysIndex;
          if (this.lock) this.setCurrentData(this.currentData);
          else {
            var r;
            (this.lock = !0), (this._mdf = !1);
            var s = this.effectsSequence.length,
              a = t || this.data.d.k[this.keysIndex].s;
            for (r = 0; r < s; r += 1)
              a =
                i !== this.keysIndex
                  ? this.effectsSequence[r](a, a.t)
                  : this.effectsSequence[r](this.currentData, a.t);
            e !== a && this.setCurrentData(a),
              (this.v = this.currentData),
              (this.pv = this.v),
              (this.lock = !1),
              (this.frameId = this.elem.globalData.frameId);
          }
        }
      }),
      (TextProperty.prototype.getKeyframeValue = function () {
        for (
          var t = this.data.d.k,
            e = this.elem.comp.renderedFrame,
            i = 0,
            r = t.length;
          i <= r - 1 && !(i === r - 1 || t[i + 1].t > e);

        )
          i += 1;
        return (
          this.keysIndex !== i && (this.keysIndex = i),
          this.data.d.k[this.keysIndex].s
        );
      }),
      (TextProperty.prototype.buildFinalText = function (t) {
        for (
          var e, i, r = [], s = 0, a = t.length, n = !1, o = !1, h = "";
          s < a;

        )
          (n = o),
            (o = !1),
            (e = t.charCodeAt(s)),
            (h = t.charAt(s)),
            FontManager.isCombinedCharacter(e)
              ? (n = !0)
              : e >= 55296 && e <= 56319
              ? FontManager.isRegionalFlag(t, s)
                ? (h = t.substr(s, 14))
                : (i = t.charCodeAt(s + 1)) >= 56320 &&
                  i <= 57343 &&
                  (FontManager.isModifier(e, i)
                    ? ((h = t.substr(s, 2)), (n = !0))
                    : (h = FontManager.isFlagEmoji(t.substr(s, 4))
                        ? t.substr(s, 4)
                        : t.substr(s, 2)))
              : e > 56319
              ? ((i = t.charCodeAt(s + 1)),
                FontManager.isVariationSelector(e) && (n = !0))
              : FontManager.isZeroWidthJoiner(e) && ((n = !0), (o = !0)),
            n ? ((r[r.length - 1] += h), (n = !1)) : r.push(h),
            (s += h.length);
        return r;
      }),
      (TextProperty.prototype.completeTextData = function (t) {
        t.__complete = !0;
        var e,
          i,
          r,
          s,
          a,
          n,
          o,
          h = this.elem.globalData.fontManager,
          l = this.data,
          p = [],
          f = 0,
          m = l.m.g,
          c = 0,
          d = 0,
          u = 0,
          y = [],
          g = 0,
          v = 0,
          b = h.getFontByName(t.f),
          x = 0,
          P = getFontProperties(b);
        (t.fWeight = P.weight),
          (t.fStyle = P.style),
          (t.finalSize = t.s),
          (t.finalText = this.buildFinalText(t.t)),
          (i = t.finalText.length),
          (t.finalLineHeight = t.lh);
        var E,
          S = (t.tr / 1e3) * t.finalSize;
        if (t.sz)
          for (var C, _, A = !0, T = t.sz[0], M = t.sz[1]; A; ) {
            (C = 0),
              (g = 0),
              (i = (_ = this.buildFinalText(t.t)).length),
              (S = (t.tr / 1e3) * t.finalSize);
            var k = -1;
            for (e = 0; e < i; e += 1)
              (E = _[e].charCodeAt(0)),
                (r = !1),
                " " === _[e]
                  ? (k = e)
                  : (13 !== E && 3 !== E) ||
                    ((g = 0),
                    (r = !0),
                    (C += t.finalLineHeight || 1.2 * t.finalSize)),
                h.chars
                  ? ((o = h.getCharData(_[e], b.fStyle, b.fFamily)),
                    (x = r ? 0 : (o.w * t.finalSize) / 100))
                  : (x = h.measureText(_[e], t.f, t.finalSize)),
                g + x > T && " " !== _[e]
                  ? (-1 === k ? (i += 1) : (e = k),
                    (C += t.finalLineHeight || 1.2 * t.finalSize),
                    _.splice(e, k === e ? 1 : 0, "\r"),
                    (k = -1),
                    (g = 0))
                  : ((g += x), (g += S));
            (C += (b.ascent * t.finalSize) / 100),
              this.canResize && t.finalSize > this.minimumFontSize && M < C
                ? ((t.finalSize -= 1),
                  (t.finalLineHeight = (t.finalSize * t.lh) / t.s))
                : ((t.finalText = _), (i = t.finalText.length), (A = !1));
          }
        (g = -S), (x = 0);
        var D,
          F = 0;
        for (e = 0; e < i; e += 1)
          if (
            ((r = !1),
            13 === (E = (D = t.finalText[e]).charCodeAt(0)) || 3 === E
              ? ((F = 0),
                y.push(g),
                (v = g > v ? g : v),
                (g = -2 * S),
                (s = ""),
                (r = !0),
                (u += 1))
              : (s = D),
            h.chars
              ? ((o = h.getCharData(D, b.fStyle, h.getFontByName(t.f).fFamily)),
                (x = r ? 0 : (o.w * t.finalSize) / 100))
              : (x = h.measureText(s, t.f, t.finalSize)),
            " " === D ? (F += x + S) : ((g += x + S + F), (F = 0)),
            p.push({
              l: x,
              an: x,
              add: c,
              n: r,
              anIndexes: [],
              val: s,
              line: u,
              animatorJustifyOffset: 0,
            }),
            2 == m)
          ) {
            if (((c += x), "" === s || " " === s || e === i - 1)) {
              for (("" !== s && " " !== s) || (c -= x); d <= e; )
                (p[d].an = c), (p[d].ind = f), (p[d].extra = x), (d += 1);
              (f += 1), (c = 0);
            }
          } else if (3 == m) {
            if (((c += x), "" === s || e === i - 1)) {
              for ("" === s && (c -= x); d <= e; )
                (p[d].an = c), (p[d].ind = f), (p[d].extra = x), (d += 1);
              (c = 0), (f += 1);
            }
          } else (p[f].ind = f), (p[f].extra = 0), (f += 1);
        if (((t.l = p), (v = g > v ? g : v), y.push(g), t.sz))
          (t.boxWidth = t.sz[0]), (t.justifyOffset = 0);
        else
          switch (((t.boxWidth = v), t.j)) {
            case 1:
              t.justifyOffset = -t.boxWidth;
              break;
            case 2:
              t.justifyOffset = -t.boxWidth / 2;
              break;
            default:
              t.justifyOffset = 0;
          }
        t.lineWidths = y;
        var w,
          I,
          V,
          B,
          R = l.a;
        n = R.length;
        var L = [];
        for (a = 0; a < n; a += 1) {
          for (
            (w = R[a]).a.sc && (t.strokeColorAnim = !0),
              w.a.sw && (t.strokeWidthAnim = !0),
              (w.a.fc || w.a.fh || w.a.fs || w.a.fb) && (t.fillColorAnim = !0),
              B = 0,
              V = w.s.b,
              e = 0;
            e < i;
            e += 1
          )
            ((I = p[e]).anIndexes[a] = B),
              ((1 == V && "" !== I.val) ||
                (2 == V && "" !== I.val && " " !== I.val) ||
                (3 == V && (I.n || " " == I.val || e == i - 1)) ||
                (4 == V && (I.n || e == i - 1))) &&
                (1 === w.s.rn && L.push(B), (B += 1));
          l.a[a].s.totalChars = B;
          var G,
            z = -1;
          if (1 === w.s.rn)
            for (e = 0; e < i; e += 1)
              z != (I = p[e]).anIndexes[a] &&
                ((z = I.anIndexes[a]),
                (G = L.splice(Math.floor(Math.random() * L.length), 1)[0])),
                (I.anIndexes[a] = G);
        }
        (t.yOffset = t.finalLineHeight || 1.2 * t.finalSize),
          (t.ls = t.ls || 0),
          (t.ascent = (b.ascent * t.finalSize) / 100);
      }),
      (TextProperty.prototype.updateDocumentData = function (t, e) {
        e = void 0 === e ? this.keysIndex : e;
        var i = this.copyData({}, this.data.d.k[e].s);
        (i = this.copyData(i, t)),
          (this.data.d.k[e].s = i),
          this.recalculate(e),
          this.setCurrentData(i),
          this.elem.addDynamicProperty(this);
      }),
      (TextProperty.prototype.recalculate = function (t) {
        var e = this.data.d.k[t].s;
        (e.__complete = !1),
          (this.keysIndex = 0),
          (this._isFirstFrame = !0),
          this.getValue(e);
      }),
      (TextProperty.prototype.canResizeFont = function (t) {
        (this.canResize = t),
          this.recalculate(this.keysIndex),
          this.elem.addDynamicProperty(this);
      }),
      (TextProperty.prototype.setMinimumFontSize = function (t) {
        (this.minimumFontSize = Math.floor(t) || 1),
          this.recalculate(this.keysIndex),
          this.elem.addDynamicProperty(this);
      });
    var TextSelectorProp = (function () {
      var t = Math.max,
        e = Math.min,
        i = Math.floor;
      function r(t, e) {
        (this._currentTextLength = -1),
          (this.k = !1),
          (this.data = e),
          (this.elem = t),
          (this.comp = t.comp),
          (this.finalS = 0),
          (this.finalE = 0),
          this.initDynamicPropertyContainer(t),
          (this.s = PropertyFactory.getProp(t, e.s || { k: 0 }, 0, 0, this)),
          (this.e =
            "e" in e
              ? PropertyFactory.getProp(t, e.e, 0, 0, this)
              : { v: 100 }),
          (this.o = PropertyFactory.getProp(t, e.o || { k: 0 }, 0, 0, this)),
          (this.xe = PropertyFactory.getProp(t, e.xe || { k: 0 }, 0, 0, this)),
          (this.ne = PropertyFactory.getProp(t, e.ne || { k: 0 }, 0, 0, this)),
          (this.sm = PropertyFactory.getProp(
            t,
            e.sm || { k: 100 },
            0,
            0,
            this
          )),
          (this.a = PropertyFactory.getProp(t, e.a, 0, 0.01, this)),
          this.dynamicProperties.length || this.getValue();
      }
      return (
        (r.prototype = {
          getMult: function (r) {
            this._currentTextLength !==
              this.elem.textProperty.currentData.l.length && this.getValue();
            var s = 0,
              a = 0,
              n = 1,
              o = 1;
            this.ne.v > 0 ? (s = this.ne.v / 100) : (a = -this.ne.v / 100),
              this.xe.v > 0
                ? (n = 1 - this.xe.v / 100)
                : (o = 1 + this.xe.v / 100);
            var h = BezierFactory.getBezierEasing(s, a, n, o).get,
              l = 0,
              p = this.finalS,
              f = this.finalE,
              m = this.data.sh;
            if (2 === m)
              l = h(
                (l =
                  f === p
                    ? r >= f
                      ? 1
                      : 0
                    : t(0, e(0.5 / (f - p) + (r - p) / (f - p), 1)))
              );
            else if (3 === m)
              l = h(
                (l =
                  f === p
                    ? r >= f
                      ? 0
                      : 1
                    : 1 - t(0, e(0.5 / (f - p) + (r - p) / (f - p), 1)))
              );
            else if (4 === m)
              f === p
                ? (l = 0)
                : (l = t(0, e(0.5 / (f - p) + (r - p) / (f - p), 1))) < 0.5
                ? (l *= 2)
                : (l = 1 - 2 * (l - 0.5)),
                (l = h(l));
            else if (5 === m) {
              if (f === p) l = 0;
              else {
                var c = f - p,
                  d = -c / 2 + (r = e(t(0, r + 0.5 - p), f - p)),
                  u = c / 2;
                l = Math.sqrt(1 - (d * d) / (u * u));
              }
              l = h(l);
            } else
              6 === m
                ? (f === p
                    ? (l = 0)
                    : ((r = e(t(0, r + 0.5 - p), f - p)),
                      (l =
                        (1 + Math.cos(Math.PI + (2 * Math.PI * r) / (f - p))) /
                        2)),
                  (l = h(l)))
                : (r >= i(p) &&
                    (l = t(0, e(r - p < 0 ? e(f, 1) - (p - r) : f - r, 1))),
                  (l = h(l)));
            if (100 !== this.sm.v) {
              var y = 0.01 * this.sm.v;
              0 === y && (y = 1e-8);
              var g = 0.5 - 0.5 * y;
              l < g ? (l = 0) : (l = (l - g) / y) > 1 && (l = 1);
            }
            return l * this.a.v;
          },
          getValue: function (t) {
            this.iterateDynamicProperties(),
              (this._mdf = t || this._mdf),
              (this._currentTextLength =
                this.elem.textProperty.currentData.l.length || 0),
              t && 2 === this.data.r && (this.e.v = this._currentTextLength);
            var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars,
              i = this.o.v / e,
              r = this.s.v / e + i,
              s = this.e.v / e + i;
            if (r > s) {
              var a = r;
              (r = s), (s = a);
            }
            (this.finalS = r), (this.finalE = s);
          },
        }),
        extendPrototype([DynamicPropertyContainer], r),
        {
          getTextSelectorProp: function (t, e, i) {
            return new r(t, e, i);
          },
        }
      );
    })();
    function TextAnimatorDataProperty(t, e, i) {
      var r = { propType: !1 },
        s = PropertyFactory.getProp,
        a = e.a;
      (this.a = {
        r: a.r ? s(t, a.r, 0, degToRads, i) : r,
        rx: a.rx ? s(t, a.rx, 0, degToRads, i) : r,
        ry: a.ry ? s(t, a.ry, 0, degToRads, i) : r,
        sk: a.sk ? s(t, a.sk, 0, degToRads, i) : r,
        sa: a.sa ? s(t, a.sa, 0, degToRads, i) : r,
        s: a.s ? s(t, a.s, 1, 0.01, i) : r,
        a: a.a ? s(t, a.a, 1, 0, i) : r,
        o: a.o ? s(t, a.o, 0, 0.01, i) : r,
        p: a.p ? s(t, a.p, 1, 0, i) : r,
        sw: a.sw ? s(t, a.sw, 0, 0, i) : r,
        sc: a.sc ? s(t, a.sc, 1, 0, i) : r,
        fc: a.fc ? s(t, a.fc, 1, 0, i) : r,
        fh: a.fh ? s(t, a.fh, 0, 0, i) : r,
        fs: a.fs ? s(t, a.fs, 0, 0.01, i) : r,
        fb: a.fb ? s(t, a.fb, 0, 0.01, i) : r,
        t: a.t ? s(t, a.t, 0, 0, i) : r,
      }),
        (this.s = TextSelectorProp.getTextSelectorProp(t, e.s, i)),
        (this.s.t = e.s.t);
    }
    function TextAnimatorProperty(t, e, i) {
      (this._isFirstFrame = !0),
        (this._hasMaskedPath = !1),
        (this._frameId = -1),
        (this._textData = t),
        (this._renderType = e),
        (this._elem = i),
        (this._animatorsData = createSizedArray(this._textData.a.length)),
        (this._pathData = {}),
        (this._moreOptions = { alignment: {} }),
        (this.renderedLetters = []),
        (this.lettersChangedFlag = !1),
        this.initDynamicPropertyContainer(i);
    }
    function ITextElement() {}
    (TextAnimatorProperty.prototype.searchProperties = function () {
      var t,
        e,
        i = this._textData.a.length,
        r = PropertyFactory.getProp;
      for (t = 0; t < i; t += 1)
        (e = this._textData.a[t]),
          (this._animatorsData[t] = new TextAnimatorDataProperty(
            this._elem,
            e,
            this
          ));
      this._textData.p && "m" in this._textData.p
        ? ((this._pathData = {
            a: r(this._elem, this._textData.p.a, 0, 0, this),
            f: r(this._elem, this._textData.p.f, 0, 0, this),
            l: r(this._elem, this._textData.p.l, 0, 0, this),
            r: r(this._elem, this._textData.p.r, 0, 0, this),
            p: r(this._elem, this._textData.p.p, 0, 0, this),
            m: this._elem.maskManager.getMaskProperty(this._textData.p.m),
          }),
          (this._hasMaskedPath = !0))
        : (this._hasMaskedPath = !1),
        (this._moreOptions.alignment = r(
          this._elem,
          this._textData.m.a,
          1,
          0,
          this
        ));
    }),
      (TextAnimatorProperty.prototype.getMeasures = function (t, e) {
        if (
          ((this.lettersChangedFlag = e),
          this._mdf ||
            this._isFirstFrame ||
            e ||
            (this._hasMaskedPath && this._pathData.m._mdf))
        ) {
          this._isFirstFrame = !1;
          var i,
            r,
            s,
            a,
            n,
            o,
            h,
            l,
            p,
            f,
            m,
            c,
            d,
            u,
            y,
            g,
            v,
            b,
            x,
            P = this._moreOptions.alignment.v,
            E = this._animatorsData,
            S = this._textData,
            C = this.mHelper,
            _ = this._renderType,
            A = this.renderedLetters.length,
            T = t.l;
          if (this._hasMaskedPath) {
            if (
              ((x = this._pathData.m), !this._pathData.n || this._pathData._mdf)
            ) {
              var M,
                k = x.v;
              for (
                this._pathData.r.v && (k = k.reverse()),
                  n = { tLength: 0, segments: [] },
                  a = k._length - 1,
                  g = 0,
                  s = 0;
                s < a;
                s += 1
              )
                (M = bez.buildBezierData(
                  k.v[s],
                  k.v[s + 1],
                  [k.o[s][0] - k.v[s][0], k.o[s][1] - k.v[s][1]],
                  [k.i[s + 1][0] - k.v[s + 1][0], k.i[s + 1][1] - k.v[s + 1][1]]
                )),
                  (n.tLength += M.segmentLength),
                  n.segments.push(M),
                  (g += M.segmentLength);
              (s = a),
                x.v.c &&
                  ((M = bez.buildBezierData(
                    k.v[s],
                    k.v[0],
                    [k.o[s][0] - k.v[s][0], k.o[s][1] - k.v[s][1]],
                    [k.i[0][0] - k.v[0][0], k.i[0][1] - k.v[0][1]]
                  )),
                  (n.tLength += M.segmentLength),
                  n.segments.push(M),
                  (g += M.segmentLength)),
                (this._pathData.pi = n);
            }
            if (
              ((n = this._pathData.pi),
              (o = this._pathData.f.v),
              (m = 0),
              (f = 1),
              (l = 0),
              (p = !0),
              (u = n.segments),
              o < 0 && x.v.c)
            )
              for (
                n.tLength < Math.abs(o) && (o = -Math.abs(o) % n.tLength),
                  f = (d = u[(m = u.length - 1)].points).length - 1;
                o < 0;

              )
                (o += d[f].partialLength),
                  (f -= 1) < 0 && (f = (d = u[(m -= 1)].points).length - 1);
            (c = (d = u[m].points)[f - 1]), (y = (h = d[f]).partialLength);
          }
          (a = T.length), (i = 0), (r = 0);
          var D,
            F,
            w,
            I,
            V,
            B = 1.2 * t.finalSize * 0.714,
            R = !0;
          w = E.length;
          var L,
            G,
            z,
            O,
            N,
            H,
            q,
            j,
            W,
            $,
            Y,
            J,
            X = -1,
            Z = o,
            K = m,
            U = f,
            Q = -1,
            tt = "",
            et = this.defaultPropsArray;
          if (2 === t.j || 1 === t.j) {
            var it = 0,
              rt = 0,
              st = 2 === t.j ? -0.5 : -1,
              at = 0,
              nt = !0;
            for (s = 0; s < a; s += 1)
              if (T[s].n) {
                for (it && (it += rt); at < s; )
                  (T[at].animatorJustifyOffset = it), (at += 1);
                (it = 0), (nt = !0);
              } else {
                for (F = 0; F < w; F += 1)
                  (D = E[F].a).t.propType &&
                    (nt && 2 === t.j && (rt += D.t.v * st),
                    (V = E[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars))
                      .length
                      ? (it += D.t.v * V[0] * st)
                      : (it += D.t.v * V * st));
                nt = !1;
              }
            for (it && (it += rt); at < s; )
              (T[at].animatorJustifyOffset = it), (at += 1);
          }
          for (s = 0; s < a; s += 1) {
            if ((C.reset(), (O = 1), T[s].n))
              (i = 0),
                (r += t.yOffset),
                (r += R ? 1 : 0),
                (o = Z),
                (R = !1),
                this._hasMaskedPath &&
                  ((f = U),
                  (c = (d = u[(m = K)].points)[f - 1]),
                  (y = (h = d[f]).partialLength),
                  (l = 0)),
                (tt = ""),
                (Y = ""),
                (W = ""),
                (J = ""),
                (et = this.defaultPropsArray);
            else {
              if (this._hasMaskedPath) {
                if (Q !== T[s].line) {
                  switch (t.j) {
                    case 1:
                      o += g - t.lineWidths[T[s].line];
                      break;
                    case 2:
                      o += (g - t.lineWidths[T[s].line]) / 2;
                  }
                  Q = T[s].line;
                }
                X !== T[s].ind &&
                  (T[X] && (o += T[X].extra),
                  (o += T[s].an / 2),
                  (X = T[s].ind)),
                  (o += P[0] * T[s].an * 0.005);
                var ot = 0;
                for (F = 0; F < w; F += 1)
                  (D = E[F].a).p.propType &&
                    ((V = E[F].s.getMult(
                      T[s].anIndexes[F],
                      S.a[F].s.totalChars
                    )).length
                      ? (ot += D.p.v[0] * V[0])
                      : (ot += D.p.v[0] * V)),
                    D.a.propType &&
                      ((V = E[F].s.getMult(
                        T[s].anIndexes[F],
                        S.a[F].s.totalChars
                      )).length
                        ? (ot += D.a.v[0] * V[0])
                        : (ot += D.a.v[0] * V));
                for (
                  p = !0,
                    this._pathData.a.v &&
                      ((o =
                        0.5 * T[0].an +
                        ((g -
                          this._pathData.f.v -
                          0.5 * T[0].an -
                          0.5 * T[T.length - 1].an) *
                          X) /
                          (a - 1)),
                      (o += this._pathData.f.v));
                  p;

                )
                  l + y >= o + ot || !d
                    ? ((v = (o + ot - l) / h.partialLength),
                      (G = c.point[0] + (h.point[0] - c.point[0]) * v),
                      (z = c.point[1] + (h.point[1] - c.point[1]) * v),
                      C.translate(-P[0] * T[s].an * 0.005, -P[1] * B * 0.01),
                      (p = !1))
                    : d &&
                      ((l += h.partialLength),
                      (f += 1) >= d.length &&
                        ((f = 0),
                        u[(m += 1)]
                          ? (d = u[m].points)
                          : x.v.c
                          ? ((f = 0), (d = u[(m = 0)].points))
                          : ((l -= h.partialLength), (d = null))),
                      d && ((c = h), (y = (h = d[f]).partialLength)));
                (L = T[s].an / 2 - T[s].add), C.translate(-L, 0, 0);
              } else
                (L = T[s].an / 2 - T[s].add),
                  C.translate(-L, 0, 0),
                  C.translate(-P[0] * T[s].an * 0.005, -P[1] * B * 0.01, 0);
              for (F = 0; F < w; F += 1)
                (D = E[F].a).t.propType &&
                  ((V = E[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars)),
                  (0 === i && 0 === t.j) ||
                    (this._hasMaskedPath
                      ? V.length
                        ? (o += D.t.v * V[0])
                        : (o += D.t.v * V)
                      : V.length
                      ? (i += D.t.v * V[0])
                      : (i += D.t.v * V)));
              for (
                t.strokeWidthAnim && (H = t.sw || 0),
                  t.strokeColorAnim &&
                    (N = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]),
                  t.fillColorAnim && t.fc && (q = [t.fc[0], t.fc[1], t.fc[2]]),
                  F = 0;
                F < w;
                F += 1
              )
                (D = E[F].a).a.propType &&
                  ((V = E[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars))
                    .length
                    ? C.translate(
                        -D.a.v[0] * V[0],
                        -D.a.v[1] * V[1],
                        D.a.v[2] * V[2]
                      )
                    : C.translate(-D.a.v[0] * V, -D.a.v[1] * V, D.a.v[2] * V));
              for (F = 0; F < w; F += 1)
                (D = E[F].a).s.propType &&
                  ((V = E[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars))
                    .length
                    ? C.scale(
                        1 + (D.s.v[0] - 1) * V[0],
                        1 + (D.s.v[1] - 1) * V[1],
                        1
                      )
                    : C.scale(
                        1 + (D.s.v[0] - 1) * V,
                        1 + (D.s.v[1] - 1) * V,
                        1
                      ));
              for (F = 0; F < w; F += 1) {
                if (
                  ((D = E[F].a),
                  (V = E[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars)),
                  D.sk.propType &&
                    (V.length
                      ? C.skewFromAxis(-D.sk.v * V[0], D.sa.v * V[1])
                      : C.skewFromAxis(-D.sk.v * V, D.sa.v * V)),
                  D.r.propType &&
                    (V.length
                      ? C.rotateZ(-D.r.v * V[2])
                      : C.rotateZ(-D.r.v * V)),
                  D.ry.propType &&
                    (V.length
                      ? C.rotateY(D.ry.v * V[1])
                      : C.rotateY(D.ry.v * V)),
                  D.rx.propType &&
                    (V.length
                      ? C.rotateX(D.rx.v * V[0])
                      : C.rotateX(D.rx.v * V)),
                  D.o.propType &&
                    (V.length
                      ? (O += (D.o.v * V[0] - O) * V[0])
                      : (O += (D.o.v * V - O) * V)),
                  t.strokeWidthAnim &&
                    D.sw.propType &&
                    (V.length ? (H += D.sw.v * V[0]) : (H += D.sw.v * V)),
                  t.strokeColorAnim && D.sc.propType)
                )
                  for (j = 0; j < 3; j += 1)
                    V.length
                      ? (N[j] += (D.sc.v[j] - N[j]) * V[0])
                      : (N[j] += (D.sc.v[j] - N[j]) * V);
                if (t.fillColorAnim && t.fc) {
                  if (D.fc.propType)
                    for (j = 0; j < 3; j += 1)
                      V.length
                        ? (q[j] += (D.fc.v[j] - q[j]) * V[0])
                        : (q[j] += (D.fc.v[j] - q[j]) * V);
                  D.fh.propType &&
                    (q = V.length
                      ? addHueToRGB(q, D.fh.v * V[0])
                      : addHueToRGB(q, D.fh.v * V)),
                    D.fs.propType &&
                      (q = V.length
                        ? addSaturationToRGB(q, D.fs.v * V[0])
                        : addSaturationToRGB(q, D.fs.v * V)),
                    D.fb.propType &&
                      (q = V.length
                        ? addBrightnessToRGB(q, D.fb.v * V[0])
                        : addBrightnessToRGB(q, D.fb.v * V));
                }
              }
              for (F = 0; F < w; F += 1)
                (D = E[F].a).p.propType &&
                  ((V = E[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars)),
                  this._hasMaskedPath
                    ? V.length
                      ? C.translate(0, D.p.v[1] * V[0], -D.p.v[2] * V[1])
                      : C.translate(0, D.p.v[1] * V, -D.p.v[2] * V)
                    : V.length
                    ? C.translate(
                        D.p.v[0] * V[0],
                        D.p.v[1] * V[1],
                        -D.p.v[2] * V[2]
                      )
                    : C.translate(D.p.v[0] * V, D.p.v[1] * V, -D.p.v[2] * V));
              if (
                (t.strokeWidthAnim && (W = H < 0 ? 0 : H),
                t.strokeColorAnim &&
                  ($ =
                    "rgb(" +
                    Math.round(255 * N[0]) +
                    "," +
                    Math.round(255 * N[1]) +
                    "," +
                    Math.round(255 * N[2]) +
                    ")"),
                t.fillColorAnim &&
                  t.fc &&
                  (Y =
                    "rgb(" +
                    Math.round(255 * q[0]) +
                    "," +
                    Math.round(255 * q[1]) +
                    "," +
                    Math.round(255 * q[2]) +
                    ")"),
                this._hasMaskedPath)
              ) {
                if (
                  (C.translate(0, -t.ls),
                  C.translate(0, P[1] * B * 0.01 + r, 0),
                  this._pathData.p.v)
                ) {
                  b = (h.point[1] - c.point[1]) / (h.point[0] - c.point[0]);
                  var ht = (180 * Math.atan(b)) / Math.PI;
                  h.point[0] < c.point[0] && (ht += 180),
                    C.rotate((-ht * Math.PI) / 180);
                }
                C.translate(G, z, 0),
                  (o -= P[0] * T[s].an * 0.005),
                  T[s + 1] &&
                    X !== T[s + 1].ind &&
                    ((o += T[s].an / 2), (o += 0.001 * t.tr * t.finalSize));
              } else {
                switch (
                  (C.translate(i, r, 0),
                  t.ps && C.translate(t.ps[0], t.ps[1] + t.ascent, 0),
                  t.j)
                ) {
                  case 1:
                    C.translate(
                      T[s].animatorJustifyOffset +
                        t.justifyOffset +
                        (t.boxWidth - t.lineWidths[T[s].line]),
                      0,
                      0
                    );
                    break;
                  case 2:
                    C.translate(
                      T[s].animatorJustifyOffset +
                        t.justifyOffset +
                        (t.boxWidth - t.lineWidths[T[s].line]) / 2,
                      0,
                      0
                    );
                }
                C.translate(0, -t.ls),
                  C.translate(L, 0, 0),
                  C.translate(P[0] * T[s].an * 0.005, P[1] * B * 0.01, 0),
                  (i += T[s].l + 0.001 * t.tr * t.finalSize);
              }
              "html" === _
                ? (tt = C.toCSS())
                : "svg" === _
                ? (tt = C.to2dCSS())
                : (et = [
                    C.props[0],
                    C.props[1],
                    C.props[2],
                    C.props[3],
                    C.props[4],
                    C.props[5],
                    C.props[6],
                    C.props[7],
                    C.props[8],
                    C.props[9],
                    C.props[10],
                    C.props[11],
                    C.props[12],
                    C.props[13],
                    C.props[14],
                    C.props[15],
                  ]),
                (J = O);
            }
            A <= s
              ? ((I = new LetterProps(J, W, $, Y, tt, et)),
                this.renderedLetters.push(I),
                (A += 1),
                (this.lettersChangedFlag = !0))
              : ((I = this.renderedLetters[s]),
                (this.lettersChangedFlag =
                  I.update(J, W, $, Y, tt, et) || this.lettersChangedFlag));
          }
        }
      }),
      (TextAnimatorProperty.prototype.getValue = function () {
        this._elem.globalData.frameId !== this._frameId &&
          ((this._frameId = this._elem.globalData.frameId),
          this.iterateDynamicProperties());
      }),
      (TextAnimatorProperty.prototype.mHelper = new Matrix()),
      (TextAnimatorProperty.prototype.defaultPropsArray = []),
      extendPrototype([DynamicPropertyContainer], TextAnimatorProperty),
      (ITextElement.prototype.initElement = function (t, e, i) {
        (this.lettersChangedFlag = !0),
          this.initFrame(),
          this.initBaseData(t, e, i),
          (this.textProperty = new TextProperty(
            this,
            t.t,
            this.dynamicProperties
          )),
          (this.textAnimator = new TextAnimatorProperty(
            t.t,
            this.renderType,
            this
          )),
          this.initTransform(t, e, i),
          this.initHierarchy(),
          this.initRenderable(),
          this.initRendererElement(),
          this.createContainerElements(),
          this.createRenderableComponents(),
          this.createContent(),
          this.hide(),
          this.textAnimator.searchProperties(this.dynamicProperties);
      }),
      (ITextElement.prototype.prepareFrame = function (t) {
        (this._mdf = !1),
          this.prepareRenderableFrame(t),
          this.prepareProperties(t, this.isInRange);
      }),
      (ITextElement.prototype.createPathShape = function (t, e) {
        var i,
          r,
          s = e.length,
          a = "";
        for (i = 0; i < s; i += 1)
          "sh" === e[i].ty &&
            ((r = e[i].ks.k), (a += buildShapeString(r, r.i.length, !0, t)));
        return a;
      }),
      (ITextElement.prototype.updateDocumentData = function (t, e) {
        this.textProperty.updateDocumentData(t, e);
      }),
      (ITextElement.prototype.canResizeFont = function (t) {
        this.textProperty.canResizeFont(t);
      }),
      (ITextElement.prototype.setMinimumFontSize = function (t) {
        this.textProperty.setMinimumFontSize(t);
      }),
      (ITextElement.prototype.applyTextPropertiesToMatrix = function (
        t,
        e,
        i,
        r,
        s
      ) {
        switch (
          (t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0),
          e.translate(0, -t.ls, 0),
          t.j)
        ) {
          case 1:
            e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[i]), 0, 0);
            break;
          case 2:
            e.translate(
              t.justifyOffset + (t.boxWidth - t.lineWidths[i]) / 2,
              0,
              0
            );
        }
        e.translate(r, s, 0);
      }),
      (ITextElement.prototype.buildColor = function (t) {
        return (
          "rgb(" +
          Math.round(255 * t[0]) +
          "," +
          Math.round(255 * t[1]) +
          "," +
          Math.round(255 * t[2]) +
          ")"
        );
      }),
      (ITextElement.prototype.emptyProp = new LetterProps()),
      (ITextElement.prototype.destroy = function () {}),
      (ITextElement.prototype.validateText = function () {
        (this.textProperty._mdf || this.textProperty._isFirstFrame) &&
          (this.buildNewText(),
          (this.textProperty._isFirstFrame = !1),
          (this.textProperty._mdf = !1));
      });
    var emptyShapeData = { shapes: [] };
    function SVGTextLottieElement(t, e, i) {
      (this.textSpans = []),
        (this.renderType = "svg"),
        this.initElement(t, e, i);
    }
    function ISolidElement(t, e, i) {
      this.initElement(t, e, i);
    }
    function NullElement(t, e, i) {
      this.initFrame(),
        this.initBaseData(t, e, i),
        this.initFrame(),
        this.initTransform(t, e, i),
        this.initHierarchy();
    }
    function SVGRendererBase() {}
    function ICompElement() {}
    function SVGCompElement(t, e, i) {
      (this.layers = t.layers),
        (this.supports3d = !0),
        (this.completeLayers = !1),
        (this.pendingElements = []),
        (this.elements = this.layers
          ? createSizedArray(this.layers.length)
          : []),
        this.initElement(t, e, i),
        (this.tm = t.tm
          ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
          : { _placeholder: !0 });
    }
    function SVGRenderer(t, e) {
      (this.animationItem = t),
        (this.layers = null),
        (this.renderedFrame = -1),
        (this.svgElement = createNS("svg"));
      var i = "";
      if (e && e.title) {
        var r = createNS("title"),
          s = createElementID();
        r.setAttribute("id", s),
          (r.textContent = e.title),
          this.svgElement.appendChild(r),
          (i += s);
      }
      if (e && e.description) {
        var a = createNS("desc"),
          n = createElementID();
        a.setAttribute("id", n),
          (a.textContent = e.description),
          this.svgElement.appendChild(a),
          (i += " " + n);
      }
      i && this.svgElement.setAttribute("aria-labelledby", i);
      var o = createNS("defs");
      this.svgElement.appendChild(o);
      var h = createNS("g");
      this.svgElement.appendChild(h),
        (this.layerElement = h),
        (this.renderConfig = {
          preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
          imagePreserveAspectRatio:
            (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
          contentVisibility: (e && e.contentVisibility) || "visible",
          progressiveLoad: (e && e.progressiveLoad) || !1,
          hideOnTransparent: !(e && !1 === e.hideOnTransparent),
          viewBoxOnly: (e && e.viewBoxOnly) || !1,
          viewBoxSize: (e && e.viewBoxSize) || !1,
          className: (e && e.className) || "",
          id: (e && e.id) || "",
          focusable: e && e.focusable,
          filterSize: {
            width: (e && e.filterSize && e.filterSize.width) || "100%",
            height: (e && e.filterSize && e.filterSize.height) || "100%",
            x: (e && e.filterSize && e.filterSize.x) || "0%",
            y: (e && e.filterSize && e.filterSize.y) || "0%",
          },
          width: e && e.width,
          height: e && e.height,
          runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
        }),
        (this.globalData = {
          _mdf: !1,
          frameNum: -1,
          defs: o,
          renderConfig: this.renderConfig,
        }),
        (this.elements = []),
        (this.pendingElements = []),
        (this.destroyed = !1),
        (this.rendererType = "svg");
    }
    function ShapeTransformManager() {
      (this.sequences = {}),
        (this.sequenceList = []),
        (this.transform_key_count = 0);
    }
    extendPrototype(
      [
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement,
      ],
      SVGTextLottieElement
    ),
      (SVGTextLottieElement.prototype.createContent = function () {
        this.data.singleShape &&
          !this.globalData.fontManager.chars &&
          (this.textContainer = createNS("text"));
      }),
      (SVGTextLottieElement.prototype.buildTextContents = function (t) {
        for (var e = 0, i = t.length, r = [], s = ""; e < i; )
          t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3)
            ? (r.push(s), (s = ""))
            : (s += t[e]),
            (e += 1);
        return r.push(s), r;
      }),
      (SVGTextLottieElement.prototype.buildShapeData = function (t, e) {
        if (t.shapes && t.shapes.length) {
          var i = t.shapes[0];
          if (i.it) {
            var r = i.it[i.it.length - 1];
            r.s && ((r.s.k[0] = e), (r.s.k[1] = e));
          }
        }
        return t;
      }),
      (SVGTextLottieElement.prototype.buildNewText = function () {
        var t, e;
        this.addDynamicProperty(this);
        var i = this.textProperty.currentData;
        (this.renderedLetters = createSizedArray(i ? i.l.length : 0)),
          i.fc
            ? this.layerElement.setAttribute("fill", this.buildColor(i.fc))
            : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"),
          i.sc &&
            (this.layerElement.setAttribute("stroke", this.buildColor(i.sc)),
            this.layerElement.setAttribute("stroke-width", i.sw)),
          this.layerElement.setAttribute("font-size", i.finalSize);
        var r = this.globalData.fontManager.getFontByName(i.f);
        if (r.fClass) this.layerElement.setAttribute("class", r.fClass);
        else {
          this.layerElement.setAttribute("font-family", r.fFamily);
          var s = i.fWeight,
            a = i.fStyle;
          this.layerElement.setAttribute("font-style", a),
            this.layerElement.setAttribute("font-weight", s);
        }
        this.layerElement.setAttribute("aria-label", i.t);
        var n,
          o = i.l || [],
          h = !!this.globalData.fontManager.chars;
        e = o.length;
        var l = this.mHelper,
          p = this.data.singleShape,
          f = 0,
          m = 0,
          c = !0,
          d = 0.001 * i.tr * i.finalSize;
        if (!p || h || i.sz) {
          var u,
            y = this.textSpans.length;
          for (t = 0; t < e; t += 1) {
            if (
              (this.textSpans[t] ||
                (this.textSpans[t] = {
                  span: null,
                  childSpan: null,
                  glyph: null,
                }),
              !h || !p || 0 === t)
            ) {
              if (
                ((n =
                  y > t ? this.textSpans[t].span : createNS(h ? "g" : "text")),
                y <= t)
              ) {
                if (
                  (n.setAttribute("stroke-linecap", "butt"),
                  n.setAttribute("stroke-linejoin", "round"),
                  n.setAttribute("stroke-miterlimit", "4"),
                  (this.textSpans[t].span = n),
                  h)
                ) {
                  var g = createNS("g");
                  n.appendChild(g), (this.textSpans[t].childSpan = g);
                }
                (this.textSpans[t].span = n), this.layerElement.appendChild(n);
              }
              n.style.display = "inherit";
            }
            if (
              (l.reset(),
              p &&
                (o[t].n &&
                  ((f = -d), (m += i.yOffset), (m += c ? 1 : 0), (c = !1)),
                this.applyTextPropertiesToMatrix(i, l, o[t].line, f, m),
                (f += o[t].l || 0),
                (f += d)),
              h)
            ) {
              var v;
              if (
                1 ===
                (u = this.globalData.fontManager.getCharData(
                  i.finalText[t],
                  r.fStyle,
                  this.globalData.fontManager.getFontByName(i.f).fFamily
                )).t
              )
                v = new SVGCompElement(u.data, this.globalData, this);
              else {
                var b = emptyShapeData;
                u.data &&
                  u.data.shapes &&
                  (b = this.buildShapeData(u.data, i.finalSize)),
                  (v = new SVGShapeElement(b, this.globalData, this));
              }
              if (this.textSpans[t].glyph) {
                var x = this.textSpans[t].glyph;
                this.textSpans[t].childSpan.removeChild(x.layerElement),
                  x.destroy();
              }
              (this.textSpans[t].glyph = v),
                (v._debug = !0),
                v.prepareFrame(0),
                v.renderFrame(),
                this.textSpans[t].childSpan.appendChild(v.layerElement),
                1 === u.t &&
                  this.textSpans[t].childSpan.setAttribute(
                    "transform",
                    "scale(" + i.finalSize / 100 + "," + i.finalSize / 100 + ")"
                  );
            } else
              p &&
                n.setAttribute(
                  "transform",
                  "translate(" + l.props[12] + "," + l.props[13] + ")"
                ),
                (n.textContent = o[t].val),
                n.setAttributeNS(
                  "http://www.w3.org/XML/1998/namespace",
                  "xml:space",
                  "preserve"
                );
          }
          p && n && n.setAttribute("d", "");
        } else {
          var P = this.textContainer,
            E = "start";
          switch (i.j) {
            case 1:
              E = "end";
              break;
            case 2:
              E = "middle";
              break;
            default:
              E = "start";
          }
          P.setAttribute("text-anchor", E), P.setAttribute("letter-spacing", d);
          var S = this.buildTextContents(i.finalText);
          for (
            e = S.length, m = i.ps ? i.ps[1] + i.ascent : 0, t = 0;
            t < e;
            t += 1
          )
            ((n = this.textSpans[t].span || createNS("tspan")).textContent =
              S[t]),
              n.setAttribute("x", 0),
              n.setAttribute("y", m),
              (n.style.display = "inherit"),
              P.appendChild(n),
              this.textSpans[t] ||
                (this.textSpans[t] = { span: null, glyph: null }),
              (this.textSpans[t].span = n),
              (m += i.finalLineHeight);
          this.layerElement.appendChild(P);
        }
        for (; t < this.textSpans.length; )
          (this.textSpans[t].span.style.display = "none"), (t += 1);
        this._sizeChanged = !0;
      }),
      (SVGTextLottieElement.prototype.sourceRectAtTime = function () {
        if (
          (this.prepareFrame(this.comp.renderedFrame - this.data.st),
          this.renderInnerContent(),
          this._sizeChanged)
        ) {
          this._sizeChanged = !1;
          var t = this.layerElement.getBBox();
          this.bbox = { top: t.y, left: t.x, width: t.width, height: t.height };
        }
        return this.bbox;
      }),
      (SVGTextLottieElement.prototype.getValue = function () {
        var t,
          e,
          i = this.textSpans.length;
        for (this.renderedFrame = this.comp.renderedFrame, t = 0; t < i; t += 1)
          (e = this.textSpans[t].glyph) &&
            (e.prepareFrame(this.comp.renderedFrame - this.data.st),
            e._mdf && (this._mdf = !0));
      }),
      (SVGTextLottieElement.prototype.renderInnerContent = function () {
        if (
          (this.validateText(),
          (!this.data.singleShape || this._mdf) &&
            (this.textAnimator.getMeasures(
              this.textProperty.currentData,
              this.lettersChangedFlag
            ),
            this.lettersChangedFlag || this.textAnimator.lettersChangedFlag))
        ) {
          var t, e;
          this._sizeChanged = !0;
          var i,
            r,
            s,
            a = this.textAnimator.renderedLetters,
            n = this.textProperty.currentData.l;
          for (e = n.length, t = 0; t < e; t += 1)
            n[t].n ||
              ((i = a[t]),
              (r = this.textSpans[t].span),
              (s = this.textSpans[t].glyph) && s.renderFrame(),
              i._mdf.m && r.setAttribute("transform", i.m),
              i._mdf.o && r.setAttribute("opacity", i.o),
              i._mdf.sw && r.setAttribute("stroke-width", i.sw),
              i._mdf.sc && r.setAttribute("stroke", i.sc),
              i._mdf.fc && r.setAttribute("fill", i.fc));
        }
      }),
      extendPrototype([IImageElement], ISolidElement),
      (ISolidElement.prototype.createContent = function () {
        var t = createNS("rect");
        t.setAttribute("width", this.data.sw),
          t.setAttribute("height", this.data.sh),
          t.setAttribute("fill", this.data.sc),
          this.layerElement.appendChild(t);
      }),
      (NullElement.prototype.prepareFrame = function (t) {
        this.prepareProperties(t, !0);
      }),
      (NullElement.prototype.renderFrame = function () {}),
      (NullElement.prototype.getBaseElement = function () {
        return null;
      }),
      (NullElement.prototype.destroy = function () {}),
      (NullElement.prototype.sourceRectAtTime = function () {}),
      (NullElement.prototype.hide = function () {}),
      extendPrototype(
        [BaseElement, TransformElement, HierarchyElement, FrameElement],
        NullElement
      ),
      extendPrototype([BaseRenderer], SVGRendererBase),
      (SVGRendererBase.prototype.createNull = function (t) {
        return new NullElement(t, this.globalData, this);
      }),
      (SVGRendererBase.prototype.createShape = function (t) {
        return new SVGShapeElement(t, this.globalData, this);
      }),
      (SVGRendererBase.prototype.createText = function (t) {
        return new SVGTextLottieElement(t, this.globalData, this);
      }),
      (SVGRendererBase.prototype.createImage = function (t) {
        return new IImageElement(t, this.globalData, this);
      }),
      (SVGRendererBase.prototype.createSolid = function (t) {
        return new ISolidElement(t, this.globalData, this);
      }),
      (SVGRendererBase.prototype.configAnimation = function (t) {
        this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"),
          this.svgElement.setAttribute(
            "xmlns:xlink",
            "http://www.w3.org/1999/xlink"
          ),
          this.renderConfig.viewBoxSize
            ? this.svgElement.setAttribute(
                "viewBox",
                this.renderConfig.viewBoxSize
              )
            : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h),
          this.renderConfig.viewBoxOnly ||
            (this.svgElement.setAttribute("width", t.w),
            this.svgElement.setAttribute("height", t.h),
            (this.svgElement.style.width = "100%"),
            (this.svgElement.style.height = "100%"),
            (this.svgElement.style.transform = "translate3d(0,0,0)"),
            (this.svgElement.style.contentVisibility =
              this.renderConfig.contentVisibility)),
          this.renderConfig.width &&
            this.svgElement.setAttribute("width", this.renderConfig.width),
          this.renderConfig.height &&
            this.svgElement.setAttribute("height", this.renderConfig.height),
          this.renderConfig.className &&
            this.svgElement.setAttribute("class", this.renderConfig.className),
          this.renderConfig.id &&
            this.svgElement.setAttribute("id", this.renderConfig.id),
          void 0 !== this.renderConfig.focusable &&
            this.svgElement.setAttribute(
              "focusable",
              this.renderConfig.focusable
            ),
          this.svgElement.setAttribute(
            "preserveAspectRatio",
            this.renderConfig.preserveAspectRatio
          ),
          this.animationItem.wrapper.appendChild(this.svgElement);
        var e = this.globalData.defs;
        this.setupGlobalData(t, e),
          (this.globalData.progressiveLoad = this.renderConfig.progressiveLoad),
          (this.data = t);
        var i = createNS("clipPath"),
          r = createNS("rect");
        r.setAttribute("width", t.w),
          r.setAttribute("height", t.h),
          r.setAttribute("x", 0),
          r.setAttribute("y", 0);
        var s = createElementID();
        i.setAttribute("id", s),
          i.appendChild(r),
          this.layerElement.setAttribute(
            "clip-path",
            "url(" + getLocationHref() + "#" + s + ")"
          ),
          e.appendChild(i),
          (this.layers = t.layers),
          (this.elements = createSizedArray(t.layers.length));
      }),
      (SVGRendererBase.prototype.destroy = function () {
        var t;
        this.animationItem.wrapper &&
          (this.animationItem.wrapper.innerText = ""),
          (this.layerElement = null),
          (this.globalData.defs = null);
        var e = this.layers ? this.layers.length : 0;
        for (t = 0; t < e; t += 1)
          this.elements[t] &&
            this.elements[t].destroy &&
            this.elements[t].destroy();
        (this.elements.length = 0),
          (this.destroyed = !0),
          (this.animationItem = null);
      }),
      (SVGRendererBase.prototype.updateContainerSize = function () {}),
      (SVGRendererBase.prototype.findIndexByInd = function (t) {
        var e = 0,
          i = this.layers.length;
        for (e = 0; e < i; e += 1) if (this.layers[e].ind === t) return e;
        return -1;
      }),
      (SVGRendererBase.prototype.buildItem = function (t) {
        var e = this.elements;
        if (!e[t] && 99 !== this.layers[t].ty) {
          e[t] = !0;
          var i = this.createItem(this.layers[t]);
          if (
            ((e[t] = i),
            getExpressionsPlugin() &&
              (0 === this.layers[t].ty &&
                this.globalData.projectInterface.registerComposition(i),
              i.initExpressions()),
            this.appendElementInPos(i, t),
            this.layers[t].tt)
          ) {
            var r =
              "tp" in this.layers[t]
                ? this.findIndexByInd(this.layers[t].tp)
                : t - 1;
            if (-1 === r) return;
            if (this.elements[r] && !0 !== this.elements[r]) {
              var s = e[r].getMatte(this.layers[t].tt);
              i.setMatte(s);
            } else this.buildItem(r), this.addPendingElement(i);
          }
        }
      }),
      (SVGRendererBase.prototype.checkPendingElements = function () {
        for (; this.pendingElements.length; ) {
          var t = this.pendingElements.pop();
          if ((t.checkParenting(), t.data.tt))
            for (var e = 0, i = this.elements.length; e < i; ) {
              if (this.elements[e] === t) {
                var r = "tp" in t.data ? this.findIndexByInd(t.data.tp) : e - 1,
                  s = this.elements[r].getMatte(this.layers[e].tt);
                t.setMatte(s);
                break;
              }
              e += 1;
            }
        }
      }),
      (SVGRendererBase.prototype.renderFrame = function (t) {
        if (this.renderedFrame !== t && !this.destroyed) {
          var e;
          null === t ? (t = this.renderedFrame) : (this.renderedFrame = t),
            (this.globalData.frameNum = t),
            (this.globalData.frameId += 1),
            (this.globalData.projectInterface.currentFrame = t),
            (this.globalData._mdf = !1);
          var i = this.layers.length;
          for (
            this.completeLayers || this.checkLayers(t), e = i - 1;
            e >= 0;
            e -= 1
          )
            (this.completeLayers || this.elements[e]) &&
              this.elements[e].prepareFrame(t - this.layers[e].st);
          if (this.globalData._mdf)
            for (e = 0; e < i; e += 1)
              (this.completeLayers || this.elements[e]) &&
                this.elements[e].renderFrame();
        }
      }),
      (SVGRendererBase.prototype.appendElementInPos = function (t, e) {
        var i = t.getBaseElement();
        if (i) {
          for (var r, s = 0; s < e; )
            this.elements[s] &&
              !0 !== this.elements[s] &&
              this.elements[s].getBaseElement() &&
              (r = this.elements[s].getBaseElement()),
              (s += 1);
          r
            ? this.layerElement.insertBefore(i, r)
            : this.layerElement.appendChild(i);
        }
      }),
      (SVGRendererBase.prototype.hide = function () {
        this.layerElement.style.display = "none";
      }),
      (SVGRendererBase.prototype.show = function () {
        this.layerElement.style.display = "block";
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          HierarchyElement,
          FrameElement,
          RenderableDOMElement,
        ],
        ICompElement
      ),
      (ICompElement.prototype.initElement = function (t, e, i) {
        this.initFrame(),
          this.initBaseData(t, e, i),
          this.initTransform(t, e, i),
          this.initRenderable(),
          this.initHierarchy(),
          this.initRendererElement(),
          this.createContainerElements(),
          this.createRenderableComponents(),
          (!this.data.xt && e.progressiveLoad) || this.buildAllItems(),
          this.hide();
      }),
      (ICompElement.prototype.prepareFrame = function (t) {
        if (
          ((this._mdf = !1),
          this.prepareRenderableFrame(t),
          this.prepareProperties(t, this.isInRange),
          this.isInRange || this.data.xt)
        ) {
          if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
          else {
            var e = this.tm.v;
            e === this.data.op && (e = this.data.op - 1),
              (this.renderedFrame = e);
          }
          var i,
            r = this.elements.length;
          for (
            this.completeLayers || this.checkLayers(this.renderedFrame),
              i = r - 1;
            i >= 0;
            i -= 1
          )
            (this.completeLayers || this.elements[i]) &&
              (this.elements[i].prepareFrame(
                this.renderedFrame - this.layers[i].st
              ),
              this.elements[i]._mdf && (this._mdf = !0));
        }
      }),
      (ICompElement.prototype.renderInnerContent = function () {
        var t,
          e = this.layers.length;
        for (t = 0; t < e; t += 1)
          (this.completeLayers || this.elements[t]) &&
            this.elements[t].renderFrame();
      }),
      (ICompElement.prototype.setElements = function (t) {
        this.elements = t;
      }),
      (ICompElement.prototype.getElements = function () {
        return this.elements;
      }),
      (ICompElement.prototype.destroyElements = function () {
        var t,
          e = this.layers.length;
        for (t = 0; t < e; t += 1)
          this.elements[t] && this.elements[t].destroy();
      }),
      (ICompElement.prototype.destroy = function () {
        this.destroyElements(), this.destroyBaseElement();
      }),
      extendPrototype(
        [SVGRendererBase, ICompElement, SVGBaseElement],
        SVGCompElement
      ),
      (SVGCompElement.prototype.createComp = function (t) {
        return new SVGCompElement(t, this.globalData, this);
      }),
      extendPrototype([SVGRendererBase], SVGRenderer),
      (SVGRenderer.prototype.createComp = function (t) {
        return new SVGCompElement(t, this.globalData, this);
      }),
      (ShapeTransformManager.prototype = {
        addTransformSequence: function (t) {
          var e,
            i = t.length,
            r = "_";
          for (e = 0; e < i; e += 1) r += t[e].transform.key + "_";
          var s = this.sequences[r];
          return (
            s ||
              ((s = {
                transforms: [].concat(t),
                finalTransform: new Matrix(),
                _mdf: !1,
              }),
              (this.sequences[r] = s),
              this.sequenceList.push(s)),
            s
          );
        },
        processSequence: function (t, e) {
          for (var i = 0, r = t.transforms.length, s = e; i < r && !e; ) {
            if (t.transforms[i].transform.mProps._mdf) {
              s = !0;
              break;
            }
            i += 1;
          }
          if (s)
            for (t.finalTransform.reset(), i = r - 1; i >= 0; i -= 1)
              t.finalTransform.multiply(t.transforms[i].transform.mProps.v);
          t._mdf = s;
        },
        processSequences: function (t) {
          var e,
            i = this.sequenceList.length;
          for (e = 0; e < i; e += 1)
            this.processSequence(this.sequenceList[e], t);
        },
        getNewKey: function () {
          return (
            (this.transform_key_count += 1), "_" + this.transform_key_count
          );
        },
      });
    var lumaLoader = function () {
      var t = "__lottie_element_luma_buffer",
        e = null,
        i = null,
        r = null;
      function s() {
        var s, a, n;
        e ||
          ((s = createNS("svg")),
          (a = createNS("filter")),
          (n = createNS("feColorMatrix")),
          a.setAttribute("id", t),
          n.setAttribute("type", "matrix"),
          n.setAttribute("color-interpolation-filters", "sRGB"),
          n.setAttribute(
            "values",
            "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"
          ),
          a.appendChild(n),
          s.appendChild(a),
          s.setAttribute("id", t + "_svg"),
          featureSupport.svgLumaHidden && (s.style.display = "none"),
          (r = s),
          document.body.appendChild(r),
          (e = createTag("canvas")),
          ((i = e.getContext("2d")).filter = "url(#" + t + ")"),
          (i.fillStyle = "rgba(0,0,0,0)"),
          i.fillRect(0, 0, 1, 1));
      }
      return {
        load: s,
        get: function (r) {
          return (
            e || s(),
            (e.width = r.width),
            (e.height = r.height),
            (i.filter = "url(#" + t + ")"),
            e
          );
        },
      };
    };
    function createCanvas(t, e) {
      if (featureSupport.offscreenCanvas) return new OffscreenCanvas(t, e);
      var i = createTag("canvas");
      return (i.width = t), (i.height = e), i;
    }
    var assetLoader = {
        loadLumaCanvas: lumaLoader.load,
        getLumaCanvas: lumaLoader.get,
        createCanvas: createCanvas,
      },
      registeredEffects = {};
    function CVEffects(t) {
      var e,
        i,
        r = t.data.ef ? t.data.ef.length : 0;
      for (this.filters = [], e = 0; e < r; e += 1) {
        i = null;
        var s = t.data.ef[e].ty;
        if (registeredEffects[s])
          i = new (0, registeredEffects[s].effect)(
            t.effectsManager.effectElements[e],
            t
          );
        i && this.filters.push(i);
      }
      this.filters.length && t.addRenderableComponent(this);
    }
    function registerEffect(t, e) {
      registeredEffects[t] = { effect: e };
    }
    function CVMaskElement(t, e) {
      var i;
      (this.data = t),
        (this.element = e),
        (this.masksProperties = this.data.masksProperties || []),
        (this.viewData = createSizedArray(this.masksProperties.length));
      var r = this.masksProperties.length,
        s = !1;
      for (i = 0; i < r; i += 1)
        "n" !== this.masksProperties[i].mode && (s = !0),
          (this.viewData[i] = ShapePropertyFactory.getShapeProp(
            this.element,
            this.masksProperties[i],
            3
          ));
      (this.hasMasks = s), s && this.element.addRenderableComponent(this);
    }
    function CVBaseElement() {}
    (CVEffects.prototype.renderFrame = function (t) {
      var e,
        i = this.filters.length;
      for (e = 0; e < i; e += 1) this.filters[e].renderFrame(t);
    }),
      (CVEffects.prototype.getEffects = function (t) {
        var e,
          i = this.filters.length,
          r = [];
        for (e = 0; e < i; e += 1)
          this.filters[e].type === t && r.push(this.filters[e]);
        return r;
      }),
      (CVMaskElement.prototype.renderFrame = function () {
        if (this.hasMasks) {
          var t,
            e,
            i,
            r,
            s = this.element.finalTransform.mat,
            a = this.element.canvasContext,
            n = this.masksProperties.length;
          for (a.beginPath(), t = 0; t < n; t += 1)
            if ("n" !== this.masksProperties[t].mode) {
              var o;
              this.masksProperties[t].inv &&
                (a.moveTo(0, 0),
                a.lineTo(this.element.globalData.compSize.w, 0),
                a.lineTo(
                  this.element.globalData.compSize.w,
                  this.element.globalData.compSize.h
                ),
                a.lineTo(0, this.element.globalData.compSize.h),
                a.lineTo(0, 0)),
                (r = this.viewData[t].v),
                (e = s.applyToPointArray(r.v[0][0], r.v[0][1], 0)),
                a.moveTo(e[0], e[1]);
              var h = r._length;
              for (o = 1; o < h; o += 1)
                (i = s.applyToTriplePoints(r.o[o - 1], r.i[o], r.v[o])),
                  a.bezierCurveTo(i[0], i[1], i[2], i[3], i[4], i[5]);
              (i = s.applyToTriplePoints(r.o[o - 1], r.i[0], r.v[0])),
                a.bezierCurveTo(i[0], i[1], i[2], i[3], i[4], i[5]);
            }
          this.element.globalData.renderer.save(!0), a.clip();
        }
      }),
      (CVMaskElement.prototype.getMaskProperty =
        MaskElement.prototype.getMaskProperty),
      (CVMaskElement.prototype.destroy = function () {
        this.element = null;
      });
    var operationsMap = {
      1: "source-in",
      2: "source-out",
      3: "source-in",
      4: "source-out",
    };
    function CVShapeData(t, e, i, r) {
      (this.styledShapes = []), (this.tr = [0, 0, 0, 0, 0, 0]);
      var s,
        a = 4;
      "rc" === e.ty
        ? (a = 5)
        : "el" === e.ty
        ? (a = 6)
        : "sr" === e.ty && (a = 7),
        (this.sh = ShapePropertyFactory.getShapeProp(t, e, a, t));
      var n,
        o = i.length;
      for (s = 0; s < o; s += 1)
        i[s].closed ||
          ((n = {
            transforms: r.addTransformSequence(i[s].transforms),
            trNodes: [],
          }),
          this.styledShapes.push(n),
          i[s].elements.push(n));
    }
    function CVShapeElement(t, e, i) {
      (this.shapes = []),
        (this.shapesData = t.shapes),
        (this.stylesList = []),
        (this.itemsData = []),
        (this.prevViewData = []),
        (this.shapeModifiers = []),
        (this.processedElements = []),
        (this.transformsManager = new ShapeTransformManager()),
        this.initElement(t, e, i);
    }
    function CVTextElement(t, e, i) {
      (this.textSpans = []),
        (this.yOffset = 0),
        (this.fillColorAnim = !1),
        (this.strokeColorAnim = !1),
        (this.strokeWidthAnim = !1),
        (this.stroke = !1),
        (this.fill = !1),
        (this.justifyOffset = 0),
        (this.currentRender = null),
        (this.renderType = "canvas"),
        (this.values = {
          fill: "rgba(0,0,0,0)",
          stroke: "rgba(0,0,0,0)",
          sWidth: 0,
          fValue: "",
        }),
        this.initElement(t, e, i);
    }
    function CVImageElement(t, e, i) {
      (this.assetData = e.getAssetData(t.refId)),
        (this.img = e.imageLoader.getAsset(this.assetData)),
        this.initElement(t, e, i);
    }
    function CVSolidElement(t, e, i) {
      this.initElement(t, e, i);
    }
    function CanvasRendererBase() {}
    function CanvasContext() {
      (this.opacity = -1),
        (this.transform = createTypedArray("float32", 16)),
        (this.fillStyle = ""),
        (this.strokeStyle = ""),
        (this.lineWidth = ""),
        (this.lineCap = ""),
        (this.lineJoin = ""),
        (this.miterLimit = ""),
        (this.id = Math.random());
    }
    function CVContextData() {
      var t;
      (this.stack = []), (this.cArrPos = 0), (this.cTr = new Matrix());
      for (t = 0; t < 15; t += 1) {
        var e = new CanvasContext();
        this.stack[t] = e;
      }
      (this._length = 15),
        (this.nativeContext = null),
        (this.transformMat = new Matrix()),
        (this.currentOpacity = 1),
        (this.currentFillStyle = ""),
        (this.appliedFillStyle = ""),
        (this.currentStrokeStyle = ""),
        (this.appliedStrokeStyle = ""),
        (this.currentLineWidth = ""),
        (this.appliedLineWidth = ""),
        (this.currentLineCap = ""),
        (this.appliedLineCap = ""),
        (this.currentLineJoin = ""),
        (this.appliedLineJoin = ""),
        (this.appliedMiterLimit = ""),
        (this.currentMiterLimit = "");
    }
    function CVCompElement(t, e, i) {
      (this.completeLayers = !1),
        (this.layers = t.layers),
        (this.pendingElements = []),
        (this.elements = createSizedArray(this.layers.length)),
        this.initElement(t, e, i),
        (this.tm = t.tm
          ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
          : { _placeholder: !0 });
    }
    function CanvasRenderer(t, e) {
      (this.animationItem = t),
        (this.renderConfig = {
          clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
          context: (e && e.context) || null,
          progressiveLoad: (e && e.progressiveLoad) || !1,
          preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
          imagePreserveAspectRatio:
            (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
          contentVisibility: (e && e.contentVisibility) || "visible",
          className: (e && e.className) || "",
          id: (e && e.id) || "",
          runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
        }),
        (this.renderConfig.dpr = (e && e.dpr) || 1),
        this.animationItem.wrapper &&
          (this.renderConfig.dpr =
            (e && e.dpr) || window.devicePixelRatio || 1),
        (this.renderedFrame = -1),
        (this.globalData = {
          frameNum: -1,
          _mdf: !1,
          renderConfig: this.renderConfig,
          currentGlobalAlpha: -1,
        }),
        (this.contextData = new CVContextData()),
        (this.elements = []),
        (this.pendingElements = []),
        (this.transformMat = new Matrix()),
        (this.completeLayers = !1),
        (this.rendererType = "canvas"),
        this.renderConfig.clearCanvas &&
          ((this.ctxTransform = this.contextData.transform.bind(
            this.contextData
          )),
          (this.ctxOpacity = this.contextData.opacity.bind(this.contextData)),
          (this.ctxFillStyle = this.contextData.fillStyle.bind(
            this.contextData
          )),
          (this.ctxStrokeStyle = this.contextData.strokeStyle.bind(
            this.contextData
          )),
          (this.ctxLineWidth = this.contextData.lineWidth.bind(
            this.contextData
          )),
          (this.ctxLineCap = this.contextData.lineCap.bind(this.contextData)),
          (this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData)),
          (this.ctxMiterLimit = this.contextData.miterLimit.bind(
            this.contextData
          )),
          (this.ctxFill = this.contextData.fill.bind(this.contextData)),
          (this.ctxFillRect = this.contextData.fillRect.bind(this.contextData)),
          (this.ctxStroke = this.contextData.stroke.bind(this.contextData)),
          (this.save = this.contextData.save.bind(this.contextData)));
    }
    function HBaseElement() {}
    function HSolidElement(t, e, i) {
      this.initElement(t, e, i);
    }
    function HShapeElement(t, e, i) {
      (this.shapes = []),
        (this.shapesData = t.shapes),
        (this.stylesList = []),
        (this.shapeModifiers = []),
        (this.itemsData = []),
        (this.processedElements = []),
        (this.animatedContents = []),
        (this.shapesContainer = createNS("g")),
        this.initElement(t, e, i),
        (this.prevViewData = []),
        (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 });
    }
    function HTextElement(t, e, i) {
      (this.textSpans = []),
        (this.textPaths = []),
        (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 }),
        (this.renderType = "svg"),
        (this.isMasked = !1),
        this.initElement(t, e, i);
    }
    function HCameraElement(t, e, i) {
      this.initFrame(), this.initBaseData(t, e, i), this.initHierarchy();
      var r = PropertyFactory.getProp;
      if (
        ((this.pe = r(this, t.pe, 0, 0, this)),
        t.ks.p.s
          ? ((this.px = r(this, t.ks.p.x, 1, 0, this)),
            (this.py = r(this, t.ks.p.y, 1, 0, this)),
            (this.pz = r(this, t.ks.p.z, 1, 0, this)))
          : (this.p = r(this, t.ks.p, 1, 0, this)),
        t.ks.a && (this.a = r(this, t.ks.a, 1, 0, this)),
        t.ks.or.k.length && t.ks.or.k[0].to)
      ) {
        var s,
          a = t.ks.or.k.length;
        for (s = 0; s < a; s += 1)
          (t.ks.or.k[s].to = null), (t.ks.or.k[s].ti = null);
      }
      (this.or = r(this, t.ks.or, 1, degToRads, this)),
        (this.or.sh = !0),
        (this.rx = r(this, t.ks.rx, 0, degToRads, this)),
        (this.ry = r(this, t.ks.ry, 0, degToRads, this)),
        (this.rz = r(this, t.ks.rz, 0, degToRads, this)),
        (this.mat = new Matrix()),
        (this._prevMat = new Matrix()),
        (this._isFirstFrame = !0),
        (this.finalTransform = { mProp: this });
    }
    function HImageElement(t, e, i) {
      (this.assetData = e.getAssetData(t.refId)), this.initElement(t, e, i);
    }
    function HybridRendererBase(t, e) {
      (this.animationItem = t),
        (this.layers = null),
        (this.renderedFrame = -1),
        (this.renderConfig = {
          className: (e && e.className) || "",
          imagePreserveAspectRatio:
            (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
          hideOnTransparent: !(e && !1 === e.hideOnTransparent),
          filterSize: {
            width: (e && e.filterSize && e.filterSize.width) || "400%",
            height: (e && e.filterSize && e.filterSize.height) || "400%",
            x: (e && e.filterSize && e.filterSize.x) || "-100%",
            y: (e && e.filterSize && e.filterSize.y) || "-100%",
          },
        }),
        (this.globalData = {
          _mdf: !1,
          frameNum: -1,
          renderConfig: this.renderConfig,
        }),
        (this.pendingElements = []),
        (this.elements = []),
        (this.threeDElements = []),
        (this.destroyed = !1),
        (this.camera = null),
        (this.supports3d = !0),
        (this.rendererType = "html");
    }
    function HCompElement(t, e, i) {
      (this.layers = t.layers),
        (this.supports3d = !t.hasMask),
        (this.completeLayers = !1),
        (this.pendingElements = []),
        (this.elements = this.layers
          ? createSizedArray(this.layers.length)
          : []),
        this.initElement(t, e, i),
        (this.tm = t.tm
          ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
          : { _placeholder: !0 });
    }
    function HybridRenderer(t, e) {
      (this.animationItem = t),
        (this.layers = null),
        (this.renderedFrame = -1),
        (this.renderConfig = {
          className: (e && e.className) || "",
          imagePreserveAspectRatio:
            (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
          hideOnTransparent: !(e && !1 === e.hideOnTransparent),
          filterSize: {
            width: (e && e.filterSize && e.filterSize.width) || "400%",
            height: (e && e.filterSize && e.filterSize.height) || "400%",
            x: (e && e.filterSize && e.filterSize.x) || "-100%",
            y: (e && e.filterSize && e.filterSize.y) || "-100%",
          },
          runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
        }),
        (this.globalData = {
          _mdf: !1,
          frameNum: -1,
          renderConfig: this.renderConfig,
        }),
        (this.pendingElements = []),
        (this.elements = []),
        (this.threeDElements = []),
        (this.destroyed = !1),
        (this.camera = null),
        (this.supports3d = !0),
        (this.rendererType = "html");
    }
    (CVBaseElement.prototype = {
      createElements: function () {},
      initRendererElement: function () {},
      createContainerElements: function () {
        if (this.data.tt >= 1) {
          this.buffers = [];
          var t = this.globalData.canvasContext,
            e = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
          this.buffers.push(e);
          var i = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
          this.buffers.push(i),
            this.data.tt >= 3 &&
              !document._isProxy &&
              assetLoader.loadLumaCanvas();
        }
        (this.canvasContext = this.globalData.canvasContext),
          (this.transformCanvas = this.globalData.transformCanvas),
          (this.renderableEffectsManager = new CVEffects(this)),
          this.searchEffectTransforms();
      },
      createContent: function () {},
      setBlendMode: function () {
        var t = this.globalData;
        if (t.blendMode !== this.data.bm) {
          t.blendMode = this.data.bm;
          var e = getBlendMode(this.data.bm);
          t.canvasContext.globalCompositeOperation = e;
        }
      },
      createRenderableComponents: function () {
        (this.maskManager = new CVMaskElement(this.data, this)),
          (this.transformEffects = this.renderableEffectsManager.getEffects(
            effectTypes.TRANSFORM_EFFECT
          ));
      },
      hideElement: function () {
        this.hidden ||
          (this.isInRange && !this.isTransparent) ||
          (this.hidden = !0);
      },
      showElement: function () {
        this.isInRange &&
          !this.isTransparent &&
          ((this.hidden = !1),
          (this._isFirstFrame = !0),
          (this.maskManager._isFirstFrame = !0));
      },
      clearCanvas: function (t) {
        t.clearRect(
          this.transformCanvas.tx,
          this.transformCanvas.ty,
          this.transformCanvas.w * this.transformCanvas.sx,
          this.transformCanvas.h * this.transformCanvas.sy
        );
      },
      prepareLayer: function () {
        if (this.data.tt >= 1) {
          var t = this.buffers[0].getContext("2d");
          this.clearCanvas(t),
            t.drawImage(this.canvasContext.canvas, 0, 0),
            (this.currentTransform = this.canvasContext.getTransform()),
            this.canvasContext.setTransform(1, 0, 0, 1, 0, 0),
            this.clearCanvas(this.canvasContext),
            this.canvasContext.setTransform(this.currentTransform);
        }
      },
      exitLayer: function () {
        if (this.data.tt >= 1) {
          var t = this.buffers[1],
            e = t.getContext("2d");
          if (
            (this.clearCanvas(e),
            e.drawImage(this.canvasContext.canvas, 0, 0),
            this.canvasContext.setTransform(1, 0, 0, 1, 0, 0),
            this.clearCanvas(this.canvasContext),
            this.canvasContext.setTransform(this.currentTransform),
            this.comp
              .getElementById(
                "tp" in this.data ? this.data.tp : this.data.ind - 1
              )
              .renderFrame(!0),
            this.canvasContext.setTransform(1, 0, 0, 1, 0, 0),
            this.data.tt >= 3 && !document._isProxy)
          ) {
            var i = assetLoader.getLumaCanvas(this.canvasContext.canvas);
            i.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0),
              this.clearCanvas(this.canvasContext),
              this.canvasContext.drawImage(i, 0, 0);
          }
          (this.canvasContext.globalCompositeOperation =
            operationsMap[this.data.tt]),
            this.canvasContext.drawImage(t, 0, 0),
            (this.canvasContext.globalCompositeOperation = "destination-over"),
            this.canvasContext.drawImage(this.buffers[0], 0, 0),
            this.canvasContext.setTransform(this.currentTransform),
            (this.canvasContext.globalCompositeOperation = "source-over");
        }
      },
      renderFrame: function (t) {
        if (!this.hidden && !this.data.hd && (1 !== this.data.td || t)) {
          this.renderTransform(),
            this.renderRenderable(),
            this.renderLocalTransform(),
            this.setBlendMode();
          var e = 0 === this.data.ty;
          this.prepareLayer(),
            this.globalData.renderer.save(e),
            this.globalData.renderer.ctxTransform(
              this.finalTransform.localMat.props
            ),
            this.globalData.renderer.ctxOpacity(
              this.finalTransform.localOpacity
            ),
            this.renderInnerContent(),
            this.globalData.renderer.restore(e),
            this.exitLayer(),
            this.maskManager.hasMasks && this.globalData.renderer.restore(!0),
            this._isFirstFrame && (this._isFirstFrame = !1);
        }
      },
      destroy: function () {
        (this.canvasContext = null),
          (this.data = null),
          (this.globalData = null),
          this.maskManager.destroy();
      },
      mHelper: new Matrix(),
    }),
      (CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement),
      (CVBaseElement.prototype.show = CVBaseElement.prototype.showElement),
      (CVShapeData.prototype.setAsAnimated =
        SVGShapeData.prototype.setAsAnimated),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          CVBaseElement,
          IShapeElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
        ],
        CVShapeElement
      ),
      (CVShapeElement.prototype.initElement =
        RenderableDOMElement.prototype.initElement),
      (CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: !1 }),
      (CVShapeElement.prototype.dashResetter = []),
      (CVShapeElement.prototype.createContent = function () {
        this.searchShapes(
          this.shapesData,
          this.itemsData,
          this.prevViewData,
          !0,
          []
        );
      }),
      (CVShapeElement.prototype.createStyleElement = function (t, e) {
        var i = {
            data: t,
            type: t.ty,
            preTransforms: this.transformsManager.addTransformSequence(e),
            transforms: [],
            elements: [],
            closed: !0 === t.hd,
          },
          r = {};
        if (
          ("fl" === t.ty || "st" === t.ty
            ? ((r.c = PropertyFactory.getProp(this, t.c, 1, 255, this)),
              r.c.k ||
                (i.co =
                  "rgb(" +
                  bmFloor(r.c.v[0]) +
                  "," +
                  bmFloor(r.c.v[1]) +
                  "," +
                  bmFloor(r.c.v[2]) +
                  ")"))
            : ("gf" !== t.ty && "gs" !== t.ty) ||
              ((r.s = PropertyFactory.getProp(this, t.s, 1, null, this)),
              (r.e = PropertyFactory.getProp(this, t.e, 1, null, this)),
              (r.h = PropertyFactory.getProp(
                this,
                t.h || { k: 0 },
                0,
                0.01,
                this
              )),
              (r.a = PropertyFactory.getProp(
                this,
                t.a || { k: 0 },
                0,
                degToRads,
                this
              )),
              (r.g = new GradientProperty(this, t.g, this))),
          (r.o = PropertyFactory.getProp(this, t.o, 0, 0.01, this)),
          "st" === t.ty || "gs" === t.ty)
        ) {
          if (
            ((i.lc = lineCapEnum[t.lc || 2]),
            (i.lj = lineJoinEnum[t.lj || 2]),
            1 == t.lj && (i.ml = t.ml),
            (r.w = PropertyFactory.getProp(this, t.w, 0, null, this)),
            r.w.k || (i.wi = r.w.v),
            t.d)
          ) {
            var s = new DashProperty(this, t.d, "canvas", this);
            (r.d = s),
              r.d.k || ((i.da = r.d.dashArray), (i.do = r.d.dashoffset[0]));
          }
        } else i.r = 2 === t.r ? "evenodd" : "nonzero";
        return this.stylesList.push(i), (r.style = i), r;
      }),
      (CVShapeElement.prototype.createGroupElement = function () {
        return { it: [], prevViewData: [] };
      }),
      (CVShapeElement.prototype.createTransformElement = function (t) {
        return {
          transform: {
            opacity: 1,
            _opMdf: !1,
            key: this.transformsManager.getNewKey(),
            op: PropertyFactory.getProp(this, t.o, 0, 0.01, this),
            mProps: TransformPropertyFactory.getTransformProperty(
              this,
              t,
              this
            ),
          },
        };
      }),
      (CVShapeElement.prototype.createShapeElement = function (t) {
        var e = new CVShapeData(
          this,
          t,
          this.stylesList,
          this.transformsManager
        );
        return this.shapes.push(e), this.addShapeToModifiers(e), e;
      }),
      (CVShapeElement.prototype.reloadShapes = function () {
        var t;
        this._isFirstFrame = !0;
        var e = this.itemsData.length;
        for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
        for (
          this.searchShapes(
            this.shapesData,
            this.itemsData,
            this.prevViewData,
            !0,
            []
          ),
            e = this.dynamicProperties.length,
            t = 0;
          t < e;
          t += 1
        )
          this.dynamicProperties[t].getValue();
        this.renderModifiers(),
          this.transformsManager.processSequences(this._isFirstFrame);
      }),
      (CVShapeElement.prototype.addTransformToStyleList = function (t) {
        var e,
          i = this.stylesList.length;
        for (e = 0; e < i; e += 1)
          this.stylesList[e].closed || this.stylesList[e].transforms.push(t);
      }),
      (CVShapeElement.prototype.removeTransformFromStyleList = function () {
        var t,
          e = this.stylesList.length;
        for (t = 0; t < e; t += 1)
          this.stylesList[t].closed || this.stylesList[t].transforms.pop();
      }),
      (CVShapeElement.prototype.closeStyles = function (t) {
        var e,
          i = t.length;
        for (e = 0; e < i; e += 1) t[e].closed = !0;
      }),
      (CVShapeElement.prototype.searchShapes = function (t, e, i, r, s) {
        var a,
          n,
          o,
          h,
          l,
          p,
          f = t.length - 1,
          m = [],
          c = [],
          d = [].concat(s);
        for (a = f; a >= 0; a -= 1) {
          if (
            ((h = this.searchProcessedElement(t[a]))
              ? (e[a] = i[h - 1])
              : (t[a]._shouldRender = r),
            "fl" === t[a].ty ||
              "st" === t[a].ty ||
              "gf" === t[a].ty ||
              "gs" === t[a].ty)
          )
            h
              ? (e[a].style.closed = !1)
              : (e[a] = this.createStyleElement(t[a], d)),
              m.push(e[a].style);
          else if ("gr" === t[a].ty) {
            if (h)
              for (o = e[a].it.length, n = 0; n < o; n += 1)
                e[a].prevViewData[n] = e[a].it[n];
            else e[a] = this.createGroupElement(t[a]);
            this.searchShapes(t[a].it, e[a].it, e[a].prevViewData, r, d);
          } else
            "tr" === t[a].ty
              ? (h || ((p = this.createTransformElement(t[a])), (e[a] = p)),
                d.push(e[a]),
                this.addTransformToStyleList(e[a]))
              : "sh" === t[a].ty ||
                "rc" === t[a].ty ||
                "el" === t[a].ty ||
                "sr" === t[a].ty
              ? h || (e[a] = this.createShapeElement(t[a]))
              : "tm" === t[a].ty ||
                "rd" === t[a].ty ||
                "pb" === t[a].ty ||
                "zz" === t[a].ty ||
                "op" === t[a].ty
              ? (h
                  ? ((l = e[a]).closed = !1)
                  : ((l = ShapeModifiers.getModifier(t[a].ty)).init(this, t[a]),
                    (e[a] = l),
                    this.shapeModifiers.push(l)),
                c.push(l))
              : "rp" === t[a].ty &&
                (h
                  ? ((l = e[a]).closed = !0)
                  : ((l = ShapeModifiers.getModifier(t[a].ty)),
                    (e[a] = l),
                    l.init(this, t, a, e),
                    this.shapeModifiers.push(l),
                    (r = !1)),
                c.push(l));
          this.addProcessedElement(t[a], a + 1);
        }
        for (
          this.removeTransformFromStyleList(),
            this.closeStyles(m),
            f = c.length,
            a = 0;
          a < f;
          a += 1
        )
          c[a].closed = !0;
      }),
      (CVShapeElement.prototype.renderInnerContent = function () {
        (this.transformHelper.opacity = 1),
          (this.transformHelper._opMdf = !1),
          this.renderModifiers(),
          this.transformsManager.processSequences(this._isFirstFrame),
          this.renderShape(
            this.transformHelper,
            this.shapesData,
            this.itemsData,
            !0
          );
      }),
      (CVShapeElement.prototype.renderShapeTransform = function (t, e) {
        (t._opMdf || e.op._mdf || this._isFirstFrame) &&
          ((e.opacity = t.opacity), (e.opacity *= e.op.v), (e._opMdf = !0));
      }),
      (CVShapeElement.prototype.drawLayer = function () {
        var t,
          e,
          i,
          r,
          s,
          a,
          n,
          o,
          h,
          l = this.stylesList.length,
          p = this.globalData.renderer,
          f = this.globalData.canvasContext;
        for (t = 0; t < l; t += 1)
          if (
            (("st" !== (o = (h = this.stylesList[t]).type) && "gs" !== o) ||
              0 !== h.wi) &&
            h.data._shouldRender &&
            0 !== h.coOp &&
            0 !== this.globalData.currentGlobalAlpha
          ) {
            for (
              p.save(),
                a = h.elements,
                "st" === o || "gs" === o
                  ? (p.ctxStrokeStyle("st" === o ? h.co : h.grd),
                    p.ctxLineWidth(h.wi),
                    p.ctxLineCap(h.lc),
                    p.ctxLineJoin(h.lj),
                    p.ctxMiterLimit(h.ml || 0))
                  : p.ctxFillStyle("fl" === o ? h.co : h.grd),
                p.ctxOpacity(h.coOp),
                "st" !== o && "gs" !== o && f.beginPath(),
                p.ctxTransform(h.preTransforms.finalTransform.props),
                i = a.length,
                e = 0;
              e < i;
              e += 1
            ) {
              for (
                ("st" !== o && "gs" !== o) ||
                  (f.beginPath(),
                  h.da && (f.setLineDash(h.da), (f.lineDashOffset = h.do))),
                  s = (n = a[e].trNodes).length,
                  r = 0;
                r < s;
                r += 1
              )
                "m" === n[r].t
                  ? f.moveTo(n[r].p[0], n[r].p[1])
                  : "c" === n[r].t
                  ? f.bezierCurveTo(
                      n[r].pts[0],
                      n[r].pts[1],
                      n[r].pts[2],
                      n[r].pts[3],
                      n[r].pts[4],
                      n[r].pts[5]
                    )
                  : f.closePath();
              ("st" !== o && "gs" !== o) ||
                (p.ctxStroke(), h.da && f.setLineDash(this.dashResetter));
            }
            "st" !== o && "gs" !== o && this.globalData.renderer.ctxFill(h.r),
              p.restore();
          }
      }),
      (CVShapeElement.prototype.renderShape = function (t, e, i, r) {
        var s, a;
        for (a = t, s = e.length - 1; s >= 0; s -= 1)
          "tr" === e[s].ty
            ? ((a = i[s].transform), this.renderShapeTransform(t, a))
            : "sh" === e[s].ty ||
              "el" === e[s].ty ||
              "rc" === e[s].ty ||
              "sr" === e[s].ty
            ? this.renderPath(e[s], i[s])
            : "fl" === e[s].ty
            ? this.renderFill(e[s], i[s], a)
            : "st" === e[s].ty
            ? this.renderStroke(e[s], i[s], a)
            : "gf" === e[s].ty || "gs" === e[s].ty
            ? this.renderGradientFill(e[s], i[s], a)
            : "gr" === e[s].ty
            ? this.renderShape(a, e[s].it, i[s].it)
            : e[s].ty;
        r && this.drawLayer();
      }),
      (CVShapeElement.prototype.renderStyledShape = function (t, e) {
        if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
          var i,
            r,
            s,
            a = t.trNodes,
            n = e.paths,
            o = n._length;
          a.length = 0;
          var h = t.transforms.finalTransform;
          for (s = 0; s < o; s += 1) {
            var l = n.shapes[s];
            if (l && l.v) {
              for (r = l._length, i = 1; i < r; i += 1)
                1 === i &&
                  a.push({
                    t: "m",
                    p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0),
                  }),
                  a.push({
                    t: "c",
                    pts: h.applyToTriplePoints(l.o[i - 1], l.i[i], l.v[i]),
                  });
              1 === r &&
                a.push({
                  t: "m",
                  p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0),
                }),
                l.c &&
                  r &&
                  (a.push({
                    t: "c",
                    pts: h.applyToTriplePoints(l.o[i - 1], l.i[0], l.v[0]),
                  }),
                  a.push({ t: "z" }));
            }
          }
          t.trNodes = a;
        }
      }),
      (CVShapeElement.prototype.renderPath = function (t, e) {
        if (!0 !== t.hd && t._shouldRender) {
          var i,
            r = e.styledShapes.length;
          for (i = 0; i < r; i += 1)
            this.renderStyledShape(e.styledShapes[i], e.sh);
        }
      }),
      (CVShapeElement.prototype.renderFill = function (t, e, i) {
        var r = e.style;
        (e.c._mdf || this._isFirstFrame) &&
          (r.co =
            "rgb(" +
            bmFloor(e.c.v[0]) +
            "," +
            bmFloor(e.c.v[1]) +
            "," +
            bmFloor(e.c.v[2]) +
            ")"),
          (e.o._mdf || i._opMdf || this._isFirstFrame) &&
            (r.coOp = e.o.v * i.opacity);
      }),
      (CVShapeElement.prototype.renderGradientFill = function (t, e, i) {
        var r,
          s = e.style;
        if (
          !s.grd ||
          e.g._mdf ||
          e.s._mdf ||
          e.e._mdf ||
          (1 !== t.t && (e.h._mdf || e.a._mdf))
        ) {
          var a,
            n = this.globalData.canvasContext,
            o = e.s.v,
            h = e.e.v;
          if (1 === t.t) r = n.createLinearGradient(o[0], o[1], h[0], h[1]);
          else {
            var l = Math.sqrt(
                Math.pow(o[0] - h[0], 2) + Math.pow(o[1] - h[1], 2)
              ),
              p = Math.atan2(h[1] - o[1], h[0] - o[0]),
              f = e.h.v;
            f >= 1 ? (f = 0.99) : f <= -1 && (f = -0.99);
            var m = l * f,
              c = Math.cos(p + e.a.v) * m + o[0],
              d = Math.sin(p + e.a.v) * m + o[1];
            r = n.createRadialGradient(c, d, 0, o[0], o[1], l);
          }
          var u = t.g.p,
            y = e.g.c,
            g = 1;
          for (a = 0; a < u; a += 1)
            e.g._hasOpacity && e.g._collapsable && (g = e.g.o[2 * a + 1]),
              r.addColorStop(
                y[4 * a] / 100,
                "rgba(" +
                  y[4 * a + 1] +
                  "," +
                  y[4 * a + 2] +
                  "," +
                  y[4 * a + 3] +
                  "," +
                  g +
                  ")"
              );
          s.grd = r;
        }
        s.coOp = e.o.v * i.opacity;
      }),
      (CVShapeElement.prototype.renderStroke = function (t, e, i) {
        var r = e.style,
          s = e.d;
        s &&
          (s._mdf || this._isFirstFrame) &&
          ((r.da = s.dashArray), (r.do = s.dashoffset[0])),
          (e.c._mdf || this._isFirstFrame) &&
            (r.co =
              "rgb(" +
              bmFloor(e.c.v[0]) +
              "," +
              bmFloor(e.c.v[1]) +
              "," +
              bmFloor(e.c.v[2]) +
              ")"),
          (e.o._mdf || i._opMdf || this._isFirstFrame) &&
            (r.coOp = e.o.v * i.opacity),
          (e.w._mdf || this._isFirstFrame) && (r.wi = e.w.v);
      }),
      (CVShapeElement.prototype.destroy = function () {
        (this.shapesData = null),
          (this.globalData = null),
          (this.canvasContext = null),
          (this.stylesList.length = 0),
          (this.itemsData.length = 0);
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          CVBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
          ITextElement,
        ],
        CVTextElement
      ),
      (CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d")),
      (CVTextElement.prototype.buildNewText = function () {
        var t = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
        var e = !1;
        t.fc
          ? ((e = !0), (this.values.fill = this.buildColor(t.fc)))
          : (this.values.fill = "rgba(0,0,0,0)"),
          (this.fill = e);
        var i = !1;
        t.sc &&
          ((i = !0),
          (this.values.stroke = this.buildColor(t.sc)),
          (this.values.sWidth = t.sw));
        var r,
          s,
          a,
          n,
          o,
          h,
          l,
          p,
          f,
          m,
          c,
          d,
          u = this.globalData.fontManager.getFontByName(t.f),
          y = t.l,
          g = this.mHelper;
        (this.stroke = i),
          (this.values.fValue =
            t.finalSize +
            "px " +
            this.globalData.fontManager.getFontByName(t.f).fFamily),
          (s = t.finalText.length);
        var v = this.data.singleShape,
          b = 0.001 * t.tr * t.finalSize,
          x = 0,
          P = 0,
          E = !0,
          S = 0;
        for (r = 0; r < s; r += 1) {
          (n =
            ((a = this.globalData.fontManager.getCharData(
              t.finalText[r],
              u.fStyle,
              this.globalData.fontManager.getFontByName(t.f).fFamily
            )) &&
              a.data) ||
            {}),
            g.reset(),
            v &&
              y[r].n &&
              ((x = -b), (P += t.yOffset), (P += E ? 1 : 0), (E = !1)),
            (f = (l = n.shapes ? n.shapes[0].it : []).length),
            g.scale(t.finalSize / 100, t.finalSize / 100),
            v && this.applyTextPropertiesToMatrix(t, g, y[r].line, x, P),
            (c = createSizedArray(f - 1));
          var C = 0;
          for (p = 0; p < f; p += 1)
            if ("sh" === l[p].ty) {
              for (
                h = l[p].ks.k.i.length, m = l[p].ks.k, d = [], o = 1;
                o < h;
                o += 1
              )
                1 === o &&
                  d.push(
                    g.applyToX(m.v[0][0], m.v[0][1], 0),
                    g.applyToY(m.v[0][0], m.v[0][1], 0)
                  ),
                  d.push(
                    g.applyToX(m.o[o - 1][0], m.o[o - 1][1], 0),
                    g.applyToY(m.o[o - 1][0], m.o[o - 1][1], 0),
                    g.applyToX(m.i[o][0], m.i[o][1], 0),
                    g.applyToY(m.i[o][0], m.i[o][1], 0),
                    g.applyToX(m.v[o][0], m.v[o][1], 0),
                    g.applyToY(m.v[o][0], m.v[o][1], 0)
                  );
              d.push(
                g.applyToX(m.o[o - 1][0], m.o[o - 1][1], 0),
                g.applyToY(m.o[o - 1][0], m.o[o - 1][1], 0),
                g.applyToX(m.i[0][0], m.i[0][1], 0),
                g.applyToY(m.i[0][0], m.i[0][1], 0),
                g.applyToX(m.v[0][0], m.v[0][1], 0),
                g.applyToY(m.v[0][0], m.v[0][1], 0)
              ),
                (c[C] = d),
                (C += 1);
            }
          v && ((x += y[r].l), (x += b)),
            this.textSpans[S]
              ? (this.textSpans[S].elem = c)
              : (this.textSpans[S] = { elem: c }),
            (S += 1);
        }
      }),
      (CVTextElement.prototype.renderInnerContent = function () {
        var t, e, i, r, s, a;
        this.validateText(),
          (this.canvasContext.font = this.values.fValue),
          this.globalData.renderer.ctxLineCap("butt"),
          this.globalData.renderer.ctxLineJoin("miter"),
          this.globalData.renderer.ctxMiterLimit(4),
          this.data.singleShape ||
            this.textAnimator.getMeasures(
              this.textProperty.currentData,
              this.lettersChangedFlag
            );
        var n,
          o = this.textAnimator.renderedLetters,
          h = this.textProperty.currentData.l;
        e = h.length;
        var l,
          p,
          f = null,
          m = null,
          c = null,
          d = this.globalData.renderer;
        for (t = 0; t < e; t += 1)
          if (!h[t].n) {
            if (
              ((n = o[t]) && (d.save(), d.ctxTransform(n.p), d.ctxOpacity(n.o)),
              this.fill)
            ) {
              for (
                n && n.fc
                  ? f !== n.fc && (d.ctxFillStyle(n.fc), (f = n.fc))
                  : f !== this.values.fill &&
                    ((f = this.values.fill), d.ctxFillStyle(this.values.fill)),
                  r = (l = this.textSpans[t].elem).length,
                  this.globalData.canvasContext.beginPath(),
                  i = 0;
                i < r;
                i += 1
              )
                for (
                  a = (p = l[i]).length,
                    this.globalData.canvasContext.moveTo(p[0], p[1]),
                    s = 2;
                  s < a;
                  s += 6
                )
                  this.globalData.canvasContext.bezierCurveTo(
                    p[s],
                    p[s + 1],
                    p[s + 2],
                    p[s + 3],
                    p[s + 4],
                    p[s + 5]
                  );
              this.globalData.canvasContext.closePath(), d.ctxFill();
            }
            if (this.stroke) {
              for (
                n && n.sw
                  ? c !== n.sw && ((c = n.sw), d.ctxLineWidth(n.sw))
                  : c !== this.values.sWidth &&
                    ((c = this.values.sWidth),
                    d.ctxLineWidth(this.values.sWidth)),
                  n && n.sc
                    ? m !== n.sc && ((m = n.sc), d.ctxStrokeStyle(n.sc))
                    : m !== this.values.stroke &&
                      ((m = this.values.stroke),
                      d.ctxStrokeStyle(this.values.stroke)),
                  r = (l = this.textSpans[t].elem).length,
                  this.globalData.canvasContext.beginPath(),
                  i = 0;
                i < r;
                i += 1
              )
                for (
                  a = (p = l[i]).length,
                    this.globalData.canvasContext.moveTo(p[0], p[1]),
                    s = 2;
                  s < a;
                  s += 6
                )
                  this.globalData.canvasContext.bezierCurveTo(
                    p[s],
                    p[s + 1],
                    p[s + 2],
                    p[s + 3],
                    p[s + 4],
                    p[s + 5]
                  );
              this.globalData.canvasContext.closePath(), d.ctxStroke();
            }
            n && this.globalData.renderer.restore();
          }
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          CVBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
        ],
        CVImageElement
      ),
      (CVImageElement.prototype.initElement =
        SVGShapeElement.prototype.initElement),
      (CVImageElement.prototype.prepareFrame =
        IImageElement.prototype.prepareFrame),
      (CVImageElement.prototype.createContent = function () {
        if (
          this.img.width &&
          (this.assetData.w !== this.img.width ||
            this.assetData.h !== this.img.height)
        ) {
          var t = createTag("canvas");
          (t.width = this.assetData.w), (t.height = this.assetData.h);
          var e,
            i,
            r = t.getContext("2d"),
            s = this.img.width,
            a = this.img.height,
            n = s / a,
            o = this.assetData.w / this.assetData.h,
            h =
              this.assetData.pr ||
              this.globalData.renderConfig.imagePreserveAspectRatio;
          (n > o && "xMidYMid slice" === h) || (n < o && "xMidYMid slice" !== h)
            ? (e = (i = a) * o)
            : (i = (e = s) / o),
            r.drawImage(
              this.img,
              (s - e) / 2,
              (a - i) / 2,
              e,
              i,
              0,
              0,
              this.assetData.w,
              this.assetData.h
            ),
            (this.img = t);
        }
      }),
      (CVImageElement.prototype.renderInnerContent = function () {
        this.canvasContext.drawImage(this.img, 0, 0);
      }),
      (CVImageElement.prototype.destroy = function () {
        this.img = null;
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          CVBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
        ],
        CVSolidElement
      ),
      (CVSolidElement.prototype.initElement =
        SVGShapeElement.prototype.initElement),
      (CVSolidElement.prototype.prepareFrame =
        IImageElement.prototype.prepareFrame),
      (CVSolidElement.prototype.renderInnerContent = function () {
        this.globalData.renderer.ctxFillStyle(this.data.sc),
          this.globalData.renderer.ctxFillRect(
            0,
            0,
            this.data.sw,
            this.data.sh
          );
      }),
      extendPrototype([BaseRenderer], CanvasRendererBase),
      (CanvasRendererBase.prototype.createShape = function (t) {
        return new CVShapeElement(t, this.globalData, this);
      }),
      (CanvasRendererBase.prototype.createText = function (t) {
        return new CVTextElement(t, this.globalData, this);
      }),
      (CanvasRendererBase.prototype.createImage = function (t) {
        return new CVImageElement(t, this.globalData, this);
      }),
      (CanvasRendererBase.prototype.createSolid = function (t) {
        return new CVSolidElement(t, this.globalData, this);
      }),
      (CanvasRendererBase.prototype.createNull =
        SVGRenderer.prototype.createNull),
      (CanvasRendererBase.prototype.ctxTransform = function (t) {
        (1 === t[0] &&
          0 === t[1] &&
          0 === t[4] &&
          1 === t[5] &&
          0 === t[12] &&
          0 === t[13]) ||
          this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
      }),
      (CanvasRendererBase.prototype.ctxOpacity = function (t) {
        this.canvasContext.globalAlpha *= t < 0 ? 0 : t;
      }),
      (CanvasRendererBase.prototype.ctxFillStyle = function (t) {
        this.canvasContext.fillStyle = t;
      }),
      (CanvasRendererBase.prototype.ctxStrokeStyle = function (t) {
        this.canvasContext.strokeStyle = t;
      }),
      (CanvasRendererBase.prototype.ctxLineWidth = function (t) {
        this.canvasContext.lineWidth = t;
      }),
      (CanvasRendererBase.prototype.ctxLineCap = function (t) {
        this.canvasContext.lineCap = t;
      }),
      (CanvasRendererBase.prototype.ctxLineJoin = function (t) {
        this.canvasContext.lineJoin = t;
      }),
      (CanvasRendererBase.prototype.ctxMiterLimit = function (t) {
        this.canvasContext.miterLimit = t;
      }),
      (CanvasRendererBase.prototype.ctxFill = function (t) {
        this.canvasContext.fill(t);
      }),
      (CanvasRendererBase.prototype.ctxFillRect = function (t, e, i, r) {
        this.canvasContext.fillRect(t, e, i, r);
      }),
      (CanvasRendererBase.prototype.ctxStroke = function () {
        this.canvasContext.stroke();
      }),
      (CanvasRendererBase.prototype.reset = function () {
        this.renderConfig.clearCanvas
          ? this.contextData.reset()
          : this.canvasContext.restore();
      }),
      (CanvasRendererBase.prototype.save = function () {
        this.canvasContext.save();
      }),
      (CanvasRendererBase.prototype.restore = function (t) {
        this.renderConfig.clearCanvas
          ? (t && (this.globalData.blendMode = "source-over"),
            this.contextData.restore(t))
          : this.canvasContext.restore();
      }),
      (CanvasRendererBase.prototype.configAnimation = function (t) {
        if (this.animationItem.wrapper) {
          this.animationItem.container = createTag("canvas");
          var e = this.animationItem.container.style;
          (e.width = "100%"), (e.height = "100%");
          var i = "0px 0px 0px";
          (e.transformOrigin = i),
            (e.mozTransformOrigin = i),
            (e.webkitTransformOrigin = i),
            (e["-webkit-transform"] = i),
            (e.contentVisibility = this.renderConfig.contentVisibility),
            this.animationItem.wrapper.appendChild(
              this.animationItem.container
            ),
            (this.canvasContext =
              this.animationItem.container.getContext("2d")),
            this.renderConfig.className &&
              this.animationItem.container.setAttribute(
                "class",
                this.renderConfig.className
              ),
            this.renderConfig.id &&
              this.animationItem.container.setAttribute(
                "id",
                this.renderConfig.id
              );
        } else this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext),
          (this.data = t),
          (this.layers = t.layers),
          (this.transformCanvas = {
            w: t.w,
            h: t.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0,
          }),
          this.setupGlobalData(t, document.body),
          (this.globalData.canvasContext = this.canvasContext),
          (this.globalData.renderer = this),
          (this.globalData.isDashed = !1),
          (this.globalData.progressiveLoad = this.renderConfig.progressiveLoad),
          (this.globalData.transformCanvas = this.transformCanvas),
          (this.elements = createSizedArray(t.layers.length)),
          this.updateContainerSize();
      }),
      (CanvasRendererBase.prototype.updateContainerSize = function (t, e) {
        var i, r, s, a;
        if (
          (this.reset(),
          t
            ? ((i = t),
              (r = e),
              (this.canvasContext.canvas.width = i),
              (this.canvasContext.canvas.height = r))
            : (this.animationItem.wrapper && this.animationItem.container
                ? ((i = this.animationItem.wrapper.offsetWidth),
                  (r = this.animationItem.wrapper.offsetHeight))
                : ((i = this.canvasContext.canvas.width),
                  (r = this.canvasContext.canvas.height)),
              (this.canvasContext.canvas.width = i * this.renderConfig.dpr),
              (this.canvasContext.canvas.height = r * this.renderConfig.dpr)),
          -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") ||
            -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice"))
        ) {
          var n = this.renderConfig.preserveAspectRatio.split(" "),
            o = n[1] || "meet",
            h = n[0] || "xMidYMid",
            l = h.substr(0, 4),
            p = h.substr(4);
          (s = i / r),
            ((a = this.transformCanvas.w / this.transformCanvas.h) > s &&
              "meet" === o) ||
            (a < s && "slice" === o)
              ? ((this.transformCanvas.sx =
                  i / (this.transformCanvas.w / this.renderConfig.dpr)),
                (this.transformCanvas.sy =
                  i / (this.transformCanvas.w / this.renderConfig.dpr)))
              : ((this.transformCanvas.sx =
                  r / (this.transformCanvas.h / this.renderConfig.dpr)),
                (this.transformCanvas.sy =
                  r / (this.transformCanvas.h / this.renderConfig.dpr))),
            (this.transformCanvas.tx =
              "xMid" === l &&
              ((a < s && "meet" === o) || (a > s && "slice" === o))
                ? ((i - this.transformCanvas.w * (r / this.transformCanvas.h)) /
                    2) *
                  this.renderConfig.dpr
                : "xMax" === l &&
                  ((a < s && "meet" === o) || (a > s && "slice" === o))
                ? (i - this.transformCanvas.w * (r / this.transformCanvas.h)) *
                  this.renderConfig.dpr
                : 0),
            (this.transformCanvas.ty =
              "YMid" === p &&
              ((a > s && "meet" === o) || (a < s && "slice" === o))
                ? ((r - this.transformCanvas.h * (i / this.transformCanvas.w)) /
                    2) *
                  this.renderConfig.dpr
                : "YMax" === p &&
                  ((a > s && "meet" === o) || (a < s && "slice" === o))
                ? (r - this.transformCanvas.h * (i / this.transformCanvas.w)) *
                  this.renderConfig.dpr
                : 0);
        } else
          "none" === this.renderConfig.preserveAspectRatio
            ? ((this.transformCanvas.sx =
                i / (this.transformCanvas.w / this.renderConfig.dpr)),
              (this.transformCanvas.sy =
                r / (this.transformCanvas.h / this.renderConfig.dpr)),
              (this.transformCanvas.tx = 0),
              (this.transformCanvas.ty = 0))
            : ((this.transformCanvas.sx = this.renderConfig.dpr),
              (this.transformCanvas.sy = this.renderConfig.dpr),
              (this.transformCanvas.tx = 0),
              (this.transformCanvas.ty = 0));
        (this.transformCanvas.props = [
          this.transformCanvas.sx,
          0,
          0,
          0,
          0,
          this.transformCanvas.sy,
          0,
          0,
          0,
          0,
          1,
          0,
          this.transformCanvas.tx,
          this.transformCanvas.ty,
          0,
          1,
        ]),
          this.ctxTransform(this.transformCanvas.props),
          this.canvasContext.beginPath(),
          this.canvasContext.rect(
            0,
            0,
            this.transformCanvas.w,
            this.transformCanvas.h
          ),
          this.canvasContext.closePath(),
          this.canvasContext.clip(),
          this.renderFrame(this.renderedFrame, !0);
      }),
      (CanvasRendererBase.prototype.destroy = function () {
        var t;
        for (
          this.renderConfig.clearCanvas &&
            this.animationItem.wrapper &&
            (this.animationItem.wrapper.innerText = ""),
            t = (this.layers ? this.layers.length : 0) - 1;
          t >= 0;
          t -= 1
        )
          this.elements[t] &&
            this.elements[t].destroy &&
            this.elements[t].destroy();
        (this.elements.length = 0),
          (this.globalData.canvasContext = null),
          (this.animationItem.container = null),
          (this.destroyed = !0);
      }),
      (CanvasRendererBase.prototype.renderFrame = function (t, e) {
        if (
          (this.renderedFrame !== t ||
            !0 !== this.renderConfig.clearCanvas ||
            e) &&
          !this.destroyed &&
          -1 !== t
        ) {
          var i;
          (this.renderedFrame = t),
            (this.globalData.frameNum = t - this.animationItem._isFirstFrame),
            (this.globalData.frameId += 1),
            (this.globalData._mdf = !this.renderConfig.clearCanvas || e),
            (this.globalData.projectInterface.currentFrame = t);
          var r = this.layers.length;
          for (
            this.completeLayers || this.checkLayers(t), i = r - 1;
            i >= 0;
            i -= 1
          )
            (this.completeLayers || this.elements[i]) &&
              this.elements[i].prepareFrame(t - this.layers[i].st);
          if (this.globalData._mdf) {
            for (
              !0 === this.renderConfig.clearCanvas
                ? this.canvasContext.clearRect(
                    0,
                    0,
                    this.transformCanvas.w,
                    this.transformCanvas.h
                  )
                : this.save(),
                i = r - 1;
              i >= 0;
              i -= 1
            )
              (this.completeLayers || this.elements[i]) &&
                this.elements[i].renderFrame();
            !0 !== this.renderConfig.clearCanvas && this.restore();
          }
        }
      }),
      (CanvasRendererBase.prototype.buildItem = function (t) {
        var e = this.elements;
        if (!e[t] && 99 !== this.layers[t].ty) {
          var i = this.createItem(this.layers[t], this, this.globalData);
          (e[t] = i), i.initExpressions();
        }
      }),
      (CanvasRendererBase.prototype.checkPendingElements = function () {
        for (; this.pendingElements.length; ) {
          this.pendingElements.pop().checkParenting();
        }
      }),
      (CanvasRendererBase.prototype.hide = function () {
        this.animationItem.container.style.display = "none";
      }),
      (CanvasRendererBase.prototype.show = function () {
        this.animationItem.container.style.display = "block";
      }),
      (CVContextData.prototype.duplicate = function () {
        var t = 2 * this._length,
          e = 0;
        for (e = this._length; e < t; e += 1)
          this.stack[e] = new CanvasContext();
        this._length = t;
      }),
      (CVContextData.prototype.reset = function () {
        (this.cArrPos = 0),
          this.cTr.reset(),
          (this.stack[this.cArrPos].opacity = 1);
      }),
      (CVContextData.prototype.restore = function (t) {
        this.cArrPos -= 1;
        var e,
          i = this.stack[this.cArrPos],
          r = i.transform,
          s = this.cTr.props;
        for (e = 0; e < 16; e += 1) s[e] = r[e];
        if (t) {
          this.nativeContext.restore();
          var a = this.stack[this.cArrPos + 1];
          (this.appliedFillStyle = a.fillStyle),
            (this.appliedStrokeStyle = a.strokeStyle),
            (this.appliedLineWidth = a.lineWidth),
            (this.appliedLineCap = a.lineCap),
            (this.appliedLineJoin = a.lineJoin),
            (this.appliedMiterLimit = a.miterLimit);
        }
        this.nativeContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]),
          (t || (-1 !== i.opacity && this.currentOpacity !== i.opacity)) &&
            ((this.nativeContext.globalAlpha = i.opacity),
            (this.currentOpacity = i.opacity)),
          (this.currentFillStyle = i.fillStyle),
          (this.currentStrokeStyle = i.strokeStyle),
          (this.currentLineWidth = i.lineWidth),
          (this.currentLineCap = i.lineCap),
          (this.currentLineJoin = i.lineJoin),
          (this.currentMiterLimit = i.miterLimit);
      }),
      (CVContextData.prototype.save = function (t) {
        t && this.nativeContext.save();
        var e = this.cTr.props;
        this._length <= this.cArrPos && this.duplicate();
        var i,
          r = this.stack[this.cArrPos];
        for (i = 0; i < 16; i += 1) r.transform[i] = e[i];
        this.cArrPos += 1;
        var s = this.stack[this.cArrPos];
        (s.opacity = r.opacity),
          (s.fillStyle = r.fillStyle),
          (s.strokeStyle = r.strokeStyle),
          (s.lineWidth = r.lineWidth),
          (s.lineCap = r.lineCap),
          (s.lineJoin = r.lineJoin),
          (s.miterLimit = r.miterLimit);
      }),
      (CVContextData.prototype.setOpacity = function (t) {
        this.stack[this.cArrPos].opacity = t;
      }),
      (CVContextData.prototype.setContext = function (t) {
        this.nativeContext = t;
      }),
      (CVContextData.prototype.fillStyle = function (t) {
        this.stack[this.cArrPos].fillStyle !== t &&
          ((this.currentFillStyle = t),
          (this.stack[this.cArrPos].fillStyle = t));
      }),
      (CVContextData.prototype.strokeStyle = function (t) {
        this.stack[this.cArrPos].strokeStyle !== t &&
          ((this.currentStrokeStyle = t),
          (this.stack[this.cArrPos].strokeStyle = t));
      }),
      (CVContextData.prototype.lineWidth = function (t) {
        this.stack[this.cArrPos].lineWidth !== t &&
          ((this.currentLineWidth = t),
          (this.stack[this.cArrPos].lineWidth = t));
      }),
      (CVContextData.prototype.lineCap = function (t) {
        this.stack[this.cArrPos].lineCap !== t &&
          ((this.currentLineCap = t), (this.stack[this.cArrPos].lineCap = t));
      }),
      (CVContextData.prototype.lineJoin = function (t) {
        this.stack[this.cArrPos].lineJoin !== t &&
          ((this.currentLineJoin = t), (this.stack[this.cArrPos].lineJoin = t));
      }),
      (CVContextData.prototype.miterLimit = function (t) {
        this.stack[this.cArrPos].miterLimit !== t &&
          ((this.currentMiterLimit = t),
          (this.stack[this.cArrPos].miterLimit = t));
      }),
      (CVContextData.prototype.transform = function (t) {
        this.transformMat.cloneFromProps(t);
        var e = this.cTr;
        this.transformMat.multiply(e),
          e.cloneFromProps(this.transformMat.props);
        var i = e.props;
        this.nativeContext.setTransform(i[0], i[1], i[4], i[5], i[12], i[13]);
      }),
      (CVContextData.prototype.opacity = function (t) {
        var e = this.stack[this.cArrPos].opacity;
        (e *= t < 0 ? 0 : t),
          this.stack[this.cArrPos].opacity !== e &&
            (this.currentOpacity !== t &&
              ((this.nativeContext.globalAlpha = t), (this.currentOpacity = t)),
            (this.stack[this.cArrPos].opacity = e));
      }),
      (CVContextData.prototype.fill = function (t) {
        this.appliedFillStyle !== this.currentFillStyle &&
          ((this.appliedFillStyle = this.currentFillStyle),
          (this.nativeContext.fillStyle = this.appliedFillStyle)),
          this.nativeContext.fill(t);
      }),
      (CVContextData.prototype.fillRect = function (t, e, i, r) {
        this.appliedFillStyle !== this.currentFillStyle &&
          ((this.appliedFillStyle = this.currentFillStyle),
          (this.nativeContext.fillStyle = this.appliedFillStyle)),
          this.nativeContext.fillRect(t, e, i, r);
      }),
      (CVContextData.prototype.stroke = function () {
        this.appliedStrokeStyle !== this.currentStrokeStyle &&
          ((this.appliedStrokeStyle = this.currentStrokeStyle),
          (this.nativeContext.strokeStyle = this.appliedStrokeStyle)),
          this.appliedLineWidth !== this.currentLineWidth &&
            ((this.appliedLineWidth = this.currentLineWidth),
            (this.nativeContext.lineWidth = this.appliedLineWidth)),
          this.appliedLineCap !== this.currentLineCap &&
            ((this.appliedLineCap = this.currentLineCap),
            (this.nativeContext.lineCap = this.appliedLineCap)),
          this.appliedLineJoin !== this.currentLineJoin &&
            ((this.appliedLineJoin = this.currentLineJoin),
            (this.nativeContext.lineJoin = this.appliedLineJoin)),
          this.appliedMiterLimit !== this.currentMiterLimit &&
            ((this.appliedMiterLimit = this.currentMiterLimit),
            (this.nativeContext.miterLimit = this.appliedMiterLimit)),
          this.nativeContext.stroke();
      }),
      extendPrototype(
        [CanvasRendererBase, ICompElement, CVBaseElement],
        CVCompElement
      ),
      (CVCompElement.prototype.renderInnerContent = function () {
        var t,
          e = this.canvasContext;
        for (
          e.beginPath(),
            e.moveTo(0, 0),
            e.lineTo(this.data.w, 0),
            e.lineTo(this.data.w, this.data.h),
            e.lineTo(0, this.data.h),
            e.lineTo(0, 0),
            e.clip(),
            t = this.layers.length - 1;
          t >= 0;
          t -= 1
        )
          (this.completeLayers || this.elements[t]) &&
            this.elements[t].renderFrame();
      }),
      (CVCompElement.prototype.destroy = function () {
        var t;
        for (t = this.layers.length - 1; t >= 0; t -= 1)
          this.elements[t] && this.elements[t].destroy();
        (this.layers = null), (this.elements = null);
      }),
      (CVCompElement.prototype.createComp = function (t) {
        return new CVCompElement(t, this.globalData, this);
      }),
      extendPrototype([CanvasRendererBase], CanvasRenderer),
      (CanvasRenderer.prototype.createComp = function (t) {
        return new CVCompElement(t, this.globalData, this);
      }),
      (HBaseElement.prototype = {
        checkBlendMode: function () {},
        initRendererElement: function () {
          (this.baseElement = createTag(this.data.tg || "div")),
            this.data.hasMask
              ? ((this.svgElement = createNS("svg")),
                (this.layerElement = createNS("g")),
                (this.maskedElement = this.layerElement),
                this.svgElement.appendChild(this.layerElement),
                this.baseElement.appendChild(this.svgElement))
              : (this.layerElement = this.baseElement),
            styleDiv(this.baseElement);
        },
        createContainerElements: function () {
          (this.renderableEffectsManager = new CVEffects(this)),
            (this.transformedElement = this.baseElement),
            (this.maskedElement = this.layerElement),
            this.data.ln && this.layerElement.setAttribute("id", this.data.ln),
            this.data.cl &&
              this.layerElement.setAttribute("class", this.data.cl),
            0 !== this.data.bm && this.setBlendMode();
        },
        renderElement: function () {
          var t = this.transformedElement ? this.transformedElement.style : {};
          if (this.finalTransform._matMdf) {
            var e = this.finalTransform.mat.toCSS();
            (t.transform = e), (t.webkitTransform = e);
          }
          this.finalTransform._opMdf &&
            (t.opacity = this.finalTransform.mProp.o.v);
        },
        renderFrame: function () {
          this.data.hd ||
            this.hidden ||
            (this.renderTransform(),
            this.renderRenderable(),
            this.renderElement(),
            this.renderInnerContent(),
            this._isFirstFrame && (this._isFirstFrame = !1));
        },
        destroy: function () {
          (this.layerElement = null),
            (this.transformedElement = null),
            this.matteElement && (this.matteElement = null),
            this.maskManager &&
              (this.maskManager.destroy(), (this.maskManager = null));
        },
        createRenderableComponents: function () {
          this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function () {},
        setMatte: function () {},
      }),
      (HBaseElement.prototype.getBaseElement =
        SVGBaseElement.prototype.getBaseElement),
      (HBaseElement.prototype.destroyBaseElement =
        HBaseElement.prototype.destroy),
      (HBaseElement.prototype.buildElementParenting =
        BaseRenderer.prototype.buildElementParenting),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          HBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableDOMElement,
        ],
        HSolidElement
      ),
      (HSolidElement.prototype.createContent = function () {
        var t;
        this.data.hasMask
          ? ((t = createNS("rect")).setAttribute("width", this.data.sw),
            t.setAttribute("height", this.data.sh),
            t.setAttribute("fill", this.data.sc),
            this.svgElement.setAttribute("width", this.data.sw),
            this.svgElement.setAttribute("height", this.data.sh))
          : (((t = createTag("div")).style.width = this.data.sw + "px"),
            (t.style.height = this.data.sh + "px"),
            (t.style.backgroundColor = this.data.sc)),
          this.layerElement.appendChild(t);
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          HSolidElement,
          SVGShapeElement,
          HBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
        ],
        HShapeElement
      ),
      (HShapeElement.prototype._renderShapeFrame =
        HShapeElement.prototype.renderInnerContent),
      (HShapeElement.prototype.createContent = function () {
        var t;
        if (((this.baseElement.style.fontSize = 0), this.data.hasMask))
          this.layerElement.appendChild(this.shapesContainer),
            (t = this.svgElement);
        else {
          t = createNS("svg");
          var e = this.comp.data ? this.comp.data : this.globalData.compSize;
          t.setAttribute("width", e.w),
            t.setAttribute("height", e.h),
            t.appendChild(this.shapesContainer),
            this.layerElement.appendChild(t);
        }
        this.searchShapes(
          this.shapesData,
          this.itemsData,
          this.prevViewData,
          this.shapesContainer,
          0,
          [],
          !0
        ),
          this.filterUniqueShapes(),
          (this.shapeCont = t);
      }),
      (HShapeElement.prototype.getTransformedPoint = function (t, e) {
        var i,
          r = t.length;
        for (i = 0; i < r; i += 1)
          e = t[i].mProps.v.applyToPointArray(e[0], e[1], 0);
        return e;
      }),
      (HShapeElement.prototype.calculateShapeBoundingBox = function (t, e) {
        var i,
          r,
          s,
          a,
          n,
          o = t.sh.v,
          h = t.transformers,
          l = o._length;
        if (!(l <= 1)) {
          for (i = 0; i < l - 1; i += 1)
            (r = this.getTransformedPoint(h, o.v[i])),
              (s = this.getTransformedPoint(h, o.o[i])),
              (a = this.getTransformedPoint(h, o.i[i + 1])),
              (n = this.getTransformedPoint(h, o.v[i + 1])),
              this.checkBounds(r, s, a, n, e);
          o.c &&
            ((r = this.getTransformedPoint(h, o.v[i])),
            (s = this.getTransformedPoint(h, o.o[i])),
            (a = this.getTransformedPoint(h, o.i[0])),
            (n = this.getTransformedPoint(h, o.v[0])),
            this.checkBounds(r, s, a, n, e));
        }
      }),
      (HShapeElement.prototype.checkBounds = function (t, e, i, r, s) {
        this.getBoundsOfCurve(t, e, i, r);
        var a = this.shapeBoundingBox;
        (s.x = bmMin(a.left, s.x)),
          (s.xMax = bmMax(a.right, s.xMax)),
          (s.y = bmMin(a.top, s.y)),
          (s.yMax = bmMax(a.bottom, s.yMax));
      }),
      (HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      }),
      (HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0,
      }),
      (HShapeElement.prototype.getBoundsOfCurve = function (t, e, i, r) {
        for (
          var s,
            a,
            n,
            o,
            h,
            l,
            p,
            f = [
              [t[0], r[0]],
              [t[1], r[1]],
            ],
            m = 0;
          m < 2;
          ++m
        )
          (a = 6 * t[m] - 12 * e[m] + 6 * i[m]),
            (s = -3 * t[m] + 9 * e[m] - 9 * i[m] + 3 * r[m]),
            (n = 3 * e[m] - 3 * t[m]),
            (a |= 0),
            (n |= 0),
            (0 === (s |= 0) && 0 === a) ||
              (0 === s
                ? (o = -n / a) > 0 &&
                  o < 1 &&
                  f[m].push(this.calculateF(o, t, e, i, r, m))
                : (h = a * a - 4 * n * s) >= 0 &&
                  ((l = (-a + bmSqrt(h)) / (2 * s)) > 0 &&
                    l < 1 &&
                    f[m].push(this.calculateF(l, t, e, i, r, m)),
                  (p = (-a - bmSqrt(h)) / (2 * s)) > 0 &&
                    p < 1 &&
                    f[m].push(this.calculateF(p, t, e, i, r, m))));
        (this.shapeBoundingBox.left = bmMin.apply(null, f[0])),
          (this.shapeBoundingBox.top = bmMin.apply(null, f[1])),
          (this.shapeBoundingBox.right = bmMax.apply(null, f[0])),
          (this.shapeBoundingBox.bottom = bmMax.apply(null, f[1]));
      }),
      (HShapeElement.prototype.calculateF = function (t, e, i, r, s, a) {
        return (
          bmPow(1 - t, 3) * e[a] +
          3 * bmPow(1 - t, 2) * t * i[a] +
          3 * (1 - t) * bmPow(t, 2) * r[a] +
          bmPow(t, 3) * s[a]
        );
      }),
      (HShapeElement.prototype.calculateBoundingBox = function (t, e) {
        var i,
          r = t.length;
        for (i = 0; i < r; i += 1)
          t[i] && t[i].sh
            ? this.calculateShapeBoundingBox(t[i], e)
            : t[i] && t[i].it
            ? this.calculateBoundingBox(t[i].it, e)
            : t[i] &&
              t[i].style &&
              t[i].w &&
              this.expandStrokeBoundingBox(t[i].w, e);
      }),
      (HShapeElement.prototype.expandStrokeBoundingBox = function (t, e) {
        var i = 0;
        if (t.keyframes) {
          for (var r = 0; r < t.keyframes.length; r += 1) {
            var s = t.keyframes[r].s;
            s > i && (i = s);
          }
          i *= t.mult;
        } else i = t.v * t.mult;
        (e.x -= i), (e.xMax += i), (e.y -= i), (e.yMax += i);
      }),
      (HShapeElement.prototype.currentBoxContains = function (t) {
        return (
          this.currentBBox.x <= t.x &&
          this.currentBBox.y <= t.y &&
          this.currentBBox.width + this.currentBBox.x >= t.x + t.width &&
          this.currentBBox.height + this.currentBBox.y >= t.y + t.height
        );
      }),
      (HShapeElement.prototype.renderInnerContent = function () {
        if (
          (this._renderShapeFrame(),
          !this.hidden && (this._isFirstFrame || this._mdf))
        ) {
          var t = this.tempBoundingBox,
            e = 999999;
          if (
            ((t.x = e),
            (t.xMax = -e),
            (t.y = e),
            (t.yMax = -e),
            this.calculateBoundingBox(this.itemsData, t),
            (t.width = t.xMax < t.x ? 0 : t.xMax - t.x),
            (t.height = t.yMax < t.y ? 0 : t.yMax - t.y),
            this.currentBoxContains(t))
          )
            return;
          var i = !1;
          if (
            (this.currentBBox.w !== t.width &&
              ((this.currentBBox.w = t.width),
              this.shapeCont.setAttribute("width", t.width),
              (i = !0)),
            this.currentBBox.h !== t.height &&
              ((this.currentBBox.h = t.height),
              this.shapeCont.setAttribute("height", t.height),
              (i = !0)),
            i || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y)
          ) {
            (this.currentBBox.w = t.width),
              (this.currentBBox.h = t.height),
              (this.currentBBox.x = t.x),
              (this.currentBBox.y = t.y),
              this.shapeCont.setAttribute(
                "viewBox",
                this.currentBBox.x +
                  " " +
                  this.currentBBox.y +
                  " " +
                  this.currentBBox.w +
                  " " +
                  this.currentBBox.h
              );
            var r = this.shapeCont.style,
              s =
                "translate(" +
                this.currentBBox.x +
                "px," +
                this.currentBBox.y +
                "px)";
            (r.transform = s), (r.webkitTransform = s);
          }
        }
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          HBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableDOMElement,
          ITextElement,
        ],
        HTextElement
      ),
      (HTextElement.prototype.createContent = function () {
        if (((this.isMasked = this.checkMasks()), this.isMasked)) {
          (this.renderType = "svg"),
            (this.compW = this.comp.data.w),
            (this.compH = this.comp.data.h),
            this.svgElement.setAttribute("width", this.compW),
            this.svgElement.setAttribute("height", this.compH);
          var t = createNS("g");
          this.maskedElement.appendChild(t), (this.innerElem = t);
        } else (this.renderType = "html"), (this.innerElem = this.layerElement);
        this.checkParenting();
      }),
      (HTextElement.prototype.buildNewText = function () {
        var t = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
        var e = this.innerElem.style,
          i = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
        (e.fill = i),
          (e.color = i),
          t.sc &&
            ((e.stroke = this.buildColor(t.sc)), (e.strokeWidth = t.sw + "px"));
        var r,
          s,
          a = this.globalData.fontManager.getFontByName(t.f);
        if (!this.globalData.fontManager.chars)
          if (
            ((e.fontSize = t.finalSize + "px"),
            (e.lineHeight = t.finalSize + "px"),
            a.fClass)
          )
            this.innerElem.className = a.fClass;
          else {
            e.fontFamily = a.fFamily;
            var n = t.fWeight,
              o = t.fStyle;
            (e.fontStyle = o), (e.fontWeight = n);
          }
        var h,
          l,
          p,
          f = t.l;
        s = f.length;
        var m,
          c = this.mHelper,
          d = "",
          u = 0;
        for (r = 0; r < s; r += 1) {
          if (
            (this.globalData.fontManager.chars
              ? (this.textPaths[u]
                  ? (h = this.textPaths[u])
                  : ((h = createNS("path")).setAttribute(
                      "stroke-linecap",
                      lineCapEnum[1]
                    ),
                    h.setAttribute("stroke-linejoin", lineJoinEnum[2]),
                    h.setAttribute("stroke-miterlimit", "4")),
                this.isMasked ||
                  (this.textSpans[u]
                    ? (p = (l = this.textSpans[u]).children[0])
                    : (((l = createTag("div")).style.lineHeight = 0),
                      (p = createNS("svg")).appendChild(h),
                      styleDiv(l))))
              : this.isMasked
              ? (h = this.textPaths[u] ? this.textPaths[u] : createNS("text"))
              : this.textSpans[u]
              ? ((l = this.textSpans[u]), (h = this.textPaths[u]))
              : (styleDiv((l = createTag("span"))),
                styleDiv((h = createTag("span"))),
                l.appendChild(h)),
            this.globalData.fontManager.chars)
          ) {
            var y,
              g = this.globalData.fontManager.getCharData(
                t.finalText[r],
                a.fStyle,
                this.globalData.fontManager.getFontByName(t.f).fFamily
              );
            if (
              ((y = g ? g.data : null),
              c.reset(),
              y &&
                y.shapes &&
                y.shapes.length &&
                ((m = y.shapes[0].it),
                c.scale(t.finalSize / 100, t.finalSize / 100),
                (d = this.createPathShape(c, m)),
                h.setAttribute("d", d)),
              this.isMasked)
            )
              this.innerElem.appendChild(h);
            else {
              if ((this.innerElem.appendChild(l), y && y.shapes)) {
                document.body.appendChild(p);
                var v = p.getBBox();
                p.setAttribute("width", v.width + 2),
                  p.setAttribute("height", v.height + 2),
                  p.setAttribute(
                    "viewBox",
                    v.x -
                      1 +
                      " " +
                      (v.y - 1) +
                      " " +
                      (v.width + 2) +
                      " " +
                      (v.height + 2)
                  );
                var b = p.style,
                  x = "translate(" + (v.x - 1) + "px," + (v.y - 1) + "px)";
                (b.transform = x),
                  (b.webkitTransform = x),
                  (f[r].yOffset = v.y - 1);
              } else p.setAttribute("width", 1), p.setAttribute("height", 1);
              l.appendChild(p);
            }
          } else if (
            ((h.textContent = f[r].val),
            h.setAttributeNS(
              "http://www.w3.org/XML/1998/namespace",
              "xml:space",
              "preserve"
            ),
            this.isMasked)
          )
            this.innerElem.appendChild(h);
          else {
            this.innerElem.appendChild(l);
            var P = h.style,
              E = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
            (P.transform = E), (P.webkitTransform = E);
          }
          this.isMasked ? (this.textSpans[u] = h) : (this.textSpans[u] = l),
            (this.textSpans[u].style.display = "block"),
            (this.textPaths[u] = h),
            (u += 1);
        }
        for (; u < this.textSpans.length; )
          (this.textSpans[u].style.display = "none"), (u += 1);
      }),
      (HTextElement.prototype.renderInnerContent = function () {
        var t;
        if ((this.validateText(), this.data.singleShape)) {
          if (!this._isFirstFrame && !this.lettersChangedFlag) return;
          if (this.isMasked && this.finalTransform._matMdf) {
            this.svgElement.setAttribute(
              "viewBox",
              -this.finalTransform.mProp.p.v[0] +
                " " +
                -this.finalTransform.mProp.p.v[1] +
                " " +
                this.compW +
                " " +
                this.compH
            ),
              (t = this.svgElement.style);
            var e =
              "translate(" +
              -this.finalTransform.mProp.p.v[0] +
              "px," +
              -this.finalTransform.mProp.p.v[1] +
              "px)";
            (t.transform = e), (t.webkitTransform = e);
          }
        }
        if (
          (this.textAnimator.getMeasures(
            this.textProperty.currentData,
            this.lettersChangedFlag
          ),
          this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)
        ) {
          var i,
            r,
            s,
            a,
            n,
            o = 0,
            h = this.textAnimator.renderedLetters,
            l = this.textProperty.currentData.l;
          for (r = l.length, i = 0; i < r; i += 1)
            l[i].n
              ? (o += 1)
              : ((a = this.textSpans[i]),
                (n = this.textPaths[i]),
                (s = h[o]),
                (o += 1),
                s._mdf.m &&
                  (this.isMasked
                    ? a.setAttribute("transform", s.m)
                    : ((a.style.webkitTransform = s.m),
                      (a.style.transform = s.m))),
                (a.style.opacity = s.o),
                s.sw && s._mdf.sw && n.setAttribute("stroke-width", s.sw),
                s.sc && s._mdf.sc && n.setAttribute("stroke", s.sc),
                s.fc &&
                  s._mdf.fc &&
                  (n.setAttribute("fill", s.fc), (n.style.color = s.fc)));
          if (
            this.innerElem.getBBox &&
            !this.hidden &&
            (this._isFirstFrame || this._mdf)
          ) {
            var p = this.innerElem.getBBox();
            this.currentBBox.w !== p.width &&
              ((this.currentBBox.w = p.width),
              this.svgElement.setAttribute("width", p.width)),
              this.currentBBox.h !== p.height &&
                ((this.currentBBox.h = p.height),
                this.svgElement.setAttribute("height", p.height));
            if (
              this.currentBBox.w !== p.width + 2 ||
              this.currentBBox.h !== p.height + 2 ||
              this.currentBBox.x !== p.x - 1 ||
              this.currentBBox.y !== p.y - 1
            ) {
              (this.currentBBox.w = p.width + 2),
                (this.currentBBox.h = p.height + 2),
                (this.currentBBox.x = p.x - 1),
                (this.currentBBox.y = p.y - 1),
                this.svgElement.setAttribute(
                  "viewBox",
                  this.currentBBox.x +
                    " " +
                    this.currentBBox.y +
                    " " +
                    this.currentBBox.w +
                    " " +
                    this.currentBBox.h
                ),
                (t = this.svgElement.style);
              var f =
                "translate(" +
                this.currentBBox.x +
                "px," +
                this.currentBBox.y +
                "px)";
              (t.transform = f), (t.webkitTransform = f);
            }
          }
        }
      }),
      extendPrototype(
        [BaseElement, FrameElement, HierarchyElement],
        HCameraElement
      ),
      (HCameraElement.prototype.setup = function () {
        var t,
          e,
          i,
          r,
          s = this.comp.threeDElements.length;
        for (t = 0; t < s; t += 1)
          if ("3d" === (e = this.comp.threeDElements[t]).type) {
            (i = e.perspectiveElem.style), (r = e.container.style);
            var a = this.pe.v + "px",
              n = "0px 0px 0px",
              o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
            (i.perspective = a),
              (i.webkitPerspective = a),
              (r.transformOrigin = n),
              (r.mozTransformOrigin = n),
              (r.webkitTransformOrigin = n),
              (i.transform = o),
              (i.webkitTransform = o);
          }
      }),
      (HCameraElement.prototype.createElements = function () {}),
      (HCameraElement.prototype.hide = function () {}),
      (HCameraElement.prototype.renderFrame = function () {
        var t,
          e,
          i = this._isFirstFrame;
        if (this.hierarchy)
          for (e = this.hierarchy.length, t = 0; t < e; t += 1)
            i = this.hierarchy[t].finalTransform.mProp._mdf || i;
        if (
          i ||
          this.pe._mdf ||
          (this.p && this.p._mdf) ||
          (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) ||
          this.rx._mdf ||
          this.ry._mdf ||
          this.rz._mdf ||
          this.or._mdf ||
          (this.a && this.a._mdf)
        ) {
          if ((this.mat.reset(), this.hierarchy))
            for (t = e = this.hierarchy.length - 1; t >= 0; t -= 1) {
              var r = this.hierarchy[t].finalTransform.mProp;
              this.mat.translate(-r.p.v[0], -r.p.v[1], r.p.v[2]),
                this.mat
                  .rotateX(-r.or.v[0])
                  .rotateY(-r.or.v[1])
                  .rotateZ(r.or.v[2]),
                this.mat.rotateX(-r.rx.v).rotateY(-r.ry.v).rotateZ(r.rz.v),
                this.mat.scale(1 / r.s.v[0], 1 / r.s.v[1], 1 / r.s.v[2]),
                this.mat.translate(r.a.v[0], r.a.v[1], r.a.v[2]);
            }
          if (
            (this.p
              ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2])
              : this.mat.translate(-this.px.v, -this.py.v, this.pz.v),
            this.a)
          ) {
            var s;
            s = this.p
              ? [
                  this.p.v[0] - this.a.v[0],
                  this.p.v[1] - this.a.v[1],
                  this.p.v[2] - this.a.v[2],
                ]
              : [
                  this.px.v - this.a.v[0],
                  this.py.v - this.a.v[1],
                  this.pz.v - this.a.v[2],
                ];
            var a = Math.sqrt(
                Math.pow(s[0], 2) + Math.pow(s[1], 2) + Math.pow(s[2], 2)
              ),
              n = [s[0] / a, s[1] / a, s[2] / a],
              o = Math.sqrt(n[2] * n[2] + n[0] * n[0]),
              h = Math.atan2(n[1], o),
              l = Math.atan2(n[0], -n[2]);
            this.mat.rotateY(l).rotateX(-h);
          }
          this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v),
            this.mat
              .rotateX(-this.or.v[0])
              .rotateY(-this.or.v[1])
              .rotateZ(this.or.v[2]),
            this.mat.translate(
              this.globalData.compSize.w / 2,
              this.globalData.compSize.h / 2,
              0
            ),
            this.mat.translate(0, 0, this.pe.v);
          var p = !this._prevMat.equals(this.mat);
          if ((p || this.pe._mdf) && this.comp.threeDElements) {
            var f, m, c;
            for (e = this.comp.threeDElements.length, t = 0; t < e; t += 1)
              if ("3d" === (f = this.comp.threeDElements[t]).type) {
                if (p) {
                  var d = this.mat.toCSS();
                  ((c = f.container.style).transform = d),
                    (c.webkitTransform = d);
                }
                this.pe._mdf &&
                  (((m = f.perspectiveElem.style).perspective =
                    this.pe.v + "px"),
                  (m.webkitPerspective = this.pe.v + "px"));
              }
            this.mat.clone(this._prevMat);
          }
        }
        this._isFirstFrame = !1;
      }),
      (HCameraElement.prototype.prepareFrame = function (t) {
        this.prepareProperties(t, !0);
      }),
      (HCameraElement.prototype.destroy = function () {}),
      (HCameraElement.prototype.getBaseElement = function () {
        return null;
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          HBaseElement,
          HSolidElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
        ],
        HImageElement
      ),
      (HImageElement.prototype.createContent = function () {
        var t = this.globalData.getAssetsPath(this.assetData),
          e = new Image();
        this.data.hasMask
          ? ((this.imageElem = createNS("image")),
            this.imageElem.setAttribute("width", this.assetData.w + "px"),
            this.imageElem.setAttribute("height", this.assetData.h + "px"),
            this.imageElem.setAttributeNS(
              "http://www.w3.org/1999/xlink",
              "href",
              t
            ),
            this.layerElement.appendChild(this.imageElem),
            this.baseElement.setAttribute("width", this.assetData.w),
            this.baseElement.setAttribute("height", this.assetData.h))
          : this.layerElement.appendChild(e),
          (e.crossOrigin = "anonymous"),
          (e.src = t),
          this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
      }),
      extendPrototype([BaseRenderer], HybridRendererBase),
      (HybridRendererBase.prototype.buildItem =
        SVGRenderer.prototype.buildItem),
      (HybridRendererBase.prototype.checkPendingElements = function () {
        for (; this.pendingElements.length; ) {
          this.pendingElements.pop().checkParenting();
        }
      }),
      (HybridRendererBase.prototype.appendElementInPos = function (t, e) {
        var i = t.getBaseElement();
        if (i) {
          var r = this.layers[e];
          if (r.ddd && this.supports3d) this.addTo3dContainer(i, e);
          else if (this.threeDElements) this.addTo3dContainer(i, e);
          else {
            for (var s, a, n = 0; n < e; )
              this.elements[n] &&
                !0 !== this.elements[n] &&
                this.elements[n].getBaseElement &&
                ((a = this.elements[n]),
                (s =
                  (this.layers[n].ddd
                    ? this.getThreeDContainerByPos(n)
                    : a.getBaseElement()) || s)),
                (n += 1);
            s
              ? (r.ddd && this.supports3d) ||
                this.layerElement.insertBefore(i, s)
              : (r.ddd && this.supports3d) || this.layerElement.appendChild(i);
          }
        }
      }),
      (HybridRendererBase.prototype.createShape = function (t) {
        return this.supports3d
          ? new HShapeElement(t, this.globalData, this)
          : new SVGShapeElement(t, this.globalData, this);
      }),
      (HybridRendererBase.prototype.createText = function (t) {
        return this.supports3d
          ? new HTextElement(t, this.globalData, this)
          : new SVGTextLottieElement(t, this.globalData, this);
      }),
      (HybridRendererBase.prototype.createCamera = function (t) {
        return (
          (this.camera = new HCameraElement(t, this.globalData, this)),
          this.camera
        );
      }),
      (HybridRendererBase.prototype.createImage = function (t) {
        return this.supports3d
          ? new HImageElement(t, this.globalData, this)
          : new IImageElement(t, this.globalData, this);
      }),
      (HybridRendererBase.prototype.createSolid = function (t) {
        return this.supports3d
          ? new HSolidElement(t, this.globalData, this)
          : new ISolidElement(t, this.globalData, this);
      }),
      (HybridRendererBase.prototype.createNull =
        SVGRenderer.prototype.createNull),
      (HybridRendererBase.prototype.getThreeDContainerByPos = function (t) {
        for (var e = 0, i = this.threeDElements.length; e < i; ) {
          if (
            this.threeDElements[e].startPos <= t &&
            this.threeDElements[e].endPos >= t
          )
            return this.threeDElements[e].perspectiveElem;
          e += 1;
        }
        return null;
      }),
      (HybridRendererBase.prototype.createThreeDContainer = function (t, e) {
        var i,
          r,
          s = createTag("div");
        styleDiv(s);
        var a = createTag("div");
        if ((styleDiv(a), "3d" === e)) {
          ((i = s.style).width = this.globalData.compSize.w + "px"),
            (i.height = this.globalData.compSize.h + "px");
          var n = "50% 50%";
          (i.webkitTransformOrigin = n),
            (i.mozTransformOrigin = n),
            (i.transformOrigin = n);
          var o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          ((r = a.style).transform = o), (r.webkitTransform = o);
        }
        s.appendChild(a);
        var h = {
          container: a,
          perspectiveElem: s,
          startPos: t,
          endPos: t,
          type: e,
        };
        return this.threeDElements.push(h), h;
      }),
      (HybridRendererBase.prototype.build3dContainers = function () {
        var t,
          e,
          i = this.layers.length,
          r = "";
        for (t = 0; t < i; t += 1)
          this.layers[t].ddd && 3 !== this.layers[t].ty
            ? ("3d" !== r &&
                ((r = "3d"), (e = this.createThreeDContainer(t, "3d"))),
              (e.endPos = Math.max(e.endPos, t)))
            : ("2d" !== r &&
                ((r = "2d"), (e = this.createThreeDContainer(t, "2d"))),
              (e.endPos = Math.max(e.endPos, t)));
        for (t = (i = this.threeDElements.length) - 1; t >= 0; t -= 1)
          this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
      }),
      (HybridRendererBase.prototype.addTo3dContainer = function (t, e) {
        for (var i = 0, r = this.threeDElements.length; i < r; ) {
          if (e <= this.threeDElements[i].endPos) {
            for (var s, a = this.threeDElements[i].startPos; a < e; )
              this.elements[a] &&
                this.elements[a].getBaseElement &&
                (s = this.elements[a].getBaseElement()),
                (a += 1);
            s
              ? this.threeDElements[i].container.insertBefore(t, s)
              : this.threeDElements[i].container.appendChild(t);
            break;
          }
          i += 1;
        }
      }),
      (HybridRendererBase.prototype.configAnimation = function (t) {
        var e = createTag("div"),
          i = this.animationItem.wrapper,
          r = e.style;
        (r.width = t.w + "px"),
          (r.height = t.h + "px"),
          (this.resizerElem = e),
          styleDiv(e),
          (r.transformStyle = "flat"),
          (r.mozTransformStyle = "flat"),
          (r.webkitTransformStyle = "flat"),
          this.renderConfig.className &&
            e.setAttribute("class", this.renderConfig.className),
          i.appendChild(e),
          (r.overflow = "hidden");
        var s = createNS("svg");
        s.setAttribute("width", "1"),
          s.setAttribute("height", "1"),
          styleDiv(s),
          this.resizerElem.appendChild(s);
        var a = createNS("defs");
        s.appendChild(a),
          (this.data = t),
          this.setupGlobalData(t, s),
          (this.globalData.defs = a),
          (this.layers = t.layers),
          (this.layerElement = this.resizerElem),
          this.build3dContainers(),
          this.updateContainerSize();
      }),
      (HybridRendererBase.prototype.destroy = function () {
        var t;
        this.animationItem.wrapper &&
          (this.animationItem.wrapper.innerText = ""),
          (this.animationItem.container = null),
          (this.globalData.defs = null);
        var e = this.layers ? this.layers.length : 0;
        for (t = 0; t < e; t += 1)
          this.elements[t] &&
            this.elements[t].destroy &&
            this.elements[t].destroy();
        (this.elements.length = 0),
          (this.destroyed = !0),
          (this.animationItem = null);
      }),
      (HybridRendererBase.prototype.updateContainerSize = function () {
        var t,
          e,
          i,
          r,
          s = this.animationItem.wrapper.offsetWidth,
          a = this.animationItem.wrapper.offsetHeight,
          n = s / a;
        this.globalData.compSize.w / this.globalData.compSize.h > n
          ? ((t = s / this.globalData.compSize.w),
            (e = s / this.globalData.compSize.w),
            (i = 0),
            (r =
              (a -
                this.globalData.compSize.h * (s / this.globalData.compSize.w)) /
              2))
          : ((t = a / this.globalData.compSize.h),
            (e = a / this.globalData.compSize.h),
            (i =
              (s -
                this.globalData.compSize.w * (a / this.globalData.compSize.h)) /
              2),
            (r = 0));
        var o = this.resizerElem.style;
        (o.webkitTransform =
          "matrix3d(" +
          t +
          ",0,0,0,0," +
          e +
          ",0,0,0,0,1,0," +
          i +
          "," +
          r +
          ",0,1)"),
          (o.transform = o.webkitTransform);
      }),
      (HybridRendererBase.prototype.renderFrame =
        SVGRenderer.prototype.renderFrame),
      (HybridRendererBase.prototype.hide = function () {
        this.resizerElem.style.display = "none";
      }),
      (HybridRendererBase.prototype.show = function () {
        this.resizerElem.style.display = "block";
      }),
      (HybridRendererBase.prototype.initItems = function () {
        if ((this.buildAllItems(), this.camera)) this.camera.setup();
        else {
          var t,
            e = this.globalData.compSize.w,
            i = this.globalData.compSize.h,
            r = this.threeDElements.length;
          for (t = 0; t < r; t += 1) {
            var s = this.threeDElements[t].perspectiveElem.style;
            (s.webkitPerspective =
              Math.sqrt(Math.pow(e, 2) + Math.pow(i, 2)) + "px"),
              (s.perspective = s.webkitPerspective);
          }
        }
      }),
      (HybridRendererBase.prototype.searchExtraCompositions = function (t) {
        var e,
          i = t.length,
          r = createTag("div");
        for (e = 0; e < i; e += 1)
          if (t[e].xt) {
            var s = this.createComp(t[e], r, this.globalData.comp, null);
            s.initExpressions(),
              this.globalData.projectInterface.registerComposition(s);
          }
      }),
      extendPrototype(
        [HybridRendererBase, ICompElement, HBaseElement],
        HCompElement
      ),
      (HCompElement.prototype._createBaseContainerElements =
        HCompElement.prototype.createContainerElements),
      (HCompElement.prototype.createContainerElements = function () {
        this._createBaseContainerElements(),
          this.data.hasMask
            ? (this.svgElement.setAttribute("width", this.data.w),
              this.svgElement.setAttribute("height", this.data.h),
              (this.transformedElement = this.baseElement))
            : (this.transformedElement = this.layerElement);
      }),
      (HCompElement.prototype.addTo3dContainer = function (t, e) {
        for (var i, r = 0; r < e; )
          this.elements[r] &&
            this.elements[r].getBaseElement &&
            (i = this.elements[r].getBaseElement()),
            (r += 1);
        i
          ? this.layerElement.insertBefore(t, i)
          : this.layerElement.appendChild(t);
      }),
      (HCompElement.prototype.createComp = function (t) {
        return this.supports3d
          ? new HCompElement(t, this.globalData, this)
          : new SVGCompElement(t, this.globalData, this);
      }),
      extendPrototype([HybridRendererBase], HybridRenderer),
      (HybridRenderer.prototype.createComp = function (t) {
        return this.supports3d
          ? new HCompElement(t, this.globalData, this)
          : new SVGCompElement(t, this.globalData, this);
      });
    var CompExpressionInterface = function (t) {
      function e(e) {
        for (var i = 0, r = t.layers.length; i < r; ) {
          if (t.layers[i].nm === e || t.layers[i].ind === e)
            return t.elements[i].layerInterface;
          i += 1;
        }
        return null;
      }
      return (
        Object.defineProperty(e, "_name", { value: t.data.nm }),
        (e.layer = e),
        (e.pixelAspect = 1),
        (e.height = t.data.h || t.globalData.compSize.h),
        (e.width = t.data.w || t.globalData.compSize.w),
        (e.pixelAspect = 1),
        (e.frameDuration = 1 / t.globalData.frameRate),
        (e.displayStartTime = 0),
        (e.numLayers = t.layers.length),
        e
      );
    };
    function _typeof$2(t) {
      return (
        (_typeof$2 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$2(t)
      );
    }
    function seedRandom(t, e) {
      var i,
        r = this,
        s = 256,
        a = e.pow(s, 6),
        n = e.pow(2, 52),
        o = 2 * n,
        h = 255;
      function l(t) {
        var e,
          i = t.length,
          r = this,
          a = 0,
          n = (r.i = r.j = 0),
          o = (r.S = []);
        for (i || (t = [i++]); a < s; ) o[a] = a++;
        for (a = 0; a < s; a++)
          (o[a] = o[(n = h & (n + t[a % i] + (e = o[a])))]), (o[n] = e);
        r.g = function (t) {
          for (var e, i = 0, a = r.i, n = r.j, o = r.S; t--; )
            (e = o[(a = h & (a + 1))]),
              (i = i * s + o[h & ((o[a] = o[(n = h & (n + e))]) + (o[n] = e))]);
          return (r.i = a), (r.j = n), i;
        };
      }
      function p(t, e) {
        return (e.i = t.i), (e.j = t.j), (e.S = t.S.slice()), e;
      }
      function f(t, e) {
        var i,
          r = [],
          s = _typeof$2(t);
        if (e && "object" == s)
          for (i in t)
            try {
              r.push(f(t[i], e - 1));
            } catch (t) {}
        return r.length ? r : "string" == s ? t : t + "\0";
      }
      function m(t, e) {
        for (var i, r = t + "", s = 0; s < r.length; )
          e[h & s] = h & ((i ^= 19 * e[h & s]) + r.charCodeAt(s++));
        return c(e);
      }
      function c(t) {
        return String.fromCharCode.apply(0, t);
      }
      (e.seedrandom = function (h, d, u) {
        var y = [],
          g = m(
            f(
              (d = !0 === d ? { entropy: !0 } : d || {}).entropy
                ? [h, c(t)]
                : null === h
                ? (function () {
                    try {
                      i;
                      var e = new Uint8Array(s);
                      return (r.crypto || r.msCrypto).getRandomValues(e), c(e);
                    } catch (e) {
                      var a = r.navigator,
                        n = a && a.plugins;
                      return [+new Date(), r, n, r.screen, c(t)];
                    }
                  })()
                : h,
              3
            ),
            y
          ),
          v = new l(y),
          b = function () {
            for (var t = v.g(6), e = a, i = 0; t < n; )
              (t = (t + i) * s), (e *= s), (i = v.g(1));
            for (; t >= o; ) (t /= 2), (e /= 2), (i >>>= 1);
            return (t + i) / e;
          };
        return (
          (b.int32 = function () {
            return 0 | v.g(4);
          }),
          (b.quick = function () {
            return v.g(4) / 4294967296;
          }),
          (b.double = b),
          m(c(v.S), t),
          (
            d.pass ||
            u ||
            function (t, i, r, s) {
              return (
                s &&
                  (s.S && p(s, v),
                  (t.state = function () {
                    return p(v, {});
                  })),
                r ? ((e.random = t), i) : t
              );
            }
          )(b, g, "global" in d ? d.global : this == e, d.state)
        );
      }),
        m(e.random(), t);
    }
    function initialize$2(t) {
      seedRandom([], t);
    }
    var propTypes = { SHAPE: "shape" };
    function _typeof$1(t) {
      return (
        (_typeof$1 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$1(t)
      );
    }
    var ExpressionManager = (function () {
        var ob = {},
          Math = BMMath,
          window = null,
          document = null,
          XMLHttpRequest = null,
          fetch = null,
          frames = null,
          _lottieGlobal = {};
        function resetFrame() {
          _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(t) {
          return t.constructor === Array || t.constructor === Float32Array;
        }
        function isNumerable(t, e) {
          return (
            "number" === t ||
            e instanceof Number ||
            "boolean" === t ||
            "string" === t
          );
        }
        function $bm_neg(t) {
          var e = _typeof$1(t);
          if ("number" === e || t instanceof Number || "boolean" === e)
            return -t;
          if ($bm_isInstanceOfArray(t)) {
            var i,
              r = t.length,
              s = [];
            for (i = 0; i < r; i += 1) s[i] = -t[i];
            return s;
          }
          return t.propType ? t.v : -t;
        }
        initialize$2(BMMath);
        var easeInBez = BezierFactory.getBezierEasing(
            0.333,
            0,
            0.833,
            0.833,
            "easeIn"
          ).get,
          easeOutBez = BezierFactory.getBezierEasing(
            0.167,
            0.167,
            0.667,
            1,
            "easeOut"
          ).get,
          easeInOutBez = BezierFactory.getBezierEasing(
            0.33,
            0,
            0.667,
            1,
            "easeInOut"
          ).get;
        function sum(t, e) {
          var i = _typeof$1(t),
            r = _typeof$1(e);
          if (
            (isNumerable(i, t) && isNumerable(r, e)) ||
            "string" === i ||
            "string" === r
          )
            return t + e;
          if ($bm_isInstanceOfArray(t) && isNumerable(r, e))
            return ((t = t.slice(0))[0] += e), t;
          if (isNumerable(i, t) && $bm_isInstanceOfArray(e))
            return ((e = e.slice(0))[0] = t + e[0]), e;
          if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
            for (
              var s = 0, a = t.length, n = e.length, o = [];
              s < a || s < n;

            )
              ("number" == typeof t[s] || t[s] instanceof Number) &&
              ("number" == typeof e[s] || e[s] instanceof Number)
                ? (o[s] = t[s] + e[s])
                : (o[s] = void 0 === e[s] ? t[s] : t[s] || e[s]),
                (s += 1);
            return o;
          }
          return 0;
        }
        var add = sum;
        function sub(t, e) {
          var i = _typeof$1(t),
            r = _typeof$1(e);
          if (isNumerable(i, t) && isNumerable(r, e))
            return (
              "string" === i && (t = parseInt(t, 10)),
              "string" === r && (e = parseInt(e, 10)),
              t - e
            );
          if ($bm_isInstanceOfArray(t) && isNumerable(r, e))
            return ((t = t.slice(0))[0] -= e), t;
          if (isNumerable(i, t) && $bm_isInstanceOfArray(e))
            return ((e = e.slice(0))[0] = t - e[0]), e;
          if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
            for (
              var s = 0, a = t.length, n = e.length, o = [];
              s < a || s < n;

            )
              ("number" == typeof t[s] || t[s] instanceof Number) &&
              ("number" == typeof e[s] || e[s] instanceof Number)
                ? (o[s] = t[s] - e[s])
                : (o[s] = void 0 === e[s] ? t[s] : t[s] || e[s]),
                (s += 1);
            return o;
          }
          return 0;
        }
        function mul(t, e) {
          var i,
            r,
            s,
            a = _typeof$1(t),
            n = _typeof$1(e);
          if (isNumerable(a, t) && isNumerable(n, e)) return t * e;
          if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
            for (
              s = t.length, i = createTypedArray("float32", s), r = 0;
              r < s;
              r += 1
            )
              i[r] = t[r] * e;
            return i;
          }
          if (isNumerable(a, t) && $bm_isInstanceOfArray(e)) {
            for (
              s = e.length, i = createTypedArray("float32", s), r = 0;
              r < s;
              r += 1
            )
              i[r] = t * e[r];
            return i;
          }
          return 0;
        }
        function div(t, e) {
          var i,
            r,
            s,
            a = _typeof$1(t),
            n = _typeof$1(e);
          if (isNumerable(a, t) && isNumerable(n, e)) return t / e;
          if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
            for (
              s = t.length, i = createTypedArray("float32", s), r = 0;
              r < s;
              r += 1
            )
              i[r] = t[r] / e;
            return i;
          }
          if (isNumerable(a, t) && $bm_isInstanceOfArray(e)) {
            for (
              s = e.length, i = createTypedArray("float32", s), r = 0;
              r < s;
              r += 1
            )
              i[r] = t / e[r];
            return i;
          }
          return 0;
        }
        function mod(t, e) {
          return (
            "string" == typeof t && (t = parseInt(t, 10)),
            "string" == typeof e && (e = parseInt(e, 10)),
            t % e
          );
        }
        var $bm_sum = sum,
          $bm_sub = sub,
          $bm_mul = mul,
          $bm_div = div,
          $bm_mod = mod;
        function clamp(t, e, i) {
          if (e > i) {
            var r = i;
            (i = e), (e = r);
          }
          return Math.min(Math.max(t, e), i);
        }
        function radiansToDegrees(t) {
          return t / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(t) {
          return t * degToRads;
        }
        var degrees_to_radians = radiansToDegrees,
          helperLengthArray = [0, 0, 0, 0, 0, 0];
        function length(t, e) {
          if ("number" == typeof t || t instanceof Number)
            return (e = e || 0), Math.abs(t - e);
          var i;
          e || (e = helperLengthArray);
          var r = Math.min(t.length, e.length),
            s = 0;
          for (i = 0; i < r; i += 1) s += Math.pow(e[i] - t[i], 2);
          return Math.sqrt(s);
        }
        function normalize(t) {
          return div(t, length(t));
        }
        function rgbToHsl(t) {
          var e,
            i,
            r = t[0],
            s = t[1],
            a = t[2],
            n = Math.max(r, s, a),
            o = Math.min(r, s, a),
            h = (n + o) / 2;
          if (n === o) (e = 0), (i = 0);
          else {
            var l = n - o;
            switch (((i = h > 0.5 ? l / (2 - n - o) : l / (n + o)), n)) {
              case r:
                e = (s - a) / l + (s < a ? 6 : 0);
                break;
              case s:
                e = (a - r) / l + 2;
                break;
              case a:
                e = (r - s) / l + 4;
            }
            e /= 6;
          }
          return [e, i, h, t[3]];
        }
        function hue2rgb(t, e, i) {
          return (
            i < 0 && (i += 1),
            i > 1 && (i -= 1),
            i < 1 / 6
              ? t + 6 * (e - t) * i
              : i < 0.5
              ? e
              : i < 2 / 3
              ? t + (e - t) * (2 / 3 - i) * 6
              : t
          );
        }
        function hslToRgb(t) {
          var e,
            i,
            r,
            s = t[0],
            a = t[1],
            n = t[2];
          if (0 === a) (e = n), (r = n), (i = n);
          else {
            var o = n < 0.5 ? n * (1 + a) : n + a - n * a,
              h = 2 * n - o;
            (e = hue2rgb(h, o, s + 1 / 3)),
              (i = hue2rgb(h, o, s)),
              (r = hue2rgb(h, o, s - 1 / 3));
          }
          return [e, i, r, t[3]];
        }
        function linear(t, e, i, r, s) {
          if (
            ((void 0 !== r && void 0 !== s) ||
              ((r = e), (s = i), (e = 0), (i = 1)),
            i < e)
          ) {
            var a = i;
            (i = e), (e = a);
          }
          if (t <= e) return r;
          if (t >= i) return s;
          var n,
            o = i === e ? 0 : (t - e) / (i - e);
          if (!r.length) return r + (s - r) * o;
          var h = r.length,
            l = createTypedArray("float32", h);
          for (n = 0; n < h; n += 1) l[n] = r[n] + (s[n] - r[n]) * o;
          return l;
        }
        function random(t, e) {
          if (
            (void 0 === e &&
              (void 0 === t ? ((t = 0), (e = 1)) : ((e = t), (t = void 0))),
            e.length)
          ) {
            var i,
              r = e.length;
            t || (t = createTypedArray("float32", r));
            var s = createTypedArray("float32", r),
              a = BMMath.random();
            for (i = 0; i < r; i += 1) s[i] = t[i] + a * (e[i] - t[i]);
            return s;
          }
          return void 0 === t && (t = 0), t + BMMath.random() * (e - t);
        }
        function createPath(t, e, i, r) {
          var s,
            a = t.length,
            n = shapePool.newElement();
          n.setPathData(!!r, a);
          var o,
            h,
            l = [0, 0];
          for (s = 0; s < a; s += 1)
            (o = e && e[s] ? e[s] : l),
              (h = i && i[s] ? i[s] : l),
              n.setTripleAt(
                t[s][0],
                t[s][1],
                h[0] + t[s][0],
                h[1] + t[s][1],
                o[0] + t[s][0],
                o[1] + t[s][1],
                s,
                !0
              );
          return n;
        }
        function initiateExpression(elem, data, property) {
          function noOp(t) {
            return t;
          }
          if (!elem.globalData.renderConfig.runExpressions) return noOp;
          var val = data.x,
            needsVelocity = /velocity(?![\w\d])/.test(val),
            _needsRandom = -1 !== val.indexOf("random"),
            elemType = elem.data.ty,
            transform,
            $bm_transform,
            content,
            effect,
            thisProperty = property;
          (thisProperty.valueAtTime = thisProperty.getValueAtTime),
            Object.defineProperty(thisProperty, "value", {
              get: function () {
                return thisProperty.v;
              },
            }),
            (elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate),
            (elem.comp.displayStartTime = 0);
          var inPoint = elem.data.ip / elem.comp.globalData.frameRate,
            outPoint = elem.data.op / elem.comp.globalData.frameRate,
            width = elem.data.sw ? elem.data.sw : 0,
            height = elem.data.sh ? elem.data.sh : 0,
            name = elem.data.nm,
            loopIn,
            loop_in,
            loopOut,
            loop_out,
            smooth,
            toWorld,
            fromWorld,
            fromComp,
            toComp,
            fromCompToSurface,
            position,
            rotation,
            anchorPoint,
            scale,
            thisLayer,
            thisComp,
            mask,
            valueAtTime,
            velocityAtTime,
            scoped_bm_rt,
            expression_function = eval(
              "[function _expression_function(){" +
                val +
                ";scoped_bm_rt=$bm_rt}]"
            )[0],
            numKeys = property.kf ? data.k.length : 0,
            active = !this.data || !0 !== this.data.hd,
            wiggle = function (t, e) {
              var i,
                r,
                s = this.pv.length ? this.pv.length : 1,
                a = createTypedArray("float32", s);
              var n = Math.floor(5 * time);
              for (i = 0, r = 0; i < n; ) {
                for (r = 0; r < s; r += 1) a[r] += -e + 2 * e * BMMath.random();
                i += 1;
              }
              var o = 5 * time,
                h = o - Math.floor(o),
                l = createTypedArray("float32", s);
              if (s > 1) {
                for (r = 0; r < s; r += 1)
                  l[r] = this.pv[r] + a[r] + (-e + 2 * e * BMMath.random()) * h;
                return l;
              }
              return this.pv + a[0] + (-e + 2 * e * BMMath.random()) * h;
            }.bind(this);
          function loopInDuration(t, e) {
            return loopIn(t, e, !0);
          }
          function loopOutDuration(t, e) {
            return loopOut(t, e, !0);
          }
          thisProperty.loopIn &&
            ((loopIn = thisProperty.loopIn.bind(thisProperty)),
            (loop_in = loopIn)),
            thisProperty.loopOut &&
              ((loopOut = thisProperty.loopOut.bind(thisProperty)),
              (loop_out = loopOut)),
            thisProperty.smooth &&
              (smooth = thisProperty.smooth.bind(thisProperty)),
            this.getValueAtTime &&
              (valueAtTime = this.getValueAtTime.bind(this)),
            this.getVelocityAtTime &&
              (velocityAtTime = this.getVelocityAtTime.bind(this));
          var comp = elem.comp.globalData.projectInterface.bind(
              elem.comp.globalData.projectInterface
            ),
            time,
            velocity,
            value,
            text,
            textIndex,
            textTotal,
            selectorValue;
          function lookAt(t, e) {
            var i = [e[0] - t[0], e[1] - t[1], e[2] - t[2]],
              r =
                Math.atan2(i[0], Math.sqrt(i[1] * i[1] + i[2] * i[2])) /
                degToRads;
            return [-Math.atan2(i[1], i[2]) / degToRads, r, 0];
          }
          function easeOut(t, e, i, r, s) {
            return applyEase(easeOutBez, t, e, i, r, s);
          }
          function easeIn(t, e, i, r, s) {
            return applyEase(easeInBez, t, e, i, r, s);
          }
          function ease(t, e, i, r, s) {
            return applyEase(easeInOutBez, t, e, i, r, s);
          }
          function applyEase(t, e, i, r, s, a) {
            void 0 === s ? ((s = i), (a = r)) : (e = (e - i) / (r - i)),
              e > 1 ? (e = 1) : e < 0 && (e = 0);
            var n = t(e);
            if ($bm_isInstanceOfArray(s)) {
              var o,
                h = s.length,
                l = createTypedArray("float32", h);
              for (o = 0; o < h; o += 1) l[o] = (a[o] - s[o]) * n + s[o];
              return l;
            }
            return (a - s) * n + s;
          }
          function nearestKey(t) {
            var e,
              i,
              r,
              s = data.k.length;
            if (data.k.length && "number" != typeof data.k[0])
              if (
                ((i = -1), (t *= elem.comp.globalData.frameRate) < data.k[0].t)
              )
                (i = 1), (r = data.k[0].t);
              else {
                for (e = 0; e < s - 1; e += 1) {
                  if (t === data.k[e].t) {
                    (i = e + 1), (r = data.k[e].t);
                    break;
                  }
                  if (t > data.k[e].t && t < data.k[e + 1].t) {
                    t - data.k[e].t > data.k[e + 1].t - t
                      ? ((i = e + 2), (r = data.k[e + 1].t))
                      : ((i = e + 1), (r = data.k[e].t));
                    break;
                  }
                }
                -1 === i && ((i = e + 1), (r = data.k[e].t));
              }
            else (i = 0), (r = 0);
            var a = {};
            return (
              (a.index = i), (a.time = r / elem.comp.globalData.frameRate), a
            );
          }
          function key(t) {
            var e, i, r;
            if (!data.k.length || "number" == typeof data.k[0])
              throw new Error("The property has no keyframe at index " + t);
            (t -= 1),
              (e = {
                time: data.k[t].t / elem.comp.globalData.frameRate,
                value: [],
              });
            var s = Object.prototype.hasOwnProperty.call(data.k[t], "s")
              ? data.k[t].s
              : data.k[t - 1].e;
            for (r = s.length, i = 0; i < r; i += 1)
              (e[i] = s[i]), (e.value[i] = s[i]);
            return e;
          }
          function framesToTime(t, e) {
            return e || (e = elem.comp.globalData.frameRate), t / e;
          }
          function timeToFrames(t, e) {
            return (
              t || 0 === t || (t = time),
              e || (e = elem.comp.globalData.frameRate),
              t * e
            );
          }
          function seedRandom(t) {
            BMMath.seedrandom(randSeed + t);
          }
          function sourceRectAtTime() {
            return elem.sourceRectAtTime();
          }
          function substring(t, e) {
            return "string" == typeof value
              ? void 0 === e
                ? value.substring(t)
                : value.substring(t, e)
              : "";
          }
          function substr(t, e) {
            return "string" == typeof value
              ? void 0 === e
                ? value.substr(t)
                : value.substr(t, e)
              : "";
          }
          function posterizeTime(t) {
            (time = 0 === t ? 0 : Math.floor(time * t) / t),
              (value = valueAtTime(time));
          }
          var index = elem.data.ind,
            hasParent = !(!elem.hierarchy || !elem.hierarchy.length),
            parent,
            randSeed = Math.floor(1e6 * Math.random()),
            globalData = elem.globalData;
          function executeExpression(t) {
            return (
              (value = t),
              this.frameExpressionId === elem.globalData.frameId &&
              "textSelector" !== this.propType
                ? value
                : ("textSelector" === this.propType &&
                    ((textIndex = this.textIndex),
                    (textTotal = this.textTotal),
                    (selectorValue = this.selectorValue)),
                  thisLayer ||
                    ((text = elem.layerInterface.text),
                    (thisLayer = elem.layerInterface),
                    (thisComp = elem.comp.compInterface),
                    (toWorld = thisLayer.toWorld.bind(thisLayer)),
                    (fromWorld = thisLayer.fromWorld.bind(thisLayer)),
                    (fromComp = thisLayer.fromComp.bind(thisLayer)),
                    (toComp = thisLayer.toComp.bind(thisLayer)),
                    (mask = thisLayer.mask
                      ? thisLayer.mask.bind(thisLayer)
                      : null),
                    (fromCompToSurface = fromComp)),
                  transform ||
                    ((transform = elem.layerInterface("ADBE Transform Group")),
                    ($bm_transform = transform),
                    transform && (anchorPoint = transform.anchorPoint)),
                  4 !== elemType ||
                    content ||
                    (content = thisLayer("ADBE Root Vectors Group")),
                  effect || (effect = thisLayer(4)),
                  (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) &&
                    !parent &&
                    (parent = elem.hierarchy[0].layerInterface),
                  (time =
                    this.comp.renderedFrame / this.comp.globalData.frameRate),
                  _needsRandom && seedRandom(randSeed + time),
                  needsVelocity && (velocity = velocityAtTime(time)),
                  expression_function(),
                  (this.frameExpressionId = elem.globalData.frameId),
                  (scoped_bm_rt =
                    scoped_bm_rt.propType === propTypes.SHAPE
                      ? scoped_bm_rt.v
                      : scoped_bm_rt))
            );
          }
          return (
            (executeExpression.__preventDeadCodeRemoval = [
              $bm_transform,
              anchorPoint,
              time,
              velocity,
              inPoint,
              outPoint,
              width,
              height,
              name,
              loop_in,
              loop_out,
              smooth,
              toComp,
              fromCompToSurface,
              toWorld,
              fromWorld,
              mask,
              position,
              rotation,
              scale,
              thisComp,
              numKeys,
              active,
              wiggle,
              loopInDuration,
              loopOutDuration,
              comp,
              lookAt,
              easeOut,
              easeIn,
              ease,
              nearestKey,
              key,
              text,
              textIndex,
              textTotal,
              selectorValue,
              framesToTime,
              timeToFrames,
              sourceRectAtTime,
              substring,
              substr,
              posterizeTime,
              index,
              globalData,
            ]),
            executeExpression
          );
        }
        return (
          (ob.initiateExpression = initiateExpression),
          (ob.__preventDeadCodeRemoval = [
            window,
            document,
            XMLHttpRequest,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal,
          ]),
          (ob.resetFrame = resetFrame),
          ob
        );
      })(),
      Expressions = (function () {
        var t = {};
        return (
          (t.initExpressions = function (t) {
            var e = 0,
              i = [];
            (t.renderer.compInterface = CompExpressionInterface(t.renderer)),
              t.renderer.globalData.projectInterface.registerComposition(
                t.renderer
              ),
              (t.renderer.globalData.pushExpression = function () {
                e += 1;
              }),
              (t.renderer.globalData.popExpression = function () {
                0 == (e -= 1) &&
                  (function () {
                    var t,
                      e = i.length;
                    for (t = 0; t < e; t += 1) i[t].release();
                    i.length = 0;
                  })();
              }),
              (t.renderer.globalData.registerExpressionProperty = function (t) {
                -1 === i.indexOf(t) && i.push(t);
              });
          }),
          (t.resetFrame = ExpressionManager.resetFrame),
          t
        );
      })(),
      MaskManagerInterface = (function () {
        function t(t, e) {
          (this._mask = t), (this._data = e);
        }
        Object.defineProperty(t.prototype, "maskPath", {
          get: function () {
            return (
              this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop
            );
          },
        }),
          Object.defineProperty(t.prototype, "maskOpacity", {
            get: function () {
              return (
                this._mask.op.k && this._mask.op.getValue(),
                100 * this._mask.op.v
              );
            },
          });
        return function (e) {
          var i,
            r = createSizedArray(e.viewData.length),
            s = e.viewData.length;
          for (i = 0; i < s; i += 1)
            r[i] = new t(e.viewData[i], e.masksProperties[i]);
          return function (t) {
            for (i = 0; i < s; ) {
              if (e.masksProperties[i].nm === t) return r[i];
              i += 1;
            }
            return null;
          };
        };
      })(),
      ExpressionPropertyInterface = (function () {
        var t = { pv: 0, v: 0, mult: 1 },
          e = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };
        function i(t, e, i) {
          Object.defineProperty(t, "velocity", {
            get: function () {
              return e.getVelocityAtTime(e.comp.currentFrame);
            },
          }),
            (t.numKeys = e.keyframes ? e.keyframes.length : 0),
            (t.key = function (r) {
              if (!t.numKeys) return 0;
              var s = "";
              s =
                "s" in e.keyframes[r - 1]
                  ? e.keyframes[r - 1].s
                  : "e" in e.keyframes[r - 2]
                  ? e.keyframes[r - 2].e
                  : e.keyframes[r - 2].s;
              var a =
                "unidimensional" === i ? new Number(s) : Object.assign({}, s);
              return (
                (a.time =
                  e.keyframes[r - 1].t / e.elem.comp.globalData.frameRate),
                (a.value = "unidimensional" === i ? s[0] : s),
                a
              );
            }),
            (t.valueAtTime = e.getValueAtTime),
            (t.speedAtTime = e.getSpeedAtTime),
            (t.velocityAtTime = e.getVelocityAtTime),
            (t.propertyGroup = e.propertyGroup);
        }
        function r() {
          return t;
        }
        return function (s) {
          return s
            ? "unidimensional" === s.propType
              ? (function (e) {
                  (e && "pv" in e) || (e = t);
                  var r = 1 / e.mult,
                    s = e.pv * r,
                    a = new Number(s);
                  return (
                    (a.value = s),
                    i(a, e, "unidimensional"),
                    function () {
                      return (
                        e.k && e.getValue(),
                        (s = e.v * r),
                        a.value !== s &&
                          (((a = new Number(s)).value = s),
                          i(a, e, "unidimensional")),
                        a
                      );
                    }
                  );
                })(s)
              : (function (t) {
                  (t && "pv" in t) || (t = e);
                  var r = 1 / t.mult,
                    s = (t.data && t.data.l) || t.pv.length,
                    a = createTypedArray("float32", s),
                    n = createTypedArray("float32", s);
                  return (
                    (a.value = n),
                    i(a, t, "multidimensional"),
                    function () {
                      t.k && t.getValue();
                      for (var e = 0; e < s; e += 1)
                        (n[e] = t.v[e] * r), (a[e] = n[e]);
                      return a;
                    }
                  );
                })(s)
            : r;
        };
      })(),
      TransformExpressionInterface = function (t) {
        function e(t) {
          switch (t) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return e.scale;
            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return e.rotation;
            case "ADBE Rotate X":
              return e.xRotation;
            case "ADBE Rotate Y":
              return e.yRotation;
            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return e.position;
            case "ADBE Position_0":
              return e.xPosition;
            case "ADBE Position_1":
              return e.yPosition;
            case "ADBE Position_2":
              return e.zPosition;
            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return e.anchorPoint;
            case "opacity":
            case "Opacity":
            case 11:
              return e.opacity;
            default:
              return null;
          }
        }
        var i, r, s, a;
        return (
          Object.defineProperty(e, "rotation", {
            get: ExpressionPropertyInterface(t.r || t.rz),
          }),
          Object.defineProperty(e, "zRotation", {
            get: ExpressionPropertyInterface(t.rz || t.r),
          }),
          Object.defineProperty(e, "xRotation", {
            get: ExpressionPropertyInterface(t.rx),
          }),
          Object.defineProperty(e, "yRotation", {
            get: ExpressionPropertyInterface(t.ry),
          }),
          Object.defineProperty(e, "scale", {
            get: ExpressionPropertyInterface(t.s),
          }),
          t.p
            ? (a = ExpressionPropertyInterface(t.p))
            : ((i = ExpressionPropertyInterface(t.px)),
              (r = ExpressionPropertyInterface(t.py)),
              t.pz && (s = ExpressionPropertyInterface(t.pz))),
          Object.defineProperty(e, "position", {
            get: function () {
              return t.p ? a() : [i(), r(), s ? s() : 0];
            },
          }),
          Object.defineProperty(e, "xPosition", {
            get: ExpressionPropertyInterface(t.px),
          }),
          Object.defineProperty(e, "yPosition", {
            get: ExpressionPropertyInterface(t.py),
          }),
          Object.defineProperty(e, "zPosition", {
            get: ExpressionPropertyInterface(t.pz),
          }),
          Object.defineProperty(e, "anchorPoint", {
            get: ExpressionPropertyInterface(t.a),
          }),
          Object.defineProperty(e, "opacity", {
            get: ExpressionPropertyInterface(t.o),
          }),
          Object.defineProperty(e, "skew", {
            get: ExpressionPropertyInterface(t.sk),
          }),
          Object.defineProperty(e, "skewAxis", {
            get: ExpressionPropertyInterface(t.sa),
          }),
          Object.defineProperty(e, "orientation", {
            get: ExpressionPropertyInterface(t.or),
          }),
          e
        );
      },
      LayerExpressionInterface = (function () {
        function t(t) {
          var e = new Matrix();
          void 0 !== t
            ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e)
            : this._elem.finalTransform.mProp.applyToMatrix(e);
          return e;
        }
        function e(t, e) {
          var i = this.getMatrix(e);
          return (
            (i.props[12] = 0),
            (i.props[13] = 0),
            (i.props[14] = 0),
            this.applyPoint(i, t)
          );
        }
        function i(t, e) {
          var i = this.getMatrix(e);
          return this.applyPoint(i, t);
        }
        function r(t, e) {
          var i = this.getMatrix(e);
          return (
            (i.props[12] = 0),
            (i.props[13] = 0),
            (i.props[14] = 0),
            this.invertPoint(i, t)
          );
        }
        function s(t, e) {
          var i = this.getMatrix(e);
          return this.invertPoint(i, t);
        }
        function a(t, e) {
          if (this._elem.hierarchy && this._elem.hierarchy.length) {
            var i,
              r = this._elem.hierarchy.length;
            for (i = 0; i < r; i += 1)
              this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(t);
          }
          return t.applyToPointArray(e[0], e[1], e[2] || 0);
        }
        function n(t, e) {
          if (this._elem.hierarchy && this._elem.hierarchy.length) {
            var i,
              r = this._elem.hierarchy.length;
            for (i = 0; i < r; i += 1)
              this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(t);
          }
          return t.inversePoint(e);
        }
        function o(t) {
          var e = new Matrix();
          if (
            (e.reset(),
            this._elem.finalTransform.mProp.applyToMatrix(e),
            this._elem.hierarchy && this._elem.hierarchy.length)
          ) {
            var i,
              r = this._elem.hierarchy.length;
            for (i = 0; i < r; i += 1)
              this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(e);
            return e.inversePoint(t);
          }
          return e.inversePoint(t);
        }
        function h() {
          return [1, 1, 1, 1];
        }
        return function (l) {
          var p;
          function f(t) {
            switch (t) {
              case "ADBE Root Vectors Group":
              case "Contents":
              case 2:
                return f.shapeInterface;
              case 1:
              case 6:
              case "Transform":
              case "transform":
              case "ADBE Transform Group":
                return p;
              case 4:
              case "ADBE Effect Parade":
              case "effects":
              case "Effects":
                return f.effect;
              case "ADBE Text Properties":
                return f.textInterface;
              default:
                return null;
            }
          }
          (f.getMatrix = t),
            (f.invertPoint = n),
            (f.applyPoint = a),
            (f.toWorld = i),
            (f.toWorldVec = e),
            (f.fromWorld = s),
            (f.fromWorldVec = r),
            (f.toComp = i),
            (f.fromComp = o),
            (f.sampleImage = h),
            (f.sourceRectAtTime = l.sourceRectAtTime.bind(l)),
            (f._elem = l);
          var m = getDescriptor(
            (p = TransformExpressionInterface(l.finalTransform.mProp)),
            "anchorPoint"
          );
          return (
            Object.defineProperties(f, {
              hasParent: {
                get: function () {
                  return l.hierarchy.length;
                },
              },
              parent: {
                get: function () {
                  return l.hierarchy[0].layerInterface;
                },
              },
              rotation: getDescriptor(p, "rotation"),
              scale: getDescriptor(p, "scale"),
              position: getDescriptor(p, "position"),
              opacity: getDescriptor(p, "opacity"),
              anchorPoint: m,
              anchor_point: m,
              transform: {
                get: function () {
                  return p;
                },
              },
              active: {
                get: function () {
                  return l.isInRange;
                },
              },
            }),
            (f.startTime = l.data.st),
            (f.index = l.data.ind),
            (f.source = l.data.refId),
            (f.height = 0 === l.data.ty ? l.data.h : 100),
            (f.width = 0 === l.data.ty ? l.data.w : 100),
            (f.inPoint = l.data.ip / l.comp.globalData.frameRate),
            (f.outPoint = l.data.op / l.comp.globalData.frameRate),
            (f._name = l.data.nm),
            (f.registerMaskInterface = function (t) {
              f.mask = new MaskManagerInterface(t, l);
            }),
            (f.registerEffectsInterface = function (t) {
              f.effect = t;
            }),
            f
          );
        };
      })(),
      propertyGroupFactory = function (t, e) {
        return function (i) {
          return (i = void 0 === i ? 1 : i) <= 0 ? t : e(i - 1);
        };
      },
      PropertyInterface = function (t, e) {
        var i = { _name: t };
        return function (t) {
          return (t = void 0 === t ? 1 : t) <= 0 ? i : e(t - 1);
        };
      },
      EffectsExpressionInterface = (function () {
        function t(i, r, s, a) {
          function n(t) {
            for (var e = i.ef, r = 0, s = e.length; r < s; ) {
              if (t === e[r].nm || t === e[r].mn || t === e[r].ix)
                return 5 === e[r].ty ? l[r] : l[r]();
              r += 1;
            }
            throw new Error();
          }
          var o,
            h = propertyGroupFactory(n, s),
            l = [],
            p = i.ef.length;
          for (o = 0; o < p; o += 1)
            5 === i.ef[o].ty
              ? l.push(
                  t(
                    i.ef[o],
                    r.effectElements[o],
                    r.effectElements[o].propertyGroup,
                    a
                  )
                )
              : l.push(e(r.effectElements[o], i.ef[o].ty, a, h));
          return (
            "ADBE Color Control" === i.mn &&
              Object.defineProperty(n, "color", {
                get: function () {
                  return l[0]();
                },
              }),
            Object.defineProperties(n, {
              numProperties: {
                get: function () {
                  return i.np;
                },
              },
              _name: { value: i.nm },
              propertyGroup: { value: h },
            }),
            (n.enabled = 0 !== i.en),
            (n.active = n.enabled),
            n
          );
        }
        function e(t, e, i, r) {
          var s = ExpressionPropertyInterface(t.p);
          return (
            t.p.setGroupProperty &&
              t.p.setGroupProperty(PropertyInterface("", r)),
            function () {
              return 10 === e ? i.comp.compInterface(t.p.v) : s();
            }
          );
        }
        return {
          createEffectsInterface: function (e, i) {
            if (e.effectsManager) {
              var r,
                s = [],
                a = e.data.ef,
                n = e.effectsManager.effectElements.length;
              for (r = 0; r < n; r += 1)
                s.push(t(a[r], e.effectsManager.effectElements[r], i, e));
              var o = e.data.ef || [],
                h = function (t) {
                  for (r = 0, n = o.length; r < n; ) {
                    if (t === o[r].nm || t === o[r].mn || t === o[r].ix)
                      return s[r];
                    r += 1;
                  }
                  return null;
                };
              return (
                Object.defineProperty(h, "numProperties", {
                  get: function () {
                    return o.length;
                  },
                }),
                h
              );
            }
            return null;
          },
        };
      })(),
      ShapePathInterface = function (t, e, i) {
        var r = e.sh;
        function s(t) {
          return "Shape" === t ||
            "shape" === t ||
            "Path" === t ||
            "path" === t ||
            "ADBE Vector Shape" === t ||
            2 === t
            ? s.path
            : null;
        }
        var a = propertyGroupFactory(s, i);
        return (
          r.setGroupProperty(PropertyInterface("Path", a)),
          Object.defineProperties(s, {
            path: {
              get: function () {
                return r.k && r.getValue(), r;
              },
            },
            shape: {
              get: function () {
                return r.k && r.getValue(), r;
              },
            },
            _name: { value: t.nm },
            ix: { value: t.ix },
            propertyIndex: { value: t.ix },
            mn: { value: t.mn },
            propertyGroup: { value: i },
          }),
          s
        );
      },
      ShapeExpressionInterface = (function () {
        function t(t, o, c) {
          var d,
            u = [],
            y = t ? t.length : 0;
          for (d = 0; d < y; d += 1)
            "gr" === t[d].ty
              ? u.push(e(t[d], o[d], c))
              : "fl" === t[d].ty
              ? u.push(i(t[d], o[d], c))
              : "st" === t[d].ty
              ? u.push(a(t[d], o[d], c))
              : "tm" === t[d].ty
              ? u.push(n(t[d], o[d], c))
              : "tr" === t[d].ty ||
                ("el" === t[d].ty
                  ? u.push(h(t[d], o[d], c))
                  : "sr" === t[d].ty
                  ? u.push(l(t[d], o[d], c))
                  : "sh" === t[d].ty
                  ? u.push(ShapePathInterface(t[d], o[d], c))
                  : "rc" === t[d].ty
                  ? u.push(p(t[d], o[d], c))
                  : "rd" === t[d].ty
                  ? u.push(f(t[d], o[d], c))
                  : "rp" === t[d].ty
                  ? u.push(m(t[d], o[d], c))
                  : "gf" === t[d].ty
                  ? u.push(r(t[d], o[d], c))
                  : u.push(s(t[d], o[d])));
          return u;
        }
        function e(e, i, r) {
          var s = function (t) {
            switch (t) {
              case "ADBE Vectors Group":
              case "Contents":
              case 2:
                return s.content;
              default:
                return s.transform;
            }
          };
          s.propertyGroup = propertyGroupFactory(s, r);
          var a = (function (e, i, r) {
              var s,
                a = function (t) {
                  for (var e = 0, i = s.length; e < i; ) {
                    if (
                      s[e]._name === t ||
                      s[e].mn === t ||
                      s[e].propertyIndex === t ||
                      s[e].ix === t ||
                      s[e].ind === t
                    )
                      return s[e];
                    e += 1;
                  }
                  return "number" == typeof t ? s[t - 1] : null;
                };
              (a.propertyGroup = propertyGroupFactory(a, r)),
                (s = t(e.it, i.it, a.propertyGroup)),
                (a.numProperties = s.length);
              var n = o(
                e.it[e.it.length - 1],
                i.it[i.it.length - 1],
                a.propertyGroup
              );
              return (
                (a.transform = n),
                (a.propertyIndex = e.cix),
                (a._name = e.nm),
                a
              );
            })(e, i, s.propertyGroup),
            n = o(
              e.it[e.it.length - 1],
              i.it[i.it.length - 1],
              s.propertyGroup
            );
          return (
            (s.content = a),
            (s.transform = n),
            Object.defineProperty(s, "_name", {
              get: function () {
                return e.nm;
              },
            }),
            (s.numProperties = e.np),
            (s.propertyIndex = e.ix),
            (s.nm = e.nm),
            (s.mn = e.mn),
            s
          );
        }
        function i(t, e, i) {
          function r(t) {
            return "Color" === t || "color" === t
              ? r.color
              : "Opacity" === t || "opacity" === t
              ? r.opacity
              : null;
          }
          return (
            Object.defineProperties(r, {
              color: { get: ExpressionPropertyInterface(e.c) },
              opacity: { get: ExpressionPropertyInterface(e.o) },
              _name: { value: t.nm },
              mn: { value: t.mn },
            }),
            e.c.setGroupProperty(PropertyInterface("Color", i)),
            e.o.setGroupProperty(PropertyInterface("Opacity", i)),
            r
          );
        }
        function r(t, e, i) {
          function r(t) {
            return "Start Point" === t || "start point" === t
              ? r.startPoint
              : "End Point" === t || "end point" === t
              ? r.endPoint
              : "Opacity" === t || "opacity" === t
              ? r.opacity
              : null;
          }
          return (
            Object.defineProperties(r, {
              startPoint: { get: ExpressionPropertyInterface(e.s) },
              endPoint: { get: ExpressionPropertyInterface(e.e) },
              opacity: { get: ExpressionPropertyInterface(e.o) },
              type: {
                get: function () {
                  return "a";
                },
              },
              _name: { value: t.nm },
              mn: { value: t.mn },
            }),
            e.s.setGroupProperty(PropertyInterface("Start Point", i)),
            e.e.setGroupProperty(PropertyInterface("End Point", i)),
            e.o.setGroupProperty(PropertyInterface("Opacity", i)),
            r
          );
        }
        function s() {
          return function () {
            return null;
          };
        }
        function a(t, e, i) {
          var r,
            s = propertyGroupFactory(l, i),
            a = propertyGroupFactory(h, s);
          function n(i) {
            Object.defineProperty(h, t.d[i].nm, {
              get: ExpressionPropertyInterface(e.d.dataProps[i].p),
            });
          }
          var o = t.d ? t.d.length : 0,
            h = {};
          for (r = 0; r < o; r += 1)
            n(r), e.d.dataProps[r].p.setGroupProperty(a);
          function l(t) {
            return "Color" === t || "color" === t
              ? l.color
              : "Opacity" === t || "opacity" === t
              ? l.opacity
              : "Stroke Width" === t || "stroke width" === t
              ? l.strokeWidth
              : null;
          }
          return (
            Object.defineProperties(l, {
              color: { get: ExpressionPropertyInterface(e.c) },
              opacity: { get: ExpressionPropertyInterface(e.o) },
              strokeWidth: { get: ExpressionPropertyInterface(e.w) },
              dash: {
                get: function () {
                  return h;
                },
              },
              _name: { value: t.nm },
              mn: { value: t.mn },
            }),
            e.c.setGroupProperty(PropertyInterface("Color", s)),
            e.o.setGroupProperty(PropertyInterface("Opacity", s)),
            e.w.setGroupProperty(PropertyInterface("Stroke Width", s)),
            l
          );
        }
        function n(t, e, i) {
          function r(e) {
            return e === t.e.ix || "End" === e || "end" === e
              ? r.end
              : e === t.s.ix
              ? r.start
              : e === t.o.ix
              ? r.offset
              : null;
          }
          var s = propertyGroupFactory(r, i);
          return (
            (r.propertyIndex = t.ix),
            e.s.setGroupProperty(PropertyInterface("Start", s)),
            e.e.setGroupProperty(PropertyInterface("End", s)),
            e.o.setGroupProperty(PropertyInterface("Offset", s)),
            (r.propertyIndex = t.ix),
            (r.propertyGroup = i),
            Object.defineProperties(r, {
              start: { get: ExpressionPropertyInterface(e.s) },
              end: { get: ExpressionPropertyInterface(e.e) },
              offset: { get: ExpressionPropertyInterface(e.o) },
              _name: { value: t.nm },
            }),
            (r.mn = t.mn),
            r
          );
        }
        function o(t, e, i) {
          function r(e) {
            return t.a.ix === e || "Anchor Point" === e
              ? r.anchorPoint
              : t.o.ix === e || "Opacity" === e
              ? r.opacity
              : t.p.ix === e || "Position" === e
              ? r.position
              : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e
              ? r.rotation
              : t.s.ix === e || "Scale" === e
              ? r.scale
              : (t.sk && t.sk.ix === e) || "Skew" === e
              ? r.skew
              : (t.sa && t.sa.ix === e) || "Skew Axis" === e
              ? r.skewAxis
              : null;
          }
          var s = propertyGroupFactory(r, i);
          return (
            e.transform.mProps.o.setGroupProperty(
              PropertyInterface("Opacity", s)
            ),
            e.transform.mProps.p.setGroupProperty(
              PropertyInterface("Position", s)
            ),
            e.transform.mProps.a.setGroupProperty(
              PropertyInterface("Anchor Point", s)
            ),
            e.transform.mProps.s.setGroupProperty(
              PropertyInterface("Scale", s)
            ),
            e.transform.mProps.r.setGroupProperty(
              PropertyInterface("Rotation", s)
            ),
            e.transform.mProps.sk &&
              (e.transform.mProps.sk.setGroupProperty(
                PropertyInterface("Skew", s)
              ),
              e.transform.mProps.sa.setGroupProperty(
                PropertyInterface("Skew Angle", s)
              )),
            e.transform.op.setGroupProperty(PropertyInterface("Opacity", s)),
            Object.defineProperties(r, {
              opacity: {
                get: ExpressionPropertyInterface(e.transform.mProps.o),
              },
              position: {
                get: ExpressionPropertyInterface(e.transform.mProps.p),
              },
              anchorPoint: {
                get: ExpressionPropertyInterface(e.transform.mProps.a),
              },
              scale: { get: ExpressionPropertyInterface(e.transform.mProps.s) },
              rotation: {
                get: ExpressionPropertyInterface(e.transform.mProps.r),
              },
              skew: { get: ExpressionPropertyInterface(e.transform.mProps.sk) },
              skewAxis: {
                get: ExpressionPropertyInterface(e.transform.mProps.sa),
              },
              _name: { value: t.nm },
            }),
            (r.ty = "tr"),
            (r.mn = t.mn),
            (r.propertyGroup = i),
            r
          );
        }
        function h(t, e, i) {
          function r(e) {
            return t.p.ix === e ? r.position : t.s.ix === e ? r.size : null;
          }
          var s = propertyGroupFactory(r, i);
          r.propertyIndex = t.ix;
          var a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
          return (
            a.s.setGroupProperty(PropertyInterface("Size", s)),
            a.p.setGroupProperty(PropertyInterface("Position", s)),
            Object.defineProperties(r, {
              size: { get: ExpressionPropertyInterface(a.s) },
              position: { get: ExpressionPropertyInterface(a.p) },
              _name: { value: t.nm },
            }),
            (r.mn = t.mn),
            r
          );
        }
        function l(t, e, i) {
          function r(e) {
            return t.p.ix === e
              ? r.position
              : t.r.ix === e
              ? r.rotation
              : t.pt.ix === e
              ? r.points
              : t.or.ix === e || "ADBE Vector Star Outer Radius" === e
              ? r.outerRadius
              : t.os.ix === e
              ? r.outerRoundness
              : !t.ir ||
                (t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e)
              ? t.is && t.is.ix === e
                ? r.innerRoundness
                : null
              : r.innerRadius;
          }
          var s = propertyGroupFactory(r, i),
            a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
          return (
            (r.propertyIndex = t.ix),
            a.or.setGroupProperty(PropertyInterface("Outer Radius", s)),
            a.os.setGroupProperty(PropertyInterface("Outer Roundness", s)),
            a.pt.setGroupProperty(PropertyInterface("Points", s)),
            a.p.setGroupProperty(PropertyInterface("Position", s)),
            a.r.setGroupProperty(PropertyInterface("Rotation", s)),
            t.ir &&
              (a.ir.setGroupProperty(PropertyInterface("Inner Radius", s)),
              a.is.setGroupProperty(PropertyInterface("Inner Roundness", s))),
            Object.defineProperties(r, {
              position: { get: ExpressionPropertyInterface(a.p) },
              rotation: { get: ExpressionPropertyInterface(a.r) },
              points: { get: ExpressionPropertyInterface(a.pt) },
              outerRadius: { get: ExpressionPropertyInterface(a.or) },
              outerRoundness: { get: ExpressionPropertyInterface(a.os) },
              innerRadius: { get: ExpressionPropertyInterface(a.ir) },
              innerRoundness: { get: ExpressionPropertyInterface(a.is) },
              _name: { value: t.nm },
            }),
            (r.mn = t.mn),
            r
          );
        }
        function p(t, e, i) {
          function r(e) {
            return t.p.ix === e
              ? r.position
              : t.r.ix === e
              ? r.roundness
              : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e
              ? r.size
              : null;
          }
          var s = propertyGroupFactory(r, i),
            a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
          return (
            (r.propertyIndex = t.ix),
            a.p.setGroupProperty(PropertyInterface("Position", s)),
            a.s.setGroupProperty(PropertyInterface("Size", s)),
            a.r.setGroupProperty(PropertyInterface("Rotation", s)),
            Object.defineProperties(r, {
              position: { get: ExpressionPropertyInterface(a.p) },
              roundness: { get: ExpressionPropertyInterface(a.r) },
              size: { get: ExpressionPropertyInterface(a.s) },
              _name: { value: t.nm },
            }),
            (r.mn = t.mn),
            r
          );
        }
        function f(t, e, i) {
          function r(e) {
            return t.r.ix === e || "Round Corners 1" === e ? r.radius : null;
          }
          var s = propertyGroupFactory(r, i),
            a = e;
          return (
            (r.propertyIndex = t.ix),
            a.rd.setGroupProperty(PropertyInterface("Radius", s)),
            Object.defineProperties(r, {
              radius: { get: ExpressionPropertyInterface(a.rd) },
              _name: { value: t.nm },
            }),
            (r.mn = t.mn),
            r
          );
        }
        function m(t, e, i) {
          function r(e) {
            return t.c.ix === e || "Copies" === e
              ? r.copies
              : t.o.ix === e || "Offset" === e
              ? r.offset
              : null;
          }
          var s = propertyGroupFactory(r, i),
            a = e;
          return (
            (r.propertyIndex = t.ix),
            a.c.setGroupProperty(PropertyInterface("Copies", s)),
            a.o.setGroupProperty(PropertyInterface("Offset", s)),
            Object.defineProperties(r, {
              copies: { get: ExpressionPropertyInterface(a.c) },
              offset: { get: ExpressionPropertyInterface(a.o) },
              _name: { value: t.nm },
            }),
            (r.mn = t.mn),
            r
          );
        }
        return function (e, i, r) {
          var s;
          function a(t) {
            if ("number" == typeof t)
              return 0 === (t = void 0 === t ? 1 : t) ? r : s[t - 1];
            for (var e = 0, i = s.length; e < i; ) {
              if (s[e]._name === t) return s[e];
              e += 1;
            }
            return null;
          }
          return (
            (a.propertyGroup = propertyGroupFactory(a, function () {
              return r;
            })),
            (s = t(e, i, a.propertyGroup)),
            (a.numProperties = s.length),
            (a._name = "Contents"),
            a
          );
        };
      })(),
      TextExpressionInterface = function (t) {
        var e;
        function i(t) {
          return "ADBE Text Document" === t ? i.sourceText : null;
        }
        return (
          Object.defineProperty(i, "sourceText", {
            get: function () {
              t.textProperty.getValue();
              var i = t.textProperty.currentData.t;
              return (
                (e && i === e.value) ||
                  (((e = new String(i)).value = i || new String(i)),
                  Object.defineProperty(e, "style", {
                    get: function () {
                      return { fillColor: t.textProperty.currentData.fc };
                    },
                  })),
                e
              );
            },
          }),
          i
        );
      };
    function _typeof(t) {
      return (
        (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof(t)
      );
    }
    var FootageInterface =
        ((dataInterfaceFactory = function (t) {
          function e(t) {
            return "Outline" === t ? e.outlineInterface() : null;
          }
          return (
            (e._name = "Outline"),
            (e.outlineInterface = (function (t) {
              var e = "",
                i = t.getFootageData();
              function r(t) {
                if (i[t])
                  return (e = t), "object" === _typeof((i = i[t])) ? r : i;
                var s = t.indexOf(e);
                if (-1 !== s) {
                  var a = parseInt(t.substr(s + e.length), 10);
                  return "object" === _typeof((i = i[a])) ? r : i;
                }
                return "";
              }
              return function () {
                return (e = ""), (i = t.getFootageData()), r;
              };
            })(t)),
            e
          );
        }),
        function (t) {
          function e(t) {
            return "Data" === t ? e.dataInterface : null;
          }
          return (
            (e._name = "Data"), (e.dataInterface = dataInterfaceFactory(t)), e
          );
        }),
      dataInterfaceFactory,
      interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface,
      };
    function getInterface(t) {
      return interfaces[t] || null;
    }
    var expressionHelpers = {
      searchExpressions: function (t, e, i) {
        e.x &&
          ((i.k = !0),
          (i.x = !0),
          (i.initiateExpression = ExpressionManager.initiateExpression),
          i.effectsSequence.push(i.initiateExpression(t, e, i).bind(i)));
      },
      getSpeedAtTime: function (t) {
        var e = this.getValueAtTime(t),
          i = this.getValueAtTime(t + -0.01),
          r = 0;
        if (e.length) {
          var s;
          for (s = 0; s < e.length; s += 1) r += Math.pow(i[s] - e[s], 2);
          r = 100 * Math.sqrt(r);
        } else r = 0;
        return r;
      },
      getVelocityAtTime: function (t) {
        if (void 0 !== this.vel) return this.vel;
        var e,
          i,
          r = -0.001,
          s = this.getValueAtTime(t),
          a = this.getValueAtTime(t + r);
        if (s.length)
          for (
            e = createTypedArray("float32", s.length), i = 0;
            i < s.length;
            i += 1
          )
            e[i] = (a[i] - s[i]) / r;
        else e = (a - s) / r;
        return e;
      },
      getValueAtTime: function (t) {
        return (
          (t *= this.elem.globalData.frameRate),
          (t -= this.offsetTime) !== this._cachingAtTime.lastFrame &&
            ((this._cachingAtTime.lastIndex =
              this._cachingAtTime.lastFrame < t
                ? this._cachingAtTime.lastIndex
                : 0),
            (this._cachingAtTime.value = this.interpolateValue(
              t,
              this._cachingAtTime
            )),
            (this._cachingAtTime.lastFrame = t)),
          this._cachingAtTime.value
        );
      },
      getStaticValueAtTime: function () {
        return this.pv;
      },
      setGroupProperty: function (t) {
        this.propertyGroup = t;
      },
    };
    function addPropertyDecorator() {
      function t(t, e, i) {
        if (!this.k || !this.keyframes) return this.pv;
        t = t ? t.toLowerCase() : "";
        var r,
          s,
          a,
          n,
          o,
          h = this.comp.renderedFrame,
          l = this.keyframes,
          p = l[l.length - 1].t;
        if (h <= p) return this.pv;
        if (
          (i
            ? (s =
                p -
                (r = e
                  ? Math.abs(p - this.elem.comp.globalData.frameRate * e)
                  : Math.max(0, p - this.elem.data.ip)))
            : ((!e || e > l.length - 1) && (e = l.length - 1),
              (r = p - (s = l[l.length - 1 - e].t))),
          "pingpong" === t)
        ) {
          if (Math.floor((h - s) / r) % 2 != 0)
            return this.getValueAtTime(
              (r - ((h - s) % r) + s) / this.comp.globalData.frameRate,
              0
            );
        } else {
          if ("offset" === t) {
            var f = this.getValueAtTime(s / this.comp.globalData.frameRate, 0),
              m = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
              c = this.getValueAtTime(
                (((h - s) % r) + s) / this.comp.globalData.frameRate,
                0
              ),
              d = Math.floor((h - s) / r);
            if (this.pv.length) {
              for (n = (o = new Array(f.length)).length, a = 0; a < n; a += 1)
                o[a] = (m[a] - f[a]) * d + c[a];
              return o;
            }
            return (m - f) * d + c;
          }
          if ("continue" === t) {
            var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
              y = this.getValueAtTime(
                (p - 0.001) / this.comp.globalData.frameRate,
                0
              );
            if (this.pv.length) {
              for (n = (o = new Array(u.length)).length, a = 0; a < n; a += 1)
                o[a] =
                  u[a] +
                  ((u[a] - y[a]) * ((h - p) / this.comp.globalData.frameRate)) /
                    5e-4;
              return o;
            }
            return u + ((h - p) / 0.001) * (u - y);
          }
        }
        return this.getValueAtTime(
          (((h - s) % r) + s) / this.comp.globalData.frameRate,
          0
        );
      }
      function e(t, e, i) {
        if (!this.k) return this.pv;
        t = t ? t.toLowerCase() : "";
        var r,
          s,
          a,
          n,
          o,
          h = this.comp.renderedFrame,
          l = this.keyframes,
          p = l[0].t;
        if (h >= p) return this.pv;
        if (
          (i
            ? (s =
                p +
                (r = e
                  ? Math.abs(this.elem.comp.globalData.frameRate * e)
                  : Math.max(0, this.elem.data.op - p)))
            : ((!e || e > l.length - 1) && (e = l.length - 1),
              (r = (s = l[e].t) - p)),
          "pingpong" === t)
        ) {
          if (Math.floor((p - h) / r) % 2 == 0)
            return this.getValueAtTime(
              (((p - h) % r) + p) / this.comp.globalData.frameRate,
              0
            );
        } else {
          if ("offset" === t) {
            var f = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
              m = this.getValueAtTime(s / this.comp.globalData.frameRate, 0),
              c = this.getValueAtTime(
                (r - ((p - h) % r) + p) / this.comp.globalData.frameRate,
                0
              ),
              d = Math.floor((p - h) / r) + 1;
            if (this.pv.length) {
              for (n = (o = new Array(f.length)).length, a = 0; a < n; a += 1)
                o[a] = c[a] - (m[a] - f[a]) * d;
              return o;
            }
            return c - (m - f) * d;
          }
          if ("continue" === t) {
            var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
              y = this.getValueAtTime(
                (p + 0.001) / this.comp.globalData.frameRate,
                0
              );
            if (this.pv.length) {
              for (n = (o = new Array(u.length)).length, a = 0; a < n; a += 1)
                o[a] = u[a] + ((u[a] - y[a]) * (p - h)) / 0.001;
              return o;
            }
            return u + ((u - y) * (p - h)) / 0.001;
          }
        }
        return this.getValueAtTime(
          (r - (((p - h) % r) + p)) / this.comp.globalData.frameRate,
          0
        );
      }
      function i(t, e) {
        if (!this.k) return this.pv;
        if (((t = 0.5 * (t || 0.4)), (e = Math.floor(e || 5)) <= 1))
          return this.pv;
        var i,
          r,
          s = this.comp.renderedFrame / this.comp.globalData.frameRate,
          a = s - t,
          n = e > 1 ? (s + t - a) / (e - 1) : 1,
          o = 0,
          h = 0;
        for (
          i = this.pv.length ? createTypedArray("float32", this.pv.length) : 0;
          o < e;

        ) {
          if (((r = this.getValueAtTime(a + o * n)), this.pv.length))
            for (h = 0; h < this.pv.length; h += 1) i[h] += r[h];
          else i += r;
          o += 1;
        }
        if (this.pv.length) for (h = 0; h < this.pv.length; h += 1) i[h] /= e;
        else i /= e;
        return i;
      }
      function r(t) {
        this._transformCachingAtTime ||
          (this._transformCachingAtTime = { v: new Matrix() });
        var e = this._transformCachingAtTime.v;
        if (
          (e.cloneFromProps(this.pre.props), this.appliedTransformations < 1)
        ) {
          var i = this.a.getValueAtTime(t);
          e.translate(
            -i[0] * this.a.mult,
            -i[1] * this.a.mult,
            i[2] * this.a.mult
          );
        }
        if (this.appliedTransformations < 2) {
          var r = this.s.getValueAtTime(t);
          e.scale(r[0] * this.s.mult, r[1] * this.s.mult, r[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var s = this.sk.getValueAtTime(t),
            a = this.sa.getValueAtTime(t);
          e.skewFromAxis(-s * this.sk.mult, a * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var n = this.r.getValueAtTime(t);
          e.rotate(-n * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var o = this.rz.getValueAtTime(t),
            h = this.ry.getValueAtTime(t),
            l = this.rx.getValueAtTime(t),
            p = this.or.getValueAtTime(t);
          e.rotateZ(-o * this.rz.mult)
            .rotateY(h * this.ry.mult)
            .rotateX(l * this.rx.mult)
            .rotateZ(-p[2] * this.or.mult)
            .rotateY(p[1] * this.or.mult)
            .rotateX(p[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var f = this.px.getValueAtTime(t),
            m = this.py.getValueAtTime(t);
          if (this.data.p.z) {
            var c = this.pz.getValueAtTime(t);
            e.translate(f * this.px.mult, m * this.py.mult, -c * this.pz.mult);
          } else e.translate(f * this.px.mult, m * this.py.mult, 0);
        } else {
          var d = this.p.getValueAtTime(t);
          e.translate(
            d[0] * this.p.mult,
            d[1] * this.p.mult,
            -d[2] * this.p.mult
          );
        }
        return e;
      }
      function s() {
        return this.v.clone(new Matrix());
      }
      var a = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function (t, e, i) {
        var n = a(t, e, i);
        return (
          n.dynamicProperties.length
            ? (n.getValueAtTime = r.bind(n))
            : (n.getValueAtTime = s.bind(n)),
          (n.setGroupProperty = expressionHelpers.setGroupProperty),
          n
        );
      };
      var n = PropertyFactory.getProp;
      PropertyFactory.getProp = function (r, s, a, o, h) {
        var l = n(r, s, a, o, h);
        l.kf
          ? (l.getValueAtTime = expressionHelpers.getValueAtTime.bind(l))
          : (l.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(l)),
          (l.setGroupProperty = expressionHelpers.setGroupProperty),
          (l.loopOut = t),
          (l.loopIn = e),
          (l.smooth = i),
          (l.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(l)),
          (l.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(l)),
          (l.numKeys = 1 === s.a ? s.k.length : 0),
          (l.propertyIndex = s.ix);
        var p = 0;
        return (
          0 !== a &&
            (p = createTypedArray(
              "float32",
              1 === s.a ? s.k[0].s.length : s.k.length
            )),
          (l._cachingAtTime = {
            lastFrame: initialDefaultFrame,
            lastIndex: 0,
            value: p,
          }),
          expressionHelpers.searchExpressions(r, s, l),
          l.k && h.addDynamicProperty(l),
          l
        );
      };
      var o = ShapePropertyFactory.getConstructorFunction(),
        h = ShapePropertyFactory.getKeyframedConstructorFunction();
      function l() {}
      (l.prototype = {
        vertices: function (t, e) {
          this.k && this.getValue();
          var i,
            r = this.v;
          void 0 !== e && (r = this.getValueAtTime(e, 0));
          var s = r._length,
            a = r[t],
            n = r.v,
            o = createSizedArray(s);
          for (i = 0; i < s; i += 1)
            o[i] =
              "i" === t || "o" === t
                ? [a[i][0] - n[i][0], a[i][1] - n[i][1]]
                : [a[i][0], a[i][1]];
          return o;
        },
        points: function (t) {
          return this.vertices("v", t);
        },
        inTangents: function (t) {
          return this.vertices("i", t);
        },
        outTangents: function (t) {
          return this.vertices("o", t);
        },
        isClosed: function () {
          return this.v.c;
        },
        pointOnPath: function (t, e) {
          var i = this.v;
          void 0 !== e && (i = this.getValueAtTime(e, 0)),
            this._segmentsLength ||
              (this._segmentsLength = bez.getSegmentsLength(i));
          for (
            var r,
              s = this._segmentsLength,
              a = s.lengths,
              n = s.totalLength * t,
              o = 0,
              h = a.length,
              l = 0;
            o < h;

          ) {
            if (l + a[o].addedLength > n) {
              var p = o,
                f = i.c && o === h - 1 ? 0 : o + 1,
                m = (n - l) / a[o].addedLength;
              r = bez.getPointInSegment(
                i.v[p],
                i.v[f],
                i.o[p],
                i.i[f],
                m,
                a[o]
              );
              break;
            }
            (l += a[o].addedLength), (o += 1);
          }
          return (
            r ||
              (r = i.c
                ? [i.v[0][0], i.v[0][1]]
                : [i.v[i._length - 1][0], i.v[i._length - 1][1]]),
            r
          );
        },
        vectorOnPath: function (t, e, i) {
          1 == t ? (t = this.v.c) : 0 == t && (t = 0.999);
          var r = this.pointOnPath(t, e),
            s = this.pointOnPath(t + 0.001, e),
            a = s[0] - r[0],
            n = s[1] - r[1],
            o = Math.sqrt(Math.pow(a, 2) + Math.pow(n, 2));
          return 0 === o
            ? [0, 0]
            : "tangent" === i
            ? [a / o, n / o]
            : [-n / o, a / o];
        },
        tangentOnPath: function (t, e) {
          return this.vectorOnPath(t, e, "tangent");
        },
        normalOnPath: function (t, e) {
          return this.vectorOnPath(t, e, "normal");
        },
        setGroupProperty: expressionHelpers.setGroupProperty,
        getValueAtTime: expressionHelpers.getStaticValueAtTime,
      }),
        extendPrototype([l], o),
        extendPrototype([l], h),
        (h.prototype.getValueAtTime = function (t) {
          return (
            this._cachingAtTime ||
              (this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame,
              }),
            (t *= this.elem.globalData.frameRate),
            (t -= this.offsetTime) !== this._cachingAtTime.lastTime &&
              ((this._cachingAtTime.lastIndex =
                this._cachingAtTime.lastTime < t ? this._caching.lastIndex : 0),
              (this._cachingAtTime.lastTime = t),
              this.interpolateShape(
                t,
                this._cachingAtTime.shapeValue,
                this._cachingAtTime
              )),
            this._cachingAtTime.shapeValue
          );
        }),
        (h.prototype.initiateExpression = ExpressionManager.initiateExpression);
      var p = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function (t, e, i, r, s) {
        var a = p(t, e, i, r, s);
        return (
          (a.propertyIndex = e.ix),
          (a.lock = !1),
          3 === i
            ? expressionHelpers.searchExpressions(t, e.pt, a)
            : 4 === i && expressionHelpers.searchExpressions(t, e.ks, a),
          a.k && t.addDynamicProperty(a),
          a
        );
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      (TextProperty.prototype.getExpressionValue = function (t, e) {
        var i = this.calculateExpression(e);
        if (t.t !== i) {
          var r = {};
          return (
            this.copyData(r, t), (r.t = i.toString()), (r.__complete = !1), r
          );
        }
        return t;
      }),
        (TextProperty.prototype.searchProperty = function () {
          var t = this.searchKeyframes(),
            e = this.searchExpressions();
          return (this.kf = t || e), this.kf;
        }),
        (TextProperty.prototype.searchExpressions = function () {
          return this.data.d.x
            ? ((this.calculateExpression =
                ExpressionManager.initiateExpression.bind(this)(
                  this.elem,
                  this.data.d,
                  this
                )),
              this.addEffect(this.getExpressionValue.bind(this)),
              !0)
            : null;
        });
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
      createMergeNode: function (t, e) {
        var i,
          r,
          s = createNS("feMerge");
        for (s.setAttribute("result", t), r = 0; r < e.length; r += 1)
          (i = createNS("feMergeNode")).setAttribute("in", e[r]),
            s.appendChild(i),
            s.appendChild(i);
        return s;
      },
    };
    var linearFilterValue =
      "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(t, e, i, r, s) {
      this.filterManager = e;
      var a = createNS("feColorMatrix");
      a.setAttribute("type", "matrix"),
        a.setAttribute("color-interpolation-filters", "linearRGB"),
        a.setAttribute("values", linearFilterValue + " 1 0"),
        (this.linearFilter = a),
        a.setAttribute("result", r + "_tint_1"),
        t.appendChild(a),
        (a = createNS("feColorMatrix")).setAttribute("type", "matrix"),
        a.setAttribute("color-interpolation-filters", "sRGB"),
        a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
        a.setAttribute("result", r + "_tint_2"),
        t.appendChild(a),
        (this.matrixFilter = a);
      var n = this.createMergeNode(r, [s, r + "_tint_1", r + "_tint_2"]);
      t.appendChild(n);
    }
    function SVGFillFilter(t, e, i, r) {
      this.filterManager = e;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"),
        s.setAttribute("color-interpolation-filters", "sRGB"),
        s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
        s.setAttribute("result", r),
        t.appendChild(s),
        (this.matrixFilter = s);
    }
    function SVGStrokeEffect(t, e, i) {
      (this.initialized = !1),
        (this.filterManager = e),
        (this.elem = i),
        (this.paths = []);
    }
    function SVGTritoneFilter(t, e, i, r) {
      this.filterManager = e;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"),
        s.setAttribute("color-interpolation-filters", "linearRGB"),
        s.setAttribute(
          "values",
          "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
        ),
        t.appendChild(s);
      var a = createNS("feComponentTransfer");
      a.setAttribute("color-interpolation-filters", "sRGB"),
        a.setAttribute("result", r),
        (this.matrixFilter = a);
      var n = createNS("feFuncR");
      n.setAttribute("type", "table"), a.appendChild(n), (this.feFuncR = n);
      var o = createNS("feFuncG");
      o.setAttribute("type", "table"), a.appendChild(o), (this.feFuncG = o);
      var h = createNS("feFuncB");
      h.setAttribute("type", "table"),
        a.appendChild(h),
        (this.feFuncB = h),
        t.appendChild(a);
    }
    function SVGProLevelsFilter(t, e, i, r) {
      this.filterManager = e;
      var s = this.filterManager.effectElements,
        a = createNS("feComponentTransfer");
      (s[10].p.k ||
        0 !== s[10].p.v ||
        s[11].p.k ||
        1 !== s[11].p.v ||
        s[12].p.k ||
        1 !== s[12].p.v ||
        s[13].p.k ||
        0 !== s[13].p.v ||
        s[14].p.k ||
        1 !== s[14].p.v) &&
        (this.feFuncR = this.createFeFunc("feFuncR", a)),
        (s[17].p.k ||
          0 !== s[17].p.v ||
          s[18].p.k ||
          1 !== s[18].p.v ||
          s[19].p.k ||
          1 !== s[19].p.v ||
          s[20].p.k ||
          0 !== s[20].p.v ||
          s[21].p.k ||
          1 !== s[21].p.v) &&
          (this.feFuncG = this.createFeFunc("feFuncG", a)),
        (s[24].p.k ||
          0 !== s[24].p.v ||
          s[25].p.k ||
          1 !== s[25].p.v ||
          s[26].p.k ||
          1 !== s[26].p.v ||
          s[27].p.k ||
          0 !== s[27].p.v ||
          s[28].p.k ||
          1 !== s[28].p.v) &&
          (this.feFuncB = this.createFeFunc("feFuncB", a)),
        (s[31].p.k ||
          0 !== s[31].p.v ||
          s[32].p.k ||
          1 !== s[32].p.v ||
          s[33].p.k ||
          1 !== s[33].p.v ||
          s[34].p.k ||
          0 !== s[34].p.v ||
          s[35].p.k ||
          1 !== s[35].p.v) &&
          (this.feFuncA = this.createFeFunc("feFuncA", a)),
        (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) &&
          (a.setAttribute("color-interpolation-filters", "sRGB"),
          t.appendChild(a)),
        (s[3].p.k ||
          0 !== s[3].p.v ||
          s[4].p.k ||
          1 !== s[4].p.v ||
          s[5].p.k ||
          1 !== s[5].p.v ||
          s[6].p.k ||
          0 !== s[6].p.v ||
          s[7].p.k ||
          1 !== s[7].p.v) &&
          ((a = createNS("feComponentTransfer")).setAttribute(
            "color-interpolation-filters",
            "sRGB"
          ),
          a.setAttribute("result", r),
          t.appendChild(a),
          (this.feFuncRComposed = this.createFeFunc("feFuncR", a)),
          (this.feFuncGComposed = this.createFeFunc("feFuncG", a)),
          (this.feFuncBComposed = this.createFeFunc("feFuncB", a)));
    }
    function SVGDropShadowEffect(t, e, i, r, s) {
      var a = e.container.globalData.renderConfig.filterSize,
        n = e.data.fs || a;
      t.setAttribute("x", n.x || a.x),
        t.setAttribute("y", n.y || a.y),
        t.setAttribute("width", n.width || a.width),
        t.setAttribute("height", n.height || a.height),
        (this.filterManager = e);
      var o = createNS("feGaussianBlur");
      o.setAttribute("in", "SourceAlpha"),
        o.setAttribute("result", r + "_drop_shadow_1"),
        o.setAttribute("stdDeviation", "0"),
        (this.feGaussianBlur = o),
        t.appendChild(o);
      var h = createNS("feOffset");
      h.setAttribute("dx", "25"),
        h.setAttribute("dy", "0"),
        h.setAttribute("in", r + "_drop_shadow_1"),
        h.setAttribute("result", r + "_drop_shadow_2"),
        (this.feOffset = h),
        t.appendChild(h);
      var l = createNS("feFlood");
      l.setAttribute("flood-color", "#00ff00"),
        l.setAttribute("flood-opacity", "1"),
        l.setAttribute("result", r + "_drop_shadow_3"),
        (this.feFlood = l),
        t.appendChild(l);
      var p = createNS("feComposite");
      p.setAttribute("in", r + "_drop_shadow_3"),
        p.setAttribute("in2", r + "_drop_shadow_2"),
        p.setAttribute("operator", "in"),
        p.setAttribute("result", r + "_drop_shadow_4"),
        t.appendChild(p);
      var f = this.createMergeNode(r, [r + "_drop_shadow_4", s]);
      t.appendChild(f);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter),
      (SVGTintFilter.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          var e = this.filterManager.effectElements[0].p.v,
            i = this.filterManager.effectElements[1].p.v,
            r = this.filterManager.effectElements[2].p.v / 100;
          this.linearFilter.setAttribute(
            "values",
            linearFilterValue + " " + r + " 0"
          ),
            this.matrixFilter.setAttribute(
              "values",
              i[0] -
                e[0] +
                " 0 0 0 " +
                e[0] +
                " " +
                (i[1] - e[1]) +
                " 0 0 0 " +
                e[1] +
                " " +
                (i[2] - e[2]) +
                " 0 0 0 " +
                e[2] +
                " 0 0 0 1 0"
            );
        }
      }),
      (SVGFillFilter.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          var e = this.filterManager.effectElements[2].p.v,
            i = this.filterManager.effectElements[6].p.v;
          this.matrixFilter.setAttribute(
            "values",
            "0 0 0 0 " +
              e[0] +
              " 0 0 0 0 " +
              e[1] +
              " 0 0 0 0 " +
              e[2] +
              " 0 0 0 " +
              i +
              " 0"
          );
        }
      }),
      (SVGStrokeEffect.prototype.initialize = function () {
        var t,
          e,
          i,
          r,
          s =
            this.elem.layerElement.children ||
            this.elem.layerElement.childNodes;
        for (
          1 === this.filterManager.effectElements[1].p.v
            ? ((r = this.elem.maskManager.masksProperties.length), (i = 0))
            : (r = (i = this.filterManager.effectElements[0].p.v - 1) + 1),
            (e = createNS("g")).setAttribute("fill", "none"),
            e.setAttribute("stroke-linecap", "round"),
            e.setAttribute("stroke-dashoffset", 1);
          i < r;
          i += 1
        )
          (t = createNS("path")),
            e.appendChild(t),
            this.paths.push({ p: t, m: i });
        if (3 === this.filterManager.effectElements[10].p.v) {
          var a = createNS("mask"),
            n = createElementID();
          a.setAttribute("id", n),
            a.setAttribute("mask-type", "alpha"),
            a.appendChild(e),
            this.elem.globalData.defs.appendChild(a);
          var o = createNS("g");
          for (
            o.setAttribute("mask", "url(" + getLocationHref() + "#" + n + ")");
            s[0];

          )
            o.appendChild(s[0]);
          this.elem.layerElement.appendChild(o),
            (this.masker = a),
            e.setAttribute("stroke", "#fff");
        } else if (
          1 === this.filterManager.effectElements[10].p.v ||
          2 === this.filterManager.effectElements[10].p.v
        ) {
          if (2 === this.filterManager.effectElements[10].p.v)
            for (
              s =
                this.elem.layerElement.children ||
                this.elem.layerElement.childNodes;
              s.length;

            )
              this.elem.layerElement.removeChild(s[0]);
          this.elem.layerElement.appendChild(e),
            this.elem.layerElement.removeAttribute("mask"),
            e.setAttribute("stroke", "#fff");
        }
        (this.initialized = !0), (this.pathMasker = e);
      }),
      (SVGStrokeEffect.prototype.renderFrame = function (t) {
        var e;
        this.initialized || this.initialize();
        var i,
          r,
          s = this.paths.length;
        for (e = 0; e < s; e += 1)
          if (
            -1 !== this.paths[e].m &&
            ((i = this.elem.maskManager.viewData[this.paths[e].m]),
            (r = this.paths[e].p),
            (t || this.filterManager._mdf || i.prop._mdf) &&
              r.setAttribute("d", i.lastPath),
            t ||
              this.filterManager.effectElements[9].p._mdf ||
              this.filterManager.effectElements[4].p._mdf ||
              this.filterManager.effectElements[7].p._mdf ||
              this.filterManager.effectElements[8].p._mdf ||
              i.prop._mdf)
          ) {
            var a;
            if (
              0 !== this.filterManager.effectElements[7].p.v ||
              100 !== this.filterManager.effectElements[8].p.v
            ) {
              var n =
                  0.01 *
                  Math.min(
                    this.filterManager.effectElements[7].p.v,
                    this.filterManager.effectElements[8].p.v
                  ),
                o =
                  0.01 *
                  Math.max(
                    this.filterManager.effectElements[7].p.v,
                    this.filterManager.effectElements[8].p.v
                  ),
                h = r.getTotalLength();
              a = "0 0 0 " + h * n + " ";
              var l,
                p = h * (o - n),
                f =
                  1 +
                  2 *
                    this.filterManager.effectElements[4].p.v *
                    this.filterManager.effectElements[9].p.v *
                    0.01,
                m = Math.floor(p / f);
              for (l = 0; l < m; l += 1)
                a +=
                  "1 " +
                  2 *
                    this.filterManager.effectElements[4].p.v *
                    this.filterManager.effectElements[9].p.v *
                    0.01 +
                  " ";
              a += "0 " + 10 * h + " 0 0";
            } else
              a =
                "1 " +
                2 *
                  this.filterManager.effectElements[4].p.v *
                  this.filterManager.effectElements[9].p.v *
                  0.01;
            r.setAttribute("stroke-dasharray", a);
          }
        if (
          ((t || this.filterManager.effectElements[4].p._mdf) &&
            this.pathMasker.setAttribute(
              "stroke-width",
              2 * this.filterManager.effectElements[4].p.v
            ),
          (t || this.filterManager.effectElements[6].p._mdf) &&
            this.pathMasker.setAttribute(
              "opacity",
              this.filterManager.effectElements[6].p.v
            ),
          (1 === this.filterManager.effectElements[10].p.v ||
            2 === this.filterManager.effectElements[10].p.v) &&
            (t || this.filterManager.effectElements[3].p._mdf))
        ) {
          var c = this.filterManager.effectElements[3].p.v;
          this.pathMasker.setAttribute(
            "stroke",
            "rgb(" +
              bmFloor(255 * c[0]) +
              "," +
              bmFloor(255 * c[1]) +
              "," +
              bmFloor(255 * c[2]) +
              ")"
          );
        }
      }),
      (SVGTritoneFilter.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          var e = this.filterManager.effectElements[0].p.v,
            i = this.filterManager.effectElements[1].p.v,
            r = this.filterManager.effectElements[2].p.v,
            s = r[0] + " " + i[0] + " " + e[0],
            a = r[1] + " " + i[1] + " " + e[1],
            n = r[2] + " " + i[2] + " " + e[2];
          this.feFuncR.setAttribute("tableValues", s),
            this.feFuncG.setAttribute("tableValues", a),
            this.feFuncB.setAttribute("tableValues", n);
        }
      }),
      (SVGProLevelsFilter.prototype.createFeFunc = function (t, e) {
        var i = createNS(t);
        return i.setAttribute("type", "table"), e.appendChild(i), i;
      }),
      (SVGProLevelsFilter.prototype.getTableValue = function (t, e, i, r, s) {
        for (
          var a,
            n,
            o = 0,
            h = Math.min(t, e),
            l = Math.max(t, e),
            p = Array.call(null, { length: 256 }),
            f = 0,
            m = s - r,
            c = e - t;
          o <= 256;

        )
          (n =
            (a = o / 256) <= h
              ? c < 0
                ? s
                : r
              : a >= l
              ? c < 0
                ? r
                : s
              : r + m * Math.pow((a - t) / c, 1 / i)),
            (p[f] = n),
            (f += 1),
            (o += 256 / 255);
        return p.join(" ");
      }),
      (SVGProLevelsFilter.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          var e,
            i = this.filterManager.effectElements;
          this.feFuncRComposed &&
            (t ||
              i[3].p._mdf ||
              i[4].p._mdf ||
              i[5].p._mdf ||
              i[6].p._mdf ||
              i[7].p._mdf) &&
            ((e = this.getTableValue(
              i[3].p.v,
              i[4].p.v,
              i[5].p.v,
              i[6].p.v,
              i[7].p.v
            )),
            this.feFuncRComposed.setAttribute("tableValues", e),
            this.feFuncGComposed.setAttribute("tableValues", e),
            this.feFuncBComposed.setAttribute("tableValues", e)),
            this.feFuncR &&
              (t ||
                i[10].p._mdf ||
                i[11].p._mdf ||
                i[12].p._mdf ||
                i[13].p._mdf ||
                i[14].p._mdf) &&
              ((e = this.getTableValue(
                i[10].p.v,
                i[11].p.v,
                i[12].p.v,
                i[13].p.v,
                i[14].p.v
              )),
              this.feFuncR.setAttribute("tableValues", e)),
            this.feFuncG &&
              (t ||
                i[17].p._mdf ||
                i[18].p._mdf ||
                i[19].p._mdf ||
                i[20].p._mdf ||
                i[21].p._mdf) &&
              ((e = this.getTableValue(
                i[17].p.v,
                i[18].p.v,
                i[19].p.v,
                i[20].p.v,
                i[21].p.v
              )),
              this.feFuncG.setAttribute("tableValues", e)),
            this.feFuncB &&
              (t ||
                i[24].p._mdf ||
                i[25].p._mdf ||
                i[26].p._mdf ||
                i[27].p._mdf ||
                i[28].p._mdf) &&
              ((e = this.getTableValue(
                i[24].p.v,
                i[25].p.v,
                i[26].p.v,
                i[27].p.v,
                i[28].p.v
              )),
              this.feFuncB.setAttribute("tableValues", e)),
            this.feFuncA &&
              (t ||
                i[31].p._mdf ||
                i[32].p._mdf ||
                i[33].p._mdf ||
                i[34].p._mdf ||
                i[35].p._mdf) &&
              ((e = this.getTableValue(
                i[31].p.v,
                i[32].p.v,
                i[33].p.v,
                i[34].p.v,
                i[35].p.v
              )),
              this.feFuncA.setAttribute("tableValues", e));
        }
      }),
      extendPrototype([SVGComposableEffect], SVGDropShadowEffect),
      (SVGDropShadowEffect.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          if (
            ((t || this.filterManager.effectElements[4].p._mdf) &&
              this.feGaussianBlur.setAttribute(
                "stdDeviation",
                this.filterManager.effectElements[4].p.v / 4
              ),
            t || this.filterManager.effectElements[0].p._mdf)
          ) {
            var e = this.filterManager.effectElements[0].p.v;
            this.feFlood.setAttribute(
              "flood-color",
              rgbToHex(
                Math.round(255 * e[0]),
                Math.round(255 * e[1]),
                Math.round(255 * e[2])
              )
            );
          }
          if (
            ((t || this.filterManager.effectElements[1].p._mdf) &&
              this.feFlood.setAttribute(
                "flood-opacity",
                this.filterManager.effectElements[1].p.v / 255
              ),
            t ||
              this.filterManager.effectElements[2].p._mdf ||
              this.filterManager.effectElements[3].p._mdf)
          ) {
            var i = this.filterManager.effectElements[3].p.v,
              r = (this.filterManager.effectElements[2].p.v - 90) * degToRads,
              s = i * Math.cos(r),
              a = i * Math.sin(r);
            this.feOffset.setAttribute("dx", s),
              this.feOffset.setAttribute("dy", a);
          }
        }
      });
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(t, e, i) {
      (this.initialized = !1),
        (this.filterManager = e),
        (this.filterElem = t),
        (this.elem = i),
        (i.matteElement = createNS("g")),
        i.matteElement.appendChild(i.layerElement),
        i.matteElement.appendChild(i.transformedElement),
        (i.baseElement = i.matteElement);
    }
    function SVGGaussianBlurEffect(t, e, i, r) {
      t.setAttribute("x", "-100%"),
        t.setAttribute("y", "-100%"),
        t.setAttribute("width", "300%"),
        t.setAttribute("height", "300%"),
        (this.filterManager = e);
      var s = createNS("feGaussianBlur");
      s.setAttribute("result", r), t.appendChild(s), (this.feGaussianBlur = s);
    }
    function TransformEffect() {}
    function SVGTransformEffect(t, e) {
      this.init(e);
    }
    function CVTransformEffect(t) {
      this.init(t);
    }
    return (
      (SVGMatte3Effect.prototype.findSymbol = function (t) {
        for (var e = 0, i = _svgMatteSymbols.length; e < i; ) {
          if (_svgMatteSymbols[e] === t) return _svgMatteSymbols[e];
          e += 1;
        }
        return null;
      }),
      (SVGMatte3Effect.prototype.replaceInParent = function (t, e) {
        var i = t.layerElement.parentNode;
        if (i) {
          for (
            var r, s = i.children, a = 0, n = s.length;
            a < n && s[a] !== t.layerElement;

          )
            a += 1;
          a <= n - 2 && (r = s[a + 1]);
          var o = createNS("use");
          o.setAttribute("href", "#" + e),
            r ? i.insertBefore(o, r) : i.appendChild(o);
        }
      }),
      (SVGMatte3Effect.prototype.setElementAsMask = function (t, e) {
        if (!this.findSymbol(e)) {
          var i = createElementID(),
            r = createNS("mask");
          r.setAttribute("id", e.layerId),
            r.setAttribute("mask-type", "alpha"),
            _svgMatteSymbols.push(e);
          var s = t.globalData.defs;
          s.appendChild(r);
          var a = createNS("symbol");
          a.setAttribute("id", i),
            this.replaceInParent(e, i),
            a.appendChild(e.layerElement),
            s.appendChild(a);
          var n = createNS("use");
          n.setAttribute("href", "#" + i),
            r.appendChild(n),
            (e.data.hd = !1),
            e.show();
        }
        t.setMatte(e.layerId);
      }),
      (SVGMatte3Effect.prototype.initialize = function () {
        for (
          var t = this.filterManager.effectElements[0].p.v,
            e = this.elem.comp.elements,
            i = 0,
            r = e.length;
          i < r;

        )
          e[i] && e[i].data.ind === t && this.setElementAsMask(this.elem, e[i]),
            (i += 1);
        this.initialized = !0;
      }),
      (SVGMatte3Effect.prototype.renderFrame = function () {
        this.initialized || this.initialize();
      }),
      (SVGGaussianBlurEffect.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          var e = 0.3 * this.filterManager.effectElements[0].p.v,
            i = this.filterManager.effectElements[1].p.v,
            r = 3 == i ? 0 : e,
            s = 2 == i ? 0 : e;
          this.feGaussianBlur.setAttribute("stdDeviation", r + " " + s);
          var a =
            1 == this.filterManager.effectElements[2].p.v
              ? "wrap"
              : "duplicate";
          this.feGaussianBlur.setAttribute("edgeMode", a);
        }
      }),
      (TransformEffect.prototype.init = function (t) {
        (this.effectsManager = t),
          (this.type = effectTypes.TRANSFORM_EFFECT),
          (this.matrix = new Matrix()),
          (this.opacity = -1),
          (this._mdf = !1),
          (this._opMdf = !1);
      }),
      (TransformEffect.prototype.renderFrame = function (t) {
        if (
          ((this._opMdf = !1), (this._mdf = !1), t || this.effectsManager._mdf)
        ) {
          var e = this.effectsManager.effectElements,
            i = e[0].p.v,
            r = e[1].p.v,
            s = 1 === e[2].p.v,
            a = e[3].p.v,
            n = s ? a : e[4].p.v,
            o = e[5].p.v,
            h = e[6].p.v,
            l = e[7].p.v;
          this.matrix.reset(),
            this.matrix.translate(-i[0], -i[1], i[2]),
            this.matrix.scale(0.01 * n, 0.01 * a, 1),
            this.matrix.rotate(-l * degToRads),
            this.matrix.skewFromAxis(-o * degToRads, (h + 90) * degToRads),
            this.matrix.translate(r[0], r[1], 0),
            (this._mdf = !0),
            this.opacity !== e[8].p.v &&
              ((this.opacity = e[8].p.v), (this._opMdf = !0));
        }
      }),
      extendPrototype([TransformEffect], SVGTransformEffect),
      extendPrototype([TransformEffect], CVTransformEffect),
      registerRenderer("canvas", CanvasRenderer),
      registerRenderer("html", HybridRenderer),
      registerRenderer("svg", SVGRenderer),
      ShapeModifiers.registerModifier("tm", TrimModifier),
      ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier),
      ShapeModifiers.registerModifier("rp", RepeaterModifier),
      ShapeModifiers.registerModifier("rd", RoundCornersModifier),
      ShapeModifiers.registerModifier("zz", ZigZagModifier),
      ShapeModifiers.registerModifier("op", OffsetPathModifier),
      setExpressionsPlugin(Expressions),
      setExpressionInterfaces(getInterface),
      initialize$1(),
      initialize(),
      registerEffect$1(20, SVGTintFilter, !0),
      registerEffect$1(21, SVGFillFilter, !0),
      registerEffect$1(22, SVGStrokeEffect, !1),
      registerEffect$1(23, SVGTritoneFilter, !0),
      registerEffect$1(24, SVGProLevelsFilter, !0),
      registerEffect$1(25, SVGDropShadowEffect, !0),
      registerEffect$1(28, SVGMatte3Effect, !1),
      registerEffect$1(29, SVGGaussianBlurEffect, !0),
      registerEffect$1(35, SVGTransformEffect, !1),
      registerEffect(35, CVTransformEffect),
      lottie
    );
  });

/*!
 * ScrollToPlugin 3.11.5
 * https://greensock.com
 *
 * @license Copyright 2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */

!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? t(exports)
    : "function" == typeof define && define.amd
    ? define(["exports"], t)
    : t(((e = e || self).window = e.window || {}));
})(this, function (e) {
  "use strict";
  function l() {
    return "undefined" != typeof window;
  }
  function m() {
    return f || (l() && (f = window.gsap) && f.registerPlugin && f);
  }
  function n(e) {
    return "string" == typeof e;
  }
  function o(e) {
    return "function" == typeof e;
  }
  function p(e, t) {
    var o = "x" === t ? "Width" : "Height",
      n = "scroll" + o,
      l = "client" + o;
    return e === T || e === i || e === c
      ? Math.max(i[n], c[n]) - (T["inner" + o] || i[l] || c[l])
      : e[n] - e["offset" + o];
  }
  function q(e, t) {
    var o = "scroll" + ("x" === t ? "Left" : "Top");
    return (
      e === T &&
        (null != e.pageXOffset
          ? (o = "page" + t.toUpperCase() + "Offset")
          : (e = null != i[o] ? i : c)),
      function () {
        return e[o];
      }
    );
  }
  function s(e, t) {
    if (!(e = y(e)[0]) || !e.getBoundingClientRect)
      return (
        console.warn("scrollTo target doesn't exist. Using 0") || { x: 0, y: 0 }
      );
    var o = e.getBoundingClientRect(),
      n = !t || t === T || t === c,
      l = n
        ? {
            top:
              i.clientTop - (T.pageYOffset || i.scrollTop || c.scrollTop || 0),
            left:
              i.clientLeft -
              (T.pageXOffset || i.scrollLeft || c.scrollLeft || 0),
          }
        : t.getBoundingClientRect(),
      r = { x: o.left - l.left, y: o.top - l.top };
    return !n && t && ((r.x += q(t, "x")()), (r.y += q(t, "y")())), r;
  }
  function t(e, t, o, l, r) {
    return isNaN(e) || "object" == typeof e
      ? n(e) && "=" === e.charAt(1)
        ? parseFloat(e.substr(2)) * ("-" === e.charAt(0) ? -1 : 1) + l - r
        : "max" === e
        ? p(t, o) - r
        : Math.min(p(t, o), s(e, t)[o] - r)
      : parseFloat(e) - r;
  }
  function u() {
    (f = m()),
      l() &&
        f &&
        "undefined" != typeof document &&
        document.body &&
        ((T = window),
        (c = document.body),
        (i = document.documentElement),
        (y = f.utils.toArray),
        f.config({ autoKillThreshold: 7 }),
        (v = f.config()),
        (a = 1));
  }
  var f,
    a,
    T,
    i,
    c,
    y,
    v,
    h,
    r = {
      version: "3.11.5",
      name: "scrollTo",
      rawVars: 1,
      register: function register(e) {
        (f = e), u();
      },
      init: function init(e, l, r, s, i) {
        a || u();
        var p = this,
          c = f.getProperty(e, "scrollSnapType");
        (p.isWin = e === T),
          (p.target = e),
          (p.tween = r),
          (l = (function _clean(e, t, l, r) {
            if ((o(e) && (e = e(t, l, r)), "object" != typeof e))
              return n(e) && "max" !== e && "=" !== e.charAt(1)
                ? { x: e, y: e }
                : { y: e };
            if (e.nodeType) return { y: e, x: e };
            var s,
              i = {};
            for (s in e)
              i[s] = "onAutoKill" !== s && o(e[s]) ? e[s](t, l, r) : e[s];
            return i;
          })(l, s, e, i)),
          (p.vars = l),
          (p.autoKill = !!l.autoKill),
          (p.getX = q(e, "x")),
          (p.getY = q(e, "y")),
          (p.x = p.xPrev = p.getX()),
          (p.y = p.yPrev = p.getY()),
          (h = h || f.core.globals().ScrollTrigger),
          "smooth" === f.getProperty(e, "scrollBehavior") &&
            f.set(e, { scrollBehavior: "auto" }),
          c &&
            "none" !== c &&
            ((p.snap = 1),
            (p.snapInline = e.style.scrollSnapType),
            (e.style.scrollSnapType = "none")),
          null != l.x
            ? (p.add(p, "x", p.x, t(l.x, e, "x", p.x, l.offsetX || 0), s, i),
              p._props.push("scrollTo_x"))
            : (p.skipX = 1),
          null != l.y
            ? (p.add(p, "y", p.y, t(l.y, e, "y", p.y, l.offsetY || 0), s, i),
              p._props.push("scrollTo_y"))
            : (p.skipY = 1);
      },
      render: function render(e, t) {
        for (
          var o,
            n,
            l,
            r,
            s,
            i = t._pt,
            c = t.target,
            u = t.tween,
            f = t.autoKill,
            a = t.xPrev,
            y = t.yPrev,
            d = t.isWin,
            g = t.snap,
            x = t.snapInline;
          i;

        )
          i.r(e, i.d), (i = i._next);
        (o = d || !t.skipX ? t.getX() : a),
          (l = (n = d || !t.skipY ? t.getY() : y) - y),
          (r = o - a),
          (s = v.autoKillThreshold),
          t.x < 0 && (t.x = 0),
          t.y < 0 && (t.y = 0),
          f &&
            (!t.skipX && (s < r || r < -s) && o < p(c, "x") && (t.skipX = 1),
            !t.skipY && (s < l || l < -s) && n < p(c, "y") && (t.skipY = 1),
            t.skipX &&
              t.skipY &&
              (u.kill(),
              t.vars.onAutoKill &&
                t.vars.onAutoKill.apply(u, t.vars.onAutoKillParams || []))),
          d
            ? T.scrollTo(t.skipX ? o : t.x, t.skipY ? n : t.y)
            : (t.skipY || (c.scrollTop = t.y), t.skipX || (c.scrollLeft = t.x)),
          !g ||
            (1 !== e && 0 !== e) ||
            ((n = c.scrollTop),
            (o = c.scrollLeft),
            x
              ? (c.style.scrollSnapType = x)
              : c.style.removeProperty("scroll-snap-type"),
            (c.scrollTop = n + 1),
            (c.scrollLeft = o + 1),
            (c.scrollTop = n),
            (c.scrollLeft = o)),
          (t.xPrev = t.x),
          (t.yPrev = t.y),
          h && h.update();
      },
      kill: function kill(e) {
        var t = "scrollTo" === e;
        (!t && "scrollTo_x" !== e) || (this.skipX = 1),
          (!t && "scrollTo_y" !== e) || (this.skipY = 1);
      },
    };
  (r.max = p),
    (r.getOffset = s),
    (r.buildGetter = q),
    m() && f.registerPlugin(r),
    (e.ScrollToPlugin = r),
    (e.default = r);
  if (typeof window === "undefined" || window !== e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
  } else {
    delete e.default;
  }
});

/*!
 * ScrollTrigger 3.9.1
 * https://greensock.com
 * 
 * @license Copyright 2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */

!function(e,r){"object"==typeof exports&&"undefined"!=typeof module?r(exports):"function"==typeof define&&define.amd?define(["exports"],r):r((e=e||self).window=e.window||{})}(this,function(e){"use strict";function H(e){return e}function I(e){return Ve(e)[0]||(rr(e)&&!1!==Re.config().nullTargetWarn?console.warn("Element not found:",e):null)}function J(e){return Math.round(1e5*e)/1e5||0}function K(){return"undefined"!=typeof window}function L(){return Re||K()&&(Re=window.gsap)&&Re.registerPlugin&&Re}function M(e){return!!~i.indexOf(e)}function N(e,r){return~Ue.indexOf(e)&&Ue[Ue.indexOf(e)+1][r]}function O(r,e){var t=e.s,n=e.sc,i=g.indexOf(r),o=n===gr.sc?1:2;return~i||(i=g.push(r)-1),g[i+o]||(g[i+o]=N(r,t)||(M(r)?n:function(e){return arguments.length?r[t]=e:r[t]}))}function P(e){return N(e,"getBoundingClientRect")||(M(e)?function(){return wr.width=ze.innerWidth,wr.height=ze.innerHeight,wr}:function(){return hr(e)})}function S(e,r){var t=r.s,n=r.d2,i=r.d,o=r.a;return(t="scroll"+n)&&(o=N(e,t))?o()-P(e)()[i]:M(e)?(Fe[t]||We[t])-(ze["inner"+n]||We["client"+n]||Fe["client"+n]):e[t]-e["offset"+n]}function T(e,r){for(var t=0;t<f.length;t+=3)r&&!~r.indexOf(f[t+1])||e(f[t],f[t+1],f[t+2])}function V(e){return"function"==typeof e}function W(e){return"number"==typeof e}function X(e){return"object"==typeof e}function Y(e){return V(e)&&e()}function Z(t,n){return function(){var e=Y(t),r=Y(n);return function(){Y(e),Y(r)}}}function $(e,r,t){return e&&e.progress(r?0:1)&&t&&e.pause()}function _(e,r){if(e.enabled){var t=r(e);t&&t.totalTime&&(e.callbackAnimation=t)}}function ua(e){return ze.getComputedStyle(e)}function wa(e,r){for(var t in r)t in e||(e[t]=r[t]);return e}function ya(e,r){var t=r.d2;return e["offset"+t]||e["client"+t]||0}function za(e){var r,t=[],n=e.labels,i=e.duration();for(r in n)t.push(n[r]/i);return t}function Ba(i){var o=Re.utils.snap(i),a=Array.isArray(i)&&i.slice(0).sort(function(e,r){return e-r});return a?function(e,r,t){var n;if(void 0===t&&(t=.001),!r)return o(e);if(0<r){for(e-=t,n=0;n<a.length;n++)if(a[n]>=e)return a[n];return a[n-1]}for(n=a.length,e+=t;n--;)if(a[n]<=e)return a[n];return a[0]}:function(e,r,t){void 0===t&&(t=.001);var n=o(e);return!r||Math.abs(n-e)<t||n-e<0==r<0?n:o(r<0?e-i:e+i)}}function Da(r,t,e,n){return e.split(",").forEach(function(e){return r(t,e,n)})}function Ea(e,r,t){return e.addEventListener(r,t,{passive:!0})}function Fa(e,r,t){return e.removeEventListener(r,t)}function Ja(e,r){if(rr(e)){var t=e.indexOf("="),n=~t?(e.charAt(t-1)+1)*parseFloat(e.substr(t+1)):0;~t&&(e.indexOf("%")>t&&(n*=r/100),e=e.substr(0,t-1)),e=n+(e in b?b[e]*r:~e.indexOf("%")?parseFloat(e)*r/100:parseFloat(e)||0)}return e}function Ka(e,r,t,n,i,o,a,s){var l=i.startColor,c=i.endColor,u=i.fontSize,f=i.indent,p=i.fontWeight,d=Le.createElement("div"),g=M(t)||"fixed"===N(t,"pinType"),h=-1!==e.indexOf("scroller"),v=g?Fe:t,m=-1!==e.indexOf("start"),b=m?l:c,x="border-color:"+b+";font-size:"+u+";color:"+b+";font-weight:"+p+";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";return x+="position:"+((h||s)&&g?"fixed;":"absolute;"),!h&&!s&&g||(x+=(n===gr?y:w)+":"+(o+parseFloat(f))+"px;"),a&&(x+="box-sizing:border-box;text-align:left;width:"+a.offsetWidth+"px;"),d._isStart=m,d.setAttribute("class","gsap-marker-"+e+(r?" marker-"+r:"")),d.style.cssText=x,d.innerText=r||0===r?e+"-"+r:e,v.children[0]?v.insertBefore(d,v.children[0]):v.appendChild(d),d._offset=d["offset"+n.op.d2],E(d,0,n,m),d}function Oa(){return 34<Ze()-Ge&&j()}function Pa(){j(),Ge||A("scrollStart"),Ge=Ze()}function Qa(){return!Xe&&!t&&!Le.fullscreenElement&&a.restart(!0)}function Wa(e){var r,t=Re.ticker.frame,n=[],i=0;if(p!==t||qe){for(z();i<C.length;i+=4)(r=ze.matchMedia(C[i]).matches)!==C[i+3]&&((C[i+3]=r)?n.push(i):z(1,C[i])||V(C[i+2])&&C[i+2]());for(R(),i=0;i<n.length;i++)r=n[i],Qe=C[r],C[r+2]=C[r+1](e);Qe=0,o&&F(0,1),p=t,A("matchMedia")}}function Xa(){return Fa(ee,"scrollEnd",Xa)||F(!0)}function ab(){return g.forEach(function(e){return"function"==typeof e&&(e.rec=0)})}function jb(e,r,t,n){if(e.parentNode!==r){for(var i,o=Q.length,a=r.style,s=e.style;o--;)a[i=Q[o]]=t[i];a.position="absolute"===t.position?"absolute":"relative","inline"===t.display&&(a.display="inline-block"),s[w]=s[y]=a.flexBasis="auto",a.overflow="visible",a.boxSizing="border-box",a[nr]=ya(e,dr)+pr,a[ir]=ya(e,gr)+pr,a[cr]=s[ur]=s.top=s[v]="0",Sr(n),s[nr]=s.maxWidth=t[nr],s[ir]=s.maxHeight=t[ir],s[cr]=t[cr],e.parentNode.insertBefore(r,e),r.appendChild(e)}}function mb(e){for(var r=q.length,t=e.style,n=[],i=0;i<r;i++)n.push(q[i],t[q[i]]);return n.t=e,n}function pb(e,r,t,n,i,o,a,s,l,c,u,f,p){V(e)&&(e=e(s)),rr(e)&&"max"===e.substr(0,3)&&(e=f+("="===e.charAt(4)?Ja("0"+e.substr(3),t):0));var d,g,h,v=p?p.time():0;if(p&&p.seek(0),W(e))a&&E(a,t,n,!0);else{V(r)&&(r=r(s));var m,b,x,y,S=e.split(" ");h=I(r)||Fe,(m=hr(h)||{})&&(m.left||m.top)||"none"!==ua(h).display||(y=h.style.display,h.style.display="block",m=hr(h),y?h.style.display=y:h.style.removeProperty("display")),b=Ja(S[0],m[n.d]),x=Ja(S[1]||"0",t),e=m[n.p]-l[n.p]-c+b+i-x,a&&E(a,x,n,t-x<20||a._isStart&&20<x),t-=t-x}if(o){var w=e+t,T=o._isStart;d="scroll"+n.d2,E(o,w,n,T&&20<w||!T&&(u?Math.max(Fe[d],We[d]):o.parentNode[d])<=w+1),u&&(l=hr(a),u&&(o.style[n.op.p]=l[n.op.p]-n.op.m-o._offset+pr))}return p&&h&&(d=hr(h),p.seek(f),g=hr(h),p._caScrollDist=d[n.p]-g[n.p],e=e/p._caScrollDist*f),p&&p.seek(v),p?e:Math.round(e)}function rb(e,r,t,n){if(e.parentNode!==r){var i,o,a=e.style;if(r===Fe){for(i in e._stOrig=a.cssText,o=ua(e))+i||G.test(i)||!o[i]||"string"!=typeof a[i]||"0"===i||(a[i]=o[i]);a.top=t,a.left=n}else a.cssText=e._stOrig;Re.core.getCache(e).uncache=1,r.appendChild(e)}}function sb(l,e){function xf(e,r,t,n,i){var o=xf.tween,a=r.onComplete,s={};return o&&o.kill(),c=Math.round(t),r[p]=e,(r.modifiers=s)[p]=function(e){return(e=J(f()))!==c&&e!==u&&2<Math.abs(e-c)&&2<Math.abs(e-u)?(o.kill(),xf.tween=0):e=t+n*o.ratio+i*o.ratio*o.ratio,u=c,c=J(e)},r.onComplete=function(){xf.tween=0,a&&a.call(o)},o=xf.tween=Re.to(l,r)}var c,u,f=O(l,e),p="_scroll"+e.p2;return l[p]=f,Ea(l,"wheel",function(){return xf.tween&&xf.tween.kill()&&(xf.tween=0)}),xf}var Re,o,ze,Le,We,Fe,i,a,Ve,De,He,s,Xe,je,l,Je,c,u,f,Ke,Ye,t,$e,Qe,p,d,qe=1,Ue=[],g=[],Ze=Date.now,h=Ze(),Ge=0,er=1,rr=function _isString(e){return"string"==typeof e},tr=Math.abs,r="scrollLeft",n="scrollTop",v="left",y="right",w="bottom",nr="width",ir="height",or="Right",ar="Left",sr="Top",lr="Bottom",cr="padding",ur="margin",fr="Width",m="Height",pr="px",dr={s:r,p:v,p2:ar,os:y,os2:or,d:nr,d2:fr,a:"x",sc:function sc(e){return arguments.length?ze.scrollTo(e,gr.sc()):ze.pageXOffset||Le[r]||We[r]||Fe[r]||0}},gr={s:n,p:"top",p2:sr,os:w,os2:lr,d:ir,d2:m,a:"y",op:dr,sc:function sc(e){return arguments.length?ze.scrollTo(dr.sc(),e):ze.pageYOffset||Le[n]||We[n]||Fe[n]||0}},hr=function _getBounds(e,r){var t=r&&"matrix(1, 0, 0, 1, 0, 0)"!==ua(e)[l]&&Re.to(e,{x:0,y:0,xPercent:0,yPercent:0,rotation:0,rotationX:0,rotationY:0,scale:1,skewX:0,skewY:0}).progress(1),n=e.getBoundingClientRect();return t&&t.progress(0).kill(),n},vr={startColor:"green",endColor:"red",indent:0,fontSize:"16px",fontWeight:"normal"},mr={toggleActions:"play",anticipatePin:0},b={top:0,left:0,center:.5,bottom:1,right:1},E=function _positionMarker(e,r,t,n){var i={display:"block"},o=t[n?"os2":"p2"],a=t[n?"p2":"os2"];e._isFlipped=n,i[t.a+"Percent"]=n?-100:0,i[t.a]=n?"1px":0,i["border"+o+fr]=1,i["border"+a+fr]=0,i[t.p]=r+"px",Re.set(e,i)},br=[],xr={},x={},k=[],C=[],A=function _dispatch(e){return x[e]&&x[e].map(function(e){return e()})||k},B=[],R=function _revertRecorded(e){for(var r=0;r<B.length;r+=5)e&&B[r+4]!==e||(B[r].style.cssText=B[r+1],B[r].getBBox&&B[r].setAttribute("transform",B[r+2]||""),B[r+3].uncache=1)},z=function _revertAll(e,r){var t;for(Je=0;Je<br.length;Je++)t=br[Je],r&&t.media!==r||(e?t.kill(1):t.revert());r&&R(r),r||A("revert")},F=function _refreshAll(e,r){if(!Ge||e){d=!0;var t=A("refreshInit");Ke&&ee.sort(),r||z(),br.forEach(function(e){return e.refresh()}),br.forEach(function(e){return"max"===e.vars.end&&e.setPositions(e.start,S(e.scroller,e._dir))}),t.forEach(function(e){return e&&e.render&&e.render(-1)}),ab(),a.pause(),d=!1,A("refresh")}else Ea(ee,"scrollEnd",Xa)},D=0,yr=1,j=function _updateAll(){if(!d){var e=br.length,r=Ze(),t=50<=r-h,n=e&&br[0].scroll();if(yr=n<D?-1:1,D=n,t&&(Ge&&!je&&200<r-Ge&&(Ge=0,A("scrollEnd")),He=h,h=r),yr<0){for(Je=e;0<Je--;)br[Je]&&br[Je].update(0,t);yr=1}else for(Je=0;Je<e;Je++)br[Je]&&br[Je].update(0,t)}},Q=[v,"top",w,y,ur+lr,ur+or,ur+sr,ur+ar,"display","flexShrink","float","zIndex","gridColumnStart","gridColumnEnd","gridRowStart","gridRowEnd","gridArea","justifySelf","alignSelf","placeSelf","order"],q=Q.concat([nr,ir,"boxSizing","max"+fr,"max"+m,"position",ur,cr,cr+sr,cr+or,cr+lr,cr+ar]),U=/([A-Z])/g,Sr=function _setState(e){if(e){var r,t,n=e.t.style,i=e.length,o=0;for((e.t._gsap||Re.core.getCache(e.t)).uncache=1;o<i;o+=2)t=e[o+1],r=e[o],t?n[r]=t:n[r]&&n.removeProperty(r.replace(U,"-$1").toLowerCase())}},wr={left:0,top:0},G=/(?:webkit|moz|length|cssText|inset)/i;dr.op=gr;var ee=(ScrollTrigger.prototype.init=function init(E,k){if(this.progress=this.start=0,this.vars&&this.kill(1),er){var m,n,f,C,A,B,R,z,L,F,D,e,j,J,K,Y,Q,r,q,b,U,Z,x,G,y,w,t,T,ee,re,i,p,te,ne,ie,oe,ae,se=(E=wa(rr(E)||W(E)||E.nodeType?{trigger:E}:E,mr)).onUpdate,le=E.toggleClass,o=E.id,ce=E.onToggle,ue=E.onRefresh,fe=E.scrub,pe=E.trigger,de=E.pin,ge=E.pinSpacing,he=E.invalidateOnRefresh,ve=E.anticipatePin,a=E.onScrubComplete,d=E.onSnapComplete,me=E.once,be=E.snap,xe=E.pinReparent,s=E.pinSpacer,ye=E.containerAnimation,Se=E.fastScrollEnd,we=E.preventOverlaps,Te=E.horizontal||E.containerAnimation&&!1!==E.horizontal?dr:gr,Ee=!fe&&0!==fe,Oe=I(E.scroller||ze),l=Re.core.getCache(Oe),_e=M(Oe),ke="fixed"===("pinType"in E?E.pinType:N(Oe,"pinType")||_e&&"fixed"),Ce=[E.onEnter,E.onLeave,E.onEnterBack,E.onLeaveBack],Me=Ee&&E.toggleActions.split(" "),c="markers"in E?E.markers:mr.markers,Pe=_e?0:parseFloat(ua(Oe)["border"+Te.p2+fr])||0,Ie=this,u=E.onRefreshInit&&function(){return E.onRefreshInit(Ie)},Ae=function _getSizeFunc(e,r,t){var n=t.d,i=t.d2,o=t.a;return(o=N(e,"getBoundingClientRect"))?function(){return o()[n]}:function(){return(r?ze["inner"+i]:e["client"+i])||0}}(Oe,_e,Te),Ne=function _getOffsetsFunc(e,r){return!r||~Ue.indexOf(e)?P(e):function(){return wr}}(Oe,_e),g=0,Be=O(Oe,Te);if(Ie.media=Qe,Ie._dir=Te,ve*=45,Ie.scroller=Oe,Ie.scroll=ye?ye.time.bind(ye):Be,C=Be(),Ie.vars=E,k=k||E.animation,"refreshPriority"in E&&(Ke=1),l.tweenScroll=l.tweenScroll||{top:sb(Oe,gr),left:sb(Oe,dr)},Ie.tweenTo=m=l.tweenScroll[Te.p],k&&(k.vars.lazy=!1,k._initted||!1!==k.vars.immediateRender&&!1!==E.immediateRender&&k.render(0,!0,!0),Ie.animation=k.pause(),k.scrollTrigger=Ie,(i=W(fe)&&fe)&&(re=Re.to(k,{ease:"power3",duration:i,onComplete:function onComplete(){return a&&a(Ie)}})),T=0,o=o||k.vars.id),br.push(Ie),be&&(X(be)&&!be.push||(be={snapTo:be}),"scrollBehavior"in Fe.style&&Re.set(_e?[Fe,We]:Oe,{scrollBehavior:"auto"}),f=V(be.snapTo)?be.snapTo:"labels"===be.snapTo?function _getClosestLabel(r){return function(e){return Re.utils.snap(za(r),e)}}(k):"labelsDirectional"===be.snapTo?function _getLabelAtDirection(t){return function(e,r){return Ba(za(t))(e,r.direction)}}(k):!1!==be.directional?function(e,r){return Ba(be.snapTo)(e,r.direction)}:Re.utils.snap(be.snapTo),p=be.duration||{min:.1,max:2},p=X(p)?De(p.min,p.max):De(p,p),te=Re.delayedCall(be.delay||i/2||.1,function(){if(Math.abs(Ie.getVelocity())<10&&!je&&g!==Be()){var e=k&&!Ee?k.totalProgress():Ie.progress,r=(e-ee)/(Ze()-He)*1e3||0,t=Re.utils.clamp(-Ie.progress,1-Ie.progress,tr(r/2)*r/.185),n=Ie.progress+(!1===be.inertia?0:t),i=De(0,1,f(n,Ie)),o=Be(),a=Math.round(B+i*j),s=be.onStart,l=be.onInterrupt,c=be.onComplete,u=m.tween;if(o<=R&&B<=o&&a!==o){if(u&&!u._initted&&u.data<=tr(a-o))return;!1===be.inertia&&(t=i-Ie.progress),m(a,{duration:p(tr(.185*Math.max(tr(n-e),tr(i-e))/r/.05||0)),ease:be.ease||"power3",data:tr(a-o),onInterrupt:function onInterrupt(){return te.restart(!0)&&l&&l(Ie)},onComplete:function onComplete(){Ie.update(),g=Be(),T=ee=k&&!Ee?k.totalProgress():Ie.progress,d&&d(Ie),c&&c(Ie)}},o,t*j,a-o-t*j),s&&s(Ie,m.tween)}}else Ie.isActive&&te.restart(!0)}).pause()),o&&(xr[o]=Ie),pe=Ie.trigger=I(pe||de),de=!0===de?pe:I(de),rr(le)&&(le={targets:pe,className:le}),de&&(!1===ge||ge===ur||(ge=!(!ge&&"flex"===ua(de.parentNode).display)&&cr),Ie.pin=de,!1!==E.force3D&&Re.set(de,{force3D:!0}),(n=Re.core.getCache(de)).spacer?J=n.pinState:(s&&((s=I(s))&&!s.nodeType&&(s=s.current||s.nativeElement),n.spacerIsNative=!!s,s&&(n.spacerState=mb(s))),n.spacer=Q=s||Le.createElement("div"),Q.classList.add("pin-spacer"),o&&Q.classList.add("pin-spacer-"+o),n.pinState=J=mb(de)),Ie.spacer=Q=n.spacer,t=ua(de),x=t[ge+Te.os2],q=Re.getProperty(de),b=Re.quickSetter(de,Te.a,pr),jb(de,Q,t),Y=mb(de)),c&&(e=X(c)?wa(c,vr):vr,F=Ka("scroller-start",o,Oe,Te,e,0),D=Ka("scroller-end",o,Oe,Te,e,0,F),r=F["offset"+Te.op.d2],z=Ka("start",o,Oe,Te,e,r,0,ye),L=Ka("end",o,Oe,Te,e,r,0,ye),ye&&(ae=Re.quickSetter([z,L],Te.a,pr)),ke||Ue.length&&!0===N(Oe,"fixedMarkers")||(function _makePositionable(e){var r=ua(e).position;e.style.position="absolute"===r||"fixed"===r?r:"relative"}(_e?Fe:Oe),Re.set([F,D],{force3D:!0}),y=Re.quickSetter(F,Te.a,pr),w=Re.quickSetter(D,Te.a,pr))),ye){var h=ye.vars.onUpdate,v=ye.vars.onUpdateParams;ye.eventCallback("onUpdate",function(){Ie.update(0,0,1),h&&h.apply(v||[])})}Ie.previous=function(){return br[br.indexOf(Ie)-1]},Ie.next=function(){return br[br.indexOf(Ie)+1]},Ie.revert=function(e){var r=!1!==e||!Ie.enabled,t=Xe;r!==Ie.isReverted&&(r&&(Ie.scroll.rec||(Ie.scroll.rec=Be()),ie=Math.max(Be(),Ie.scroll.rec||0),ne=Ie.progress,oe=k&&k.progress()),z&&[z,L,F,D].forEach(function(e){return e.style.display=r?"none":"block"}),r&&(Xe=1),Ie.update(r),Xe=t,de&&(r?function _swapPinOut(e,r,t){Sr(t);var n=e._gsap;if(n.spacerIsNative)Sr(n.spacerState);else if(e.parentNode===r){var i=r.parentNode;i&&(i.insertBefore(e,r),i.removeChild(r))}}(de,Q,J):xe&&Ie.isActive||jb(de,Q,ua(de),G)),Ie.isReverted=r)},Ie.refresh=function(e,r){if(!Xe&&Ie.enabled||r)if(de&&e&&Ge)Ea(ScrollTrigger,"scrollEnd",Xa);else{Xe=1,re&&re.pause(),he&&k&&k.time(-.01,!0).invalidate(),Ie.isReverted||Ie.revert();for(var t,n,i,o,a,s,l,c,u,f,p=Ae(),d=Ne(),g=ye?ye.duration():S(Oe,Te),h=0,v=0,m=E.end,b=E.endTrigger||pe,x=E.start||(0!==E.start&&pe?de?"0 0":"0 100%":0),y=E.pinnedContainer&&I(E.pinnedContainer),w=pe&&Math.max(0,br.indexOf(Ie))||0,T=w;T--;)(s=br[T]).end||s.refresh(0,1)||(Xe=1),!(l=s.pin)||l!==pe&&l!==de||s.isReverted||((f=f||[]).unshift(s),s.revert());for(V(x)&&(x=x(Ie)),B=pb(x,pe,p,Te,Be(),z,F,Ie,d,Pe,ke,g,ye)||(de?-.001:0),V(m)&&(m=m(Ie)),rr(m)&&!m.indexOf("+=")&&(~m.indexOf(" ")?m=(rr(x)?x.split(" ")[0]:"")+m:(h=Ja(m.substr(2),p),m=rr(x)?x:B+h,b=pe)),R=Math.max(B,pb(m||(b?"100% 0":g),b,p,Te,Be()+h,L,D,Ie,d,Pe,ke,g,ye))||-.001,j=R-B||(B-=.01)&&.001,h=0,T=w;T--;)(l=(s=br[T]).pin)&&s.start-s._pinPush<B&&!ye&&(t=s.end-s.start,l!==pe&&l!==y||W(x)||(h+=t*(1-s.progress)),l===de&&(v+=t));if(B+=h,R+=h,Ie._pinPush=v,z&&h&&((t={})[Te.a]="+="+h,y&&(t[Te.p]="-="+Be()),Re.set([z,L],t)),de)t=ua(de),o=Te===gr,i=Be(),U=parseFloat(q(Te.a))+v,!g&&1<R&&((_e?Fe:Oe).style["overflow-"+Te.a]="scroll"),jb(de,Q,t),Y=mb(de),n=hr(de,!0),c=ke&&O(Oe,o?dr:gr)(),ge&&((G=[ge+Te.os2,j+v+pr]).t=Q,(T=ge===cr?ya(de,Te)+j+v:0)&&G.push(Te.d,T+pr),Sr(G),ke&&Be(ie)),ke&&((a={top:n.top+(o?i-B:c)+pr,left:n.left+(o?c:i-B)+pr,boxSizing:"border-box",position:"fixed"})[nr]=a.maxWidth=Math.ceil(n.width)+pr,a[ir]=a.maxHeight=Math.ceil(n.height)+pr,a[ur]=a[ur+sr]=a[ur+or]=a[ur+lr]=a[ur+ar]="0",a[cr]=t[cr],a[cr+sr]=t[cr+sr],a[cr+or]=t[cr+or],a[cr+lr]=t[cr+lr],a[cr+ar]=t[cr+ar],K=function _copyState(e,r,t){for(var n,i=[],o=e.length,a=t?8:0;a<o;a+=2)n=e[a],i.push(n,n in r?r[n]:e[a+1]);return i.t=e.t,i}(J,a,xe)),k?(u=k._initted,Ye(1),k.render(k.duration(),!0,!0),Z=q(Te.a)-U+j+v,j!==Z&&K.splice(K.length-2,2),k.render(0,!0,!0),u||k.invalidate(),Ye(0)):Z=j;else if(pe&&Be()&&!ye)for(n=pe.parentNode;n&&n!==Fe;)n._pinOffset&&(B-=n._pinOffset,R-=n._pinOffset),n=n.parentNode;f&&f.forEach(function(e){return e.revert(!1)}),Ie.start=B,Ie.end=R,C=A=Be(),ye||(C<ie&&Be(ie),Ie.scroll.rec=0),Ie.revert(!1),Xe=0,k&&Ee&&k._initted&&k.progress()!==oe&&k.progress(oe,!0).render(k.time(),!0,!0),ne===Ie.progress&&!ye||(k&&!Ee&&k.totalProgress(ne,!0),Ie.progress=ne,Ie.update(0,0,1)),de&&ge&&(Q._pinOffset=Math.round(Ie.progress*Z)),ue&&ue(Ie)}},Ie.getVelocity=function(){return(Be()-A)/(Ze()-He)*1e3||0},Ie.endAnimation=function(){$(Ie.callbackAnimation),k&&(re?re.progress(1):k.paused()?Ee||$(k,Ie.direction<0,1):$(k,k.reversed()))},Ie.labelToScroll=function(e){return k&&k.labels&&(B||Ie.refresh()||B)+k.labels[e]/k.duration()*j||0},Ie.getTrailing=function(r){var e=br.indexOf(Ie),t=0<Ie.direction?br.slice(0,e).reverse():br.slice(e+1);return rr(r)?t.filter(function(e){return e.vars.preventOverlaps===r}):t},Ie.update=function(e,r,t){if(!ye||t||e){var n,i,o,a,s,l,c,u=Ie.scroll(),f=e?0:(u-B)/j,p=f<0?0:1<f?1:f||0,d=Ie.progress;if(r&&(A=C,C=ye?Be():u,be&&(ee=T,T=k&&!Ee?k.totalProgress():p)),ve&&!p&&de&&!Xe&&!qe&&Ge&&B<u+(u-A)/(Ze()-He)*ve&&(p=1e-4),p!==d&&Ie.enabled){if(a=(s=(n=Ie.isActive=!!p&&p<1)!=(!!d&&d<1))||!!p!=!!d,Ie.direction=d<p?1:-1,Ie.progress=p,a&&!Xe&&(i=p&&!d?0:1===p?1:1===d?2:3,Ee&&(o=!s&&"none"!==Me[i+1]&&Me[i+1]||Me[i],c=k&&("complete"===o||"reset"===o||o in k))),we&&s&&(c||fe||!k)&&(V(we)?we(Ie):Ie.getTrailing(we).forEach(function(e){return e.endAnimation()})),Ee||(!re||Xe||qe?k&&k.totalProgress(p,!!Xe):(re.vars.totalProgress=p,re.invalidate().restart())),de)if(e&&ge&&(Q.style[ge+Te.os2]=x),ke){if(a){if(l=!e&&d<p&&u<R+1&&u+1>=S(Oe,Te),xe)if(e||!n&&!l)rb(de,Q);else{var g=hr(de,!0),h=u-B;rb(de,Fe,g.top+(Te===gr?h:0)+pr,g.left+(Te===gr?0:h)+pr)}Sr(n||l?K:Y),Z!==j&&p<1&&n||b(U+(1!==p||l?0:Z))}}else b(U+Z*p);!be||m.tween||Xe||qe||te.restart(!0),le&&(s||me&&p&&(p<1||!$e))&&Ve(le.targets).forEach(function(e){return e.classList[n||me?"add":"remove"](le.className)}),!se||Ee||e||se(Ie),a&&!Xe?(Ee&&(c&&("complete"===o?k.pause().totalProgress(1):"reset"===o?k.restart(!0).pause():"restart"===o?k.restart(!0):k[o]()),se&&se(Ie)),!s&&$e||(ce&&s&&_(Ie,ce),Ce[i]&&_(Ie,Ce[i]),me&&(1===p?Ie.kill(!1,1):Ce[i]=0),s||Ce[i=1===p?1:3]&&_(Ie,Ce[i])),Se&&!n&&Math.abs(Ie.getVelocity())>(W(Se)?Se:2500)&&($(Ie.callbackAnimation),re?re.progress(1):$(k,!p,1))):Ee&&se&&!Xe&&se(Ie)}if(w){var v=ye?u/ye.duration()*(ye._caScrollDist||0):u;y(v+(F._isFlipped?1:0)),w(v)}ae&&ae(-u/ye.duration()*(ye._caScrollDist||0))}},Ie.enable=function(e,r){Ie.enabled||(Ie.enabled=!0,Ea(Oe,"resize",Qa),Ea(Oe,"scroll",Pa),u&&Ea(ScrollTrigger,"refreshInit",u),!1!==e&&(Ie.progress=ne=0,C=A=g=Be()),!1!==r&&Ie.refresh())},Ie.getTween=function(e){return e&&m?m.tween:re},Ie.setPositions=function(e,r){de&&(U+=e-B,Z+=r-e-j),Ie.start=B=e,Ie.end=R=r,j=r-e,Ie.update()},Ie.disable=function(e,r){if(Ie.enabled&&(!1!==e&&Ie.revert(),Ie.enabled=Ie.isActive=!1,r||re&&re.pause(),ie=0,n&&(n.uncache=1),u&&Fa(ScrollTrigger,"refreshInit",u),te&&(te.pause(),m.tween&&m.tween.kill()&&(m.tween=0)),!_e)){for(var t=br.length;t--;)if(br[t].scroller===Oe&&br[t]!==Ie)return;Fa(Oe,"resize",Qa),Fa(Oe,"scroll",Pa)}},Ie.kill=function(e,r){Ie.disable(e,r),re&&re.kill(),o&&delete xr[o];var t=br.indexOf(Ie);0<=t&&br.splice(t,1),t===Je&&0<yr&&Je--,t=0,br.forEach(function(e){return e.scroller===Ie.scroller&&(t=1)}),t||(Ie.scroll.rec=0),k&&(k.scrollTrigger=null,e&&k.render(-1),r||k.kill()),z&&[z,L,F,D].forEach(function(e){return e.parentNode&&e.parentNode.removeChild(e)}),de&&(n&&(n.uncache=1),t=0,br.forEach(function(e){return e.pin===de&&t++}),t||(n.spacer=0))},Ie.enable(!1,!1),k&&k.add&&!j?Re.delayedCall(.01,function(){return B||R||Ie.refresh()})&&(j=.01)&&(B=R=0):Ie.refresh()}else this.update=this.refresh=this.kill=H},ScrollTrigger.register=function register(e){if(!o&&(Re=e||L(),K()&&window.document&&(ze=window,Le=document,We=Le.documentElement,Fe=Le.body),Re&&(Ve=Re.utils.toArray,De=Re.utils.clamp,Ye=Re.core.suppressOverwrites||H,Re.core.globals("ScrollTrigger",ScrollTrigger),Fe))){Ea(ze,"wheel",Pa),i=[ze,Le,We,Fe],Ea(Le,"scroll",Pa);var r,t=Fe.style,n=t.borderTopStyle;t.borderTopStyle="solid",r=hr(Fe),gr.m=Math.round(r.top+gr.sc())||0,dr.m=Math.round(r.left+dr.sc())||0,n?t.borderTopStyle=n:t.removeProperty("border-top-style"),s=setInterval(Oa,200),Re.delayedCall(.5,function(){return qe=0}),Ea(Le,"touchcancel",H),Ea(Fe,"touchstart",H),Da(Ea,Le,"pointerdown,touchstart,mousedown",function(){return je=1}),Da(Ea,Le,"pointerup,touchend,mouseup",function(){return je=0}),l=Re.utils.checkPrefix("transform"),q.push(l),o=Ze(),a=Re.delayedCall(.2,F).pause(),f=[Le,"visibilitychange",function(){var e=ze.innerWidth,r=ze.innerHeight;Le.hidden?(c=e,u=r):c===e&&u===r||Qa()},Le,"DOMContentLoaded",F,ze,"load",function(){return Ge||F()},ze,"resize",Qa],T(Ea)}return o},ScrollTrigger.defaults=function defaults(e){if(e)for(var r in e)mr[r]=e[r];return mr},ScrollTrigger.kill=function kill(){er=0,br.slice(0).forEach(function(e){return e.kill(1)})},ScrollTrigger.config=function config(e){"limitCallbacks"in e&&($e=!!e.limitCallbacks);var r=e.syncInterval;r&&clearInterval(s)||(s=r)&&setInterval(Oa,r),"autoRefreshEvents"in e&&(T(Fa)||T(Ea,e.autoRefreshEvents||"none"),t=-1===(e.autoRefreshEvents+"").indexOf("resize"))},ScrollTrigger.scrollerProxy=function scrollerProxy(e,r){var t=I(e),n=g.indexOf(t),i=M(t);~n&&g.splice(n,i?6:2),r&&(i?Ue.unshift(ze,r,Fe,r,We,r):Ue.unshift(t,r))},ScrollTrigger.matchMedia=function matchMedia(e){var r,t,n,i,o;for(t in e)n=C.indexOf(t),i=e[t],"all"===(Qe=t)?i():(r=ze.matchMedia(t))&&(r.matches&&(o=i()),~n?(C[n+1]=Z(C[n+1],i),C[n+2]=Z(C[n+2],o)):(n=C.length,C.push(t,i,o),r.addListener?r.addListener(Wa):r.addEventListener("change",Wa)),C[n+3]=r.matches),Qe=0;return C},ScrollTrigger.clearMatchMedia=function clearMatchMedia(e){e||(C.length=0),0<=(e=C.indexOf(e))&&C.splice(e,4)},ScrollTrigger.isInViewport=function isInViewport(e,r,t){var n=(rr(e)?I(e):e).getBoundingClientRect(),i=n[t?nr:ir]*r||0;return t?0<n.right-i&&n.left+i<ze.innerWidth:0<n.bottom-i&&n.top+i<ze.innerHeight},ScrollTrigger.positionInViewport=function positionInViewport(e,r,t){rr(e)&&(e=I(e));var n=e.getBoundingClientRect(),i=n[t?nr:ir],o=null==r?i/2:r in b?b[r]*i:~r.indexOf("%")?parseFloat(r)*i/100:parseFloat(r)||0;return t?(n.left+o)/ze.innerWidth:(n.top+o)/ze.innerHeight},ScrollTrigger);function ScrollTrigger(e,r){o||ScrollTrigger.register(Re)||console.warn("Please gsap.registerPlugin(ScrollTrigger)"),this.init(e,r)}ee.version="3.9.1",ee.saveStyles=function(e){return e?Ve(e).forEach(function(e){if(e&&e.style){var r=B.indexOf(e);0<=r&&B.splice(r,5),B.push(e,e.style.cssText,e.getBBox&&e.getAttribute("transform"),Re.core.getCache(e),Qe)}}):B},ee.revert=function(e,r){return z(!e,r)},ee.create=function(e,r){return new ee(e,r)},ee.refresh=function(e){return e?Qa():(o||ee.register())&&F(!0)},ee.update=j,ee.clearScrollMemory=ab,ee.maxScroll=function(e,r){return S(e,r?dr:gr)},ee.getScrollFunc=function(e,r){return O(I(e),r?dr:gr)},ee.getById=function(e){return xr[e]},ee.getAll=function(){return br.slice(0)},ee.isScrolling=function(){return!!Ge},ee.snapDirectional=Ba,ee.addEventListener=function(e,r){var t=x[e]||(x[e]=[]);~t.indexOf(r)||t.push(r)},ee.removeEventListener=function(e,r){var t=x[e],n=t&&t.indexOf(r);0<=n&&t.splice(n,1)},ee.batch=function(e,r){function Nj(e,r){var t=[],n=[],i=Re.delayedCall(o,function(){r(t,n),t=[],n=[]}).pause();return function(e){t.length||i.restart(!0),t.push(e.trigger),n.push(e),a<=t.length&&i.progress(1)}}var t,n=[],i={},o=r.interval||.016,a=r.batchMax||1e9;for(t in r)i[t]="on"===t.substr(0,2)&&V(r[t])&&"onRefreshInit"!==t?Nj(0,r[t]):r[t];return V(a)&&(a=a(),Ea(ee,"refresh",function(){return a=r.batchMax()})),Ve(e).forEach(function(e){var r={};for(t in i)r[t]=i[t];r.trigger=e,n.push(ee.create(r))}),n},ee.sort=function(e){return br.sort(e||function(e,r){return-1e6*(e.vars.refreshPriority||0)+e.start-(r.start+-1e6*(r.vars.refreshPriority||0))})},L()&&Re.registerPlugin(ee),e.ScrollTrigger=ee,e.default=ee;if (typeof(window)==="undefined"||window!==e){Object.defineProperty(e,"__esModule",{value:!0})} else {delete e.default}});


/**
 * Swiper 9.0.5
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: February 13, 2023
 */

!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Swiper=t()}(this,(function(){"use strict";function e(e){return null!==e&&"object"==typeof e&&"constructor"in e&&e.constructor===Object}function t(s,a){void 0===s&&(s={}),void 0===a&&(a={}),Object.keys(a).forEach((i=>{void 0===s[i]?s[i]=a[i]:e(a[i])&&e(s[i])&&Object.keys(a[i]).length>0&&t(s[i],a[i])}))}const s={body:{},addEventListener(){},removeEventListener(){},activeElement:{blur(){},nodeName:""},querySelector:()=>null,querySelectorAll:()=>[],getElementById:()=>null,createEvent:()=>({initEvent(){}}),createElement:()=>({children:[],childNodes:[],style:{},setAttribute(){},getElementsByTagName:()=>[]}),createElementNS:()=>({}),importNode:()=>null,location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};function a(){const e="undefined"!=typeof document?document:{};return t(e,s),e}const i={document:s,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState(){},pushState(){},go(){},back(){}},CustomEvent:function(){return this},addEventListener(){},removeEventListener(){},getComputedStyle:()=>({getPropertyValue:()=>""}),Image(){},Date(){},screen:{},setTimeout(){},clearTimeout(){},matchMedia:()=>({}),requestAnimationFrame:e=>"undefined"==typeof setTimeout?(e(),null):setTimeout(e,0),cancelAnimationFrame(e){"undefined"!=typeof setTimeout&&clearTimeout(e)}};function r(){const e="undefined"!=typeof window?window:{};return t(e,i),e}function n(e,t){return void 0===t&&(t=0),setTimeout(e,t)}function l(){return Date.now()}function o(e,t){void 0===t&&(t="x");const s=r();let a,i,n;const l=function(e){const t=r();let s;return t.getComputedStyle&&(s=t.getComputedStyle(e,null)),!s&&e.currentStyle&&(s=e.currentStyle),s||(s=e.style),s}(e);return s.WebKitCSSMatrix?(i=l.transform||l.webkitTransform,i.split(",").length>6&&(i=i.split(", ").map((e=>e.replace(",","."))).join(", ")),n=new s.WebKitCSSMatrix("none"===i?"":i)):(n=l.MozTransform||l.OTransform||l.MsTransform||l.msTransform||l.transform||l.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,"),a=n.toString().split(",")),"x"===t&&(i=s.WebKitCSSMatrix?n.m41:16===a.length?parseFloat(a[12]):parseFloat(a[4])),"y"===t&&(i=s.WebKitCSSMatrix?n.m42:16===a.length?parseFloat(a[13]):parseFloat(a[5])),i||0}function d(e){return"object"==typeof e&&null!==e&&e.constructor&&"Object"===Object.prototype.toString.call(e).slice(8,-1)}function c(e){return"undefined"!=typeof window&&void 0!==window.HTMLElement?e instanceof HTMLElement:e&&(1===e.nodeType||11===e.nodeType)}function p(){const e=Object(arguments.length<=0?void 0:arguments[0]),t=["__proto__","constructor","prototype"];for(let s=1;s<arguments.length;s+=1){const a=s<0||arguments.length<=s?void 0:arguments[s];if(null!=a&&!c(a)){const s=Object.keys(Object(a)).filter((e=>t.indexOf(e)<0));for(let t=0,i=s.length;t<i;t+=1){const i=s[t],r=Object.getOwnPropertyDescriptor(a,i);void 0!==r&&r.enumerable&&(d(e[i])&&d(a[i])?a[i].__swiper__?e[i]=a[i]:p(e[i],a[i]):!d(e[i])&&d(a[i])?(e[i]={},a[i].__swiper__?e[i]=a[i]:p(e[i],a[i])):e[i]=a[i])}}}return e}function u(e,t,s){e.style.setProperty(t,s)}function m(e){let{swiper:t,targetPosition:s,side:a}=e;const i=r(),n=-t.translate;let l,o=null;const d=t.params.speed;t.wrapperEl.style.scrollSnapType="none",i.cancelAnimationFrame(t.cssModeFrameID);const c=s>n?"next":"prev",p=(e,t)=>"next"===c&&e>=t||"prev"===c&&e<=t,u=()=>{l=(new Date).getTime(),null===o&&(o=l);const e=Math.max(Math.min((l-o)/d,1),0),r=.5-Math.cos(e*Math.PI)/2;let c=n+r*(s-n);if(p(c,s)&&(c=s),t.wrapperEl.scrollTo({[a]:c}),p(c,s))return t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.scrollSnapType="",setTimeout((()=>{t.wrapperEl.style.overflow="",t.wrapperEl.scrollTo({[a]:c})})),void i.cancelAnimationFrame(t.cssModeFrameID);t.cssModeFrameID=i.requestAnimationFrame(u)};u()}function h(e){return e.querySelector(".swiper-slide-transform")||e.shadowEl&&e.shadowEl.querySelector(".swiper-slide-transform")||e}function f(e,t){return void 0===t&&(t=""),[...e.children].filter((e=>e.matches(t)))}function g(e,t){void 0===t&&(t=[]);const s=document.createElement(e);return s.classList.add(...Array.isArray(t)?t:[t]),s}function v(e){const t=r(),s=a(),i=e.getBoundingClientRect(),n=s.body,l=e.clientTop||n.clientTop||0,o=e.clientLeft||n.clientLeft||0,d=e===t?t.scrollY:e.scrollTop,c=e===t?t.scrollX:e.scrollLeft;return{top:i.top+d-l,left:i.left+c-o}}function w(e,t){return r().getComputedStyle(e,null).getPropertyValue(t)}function b(e){let t,s=e;if(s){for(t=0;null!==(s=s.previousSibling);)1===s.nodeType&&(t+=1);return t}}function y(e,t){const s=[];let a=e.parentElement;for(;a;)t?a.matches(t)&&s.push(a):s.push(a),a=a.parentElement;return s}function E(e,t){t&&e.addEventListener("transitionend",(function s(a){a.target===e&&(t.call(e,a),e.removeEventListener("transitionend",s))}))}function x(e,t,s){const a=r();return s?e["width"===t?"offsetWidth":"offsetHeight"]+parseFloat(a.getComputedStyle(e,null).getPropertyValue("width"===t?"margin-right":"margin-top"))+parseFloat(a.getComputedStyle(e,null).getPropertyValue("width"===t?"margin-left":"margin-bottom")):e.offsetWidth}let S,T,M;function C(){return S||(S=function(){const e=r(),t=a();return{smoothScroll:t.documentElement&&"scrollBehavior"in t.documentElement.style,touch:!!("ontouchstart"in e||e.DocumentTouch&&t instanceof e.DocumentTouch)}}()),S}function P(e){return void 0===e&&(e={}),T||(T=function(e){let{userAgent:t}=void 0===e?{}:e;const s=C(),a=r(),i=a.navigator.platform,n=t||a.navigator.userAgent,l={ios:!1,android:!1},o=a.screen.width,d=a.screen.height,c=n.match(/(Android);?[\s\/]+([\d.]+)?/);let p=n.match(/(iPad).*OS\s([\d_]+)/);const u=n.match(/(iPod)(.*OS\s([\d_]+))?/),m=!p&&n.match(/(iPhone\sOS|iOS)\s([\d_]+)/),h="Win32"===i;let f="MacIntel"===i;return!p&&f&&s.touch&&["1024x1366","1366x1024","834x1194","1194x834","834x1112","1112x834","768x1024","1024x768","820x1180","1180x820","810x1080","1080x810"].indexOf(`${o}x${d}`)>=0&&(p=n.match(/(Version)\/([\d.]+)/),p||(p=[0,1,"13_0_0"]),f=!1),c&&!h&&(l.os="android",l.android=!0),(p||m||u)&&(l.os="ios",l.ios=!0),l}(e)),T}function L(){return M||(M=function(){const e=r();let t=!1;function s(){const t=e.navigator.userAgent.toLowerCase();return t.indexOf("safari")>=0&&t.indexOf("chrome")<0&&t.indexOf("android")<0}if(s()){const s=String(e.navigator.userAgent);if(s.includes("Version/")){const[e,a]=s.split("Version/")[1].split(" ")[0].split(".").map((e=>Number(e)));t=e<16||16===e&&a<2}}return{isSafari:t||s(),needPerspectiveFix:t,isWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)}}()),M}var A={on(e,t,s){const a=this;if(!a.eventsListeners||a.destroyed)return a;if("function"!=typeof t)return a;const i=s?"unshift":"push";return e.split(" ").forEach((e=>{a.eventsListeners[e]||(a.eventsListeners[e]=[]),a.eventsListeners[e][i](t)})),a},once(e,t,s){const a=this;if(!a.eventsListeners||a.destroyed)return a;if("function"!=typeof t)return a;function i(){a.off(e,i),i.__emitterProxy&&delete i.__emitterProxy;for(var s=arguments.length,r=new Array(s),n=0;n<s;n++)r[n]=arguments[n];t.apply(a,r)}return i.__emitterProxy=t,a.on(e,i,s)},onAny(e,t){const s=this;if(!s.eventsListeners||s.destroyed)return s;if("function"!=typeof e)return s;const a=t?"unshift":"push";return s.eventsAnyListeners.indexOf(e)<0&&s.eventsAnyListeners[a](e),s},offAny(e){const t=this;if(!t.eventsListeners||t.destroyed)return t;if(!t.eventsAnyListeners)return t;const s=t.eventsAnyListeners.indexOf(e);return s>=0&&t.eventsAnyListeners.splice(s,1),t},off(e,t){const s=this;return!s.eventsListeners||s.destroyed?s:s.eventsListeners?(e.split(" ").forEach((e=>{void 0===t?s.eventsListeners[e]=[]:s.eventsListeners[e]&&s.eventsListeners[e].forEach(((a,i)=>{(a===t||a.__emitterProxy&&a.__emitterProxy===t)&&s.eventsListeners[e].splice(i,1)}))})),s):s},emit(){const e=this;if(!e.eventsListeners||e.destroyed)return e;if(!e.eventsListeners)return e;let t,s,a;for(var i=arguments.length,r=new Array(i),n=0;n<i;n++)r[n]=arguments[n];"string"==typeof r[0]||Array.isArray(r[0])?(t=r[0],s=r.slice(1,r.length),a=e):(t=r[0].events,s=r[0].data,a=r[0].context||e),s.unshift(a);return(Array.isArray(t)?t:t.split(" ")).forEach((t=>{e.eventsAnyListeners&&e.eventsAnyListeners.length&&e.eventsAnyListeners.forEach((e=>{e.apply(a,[t,...s])})),e.eventsListeners&&e.eventsListeners[t]&&e.eventsListeners[t].forEach((e=>{e.apply(a,s)}))})),e}};var z={updateSize:function(){const e=this;let t,s;const a=e.el;t=void 0!==e.params.width&&null!==e.params.width?e.params.width:a.clientWidth,s=void 0!==e.params.height&&null!==e.params.height?e.params.height:a.clientHeight,0===t&&e.isHorizontal()||0===s&&e.isVertical()||(t=t-parseInt(w(a,"padding-left")||0,10)-parseInt(w(a,"padding-right")||0,10),s=s-parseInt(w(a,"padding-top")||0,10)-parseInt(w(a,"padding-bottom")||0,10),Number.isNaN(t)&&(t=0),Number.isNaN(s)&&(s=0),Object.assign(e,{width:t,height:s,size:e.isHorizontal()?t:s}))},updateSlides:function(){const e=this;function t(t){return e.isHorizontal()?t:{width:"height","margin-top":"margin-left","margin-bottom ":"margin-right","margin-left":"margin-top","margin-right":"margin-bottom","padding-left":"padding-top","padding-right":"padding-bottom",marginRight:"marginBottom"}[t]}function s(e,s){return parseFloat(e.getPropertyValue(t(s))||0)}const a=e.params,{wrapperEl:i,slidesEl:r,size:n,rtlTranslate:l,wrongRTL:o}=e,d=e.virtual&&a.virtual.enabled,c=d?e.virtual.slides.length:e.slides.length,p=f(r,`.${e.params.slideClass}, swiper-slide`),m=d?e.virtual.slides.length:p.length;let h=[];const g=[],v=[];let b=a.slidesOffsetBefore;"function"==typeof b&&(b=a.slidesOffsetBefore.call(e));let y=a.slidesOffsetAfter;"function"==typeof y&&(y=a.slidesOffsetAfter.call(e));const E=e.snapGrid.length,S=e.slidesGrid.length;let T=a.spaceBetween,M=-b,C=0,P=0;if(void 0===n)return;"string"==typeof T&&T.indexOf("%")>=0&&(T=parseFloat(T.replace("%",""))/100*n),e.virtualSize=-T,p.forEach((e=>{l?e.style.marginLeft="":e.style.marginRight="",e.style.marginBottom="",e.style.marginTop=""})),a.centeredSlides&&a.cssMode&&(u(i,"--swiper-centered-offset-before",""),u(i,"--swiper-centered-offset-after",""));const L=a.grid&&a.grid.rows>1&&e.grid;let A;L&&e.grid.initSlides(m);const z="auto"===a.slidesPerView&&a.breakpoints&&Object.keys(a.breakpoints).filter((e=>void 0!==a.breakpoints[e].slidesPerView)).length>0;for(let i=0;i<m;i+=1){let r;if(A=0,p[i]&&(r=p[i]),L&&e.grid.updateSlide(i,r,m,t),!p[i]||"none"!==w(r,"display")){if("auto"===a.slidesPerView){z&&(p[i].style[t("width")]="");const n=getComputedStyle(r),l=r.style.transform,o=r.style.webkitTransform;if(l&&(r.style.transform="none"),o&&(r.style.webkitTransform="none"),a.roundLengths)A=e.isHorizontal()?x(r,"width",!0):x(r,"height",!0);else{const e=s(n,"width"),t=s(n,"padding-left"),a=s(n,"padding-right"),i=s(n,"margin-left"),l=s(n,"margin-right"),o=n.getPropertyValue("box-sizing");if(o&&"border-box"===o)A=e+i+l;else{const{clientWidth:s,offsetWidth:n}=r;A=e+t+a+i+l+(n-s)}}l&&(r.style.transform=l),o&&(r.style.webkitTransform=o),a.roundLengths&&(A=Math.floor(A))}else A=(n-(a.slidesPerView-1)*T)/a.slidesPerView,a.roundLengths&&(A=Math.floor(A)),p[i]&&(p[i].style[t("width")]=`${A}px`);p[i]&&(p[i].swiperSlideSize=A),v.push(A),a.centeredSlides?(M=M+A/2+C/2+T,0===C&&0!==i&&(M=M-n/2-T),0===i&&(M=M-n/2-T),Math.abs(M)<.001&&(M=0),a.roundLengths&&(M=Math.floor(M)),P%a.slidesPerGroup==0&&h.push(M),g.push(M)):(a.roundLengths&&(M=Math.floor(M)),(P-Math.min(e.params.slidesPerGroupSkip,P))%e.params.slidesPerGroup==0&&h.push(M),g.push(M),M=M+A+T),e.virtualSize+=A+T,C=A,P+=1}}if(e.virtualSize=Math.max(e.virtualSize,n)+y,l&&o&&("slide"===a.effect||"coverflow"===a.effect)&&(i.style.width=`${e.virtualSize+a.spaceBetween}px`),a.setWrapperSize&&(i.style[t("width")]=`${e.virtualSize+a.spaceBetween}px`),L&&e.grid.updateWrapperSize(A,h,t),!a.centeredSlides){const t=[];for(let s=0;s<h.length;s+=1){let i=h[s];a.roundLengths&&(i=Math.floor(i)),h[s]<=e.virtualSize-n&&t.push(i)}h=t,Math.floor(e.virtualSize-n)-Math.floor(h[h.length-1])>1&&h.push(e.virtualSize-n)}if(d&&a.loop){const t=v[0]+T;if(a.slidesPerGroup>1){const s=Math.ceil((e.virtual.slidesBefore+e.virtual.slidesAfter)/a.slidesPerGroup),i=t*a.slidesPerGroup;for(let e=0;e<s;e+=1)h.push(h[h.length-1]+i)}for(let s=0;s<e.virtual.slidesBefore+e.virtual.slidesAfter;s+=1)1===a.slidesPerGroup&&h.push(h[h.length-1]+t),g.push(g[g.length-1]+t),e.virtualSize+=t}if(0===h.length&&(h=[0]),0!==a.spaceBetween){const s=e.isHorizontal()&&l?"marginLeft":t("marginRight");p.filter(((e,t)=>!(a.cssMode&&!a.loop)||t!==p.length-1)).forEach((e=>{e.style[s]=`${T}px`}))}if(a.centeredSlides&&a.centeredSlidesBounds){let e=0;v.forEach((t=>{e+=t+(a.spaceBetween?a.spaceBetween:0)})),e-=a.spaceBetween;const t=e-n;h=h.map((e=>e<0?-b:e>t?t+y:e))}if(a.centerInsufficientSlides){let e=0;if(v.forEach((t=>{e+=t+(a.spaceBetween?a.spaceBetween:0)})),e-=a.spaceBetween,e<n){const t=(n-e)/2;h.forEach(((e,s)=>{h[s]=e-t})),g.forEach(((e,s)=>{g[s]=e+t}))}}if(Object.assign(e,{slides:p,snapGrid:h,slidesGrid:g,slidesSizesGrid:v}),a.centeredSlides&&a.cssMode&&!a.centeredSlidesBounds){u(i,"--swiper-centered-offset-before",-h[0]+"px"),u(i,"--swiper-centered-offset-after",e.size/2-v[v.length-1]/2+"px");const t=-e.snapGrid[0],s=-e.slidesGrid[0];e.snapGrid=e.snapGrid.map((e=>e+t)),e.slidesGrid=e.slidesGrid.map((e=>e+s))}if(m!==c&&e.emit("slidesLengthChange"),h.length!==E&&(e.params.watchOverflow&&e.checkOverflow(),e.emit("snapGridLengthChange")),g.length!==S&&e.emit("slidesGridLengthChange"),a.watchSlidesProgress&&e.updateSlidesOffset(),!(d||a.cssMode||"slide"!==a.effect&&"fade"!==a.effect)){const t=`${a.containerModifierClass}backface-hidden`,s=e.el.classList.contains(t);m<=a.maxBackfaceHiddenSlides?s||e.el.classList.add(t):s&&e.el.classList.remove(t)}},updateAutoHeight:function(e){const t=this,s=[],a=t.virtual&&t.params.virtual.enabled;let i,r=0;"number"==typeof e?t.setTransition(e):!0===e&&t.setTransition(t.params.speed);const n=e=>a?t.slides.filter((t=>parseInt(t.getAttribute("data-swiper-slide-index"),10)===e))[0]:t.slides[e];if("auto"!==t.params.slidesPerView&&t.params.slidesPerView>1)if(t.params.centeredSlides)(t.visibleSlides||[]).forEach((e=>{s.push(e)}));else for(i=0;i<Math.ceil(t.params.slidesPerView);i+=1){const e=t.activeIndex+i;if(e>t.slides.length&&!a)break;s.push(n(e))}else s.push(n(t.activeIndex));for(i=0;i<s.length;i+=1)if(void 0!==s[i]){const e=s[i].offsetHeight;r=e>r?e:r}(r||0===r)&&(t.wrapperEl.style.height=`${r}px`)},updateSlidesOffset:function(){const e=this,t=e.slides,s=e.isElement?e.isHorizontal()?e.wrapperEl.offsetLeft:e.wrapperEl.offsetTop:0;for(let a=0;a<t.length;a+=1)t[a].swiperSlideOffset=(e.isHorizontal()?t[a].offsetLeft:t[a].offsetTop)-s},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);const t=this,s=t.params,{slides:a,rtlTranslate:i,snapGrid:r}=t;if(0===a.length)return;void 0===a[0].swiperSlideOffset&&t.updateSlidesOffset();let n=-e;i&&(n=e),a.forEach((e=>{e.classList.remove(s.slideVisibleClass)})),t.visibleSlidesIndexes=[],t.visibleSlides=[];for(let e=0;e<a.length;e+=1){const l=a[e];let o=l.swiperSlideOffset;s.cssMode&&s.centeredSlides&&(o-=a[0].swiperSlideOffset);const d=(n+(s.centeredSlides?t.minTranslate():0)-o)/(l.swiperSlideSize+s.spaceBetween),c=(n-r[0]+(s.centeredSlides?t.minTranslate():0)-o)/(l.swiperSlideSize+s.spaceBetween),p=-(n-o),u=p+t.slidesSizesGrid[e];(p>=0&&p<t.size-1||u>1&&u<=t.size||p<=0&&u>=t.size)&&(t.visibleSlides.push(l),t.visibleSlidesIndexes.push(e),a[e].classList.add(s.slideVisibleClass)),l.progress=i?-d:d,l.originalProgress=i?-c:c}},updateProgress:function(e){const t=this;if(void 0===e){const s=t.rtlTranslate?-1:1;e=t&&t.translate&&t.translate*s||0}const s=t.params,a=t.maxTranslate()-t.minTranslate();let{progress:i,isBeginning:r,isEnd:n,progressLoop:l}=t;const o=r,d=n;if(0===a)i=0,r=!0,n=!0;else{i=(e-t.minTranslate())/a;const s=Math.abs(e-t.minTranslate())<1,l=Math.abs(e-t.maxTranslate())<1;r=s||i<=0,n=l||i>=1,s&&(i=0),l&&(i=1)}if(s.loop){const s=b(t.slides.filter((e=>"0"===e.getAttribute("data-swiper-slide-index")))[0]),a=b(t.slides.filter((e=>1*e.getAttribute("data-swiper-slide-index")==t.slides.length-1))[0]),i=t.slidesGrid[s],r=t.slidesGrid[a],n=t.slidesGrid[t.slidesGrid.length-1],o=Math.abs(e);l=o>=i?(o-i)/n:(o+n-r)/n,l>1&&(l-=1)}Object.assign(t,{progress:i,progressLoop:l,isBeginning:r,isEnd:n}),(s.watchSlidesProgress||s.centeredSlides&&s.autoHeight)&&t.updateSlidesProgress(e),r&&!o&&t.emit("reachBeginning toEdge"),n&&!d&&t.emit("reachEnd toEdge"),(o&&!r||d&&!n)&&t.emit("fromEdge"),t.emit("progress",i)},updateSlidesClasses:function(){const e=this,{slides:t,params:s,slidesEl:a,activeIndex:i}=e,r=e.virtual&&s.virtual.enabled,n=e=>f(a,`.${s.slideClass}${e}, swiper-slide${e}`)[0];let l;if(t.forEach((e=>{e.classList.remove(s.slideActiveClass,s.slideNextClass,s.slidePrevClass)})),r)if(s.loop){let t=i-e.virtual.slidesBefore;t<0&&(t=e.virtual.slides.length+t),t>=e.virtual.slides.length&&(t-=e.virtual.slides.length),l=n(`[data-swiper-slide-index="${t}"]`)}else l=n(`[data-swiper-slide-index="${i}"]`);else l=t[i];if(l){l.classList.add(s.slideActiveClass);let e=function(e,t){const s=[];for(;e.nextElementSibling;){const a=e.nextElementSibling;t?a.matches(t)&&s.push(a):s.push(a),e=a}return s}(l,`.${s.slideClass}, swiper-slide`)[0];s.loop&&!e&&(e=t[0]),e&&e.classList.add(s.slideNextClass);let a=function(e,t){const s=[];for(;e.previousElementSibling;){const a=e.previousElementSibling;t?a.matches(t)&&s.push(a):s.push(a),e=a}return s}(l,`.${s.slideClass}, swiper-slide`)[0];s.loop&&0===!a&&(a=t[t.length-1]),a&&a.classList.add(s.slidePrevClass)}e.emitSlidesClasses()},updateActiveIndex:function(e){const t=this,s=t.rtlTranslate?t.translate:-t.translate,{snapGrid:a,params:i,activeIndex:r,realIndex:n,snapIndex:l}=t;let o,d=e;const c=e=>{let s=e-t.virtual.slidesBefore;return s<0&&(s=t.virtual.slides.length+s),s>=t.virtual.slides.length&&(s-=t.virtual.slides.length),s};if(void 0===d&&(d=function(e){const{slidesGrid:t,params:s}=e,a=e.rtlTranslate?e.translate:-e.translate;let i;for(let e=0;e<t.length;e+=1)void 0!==t[e+1]?a>=t[e]&&a<t[e+1]-(t[e+1]-t[e])/2?i=e:a>=t[e]&&a<t[e+1]&&(i=e+1):a>=t[e]&&(i=e);return s.normalizeSlideIndex&&(i<0||void 0===i)&&(i=0),i}(t)),a.indexOf(s)>=0)o=a.indexOf(s);else{const e=Math.min(i.slidesPerGroupSkip,d);o=e+Math.floor((d-e)/i.slidesPerGroup)}if(o>=a.length&&(o=a.length-1),d===r)return o!==l&&(t.snapIndex=o,t.emit("snapIndexChange")),void(t.params.loop&&t.virtual&&t.params.virtual.enabled&&(t.realIndex=c(d)));let p;p=t.virtual&&i.virtual.enabled&&i.loop?c(d):t.slides[d]?parseInt(t.slides[d].getAttribute("data-swiper-slide-index")||d,10):d,Object.assign(t,{snapIndex:o,realIndex:p,previousIndex:r,activeIndex:d}),t.emit("activeIndexChange"),t.emit("snapIndexChange"),n!==p&&t.emit("realIndexChange"),(t.initialized||t.params.runCallbacksOnInit)&&t.emit("slideChange")},updateClickedSlide:function(e){const t=this,s=t.params,a=e.closest(`.${s.slideClass}, swiper-slide`);let i,r=!1;if(a)for(let e=0;e<t.slides.length;e+=1)if(t.slides[e]===a){r=!0,i=e;break}if(!a||!r)return t.clickedSlide=void 0,void(t.clickedIndex=void 0);t.clickedSlide=a,t.virtual&&t.params.virtual.enabled?t.clickedIndex=parseInt(a.getAttribute("data-swiper-slide-index"),10):t.clickedIndex=i,s.slideToClickedSlide&&void 0!==t.clickedIndex&&t.clickedIndex!==t.activeIndex&&t.slideToClickedSlide()}};var $={getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");const{params:t,rtlTranslate:s,translate:a,wrapperEl:i}=this;if(t.virtualTranslate)return s?-a:a;if(t.cssMode)return a;let r=o(i,e);return s&&(r=-r),r||0},setTranslate:function(e,t){const s=this,{rtlTranslate:a,params:i,wrapperEl:r,progress:n}=s;let l,o=0,d=0;s.isHorizontal()?o=a?-e:e:d=e,i.roundLengths&&(o=Math.floor(o),d=Math.floor(d)),i.cssMode?r[s.isHorizontal()?"scrollLeft":"scrollTop"]=s.isHorizontal()?-o:-d:i.virtualTranslate||(r.style.transform=`translate3d(${o}px, ${d}px, 0px)`),s.previousTranslate=s.translate,s.translate=s.isHorizontal()?o:d;const c=s.maxTranslate()-s.minTranslate();l=0===c?0:(e-s.minTranslate())/c,l!==n&&s.updateProgress(e),s.emit("setTranslate",s.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,s,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),void 0===a&&(a=!0);const r=this,{params:n,wrapperEl:l}=r;if(r.animating&&n.preventInteractionOnTransition)return!1;const o=r.minTranslate(),d=r.maxTranslate();let c;if(c=a&&e>o?o:a&&e<d?d:e,r.updateProgress(c),n.cssMode){const e=r.isHorizontal();if(0===t)l[e?"scrollLeft":"scrollTop"]=-c;else{if(!r.support.smoothScroll)return m({swiper:r,targetPosition:-c,side:e?"left":"top"}),!0;l.scrollTo({[e?"left":"top"]:-c,behavior:"smooth"})}return!0}return 0===t?(r.setTransition(0),r.setTranslate(c),s&&(r.emit("beforeTransitionStart",t,i),r.emit("transitionEnd"))):(r.setTransition(t),r.setTranslate(c),s&&(r.emit("beforeTransitionStart",t,i),r.emit("transitionStart")),r.animating||(r.animating=!0,r.onTranslateToWrapperTransitionEnd||(r.onTranslateToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.wrapperEl.removeEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.onTranslateToWrapperTransitionEnd=null,delete r.onTranslateToWrapperTransitionEnd,s&&r.emit("transitionEnd"))}),r.wrapperEl.addEventListener("transitionend",r.onTranslateToWrapperTransitionEnd))),!0}};function k(e){let{swiper:t,runCallbacks:s,direction:a,step:i}=e;const{activeIndex:r,previousIndex:n}=t;let l=a;if(l||(l=r>n?"next":r<n?"prev":"reset"),t.emit(`transition${i}`),s&&r!==n){if("reset"===l)return void t.emit(`slideResetTransition${i}`);t.emit(`slideChangeTransition${i}`),"next"===l?t.emit(`slideNextTransition${i}`):t.emit(`slidePrevTransition${i}`)}}var I={slideTo:function(e,t,s,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),"string"==typeof e&&(e=parseInt(e,10));const r=this;let n=e;n<0&&(n=0);const{params:l,snapGrid:o,slidesGrid:d,previousIndex:c,activeIndex:p,rtlTranslate:u,wrapperEl:h,enabled:f}=r;if(r.animating&&l.preventInteractionOnTransition||!f&&!a&&!i)return!1;const g=Math.min(r.params.slidesPerGroupSkip,n);let v=g+Math.floor((n-g)/r.params.slidesPerGroup);v>=o.length&&(v=o.length-1);const w=-o[v];if(l.normalizeSlideIndex)for(let e=0;e<d.length;e+=1){const t=-Math.floor(100*w),s=Math.floor(100*d[e]),a=Math.floor(100*d[e+1]);void 0!==d[e+1]?t>=s&&t<a-(a-s)/2?n=e:t>=s&&t<a&&(n=e+1):t>=s&&(n=e)}if(r.initialized&&n!==p){if(!r.allowSlideNext&&w<r.translate&&w<r.minTranslate())return!1;if(!r.allowSlidePrev&&w>r.translate&&w>r.maxTranslate()&&(p||0)!==n)return!1}let b;if(n!==(c||0)&&s&&r.emit("beforeSlideChangeStart"),r.updateProgress(w),b=n>p?"next":n<p?"prev":"reset",u&&-w===r.translate||!u&&w===r.translate)return r.updateActiveIndex(n),l.autoHeight&&r.updateAutoHeight(),r.updateSlidesClasses(),"slide"!==l.effect&&r.setTranslate(w),"reset"!==b&&(r.transitionStart(s,b),r.transitionEnd(s,b)),!1;if(l.cssMode){const e=r.isHorizontal(),s=u?w:-w;if(0===t){const t=r.virtual&&r.params.virtual.enabled;t&&(r.wrapperEl.style.scrollSnapType="none",r._immediateVirtual=!0),t&&!r._cssModeVirtualInitialSet&&r.params.initialSlide>0?(r._cssModeVirtualInitialSet=!0,requestAnimationFrame((()=>{h[e?"scrollLeft":"scrollTop"]=s}))):h[e?"scrollLeft":"scrollTop"]=s,t&&requestAnimationFrame((()=>{r.wrapperEl.style.scrollSnapType="",r._immediateVirtual=!1}))}else{if(!r.support.smoothScroll)return m({swiper:r,targetPosition:s,side:e?"left":"top"}),!0;h.scrollTo({[e?"left":"top"]:s,behavior:"smooth"})}return!0}return r.setTransition(t),r.setTranslate(w),r.updateActiveIndex(n),r.updateSlidesClasses(),r.emit("beforeTransitionStart",t,a),r.transitionStart(s,b),0===t?r.transitionEnd(s,b):r.animating||(r.animating=!0,r.onSlideToWrapperTransitionEnd||(r.onSlideToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.wrapperEl.removeEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.onSlideToWrapperTransitionEnd=null,delete r.onSlideToWrapperTransitionEnd,r.transitionEnd(s,b))}),r.wrapperEl.addEventListener("transitionend",r.onSlideToWrapperTransitionEnd)),!0},slideToLoop:function(e,t,s,a){if(void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),"string"==typeof e){e=parseInt(e,10)}const i=this;let r=e;return i.params.loop&&(i.virtual&&i.params.virtual.enabled?r+=i.virtual.slidesBefore:r=b(i.slides.filter((e=>1*e.getAttribute("data-swiper-slide-index")===r))[0])),i.slideTo(r,t,s,a)},slideNext:function(e,t,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const a=this,{enabled:i,params:r,animating:n}=a;if(!i)return a;let l=r.slidesPerGroup;"auto"===r.slidesPerView&&1===r.slidesPerGroup&&r.slidesPerGroupAuto&&(l=Math.max(a.slidesPerViewDynamic("current",!0),1));const o=a.activeIndex<r.slidesPerGroupSkip?1:l,d=a.virtual&&r.virtual.enabled;if(r.loop){if(n&&!d&&r.loopPreventsSliding)return!1;a.loopFix({direction:"next"}),a._clientLeft=a.wrapperEl.clientLeft}return r.rewind&&a.isEnd?a.slideTo(0,e,t,s):a.slideTo(a.activeIndex+o,e,t,s)},slidePrev:function(e,t,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const a=this,{params:i,snapGrid:r,slidesGrid:n,rtlTranslate:l,enabled:o,animating:d}=a;if(!o)return a;const c=a.virtual&&i.virtual.enabled;if(i.loop){if(d&&!c&&i.loopPreventsSliding)return!1;a.loopFix({direction:"prev"}),a._clientLeft=a.wrapperEl.clientLeft}function p(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}const u=p(l?a.translate:-a.translate),m=r.map((e=>p(e)));let h=r[m.indexOf(u)-1];if(void 0===h&&i.cssMode){let e;r.forEach(((t,s)=>{u>=t&&(e=s)})),void 0!==e&&(h=r[e>0?e-1:e])}let f=0;if(void 0!==h&&(f=n.indexOf(h),f<0&&(f=a.activeIndex-1),"auto"===i.slidesPerView&&1===i.slidesPerGroup&&i.slidesPerGroupAuto&&(f=f-a.slidesPerViewDynamic("previous",!0)+1,f=Math.max(f,0))),i.rewind&&a.isBeginning){const i=a.params.virtual&&a.params.virtual.enabled&&a.virtual?a.virtual.slides.length-1:a.slides.length-1;return a.slideTo(i,e,t,s)}return a.slideTo(f,e,t,s)},slideReset:function(e,t,s){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,s)},slideToClosest:function(e,t,s,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===a&&(a=.5);const i=this;let r=i.activeIndex;const n=Math.min(i.params.slidesPerGroupSkip,r),l=n+Math.floor((r-n)/i.params.slidesPerGroup),o=i.rtlTranslate?i.translate:-i.translate;if(o>=i.snapGrid[l]){const e=i.snapGrid[l];o-e>(i.snapGrid[l+1]-e)*a&&(r+=i.params.slidesPerGroup)}else{const e=i.snapGrid[l-1];o-e<=(i.snapGrid[l]-e)*a&&(r-=i.params.slidesPerGroup)}return r=Math.max(r,0),r=Math.min(r,i.slidesGrid.length-1),i.slideTo(r,e,t,s)},slideToClickedSlide:function(){const e=this,{params:t,slidesEl:s}=e,a="auto"===t.slidesPerView?e.slidesPerViewDynamic():t.slidesPerView;let i,r=e.clickedIndex;const l=e.isElement?"swiper-slide":`.${t.slideClass}`;if(t.loop){if(e.animating)return;i=parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"),10),t.centeredSlides?r<e.loopedSlides-a/2||r>e.slides.length-e.loopedSlides+a/2?(e.loopFix(),r=b(f(s,`${l}[data-swiper-slide-index="${i}"]`)[0]),n((()=>{e.slideTo(r)}))):e.slideTo(r):r>e.slides.length-a?(e.loopFix(),r=b(f(s,`${l}[data-swiper-slide-index="${i}"]`)[0]),n((()=>{e.slideTo(r)}))):e.slideTo(r)}else e.slideTo(r)}};var O={loopCreate:function(e){const t=this,{params:s,slidesEl:a}=t;if(!s.loop||t.virtual&&t.params.virtual.enabled)return;f(a,`.${s.slideClass}, swiper-slide`).forEach(((e,t)=>{e.setAttribute("data-swiper-slide-index",t)})),t.loopFix({slideRealIndex:e,direction:s.centeredSlides?void 0:"next"})},loopFix:function(e){let{slideRealIndex:t,slideTo:s=!0,direction:a,setTranslate:i,activeSlideIndex:r,byController:n,byMousewheel:l}=void 0===e?{}:e;const o=this;if(!o.params.loop)return;o.emit("beforeLoopFix");const{slides:d,allowSlidePrev:c,allowSlideNext:p,slidesEl:u,params:m}=o;if(o.allowSlidePrev=!0,o.allowSlideNext=!0,o.virtual&&m.virtual.enabled)return s&&(m.centeredSlides||0!==o.snapIndex?m.centeredSlides&&o.snapIndex<m.slidesPerView?o.slideTo(o.virtual.slides.length+o.snapIndex,0,!1,!0):o.snapIndex===o.snapGrid.length-1&&o.slideTo(o.virtual.slidesBefore,0,!1,!0):o.slideTo(o.virtual.slides.length,0,!1,!0)),o.allowSlidePrev=c,o.allowSlideNext=p,void o.emit("loopFix");const h="auto"===m.slidesPerView?o.slidesPerViewDynamic():Math.ceil(parseFloat(m.slidesPerView,10));let f=m.loopedSlides||h;f%m.slidesPerGroup!=0&&(f+=m.slidesPerGroup-f%m.slidesPerGroup),o.loopedSlides=f;const g=[],v=[];let w=o.activeIndex;void 0===r?r=b(o.slides.filter((e=>e.classList.contains("swiper-slide-active")))[0]):w=r;const y="next"===a||!a,E="prev"===a||!a;let x=0,S=0;if(r<f){x=f-r;for(let e=0;e<f-r;e+=1){const t=e-Math.floor(e/d.length)*d.length;g.push(d.length-t-1)}}else if(r>o.slides.length-2*f){S=r-(o.slides.length-2*f);for(let e=0;e<S;e+=1){const t=e-Math.floor(e/d.length)*d.length;v.push(t)}}if(E&&g.forEach((e=>{u.prepend(o.slides[e])})),y&&v.forEach((e=>{u.append(o.slides[e])})),o.recalcSlides(),m.watchSlidesProgress&&o.updateSlidesOffset(),s)if(g.length>0&&E)if(void 0===t){const e=o.slidesGrid[w],t=o.slidesGrid[w+x]-e;l?o.setTranslate(o.translate-t):(o.slideTo(w+x,0,!1,!0),i&&(o.touches[o.isHorizontal()?"startX":"startY"]+=t))}else i&&o.slideToLoop(t,0,!1,!0);else if(v.length>0&&y)if(void 0===t){const e=o.slidesGrid[w],t=o.slidesGrid[w-S]-e;l?o.setTranslate(o.translate-t):(o.slideTo(w-S,0,!1,!0),i&&(o.touches[o.isHorizontal()?"startX":"startY"]+=t))}else o.slideToLoop(t,0,!1,!0);if(o.allowSlidePrev=c,o.allowSlideNext=p,o.controller&&o.controller.control&&!n){const e={slideRealIndex:t,slideTo:!1,direction:a,setTranslate:i,activeSlideIndex:r,byController:!0};Array.isArray(o.controller.control)?o.controller.control.forEach((t=>{t.params.loop&&t.loopFix(e)})):o.controller.control instanceof o.constructor&&o.controller.control.params.loop&&o.controller.control.loopFix(e)}o.emit("loopFix")},loopDestroy:function(){const e=this,{slides:t,params:s,slidesEl:a}=e;if(!s.loop||e.virtual&&e.params.virtual.enabled)return;e.recalcSlides();const i=[];t.forEach((e=>{const t=void 0===e.swiperSlideIndex?1*e.getAttribute("data-swiper-slide-index"):e.swiperSlideIndex;i[t]=e})),t.forEach((e=>{e.removeAttribute("data-swiper-slide-index")})),i.forEach((e=>{a.append(e)})),e.recalcSlides(),e.slideTo(e.realIndex,0)}};function D(e){const t=this,s=a(),i=r(),n=t.touchEventsData;n.evCache.push(e);const{params:o,touches:d,enabled:c}=t;if(!c)return;if(!o.simulateTouch&&"mouse"===e.pointerType)return;if(t.animating&&o.preventInteractionOnTransition)return;!t.animating&&o.cssMode&&o.loop&&t.loopFix();let p=e;p.originalEvent&&(p=p.originalEvent);let u=p.target;if("wrapper"===o.touchEventsTarget&&!t.wrapperEl.contains(u))return;if("which"in p&&3===p.which)return;if("button"in p&&p.button>0)return;if(n.isTouched&&n.isMoved)return;const m=!!o.noSwipingClass&&""!==o.noSwipingClass,h=e.composedPath?e.composedPath():e.path;m&&p.target&&p.target.shadowRoot&&h&&(u=h[0]);const f=o.noSwipingSelector?o.noSwipingSelector:`.${o.noSwipingClass}`,g=!(!p.target||!p.target.shadowRoot);if(o.noSwiping&&(g?function(e,t){return void 0===t&&(t=this),function t(s){if(!s||s===a()||s===r())return null;s.assignedSlot&&(s=s.assignedSlot);const i=s.closest(e);return i||s.getRootNode?i||t(s.getRootNode().host):null}(t)}(f,u):u.closest(f)))return void(t.allowClick=!0);if(o.swipeHandler&&!u.closest(o.swipeHandler))return;d.currentX=p.pageX,d.currentY=p.pageY;const v=d.currentX,w=d.currentY,b=o.edgeSwipeDetection||o.iOSEdgeSwipeDetection,y=o.edgeSwipeThreshold||o.iOSEdgeSwipeThreshold;if(b&&(v<=y||v>=i.innerWidth-y)){if("prevent"!==b)return;e.preventDefault()}Object.assign(n,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),d.startX=v,d.startY=w,n.touchStartTime=l(),t.allowClick=!0,t.updateSize(),t.swipeDirection=void 0,o.threshold>0&&(n.allowThresholdMove=!1);let E=!0;u.matches(n.focusableElements)&&(E=!1,"SELECT"===u.nodeName&&(n.isTouched=!1)),s.activeElement&&s.activeElement.matches(n.focusableElements)&&s.activeElement!==u&&s.activeElement.blur();const x=E&&t.allowTouchMove&&o.touchStartPreventDefault;!o.touchStartForcePreventDefault&&!x||u.isContentEditable||p.preventDefault(),t.params.freeMode&&t.params.freeMode.enabled&&t.freeMode&&t.animating&&!o.cssMode&&t.freeMode.onTouchStart(),t.emit("touchStart",p)}function G(e){const t=a(),s=this,i=s.touchEventsData,{params:r,touches:n,rtlTranslate:o,enabled:d}=s;if(!d)return;if(!r.simulateTouch&&"mouse"===e.pointerType)return;let c=e;if(c.originalEvent&&(c=c.originalEvent),!i.isTouched)return void(i.startMoving&&i.isScrolling&&s.emit("touchMoveOpposite",c));const p=i.evCache.findIndex((e=>e.pointerId===c.pointerId));p>=0&&(i.evCache[p]=c);const u=i.evCache.length>1?i.evCache[0]:c,m=u.pageX,h=u.pageY;if(c.preventedByNestedSwiper)return n.startX=m,void(n.startY=h);if(!s.allowTouchMove)return c.target.matches(i.focusableElements)||(s.allowClick=!1),void(i.isTouched&&(Object.assign(n,{startX:m,startY:h,prevX:s.touches.currentX,prevY:s.touches.currentY,currentX:m,currentY:h}),i.touchStartTime=l()));if(r.touchReleaseOnEdges&&!r.loop)if(s.isVertical()){if(h<n.startY&&s.translate<=s.maxTranslate()||h>n.startY&&s.translate>=s.minTranslate())return i.isTouched=!1,void(i.isMoved=!1)}else if(m<n.startX&&s.translate<=s.maxTranslate()||m>n.startX&&s.translate>=s.minTranslate())return;if(t.activeElement&&c.target===t.activeElement&&c.target.matches(i.focusableElements))return i.isMoved=!0,void(s.allowClick=!1);if(i.allowTouchCallbacks&&s.emit("touchMove",c),c.targetTouches&&c.targetTouches.length>1)return;n.currentX=m,n.currentY=h;const f=n.currentX-n.startX,g=n.currentY-n.startY;if(s.params.threshold&&Math.sqrt(f**2+g**2)<s.params.threshold)return;if(void 0===i.isScrolling){let e;s.isHorizontal()&&n.currentY===n.startY||s.isVertical()&&n.currentX===n.startX?i.isScrolling=!1:f*f+g*g>=25&&(e=180*Math.atan2(Math.abs(g),Math.abs(f))/Math.PI,i.isScrolling=s.isHorizontal()?e>r.touchAngle:90-e>r.touchAngle)}if(i.isScrolling&&s.emit("touchMoveOpposite",c),void 0===i.startMoving&&(n.currentX===n.startX&&n.currentY===n.startY||(i.startMoving=!0)),i.isScrolling||s.zoom&&s.params.zoom&&s.params.zoom.enabled&&i.evCache.length>1)return void(i.isTouched=!1);if(!i.startMoving)return;s.allowClick=!1,!r.cssMode&&c.cancelable&&c.preventDefault(),r.touchMoveStopPropagation&&!r.nested&&c.stopPropagation();let v=s.isHorizontal()?f:g,w=s.isHorizontal()?n.currentX-n.previousX:n.currentY-n.previousY;r.oneWayMovement&&(v=Math.abs(v)*(o?1:-1),w=Math.abs(w)*(o?1:-1)),n.diff=v,v*=r.touchRatio,o&&(v=-v,w=-w);const b=s.touchesDirection;s.swipeDirection=v>0?"prev":"next",s.touchesDirection=w>0?"prev":"next";const y=s.params.loop&&!r.cssMode;if(!i.isMoved){if(y&&s.loopFix({direction:s.swipeDirection}),i.startTranslate=s.getTranslate(),s.setTransition(0),s.animating){const e=new window.CustomEvent("transitionend",{bubbles:!0,cancelable:!0});s.wrapperEl.dispatchEvent(e)}i.allowMomentumBounce=!1,!r.grabCursor||!0!==s.allowSlideNext&&!0!==s.allowSlidePrev||s.setGrabCursor(!0),s.emit("sliderFirstMove",c)}let E;i.isMoved&&b!==s.touchesDirection&&y&&Math.abs(v)>=1&&(s.loopFix({direction:s.swipeDirection,setTranslate:!0}),E=!0),s.emit("sliderMove",c),i.isMoved=!0,i.currentTranslate=v+i.startTranslate;let x=!0,S=r.resistanceRatio;if(r.touchReleaseOnEdges&&(S=0),v>0?(y&&!E&&i.currentTranslate>(r.centeredSlides?s.minTranslate()-s.size/2:s.minTranslate())&&s.loopFix({direction:"prev",setTranslate:!0,activeSlideIndex:0}),i.currentTranslate>s.minTranslate()&&(x=!1,r.resistance&&(i.currentTranslate=s.minTranslate()-1+(-s.minTranslate()+i.startTranslate+v)**S))):v<0&&(y&&!E&&i.currentTranslate<(r.centeredSlides?s.maxTranslate()+s.size/2:s.maxTranslate())&&s.loopFix({direction:"next",setTranslate:!0,activeSlideIndex:s.slides.length-("auto"===r.slidesPerView?s.slidesPerViewDynamic():Math.ceil(parseFloat(r.slidesPerView,10)))}),i.currentTranslate<s.maxTranslate()&&(x=!1,r.resistance&&(i.currentTranslate=s.maxTranslate()+1-(s.maxTranslate()-i.startTranslate-v)**S))),x&&(c.preventedByNestedSwiper=!0),!s.allowSlideNext&&"next"===s.swipeDirection&&i.currentTranslate<i.startTranslate&&(i.currentTranslate=i.startTranslate),!s.allowSlidePrev&&"prev"===s.swipeDirection&&i.currentTranslate>i.startTranslate&&(i.currentTranslate=i.startTranslate),s.allowSlidePrev||s.allowSlideNext||(i.currentTranslate=i.startTranslate),r.threshold>0){if(!(Math.abs(v)>r.threshold||i.allowThresholdMove))return void(i.currentTranslate=i.startTranslate);if(!i.allowThresholdMove)return i.allowThresholdMove=!0,n.startX=n.currentX,n.startY=n.currentY,i.currentTranslate=i.startTranslate,void(n.diff=s.isHorizontal()?n.currentX-n.startX:n.currentY-n.startY)}r.followFinger&&!r.cssMode&&((r.freeMode&&r.freeMode.enabled&&s.freeMode||r.watchSlidesProgress)&&(s.updateActiveIndex(),s.updateSlidesClasses()),s.params.freeMode&&r.freeMode.enabled&&s.freeMode&&s.freeMode.onTouchMove(),s.updateProgress(i.currentTranslate),s.setTranslate(i.currentTranslate))}function B(e){const t=this,s=t.touchEventsData,a=s.evCache.findIndex((t=>t.pointerId===e.pointerId));if(a>=0&&s.evCache.splice(a,1),["pointercancel","pointerout","pointerleave"].includes(e.type))return;const{params:i,touches:r,rtlTranslate:o,slidesGrid:d,enabled:c}=t;if(!c)return;if(!i.simulateTouch&&"mouse"===e.pointerType)return;let p=e;if(p.originalEvent&&(p=p.originalEvent),s.allowTouchCallbacks&&t.emit("touchEnd",p),s.allowTouchCallbacks=!1,!s.isTouched)return s.isMoved&&i.grabCursor&&t.setGrabCursor(!1),s.isMoved=!1,void(s.startMoving=!1);i.grabCursor&&s.isMoved&&s.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);const u=l(),m=u-s.touchStartTime;if(t.allowClick){const e=p.path||p.composedPath&&p.composedPath();t.updateClickedSlide(e&&e[0]||p.target),t.emit("tap click",p),m<300&&u-s.lastClickTime<300&&t.emit("doubleTap doubleClick",p)}if(s.lastClickTime=l(),n((()=>{t.destroyed||(t.allowClick=!0)})),!s.isTouched||!s.isMoved||!t.swipeDirection||0===r.diff||s.currentTranslate===s.startTranslate)return s.isTouched=!1,s.isMoved=!1,void(s.startMoving=!1);let h;if(s.isTouched=!1,s.isMoved=!1,s.startMoving=!1,h=i.followFinger?o?t.translate:-t.translate:-s.currentTranslate,i.cssMode)return;if(t.params.freeMode&&i.freeMode.enabled)return void t.freeMode.onTouchEnd({currentPos:h});let f=0,g=t.slidesSizesGrid[0];for(let e=0;e<d.length;e+=e<i.slidesPerGroupSkip?1:i.slidesPerGroup){const t=e<i.slidesPerGroupSkip-1?1:i.slidesPerGroup;void 0!==d[e+t]?h>=d[e]&&h<d[e+t]&&(f=e,g=d[e+t]-d[e]):h>=d[e]&&(f=e,g=d[d.length-1]-d[d.length-2])}let v=null,w=null;i.rewind&&(t.isBeginning?w=t.params.virtual&&t.params.virtual.enabled&&t.virtual?t.virtual.slides.length-1:t.slides.length-1:t.isEnd&&(v=0));const b=(h-d[f])/g,y=f<i.slidesPerGroupSkip-1?1:i.slidesPerGroup;if(m>i.longSwipesMs){if(!i.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(b>=i.longSwipesRatio?t.slideTo(i.rewind&&t.isEnd?v:f+y):t.slideTo(f)),"prev"===t.swipeDirection&&(b>1-i.longSwipesRatio?t.slideTo(f+y):null!==w&&b<0&&Math.abs(b)>i.longSwipesRatio?t.slideTo(w):t.slideTo(f))}else{if(!i.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(p.target===t.navigation.nextEl||p.target===t.navigation.prevEl)?p.target===t.navigation.nextEl?t.slideTo(f+y):t.slideTo(f):("next"===t.swipeDirection&&t.slideTo(null!==v?v:f+y),"prev"===t.swipeDirection&&t.slideTo(null!==w?w:f))}}let H;function X(){const e=this,{params:t,el:s}=e;if(s&&0===s.offsetWidth)return;t.breakpoints&&e.setBreakpoint();const{allowSlideNext:a,allowSlidePrev:i,snapGrid:r}=e,n=e.virtual&&e.params.virtual.enabled;e.allowSlideNext=!0,e.allowSlidePrev=!0,e.updateSize(),e.updateSlides(),e.updateSlidesClasses();const l=n&&t.loop;!("auto"===t.slidesPerView||t.slidesPerView>1)||!e.isEnd||e.isBeginning||e.params.centeredSlides||l?e.params.loop&&!n?e.slideToLoop(e.realIndex,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0):e.slideTo(e.slides.length-1,0,!1,!0),e.autoplay&&e.autoplay.running&&e.autoplay.paused&&(clearTimeout(H),H=setTimeout((()=>{e.autoplay.resume()}),500)),e.allowSlidePrev=i,e.allowSlideNext=a,e.params.watchOverflow&&r!==e.snapGrid&&e.checkOverflow()}function Y(e){const t=this;t.enabled&&(t.allowClick||(t.params.preventClicks&&e.preventDefault(),t.params.preventClicksPropagation&&t.animating&&(e.stopPropagation(),e.stopImmediatePropagation())))}function N(){const e=this,{wrapperEl:t,rtlTranslate:s,enabled:a}=e;if(!a)return;let i;e.previousTranslate=e.translate,e.isHorizontal()?e.translate=-t.scrollLeft:e.translate=-t.scrollTop,0===e.translate&&(e.translate=0),e.updateActiveIndex(),e.updateSlidesClasses();const r=e.maxTranslate()-e.minTranslate();i=0===r?0:(e.translate-e.minTranslate())/r,i!==e.progress&&e.updateProgress(s?-e.translate:e.translate),e.emit("setTranslate",e.translate,!1)}const R=(e,t)=>{if(!e||e.destroyed||!e.params)return;const s=t.closest(e.isElement?"swiper-slide":`.${e.params.slideClass}`);if(s){const t=s.querySelector(`.${e.params.lazyPreloaderClass}`);t&&t.remove()}};function q(e){R(this,e.target),this.update()}let V=!1;function F(){}const W=(e,t)=>{const s=a(),{params:i,el:r,wrapperEl:n,device:l}=e,o=!!i.nested,d="on"===t?"addEventListener":"removeEventListener",c=t;r[d]("pointerdown",e.onTouchStart,{passive:!1}),s[d]("pointermove",e.onTouchMove,{passive:!1,capture:o}),s[d]("pointerup",e.onTouchEnd,{passive:!0}),s[d]("pointercancel",e.onTouchEnd,{passive:!0}),s[d]("pointerout",e.onTouchEnd,{passive:!0}),s[d]("pointerleave",e.onTouchEnd,{passive:!0}),(i.preventClicks||i.preventClicksPropagation)&&r[d]("click",e.onClick,!0),i.cssMode&&n[d]("scroll",e.onScroll),i.updateOnWindowResize?e[c](l.ios||l.android?"resize orientationchange observerUpdate":"resize observerUpdate",X,!0):e[c]("observerUpdate",X,!0),r[d]("load",e.onLoad,{capture:!0})};const j=(e,t)=>e.grid&&t.grid&&t.grid.rows>1;var _={init:!0,direction:"horizontal",oneWayMovement:!1,touchEventsTarget:"wrapper",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,resizeObserver:!0,nested:!1,createElements:!1,enabled:!0,focusableElements:"input, select, option, textarea, button, video, label",width:null,height:null,preventInteractionOnTransition:!1,userAgent:null,url:null,edgeSwipeDetection:!1,edgeSwipeThreshold:20,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsBase:"window",spaceBetween:0,slidesPerView:1,slidesPerGroup:1,slidesPerGroupSkip:0,slidesPerGroupAuto:!1,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!0,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:5,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,loop:!1,loopedSlides:null,loopPreventsSliding:!0,rewind:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,maxBackfaceHiddenSlides:10,containerModifierClass:"swiper-",slideClass:"swiper-slide",slideActiveClass:"swiper-slide-active",slideVisibleClass:"swiper-slide-visible",slideNextClass:"swiper-slide-next",slidePrevClass:"swiper-slide-prev",wrapperClass:"swiper-wrapper",lazyPreloaderClass:"swiper-lazy-preloader",runCallbacksOnInit:!0,_emitClasses:!1};function U(e,t){return function(s){void 0===s&&(s={});const a=Object.keys(s)[0],i=s[a];"object"==typeof i&&null!==i?(["navigation","pagination","scrollbar"].indexOf(a)>=0&&!0===e[a]&&(e[a]={auto:!0}),a in e&&"enabled"in i?(!0===e[a]&&(e[a]={enabled:!0}),"object"!=typeof e[a]||"enabled"in e[a]||(e[a].enabled=!0),e[a]||(e[a]={enabled:!1}),p(t,s)):p(t,s)):p(t,s)}}const K={eventsEmitter:A,update:z,translate:$,transition:{setTransition:function(e,t){const s=this;s.params.cssMode||(s.wrapperEl.style.transitionDuration=`${e}ms`),s.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);const s=this,{params:a}=s;a.cssMode||(a.autoHeight&&s.updateAutoHeight(),k({swiper:s,runCallbacks:e,direction:t,step:"Start"}))},transitionEnd:function(e,t){void 0===e&&(e=!0);const s=this,{params:a}=s;s.animating=!1,a.cssMode||(s.setTransition(0),k({swiper:s,runCallbacks:e,direction:t,step:"End"}))}},slide:I,loop:O,grabCursor:{setGrabCursor:function(e){const t=this;if(!t.params.simulateTouch||t.params.watchOverflow&&t.isLocked||t.params.cssMode)return;const s="container"===t.params.touchEventsTarget?t.el:t.wrapperEl;s.style.cursor="move",s.style.cursor=e?"grabbing":"grab"},unsetGrabCursor:function(){const e=this;e.params.watchOverflow&&e.isLocked||e.params.cssMode||(e["container"===e.params.touchEventsTarget?"el":"wrapperEl"].style.cursor="")}},events:{attachEvents:function(){const e=this,t=a(),{params:s}=e;e.onTouchStart=D.bind(e),e.onTouchMove=G.bind(e),e.onTouchEnd=B.bind(e),s.cssMode&&(e.onScroll=N.bind(e)),e.onClick=Y.bind(e),e.onLoad=q.bind(e),V||(t.addEventListener("touchstart",F),V=!0),W(e,"on")},detachEvents:function(){W(this,"off")}},breakpoints:{setBreakpoint:function(){const e=this,{realIndex:t,initialized:s,params:a,el:i}=e,r=a.breakpoints;if(!r||r&&0===Object.keys(r).length)return;const n=e.getBreakpoint(r,e.params.breakpointsBase,e.el);if(!n||e.currentBreakpoint===n)return;const l=(n in r?r[n]:void 0)||e.originalParams,o=j(e,a),d=j(e,l),c=a.enabled;o&&!d?(i.classList.remove(`${a.containerModifierClass}grid`,`${a.containerModifierClass}grid-column`),e.emitContainerClasses()):!o&&d&&(i.classList.add(`${a.containerModifierClass}grid`),(l.grid.fill&&"column"===l.grid.fill||!l.grid.fill&&"column"===a.grid.fill)&&i.classList.add(`${a.containerModifierClass}grid-column`),e.emitContainerClasses()),["navigation","pagination","scrollbar"].forEach((t=>{const s=a[t]&&a[t].enabled,i=l[t]&&l[t].enabled;s&&!i&&e[t].disable(),!s&&i&&e[t].enable()}));const u=l.direction&&l.direction!==a.direction,m=a.loop&&(l.slidesPerView!==a.slidesPerView||u);u&&s&&e.changeDirection(),p(e.params,l);const h=e.params.enabled;Object.assign(e,{allowTouchMove:e.params.allowTouchMove,allowSlideNext:e.params.allowSlideNext,allowSlidePrev:e.params.allowSlidePrev}),c&&!h?e.disable():!c&&h&&e.enable(),e.currentBreakpoint=n,e.emit("_beforeBreakpoint",l),m&&s&&(e.loopDestroy(),e.loopCreate(t),e.updateSlides()),e.emit("breakpoint",l)},getBreakpoint:function(e,t,s){if(void 0===t&&(t="window"),!e||"container"===t&&!s)return;let a=!1;const i=r(),n="window"===t?i.innerHeight:s.clientHeight,l=Object.keys(e).map((e=>{if("string"==typeof e&&0===e.indexOf("@")){const t=parseFloat(e.substr(1));return{value:n*t,point:e}}return{value:e,point:e}}));l.sort(((e,t)=>parseInt(e.value,10)-parseInt(t.value,10)));for(let e=0;e<l.length;e+=1){const{point:r,value:n}=l[e];"window"===t?i.matchMedia(`(min-width: ${n}px)`).matches&&(a=r):n<=s.clientWidth&&(a=r)}return a||"max"}},checkOverflow:{checkOverflow:function(){const e=this,{isLocked:t,params:s}=e,{slidesOffsetBefore:a}=s;if(a){const t=e.slides.length-1,s=e.slidesGrid[t]+e.slidesSizesGrid[t]+2*a;e.isLocked=e.size>s}else e.isLocked=1===e.snapGrid.length;!0===s.allowSlideNext&&(e.allowSlideNext=!e.isLocked),!0===s.allowSlidePrev&&(e.allowSlidePrev=!e.isLocked),t&&t!==e.isLocked&&(e.isEnd=!1),t!==e.isLocked&&e.emit(e.isLocked?"lock":"unlock")}},classes:{addClasses:function(){const e=this,{classNames:t,params:s,rtl:a,el:i,device:r}=e,n=function(e,t){const s=[];return e.forEach((e=>{"object"==typeof e?Object.keys(e).forEach((a=>{e[a]&&s.push(t+a)})):"string"==typeof e&&s.push(t+e)})),s}(["initialized",s.direction,{"free-mode":e.params.freeMode&&s.freeMode.enabled},{autoheight:s.autoHeight},{rtl:a},{grid:s.grid&&s.grid.rows>1},{"grid-column":s.grid&&s.grid.rows>1&&"column"===s.grid.fill},{android:r.android},{ios:r.ios},{"css-mode":s.cssMode},{centered:s.cssMode&&s.centeredSlides},{"watch-progress":s.watchSlidesProgress}],s.containerModifierClass);t.push(...n),i.classList.add(...t),e.emitContainerClasses()},removeClasses:function(){const{el:e,classNames:t}=this;e.classList.remove(...t),this.emitContainerClasses()}}},Z={};class Q{constructor(){let e,t;for(var s=arguments.length,i=new Array(s),r=0;r<s;r++)i[r]=arguments[r];1===i.length&&i[0].constructor&&"Object"===Object.prototype.toString.call(i[0]).slice(8,-1)?t=i[0]:[e,t]=i,t||(t={}),t=p({},t),e&&!t.el&&(t.el=e);const n=a();if(t.el&&"string"==typeof t.el&&n.querySelectorAll(t.el).length>1){const e=[];return n.querySelectorAll(t.el).forEach((s=>{const a=p({},t,{el:s});e.push(new Q(a))})),e}const o=this;o.__swiper__=!0,o.support=C(),o.device=P({userAgent:t.userAgent}),o.browser=L(),o.eventsListeners={},o.eventsAnyListeners=[],o.modules=[...o.__modules__],t.modules&&Array.isArray(t.modules)&&o.modules.push(...t.modules);const d={};o.modules.forEach((e=>{e({params:t,swiper:o,extendParams:U(t,d),on:o.on.bind(o),once:o.once.bind(o),off:o.off.bind(o),emit:o.emit.bind(o)})}));const c=p({},_,d);return o.params=p({},c,Z,t),o.originalParams=p({},o.params),o.passedParams=p({},t),o.params&&o.params.on&&Object.keys(o.params.on).forEach((e=>{o.on(e,o.params.on[e])})),o.params&&o.params.onAny&&o.onAny(o.params.onAny),Object.assign(o,{enabled:o.params.enabled,el:e,classNames:[],slides:[],slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:()=>"horizontal"===o.params.direction,isVertical:()=>"vertical"===o.params.direction,activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,allowSlideNext:o.params.allowSlideNext,allowSlidePrev:o.params.allowSlidePrev,touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,focusableElements:o.params.focusableElements,lastClickTime:l(),clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,startMoving:void 0,evCache:[]},allowClick:!0,allowTouchMove:o.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),o.emit("_swiper"),o.params.init&&o.init(),o}recalcSlides(){const{slidesEl:e,params:t}=this;this.slides=f(e,`.${t.slideClass}, swiper-slide`)}enable(){const e=this;e.enabled||(e.enabled=!0,e.params.grabCursor&&e.setGrabCursor(),e.emit("enable"))}disable(){const e=this;e.enabled&&(e.enabled=!1,e.params.grabCursor&&e.unsetGrabCursor(),e.emit("disable"))}setProgress(e,t){const s=this;e=Math.min(Math.max(e,0),1);const a=s.minTranslate(),i=(s.maxTranslate()-a)*e+a;s.translateTo(i,void 0===t?0:t),s.updateActiveIndex(),s.updateSlidesClasses()}emitContainerClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=e.el.className.split(" ").filter((t=>0===t.indexOf("swiper")||0===t.indexOf(e.params.containerModifierClass)));e.emit("_containerClasses",t.join(" "))}getSlideClasses(e){const t=this;return t.destroyed?"":e.className.split(" ").filter((e=>0===e.indexOf("swiper-slide")||0===e.indexOf(t.params.slideClass))).join(" ")}emitSlidesClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=[];e.slides.forEach((s=>{const a=e.getSlideClasses(s);t.push({slideEl:s,classNames:a}),e.emit("_slideClass",s,a)})),e.emit("_slideClasses",t)}slidesPerViewDynamic(e,t){void 0===e&&(e="current"),void 0===t&&(t=!1);const{params:s,slides:a,slidesGrid:i,slidesSizesGrid:r,size:n,activeIndex:l}=this;let o=1;if(s.centeredSlides){let e,t=a[l].swiperSlideSize;for(let s=l+1;s<a.length;s+=1)a[s]&&!e&&(t+=a[s].swiperSlideSize,o+=1,t>n&&(e=!0));for(let s=l-1;s>=0;s-=1)a[s]&&!e&&(t+=a[s].swiperSlideSize,o+=1,t>n&&(e=!0))}else if("current"===e)for(let e=l+1;e<a.length;e+=1){(t?i[e]+r[e]-i[l]<n:i[e]-i[l]<n)&&(o+=1)}else for(let e=l-1;e>=0;e-=1){i[l]-i[e]<n&&(o+=1)}return o}update(){const e=this;if(!e||e.destroyed)return;const{snapGrid:t,params:s}=e;function a(){const t=e.rtlTranslate?-1*e.translate:e.translate,s=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(s),e.updateActiveIndex(),e.updateSlidesClasses()}let i;s.breakpoints&&e.setBreakpoint(),[...e.el.querySelectorAll('[loading="lazy"]')].forEach((t=>{t.complete&&R(e,t)})),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),e.params.freeMode&&e.params.freeMode.enabled?(a(),e.params.autoHeight&&e.updateAutoHeight()):(i=("auto"===e.params.slidesPerView||e.params.slidesPerView>1)&&e.isEnd&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0),i||a()),s.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}changeDirection(e,t){void 0===t&&(t=!0);const s=this,a=s.params.direction;return e||(e="horizontal"===a?"vertical":"horizontal"),e===a||"horizontal"!==e&&"vertical"!==e||(s.el.classList.remove(`${s.params.containerModifierClass}${a}`),s.el.classList.add(`${s.params.containerModifierClass}${e}`),s.emitContainerClasses(),s.params.direction=e,s.slides.forEach((t=>{"vertical"===e?t.style.width="":t.style.height=""})),s.emit("changeDirection"),t&&s.update()),s}changeLanguageDirection(e){const t=this;t.rtl&&"rtl"===e||!t.rtl&&"ltr"===e||(t.rtl="rtl"===e,t.rtlTranslate="horizontal"===t.params.direction&&t.rtl,t.rtl?(t.el.classList.add(`${t.params.containerModifierClass}rtl`),t.el.dir="rtl"):(t.el.classList.remove(`${t.params.containerModifierClass}rtl`),t.el.dir="ltr"),t.update())}mount(e){const t=this;if(t.mounted)return!0;let s=e||t.params.el;if("string"==typeof s&&(s=document.querySelector(s)),!s)return!1;s.swiper=t,s.shadowEl&&(t.isElement=!0);const a=()=>`.${(t.params.wrapperClass||"").trim().split(" ").join(".")}`;let i=(()=>{if(s&&s.shadowRoot&&s.shadowRoot.querySelector){return s.shadowRoot.querySelector(a())}return f(s,a())[0]})();return!i&&t.params.createElements&&(i=g("div",t.params.wrapperClass),s.append(i),f(s,`.${t.params.slideClass}`).forEach((e=>{i.append(e)}))),Object.assign(t,{el:s,wrapperEl:i,slidesEl:t.isElement?s:i,mounted:!0,rtl:"rtl"===s.dir.toLowerCase()||"rtl"===w(s,"direction"),rtlTranslate:"horizontal"===t.params.direction&&("rtl"===s.dir.toLowerCase()||"rtl"===w(s,"direction")),wrongRTL:"-webkit-box"===w(i,"display")}),!0}init(e){const t=this;if(t.initialized)return t;return!1===t.mount(e)||(t.emit("beforeInit"),t.params.breakpoints&&t.setBreakpoint(),t.addClasses(),t.updateSize(),t.updateSlides(),t.params.watchOverflow&&t.checkOverflow(),t.params.grabCursor&&t.enabled&&t.setGrabCursor(),t.params.loop&&t.virtual&&t.params.virtual.enabled?t.slideTo(t.params.initialSlide+t.virtual.slidesBefore,0,t.params.runCallbacksOnInit,!1,!0):t.slideTo(t.params.initialSlide,0,t.params.runCallbacksOnInit,!1,!0),t.params.loop&&t.loopCreate(),t.attachEvents(),[...t.el.querySelectorAll('[loading="lazy"]')].forEach((e=>{e.complete?R(t,e):e.addEventListener("load",(e=>{R(t,e.target)}))})),t.initialized=!0,t.emit("init"),t.emit("afterInit")),t}destroy(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);const s=this,{params:a,el:i,wrapperEl:r,slides:n}=s;return void 0===s.params||s.destroyed||(s.emit("beforeDestroy"),s.initialized=!1,s.detachEvents(),a.loop&&s.loopDestroy(),t&&(s.removeClasses(),i.removeAttribute("style"),r.removeAttribute("style"),n&&n.length&&n.forEach((e=>{e.classList.remove(a.slideVisibleClass,a.slideActiveClass,a.slideNextClass,a.slidePrevClass),e.removeAttribute("style"),e.removeAttribute("data-swiper-slide-index")}))),s.emit("destroy"),Object.keys(s.eventsListeners).forEach((e=>{s.off(e)})),!1!==e&&(s.el.swiper=null,function(e){const t=e;Object.keys(t).forEach((e=>{try{t[e]=null}catch(e){}try{delete t[e]}catch(e){}}))}(s)),s.destroyed=!0),null}static extendDefaults(e){p(Z,e)}static get extendedDefaults(){return Z}static get defaults(){return _}static installModule(e){Q.prototype.__modules__||(Q.prototype.__modules__=[]);const t=Q.prototype.__modules__;"function"==typeof e&&t.indexOf(e)<0&&t.push(e)}static use(e){return Array.isArray(e)?(e.forEach((e=>Q.installModule(e))),Q):(Q.installModule(e),Q)}}function J(e,t,s,a){return e.params.createElements&&Object.keys(a).forEach((i=>{if(!s[i]&&!0===s.auto){let r=f(e.el,`.${a[i]}`)[0];r||(r=g("div",a[i]),r.className=a[i],e.el.append(r)),s[i]=r,t[i]=r}})),s}function ee(e){return void 0===e&&(e=""),`.${e.trim().replace(/([\.:!\/])/g,"\\$1").replace(/ /g,".")}`}function te(e){const t=this,{params:s,slidesEl:a}=t;s.loop&&t.loopDestroy();const i=e=>{if("string"==typeof e){const t=document.createElement("div");t.innerHTML=e,a.append(t.children[0]),t.innerHTML=""}else a.append(e)};if("object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&i(e[t]);else i(e);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update()}function se(e){const t=this,{params:s,activeIndex:a,slidesEl:i}=t;s.loop&&t.loopDestroy();let r=a+1;const n=e=>{if("string"==typeof e){const t=document.createElement("div");t.innerHTML=e,i.prepend(t.children[0]),t.innerHTML=""}else i.prepend(e)};if("object"==typeof e&&"length"in e){for(let t=0;t<e.length;t+=1)e[t]&&n(e[t]);r=a+e.length}else n(e);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update(),t.slideTo(r,0,!1)}function ae(e,t){const s=this,{params:a,activeIndex:i,slidesEl:r}=s;let n=i;a.loop&&(n-=s.loopedSlides,s.loopDestroy(),s.recalcSlides());const l=s.slides.length;if(e<=0)return void s.prependSlide(t);if(e>=l)return void s.appendSlide(t);let o=n>e?n+1:n;const d=[];for(let t=l-1;t>=e;t-=1){const e=s.slides[t];e.remove(),d.unshift(e)}if("object"==typeof t&&"length"in t){for(let e=0;e<t.length;e+=1)t[e]&&r.append(t[e]);o=n>e?n+t.length:n}else r.append(t);for(let e=0;e<d.length;e+=1)r.append(d[e]);s.recalcSlides(),a.loop&&s.loopCreate(),a.observer&&!s.isElement||s.update(),a.loop?s.slideTo(o+s.loopedSlides,0,!1):s.slideTo(o,0,!1)}function ie(e){const t=this,{params:s,activeIndex:a}=t;let i=a;s.loop&&(i-=t.loopedSlides,t.loopDestroy());let r,n=i;if("object"==typeof e&&"length"in e){for(let s=0;s<e.length;s+=1)r=e[s],t.slides[r]&&t.slides[r].remove(),r<n&&(n-=1);n=Math.max(n,0)}else r=e,t.slides[r]&&t.slides[r].remove(),r<n&&(n-=1),n=Math.max(n,0);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update(),s.loop?t.slideTo(n+t.loopedSlides,0,!1):t.slideTo(n,0,!1)}function re(){const e=this,t=[];for(let s=0;s<e.slides.length;s+=1)t.push(s);e.removeSlide(t)}function ne(e){const{effect:t,swiper:s,on:a,setTranslate:i,setTransition:r,overwriteParams:n,perspective:l,recreateShadows:o,getEffectParams:d}=e;let c;a("beforeInit",(()=>{if(s.params.effect!==t)return;s.classNames.push(`${s.params.containerModifierClass}${t}`),l&&l()&&s.classNames.push(`${s.params.containerModifierClass}3d`);const e=n?n():{};Object.assign(s.params,e),Object.assign(s.originalParams,e)})),a("setTranslate",(()=>{s.params.effect===t&&i()})),a("setTransition",((e,a)=>{s.params.effect===t&&r(a)})),a("transitionEnd",(()=>{if(s.params.effect===t&&o){if(!d||!d().slideShadows)return;s.slides.forEach((e=>{e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e=>e.remove()))})),o()}})),a("virtualUpdate",(()=>{s.params.effect===t&&(s.slides.length||(c=!0),requestAnimationFrame((()=>{c&&s.slides&&s.slides.length&&(i(),c=!1)})))}))}function le(e,t){const s=h(t);return s!==t&&(s.style.backfaceVisibility="hidden",s.style["-webkit-backface-visibility"]="hidden"),s}function oe(e){let{swiper:t,duration:s,transformElements:a,allSlides:i}=e;const{activeIndex:r}=t;if(t.params.virtualTranslate&&0!==s){let e,s=!1;e=i?a:a.filter((e=>b(e.classList.contains("swiper-slide-transform")?(e=>{if(!e.parentElement)return t.slides.filter((t=>t.shadowEl&&t.shadowEl===e.parentNode))[0];return e.parentElement})(e):e)===r)),e.forEach((e=>{E(e,(()=>{if(s)return;if(!t||t.destroyed)return;s=!0,t.animating=!1;const e=new window.CustomEvent("transitionend",{bubbles:!0,cancelable:!0});t.wrapperEl.dispatchEvent(e)}))}))}}function de(e,t,s){const a="swiper-slide-shadow"+(s?`-${s}`:""),i=h(t);let r=i.querySelector(`.${a}`);return r||(r=g("div","swiper-slide-shadow"+(s?`-${s}`:"")),i.append(r)),r}Object.keys(K).forEach((e=>{Object.keys(K[e]).forEach((t=>{Q.prototype[t]=K[e][t]}))})),Q.use([function(e){let{swiper:t,on:s,emit:a}=e;const i=r();let n=null,l=null;const o=()=>{t&&!t.destroyed&&t.initialized&&(a("beforeResize"),a("resize"))},d=()=>{t&&!t.destroyed&&t.initialized&&a("orientationchange")};s("init",(()=>{t.params.resizeObserver&&void 0!==i.ResizeObserver?t&&!t.destroyed&&t.initialized&&(n=new ResizeObserver((e=>{l=i.requestAnimationFrame((()=>{const{width:s,height:a}=t;let i=s,r=a;e.forEach((e=>{let{contentBoxSize:s,contentRect:a,target:n}=e;n&&n!==t.el||(i=a?a.width:(s[0]||s).inlineSize,r=a?a.height:(s[0]||s).blockSize)})),i===s&&r===a||o()}))})),n.observe(t.el)):(i.addEventListener("resize",o),i.addEventListener("orientationchange",d))})),s("destroy",(()=>{l&&i.cancelAnimationFrame(l),n&&n.unobserve&&t.el&&(n.unobserve(t.el),n=null),i.removeEventListener("resize",o),i.removeEventListener("orientationchange",d)}))},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=[],l=r(),o=function(e,t){void 0===t&&(t={});const s=new(l.MutationObserver||l.WebkitMutationObserver)((e=>{if(1===e.length)return void i("observerUpdate",e[0]);const t=function(){i("observerUpdate",e[0])};l.requestAnimationFrame?l.requestAnimationFrame(t):l.setTimeout(t,0)}));s.observe(e,{attributes:void 0===t.attributes||t.attributes,childList:void 0===t.childList||t.childList,characterData:void 0===t.characterData||t.characterData}),n.push(s)};s({observer:!1,observeParents:!1,observeSlideChildren:!1}),a("init",(()=>{if(t.params.observer){if(t.params.observeParents){const e=y(t.el);for(let t=0;t<e.length;t+=1)o(e[t])}o(t.el,{childList:t.params.observeSlideChildren}),o(t.wrapperEl,{attributes:!1})}})),a("destroy",(()=>{n.forEach((e=>{e.disconnect()})),n.splice(0,n.length)}))}]);const ce=[function(e){let t,{swiper:s,extendParams:i,on:r,emit:n}=e;i({virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,renderExternalUpdate:!0,addSlidesBefore:0,addSlidesAfter:0}});const l=a();s.virtual={cache:{},from:void 0,to:void 0,slides:[],offset:0,slidesGrid:[]};const o=l.createElement("div");function d(e,t){const a=s.params.virtual;if(a.cache&&s.virtual.cache[t])return s.virtual.cache[t];let i;return a.renderSlide?(i=a.renderSlide.call(s,e,t),"string"==typeof i&&(o.innerHTML=i,i=o.children[0])):i=s.isElement?g("swiper-slide"):g("div",s.params.slideClass),i.setAttribute("data-swiper-slide-index",t),a.renderSlide||(i.textContent=e),a.cache&&(s.virtual.cache[t]=i),i}function c(e){const{slidesPerView:t,slidesPerGroup:a,centeredSlides:i,loop:r}=s.params,{addSlidesBefore:l,addSlidesAfter:o}=s.params.virtual,{from:c,to:p,slides:u,slidesGrid:m,offset:h}=s.virtual;s.params.cssMode||s.updateActiveIndex();const g=s.activeIndex||0;let v,w,b;v=s.rtlTranslate?"right":s.isHorizontal()?"left":"top",i?(w=Math.floor(t/2)+a+o,b=Math.floor(t/2)+a+l):(w=t+(a-1)+o,b=(r?t:a)+l);let y=g-b,E=g+w;r||(y=Math.max(y,0),E=Math.min(E,u.length-1));let x=(s.slidesGrid[y]||0)-(s.slidesGrid[0]||0);function S(){s.updateSlides(),s.updateProgress(),s.updateSlidesClasses(),n("virtualUpdate")}if(r&&g>=b?(y-=b,i||(x+=s.slidesGrid[0])):r&&g<b&&(y=-b,i&&(x+=s.slidesGrid[0])),Object.assign(s.virtual,{from:y,to:E,offset:x,slidesGrid:s.slidesGrid,slidesBefore:b,slidesAfter:w}),c===y&&p===E&&!e)return s.slidesGrid!==m&&x!==h&&s.slides.forEach((e=>{e.style[v]=`${x}px`})),s.updateProgress(),void n("virtualUpdate");if(s.params.virtual.renderExternal)return s.params.virtual.renderExternal.call(s,{offset:x,from:y,to:E,slides:function(){const e=[];for(let t=y;t<=E;t+=1)e.push(u[t]);return e}()}),void(s.params.virtual.renderExternalUpdate?S():n("virtualUpdate"));const T=[],M=[],C=e=>{let t=e;return e<0?t=u.length+e:t>=u.length&&(t-=u.length),t};if(e)s.slidesEl.querySelectorAll(`.${s.params.slideClass}, swiper-slide`).forEach((e=>{e.remove()}));else for(let e=c;e<=p;e+=1)if(e<y||e>E){const t=C(e);s.slidesEl.querySelectorAll(`.${s.params.slideClass}[data-swiper-slide-index="${t}"], swiper-slide[data-swiper-slide-index="${t}"]`).forEach((e=>{e.remove()}))}const P=r?-u.length:0,L=r?2*u.length:u.length;for(let t=P;t<L;t+=1)if(t>=y&&t<=E){const s=C(t);void 0===p||e?M.push(s):(t>p&&M.push(s),t<c&&T.push(s))}if(M.forEach((e=>{s.slidesEl.append(d(u[e],e))})),r)for(let e=T.length-1;e>=0;e-=1){const t=T[e];s.slidesEl.prepend(d(u[t],t))}else T.sort(((e,t)=>t-e)),T.forEach((e=>{s.slidesEl.prepend(d(u[e],e))}));f(s.slidesEl,".swiper-slide, swiper-slide").forEach((e=>{e.style[v]=`${x}px`})),S()}r("beforeInit",(()=>{if(!s.params.virtual.enabled)return;let e;if(void 0===s.passedParams.virtual.slides){const t=[...s.slidesEl.children].filter((e=>e.matches(`.${s.params.slideClass}, swiper-slide`)));t&&t.length&&(s.virtual.slides=[...t],e=!0,t.forEach(((e,t)=>{e.setAttribute("data-swiper-slide-index",t),s.virtual.cache[t]=e,e.remove()})))}e||(s.virtual.slides=s.params.virtual.slides),s.classNames.push(`${s.params.containerModifierClass}virtual`),s.params.watchSlidesProgress=!0,s.originalParams.watchSlidesProgress=!0,s.params.initialSlide||c()})),r("setTranslate",(()=>{s.params.virtual.enabled&&(s.params.cssMode&&!s._immediateVirtual?(clearTimeout(t),t=setTimeout((()=>{c()}),100)):c())})),r("init update resize",(()=>{s.params.virtual.enabled&&s.params.cssMode&&u(s.wrapperEl,"--swiper-virtual-size",`${s.virtualSize}px`)})),Object.assign(s.virtual,{appendSlide:function(e){if("object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.push(e[t]);else s.virtual.slides.push(e);c(!0)},prependSlide:function(e){const t=s.activeIndex;let a=t+1,i=1;if(Array.isArray(e)){for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.unshift(e[t]);a=t+e.length,i=e.length}else s.virtual.slides.unshift(e);if(s.params.virtual.cache){const e=s.virtual.cache,t={};Object.keys(e).forEach((s=>{const a=e[s],r=a.getAttribute("data-swiper-slide-index");r&&a.setAttribute("data-swiper-slide-index",parseInt(r,10)+i),t[parseInt(s,10)+i]=a})),s.virtual.cache=t}c(!0),s.slideTo(a,0)},removeSlide:function(e){if(null==e)return;let t=s.activeIndex;if(Array.isArray(e))for(let a=e.length-1;a>=0;a-=1)s.virtual.slides.splice(e[a],1),s.params.virtual.cache&&delete s.virtual.cache[e[a]],e[a]<t&&(t-=1),t=Math.max(t,0);else s.virtual.slides.splice(e,1),s.params.virtual.cache&&delete s.virtual.cache[e],e<t&&(t-=1),t=Math.max(t,0);c(!0),s.slideTo(t,0)},removeAllSlides:function(){s.virtual.slides=[],s.params.virtual.cache&&(s.virtual.cache={}),c(!0),s.slideTo(0,0)},update:c})},function(e){let{swiper:t,extendParams:s,on:i,emit:n}=e;const l=a(),o=r();function d(e){if(!t.enabled)return;const{rtlTranslate:s}=t;let a=e;a.originalEvent&&(a=a.originalEvent);const i=a.keyCode||a.charCode,r=t.params.keyboard.pageUpDown,d=r&&33===i,c=r&&34===i,p=37===i,u=39===i,m=38===i,h=40===i;if(!t.allowSlideNext&&(t.isHorizontal()&&u||t.isVertical()&&h||c))return!1;if(!t.allowSlidePrev&&(t.isHorizontal()&&p||t.isVertical()&&m||d))return!1;if(!(a.shiftKey||a.altKey||a.ctrlKey||a.metaKey||l.activeElement&&l.activeElement.nodeName&&("input"===l.activeElement.nodeName.toLowerCase()||"textarea"===l.activeElement.nodeName.toLowerCase()))){if(t.params.keyboard.onlyInViewport&&(d||c||p||u||m||h)){let e=!1;if(y(t.el,`.${t.params.slideClass}, swiper-slide`).length>0&&0===y(t.el,`.${t.params.slideActiveClass}`).length)return;const a=t.el,i=a.clientWidth,r=a.clientHeight,n=o.innerWidth,l=o.innerHeight,d=v(a);s&&(d.left-=a.scrollLeft);const c=[[d.left,d.top],[d.left+i,d.top],[d.left,d.top+r],[d.left+i,d.top+r]];for(let t=0;t<c.length;t+=1){const s=c[t];if(s[0]>=0&&s[0]<=n&&s[1]>=0&&s[1]<=l){if(0===s[0]&&0===s[1])continue;e=!0}}if(!e)return}t.isHorizontal()?((d||c||p||u)&&(a.preventDefault?a.preventDefault():a.returnValue=!1),((c||u)&&!s||(d||p)&&s)&&t.slideNext(),((d||p)&&!s||(c||u)&&s)&&t.slidePrev()):((d||c||m||h)&&(a.preventDefault?a.preventDefault():a.returnValue=!1),(c||h)&&t.slideNext(),(d||m)&&t.slidePrev()),n("keyPress",i)}}function c(){t.keyboard.enabled||(l.addEventListener("keydown",d),t.keyboard.enabled=!0)}function p(){t.keyboard.enabled&&(l.removeEventListener("keydown",d),t.keyboard.enabled=!1)}t.keyboard={enabled:!1},s({keyboard:{enabled:!1,onlyInViewport:!0,pageUpDown:!0}}),i("init",(()=>{t.params.keyboard.enabled&&c()})),i("destroy",(()=>{t.keyboard.enabled&&p()})),Object.assign(t.keyboard,{enable:c,disable:p})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const o=r();let d;s({mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarget:"container",thresholdDelta:null,thresholdTime:null}}),t.mousewheel={enabled:!1};let c,p=l();const u=[];function m(){t.enabled&&(t.mouseEntered=!0)}function h(){t.enabled&&(t.mouseEntered=!1)}function f(e){return!(t.params.mousewheel.thresholdDelta&&e.delta<t.params.mousewheel.thresholdDelta)&&(!(t.params.mousewheel.thresholdTime&&l()-p<t.params.mousewheel.thresholdTime)&&(e.delta>=6&&l()-p<60||(e.direction<0?t.isEnd&&!t.params.loop||t.animating||(t.slideNext(),i("scroll",e.raw)):t.isBeginning&&!t.params.loop||t.animating||(t.slidePrev(),i("scroll",e.raw)),p=(new o.Date).getTime(),!1)))}function g(e){let s=e,a=!0;if(!t.enabled)return;const r=t.params.mousewheel;t.params.cssMode&&s.preventDefault();let o=t.el;"container"!==t.params.mousewheel.eventsTarget&&(o=document.querySelector(t.params.mousewheel.eventsTarget));const p=o&&o.contains(s.target);if(!t.mouseEntered&&!p&&!r.releaseOnEdges)return!0;s.originalEvent&&(s=s.originalEvent);let m=0;const h=t.rtlTranslate?-1:1,g=function(e){let t=0,s=0,a=0,i=0;return"detail"in e&&(s=e.detail),"wheelDelta"in e&&(s=-e.wheelDelta/120),"wheelDeltaY"in e&&(s=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=s,s=0),a=10*t,i=10*s,"deltaY"in e&&(i=e.deltaY),"deltaX"in e&&(a=e.deltaX),e.shiftKey&&!a&&(a=i,i=0),(a||i)&&e.deltaMode&&(1===e.deltaMode?(a*=40,i*=40):(a*=800,i*=800)),a&&!t&&(t=a<1?-1:1),i&&!s&&(s=i<1?-1:1),{spinX:t,spinY:s,pixelX:a,pixelY:i}}(s);if(r.forceToAxis)if(t.isHorizontal()){if(!(Math.abs(g.pixelX)>Math.abs(g.pixelY)))return!0;m=-g.pixelX*h}else{if(!(Math.abs(g.pixelY)>Math.abs(g.pixelX)))return!0;m=-g.pixelY}else m=Math.abs(g.pixelX)>Math.abs(g.pixelY)?-g.pixelX*h:-g.pixelY;if(0===m)return!0;r.invert&&(m=-m);let v=t.getTranslate()+m*r.sensitivity;if(v>=t.minTranslate()&&(v=t.minTranslate()),v<=t.maxTranslate()&&(v=t.maxTranslate()),a=!!t.params.loop||!(v===t.minTranslate()||v===t.maxTranslate()),a&&t.params.nested&&s.stopPropagation(),t.params.freeMode&&t.params.freeMode.enabled){const e={time:l(),delta:Math.abs(m),direction:Math.sign(m)},a=c&&e.time<c.time+500&&e.delta<=c.delta&&e.direction===c.direction;if(!a){c=void 0;let l=t.getTranslate()+m*r.sensitivity;const o=t.isBeginning,p=t.isEnd;if(l>=t.minTranslate()&&(l=t.minTranslate()),l<=t.maxTranslate()&&(l=t.maxTranslate()),t.setTransition(0),t.setTranslate(l),t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses(),(!o&&t.isBeginning||!p&&t.isEnd)&&t.updateSlidesClasses(),t.params.loop&&t.loopFix({direction:e.direction<0?"next":"prev",byMousewheel:!0}),t.params.freeMode.sticky){clearTimeout(d),d=void 0,u.length>=15&&u.shift();const s=u.length?u[u.length-1]:void 0,a=u[0];if(u.push(e),s&&(e.delta>s.delta||e.direction!==s.direction))u.splice(0);else if(u.length>=15&&e.time-a.time<500&&a.delta-e.delta>=1&&e.delta<=6){const s=m>0?.8:.2;c=e,u.splice(0),d=n((()=>{t.slideToClosest(t.params.speed,!0,void 0,s)}),0)}d||(d=n((()=>{c=e,u.splice(0),t.slideToClosest(t.params.speed,!0,void 0,.5)}),500))}if(a||i("scroll",s),t.params.autoplay&&t.params.autoplayDisableOnInteraction&&t.autoplay.stop(),l===t.minTranslate()||l===t.maxTranslate())return!0}}else{const s={time:l(),delta:Math.abs(m),direction:Math.sign(m),raw:e};u.length>=2&&u.shift();const a=u.length?u[u.length-1]:void 0;if(u.push(s),a?(s.direction!==a.direction||s.delta>a.delta||s.time>a.time+150)&&f(s):f(s),function(e){const s=t.params.mousewheel;if(e.direction<0){if(t.isEnd&&!t.params.loop&&s.releaseOnEdges)return!0}else if(t.isBeginning&&!t.params.loop&&s.releaseOnEdges)return!0;return!1}(s))return!0}return s.preventDefault?s.preventDefault():s.returnValue=!1,!1}function v(e){let s=t.el;"container"!==t.params.mousewheel.eventsTarget&&(s=document.querySelector(t.params.mousewheel.eventsTarget)),s[e]("mouseenter",m),s[e]("mouseleave",h),s[e]("wheel",g)}function w(){return t.params.cssMode?(t.wrapperEl.removeEventListener("wheel",g),!0):!t.mousewheel.enabled&&(v("addEventListener"),t.mousewheel.enabled=!0,!0)}function b(){return t.params.cssMode?(t.wrapperEl.addEventListener(event,g),!0):!!t.mousewheel.enabled&&(v("removeEventListener"),t.mousewheel.enabled=!1,!0)}a("init",(()=>{!t.params.mousewheel.enabled&&t.params.cssMode&&b(),t.params.mousewheel.enabled&&w()})),a("destroy",(()=>{t.params.cssMode&&w(),t.mousewheel.enabled&&b()})),Object.assign(t.mousewheel,{enable:w,disable:b})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;s({navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock",navigationDisabledClass:"swiper-navigation-disabled"}}),t.navigation={nextEl:null,prevEl:null};const r=e=>(Array.isArray(e)||(e=[e].filter((e=>!!e))),e);function n(e){let s;return e&&"string"==typeof e&&t.isElement&&(s=t.el.shadowRoot.querySelector(e),s)?s:(e&&("string"==typeof e&&(s=[...document.querySelectorAll(e)]),t.params.uniqueNavElements&&"string"==typeof e&&s.length>1&&1===t.el.querySelectorAll(e).length&&(s=t.el.querySelector(e))),e&&!s?e:s)}function l(e,s){const a=t.params.navigation;(e=r(e)).forEach((e=>{e&&(e.classList[s?"add":"remove"](...a.disabledClass.split(" ")),"BUTTON"===e.tagName&&(e.disabled=s),t.params.watchOverflow&&t.enabled&&e.classList[t.isLocked?"add":"remove"](a.lockClass))}))}function o(){const{nextEl:e,prevEl:s}=t.navigation;if(t.params.loop)return l(s,!1),void l(e,!1);l(s,t.isBeginning&&!t.params.rewind),l(e,t.isEnd&&!t.params.rewind)}function d(e){e.preventDefault(),(!t.isBeginning||t.params.loop||t.params.rewind)&&(t.slidePrev(),i("navigationPrev"))}function c(e){e.preventDefault(),(!t.isEnd||t.params.loop||t.params.rewind)&&(t.slideNext(),i("navigationNext"))}function p(){const e=t.params.navigation;if(t.params.navigation=J(t,t.originalParams.navigation,t.params.navigation,{nextEl:"swiper-button-next",prevEl:"swiper-button-prev"}),!e.nextEl&&!e.prevEl)return;let s=n(e.nextEl),a=n(e.prevEl);Object.assign(t.navigation,{nextEl:s,prevEl:a}),s=r(s),a=r(a);const i=(s,a)=>{s&&s.addEventListener("click","next"===a?c:d),!t.enabled&&s&&s.classList.add(...e.lockClass.split(" "))};s.forEach((e=>i(e,"next"))),a.forEach((e=>i(e,"prev")))}function u(){let{nextEl:e,prevEl:s}=t.navigation;e=r(e),s=r(s);const a=(e,s)=>{e.removeEventListener("click","next"===s?c:d),e.classList.remove(...t.params.navigation.disabledClass.split(" "))};e.forEach((e=>a(e,"next"))),s.forEach((e=>a(e,"prev")))}a("init",(()=>{!1===t.params.navigation.enabled?m():(p(),o())})),a("toEdge fromEdge lock unlock",(()=>{o()})),a("destroy",(()=>{u()})),a("enable disable",(()=>{let{nextEl:e,prevEl:s}=t.navigation;e=r(e),s=r(s),[...e,...s].filter((e=>!!e)).forEach((e=>e.classList[t.enabled?"remove":"add"](t.params.navigation.lockClass)))})),a("click",((e,s)=>{let{nextEl:a,prevEl:n}=t.navigation;a=r(a),n=r(n);const l=s.target;if(t.params.navigation.hideOnClick&&!n.includes(l)&&!a.includes(l)){if(t.pagination&&t.params.pagination&&t.params.pagination.clickable&&(t.pagination.el===l||t.pagination.el.contains(l)))return;let e;a.length?e=a[0].classList.contains(t.params.navigation.hiddenClass):n.length&&(e=n[0].classList.contains(t.params.navigation.hiddenClass)),i(!0===e?"navigationShow":"navigationHide"),[...a,...n].filter((e=>!!e)).forEach((e=>e.classList.toggle(t.params.navigation.hiddenClass)))}}));const m=()=>{t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")),u()};Object.assign(t.navigation,{enable:()=>{t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")),p(),o()},disable:m,update:o,init:p,destroy:u})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const r="swiper-pagination";let n;s({pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:e=>e,formatFractionTotal:e=>e,bulletClass:`${r}-bullet`,bulletActiveClass:`${r}-bullet-active`,modifierClass:`${r}-`,currentClass:`${r}-current`,totalClass:`${r}-total`,hiddenClass:`${r}-hidden`,progressbarFillClass:`${r}-progressbar-fill`,progressbarOppositeClass:`${r}-progressbar-opposite`,clickableClass:`${r}-clickable`,lockClass:`${r}-lock`,horizontalClass:`${r}-horizontal`,verticalClass:`${r}-vertical`,paginationDisabledClass:`${r}-disabled`}}),t.pagination={el:null,bullets:[]};let l=0;const o=e=>(Array.isArray(e)||(e=[e].filter((e=>!!e))),e);function d(){return!t.params.pagination.el||!t.pagination.el||Array.isArray(t.pagination.el)&&0===t.pagination.el.length}function c(e,s){const{bulletActiveClass:a}=t.params.pagination;e&&(e=e[("prev"===s?"previous":"next")+"ElementSibling"])&&(e.classList.add(`${a}-${s}`),(e=e[("prev"===s?"previous":"next")+"ElementSibling"])&&e.classList.add(`${a}-${s}-${s}`))}function p(e){const s=e.target.closest(ee(t.params.pagination.bulletClass));if(!s)return;e.preventDefault();const a=b(s)*t.params.slidesPerGroup;t.params.loop?t.slideToLoop(a):t.slideTo(a)}function u(){const e=t.rtl,s=t.params.pagination;if(d())return;let a,r=t.pagination.el;r=o(r);const p=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.slides.length,u=t.params.loop?Math.ceil(p/t.params.slidesPerGroup):t.snapGrid.length;if(a=t.params.loop?t.params.slidesPerGroup>1?Math.floor(t.realIndex/t.params.slidesPerGroup):t.realIndex:void 0!==t.snapIndex?t.snapIndex:t.activeIndex||0,"bullets"===s.type&&t.pagination.bullets&&t.pagination.bullets.length>0){const i=t.pagination.bullets;let o,d,p;if(s.dynamicBullets&&(n=x(i[0],t.isHorizontal()?"width":"height",!0),r.forEach((e=>{e.style[t.isHorizontal()?"width":"height"]=n*(s.dynamicMainBullets+4)+"px"})),s.dynamicMainBullets>1&&void 0!==t.previousIndex&&(l+=a-(t.previousIndex||0),l>s.dynamicMainBullets-1?l=s.dynamicMainBullets-1:l<0&&(l=0)),o=Math.max(a-l,0),d=o+(Math.min(i.length,s.dynamicMainBullets)-1),p=(d+o)/2),i.forEach((e=>{e.classList.remove(...["","-next","-next-next","-prev","-prev-prev","-main"].map((e=>`${s.bulletActiveClass}${e}`)))})),r.length>1)i.forEach((e=>{const t=b(e);t===a&&e.classList.add(s.bulletActiveClass),s.dynamicBullets&&(t>=o&&t<=d&&e.classList.add(`${s.bulletActiveClass}-main`),t===o&&c(e,"prev"),t===d&&c(e,"next"))}));else{const e=i[a];if(e&&e.classList.add(s.bulletActiveClass),s.dynamicBullets){const e=i[o],t=i[d];for(let e=o;e<=d;e+=1)i[e].classList.add(`${s.bulletActiveClass}-main`);c(e,"prev"),c(t,"next")}}if(s.dynamicBullets){const a=Math.min(i.length,s.dynamicMainBullets+4),r=(n*a-n)/2-p*n,l=e?"right":"left";i.forEach((e=>{e.style[t.isHorizontal()?l:"top"]=`${r}px`}))}}r.forEach(((e,r)=>{if("fraction"===s.type&&(e.querySelectorAll(ee(s.currentClass)).forEach((e=>{e.textContent=s.formatFractionCurrent(a+1)})),e.querySelectorAll(ee(s.totalClass)).forEach((e=>{e.textContent=s.formatFractionTotal(u)}))),"progressbar"===s.type){let i;i=s.progressbarOpposite?t.isHorizontal()?"vertical":"horizontal":t.isHorizontal()?"horizontal":"vertical";const r=(a+1)/u;let n=1,l=1;"horizontal"===i?n=r:l=r,e.querySelectorAll(ee(s.progressbarFillClass)).forEach((e=>{e.style.transform=`translate3d(0,0,0) scaleX(${n}) scaleY(${l})`,e.style.transitionDuration=`${t.params.speed}ms`}))}"custom"===s.type&&s.renderCustom?(e.innerHTML=s.renderCustom(t,a+1,u),0===r&&i("paginationRender",e)):(0===r&&i("paginationRender",e),i("paginationUpdate",e)),t.params.watchOverflow&&t.enabled&&e.classList[t.isLocked?"add":"remove"](s.lockClass)}))}function m(){const e=t.params.pagination;if(d())return;const s=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.slides.length;let a=t.pagination.el;a=o(a);let r="";if("bullets"===e.type){let a=t.params.loop?Math.ceil(s/t.params.slidesPerGroup):t.snapGrid.length;t.params.freeMode&&t.params.freeMode.enabled&&a>s&&(a=s);for(let s=0;s<a;s+=1)e.renderBullet?r+=e.renderBullet.call(t,s,e.bulletClass):r+=`<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`}"fraction"===e.type&&(r=e.renderFraction?e.renderFraction.call(t,e.currentClass,e.totalClass):`<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),"progressbar"===e.type&&(r=e.renderProgressbar?e.renderProgressbar.call(t,e.progressbarFillClass):`<span class="${e.progressbarFillClass}"></span>`),a.forEach((s=>{"custom"!==e.type&&(s.innerHTML=r||""),"bullets"===e.type&&(t.pagination.bullets=[...s.querySelectorAll(ee(e.bulletClass))])})),"custom"!==e.type&&i("paginationRender",a[0])}function h(){t.params.pagination=J(t,t.originalParams.pagination,t.params.pagination,{el:"swiper-pagination"});const e=t.params.pagination;if(!e.el)return;let s;"string"==typeof e.el&&t.isElement&&(s=t.el.shadowRoot.querySelector(e.el)),s||"string"!=typeof e.el||(s=[...document.querySelectorAll(e.el)]),s||(s=e.el),s&&0!==s.length&&(t.params.uniqueNavElements&&"string"==typeof e.el&&Array.isArray(s)&&s.length>1&&(s=[...t.el.querySelectorAll(e.el)],s.length>1&&(s=s.filter((e=>y(e,".swiper")[0]===t.el))[0])),Array.isArray(s)&&1===s.length&&(s=s[0]),Object.assign(t.pagination,{el:s}),s=o(s),s.forEach((s=>{"bullets"===e.type&&e.clickable&&s.classList.add(e.clickableClass),s.classList.add(e.modifierClass+e.type),s.classList.add(t.isHorizontal()?e.horizontalClass:e.verticalClass),"bullets"===e.type&&e.dynamicBullets&&(s.classList.add(`${e.modifierClass}${e.type}-dynamic`),l=0,e.dynamicMainBullets<1&&(e.dynamicMainBullets=1)),"progressbar"===e.type&&e.progressbarOpposite&&s.classList.add(e.progressbarOppositeClass),e.clickable&&s.addEventListener("click",p),t.enabled||s.classList.add(e.lockClass)})))}function f(){const e=t.params.pagination;if(d())return;let s=t.pagination.el;s&&(s=o(s),s.forEach((s=>{s.classList.remove(e.hiddenClass),s.classList.remove(e.modifierClass+e.type),s.classList.remove(t.isHorizontal()?e.horizontalClass:e.verticalClass),e.clickable&&s.removeEventListener("click",p)}))),t.pagination.bullets&&t.pagination.bullets.forEach((t=>t.classList.remove(e.bulletActiveClass)))}a("init",(()=>{!1===t.params.pagination.enabled?g():(h(),m(),u())})),a("activeIndexChange",(()=>{void 0===t.snapIndex&&u()})),a("snapIndexChange",(()=>{u()})),a("snapGridLengthChange",(()=>{m(),u()})),a("destroy",(()=>{f()})),a("enable disable",(()=>{let{el:e}=t.pagination;e&&(e=o(e),e.forEach((e=>e.classList[t.enabled?"remove":"add"](t.params.pagination.lockClass))))})),a("lock unlock",(()=>{u()})),a("click",((e,s)=>{const a=s.target;let{el:r}=t.pagination;if(Array.isArray(r)||(r=[r].filter((e=>!!e))),t.params.pagination.el&&t.params.pagination.hideOnClick&&r&&r.length>0&&!a.classList.contains(t.params.pagination.bulletClass)){if(t.navigation&&(t.navigation.nextEl&&a===t.navigation.nextEl||t.navigation.prevEl&&a===t.navigation.prevEl))return;const e=r[0].classList.contains(t.params.pagination.hiddenClass);i(!0===e?"paginationShow":"paginationHide"),r.forEach((e=>e.classList.toggle(t.params.pagination.hiddenClass)))}}));const g=()=>{t.el.classList.add(t.params.pagination.paginationDisabledClass);let{el:e}=t.pagination;e&&(e=o(e),e.forEach((e=>e.classList.add(t.params.pagination.paginationDisabledClass)))),f()};Object.assign(t.pagination,{enable:()=>{t.el.classList.remove(t.params.pagination.paginationDisabledClass);let{el:e}=t.pagination;e&&(e=o(e),e.forEach((e=>e.classList.remove(t.params.pagination.paginationDisabledClass)))),h(),m(),u()},disable:g,render:m,update:u,init:h,destroy:f})},function(e){let{swiper:t,extendParams:s,on:i,emit:r}=e;const l=a();let o,d,c,p,u=!1,m=null,h=null;function f(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e,rtlTranslate:s}=t,{dragEl:a,el:i}=e,r=t.params.scrollbar,n=t.params.loop?t.progressLoop:t.progress;let l=d,o=(c-d)*n;s?(o=-o,o>0?(l=d-o,o=0):-o+d>c&&(l=c+o)):o<0?(l=d+o,o=0):o+d>c&&(l=c-o),t.isHorizontal()?(a.style.transform=`translate3d(${o}px, 0, 0)`,a.style.width=`${l}px`):(a.style.transform=`translate3d(0px, ${o}px, 0)`,a.style.height=`${l}px`),r.hide&&(clearTimeout(m),i.style.opacity=1,m=setTimeout((()=>{i.style.opacity=0,i.style.transitionDuration="400ms"}),1e3))}function w(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e}=t,{dragEl:s,el:a}=e;s.style.width="",s.style.height="",c=t.isHorizontal()?a.offsetWidth:a.offsetHeight,p=t.size/(t.virtualSize+t.params.slidesOffsetBefore-(t.params.centeredSlides?t.snapGrid[0]:0)),d="auto"===t.params.scrollbar.dragSize?c*p:parseInt(t.params.scrollbar.dragSize,10),t.isHorizontal()?s.style.width=`${d}px`:s.style.height=`${d}px`,a.style.display=p>=1?"none":"",t.params.scrollbar.hide&&(a.style.opacity=0),t.params.watchOverflow&&t.enabled&&e.el.classList[t.isLocked?"add":"remove"](t.params.scrollbar.lockClass)}function b(e){return t.isHorizontal()?e.clientX:e.clientY}function y(e){const{scrollbar:s,rtlTranslate:a}=t,{el:i}=s;let r;r=(b(e)-v(i)[t.isHorizontal()?"left":"top"]-(null!==o?o:d/2))/(c-d),r=Math.max(Math.min(r,1),0),a&&(r=1-r);const n=t.minTranslate()+(t.maxTranslate()-t.minTranslate())*r;t.updateProgress(n),t.setTranslate(n),t.updateActiveIndex(),t.updateSlidesClasses()}function E(e){const s=t.params.scrollbar,{scrollbar:a,wrapperEl:i}=t,{el:n,dragEl:l}=a;u=!0,o=e.target===l?b(e)-e.target.getBoundingClientRect()[t.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),i.style.transitionDuration="100ms",l.style.transitionDuration="100ms",y(e),clearTimeout(h),n.style.transitionDuration="0ms",s.hide&&(n.style.opacity=1),t.params.cssMode&&(t.wrapperEl.style["scroll-snap-type"]="none"),r("scrollbarDragStart",e)}function x(e){const{scrollbar:s,wrapperEl:a}=t,{el:i,dragEl:n}=s;u&&(e.preventDefault?e.preventDefault():e.returnValue=!1,y(e),a.style.transitionDuration="0ms",i.style.transitionDuration="0ms",n.style.transitionDuration="0ms",r("scrollbarDragMove",e))}function S(e){const s=t.params.scrollbar,{scrollbar:a,wrapperEl:i}=t,{el:l}=a;u&&(u=!1,t.params.cssMode&&(t.wrapperEl.style["scroll-snap-type"]="",i.style.transitionDuration=""),s.hide&&(clearTimeout(h),h=n((()=>{l.style.opacity=0,l.style.transitionDuration="400ms"}),1e3)),r("scrollbarDragEnd",e),s.snapOnRelease&&t.slideToClosest())}function T(e){const{scrollbar:s,params:a}=t,i=s.el;if(!i)return;const r=i,n=!!a.passiveListeners&&{passive:!1,capture:!1},o=!!a.passiveListeners&&{passive:!0,capture:!1};if(!r)return;const d="on"===e?"addEventListener":"removeEventListener";r[d]("pointerdown",E,n),l[d]("pointermove",x,n),l[d]("pointerup",S,o)}function M(){const{scrollbar:e,el:s}=t;t.params.scrollbar=J(t,t.originalParams.scrollbar,t.params.scrollbar,{el:"swiper-scrollbar"});const a=t.params.scrollbar;if(!a.el)return;let i,r;"string"==typeof a.el&&t.isElement&&(i=t.el.shadowRoot.querySelector(a.el)),i||"string"!=typeof a.el?i||(i=a.el):i=l.querySelectorAll(a.el),t.params.uniqueNavElements&&"string"==typeof a.el&&i.length>1&&1===s.querySelectorAll(a.el).length&&(i=s.querySelector(a.el)),i.length>0&&(i=i[0]),i.classList.add(t.isHorizontal()?a.horizontalClass:a.verticalClass),i&&(r=i.querySelector(`.${t.params.scrollbar.dragClass}`),r||(r=g("div",t.params.scrollbar.dragClass),i.append(r))),Object.assign(e,{el:i,dragEl:r}),a.draggable&&t.params.scrollbar.el&&t.scrollbar.el&&T("on"),i&&i.classList[t.enabled?"remove":"add"](t.params.scrollbar.lockClass)}function C(){const e=t.params.scrollbar,s=t.scrollbar.el;s&&s.classList.remove(t.isHorizontal()?e.horizontalClass:e.verticalClass),t.params.scrollbar.el&&t.scrollbar.el&&T("off")}s({scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag",scrollbarDisabledClass:"swiper-scrollbar-disabled",horizontalClass:"swiper-scrollbar-horizontal",verticalClass:"swiper-scrollbar-vertical"}}),t.scrollbar={el:null,dragEl:null},i("init",(()=>{!1===t.params.scrollbar.enabled?P():(M(),w(),f())})),i("update resize observerUpdate lock unlock",(()=>{w()})),i("setTranslate",(()=>{f()})),i("setTransition",((e,s)=>{!function(e){t.params.scrollbar.el&&t.scrollbar.el&&(t.scrollbar.dragEl.style.transitionDuration=`${e}ms`)}(s)})),i("enable disable",(()=>{const{el:e}=t.scrollbar;e&&e.classList[t.enabled?"remove":"add"](t.params.scrollbar.lockClass)})),i("destroy",(()=>{C()}));const P=()=>{t.el.classList.add(t.params.scrollbar.scrollbarDisabledClass),t.scrollbar.el&&t.scrollbar.el.classList.add(t.params.scrollbar.scrollbarDisabledClass),C()};Object.assign(t.scrollbar,{enable:()=>{t.el.classList.remove(t.params.scrollbar.scrollbarDisabledClass),t.scrollbar.el&&t.scrollbar.el.classList.remove(t.params.scrollbar.scrollbarDisabledClass),M(),w(),f()},disable:P,updateSize:w,setTranslate:f,init:M,destroy:C})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({parallax:{enabled:!1}});const i=(e,s)=>{const{rtl:a}=t,i=a?-1:1,r=e.getAttribute("data-swiper-parallax")||"0";let n=e.getAttribute("data-swiper-parallax-x"),l=e.getAttribute("data-swiper-parallax-y");const o=e.getAttribute("data-swiper-parallax-scale"),d=e.getAttribute("data-swiper-parallax-opacity"),c=e.getAttribute("data-swiper-parallax-rotate");if(n||l?(n=n||"0",l=l||"0"):t.isHorizontal()?(n=r,l="0"):(l=r,n="0"),n=n.indexOf("%")>=0?parseInt(n,10)*s*i+"%":n*s*i+"px",l=l.indexOf("%")>=0?parseInt(l,10)*s+"%":l*s+"px",null!=d){const t=d-(d-1)*(1-Math.abs(s));e.style.opacity=t}let p=`translate3d(${n}, ${l}, 0px)`;if(null!=o){p+=` scale(${o-(o-1)*(1-Math.abs(s))})`}if(c&&null!=c){p+=` rotate(${c*s*-1}deg)`}e.style.transform=p},r=()=>{const{el:e,slides:s,progress:a,snapGrid:r}=t;f(e,"[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach((e=>{i(e,a)})),s.forEach(((e,s)=>{let n=e.progress;t.params.slidesPerGroup>1&&"auto"!==t.params.slidesPerView&&(n+=Math.ceil(s/2)-a*(r.length-1)),n=Math.min(Math.max(n,-1),1),e.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale], [data-swiper-parallax-rotate]").forEach((e=>{i(e,n)}))}))};a("beforeInit",(()=>{t.params.parallax.enabled&&(t.params.watchSlidesProgress=!0,t.originalParams.watchSlidesProgress=!0)})),a("init",(()=>{t.params.parallax.enabled&&r()})),a("setTranslate",(()=>{t.params.parallax.enabled&&r()})),a("setTransition",((e,s)=>{t.params.parallax.enabled&&function(e){void 0===e&&(e=t.params.speed);const{el:s}=t;s.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach((t=>{let s=parseInt(t.getAttribute("data-swiper-parallax-duration"),10)||e;0===e&&(s=0),t.style.transitionDuration=`${s}ms`}))}(s)}))},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=r();s({zoom:{enabled:!1,maxRatio:3,minRatio:1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}}),t.zoom={enabled:!1};let l,d,c=1,p=!1;const u=[],m={slideEl:void 0,slideWidth:void 0,slideHeight:void 0,imageEl:void 0,imageWrapEl:void 0,maxRatio:3},h={isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},g={x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0};let w=1;function b(){if(u.length<2)return 1;const e=u[0].pageX,t=u[0].pageY,s=u[1].pageX,a=u[1].pageY;return Math.sqrt((s-e)**2+(a-t)**2)}function E(e){const s=t.isElement?"swiper-slide":`.${t.params.slideClass}`;return!!e.target.matches(s)||t.slides.filter((t=>t.contains(e.target))).length>0}function x(e){if(!E(e))return;const s=t.params.zoom;if(l=!1,d=!1,u.push(e),!(u.length<2)){if(l=!0,m.scaleStart=b(),!m.slideEl){m.slideEl=e.target.closest(`.${t.params.slideClass}, swiper-slide`),m.slideEl||(m.slideEl=t.slides[t.activeIndex]);let a=m.slideEl.querySelector(`.${s.containerClass}`);if(a&&(a=a.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),m.imageEl=a,m.imageWrapEl=a?y(m.imageEl,`.${s.containerClass}`)[0]:void 0,!m.imageWrapEl)return void(m.imageEl=void 0);m.maxRatio=m.imageWrapEl.getAttribute("data-swiper-zoom")||s.maxRatio}if(m.imageEl){const[e,t]=function(){if(u.length<2)return{x:null,y:null};const e=m.imageEl.getBoundingClientRect();return[(u[0].pageX+(u[1].pageX-u[0].pageX)/2-e.x)/c,(u[0].pageY+(u[1].pageY-u[0].pageY)/2-e.y)/c]}();m.imageEl.style.transformOrigin=`${e}px ${t}px`,m.imageEl.style.transitionDuration="0ms"}p=!0}}function S(e){if(!E(e))return;const s=t.params.zoom,a=t.zoom,i=u.findIndex((t=>t.pointerId===e.pointerId));i>=0&&(u[i]=e),u.length<2||(d=!0,m.scaleMove=b(),m.imageEl&&(a.scale=m.scaleMove/m.scaleStart*c,a.scale>m.maxRatio&&(a.scale=m.maxRatio-1+(a.scale-m.maxRatio+1)**.5),a.scale<s.minRatio&&(a.scale=s.minRatio+1-(s.minRatio-a.scale+1)**.5),m.imageEl.style.transform=`translate3d(0,0,0) scale(${a.scale})`))}function T(e){if(!E(e))return;const s=t.params.zoom,a=t.zoom,i=u.findIndex((t=>t.pointerId===e.pointerId));i>=0&&u.splice(i,1),l&&d&&(l=!1,d=!1,m.imageEl&&(a.scale=Math.max(Math.min(a.scale,m.maxRatio),s.minRatio),m.imageEl.style.transitionDuration=`${t.params.speed}ms`,m.imageEl.style.transform=`translate3d(0,0,0) scale(${a.scale})`,c=a.scale,p=!1,1===a.scale&&(m.slideEl=void 0)))}function M(e){if(!E(e)||!function(e){const s=`.${t.params.zoom.containerClass}`;return!!e.target.matches(s)||[...t.el.querySelectorAll(s)].filter((t=>t.contains(e.target))).length>0}(e))return;const s=t.zoom;if(!m.imageEl)return;if(t.allowClick=!1,!h.isTouched||!m.slideEl)return;h.isMoved||(h.width=m.imageEl.offsetWidth,h.height=m.imageEl.offsetHeight,h.startX=o(m.imageWrapEl,"x")||0,h.startY=o(m.imageWrapEl,"y")||0,m.slideWidth=m.slideEl.offsetWidth,m.slideHeight=m.slideEl.offsetHeight,m.imageWrapEl.style.transitionDuration="0ms");const a=h.width*s.scale,i=h.height*s.scale;if(!(a<m.slideWidth&&i<m.slideHeight)){if(h.minX=Math.min(m.slideWidth/2-a/2,0),h.maxX=-h.minX,h.minY=Math.min(m.slideHeight/2-i/2,0),h.maxY=-h.minY,h.touchesCurrent.x=u.length>0?u[0].pageX:e.pageX,h.touchesCurrent.y=u.length>0?u[0].pageY:e.pageY,!h.isMoved&&!p){if(t.isHorizontal()&&(Math.floor(h.minX)===Math.floor(h.startX)&&h.touchesCurrent.x<h.touchesStart.x||Math.floor(h.maxX)===Math.floor(h.startX)&&h.touchesCurrent.x>h.touchesStart.x))return void(h.isTouched=!1);if(!t.isHorizontal()&&(Math.floor(h.minY)===Math.floor(h.startY)&&h.touchesCurrent.y<h.touchesStart.y||Math.floor(h.maxY)===Math.floor(h.startY)&&h.touchesCurrent.y>h.touchesStart.y))return void(h.isTouched=!1)}e.cancelable&&e.preventDefault(),e.stopPropagation(),h.isMoved=!0,h.currentX=h.touchesCurrent.x-h.touchesStart.x+h.startX,h.currentY=h.touchesCurrent.y-h.touchesStart.y+h.startY,h.currentX<h.minX&&(h.currentX=h.minX+1-(h.minX-h.currentX+1)**.8),h.currentX>h.maxX&&(h.currentX=h.maxX-1+(h.currentX-h.maxX+1)**.8),h.currentY<h.minY&&(h.currentY=h.minY+1-(h.minY-h.currentY+1)**.8),h.currentY>h.maxY&&(h.currentY=h.maxY-1+(h.currentY-h.maxY+1)**.8),g.prevPositionX||(g.prevPositionX=h.touchesCurrent.x),g.prevPositionY||(g.prevPositionY=h.touchesCurrent.y),g.prevTime||(g.prevTime=Date.now()),g.x=(h.touchesCurrent.x-g.prevPositionX)/(Date.now()-g.prevTime)/2,g.y=(h.touchesCurrent.y-g.prevPositionY)/(Date.now()-g.prevTime)/2,Math.abs(h.touchesCurrent.x-g.prevPositionX)<2&&(g.x=0),Math.abs(h.touchesCurrent.y-g.prevPositionY)<2&&(g.y=0),g.prevPositionX=h.touchesCurrent.x,g.prevPositionY=h.touchesCurrent.y,g.prevTime=Date.now(),m.imageWrapEl.style.transform=`translate3d(${h.currentX}px, ${h.currentY}px,0)`}}function C(){const e=t.zoom;m.slideEl&&t.previousIndex!==t.activeIndex&&(m.imageEl&&(m.imageEl.style.transform="translate3d(0,0,0) scale(1)"),m.imageWrapEl&&(m.imageWrapEl.style.transform="translate3d(0,0,0)"),e.scale=1,c=1,m.slideEl=void 0,m.imageEl=void 0,m.imageWrapEl=void 0)}function P(e){const s=t.zoom,a=t.params.zoom;if(!m.slideEl){e&&e.target&&(m.slideEl=e.target.closest(`.${t.params.slideClass}, swiper-slide`)),m.slideEl||(t.params.virtual&&t.params.virtual.enabled&&t.virtual?m.slideEl=f(t.slidesEl,`.${t.params.slideActiveClass}`)[0]:m.slideEl=t.slides[t.activeIndex]);let s=m.slideEl.querySelector(`.${a.containerClass}`);s&&(s=s.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),m.imageEl=s,m.imageWrapEl=s?y(m.imageEl,`.${a.containerClass}`)[0]:void 0}if(!m.imageEl||!m.imageWrapEl)return;let i,r,l,o,d,p,u,g,w,b,E,x,S,T,M,C,P,L;t.params.cssMode&&(t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.touchAction="none"),m.slideEl.classList.add(`${a.zoomedSlideClass}`),void 0===h.touchesStart.x&&e?(i=e.pageX,r=e.pageY):(i=h.touchesStart.x,r=h.touchesStart.y);const A="number"==typeof e?e:null;1===c&&A&&(i=void 0,r=void 0),s.scale=A||m.imageWrapEl.getAttribute("data-swiper-zoom")||a.maxRatio,c=A||m.imageWrapEl.getAttribute("data-swiper-zoom")||a.maxRatio,!e||1===c&&A?(u=0,g=0):(P=m.slideEl.offsetWidth,L=m.slideEl.offsetHeight,l=v(m.slideEl).left+n.scrollX,o=v(m.slideEl).top+n.scrollY,d=l+P/2-i,p=o+L/2-r,w=m.imageEl.offsetWidth,b=m.imageEl.offsetHeight,E=w*s.scale,x=b*s.scale,S=Math.min(P/2-E/2,0),T=Math.min(L/2-x/2,0),M=-S,C=-T,u=d*s.scale,g=p*s.scale,u<S&&(u=S),u>M&&(u=M),g<T&&(g=T),g>C&&(g=C)),m.imageWrapEl.style.transitionDuration="300ms",m.imageWrapEl.style.transform=`translate3d(${u}px, ${g}px,0)`,m.imageEl.style.transitionDuration="300ms",m.imageEl.style.transform=`translate3d(0,0,0) scale(${s.scale})`}function L(){const e=t.zoom,s=t.params.zoom;if(!m.slideEl){t.params.virtual&&t.params.virtual.enabled&&t.virtual?m.slideEl=f(t.slidesEl,`.${t.params.slideActiveClass}`)[0]:m.slideEl=t.slides[t.activeIndex];let e=m.slideEl.querySelector(`.${s.containerClass}`);e&&(e=e.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),m.imageEl=e,m.imageWrapEl=e?y(m.imageEl,`.${s.containerClass}`)[0]:void 0}m.imageEl&&m.imageWrapEl&&(t.params.cssMode&&(t.wrapperEl.style.overflow="",t.wrapperEl.style.touchAction=""),e.scale=1,c=1,m.imageWrapEl.style.transitionDuration="300ms",m.imageWrapEl.style.transform="translate3d(0,0,0)",m.imageEl.style.transitionDuration="300ms",m.imageEl.style.transform="translate3d(0,0,0) scale(1)",m.slideEl.classList.remove(`${s.zoomedSlideClass}`),m.slideEl=void 0)}function A(e){const s=t.zoom;s.scale&&1!==s.scale?L():P(e)}function z(){return{passiveListener:!!t.params.passiveListeners&&{passive:!0,capture:!1},activeListenerWithCapture:!t.params.passiveListeners||{passive:!1,capture:!0}}}function $(){const e=t.zoom;if(e.enabled)return;e.enabled=!0;const{passiveListener:s,activeListenerWithCapture:a}=z();t.wrapperEl.addEventListener("pointerdown",x,s),t.wrapperEl.addEventListener("pointermove",S,a),["pointerup","pointercancel"].forEach((e=>{t.wrapperEl.addEventListener(e,T,s)})),t.wrapperEl.addEventListener("pointermove",M,a)}function k(){const e=t.zoom;if(!e.enabled)return;e.enabled=!1;const{passiveListener:s,activeListenerWithCapture:a}=z();t.wrapperEl.removeEventListener("pointerdown",x,s),t.wrapperEl.removeEventListener("pointermove",S,a),["pointerup","pointercancel"].forEach((e=>{t.wrapperEl.removeEventListener(e,T,s)})),t.wrapperEl.removeEventListener("pointermove",M,a)}Object.defineProperty(t.zoom,"scale",{get:()=>w,set(e){if(w!==e){const t=m.imageEl,s=m.slideEl;i("zoomChange",e,t,s)}w=e}}),a("init",(()=>{t.params.zoom.enabled&&$()})),a("destroy",(()=>{k()})),a("touchStart",((e,s)=>{t.zoom.enabled&&function(e){const s=t.device;m.imageEl&&(h.isTouched||(s.android&&e.cancelable&&e.preventDefault(),h.isTouched=!0,h.touchesStart.x=e.pageX,h.touchesStart.y=e.pageY))}(s)})),a("touchEnd",((e,s)=>{t.zoom.enabled&&function(){const e=t.zoom;if(!m.imageEl)return;if(!h.isTouched||!h.isMoved)return h.isTouched=!1,void(h.isMoved=!1);h.isTouched=!1,h.isMoved=!1;let s=300,a=300;const i=g.x*s,r=h.currentX+i,n=g.y*a,l=h.currentY+n;0!==g.x&&(s=Math.abs((r-h.currentX)/g.x)),0!==g.y&&(a=Math.abs((l-h.currentY)/g.y));const o=Math.max(s,a);h.currentX=r,h.currentY=l;const d=h.width*e.scale,c=h.height*e.scale;h.minX=Math.min(m.slideWidth/2-d/2,0),h.maxX=-h.minX,h.minY=Math.min(m.slideHeight/2-c/2,0),h.maxY=-h.minY,h.currentX=Math.max(Math.min(h.currentX,h.maxX),h.minX),h.currentY=Math.max(Math.min(h.currentY,h.maxY),h.minY),m.imageWrapEl.style.transitionDuration=`${o}ms`,m.imageWrapEl.style.transform=`translate3d(${h.currentX}px, ${h.currentY}px,0)`}()})),a("doubleTap",((e,s)=>{!t.animating&&t.params.zoom.enabled&&t.zoom.enabled&&t.params.zoom.toggle&&A(s)})),a("transitionEnd",(()=>{t.zoom.enabled&&t.params.zoom.enabled&&C()})),a("slideChange",(()=>{t.zoom.enabled&&t.params.zoom.enabled&&t.params.cssMode&&C()})),Object.assign(t.zoom,{enable:$,disable:k,in:P,out:L,toggle:A})},function(e){let{swiper:t,extendParams:s,on:a}=e;function i(e,t){const s=function(){let e,t,s;return(a,i)=>{for(t=-1,e=a.length;e-t>1;)s=e+t>>1,a[s]<=i?t=s:e=s;return e}}();let a,i;return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(i=s(this.x,e),a=i-1,(e-this.x[a])*(this.y[i]-this.y[a])/(this.x[i]-this.x[a])+this.y[a]):0},this}function r(){t.controller.control&&t.controller.spline&&(t.controller.spline=void 0,delete t.controller.spline)}s({controller:{control:void 0,inverse:!1,by:"slide"}}),t.controller={control:void 0},a("beforeInit",(()=>{if("undefined"!=typeof window&&("string"==typeof t.params.controller.control||t.params.controller.control instanceof HTMLElement)){const e=document.querySelector(t.params.controller.control);if(e&&e.swiper)t.controller.control=e.swiper;else if(e){const s=a=>{t.controller.control=a.detail[0],t.update(),e.removeEventListener("init",s)};e.addEventListener("init",s)}}else t.controller.control=t.params.controller.control})),a("update",(()=>{r()})),a("resize",(()=>{r()})),a("observerUpdate",(()=>{r()})),a("setTranslate",((e,s,a)=>{t.controller.control&&t.controller.setTranslate(s,a)})),a("setTransition",((e,s,a)=>{t.controller.control&&t.controller.setTransition(s,a)})),Object.assign(t.controller,{setTranslate:function(e,s){const a=t.controller.control;let r,n;const l=t.constructor;function o(e){const s=t.rtlTranslate?-t.translate:t.translate;"slide"===t.params.controller.by&&(!function(e){t.controller.spline||(t.controller.spline=t.params.loop?new i(t.slidesGrid,e.slidesGrid):new i(t.snapGrid,e.snapGrid))}(e),n=-t.controller.spline.interpolate(-s)),n&&"container"!==t.params.controller.by||(r=(e.maxTranslate()-e.minTranslate())/(t.maxTranslate()-t.minTranslate()),n=(s-t.minTranslate())*r+e.minTranslate()),t.params.controller.inverse&&(n=e.maxTranslate()-n),e.updateProgress(n),e.setTranslate(n,t),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(a))for(let e=0;e<a.length;e+=1)a[e]!==s&&a[e]instanceof l&&o(a[e]);else a instanceof l&&s!==a&&o(a)},setTransition:function(e,s){const a=t.constructor,i=t.controller.control;let r;function l(s){s.setTransition(e,t),0!==e&&(s.transitionStart(),s.params.autoHeight&&n((()=>{s.updateAutoHeight()})),E(s.wrapperEl,(()=>{i&&s.transitionEnd()})))}if(Array.isArray(i))for(r=0;r<i.length;r+=1)i[r]!==s&&i[r]instanceof a&&l(i[r]);else i instanceof a&&s!==i&&l(i)}})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",slideLabelMessage:"{{index}} / {{slidesLength}}",containerMessage:null,containerRoleDescriptionMessage:null,itemRoleDescriptionMessage:null,slideRole:"group",id:null}}),t.a11y={clicked:!1};let i=null;function r(e){const t=i;0!==t.length&&(t.innerHTML="",t.innerHTML=e)}const n=e=>(Array.isArray(e)||(e=[e].filter((e=>!!e))),e);function l(e){(e=n(e)).forEach((e=>{e.setAttribute("tabIndex","0")}))}function o(e){(e=n(e)).forEach((e=>{e.setAttribute("tabIndex","-1")}))}function d(e,t){(e=n(e)).forEach((e=>{e.setAttribute("role",t)}))}function c(e,t){(e=n(e)).forEach((e=>{e.setAttribute("aria-roledescription",t)}))}function p(e,t){(e=n(e)).forEach((e=>{e.setAttribute("aria-label",t)}))}function u(e){(e=n(e)).forEach((e=>{e.setAttribute("aria-disabled",!0)}))}function m(e){(e=n(e)).forEach((e=>{e.setAttribute("aria-disabled",!1)}))}function h(e){if(13!==e.keyCode&&32!==e.keyCode)return;const s=t.params.a11y,a=e.target;t.pagination&&t.pagination.el&&(a===t.pagination.el||t.pagination.el.contains(e.target))&&!e.target.matches(ee(t.params.pagination.bulletClass))||(t.navigation&&t.navigation.nextEl&&a===t.navigation.nextEl&&(t.isEnd&&!t.params.loop||t.slideNext(),t.isEnd?r(s.lastSlideMessage):r(s.nextSlideMessage)),t.navigation&&t.navigation.prevEl&&a===t.navigation.prevEl&&(t.isBeginning&&!t.params.loop||t.slidePrev(),t.isBeginning?r(s.firstSlideMessage):r(s.prevSlideMessage)),t.pagination&&a.matches(ee(t.params.pagination.bulletClass))&&a.click())}function f(){return t.pagination&&t.pagination.bullets&&t.pagination.bullets.length}function v(){return f()&&t.params.pagination.clickable}const w=(e,t,s)=>{l(e),"BUTTON"!==e.tagName&&(d(e,"button"),e.addEventListener("keydown",h)),p(e,s),function(e,t){(e=n(e)).forEach((e=>{e.setAttribute("aria-controls",t)}))}(e,t)},y=()=>{t.a11y.clicked=!0},E=()=>{requestAnimationFrame((()=>{requestAnimationFrame((()=>{t.destroyed||(t.a11y.clicked=!1)}))}))},x=e=>{if(t.a11y.clicked)return;const s=e.target.closest(`.${t.params.slideClass}, swiper-slide`);if(!s||!t.slides.includes(s))return;const a=t.slides.indexOf(s)===t.activeIndex,i=t.params.watchSlidesProgress&&t.visibleSlides&&t.visibleSlides.includes(s);a||i||e.sourceCapabilities&&e.sourceCapabilities.firesTouchEvents||(t.isHorizontal()?t.el.scrollLeft=0:t.el.scrollTop=0,t.slideTo(t.slides.indexOf(s),0))},S=()=>{const e=t.params.a11y;e.itemRoleDescriptionMessage&&c(t.slides,e.itemRoleDescriptionMessage),e.slideRole&&d(t.slides,e.slideRole);const s=t.slides.length;e.slideLabelMessage&&t.slides.forEach(((a,i)=>{const r=t.params.loop?parseInt(a.getAttribute("data-swiper-slide-index"),10):i;p(a,e.slideLabelMessage.replace(/\{\{index\}\}/,r+1).replace(/\{\{slidesLength\}\}/,s))}))},T=()=>{const e=t.params.a11y;t.el.append(i);const s=t.el;e.containerRoleDescriptionMessage&&c(s,e.containerRoleDescriptionMessage),e.containerMessage&&p(s,e.containerMessage);const a=t.wrapperEl,r=e.id||a.getAttribute("id")||`swiper-wrapper-${l=16,void 0===l&&(l=16),"x".repeat(l).replace(/x/g,(()=>Math.round(16*Math.random()).toString(16)))}`;var l;const o=t.params.autoplay&&t.params.autoplay.enabled?"off":"polite";var d;d=r,n(a).forEach((e=>{e.setAttribute("id",d)})),function(e,t){(e=n(e)).forEach((e=>{e.setAttribute("aria-live",t)}))}(a,o),S();let{nextEl:u,prevEl:m}=t.navigation?t.navigation:{};if(u=n(u),m=n(m),u&&u.forEach((t=>w(t,r,e.nextSlideMessage))),m&&m.forEach((t=>w(t,r,e.prevSlideMessage))),v()){(Array.isArray(t.pagination.el)?t.pagination.el:[t.pagination.el]).forEach((e=>{e.addEventListener("keydown",h)}))}t.el.addEventListener("focus",x,!0),t.el.addEventListener("pointerdown",y,!0),t.el.addEventListener("pointerup",E,!0)};a("beforeInit",(()=>{i=g("span",t.params.a11y.notificationClass),i.setAttribute("aria-live","assertive"),i.setAttribute("aria-atomic","true"),t.isElement&&i.setAttribute("slot","container-end")})),a("afterInit",(()=>{t.params.a11y.enabled&&T()})),a("slidesLengthChange snapGridLengthChange slidesGridLengthChange",(()=>{t.params.a11y.enabled&&S()})),a("fromEdge toEdge afterInit lock unlock",(()=>{t.params.a11y.enabled&&function(){if(t.params.loop||t.params.rewind||!t.navigation)return;const{nextEl:e,prevEl:s}=t.navigation;s&&(t.isBeginning?(u(s),o(s)):(m(s),l(s))),e&&(t.isEnd?(u(e),o(e)):(m(e),l(e)))}()})),a("paginationUpdate",(()=>{t.params.a11y.enabled&&function(){const e=t.params.a11y;f()&&t.pagination.bullets.forEach((s=>{t.params.pagination.clickable&&(l(s),t.params.pagination.renderBullet||(d(s,"button"),p(s,e.paginationBulletMessage.replace(/\{\{index\}\}/,b(s)+1)))),s.matches(`.${t.params.pagination.bulletActiveClass}`)?s.setAttribute("aria-current","true"):s.removeAttribute("aria-current")}))}()})),a("destroy",(()=>{t.params.a11y.enabled&&function(){i&&i.length>0&&i.remove();let{nextEl:e,prevEl:s}=t.navigation?t.navigation:{};e=n(e),s=n(s),e&&e.forEach((e=>e.removeEventListener("keydown",h))),s&&s.forEach((e=>e.removeEventListener("keydown",h))),v()&&(Array.isArray(t.pagination.el)?t.pagination.el:[t.pagination.el]).forEach((e=>{e.removeEventListener("keydown",h)}));t.el.removeEventListener("focus",x,!0),t.el.removeEventListener("pointerdown",y,!0),t.el.removeEventListener("pointerup",E,!0)}()}))},function(e){let{swiper:t,extendParams:s,on:a}=e;s({history:{enabled:!1,root:"",replaceState:!1,key:"slides",keepQuery:!1}});let i=!1,n={};const l=e=>e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,""),o=e=>{const t=r();let s;s=e?new URL(e):t.location;const a=s.pathname.slice(1).split("/").filter((e=>""!==e)),i=a.length;return{key:a[i-2],value:a[i-1]}},d=(e,s)=>{const a=r();if(!i||!t.params.history.enabled)return;let n;n=t.params.url?new URL(t.params.url):a.location;const o=t.slides[s];let d=l(o.getAttribute("data-history"));if(t.params.history.root.length>0){let s=t.params.history.root;"/"===s[s.length-1]&&(s=s.slice(0,s.length-1)),d=`${s}/${e?`${e}/`:""}${d}`}else n.pathname.includes(e)||(d=`${e?`${e}/`:""}${d}`);t.params.history.keepQuery&&(d+=n.search);const c=a.history.state;c&&c.value===d||(t.params.history.replaceState?a.history.replaceState({value:d},null,d):a.history.pushState({value:d},null,d))},c=(e,s,a)=>{if(s)for(let i=0,r=t.slides.length;i<r;i+=1){const r=t.slides[i];if(l(r.getAttribute("data-history"))===s){const s=b(r);t.slideTo(s,e,a)}}else t.slideTo(0,e,a)},p=()=>{n=o(t.params.url),c(t.params.speed,n.value,!1)};a("init",(()=>{t.params.history.enabled&&(()=>{const e=r();if(t.params.history){if(!e.history||!e.history.pushState)return t.params.history.enabled=!1,void(t.params.hashNavigation.enabled=!0);i=!0,n=o(t.params.url),n.key||n.value?(c(0,n.value,t.params.runCallbacksOnInit),t.params.history.replaceState||e.addEventListener("popstate",p)):t.params.history.replaceState||e.addEventListener("popstate",p)}})()})),a("destroy",(()=>{t.params.history.enabled&&(()=>{const e=r();t.params.history.replaceState||e.removeEventListener("popstate",p)})()})),a("transitionEnd _freeModeNoMomentumRelease",(()=>{i&&d(t.params.history.key,t.activeIndex)})),a("slideChange",(()=>{i&&t.params.cssMode&&d(t.params.history.key,t.activeIndex)}))},function(e){let{swiper:t,extendParams:s,emit:i,on:n}=e,l=!1;const o=a(),d=r();s({hashNavigation:{enabled:!1,replaceState:!1,watchState:!1}});const c=()=>{i("hashChange");const e=o.location.hash.replace("#","");if(e!==t.slides[t.activeIndex].getAttribute("data-hash")){const s=b(f(t.slidesEl,`.${t.params.slideClass}[data-hash="${e}"], swiper-slide[data-hash="${e}"]`)[0]);if(void 0===s)return;t.slideTo(s)}},p=()=>{if(l&&t.params.hashNavigation.enabled)if(t.params.hashNavigation.replaceState&&d.history&&d.history.replaceState)d.history.replaceState(null,null,`#${t.slides[t.activeIndex].getAttribute("data-hash")}`||""),i("hashSet");else{const e=t.slides[t.activeIndex],s=e.getAttribute("data-hash")||e.getAttribute("data-history");o.location.hash=s||"",i("hashSet")}};n("init",(()=>{t.params.hashNavigation.enabled&&(()=>{if(!t.params.hashNavigation.enabled||t.params.history&&t.params.history.enabled)return;l=!0;const e=o.location.hash.replace("#","");if(e){const s=0;for(let a=0,i=t.slides.length;a<i;a+=1){const i=t.slides[a];if((i.getAttribute("data-hash")||i.getAttribute("data-history"))===e){const e=b(i);t.slideTo(e,s,t.params.runCallbacksOnInit,!0)}}}t.params.hashNavigation.watchState&&d.addEventListener("hashchange",c)})()})),n("destroy",(()=>{t.params.hashNavigation.enabled&&t.params.hashNavigation.watchState&&d.removeEventListener("hashchange",c)})),n("transitionEnd _freeModeNoMomentumRelease",(()=>{l&&p()})),n("slideChange",(()=>{l&&t.params.cssMode&&p()}))},function(e){let t,s,{swiper:i,extendParams:r,on:n,emit:l,params:o}=e;i.autoplay={running:!1,paused:!1,timeLeft:0},r({autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!0,stopOnLastSlide:!1,reverseDirection:!1,pauseOnMouseEnter:!1}});let d,c,p,u,m,h,f,g=o&&o.autoplay?o.autoplay.delay:3e3,v=o&&o.autoplay?o.autoplay.delay:3e3,w=(new Date).getTime;function b(e){i&&!i.destroyed&&i.wrapperEl&&e.target===i.wrapperEl&&(i.wrapperEl.removeEventListener("transitionend",b),M())}const y=()=>{if(i.destroyed||!i.autoplay.running)return;i.autoplay.paused?c=!0:c&&(v=d,c=!1);const e=i.autoplay.paused?d:w+v-(new Date).getTime();i.autoplay.timeLeft=e,l("autoplayTimeLeft",e,e/g),s=requestAnimationFrame((()=>{y()}))},E=e=>{if(i.destroyed||!i.autoplay.running)return;cancelAnimationFrame(s),y();let a=void 0===e?i.params.autoplay.delay:e;g=i.params.autoplay.delay,v=i.params.autoplay.delay;const r=(()=>{let e;if(e=i.virtual&&i.params.virtual.enabled?i.slides.filter((e=>e.classList.contains("swiper-slide-active")))[0]:i.slides[i.activeIndex],!e)return;return parseInt(e.getAttribute("data-swiper-autoplay"),10)})();!Number.isNaN(r)&&r>0&&void 0===e&&(a=r,g=r,v=r),d=a;const n=i.params.speed,o=()=>{i&&!i.destroyed&&(i.params.autoplay.reverseDirection?!i.isBeginning||i.params.loop||i.params.rewind?(i.slidePrev(n,!0,!0),l("autoplay")):i.params.autoplay.stopOnLastSlide||(i.slideTo(i.slides.length-1,n,!0,!0),l("autoplay")):!i.isEnd||i.params.loop||i.params.rewind?(i.slideNext(n,!0,!0),l("autoplay")):i.params.autoplay.stopOnLastSlide||(i.slideTo(0,n,!0,!0),l("autoplay")),i.params.cssMode&&(w=(new Date).getTime(),requestAnimationFrame((()=>{E()}))))};return a>0?(clearTimeout(t),t=setTimeout((()=>{o()}),a)):requestAnimationFrame((()=>{o()})),a},x=()=>{i.autoplay.running=!0,E(),l("autoplayStart")},S=()=>{i.autoplay.running=!1,clearTimeout(t),cancelAnimationFrame(s),l("autoplayStop")},T=(e,s)=>{if(i.destroyed||!i.autoplay.running)return;clearTimeout(t),e||(f=!0);const a=()=>{l("autoplayPause"),i.params.autoplay.waitForTransition?i.wrapperEl.addEventListener("transitionend",b):M()};if(i.autoplay.paused=!0,s)return h&&(d=i.params.autoplay.delay),h=!1,void a();const r=d||i.params.autoplay.delay;d=r-((new Date).getTime()-w),i.isEnd&&d<0&&!i.params.loop||(d<0&&(d=0),a())},M=()=>{i.isEnd&&d<0&&!i.params.loop||i.destroyed||!i.autoplay.running||(w=(new Date).getTime(),f?(f=!1,E(d)):E(),i.autoplay.paused=!1,l("autoplayResume"))},C=()=>{if(i.destroyed||!i.autoplay.running)return;const e=a();"hidden"===e.visibilityState&&(f=!0,T(!0)),"visible"===e.visibilityState&&M()},P=e=>{"mouse"===e.pointerType&&(f=!0,T(!0))},L=e=>{"mouse"===e.pointerType&&i.autoplay.paused&&M()};n("init",(()=>{i.params.autoplay.enabled&&(i.params.autoplay.pauseOnMouseEnter&&(i.el.addEventListener("pointerenter",P),i.el.addEventListener("pointerleave",L)),a().addEventListener("visibilitychange",C),w=(new Date).getTime(),x())})),n("destroy",(()=>{i.el.removeEventListener("pointerenter",P),i.el.removeEventListener("pointerleave",L),a().removeEventListener("visibilitychange",C),i.autoplay.running&&S()})),n("beforeTransitionStart",((e,t,s)=>{!i.destroyed&&i.autoplay.running&&(s||!i.params.autoplay.disableOnInteraction?T(!0,!0):S())})),n("sliderFirstMove",(()=>{!i.destroyed&&i.autoplay.running&&(i.params.autoplay.disableOnInteraction?S():(p=!0,u=!1,f=!1,m=setTimeout((()=>{f=!0,u=!0,T(!0)}),200)))})),n("touchEnd",(()=>{if(!i.destroyed&&i.autoplay.running&&p){if(clearTimeout(m),clearTimeout(t),i.params.autoplay.disableOnInteraction)return u=!1,void(p=!1);u&&i.params.cssMode&&M(),u=!1,p=!1}})),n("slideChange",(()=>{!i.destroyed&&i.autoplay.running&&(h=!0)})),Object.assign(i.autoplay,{start:x,stop:S,pause:T,resume:M})},function(e){let{swiper:t,extendParams:s,on:i}=e;s({thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-thumbs"}});let r=!1,n=!1;function l(){const e=t.thumbs.swiper;if(!e||e.destroyed)return;const s=e.clickedIndex,a=e.clickedSlide;if(a&&a.classList.contains(t.params.thumbs.slideThumbActiveClass))return;if(null==s)return;let i;i=e.params.loop?parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"),10):s,t.params.loop?t.slideToLoop(i):t.slideTo(i)}function o(){const{thumbs:e}=t.params;if(r)return!1;r=!0;const s=t.constructor;if(e.swiper instanceof s)t.thumbs.swiper=e.swiper,Object.assign(t.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),Object.assign(t.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1}),t.thumbs.swiper.update();else if(d(e.swiper)){const a=Object.assign({},e.swiper);Object.assign(a,{watchSlidesProgress:!0,slideToClickedSlide:!1}),t.thumbs.swiper=new s(a),n=!0}return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass),t.thumbs.swiper.on("tap",l),!0}function c(e){const s=t.thumbs.swiper;if(!s||s.destroyed)return;const a="auto"===s.params.slidesPerView?s.slidesPerViewDynamic():s.params.slidesPerView;let i=1;const r=t.params.thumbs.slideThumbActiveClass;if(t.params.slidesPerView>1&&!t.params.centeredSlides&&(i=t.params.slidesPerView),t.params.thumbs.multipleActiveThumbs||(i=1),i=Math.floor(i),s.slides.forEach((e=>e.classList.remove(r))),s.params.loop||s.params.virtual&&s.params.virtual.enabled)for(let e=0;e<i;e+=1)f(s.slidesEl,`[data-swiper-slide-index="${t.realIndex+e}"]`).forEach((e=>{e.classList.add(r)}));else for(let e=0;e<i;e+=1)s.slides[t.realIndex+e]&&s.slides[t.realIndex+e].classList.add(r);const n=t.params.thumbs.autoScrollOffset,l=n&&!s.params.loop;if(t.realIndex!==s.realIndex||l){const i=s.activeIndex;let r,o;if(s.params.loop){const e=s.slides.filter((e=>e.getAttribute("data-swiper-slide-index")===`${t.realIndex}`))[0];r=s.slides.indexOf(e),o=t.activeIndex>t.previousIndex?"next":"prev"}else r=t.realIndex,o=r>t.previousIndex?"next":"prev";l&&(r+="next"===o?n:-1*n),s.visibleSlidesIndexes&&s.visibleSlidesIndexes.indexOf(r)<0&&(s.params.centeredSlides?r=r>i?r-Math.floor(a/2)+1:r+Math.floor(a/2)-1:r>i&&s.params.slidesPerGroup,s.slideTo(r,e?0:void 0))}}t.thumbs={swiper:null},i("beforeInit",(()=>{const{thumbs:e}=t.params;if(e&&e.swiper)if("string"==typeof e.swiper||e.swiper instanceof HTMLElement){const s=a(),i=()=>{const a="string"==typeof e.swiper?s.querySelector(e.swiper):e.swiper;if(a&&a.swiper)e.swiper=a.swiper,o(),c(!0);else if(a){const s=i=>{e.swiper=i.detail[0],a.removeEventListener("init",s),o(),c(!0),e.swiper.update(),t.update()};a.addEventListener("init",s)}return a},r=()=>{if(t.destroyed)return;i()||requestAnimationFrame(r)};requestAnimationFrame(r)}else o(),c(!0)})),i("slideChange update resize observerUpdate",(()=>{c()})),i("setTransition",((e,s)=>{const a=t.thumbs.swiper;a&&!a.destroyed&&a.setTransition(s)})),i("beforeDestroy",(()=>{const e=t.thumbs.swiper;e&&!e.destroyed&&n&&e.destroy()})),Object.assign(t.thumbs,{init:o,update:c})},function(e){let{swiper:t,extendParams:s,emit:a,once:i}=e;s({freeMode:{enabled:!1,momentum:!0,momentumRatio:1,momentumBounce:!0,momentumBounceRatio:1,momentumVelocityRatio:1,sticky:!1,minimumVelocity:.02}}),Object.assign(t,{freeMode:{onTouchStart:function(){const e=t.getTranslate();t.setTranslate(e),t.setTransition(0),t.touchEventsData.velocities.length=0,t.freeMode.onTouchEnd({currentPos:t.rtl?t.translate:-t.translate})},onTouchMove:function(){const{touchEventsData:e,touches:s}=t;0===e.velocities.length&&e.velocities.push({position:s[t.isHorizontal()?"startX":"startY"],time:e.touchStartTime}),e.velocities.push({position:s[t.isHorizontal()?"currentX":"currentY"],time:l()})},onTouchEnd:function(e){let{currentPos:s}=e;const{params:r,wrapperEl:n,rtlTranslate:o,snapGrid:d,touchEventsData:c}=t,p=l()-c.touchStartTime;if(s<-t.minTranslate())t.slideTo(t.activeIndex);else if(s>-t.maxTranslate())t.slides.length<d.length?t.slideTo(d.length-1):t.slideTo(t.slides.length-1);else{if(r.freeMode.momentum){if(c.velocities.length>1){const e=c.velocities.pop(),s=c.velocities.pop(),a=e.position-s.position,i=e.time-s.time;t.velocity=a/i,t.velocity/=2,Math.abs(t.velocity)<r.freeMode.minimumVelocity&&(t.velocity=0),(i>150||l()-e.time>300)&&(t.velocity=0)}else t.velocity=0;t.velocity*=r.freeMode.momentumVelocityRatio,c.velocities.length=0;let e=1e3*r.freeMode.momentumRatio;const s=t.velocity*e;let p=t.translate+s;o&&(p=-p);let u,m=!1;const h=20*Math.abs(t.velocity)*r.freeMode.momentumBounceRatio;let f;if(p<t.maxTranslate())r.freeMode.momentumBounce?(p+t.maxTranslate()<-h&&(p=t.maxTranslate()-h),u=t.maxTranslate(),m=!0,c.allowMomentumBounce=!0):p=t.maxTranslate(),r.loop&&r.centeredSlides&&(f=!0);else if(p>t.minTranslate())r.freeMode.momentumBounce?(p-t.minTranslate()>h&&(p=t.minTranslate()+h),u=t.minTranslate(),m=!0,c.allowMomentumBounce=!0):p=t.minTranslate(),r.loop&&r.centeredSlides&&(f=!0);else if(r.freeMode.sticky){let e;for(let t=0;t<d.length;t+=1)if(d[t]>-p){e=t;break}p=Math.abs(d[e]-p)<Math.abs(d[e-1]-p)||"next"===t.swipeDirection?d[e]:d[e-1],p=-p}if(f&&i("transitionEnd",(()=>{t.loopFix()})),0!==t.velocity){if(e=o?Math.abs((-p-t.translate)/t.velocity):Math.abs((p-t.translate)/t.velocity),r.freeMode.sticky){const s=Math.abs((o?-p:p)-t.translate),a=t.slidesSizesGrid[t.activeIndex];e=s<a?r.speed:s<2*a?1.5*r.speed:2.5*r.speed}}else if(r.freeMode.sticky)return void t.slideToClosest();r.freeMode.momentumBounce&&m?(t.updateProgress(u),t.setTransition(e),t.setTranslate(p),t.transitionStart(!0,t.swipeDirection),t.animating=!0,E(n,(()=>{t&&!t.destroyed&&c.allowMomentumBounce&&(a("momentumBounce"),t.setTransition(r.speed),setTimeout((()=>{t.setTranslate(u),E(n,(()=>{t&&!t.destroyed&&t.transitionEnd()}))}),0))}))):t.velocity?(a("_freeModeNoMomentumRelease"),t.updateProgress(p),t.setTransition(e),t.setTranslate(p),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,E(n,(()=>{t&&!t.destroyed&&t.transitionEnd()})))):t.updateProgress(p),t.updateActiveIndex(),t.updateSlidesClasses()}else{if(r.freeMode.sticky)return void t.slideToClosest();r.freeMode&&a("_freeModeNoMomentumRelease")}(!r.freeMode.momentum||p>=r.longSwipesMs)&&(t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}}}})},function(e){let t,s,a,{swiper:i,extendParams:r}=e;r({grid:{rows:1,fill:"column"}}),i.grid={initSlides:e=>{const{slidesPerView:r}=i.params,{rows:n,fill:l}=i.params.grid;s=t/n,a=Math.floor(e/n),t=Math.floor(e/n)===e/n?e:Math.ceil(e/n)*n,"auto"!==r&&"row"===l&&(t=Math.max(t,r*n))},updateSlide:(e,r,n,l)=>{const{slidesPerGroup:o,spaceBetween:d}=i.params,{rows:c,fill:p}=i.params.grid;let u,m,h;if("row"===p&&o>1){const s=Math.floor(e/(o*c)),a=e-c*o*s,i=0===s?o:Math.min(Math.ceil((n-s*c*o)/c),o);h=Math.floor(a/i),m=a-h*i+s*o,u=m+h*t/c,r.style.order=u}else"column"===p?(m=Math.floor(e/c),h=e-m*c,(m>a||m===a&&h===c-1)&&(h+=1,h>=c&&(h=0,m+=1))):(h=Math.floor(e/s),m=e-h*s);r.style[l("margin-top")]=0!==h?d&&`${d}px`:""},updateWrapperSize:(e,s,a)=>{const{spaceBetween:r,centeredSlides:n,roundLengths:l}=i.params,{rows:o}=i.params.grid;if(i.virtualSize=(e+r)*t,i.virtualSize=Math.ceil(i.virtualSize/o)-r,i.wrapperEl.style[a("width")]=`${i.virtualSize+r}px`,n){const e=[];for(let t=0;t<s.length;t+=1){let a=s[t];l&&(a=Math.floor(a)),s[t]<i.virtualSize+s[0]&&e.push(a)}s.splice(0,s.length),s.push(...e)}}}},function(e){let{swiper:t}=e;Object.assign(t,{appendSlide:te.bind(t),prependSlide:se.bind(t),addSlide:ae.bind(t),removeSlide:ie.bind(t),removeAllSlides:re.bind(t)})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({fadeEffect:{crossFade:!1}}),ne({effect:"fade",swiper:t,on:a,setTranslate:()=>{const{slides:e}=t;t.params.fadeEffect;for(let s=0;s<e.length;s+=1){const e=t.slides[s];let a=-e.swiperSlideOffset;t.params.virtualTranslate||(a-=t.translate);let i=0;t.isHorizontal()||(i=a,a=0);const r=t.params.fadeEffect.crossFade?Math.max(1-Math.abs(e.progress),0):1+Math.min(Math.max(e.progress,-1),0),n=le(0,e);n.style.opacity=r,n.style.transform=`translate3d(${a}px, ${i}px, 0px)`}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`})),oe({swiper:t,duration:e,transformElements:s,allSlides:!0})},overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}});const i=(e,t,s)=>{let a=s?e.querySelector(".swiper-slide-shadow-left"):e.querySelector(".swiper-slide-shadow-top"),i=s?e.querySelector(".swiper-slide-shadow-right"):e.querySelector(".swiper-slide-shadow-bottom");a||(a=g("div","swiper-slide-shadow-"+(s?"left":"top")),e.append(a)),i||(i=g("div","swiper-slide-shadow-"+(s?"right":"bottom")),e.append(i)),a&&(a.style.opacity=Math.max(-t,0)),i&&(i.style.opacity=Math.max(t,0))};ne({effect:"cube",swiper:t,on:a,setTranslate:()=>{const{el:e,wrapperEl:s,slides:a,width:r,height:n,rtlTranslate:l,size:o,browser:d}=t,c=t.params.cubeEffect,p=t.isHorizontal(),u=t.virtual&&t.params.virtual.enabled;let m,h=0;c.shadow&&(p?(m=t.slidesEl.querySelector(".swiper-cube-shadow"),m||(m=g("div","swiper-cube-shadow"),t.slidesEl.append(m)),m.style.height=`${r}px`):(m=e.querySelector(".swiper-cube-shadow"),m||(m=g("div","swiper-cube-shadow"),e.append(m))));for(let e=0;e<a.length;e+=1){const t=a[e];let s=e;u&&(s=parseInt(t.getAttribute("data-swiper-slide-index"),10));let r=90*s,n=Math.floor(r/360);l&&(r=-r,n=Math.floor(-r/360));const d=Math.max(Math.min(t.progress,1),-1);let m=0,f=0,g=0;s%4==0?(m=4*-n*o,g=0):(s-1)%4==0?(m=0,g=4*-n*o):(s-2)%4==0?(m=o+4*n*o,g=o):(s-3)%4==0&&(m=-o,g=3*o+4*o*n),l&&(m=-m),p||(f=m,m=0);const v=`rotateX(${p?0:-r}deg) rotateY(${p?r:0}deg) translate3d(${m}px, ${f}px, ${g}px)`;d<=1&&d>-1&&(h=90*s+90*d,l&&(h=90*-s-90*d)),t.style.transform=v,c.slideShadows&&i(t,d,p)}if(s.style.transformOrigin=`50% 50% -${o/2}px`,s.style["-webkit-transform-origin"]=`50% 50% -${o/2}px`,c.shadow)if(p)m.style.transform=`translate3d(0px, ${r/2+c.shadowOffset}px, ${-r/2}px) rotateX(90deg) rotateZ(0deg) scale(${c.shadowScale})`;else{const e=Math.abs(h)-90*Math.floor(Math.abs(h)/90),t=1.5-(Math.sin(2*e*Math.PI/360)/2+Math.cos(2*e*Math.PI/360)/2),s=c.shadowScale,a=c.shadowScale/t,i=c.shadowOffset;m.style.transform=`scale3d(${s}, 1, ${a}) translate3d(0px, ${n/2+i}px, ${-n/2/a}px) rotateX(-90deg)`}const f=(d.isSafari||d.isWebView)&&d.needPerspectiveFix?-o/2:0;s.style.transform=`translate3d(0px,0,${f}px) rotateX(${t.isHorizontal()?0:h}deg) rotateY(${t.isHorizontal()?-h:0}deg)`,s.style.setProperty("--swiper-cube-translate-z",`${f}px`)},setTransition:e=>{const{el:s,slides:a}=t;if(a.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),t.params.cubeEffect.shadow&&!t.isHorizontal()){const t=s.querySelector(".swiper-cube-shadow");t&&(t.style.transitionDuration=`${e}ms`)}},recreateShadows:()=>{const e=t.isHorizontal();t.slides.forEach((t=>{const s=Math.max(Math.min(t.progress,1),-1);i(t,s,e)}))},getEffectParams:()=>t.params.cubeEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({flipEffect:{slideShadows:!0,limitRotation:!0}});const i=(e,s,a)=>{let i=t.isHorizontal()?e.querySelector(".swiper-slide-shadow-left"):e.querySelector(".swiper-slide-shadow-top"),r=t.isHorizontal()?e.querySelector(".swiper-slide-shadow-right"):e.querySelector(".swiper-slide-shadow-bottom");i||(i=de(0,e,t.isHorizontal()?"left":"top")),r||(r=de(0,e,t.isHorizontal()?"right":"bottom")),i&&(i.style.opacity=Math.max(-s,0)),r&&(r.style.opacity=Math.max(s,0))};ne({effect:"flip",swiper:t,on:a,setTranslate:()=>{const{slides:e,rtlTranslate:s}=t,a=t.params.flipEffect;for(let r=0;r<e.length;r+=1){const n=e[r];let l=n.progress;t.params.flipEffect.limitRotation&&(l=Math.max(Math.min(n.progress,1),-1));const o=n.swiperSlideOffset;let d=-180*l,c=0,p=t.params.cssMode?-o-t.translate:-o,u=0;t.isHorizontal()?s&&(d=-d):(u=p,p=0,c=-d,d=0),n.style.zIndex=-Math.abs(Math.round(l))+e.length,a.slideShadows&&i(n,l);const m=`translate3d(${p}px, ${u}px, 0px) rotateX(${c}deg) rotateY(${d}deg)`;le(0,n).style.transform=m}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),oe({swiper:t,duration:e,transformElements:s})},recreateShadows:()=>{t.params.flipEffect;t.slides.forEach((e=>{let s=e.progress;t.params.flipEffect.limitRotation&&(s=Math.max(Math.min(e.progress,1),-1)),i(e,s)}))},getEffectParams:()=>t.params.flipEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({coverflowEffect:{rotate:50,stretch:0,depth:100,scale:1,modifier:1,slideShadows:!0}}),ne({effect:"coverflow",swiper:t,on:a,setTranslate:()=>{const{width:e,height:s,slides:a,slidesSizesGrid:i}=t,r=t.params.coverflowEffect,n=t.isHorizontal(),l=t.translate,o=n?e/2-l:s/2-l,d=n?r.rotate:-r.rotate,c=r.depth;for(let e=0,t=a.length;e<t;e+=1){const t=a[e],s=i[e],l=(o-t.swiperSlideOffset-s/2)/s,p="function"==typeof r.modifier?r.modifier(l):l*r.modifier;let u=n?d*p:0,m=n?0:d*p,h=-c*Math.abs(p),f=r.stretch;"string"==typeof f&&-1!==f.indexOf("%")&&(f=parseFloat(r.stretch)/100*s);let g=n?0:f*p,v=n?f*p:0,w=1-(1-r.scale)*Math.abs(p);Math.abs(v)<.001&&(v=0),Math.abs(g)<.001&&(g=0),Math.abs(h)<.001&&(h=0),Math.abs(u)<.001&&(u=0),Math.abs(m)<.001&&(m=0),Math.abs(w)<.001&&(w=0);const b=`translate3d(${v}px,${g}px,${h}px)  rotateX(${m}deg) rotateY(${u}deg) scale(${w})`;if(le(0,t).style.transform=b,t.style.zIndex=1-Math.abs(Math.round(p)),r.slideShadows){let e=n?t.querySelector(".swiper-slide-shadow-left"):t.querySelector(".swiper-slide-shadow-top"),s=n?t.querySelector(".swiper-slide-shadow-right"):t.querySelector(".swiper-slide-shadow-bottom");e||(e=de(0,t,n?"left":"top")),s||(s=de(0,t,n?"right":"bottom")),e&&(e.style.opacity=p>0?p:0),s&&(s.style.opacity=-p>0?-p:0)}}},setTransition:e=>{t.slides.map((e=>h(e))).forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))}))},perspective:()=>!0,overwriteParams:()=>({watchSlidesProgress:!0})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({creativeEffect:{limitProgress:1,shadowPerProgress:!1,progressMultiplier:1,perspective:!0,prev:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1},next:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1}}});const i=e=>"string"==typeof e?e:`${e}px`;ne({effect:"creative",swiper:t,on:a,setTranslate:()=>{const{slides:e,wrapperEl:s,slidesSizesGrid:a}=t,r=t.params.creativeEffect,{progressMultiplier:n}=r,l=t.params.centeredSlides;if(l){const e=a[0]/2-t.params.slidesOffsetBefore||0;s.style.transform=`translateX(calc(50% - ${e}px))`}for(let s=0;s<e.length;s+=1){const a=e[s],o=a.progress,d=Math.min(Math.max(a.progress,-r.limitProgress),r.limitProgress);let c=d;l||(c=Math.min(Math.max(a.originalProgress,-r.limitProgress),r.limitProgress));const p=a.swiperSlideOffset,u=[t.params.cssMode?-p-t.translate:-p,0,0],m=[0,0,0];let h=!1;t.isHorizontal()||(u[1]=u[0],u[0]=0);let f={translate:[0,0,0],rotate:[0,0,0],scale:1,opacity:1};d<0?(f=r.next,h=!0):d>0&&(f=r.prev,h=!0),u.forEach(((e,t)=>{u[t]=`calc(${e}px + (${i(f.translate[t])} * ${Math.abs(d*n)}))`})),m.forEach(((e,t)=>{m[t]=f.rotate[t]*Math.abs(d*n)})),a.style.zIndex=-Math.abs(Math.round(o))+e.length;const g=u.join(", "),v=`rotateX(${m[0]}deg) rotateY(${m[1]}deg) rotateZ(${m[2]}deg)`,w=c<0?`scale(${1+(1-f.scale)*c*n})`:`scale(${1-(1-f.scale)*c*n})`,b=c<0?1+(1-f.opacity)*c*n:1-(1-f.opacity)*c*n,y=`translate3d(${g}) ${v} ${w}`;if(h&&f.shadow||!h){let e=a.querySelector(".swiper-slide-shadow");if(!e&&f.shadow&&(e=de(0,a)),e){const t=r.shadowPerProgress?d*(1/r.limitProgress):d;e.style.opacity=Math.min(Math.max(Math.abs(t),0),1)}}const E=le(0,a);E.style.transform=y,E.style.opacity=b,f.origin&&(E.style.transformOrigin=b)}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),oe({swiper:t,duration:e,transformElements:s,allSlides:!0})},perspective:()=>t.params.creativeEffect.perspective,overwriteParams:()=>({watchSlidesProgress:!0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({cardsEffect:{slideShadows:!0,rotate:!0,perSlideRotate:2,perSlideOffset:8}}),ne({effect:"cards",swiper:t,on:a,setTranslate:()=>{const{slides:e,activeIndex:s}=t,a=t.params.cardsEffect,{startTranslate:i,isTouched:r}=t.touchEventsData,n=t.translate;for(let l=0;l<e.length;l+=1){const o=e[l],d=o.progress,c=Math.min(Math.max(d,-4),4);let p=o.swiperSlideOffset;t.params.centeredSlides&&!t.params.cssMode&&(t.wrapperEl.style.transform=`translateX(${t.minTranslate()}px)`),t.params.centeredSlides&&t.params.cssMode&&(p-=e[0].swiperSlideOffset);let u=t.params.cssMode?-p-t.translate:-p,m=0;const h=-100*Math.abs(c);let f=1,g=-a.perSlideRotate*c,v=a.perSlideOffset-.75*Math.abs(c);const w=t.virtual&&t.params.virtual.enabled?t.virtual.from+l:l,b=(w===s||w===s-1)&&c>0&&c<1&&(r||t.params.cssMode)&&n<i,y=(w===s||w===s+1)&&c<0&&c>-1&&(r||t.params.cssMode)&&n>i;if(b||y){const e=(1-Math.abs((Math.abs(c)-.5)/.5))**.5;g+=-28*c*e,f+=-.5*e,v+=96*e,m=-25*e*Math.abs(c)+"%"}if(u=c<0?`calc(${u}px + (${v*Math.abs(c)}%))`:c>0?`calc(${u}px + (-${v*Math.abs(c)}%))`:`${u}px`,!t.isHorizontal()){const e=m;m=u,u=e}const E=c<0?""+(1+(1-f)*c):""+(1-(1-f)*c),x=`\n        translate3d(${u}, ${m}, ${h}px)\n        rotateZ(${a.rotate?g:0}deg)\n        scale(${E})\n      `;if(a.slideShadows){let e=o.querySelector(".swiper-slide-shadow");e||(e=de(0,o)),e&&(e.style.opacity=Math.min(Math.max((Math.abs(c)-.5)/.5,0),1))}o.style.zIndex=-Math.abs(Math.round(d))+e.length;le(0,o).style.transform=x}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),oe({swiper:t,duration:e,transformElements:s})},perspective:()=>!0,overwriteParams:()=>({watchSlidesProgress:!0,virtualTranslate:!t.params.cssMode})})}];return Q.use(ce),Q}));
//# sourceMappingURL=swiper-bundle.min.js.map
if (document.getElementById("didomi_link")) {
  document.getElementById("didomi_link").onclick = function (event) {
    event.preventDefault();
    Didomi.preferences.show();
  };
}

/*
 * generic tabs
 * @param  {wrapper}           dom wrapper element     The element that wraps the tabs
 * @param  {callbackFunction}  function                Function to execute on active tab
 */
function generictabs(wrapper, callbackFunction) {
  const items = wrapper.querySelectorAll(".tablist li");
  const contents = wrapper.querySelectorAll(".tabpanels-container .tabpanel");
  items.forEach((item, index) => {
    contents[0].classList.add("visible");
    item.addEventListener("click", function () {
      // activate item in tab list
      const activeItem = wrapper.querySelector(
        ".tablist li[aria-selected=true]"
      );
      activeItem.setAttribute("aria-selected", "false");
      activeItem.setAttribute("tabindex", -1);
      item.setAttribute("aria-selected", "true");
      item.setAttribute("tabindex", 0);

      // activate content
      contents.forEach((content) => {
        content.setAttribute("hidden", "");
        // setTimeout(() => {
        //   content.classList.remove("visible");
        // }, "200");
      });
      contents[index].removeAttribute("hidden");
      setTimeout(() => {
        contents[index].classList.add("visible");
      }, "200");

      let activeContent = contents[index];

      // callback - ex: init swiper
      if (callbackFunction) {
        callbackFunction(activeContent);
      }
    });
  });
}

/* callback - init swiper in experience tabs
 * @param  {activeContent} / html node / The active tab container
 */
function initTabSwiper(activeContent) {
  if (activeContent.querySelector(".swiper-initialized")) {
    activeContent.querySelector(".swiper-initialized").swiper.destroy();
  }
  const tabSlider = new Swiper(activeContent.querySelector(".tab-xp-swiper"), {
    slidesPerView: 2.5,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      380: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      480: {
        slidesPerView: 1.75,
        spaceBetween: 40,
      },
      640: {
        slidesPerView: 1.75,
        spaceBetween: 40,
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 40,
        navigation: {
          nextEl: activeContent
            .querySelector(".tab-xp-swiper")
            .nextElementSibling.querySelector(".tab-xp-swiper-button-next"),
          prevEl: activeContent
            .querySelector(".tab-xp-swiper")
            .nextElementSibling.querySelector(".tab-xp-swiper-button-prev"),
        },
      },
    },
    clickable: true,
  });
}

(function ($) {
  if (document.querySelector(".bloc-access-paragraph .tabs-global-container")) {
    const wrapper = document.querySelector(
      ".bloc-access-paragraph .tabs-global-container"
    );
    generictabs(wrapper);
  }
})();

gsap.registerPlugin(ScrollTrigger);

(function ($) {
  if (document.querySelector(".accordion")) {
    let groups = gsap.utils.toArray(".accordion-group");
    let menus = gsap.utils.toArray(".accordion-group button");
    let menuToggles = groups.map(createAnimation);

    menus.forEach((menu) => {
      menu.addEventListener("click", () => toggleMenu(menu));
    });
    // menus[0].click();

    function toggleMenu(clickedMenu) {
      menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
    }

    function createAnimation(element) {
      let menu = element.querySelector("button");
      let box = element.querySelector("dd");
      let minusElement = element.querySelector(".accordion-minus");
      let plusElement = element.querySelector(".accordion-plus");

      gsap.set(box, { height: "auto" });

      let animation = gsap
        .timeline()
        .from(box, {
          height: 0,
          duration: 0.25,
          ease: "power1.inOut",
          onComplete: () => {
            menus.forEach((x) => x.setAttribute("aria-expanded", "false"));
            menu.setAttribute("aria-expanded", "true");
          },
        })
        .from(minusElement, { duration: 0.2, autoAlpha: 0, ease: "none" }, 0)
        .to(plusElement, { duration: 0.2, autoAlpha: 0, ease: "none" }, 0)
        .reverse();

      return function (clickedMenu) {
        if (clickedMenu === menu) {
          animation.reversed(!animation.reversed());
        } else {
          animation.reverse();
        }
      };
    }
  }
})();

(function ($) {
  if (document.querySelector(".bloc-animal-filter-search")) {
    const swiperContainerEl = document.querySelector(
      ".bloc-animal-filter-search"
    );
    const speciesSwiper = new Swiper(
      swiperContainerEl.querySelector(".species-swiper"),
      {
        spaceBetween: 0,
        breakpoints: {
          slidesPerView: 1,
          768: {
            slidesPerView: 5,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 0,
          },
        },
        navigation: {
          nextEl: swiperContainerEl.querySelector(
            ".species-swiper-button-next"
          ),
          prevEl: swiperContainerEl.querySelector(
            ".species-swiper-button-prev"
          ),
        },
        clickable: false,
      }
    );
  }
})();

(function ($) {
  if (!!document.querySelectorAll(".animal-push-swiper")?.length) {
    /* before initialization
     * handling possible multiple occurence of animal-push-swiper
     */
    const animalPushSwipers = document.querySelectorAll(".animal-push-swiper");
    for (i = 0; i < animalPushSwipers.length; i++) {
      const animalPushSwiper = new Swiper(animalPushSwipers[i], {
        slidesPerView: 2.5,
        watchOverflow: true,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          380: {
            slidesPerView: 1.15,
            spaceBetween: 20,
          },
          480: {
            slidesPerView: 1.5,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 1.75,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          // 1200: {
          //   slidesPerView: 3.125,
          // },
        },
        navigation: {
          enabled: !!animalPushSwipers[i].nextElementSibling,
          nextEl: animalPushSwipers[i].nextElementSibling?.querySelector(
            ".animal-push-swiper-button-next"
          ),
          prevEl: animalPushSwipers[i].nextElementSibling?.querySelector(
            ".animal-push-swiper-button-prev"
          ),
        },
        clickable: true,
      });
    }
  }
})();

(function ($) {
  if (!!document.querySelectorAll(".animations-push-swiper")?.length) {
    /* before initialization
     * handling possible multiple occurence of animations-push-swiper
     */
    const animationPushSwipers = document.querySelectorAll(
      ".animations-push-swiper"
    );
    for (i = 0; i < animationPushSwipers.length; i++) {
      const animationPushSwiper = new Swiper(animationPushSwipers[i], {
        slidesPerView: 2.5,
        breakpoints: {
          // when window width is >= 480px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          380: {
            slidesPerView: 1.25,
            spaceBetween: 20,
          },
          480: {
            slidesPerView: 1.75,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 1.75,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
        clickable: true,
      });
    }
  }
})();

(function ($) {
  // articles push swiper
  if (!!document.querySelectorAll(".articles-push-swiper")?.length) {
    /* before initialization
     * handling possible multiple occurence of articles-push-swiper
     */
    const articlePushSwipers = document.querySelectorAll(
      ".articles-push-swiper"
    );
    for (i = 0; i < articlePushSwipers.length; i++) {
      const articlePushSwiper = new Swiper(articlePushSwipers[i], {
        slidesPerView: 2.5,
        breakpoints: {
          // when window width is >= 480px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          380: {
            slidesPerView: 1.25,
            spaceBetween: 20,
          },
          480: {
            slidesPerView: 1.75,
            spaceBetween: 40,
          },
          640: {
            slidesPerView: 1.75,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          // 1200: {
          //   slidesPerView: 3.125,
          // },
        },
        navigation: {
          nextEl: articlePushSwipers[i].nextElementSibling.querySelector(
            ".new-articles-swiper-button-next"
          ),
          prevEl: articlePushSwipers[i].nextElementSibling.querySelector(
            ".new-articles-swiper-button-prev"
          ),
        },
        clickable: true,
      });
    }
  }
})();

const updateCartTotalPrice = () => {
  const totalPriceArray = [];
  let totalPriceValue = 0;
  const mobileContentWrapper = document?.querySelector(".mobile-intra-step");

  if (
    document.querySelector(".cart-content")?.querySelectorAll("[data-price]")
  ) {
    document
      .querySelector(".cart-content")
      ?.querySelectorAll("[data-price]")
      ?.forEach((x) => {
        totalPriceArray.push(x.getAttribute("data-price"));
      });
  }

  if (totalPriceArray?.length) {
    totalPriceValue = totalPriceArray.reduce(
      (accumulator, currentValue) =>
        parseFloat(accumulator) + parseFloat(currentValue)
    );
  }

  const mobileContent = document.createElement("p");
  mobileContent.setAttribute("id", `cart-content--total`);
  mobileContent.innerHTML = `<span>${mobileContentWrapper.getAttribute(
    "data-trad"
  )}</span> ${parseFloat(totalPriceValue).toFixed(2)}€`;
  mobileContent.setAttribute(
    "data-totalcart",
    parseFloat(totalPriceValue).toFixed(2)
  );

  if (totalPriceArray?.length < 2) {
    mobileContentWrapper.classList.add("desktop-hidden");
  } else {
    mobileContentWrapper.classList.remove("desktop-hidden");
  }

  const verifyMobileContent = document.getElementById(`cart-content--total`);

  if (!verifyMobileContent) {
    mobileContentWrapper.appendChild(mobileContent);
  } else {
    verifyMobileContent.innerHTML = `<span>${mobileContentWrapper.getAttribute(
      "data-trad"
    )}</span> ${parseFloat(totalPriceValue).toFixed(2)}€`;
    verifyMobileContent.setAttribute(
      "data-totalcart",
      parseFloat(totalPriceValue).toFixed(2)
    );

    if (totalPriceArray?.length < 2 && parseInt(totalPriceValue, 10) !== 0) {
      verifyMobileContent.classList.add("desktop-hidden");
    } else {
      verifyMobileContent.classList.remove("desktop-hidden");
    }

    if (totalPriceArray?.length === 1 && parseInt(totalPriceValue, 10) !== 0) {
      mobileContentWrapper.classList.add("desktop-hidden");
    } else {
      mobileContentWrapper.classList.remove("desktop-hidden");
    }

    if (document.querySelector("#customer-journey-step-date-time")) {
      if (totalPriceArray?.length > 1) {
        mobileContentWrapper.classList.add("visible");
      } else {
        mobileContentWrapper.classList.remove("visible");
      }
    }

    if (document.querySelector("#customer-journey-step-billets")) {
      if (totalPriceArray?.length > 1) {
        mobileContentWrapper.classList.add("visible");
      } else {
        mobileContentWrapper.classList.remove("visible");
      }
      if (totalPriceArray?.length > 0) {
        document.querySelector(".reminder").setAttribute("hidden", "");
      } else {
        document.querySelector(".reminder").removeAttribute("hidden");
      }
    }
  }
};

function dateFormatOption(){
  return {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric",
  }
}


function cartDynamicHandling(elDialog) {
  const cartData = structuredClone(window.crossSellEvent);

  for (let index = 0; index < cartData.length; index += 1) {
    const cartItem = cartData[index];

    if (cartItem?.time && cartItem?.tickets?.length) {
      if (!document.getElementById(`item_${cartItem.id}`)) {
        const newItem = document.createElement("div");
        newItem.classList.add("cart-item");
        newItem.setAttribute("id", `item_${cartItem.id}`);
        // document.querySelector(".dynamic-front-cart").appendChild(newItem);
        document.querySelector(".cart-from-backend").appendChild(newItem);
      }

      if (
        !document
          .getElementById(`item_${cartItem.id}`)
          .querySelector(".cart-item-header")
      ) {
        const newItemHeader = document.createElement("div");
        newItemHeader.classList.add("cart-item-header");
        document
          .querySelector(`#item_${cartItem.id}`)
          .appendChild(newItemHeader);
      }

      if (cartItem?.title) {
        document
          .getElementById(`item_${cartItem.id}`)
          .querySelector(".cart-item-header").innerHTML = "";
        const cartTitle = document.createElement("h3");
        cartTitle.classList.add("cart-item-title");
        cartTitle.innerHTML = cartItem.title;
        document
          .querySelector(`#item_${cartItem.id}`)
          .querySelector(".cart-item-header")
          .appendChild(cartTitle);
      }

      if (cartItem?.time && cartItem?.date) {
        const cartDateTime = document.createElement("p");
        cartDateTime.classList.add("cart-item-date-time");
        document
          .querySelector(`#item_${cartItem.id}`)
          .querySelector(".cart-item-header")
          .appendChild(cartDateTime);
        if (cartItem?.date) {
          const cartDate = document.createElement("span");
          cartDate.classList.add("cart-item-date");
          const currentLang = document
            .querySelector("html")
            .getAttribute("lang");
          const thisYear = cartItem.date.split("-")[0];
          const options = dateFormatOption();
          const cartItemDate = cartItem.date
            .split("")
            .map((char) => char.replace("-", "/"))
            .join("");
          const formatDate = new Date(cartItemDate)
            .toLocaleDateString(currentLang, options)
            .replace(thisYear, "");
          const formatedDate =
            formatDate.charAt(0).toUpperCase() + formatDate.slice(1);
          cartDate.innerHTML = `${formatedDate} `;
          document
            .querySelector(`#item_${cartItem.id}`)
            .querySelector(".cart-item-date-time")
            .appendChild(cartDate);
        }
        if (window.cartTraduction?.at) {
          const cartAt = document.createElement("span");
          cartAt.classList.add("cart-item-at");
          cartAt.setAttribute("style", "display: inline");
          cartAt.innerHTML = window.cartTraduction.at;
          document
            .querySelector(`#item_${cartItem.id}`)
            .querySelector(".cart-item-date-time")
            .appendChild(cartAt);
        }
        if (cartItem?.time) {
          const cartTime = document.createElement("span");
          cartTime.classList.add("cart-item-time");
          cartTime.innerHTML = ` ${cartItem.time.replace(":", "h")}`;
          document
            .querySelector(`#item_${cartItem.id}`)
            .querySelector(".cart-item-date-time")
            .appendChild(cartTime);
        }
        document
          .getElementById(`item_${cartItem.id}`)
          .classList.add("cart-item-with-date");
      }

      if (cartItem?.time && !cartItem?.date) {
        if (
          !document.getElementById(`item_${cartItem.id}`).querySelector(".time")
        ) {
          const timeParagrah = document.createElement("p");
          timeParagrah.classList.add("time");
          timeParagrah.setAttribute("aria-label", window.cartTraduction?.time);
          document
            .querySelector(`#item_${cartItem.id}`)
            .querySelector(".cart-item-header")
            .after(timeParagrah);
        }
        document
          .getElementById(`item_${cartItem.id}`)
          .querySelector(".time").innerHTML = cartItem.time.remplace(":", "h");
      }

      if (cartItem?.tickets) {
        document
          .querySelector(`#item_${cartItem.id}`)
          .querySelectorAll(".two-col-sb")
          .forEach((x) => x.remove());
        for (
          let ticketIndex = 0;
          ticketIndex < cartItem.tickets.length;
          ticketIndex += 1
        ) {
          const cartItemProduct = cartItem.tickets[ticketIndex];

          const newTicket = document.createElement("div");
          newTicket.classList.add("two-col-sb");
          newTicket.setAttribute("id", cartItemProduct.tarifId);
          newTicketDetail = document.createElement("p");
          newTicketDetail.classList.add("cart-item-subtitle");
          newTicketDetail.innerHTML = `${cartItemProduct.number} x ${cartItemProduct.label}`;
          newTicket.appendChild(newTicketDetail);

          newTicketPrice = document.createElement("p");
          newTicketPrice.classList.add("cart-item-price");
          newTicketPrice.setAttribute(
            "data-price",
            cartItemProduct.price.toFixed(2)
          );
          newTicketPrice.innerHTML = `<span>${cartItemProduct.price.toFixed(
            2
          )}</span>€`;
          newTicket.appendChild(newTicketPrice);

          document.querySelector(`#item_${cartItem.id}`).appendChild(newTicket);

          updateCartTotalPrice();
        }
      }
    }
  }

  elDialog.querySelector(".close-dialog").click();

  /** update virtual cart price */
  const cartTotalPrice = parseFloat(
    document
      .getElementById("cart-content--total")
      .getAttribute("data-totalcart")
  );
  document
    .querySelectorAll(".modal-total-cart-price")
    .forEach((x) => (x.innerHTML = parseFloat(cartTotalPrice).toFixed(2)));
  document.querySelector(".reminder")?.setAttribute("hidden", "");
}

//= require ./b--u-updateCartTotalPrice.js
//= require ./b--u-dateFormatOption.js

function createModificationBtn(containerClass, cartItemId, url) {
  const modificationBtn = document.createElement("a");
  modificationBtn.classList.add("btn--icon", "cart-item-modification");
  modificationBtn.setAttribute(
    "title",
    window?.cartTraduction?.modify || "Modifier"
  );
  modificationBtn.setAttribute("href", url);
  const icon = document.createElement("img");
  icon.setAttribute(
    "src",
    "/themes/custom/nausicaa/assets/img/icons/icon-edit.svg"
  );
  icon.setAttribute("alt", "");
  modificationBtn.appendChild(icon);
  document
    .querySelector(cartItemId)
    ?.querySelector(`.${containerClass}`)
    ?.appendChild(modificationBtn);
  document
    .querySelector(cartItemId)
    ?.querySelector(`.${containerClass}`)
    ?.classList.add("cart-item-modification-container");
}

function cartFromBackendHandling() {
  const cartData = window.cartFromBackend;
  for (let index = 0; index < cartData.length; index += 1) {
    const cartItem = cartData[index];
    const newItem = document.createElement("div");
    newItem.classList.add("cart-item");
    newItem.setAttribute("id", `item_${cartItem.id}`);
    document.querySelector(".cart-from-backend").appendChild(newItem);

    if (cartItem?.title || cartItem?.date || cartItem?.time) {
      const newItemHeader = document.createElement("div");
      newItemHeader.classList.add("cart-item-header");
      document.querySelector(`#item_${cartItem.id}`).appendChild(newItemHeader);

      if (cartItem?.title) {
        const cartTitle = document.createElement("h3");
        cartTitle.classList.add("cart-item-title");
        cartTitle.innerHTML = cartItem.title;
        document
          .querySelector(`#item_${cartItem.id}`)
          .querySelector(".cart-item-header")
          .appendChild(cartTitle);
        /** add modification btn */
        if (cartItem.ticket_modification_url) {
          createModificationBtn(
            "cart-item-title",
            `#item_${cartItem.id}`,
            cartItem.ticket_modification_url
          );
        }
        /** to remove - only for test waiting for data update */
        // else {
        //   createModificationBtn("cart-item-title", `#item_${cartItem.id}`, "#");
        // }
      }
      if (cartItem?.date || cartItem?.time) {
        const cartDateTime = document.createElement("p");
        cartDateTime.classList.add("cart-item-date-time");
        document
          .querySelector(`#item_${cartItem.id}`)
          .querySelector(".cart-item-header")
          .appendChild(cartDateTime);
        if (cartItem?.date) {
          const cartDate = document.createElement("span");
          cartDate.classList.add("cart-item-date");
          const currentLang = document
            .querySelector("html")
            .getAttribute("lang");
          const thisYear = cartItem.date.split("-")[0];
          const options = dateFormatOption();
          const cartItemDate = cartItem.date
            .split("")
            .map((char) => char.replace("-", "/"))
            .join("");
          const formatDate = new Date(cartItemDate)
            .toLocaleDateString(currentLang, options)
            .replace(thisYear, "");
          const formatedDate =
            formatDate.charAt(0).toUpperCase() + formatDate.slice(1);
          cartDate.innerHTML = `${formatedDate} `;
          document
            .querySelector(`#item_${cartItem.id}`)
            .querySelector(".cart-item-date-time")
            .appendChild(cartDate);
        }
        if (window.cartTraduction?.at) {
          const cartAt = document.createElement("span");
          cartAt.classList.add("cart-item-at");
          cartAt.setAttribute("style", "display: inline");
          cartAt.innerHTML = window.cartTraduction.at;
          document
            .querySelector(`#item_${cartItem.id}`)
            .querySelector(".cart-item-date-time")
            .appendChild(cartAt);
        }
        if (cartItem?.time) {
          const cartTime = document.createElement("span");
          cartTime.classList.add("cart-item-time");
          cartTime.innerHTML = ` ${cartItem.time.replace(":", "h")}`;
          document
            .querySelector(`#item_${cartItem.id}`)
            .querySelector(".cart-item-date-time")
            .appendChild(cartTime);
        }

        /** add modification btn */
        if (cartItem.date_modification_url) {
          createModificationBtn(
            "cart-item-date-time",
            `#item_${cartItem.id}`,
            cartItem.date_modification_url
          );
        }
        /** to remove - only for test waiting for data update */
        // else {
        //   createModificationBtn(
        //     "cart-item-date-time",
        //     `#item_${cartItem.id}`,
        //     "#"
        //   );
        // }
      }
    }

    if (cartItem?.tickets) {
      for (
        let ticketIndex = 0;
        ticketIndex < cartItem.tickets.length;
        ticketIndex += 1
      ) {
        const cartItemProduct = cartItem.tickets[ticketIndex];

        const newTicket = document.createElement("div");
        newTicket.classList.add("two-col-sb");
        newTicket.setAttribute("id", `group-${cartItemProduct.tarifId}`);
        newTicketDetail = document.createElement("p");
        newTicketDetail.classList.add("cart-item-subtitle");
        newTicketDetail.innerHTML = `${cartItemProduct.number} x ${cartItemProduct.label}`;
        newTicket.appendChild(newTicketDetail);

        newTicketPrice = document.createElement("p");
        newTicketPrice.classList.add("cart-item-price");
        newTicketPrice.setAttribute(
          "data-price",
          cartItemProduct.price.toFixed(2)
        );
        newTicketPrice.innerHTML = `<span>${cartItemProduct.price.toFixed(
          2
        )}</span>€`;
        newTicket.appendChild(newTicketPrice);

        document.querySelector(`#item_${cartItem.id}`).appendChild(newTicket);

        updateCartTotalPrice();
      }
    }
  }
}

function communicationCtr() {
  if (
    document.querySelector(".communication-container")?.childNodes?.length ===
      0 ||
    (document.querySelector(".communication-container")?.childNodes?.length ===
      1 &&
      document.querySelector(".communication-container")?.childNodes?.[0]
        ?.nodeType !== Node.ELEMENT_NODE)
  ) {
    document
      .querySelector(".communication-container")
      .setAttribute("style", "display: none");
  } else {
    document.querySelector(".communication-container").removeAttribute("style");
  }
}

function displayDialog(dialogId, buttonId, callback) {
  const isAString = typeof buttonId;
  /** is buttonId a string or a dom node */
  const validationButton =
    isAString === "string" ? document.querySelector(buttonId) : buttonId;
  const elDialog = document.querySelector(dialogId);
  const close = elDialog.querySelector(".close-dialog");

  function closeDialog() {
    validationButton.focus();

    elDialog.classList.remove("visible-dialog");
    document.querySelector("body").classList.remove("has-dialog");
    // eslint-disable-next-line no-use-before-define
    document.removeEventListener("keydown", addESC);
    elDialog.removeEventListener("keydown", closeDialog);

    setTimeout(() => {
      elDialog.style.display = "none";
    }, 250);
  }

  function addESC(e) {
    if (e.keyCode === 27) {
      closeDialog();
    }
  }

  function openDialog() {
    elDialog.style.display = "block";
    setTimeout(() => {
      elDialog.classList.add("visible-dialog");
    }, 100);

    document.addEventListener("keydown", addESC);
    document.querySelector("body").classList.add("has-dialog");
    if (elDialog.querySelector(".focusfirst")) {
      elDialog.querySelector(".focusfirst").focus();
    }
  }

  openDialog();

  close.addEventListener("click", () => {
    closeDialog();
  });

  elDialog.querySelector(".dialog-overlay").addEventListener("click", () => {
    closeDialog();
  });

  const dialog = elDialog;
  const focusableElementsArray = [
    "[href]",
    "button:not([disabled])",
    "input:not([disabled]):not([readonly])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])',
  ];
  const keyCodes = {
    tab: 9,
    enter: 13,
    escape: 27,
  };
  const focusableElements = dialog.querySelectorAll(focusableElementsArray);
  const firstFocusableElement = focusableElements[0];
  firstFocusableElement.focus();
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  // Garder le focus à l'intérieur de la modale critère 7.1
  focusableElements.forEach((focusableElement) => {
    if (focusableElement.addEventListener) {
      focusableElement.addEventListener("keydown", (event) => {
        const tab = event.which === keyCodes.tab;

        if (!tab) {
          return;
        }

        if (event.shiftKey) {
          if (event.target === firstFocusableElement) {
            // shift + tab
            event.preventDefault();

            lastFocusableElement.focus();
          }
        } else if (event.target === lastFocusableElement) {
          // tab
          event.preventDefault();

          firstFocusableElement.focus();
        }
      });
    }
  });
  if (callback) {
    callback(elDialog, validationButton);
  }
}


function confirmCallback(elDialog, validationButton) {
  elDialog.querySelector(".cancel-btn").addEventListener("click", () => {
    elDialog.querySelector(".close-dialog").click();
  });
  elDialog.querySelector(".confirm-btn").addEventListener("click", () => {
    const btnHref = validationButton.getAttribute("href");
    window.location.href = `${btnHref}`;
  });
}
function confirm() {
  const confirmation = document.querySelectorAll(".confirmation");
  confirmation.forEach((item) => {
    const btnId = item.getAttribute("id");
    item.addEventListener("click", (e) => {
      e.preventDefault();
      displayDialog(`#dialog_confirm`, `#${btnId}`, confirmCallback);
    });
  });
}

function createTimeTablist(data, container) {
  const tablistWrapper = container.querySelector(".tablist-wtapper > div");
  tablistWrapper.innerHTML = "";
  tablistWrapper.setAttribute("role", "tablist");

  /** creating tablist */
  for (let periodIndex = 0; periodIndex < data.length; periodIndex += 1) {
    const element = data[periodIndex];
    const newBtn = document.createElement("button");
    newBtn.classList.add("tab-button");
    newBtn.setAttribute("type", "button");
    newBtn.setAttribute("role", "tab");
    if (periodIndex === 0) {
      newBtn.setAttribute("aria-selected", "true");
    } else {
      newBtn.setAttribute("aria-selected", "false");
    }
    newBtn.setAttribute("tabindex", "-1");
    newBtn.setAttribute("id", `tab-${periodIndex}`);
    newBtn.setAttribute("aria-controls", `tabpanel-${periodIndex}`);
    const newSpan = document.createElement("span");
    newSpan.classList.add("focus");
    newSpan.innerText = element.label;
    newBtn.appendChild(newSpan);
    tablistWrapper.appendChild(newBtn);
  }
}

function createTimeTabPanels(data, container) {
  const tabPanelsWrapper = container.querySelector(".tabpanel-wrapper");
  tabPanelsWrapper.innerHTML = "";

  const windowWidth = window.innerWidth;

  for (let periodIndex = 0; periodIndex < data.length; periodIndex += 1) {
    const element = data[periodIndex];

    const newTabPanel = document.createElement("div");
    newTabPanel.classList.add("tabpanel");
    newTabPanel.setAttribute("id", `tabpanel-${periodIndex}`);
    if (periodIndex > 0) {
      newTabPanel.classList.add("is-hidden");
    }
    // const newTabTitle = document.createElement("h3");
    // newTabTitle.classList.add("tabpanel-desktop-title");
    // newTabTitle.innerText = element.label;
    // if (windowWidth < 1199) {
    //   newTabTitle.setAttribute("aria-hidden", "true");
    // } else {
    //   newTabTitle.setAttribute("tabindex", "0");
    // }
    // newTabPanel.appendChild(newTabTitle);

    const newContainer = document.createElement("div");
    newContainer.classList.add("checkbox-group-container");

    const timeData = element.data;
    for (let dataIndex = 0; dataIndex < timeData.length; dataIndex += 1) {
      const timeDataElement = timeData[dataIndex];
      const newInput = document.createElement("input");
      newInput.setAttribute("type", "checkbox");
      newInput.setAttribute("tabindex", "0");
      newInput.setAttribute("name", `visit-time-${periodIndex}-${dataIndex}`);
      newInput.setAttribute("id", `visit-time-${periodIndex}-${dataIndex}`);
      newInput.setAttribute("value", timeDataElement.label);

      const newHighlight = document.createElement("span");
      if (timeDataElement.highlight === true) {
        newHighlight.classList.add("last-tickets-available");
        newHighlight.setAttribute(
          "aria-label",
          tabPanelsWrapper.getAttribute("data-text")
        );
      }
      const timeDisplay = document.createElement("span");
      timeDisplay.classList.add("time-display");
      timeDisplay.innerText = timeDataElement.label;

      const checkDisplay = document.createElement("span");
      checkDisplay.classList.add("check-display");

      checkDisplay.appendChild(timeDisplay);

      /** check if available_quantity is available & use it for display & click */
      if (
        timeDataElement.available_quantity &&
        timeDataElement.available_quantity_full_txt
      ) {
        checkDisplay.classList.add("dispo-in");
        const dispoDisplay = document.createElement("span");
        dispoDisplay.classList.add("dispo-display");
        dispoDisplay.innerText = timeDataElement.available_quantity_full_txt;
        checkDisplay.appendChild(dispoDisplay);
        /** set data-input-max attribute equal to available_quantity so that we can use it on click */
        const maxValue = timeDataElement.available_quantity;
        newInput.setAttribute("data-input-max", maxValue);
      }

      const newLabel = document.createElement("label");
      newLabel.setAttribute("for", `visit-time-${periodIndex}-${dataIndex}`);

      const newWrapper = document.createElement("div");
      newWrapper.classList.add("checkbox-group-wrapper");

      newLabel.appendChild(newInput);
      newLabel.appendChild(checkDisplay);
      if (timeDataElement.highlight === true) {
        newLabel.appendChild(newHighlight);
      }
      newWrapper.appendChild(newLabel);
      newWrapper.appendChild(newLabel);
      newContainer.appendChild(newWrapper);

      newTabPanel.appendChild(newContainer);
      tabPanelsWrapper.appendChild(newTabPanel);
    }
  }
}

function createTimeTiles(data, container) {
  const productId = container.getAttribute("data-productid");
  const tabPanelsWrapper = container.querySelector(".tabpanel-wrapper");
  tabPanelsWrapper.innerHTML = "";

  const newTabPanel = document.createElement("div");
  newTabPanel.classList.add("tabpanel");
  newTabPanel.setAttribute("id", `tabpanel-${0}`);

  const newContainer = document.createElement("div");
  newContainer.classList.add("checkbox-group-container");

  const timeData = data;
  for (let dataIndex = 0; dataIndex < timeData.length; dataIndex += 1) {
    const timeDataElement = timeData[dataIndex];
    const newInput = document.createElement("input");
    newInput.setAttribute("type", "checkbox");
    newInput.setAttribute("tabindex", "0");
    newInput.setAttribute(
      "name",
      productId
        ? `${productId}_visit-time-${dataIndex}`
        : `visit-time-${dataIndex}`
    );
    newInput.setAttribute(
      "id",
      productId
        ? `${productId}_visit-time-${dataIndex}`
        : `visit-time-${dataIndex}`
    );

    if (timeDataElement.date) {
      newInput.setAttribute(
        "value",
        `date[${timeDataElement.date}]-time[${timeDataElement.label}]`
      );
      newInput.setAttribute("data-date", timeDataElement.date);
      newInput.setAttribute("data-time", timeDataElement.label);
    } else {
      newInput.setAttribute("value", timeDataElement.label);
    }

    const newHighlight = document.createElement("span");
    if (timeDataElement.highlight === true) {
      newHighlight.classList.add("last-tickets-available");
      newHighlight.setAttribute(
        "aria-label",
        tabPanelsWrapper.getAttribute("data-text")
      );
    }
    const timeDisplay = document.createElement("span");
    timeDisplay.classList.add("time-display");
    timeDisplay.innerText = timeDataElement.label;

    const checkDisplay = document.createElement("span");
    checkDisplay.classList.add("check-display");

    /** display date in tile if present in data */
    if (timeDataElement.date) {
      checkDisplay.classList.add("date-in");
      const dispoDisplay = document.createElement("span");
      dispoDisplay.classList.add("dispo-display");
      /** format date */
      const thisDay = timeDataElement.date.split("-")[2];
      const thisMonth = timeDataElement.date.split("-")[1];
      const thisYear = timeDataElement.date.split("-")[0];
      const currentLang = document.querySelector("html").getAttribute("lang");
      if (!currentLang || currentLang === "fr") {
        dispoDisplay.innerText = `${zeroLeading(thisDay)}/${zeroLeading(
          thisMonth
        )}/${thisYear} `;
      } else {
        dispoDisplay.innerText = `${thisYear}-${zeroLeading(
          thisMonth
        )}-${zeroLeading(thisDay)} `;
      }
      checkDisplay.appendChild(dispoDisplay);
    }

    checkDisplay.appendChild(timeDisplay);

    // /** check if available_quantity is available & use it for display & click */
    // if (
    //   timeDataElement.available_quantity &&
    //   timeDataElement.available_quantity_full_txt
    // ) {
    //   checkDisplay.classList.add("dispo-in");
    //   const dispoDisplay = document.createElement("span");
    //   dispoDisplay.classList.add("dispo-display");
    //   dispoDisplay.innerText = timeDataElement.available_quantity_full_txt;
    //   checkDisplay.appendChild(dispoDisplay);
    //   /** set data-input-max attribute equal to available_quantity so that we can use it on click */
    //   const maxValue = timeDataElement.available_quantity;
    //   newInput.setAttribute("data-input-max", maxValue);
    // }

    const newLabel = document.createElement("label");
    newLabel.setAttribute(
      "for",
      productId
        ? `${productId}_visit-time-${dataIndex}`
        : `visit-time-${dataIndex}`
    );

    const newWrapper = document.createElement("div");
    newWrapper.classList.add("checkbox-group-wrapper");

    newLabel.appendChild(newInput);
    newLabel.appendChild(checkDisplay);
    if (timeDataElement.highlight === true) {
      newLabel.appendChild(newHighlight);
    }
    newWrapper.appendChild(newLabel);
    newWrapper.appendChild(newLabel);
    newContainer.appendChild(newWrapper);

    newTabPanel.appendChild(newContainer);
    tabPanelsWrapper.appendChild(newTabPanel);
  }
}

//= require ./b--u-updateCartTotalPrice.js
//= require ./b--u-updateCartTotalPrice.js

const updateCart = ({ productId, number, item, price, subItem, tarifId }) => {
  const verify = document.getElementById(`item_${productId}`);

  if (!verify) {
    const updateWrapper = document.createElement("div");
    updateWrapper.classList.add("cart-item");
    updateWrapper.setAttribute("id", `item_${productId}`);
    document.querySelector(".dynamic-front-cart").appendChild(updateWrapper);
    if (
      !document.querySelector(".cart-from-backend").querySelector(".cart-item")
    ) {
      document
        .querySelector(".dynamic-front-cart")
        .classList.add("subscription-style-exception");
    }

    if (subItem) {
      const itemTwoCol = document.createElement("div");
      itemTwoCol.classList.add("two-col-sb");

      const itemTitle = document.createElement("h3");
      itemTitle.classList.add("cart-item-subtitle");
      itemTitle.innerHTML = `${number} x ${item}`;

      itemTwoCol.appendChild(itemTitle);

      const itemPrice = document.createElement("p");
      itemPrice.classList.add("cart-item-price");
      itemPrice.setAttribute("data-price", price.toFixed(2));
      itemPrice.innerHTML = "€";
      const newSpan2 = document.createElement("span");
      newSpan2.innerHTML = price.toFixed(2);
      itemPrice.prepend(newSpan2);

      itemTwoCol.appendChild(itemPrice);

      updateWrapper.appendChild(itemTwoCol);
    } else {
      const itemTitle = document.createElement("h3");
      itemTitle.classList.add("cart-item-title");
      itemTitle.innerHTML = `${item}`;

      const itemText = document.createElement("p");
      itemText.classList.add("cart-item-subtitle");
      itemText.innerHTML = `${number} x ${item}`;

      const itemPrice = document.createElement("p");
      itemPrice.classList.add("cart-item-price");
      itemPrice.setAttribute("data-price", price.toFixed(2));
      itemPrice.innerHTML = "€";
      const newSpan = document.createElement("span");
      newSpan.innerHTML = `${price.toFixed(2)}`;
      itemPrice.prepend(newSpan);

      const newLine = document.createElement("div");
      newLine.classList.add("two-col-sb");
      newLine.setAttribute("id", `group-${tarifId}`);
      newLine.appendChild(itemText);
      newLine.appendChild(itemPrice);

      updateWrapper.appendChild(itemTitle);
      // updateWrapper.appendChild(itemText);
      // updateWrapper.appendChild(itemPrice);
      updateWrapper.appendChild(newLine);
    }
  } else {
    if (subItem) {
      // let newLine;
      if (verify.querySelector(`#group-${tarifId}`)) {
        const newLine = verify.querySelector(`#group-${tarifId}`);
        newLine.querySelector(
          ".cart-item-subtitle"
        ).innerHTML = `${number} x ${item}`;
        newLine
          .querySelector(".cart-item-price")
          .setAttribute("data-price", price.toFixed(2));
        newLine
          .querySelector(".cart-item-price")
          .querySelector("span").innerHTML = price.toFixed(2);
        // newLine.innerHTML = "";
      } else {
        const newLine = document.createElement("div");
        newLine.classList.add("two-col-sb");
        newLine.setAttribute("id", `group-${tarifId}`);

        newLineDetail = document.createElement("p");
        newLineDetail.classList.add("cart-item-subtitle");
        newLineDetail.innerHTML = `${number} x ${item}`;
        newLine.appendChild(newLineDetail);

        newLinePrice = document.createElement("p");
        newLinePrice.classList.add("cart-item-price");
        newLinePrice.setAttribute("data-price", price.toFixed(2));
        newLinePrice.innerHTML = `<span>${price.toFixed(2)}</span>€`;
        newLine.appendChild(newLinePrice);
        verify.appendChild(newLine);
      }
      if (parseInt(number, 10) === 0) {
        verify.querySelector(`#group-${tarifId}`).remove();
      }
    } else {
      if (verify.querySelector(`#group-${tarifId}`)) {
        const newLine = verify.querySelector(`#group-${tarifId}`);
        newLine.querySelector(
          ".cart-item-subtitle"
        ).innerHTML = `${number} x ${item}`;
        newLine
          .querySelector(".cart-item-price")
          .setAttribute("data-price", price.toFixed(2));
        newLine
          .querySelector(".cart-item-price")
          .querySelector("span").innerHTML = price.toFixed(2);
        // newLine.innerHTML = "";
      }

      if (parseInt(number, 10) === 0) {
        document.querySelector(`#item_${productId}`).remove();
      }

      // verify.querySelector(".cart-item-text").innerHTML = `${number} ${item}`;
    }
  }
  if (!document.querySelector("#customer-journey-step-date-time")) {
    updateCartTotalPrice();
  }
};

//= require ./b--u-updateCartTotalPrice.js
const ticketFormValidate = (originForm) => {
  const date = originForm.querySelector('[name="visite-date"]');
  const time = originForm.querySelector('[name="visit-time"]');

  let ticketNumberValue;
  const inputPrices = document.querySelectorAll(".input--price");
  const ticketNumberArray = [];
  inputPrices.forEach((tnumber) => {
    ticketNumberArray.push(tnumber.value);
  });
  if (ticketNumberArray?.length) {
    ticketNumberValue = ticketNumberArray.reduce(
      (accumulator, currentValue) =>
        parseInt(accumulator, 10) + parseInt(currentValue, 10)
    );
  }

  function testValues() {
    const invalidInput = [];
    for (
      let index = 0;
      index < document.querySelectorAll(".ticket-detail-container").length;
      index += 1
    ) {
      const element = document.querySelectorAll(".ticket-detail-container")[
        index
      ];
      element.querySelectorAll("input").forEach((i) => {
        if (i.hasAttribute("required") && i.value.length === 0) {
          invalidInput.push(i);
        }
      });
    }
    if (invalidInput.length || ticketNumberValue === 0) {
      originForm.querySelector(".cart-submit-btn").setAttribute("disabled", "");
    } else {
      originForm.querySelector(".cart-submit-btn").removeAttribute("disabled");
    }
  }

  if (
    document?.querySelector('[data-tunnel-type="tunnel_date_heure_billet"]') ||
    document?.querySelector('[data-tunnel-type="tunnel_date_billet"]') ||
    document?.querySelector('[data-tunnel-type="tunnel_date_heure_dispo"]')
  ) {
    if (!date?.value || !time?.value || ticketNumberValue === 0) {
      originForm.querySelector(".cart-submit-btn").setAttribute("disabled", "");
    } else {
      testValues();
    }
  } else if (
    document?.querySelector('[data-tunnel-type="tunnel_billet"]') ||
    document?.querySelector('[data-tunnel-type="tunnel_grpe-compo"]')
  ) {
    if (ticketNumberValue === 0) {
      originForm.querySelector(".cart-submit-btn").setAttribute("disabled", "");
    } else {
      testValues();
    }
  }
};

function getNumberFieldsValues(container) {
  // eslint-disable-next-line prefer-const
  let numberArray = [];
  document.querySelectorAll(container).forEach((element) => {
    const numberBlocs = element.querySelectorAll(".number-bloc");
    numberBlocs.forEach((bloc) => {
      const inputNumber = bloc.querySelector('input[type="number"]');
      const number = inputNumber.value;
      numberArray.push(number);
    });
  });
  let numberSum = 0;
  for (let i = 0; i < numberArray.length; i += 1) {
    numberSum += parseInt(numberArray[i], 10);
  }
  return numberSum;
}

function timeAndTickets(data, dialog) {
  if (data.find((x) => x.id === dialog.getAttribute("data-productid"))) {
    const itemData = data.find(
      (x) => x.id === dialog.getAttribute("data-productid")
    );
    if (itemData?.time && itemData?.tickets?.length) {
      dialog.querySelector(".validate-option").removeAttribute("disabled");
    } else {
      dialog.querySelector(".validate-option").setAttribute("disabled", "");
    }
  } else {
    dialog.querySelector(".validate-option").setAttribute("disabled", "");
  }
}

function isAbleDialogValidate(elDialog) {
  timeAndTickets(window.crossSellEvent, elDialog);
  elDialog.dispatchEvent(catFound);
  const dispatchCrossSellEvent = new Promise((resolve) => {
    elDialog.dispatchEvent(catFound);
    resolve("dispatchCrossSellEvent");
  });

  elDialog.addEventListener("CSE_event", (e) => {
    dispatchCrossSellEvent.then(() => {
      timeAndTickets(e.detail.value, elDialog);
    });
  });
}


function disableNumberBtn(btn, arg) {
  const numberDirection = btn.getAttribute("data-update");
  const numberBloc = btn.closest(".number-bloc");
  const inputNumber = numberBloc.querySelector('input[type="number"]');

  const minusBtn = numberBloc.querySelectorAll('[data-update="-"]')[0];
  const max = parseInt(inputNumber.getAttribute("max"), 10);
  const min = parseInt(inputNumber.getAttribute("min"), 10);

  let allPlusButtons;
  if (arg?.groupId) {
    allPlusButtons = document
      .querySelector(`[data-groupid="${arg?.groupId}"]`)
      .closest(".ticket-selection-container")
      .querySelectorAll('[data-update="+"]');
  } else if (arg?.container) {
    allPlusButtons = document
      .querySelector(arg.container)
      .querySelectorAll('[data-update="+"]');
  } else {
    allPlusButtons = document
      .querySelector(".customer-journey")
      .querySelectorAll('[data-update="+"]');
  }

  if (numberDirection === "-") {
    if (parseInt(inputNumber.value, 10) === min) {
      btn.setAttribute("disabled", "");
    } else {
      btn.removeAttribute("disabled");
    }

    const sumOfValues = getNumberFieldsValues(".number-selection-container");
    if (sumOfValues < max) {
      allPlusButtons.forEach((x) => {
        x.removeAttribute("disabled");
      });
    }
  }
  if (numberDirection === "+") {
    if (inputNumber.value > inputNumber.getAttribute("min")) {
      minusBtn.removeAttribute("disabled");
    }

    const sumOfValues = getNumberFieldsValues(".number-selection-container");
    if (sumOfValues >= max) {
      allPlusButtons.forEach((x) => {
        x.setAttribute("disabled", "");
      });
    }
  }
}

function updateNumberFn(btn, arg, direction, diff) {
  const numberBloc = btn.closest(".number-bloc");
  const numberDirection = direction || btn.getAttribute("data-update");
  const inputNumber = numberBloc.querySelector('input[type="number"]');
  const max = parseInt(inputNumber.getAttribute("max"), 10);
  const min = parseInt(inputNumber.getAttribute("min"), 10);

  let priceToDisplay;

  if (numberDirection === "-") {
    if (inputNumber.value >= min) {
      if (
        (arg?.simpleUpdate && arg?.container) ||
        (arg?.simpleUpdate && arg?.groupId)
      ) {
        const dataTarif = btn
          .closest(".ticket-update-container")
          .getAttribute("data-tarif");
        const priceContainer = btn
          .closest(".ticket-update-container")
          .querySelector(".price-value");

        /** case activities modification */
        let elTarif;
        if (window.crossSellEvent?.length && btn.closest(".dialog-layer")) {
          const productId = btn
            .closest(".dialog-layer")
            .getAttribute("data-productid");
          const elTarifId = btn
            .closest(".ticket-detail-container")
            .getAttribute("data-groupid");
          const product = window.crossSellEvent.find((x) => x.id == productId);
          elTarif = product.tickets.find(
            (x) =>
              x.tarifId == elTarifId ||
              x.tarifId == elTarifId.replace("group-", "")
          );
        }
        if (elTarif) {
          initialTarif = parseFloat(elTarif.price).toFixed(2);
        } else {
          initialTarif = priceContainer.getAttribute("data-price");
        }

        let diffTarif;
        if (diff) {
          diffTarif =
            parseFloat(initialTarif) - parseFloat(dataTarif) * Math.abs(diff);
        } else {
          /** update from "+" button */
          numberBloc.querySelector('input[type="number"]').value =
            parseInt(inputNumber.value, 10) - 1;
          diffTarif = parseFloat(initialTarif) - parseFloat(dataTarif);
        }

        priceContainer.innerHTML = diffTarif;
        priceContainer.setAttribute("data-price", diffTarif);
        priceToDisplay = diffTarif;
      }
    }

    disableNumberBtn(btn, arg);
  }
  if (numberDirection === "+") {
    if (inputNumber.value <= max) {
      if (
        (arg?.simpleUpdate && arg?.container) ||
        (arg?.simpleUpdate && arg?.groupId)
      ) {
        const dataTarif = btn
          .closest(".ticket-update-container")
          .getAttribute("data-tarif");
        const priceContainer = btn
          .closest(".ticket-update-container")
          .querySelector(".price-value");
        let initialTarif = 0;

        /** case activities modification */
        if (btn.closest(".cross-sell-modal")) {
          let elTarif;
          if (window.crossSellEvent?.length) {
            const productId = btn
              .closest(".dialog-layer")
              .getAttribute("data-productid");
            const elTarifId = btn
              .closest(".ticket-detail-container")
              .getAttribute("data-groupid");
            const product = window.crossSellEvent.find(
              (x) => x.id == productId
            );
            elTarif = product.tickets.find(
              (x) =>
                x.tarifId == elTarifId ||
                x.tarifId == elTarifId.replace("group-", "")
            );
            if (elTarif) {
              initialTarif = parseFloat(elTarif.price).toFixed(2);
            } else {
              initialTarif = priceContainer.getAttribute("data-price");
            }
          } else {
            initialTarif = priceContainer.getAttribute("data-price");
          }
        }

        let sumTarif;

        if (diff) {
          sumTarif = parseFloat(dataTarif) * diff + parseFloat(initialTarif);
        } else {
          /** update from "+" button */
          numberBloc.querySelector('input[type="number"]').value =
            parseInt(inputNumber.value, 10) + 1;

          sumTarif = parseFloat(dataTarif) * parseInt(inputNumber.value, 10);
        }

        priceContainer.setAttribute("data-price", sumTarif);
        priceContainer.innerHTML = sumTarif;
        priceToDisplay = sumTarif;
      }
    }

    disableNumberBtn(btn, arg);
  }

  if (arg?.simpleUpdate) {
    const ticketLabel = btn
      .closest(".ticket-update-container")
      .getAttribute("data-label");

    const productId = btn
      .closest(".ticket-detail-container")
      .getAttribute("data-productid");

    const tarifId = btn
      .closest(".ticket-detail-container")
      .getAttribute("data-groupid")
      .replace("group-", "");

    const number = btn
      .closest(".ticket-update-container")
      .querySelector(".input--price").value;

    const ruleId = btn
      .closest(".ticket-detail-container")
      ?.getAttribute("data-rule")
      ?.split(",");

    const isAdult = btn
      .closest(".ticket-detail-container")
      ?.getAttribute("data-adult");

    if (window.ticketState) {
      /** data for rules */
      const newTicket = {
        productId: productId,
        tarifId: tarifId,
        number: number,
        item: ticketLabel,
        price: priceToDisplay,
        ruleId: ruleId,
        isAdult: isAdult,
      };

      if (window.ticketState.some((item) => item.tarifId === tarifId)) {
        let existingItem = window.ticketState.find(
          (item) => item.tarifId === tarifId
        );
        existingItem.number = number;
        existingItem.price = priceToDisplay;
      } else {
        window.ticketState.push(newTicket);
      }

      /** handling rules */
      function aprove(elDialog) {
        localStorage.setItem("check_adult", "checked");
        elDialog
          .querySelector(".callback-btn")
          .addEventListener("click", () => {
            elDialog.querySelector(".close-dialog").click();
          });
      }

      /** rule "choix-billet-enfant-seul" */
      if (ruleId?.includes("choix-billet-enfant-seul")) {
        const adultNumberArray = [];
        const childrenNumberArray = [];

        if (window.ticketState?.length) {
          for (let index = 0; index < window.ticketState.length; index++) {
            const element = window.ticketState[index];
            if (element?.isAdult === "true") {
              adultNumberArray.push(element?.number);
            } else {
              childrenNumberArray.push(element?.number);
            }
          }
        }

        window.ticketState.forEach((item) => {
          if (
            item.isAdult === "true" &&
            parseInt(item.number) > 0 &&
            parseInt(item.number) > 0
          ) {
            adultNumberArray.push(item.number);
          } else {
            childrenNumberArray.push(item.number);
          }
        });
        const adultNumber = adultNumberArray?.length
          ? adultNumberArray.reduce(
              (accumulator, currentValue) => accumulator + currentValue
            )
          : 0;
        const childrenNumber = childrenNumberArray?.length
          ? childrenNumberArray.reduce(
              (accumulator, currentValue) => accumulator + currentValue
            )
          : 0;

        if (childrenNumber > 0 && adultNumber == 0) {
          const parentNumberBloc = numberBloc;
          const clickedDataUpdate = btn.getAttribute("data-update");
          const initialDialogTrigger = parentNumberBloc.querySelector(
            `[data-update="${clickedDataUpdate}"]`
          );
          if (!localStorage.getItem("check_adult")) {
            displayDialog(
              "#dialog_choix-billet-enfant-seul",
              initialDialogTrigger,
              aprove
            );
          }
        }
      }
    }

    /** basic update with cart update */
    if (arg?.simpleUpdate && arg?.updateCart) {
      arg.updateCart({
        productId: productId,
        tarifId: tarifId,
        number: number,
        item: ticketLabel,
        price: priceToDisplay,
        subItem: arg?.crossSell ? false : true,
      });
      if (!document.getElementById("customer-journey-step-options")) {
        ticketFormValidate(
          document.querySelector(arg.container).closest("form")
        );
      }
    }

    /** option event in modal update */
    if (arg?.simpleUpdate && arg?.dialogUpdate) {
      isAbleDialogValidate(document.getElementById(`dialog_${productId}`));

      const dataProduct = window.crossSellEvent.find(
        (item) => item.id === productId
      );

      /** update json */
      if (dataProduct.tickets.find((item) => item.tarifId === tarifId)) {
        if (parseInt(number) === 0) {
          dataProduct.tickets = dataProduct.tickets.filter(
            (item) => item.tarifId !== tarifId
          );
          document
            .getElementById(`dialog_${dataProduct.id}`)
            .querySelector(".validate-option")
            .setAttribute("disabled", "");
        } else {
          const item = dataProduct.tickets.find(
            (item) => item.tarifId === tarifId
          );
          item.number = number;
          item.price = priceToDisplay;
        }
      } else {
        dataProduct.tickets.push({
          label: ticketLabel,
          number: number,
          price: priceToDisplay,
          tarifId: tarifId,
        });
      }

      /** free time selection or not */
      if (dataProduct?.tickets?.length) {
        document
          .getElementById(`dialog_${productId}`)
          .querySelector(".time-selection-container")
          .classList.add("selectable-time");
      } else {
        document
          .getElementById(`dialog_${productId}`)
          .querySelector(".time-selection-container")
          .classList.remove("selectable-time");
      }

      /** update modal prices */
      /** option price */
      let optionTotalPriceValue = 0;
      let priceInCart = 0;
      const optionTotalPriceCtr = document
        .getElementById(`dialog_${productId}`)
        .querySelector(".option-total-price");
      const optionTotalPriceArray = [];

      const optionPricesInCartArray = [];
      if (dataProduct?.tickets) {
        for (let index = 0; index < dataProduct.tickets.length; index += 1) {
          const element = dataProduct.tickets[index];
          const ticketInCart =
            document.getElementById(`${element.tarifId}`) ||
            document.getElementById(`group-${element.tarifId}`);

          if (ticketInCart) {
            priceInCart = ticketInCart
              .querySelector(".cart-item-price")
              .getAttribute("data-price");
          } else {
            priceInCart = 0;
          }
          optionPricesInCartArray.push(priceInCart);
          optionTotalPriceArray.push(element.price);
        }

        if (optionTotalPriceArray?.length) {
          optionTotalPriceValue = optionTotalPriceArray.reduce(
            (accumulator, currentValue) =>
              parseFloat(accumulator) + parseFloat(currentValue)
          );
        }
      }

      optionTotalPriceCtr.innerHTML = parseFloat(optionTotalPriceValue).toFixed(
        2
      );

      let optionPricesInCart = 0;

      /** case activities modification */
      let itemPrice;
      const elInputValue = btn
        .closest(".ticket-update-container")
        .querySelector(".input--price").value;
      if (window.crossSellEvent?.length) {
        const productId = btn
          .closest(".dialog-layer")
          .getAttribute("data-productid");
        const elTarifId = btn
          .closest(".ticket-detail-container")
          .getAttribute("data-groupid");

        const productInCSE = window.crossSellEvent.find(
          (x) => x.id == productId
        );
        const ticketInCSE = productInCSE.tickets.find(
          (x) =>
            x.tarifId == elTarifId ||
            x.tarifId == elTarifId.replace("group-", "")
        );
        if (elInputValue == 0) {
          itemPrice = btn
            .closest(".ticket-update-container")
            .getAttribute("data-tarif");
        } else {
          optionPricesInCart = optionPricesInCartArray?.length
            ? optionPricesInCartArray.reduce(
                (accumulator, currentValue) =>
                  parseFloat(accumulator) + parseFloat(currentValue)
              )
            : 0;
        }
      } else {
        optionPricesInCart = optionPricesInCartArray?.length
          ? optionPricesInCartArray.reduce(
              (accumulator, currentValue) =>
                parseFloat(accumulator) + parseFloat(currentValue)
            )
          : btn.closest(".ticket-update-container").getAttribute("data-tarif");
      }

      /** virtual cart price */
      const cartTotalPrice = parseFloat(
        document
          .getElementById("cart-content--total")
          .getAttribute("data-totalcart")
      );

      let virtualTotal;

      if (cartTotalPrice) {
        totalOptionsPriceArray = [];
        window.ticketState.forEach((element) => {
          totalOptionsPriceArray.push(element.price);
        });

        const totalOptionsPrice = totalOptionsPriceArray.reduce(
          (accumulator, currentValue) =>
            parseFloat(accumulator) + parseFloat(currentValue)
        );

        virtualTotal =
          elInputValue == 0
            ? totalOptionsPrice
            : optionTotalPriceValue + cartTotalPrice - optionPricesInCart;
      } else {
        virtualTotal = optionTotalPriceValue - optionPricesInCart;
      }

      document
        .getElementById(`dialog_${productId}`)
        .querySelector(".modal-total-cart-price").innerHTML =
        parseFloat(virtualTotal).toFixed(2);
    }
  }
}

const updateNumber = (arg) => {
  let container;
  if (arg?.groupId) {
    container = document.querySelector(`[data-groupid="${arg.groupId}"]`);
  } else if (arg?.container) {
    container = document.querySelector(arg.container);
  } else {
    container = document;
  }

  const numberBlocs = container?.querySelectorAll(".number-bloc");
  if (numberBlocs?.length) {
    numberBlocs.forEach((bloc) => {
      const updateBtn = bloc.querySelectorAll(".update-number-btn");

      /** update from button */
      updateBtn.forEach((btn) => {
        disableNumberBtn(btn, arg);

        btn.addEventListener("click", () => updateNumberFn(btn, arg));
      });

      /** update from input */
      const updateInput = bloc.querySelectorAll('[type="number"]');

      updateInput.forEach((inp) => {
        let initialValue = inp.value;
        inp.addEventListener("input", () => {
          let fieldsetNumber;
          if (
            document
              .querySelector(`[data-groupid="${arg?.groupId}"]`)
              ?.querySelectorAll(".ticket-update-container")?.length > 0
          ) {
            fieldsetNumber = document
              .querySelector(`[data-groupid="${arg?.groupId}"]`)
              .querySelectorAll(".ticket-update-container").length;
          } else {
            fieldsetNumber = 0;
          }

          if (inp.value?.length) {
            if (inp.value < 0) {
              // eslint-disable-next-line no-param-reassign
              inp.value = 0;
            }
            const sumOfValues = getNumberFieldsValues(
              ".number-selection-container"
            );

            let dir;
            if (fieldsetNumber) {
              dir = inp.value - fieldsetNumber;
            } else if (initialValue) {
              dir = inp.value - initialValue;
            }

            let elBtn;
            let direction;
            const diff = dir;
            if (dir > 0) {
              elBtn = bloc.querySelector('[data-update = "+"]');
              direction = "+";
            } else if (dir < 0) {
              elBtn = bloc.querySelector('[data-update = "-"]');
              direction = "-";
            }
            if (sumOfValues <= inp.getAttribute("data-max") && dir !== 0) {
              updateNumberFn(elBtn, arg, direction, diff);
            }
            if (sumOfValues > inp.getAttribute("data-max")) {
              // eslint-disable-next-line no-param-reassign
              inp.value = initialValue;
            }

            if (inp.value < 0) {
              initialValue = inp.value;
            } else {
              initialValue = inp.value;
            }
          }
        });
      });
    });
  }
};

//= require ./b--isAbleDialogValidate.js

const initTicketUpdate = () => {
  /**
   *  initialize ticket form
   */
  if (document.querySelector("#customer-journey-step-billets")) {
    ticketFormValidate(
      document.querySelector("#customer-journey-step-billets")
    );
    /* reset tickets */
    const originForm = document.querySelector("form");
    originForm
      .querySelectorAll('[type="number"]')
      // eslint-disable-next-line no-return-assign, no-param-reassign
      .forEach((x) => (x.value = 0));
    originForm
      .querySelectorAll(".price-value")
      // eslint-disable-next-line no-return-assign, no-param-reassign
      .forEach((x) => (x.innerHTML = 0));

    /** group composition */
    updateNumber({
      simpleUpdate: true,
      container: ".group-compo-container",
      updateCart,
    });
  }

  /**
   *  initialize options form
   */
  if (document.querySelector("#customer-journey-step-options")) {
    /* reset tickets */
    const originForm = document.querySelector("form");
    originForm
      .querySelectorAll('[type="number"]')
      // eslint-disable-next-line no-return-assign, no-param-reassign
      .forEach((x) => (x.value = 0));
    originForm
      .querySelectorAll(".price-value")
      // eslint-disable-next-line no-return-assign, no-param-reassign
      .forEach((x) => (x.innerHTML = 0));

    /** group composition */
    updateNumber({
      simpleUpdate: true,
      container: ".basic-options-group-compo-container",
      updateCart,
      crossSell: true,
    });
  }

  /**
   *  initialize subscriptions form
   */
  if (document.querySelector("#customer-journey-step-subscriptions")) {
    /* reset tickets */
    const originForm = document.querySelector("form");
    originForm
      .querySelectorAll('[type="number"]')
      // eslint-disable-next-line no-return-assign, no-param-reassign
      .forEach((x) => (x.value = 0));
    originForm
      .querySelectorAll(".price-value")
      // eslint-disable-next-line no-return-assign, no-param-reassign
      .forEach((x) => (x.innerHTML = 0));

    /** group composition */
    updateNumber({
      simpleUpdate: true,
      container: ".basic-options-group-compo-container",
      updateCart,
      crossSell: true,
    });
  }

  /**
   *  initialize extras/activities form
   */
  if (document.querySelector("#customer-journey-step-extras")) {
    const originForm = document.querySelector("#customer-journey-step-extras");

    if (
      window.crossSellEvent?.some(
        (x) => x?.tickets?.length && x?.time && x?.date
      ) ||
      window.cartFromBackend?.some(
        (x) => x?.tickets?.length && x?.time && x?.date
      )
    ) {
      originForm.querySelector(".cart-submit-btn").removeAttribute("disabled");
    } else {
      originForm.querySelector(".cart-submit-btn").setAttribute("disabled", "");
    }

    /* reset tickets */
    originForm
      .querySelectorAll('[type="number"]')
      // eslint-disable-next-line no-return-assign, no-param-reassign
      .forEach((x) => (x.value = 0));
    originForm
      .querySelectorAll(".price-value")
      // eslint-disable-next-line no-return-assign, no-param-reassign
      .forEach((x) => (x.innerHTML = 0));

    /** group composition */
    updateNumber({
      simpleUpdate: true,
      container: ".basic-options-group-compo-container",
      // updateCart,
      crossSell: true,
    });
  }

  /**
   * modification mode
   */
  /** update ticket state according to window.cartFromBackend */
  if (window.ticketState && window.cartFromBackend?.length) {
    for (let index = 0; index < window.cartFromBackend.length; index++) {
      const element = window.cartFromBackend[index];
      if (element?.tickets?.length) {
        for (let index = 0; index < element.tickets.length; index++) {
          const ticket = element?.tickets[index];
          const newTicket = {
            productId: element.id,
            tarifId: ticket.tarifId,
            number: ticket.number,
            item: ticket.label,
            price: ticket.price,
            ruleId: document
              .querySelector(`[data-productid="${element.id}"]`)
              ?.getAttribute("data-rule")
              ?.split(","),
            isAdult: ticket.isAdult,
          };

          if (
            window.ticketState.some((item) => item.tarifId === ticket.tarifId)
          ) {
            let existingItem = window.ticketState.find(
              (item) => item.tarifId === ticket.tarifId
            );
            existingItem.number = ticket.number;
            existingItem.price = ticket.price;
          } else {
            window.ticketState.push(newTicket);
          }

          // window.ticketState.push(newTicket);
        }
      }
    }
  }

  /** update fields according to window.cartFromBackend */
  if (window.cartFromBackend) {
    const actualModificationData = window.cartFromBackend;
    actualModificationData.forEach((x) => {
      if (x?.tickets) {
        x.tickets.forEach((y) => {
          // visit & subscriptions tickets
          if (
            document.getElementById(`group-${y.tarifId}-number`) &&
            document.querySelector(`[data-groupid="group-${y.tarifId}"]`)
          ) {
            // update number input field
            document.getElementById(`group-${y.tarifId}-number`).value =
              y.number;
            // update element data-price
            document
              .querySelector(`[data-groupid="group-${y.tarifId}"]`)
              .querySelector(".price-value")
              .setAttribute("data-price", y.price);
            if (
              y.number >
              document
                .getElementById(`group-${y.tarifId}-number`)
                .getAttribute("min")
            ) {
              const blocContainer = document.querySelector(
                `[data-groupid="group-${y.tarifId}"]`
              );
              blocContainer
                .querySelector('[data-update="-"]')
                .removeAttribute("disabled");
            }
            if (document.querySelector("#customer-journey-step-billets")) {
              ticketFormValidate(
                document.querySelector("#customer-journey-step-billets")
              );
            } else if (
              document.querySelector("#customer-journey-step-subscriptions")
            ) {
              ticketFormValidate(
                document.querySelector("#customer-journey-step-subscriptions")
              );
            }
          }

          // options tickets
          if (
            document.getElementById(`${y.tarifId}-basic-number`) &&
            document.querySelector(`[data-groupid="group-${y.tarifId}"]`)
          ) {
            // update number input field
            document.getElementById(`${y.tarifId}-basic-number`).value =
              y.number;
            // update element data-price
            document
              .querySelector(`[data-groupid="group-${y.tarifId}"]`)
              .querySelector(".price-value")
              .setAttribute("data-price", y.price);
            if (
              y.number >
              document
                .getElementById(`${y.tarifId}-basic-number`)
                .getAttribute("min")
            ) {
              const blocContainer = document.querySelector(
                `[data-groupid="group-${y.tarifId}"]`
              );
              blocContainer
                .querySelector('[data-update="-"]')
                .removeAttribute("disabled");
            }
          }

          // activities
          const productId = x.id.replace("product-", "");
          const tarifId = y.tarifId;
          const originDialog = document.getElementById(`dialog_${productId}`);
          const cartItemInCFB = window.cartFromBackend.find(
            (item) => item.id === `${productId}`
          );
          const itemInCSE = window.crossSellEvent.find(
            (item) => item.id === productId
          );

          if (
            originDialog &&
            document.getElementById(`number-${tarifId}-${productId}`)
          ) {
            // update number input field
            document.getElementById(`number-${tarifId}-${productId}`).value =
              y.number;
            if (
              y.number >
              document
                .getElementById(`number-${tarifId}-${productId}`)
                .getAttribute("min")
            ) {
              const blocContainer = document.querySelector(
                `[data-groupid="group-${tarifId}"]`
              );

              if (blocContainer) {
                blocContainer
                  .querySelector('[data-update="-"]')
                  .removeAttribute("disabled");
              }

              originDialog
                .querySelector(".time-selection-container")
                .classList.add("selectable-time");

              /* update tiles */
              const tilesList = originDialog.querySelectorAll(
                `[data-date="${cartItemInCFB.date}"]`
              );
              let tileId = "";
              tilesList.forEach((t) => {
                if (t.dataset.time === cartItemInCFB.time) {
                  tileId = t.id;
                }
              });
              if (document.getElementById(tileId)) {
                const isChecked = document.getElementById(tileId).checked;
                if (!isChecked) {
                  document.getElementById(tileId).click();
                }
              }

              /** update option price */
              let optionPrice = 0;
              cartItemInCFB.tickets.forEach((ticket) => {
                optionPrice += ticket.price;
              });
              originDialog.querySelector(".option-total-price").innerHTML =
                optionPrice;

              /** update crossSellEvent */
              if (cartItemInCFB?.tickets?.length) {
                itemInCSE.tickets = cartItemInCFB.tickets;
              }

              /** update dialog virtual total price */
              const cartTotalPrice = parseFloat(
                document
                  .getElementById("cart-content--total")
                  .getAttribute("data-totalcart")
              );
              document
                .getElementById(`dialog_${productId}`)
                .querySelector(".modal-total-cart-price").innerHTML =
                parseFloat(cartTotalPrice).toFixed(2);
            }
            isAbleDialogValidate(originDialog);
            // ticketFormValidate(document.querySelector(`#dialog_${productId}`));
          }
        });
      }
    });
  }
};

// create custom events
const catFound = new CustomEvent("CSE_event", {
  detail: {
    value: window.crossSellEvent,
  },
});


/** modal footer buttons & close dialog actions */
function removeFromDataAndCart(elDialog) {
  /** remove tickets from item in crossSellEvent data */
  window.crossSellEvent.find(
    (x) => x.id == elDialog.getAttribute("data-productid")
  ).tickets = [];

  /** clear inputs */
  elDialog.querySelectorAll(".input--price").forEach((x) => (x.value = 0));
  elDialog
    .querySelectorAll('[data-update = "-"]')
    .forEach((x) => x.setAttribute("disabled", ""));
  elDialog.querySelectorAll('[type = "checkbox"]').forEach((x) => {
    if (x.checked) {
      x.click();
    }
  });
  elDialog.querySelector(".option-total-price").innerHTML = "0";
  elDialog.querySelector(".modal-total-cart-price").innerHTML = "0";

  /** remove item from cart */
  if (
    document.querySelector(`#item_${elDialog.getAttribute("data-productid")}`)
  ) {
    document
      .querySelector(`#item_${elDialog.getAttribute("data-productid")}`)
      .remove();
  }
  updateCartTotalPrice();
  elDialog.querySelector(".close-dialog").click();
}

function crosscellModalCallback(elDialog) {
  const container = elDialog;
  const elId = elDialog.getAttribute("data-productid");
  const elCard = document
    .getElementById(`btn-${elId}`)
    .closest(".event-option");

  const isEventIdInJson = window.crossSellEvent.some(
    (x) => x.id === elDialog.getAttribute("data-productid")
  );

  if (isEventIdInJson === false) {
    const newEvent = {
      id: elDialog.getAttribute("data-productid"),
      title: elDialog.getAttribute("data-product-label"),
      tickets: [],
    };
    window.crossSellEvent.push(newEvent);
    elDialog.dispatchEvent(catFound);
  }

  /** virtual cart price */
  const cartTotalPrice = parseFloat(
    document
      .getElementById("cart-content--total")
      .getAttribute("data-totalcart")
  );

  const groupids = document
    .querySelector(
      `.group-compo-container_${elDialog.getAttribute("data-productid")}`
    )
    .querySelectorAll(".form-detail-container");

  groupids.forEach((x) => {
    /** update options json */
    updateNumber({
      simpleUpdate: true,
      dialogUpdate: true,
      groupId: x.getAttribute("data-groupid"),
    });
  });

  /** get time data & build tiles */
  container.classList.add("ajaxloading");

  callAjax(
    "GET",
    `${window.location.origin}/fr/get-show-sessions?id=${elDialog.getAttribute(
      "data-productid"
    )}`,
    (data) => {
      json = JSON.parse(data);
      if (json && Array.isArray(json) && json?.length) {
        // show product if data
        document
          .getElementById(`btn-${elId}`)
          .closest(".event-option")
          .classList.remove("empty-product");
        document
          .getElementById(`btn-${elId}`)
          .closest(".event-option")
          .classList.add("visible-product");

        // time tiles
        createTimeTiles(json, container);
        modalTimeSelection(elDialog);

        /**
         * modification mode
         */
        /** update ticket state according to window.cartFromBackend */
        if (window.ticketState && window.cartFromBackend?.length) {
          for (let index = 0; index < window.cartFromBackend.length; index++) {
            const element = window.cartFromBackend[index];
            if (element?.tickets?.length) {
              for (let index = 0; index < element.tickets.length; index++) {
                const ticket = element?.tickets[index];
                const newTicket = {
                  productId: element.id,
                  tarifId: ticket.tarifId,
                  number: ticket.number,
                  item: ticket.label,
                  price: ticket.price,
                  ruleId: document.querySelector(
                    `[data-productid="${element.id}"]`
                  )
                    ? document
                        .querySelector(`[data-productid="${element.id}"]`)
                        ?.getAttribute("data-rule")
                        ?.split(",")
                    : "",
                  isAdult: ticket.isAdult,
                };

                if (
                  window.ticketState.some(
                    (item) => item.tarifId === ticket.tarifId
                  )
                ) {
                  let existingItem = window.ticketState.find(
                    (item) => item.tarifId === ticket.tarifId
                  );
                  existingItem.number = ticket.number;
                  existingItem.price = ticket.price;
                } else {
                  window.ticketState.push(newTicket);
                }

                // window.ticketState.push(newTicket);
              }
            }
          }
        }
        /** update fields according to window.cartFromBackend */
        if (window.cartFromBackend) {
          const actualModificationData = window.cartFromBackend;
          actualModificationData.forEach((x) => {
            if (x?.tickets) {
              x.tickets.forEach((y) => {
                // visit tickets
                if (document.getElementById(`group-${y.tarifId}-number`)) {
                  // update number input field
                  document.getElementById(`group-${y.tarifId}-number`).value =
                    y.number;
                  // update element data-price
                  document
                    .querySelector(`[data-groupid="group-${y.tarifId}"]`)
                    .querySelector(".price-value")
                    .setAttribute("data-price", y.price);
                  if (
                    y.number >
                    document
                      .getElementById(`group-${y.tarifId}-number`)
                      .getAttribute("min")
                  ) {
                    const blocContainer = document.querySelector(
                      `[data-groupid="group-${y.tarifId}"]`
                    );
                    blocContainer
                      .querySelector('[data-update="-"]')
                      .removeAttribute("disabled");
                  }
                  ticketFormValidate(
                    document.querySelector("#customer-journey-step-billets")
                  );
                }

                // activities
                const productId = x.id.replace("product-", "");
                const tarifId = y.tarifId;
                const originDialog = document.getElementById(
                  `dialog_${productId}`
                );
                const cartItemInCFB = window.cartFromBackend.find(
                  (item) => item.id === `${productId}`
                );
                const itemInCSE = window.crossSellEvent.find(
                  (item) => item.id === productId
                );

                if (
                  originDialog &&
                  document.getElementById(`number-${tarifId}-${productId}`)
                ) {
                  // update number input field
                  document.getElementById(
                    `number-${tarifId}-${productId}`
                  ).value = y.number;
                  if (
                    y.number >
                    document
                      .getElementById(`number-${tarifId}-${productId}`)
                      .getAttribute("min")
                  ) {
                    const blocContainer = document.querySelector(
                      `[data-groupid="group-${tarifId}"]`
                    );
                    if (blocContainer) {
                      blocContainer
                        .querySelector('[data-update="-"]')
                        .removeAttribute("disabled");
                    }
                    originDialog
                      .querySelector(".time-selection-container")
                      .classList.add("selectable-time");

                    /* update tiles */
                    const tilesList = originDialog.querySelectorAll(
                      `[data-date="${cartItemInCFB.date}"]`
                    );
                    let tileId = "";
                    tilesList.forEach((t) => {
                      if (t.dataset.time === cartItemInCFB.time) {
                        tileId = t.id;
                      }
                    });
                    if (document.getElementById(tileId)) {
                      const isChecked = document.getElementById(tileId).checked;
                      if (!isChecked) {
                        document.getElementById(tileId).click();
                      }
                    }

                    /** update option price */
                    let optionPrice = 0;
                    cartItemInCFB.tickets.forEach((ticket) => {
                      optionPrice += ticket.price;
                    });
                    originDialog.querySelector(
                      ".option-total-price"
                    ).innerHTML = optionPrice;

                    /** update crossSellEvent */
                    if (cartItemInCFB?.tickets?.length) {
                      itemInCSE.tickets = cartItemInCFB.tickets;
                    }

                    /** update dialog virtual total price */
                    const cartTotalPrice = parseFloat(
                      document
                        .getElementById("cart-content--total")
                        .getAttribute("data-totalcart")
                    );
                    document
                      .getElementById(`dialog_${productId}`)
                      .querySelector(".modal-total-cart-price").innerHTML =
                      parseFloat(cartTotalPrice).toFixed(2);
                  }
                  isAbleDialogValidate(originDialog);
                  // ticketFormValidate(document.querySelector(`#dialog_${productId}`));
                }
              });
            }
          });
        }
      } else {
        // hide product if no data
        document
          .getElementById(`btn-${elId}`)
          .closest(".event-option")
          .classList.add("empty-product");
        document
          .getElementById(`btn-${elId}`)
          .closest(".event-option")
          .classList.remove("visible-product");
        setTimeout(() => {
          document
            .getElementById(`btn-${elId}`)
            .closest(".event-option")
            .remove();

          const eventOptionBlocks = document.querySelectorAll(
            ".event-option-block"
          );
          eventOptionBlocks.forEach((x) => {
            const eventOptions = x.querySelectorAll(".event-option");
            if (eventOptions.length === 0) {
              gsap.to(x, {
                duration: 0.5,
                ease: "power1.out",
                height: 0,
                opacity: 0,
                margin: 0,
                onComplete: () => {
                  x.setAttribute("aria-hidden", "true");
                },
              });
              gsap.to(x.nextElementSibling, {
                duration: 0.5,
                ease: "power1.out",
                marginTop: "-1.5rem",
              });
            }
          });
        }, 500);

        window.crossSellEvent = window.crossSellEvent.filter(
          (x) => x.id !== elDialog.getAttribute("data-productid")
        );
        document.querySelectorAll(".cross-sell-modal").forEach((x) => {
          if (
            !window.crossSellEvent.some(
              (y) => y.id == x.getAttribute("data-productid")
            )
          ) {
            x.remove();
          }
        });
      }

      container.classList.remove("ajaxloading");
      elCard.classList.remove("ajaxloading");
    }
  );

  let modalAction = "close-dialog";
  /** modal footer buttons & close dialog actions */
  elDialog.querySelector(".validate-option").addEventListener("click", () => {
    modalAction = "validate-option";
    cartDynamicHandling(elDialog);

    if (document.querySelector("#customer-journey-step-extras")) {
      if (
        window.crossSellEvent?.some(
          (x) => x?.tickets?.length && x?.time && x?.date
        ) ||
        window.cartFromBackend?.some(
          (x) => x?.tickets?.length && x?.time && x?.date
        )
      ) {
        document
          .querySelector("#customer-journey-step-extras")
          .querySelector(".cart-submit-btn")
          .removeAttribute("disabled");
      } else {
        document
          .querySelector("#customer-journey-step-extras")
          .querySelector(".cart-submit-btn")
          .setAttribute("disabled", "");
      }
    }
    /** clear localStorage check_adult */
    if (localStorage.getItem("check_adult")) {
      localStorage.removeItem("check_adult");
    }
  });
  elDialog.querySelector(".dialog-overlay").addEventListener("click", () => {
    modalAction = "dialog-overlay";
    removeFromDataAndCart(elDialog);
    /** clear localStorage check_adult */
    if (localStorage.getItem("check_adult")) {
      localStorage.removeItem("check_adult");
    }
  });

  elDialog.querySelector(".giveup-option").addEventListener("click", () => {
    modalAction = "giveup-option";
    removeFromDataAndCart(elDialog);
    /** clear localStorage check_adult */
    if (localStorage.getItem("check_adult")) {
      localStorage.removeItem("check_adult");
    }
  });

  elDialog.querySelector(".close-dialog").addEventListener("click", () => {
    if (modalAction !== "validate-option") {
      removeFromDataAndCart(elDialog);
    }
    /** clear localStorage check_adult */
    if (localStorage.getItem("check_adult")) {
      localStorage.removeItem("check_adult");
    }
  });
}

function callAjax(method, url, success, payload) {
  const xhr = window.XMLHttpRequest
    ? new XMLHttpRequest()
    : // eslint-disable-next-line no-undef
      new ActiveXObject("Microsoft.XMLHTTP");
  xhr.open(method, url);
  // eslint-disable-next-line func-names
  xhr.onreadystatechange = function () {
    if (xhr.readyState > 3 && xhr.status === 200 && success) {
      success(xhr.responseText);
    }
  };

  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

  if (payload) {
    xhr.send(JSON.stringify(payload));
  } else {
    xhr.send();
  }
  return xhr;
}


/** ******************************************************************************************** */
/*                                                                                               */
/** ***              ACCESSIBLE CALENDAR (BASED ON THE DATEPICKK JS PLUGIN)                  *** */
/*                                                                                               */
/** ******************************************************************************************** */

function Datepickk(args) {
  Datepickk.numInstances = (Datepickk.numInstances || 0) + 1;
  const that = this;
  const eventName = "click";
  let selectedDates = [];

  let currentYear = new Date().getFullYear();
  let currentMonth = new Date().getMonth() + 1;

  const languages = window.datePickkLanguages;

  const locales = {
    fr: "fr-FR",
    es: "es-ES",
    en: "en-EN",
    zh: "zh-hans",
    nl: "nl-NL",
    de: "de-DE",
  };

  /* Language aliases */

  languages.nb = languages.no;
  languages.nn = languages.no;

  let range = false;
  let maxSelections = null;
  let container = document.body;
  let opened = false;
  let months = 1;
  let closeOnSelect = false;
  let button = null;
  let title = null;
  let onNavigation = null;
  let onClose = null;
  let onConfirm = null;
  let closeOnClick = true;
  let inline = false;
  let lang = "fr";
  let onSelect = null;
  let disabledDates = [];
  let disabledDays = [];
  let highlight = [];
  let tooltips = {};
  let daynames = true;
  let today = true;
  let startDate = null;
  // let endDate = null;
  let minDate = null;
  let maxDate = null;
  let weekStart = null;
  let locked = false;
  const { legendContainer } = args;

  function generateDaynames() {
    that.el.days.innerHTML = "";
    // console.log(languages[lang]);
    const ws = weekStart !== null ? weekStart : languages[lang].weekStart;
    if (daynames) {
      for (let x = 0; x < months && x < 3; x += 1) {
        const weekEl = document.createElement("div");
        weekEl.setAttribute("class", "d-week");
        for (let i = 0; i < 7; i += 1) {
          const dayNameIndex =
            i + ws > languages[lang].dayNames.length - 1
              ? i + ws - languages[lang].dayNames.length
              : i + ws;

          const dayEl = document.createElement("p");
          const dayTextEl = document.createElement("abbr");
          dayTextEl.innerHTML = languages[lang].dayNames[dayNameIndex];
          dayTextEl.setAttribute(
            "title",
            languages[lang].dayFullNames[dayNameIndex]
          );
          dayEl.appendChild(dayTextEl);
          weekEl.appendChild(dayEl);
        }

        that.el.days.appendChild(weekEl);
      }
    }
  }

  // function generateYears() {
  // 	[].slice.call(that.el.yearPicker.childNodes).forEach(function (node, index) {
  // 		node.innerHTML = "'" + (currentYear + parseInt(node.getAttribute('data-year'))).toString().substring(2, 4);
  // 	});
  // }

  function generateInputs() {
    that.el.tables.innerHTML = "";
    for (let x = 0; x < months; x += 1) {
      // eslint-disable-next-line no-shadow
      const container = document.createElement("ol");
      container.setAttribute("class", "d-table");

      const fieldsetLegend = document.createElement("legend");
      fieldsetLegend.setAttribute("class", "visuallyhidden");
      fieldsetLegend.innerHTML = languages[lang].date;

      for (let i = 0; i < 42; i += 1) {
        const cell = document.createElement("li");
        cell.setAttribute("class", "d-cell");

        const input = document.createElement("input");
        input.type = "checkbox";
        input.id = `${Datepickk.numInstances}-${x}-d-day-${i}`;
        const label = document.createElement("label");
        label.setAttribute("for", `${Datepickk.numInstances}-${x}-d-day-${i}`);

        const text = document.createElement("span");

        const tooltip = document.createElement("span");
        tooltip.setAttribute("class", "d-tooltip");

        container.appendChild(cell);

        cell.appendChild(input);
        cell.appendChild(label);

        label.appendChild(text);
        label.appendChild(tooltip);

        // eslint-disable-next-line no-loop-func
        input.addEventListener(eventName, (event) => {
          if (locked) {
            event.preventDefault();
          }
        });
        // eslint-disable-next-line no-use-before-define
        input.addEventListener("change", inputChange);
      }
      that.el.tables.appendChild(fieldsetLegend);
      that.el.tables.appendChild(container);
    }

    // eslint-disable-next-line no-use-before-define
    that.el.tables.addEventListener("mouseover", highlightLegend);
    // eslint-disable-next-line no-use-before-define
    that.el.tables.addEventListener("mouseout", highlightLegend);

    function hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    }

    function highlightLegend(e) {
      if (e.target.nodeName !== "LABEL") return;

      const legendIds = e.target.getAttribute("data-legend-id")
        ? e.target.getAttribute("data-legend-id").split(" ")
        : [];
      if (!legendIds.length) return;

      legendIds.forEach((legendId) => {
        const element = that.el.legend.querySelector(
          `[data-legend-id="${legendId}"]`
        );
        if (e.type === "mouseover" && element) {
          const color = element.getAttribute("data-color")
            ? hexToRgb(element.getAttribute("data-color"))
            : null;
          element.setAttribute(
            "style",
            `background-color:rgba(${color.r},${color.g},${color.b},0.35);`
          );
        } else if (element) {
          element.removeAttribute("style");
        }
      });
    }
  }

  function hoverLegend(e) {
    [].slice
      .call(
        that.el.tables.querySelectorAll(
          `[data-legend-id*="${this.getAttribute("data-legend-id")}"]`
        )
      )
      .forEach((element) => {
        if (e.type === "mouseover") element.classList.add("legend-hover");
        else element.classList.remove("legend-hover");
      });
  }

  function generateLegends() {
    if (legendContainer) {
      that.legendContainer = legendContainer;
    }

    const start = new Date(
      that.el.tables.childNodes[1].childNodes[0].childNodes[0].getAttribute(
        "data-date"
      )
    );
    const end = new Date(
      that.el.tables.childNodes[
        months
      ].childNodes[41].childNodes[0].getAttribute("data-date")
    );
    // eslint-disable-next-line no-underscore-dangle
    const _highlights = highlight.filter((x) => {
      for (let m = 0; m < x.dates.length; m += 1) {
        if (x.dates[m].start < end && x.dates[m].end > start) {
          return true;
        }
      }
      return false;
    });
    const legends = [];
    for (let l = 0; l < _highlights.length; l += 1) {
      if ("legend" in _highlights[l] && _highlights[l].legend) {
        const oldLegend = container.querySelector(
          `.d-legend-item[data-legend="${_highlights[l].legend}"][data-color="${_highlights[l].backgroundColor}"]`
        );
        if (oldLegend === null) {
          const legendItem = document.createElement("p");
          legendItem.setAttribute("class", "d-legend-item");
          // legendItem.setAttribute("data-legend", _highlights[l].legend);
          legendItem.innerHTML = _highlights[l].legend;
          legendItem.setAttribute(
            "data-legend-id",
            highlight.indexOf(_highlights[l])
          );

          // that.el.legend.appendChild(legendItem);
          if (that?.legendContainer) {
            if (that.legendContainer.innerHTML === "") {
              that.legendContainer.classList.add("visible");
              that.legendContainer.appendChild(legendItem);
            }
          } else {
            legendItem.setAttribute(
              "data-color",
              _highlights[l].backgroundColor
            );
            const legendItemPoint = document.createElement("span");
            legendItemPoint.setAttribute(
              "style",
              `background-color:${_highlights[l].backgroundColor}`
            );
            legendItem.appendChild(legendItemPoint);
            that.el.legend.appendChild(legendItem);
          }

          legendItem.addEventListener("mouseover", hoverLegend);
          legendItem.addEventListener("mouseout", hoverLegend);
          legends.push(legendItem);
        } else {
          legends.push(oldLegend);
        }
      }
    }

    [].slice
      .call(that.el.legend.querySelectorAll(".d-legend-item"))
      .forEach((item) => {
        if (legends.indexOf(item) < 0) {
          item.removeEventListener("mouseover", hoverLegend);
          item.removeEventListener("mouseout", hoverLegend);
          that.el.legend.removeChild(item);
        }
      });
  }

  function parseMonth(month) {
    // eslint-disable-next-line no-param-reassign
    if (month > 11) month -= 12;
    // eslint-disable-next-line no-param-reassign
    else if (month < 0) month += 12;
    return month;
  }

  function generateDates(year, month) {
    const monthElements = that.el.querySelectorAll(".d-table");
    const ws = weekStart !== null ? weekStart : languages[lang].weekStart;

    [].slice
      .call(that.el.querySelectorAll(".d-table"))
      .forEach((element, index) => {
        const days = new Date(year, month + index, 0).getDate();
        const daysLast = new Date(year, month + index - 1, 0).getDate();
        let startDay = new Date(year, month + index - 1, 1).getDay();
        startDate = null;
        // const endDate = null;
        if (startDay - ws < 0) {
          startDay = 7 - ws;
        } else {
          startDay -= ws;
        }
        const monthText =
          languages[lang].monthNames[parseMonth(month - 1 + index)];
        element.setAttribute("data-month", monthText);

        [].slice
          .call(element.querySelectorAll(".d-table input"))
          .forEach((inputEl, i) => {
            const labelEl = inputEl.nextSibling;
            const srOnly = labelEl.querySelectorAll(".visuallyhidden");

            // eslint-disable-next-line no-param-reassign
            inputEl.checked = false;
            inputEl.removeAttribute("disabled");
            // labelEl.removeAttribute('style');
            labelEl.removeAttribute("class");
            // remove existing screen reader legends
            srOnly.forEach((sr) => {
              sr.remove();
            });

            labelEl.removeAttribute("data-legend-id");
            labelEl.className = "";

            let date = null;
            let dayNum;
            if (i < startDay) {
              dayNum = daysLast - (startDay - i - 1);

              // eslint-disable-next-line eqeqeq
              if (index === 0) {
                date = new Date(
                  year,
                  month + index - 2,
                  daysLast - (startDay - i - 1)
                );
                // labelEl.className = 'prev';
                labelEl.className = "d-hidden2 prev";
                inputEl.setAttribute("disabled", "");
              } else {
                date = "";
                labelEl.className = "d-hidden";
                inputEl.setAttribute("disabled", "");
              }
            } else if (i < days + startDay) {
              date = new Date(year, month + index - 1, i - startDay + 1);
              dayNum = i - startDay + 1;
              labelEl.className = "";
            } else {
              dayNum = i - days - startDay + 1;
              if (index === monthElements.length - 1) {
                date = new Date(year, month + index, i - days - startDay + 1);
                labelEl.className = "d-hidden2 next";
                inputEl.setAttribute("disabled", "");
              } else {
                date = "";
                labelEl.className = "d-hidden";
                inputEl.setAttribute("disabled", "");
              }
            }
            labelEl.childNodes[0].innerHTML = dayNum;

            if (date instanceof Date) {
              inputEl.setAttribute("data-date", date.toJSON());
              labelEl.setAttribute("data-date-label", date.toJSON());

              const dayName = date.toLocaleDateString(locales[lang], {
                weekday: "long",
              });
              const monthYear = date.toLocaleDateString(locales[lang], {
                month: "long",
                year: "numeric",
              });

              labelEl.childNodes[0].innerHTML = `<span class="visuallyhidden">${dayName}</span> ${dayNum} <span class="visuallyhidden">${monthYear} </span>`;

              if (
                disabledDates.indexOf(date.getTime()) !== -1 ||
                disabledDays.indexOf(date.getDay()) !== -1
              ) {
                inputEl.setAttribute("disabled", "");
                // add legend for Screen reader
                const unavailableOnlineLegend = document.createElement("span");

                unavailableOnlineLegend.setAttribute("class", "visuallyhidden");

                unavailableOnlineLegend.innerHTML =
                  languages[lang].unavailability; // temp waiting for client input.

                labelEl.appendChild(unavailableOnlineLegend);
              }

              if ((minDate && date < minDate) || (maxDate && date > maxDate)) {
                inputEl.setAttribute("disabled", "");
                labelEl.className += "d-hidden disabled-label";
              }

              if (today && date.getTime() === new Date().setHours(0, 0, 0, 0)) {
                labelEl.classList.add("today");
                labelEl.setAttribute("aria-current", "date");
              } else {
                labelEl.classList.remove("today");
              }

              if (tooltips[date.getTime()]) {
                labelEl.childNodes[0].setAttribute("data-tooltip", true);
                labelEl.childNodes[1].innerHTML = tooltips[date.getTime()];
              } else {
                labelEl.childNodes[0].removeAttribute("data-tooltip");
                labelEl.childNodes[1].innerHTML = "";
              }

              // eslint-disable-next-line no-underscore-dangle
              const _highlights = highlight.filter((x) => {
                for (let m = 0; m < x.dates.length; m += 1) {
                  if (
                    date.getTime() >= x.dates[m].start.getTime() &&
                    date.getTime() <= x.dates[m].end.getTime()
                  ) {
                    return true;
                  }
                }
                return false;
              });

              if (_highlights.length > 0) {
                // let bgColor = "";
                let legendIds = "";

                if (_highlights.length > 1) {
                  // const percent = Math.round(100 / _highlights.length);
                  // bgColor = "background: linear-gradient(-45deg,";
                  for (let z = 0; z < _highlights.length; z += 1) {
                    legendIds += highlight.indexOf(_highlights[z]);
                    if (z !== _highlights.length - 1) {
                      legendIds += " ";
                    }
                    // bgColor += `${_highlights[z].backgroundColor} ${
                    //   percent * z
                    // }%`;
                    if (z !== _highlights.length - 1) {
                      // bgColor += ",";
                      // bgColor += `${_highlights[z].backgroundColor} ${
                      //   percent * (z + 1)
                      // }%,`;
                    }
                  }
                  // bgColor += ");";
                } else {
                  // bgColor = _highlights[0].backgroundColor
                  //   ? "background:" + _highlights[0].backgroundColor + ";"
                  //   : "";
                  legendIds += highlight.indexOf(_highlights[0]);
                }
                // const Color = _highlights[0].color
                //   ? "color:" + _highlights[0].color + ";"
                //   : "";
                // labelEl.setAttribute('style', bgColor + Color);
                // labelEl.setAttribute('class', 'highlighted');

                // add legend for Screen reader
                const highlightLegend = document.createElement("span");

                highlightLegend.setAttribute("class", "visuallyhidden");

                /** TEMP TO BE VERIFIED */
                highlightLegend.innerHTML = highlight[0].legend;

                labelEl.appendChild(highlightLegend);

                labelEl.classList.add("highlighted");

                // labelEl.className += 'highlighted';
                labelEl.setAttribute("data-legend-id", legendIds);
              }
            }
          });
      });

    generateLegends();
  }

  function resetCalendar() {
    [].slice
      .call(that.el.querySelectorAll(".d-table input"))
      .forEach((inputEl) => {
        // eslint-disable-next-line no-param-reassign
        inputEl.checked = false;
      });

    // Disable Month and Year picker

    // [].slice.call(that.el.monthPicker.querySelectorAll('.current')).forEach(function (monthPickEl) {
    // 	monthPickEl.classList.remove('current');
    // });

    // [].slice.call(that.el.yearPicker.querySelectorAll('.current')).forEach(function (yearPickEl) {
    // 	yearPickEl.classList.remove('current');
    // });
  }

  function renderSelectedDates() {
    selectedDates.forEach((date) => {
      const el = that.el.querySelector(`[data-date="${date.toJSON()}"]`);

      if (el) {
        el.checked = true;
      }
    });

    that.el.tables.classList.remove("before");
    if (range && selectedDates.length > 1) {
      const currentDate = new Date(currentYear, currentMonth - 1, 1);
      const sorted = selectedDates.sort((a, b) => a.getTime() - b.getTime());
      const first = that.el.querySelector(
        `[data-date="${sorted[0].toJSON()}"]`
      );
      if (
        !first &&
        currentDate >=
          new Date(sorted[0].getFullYear(), sorted[0].getMonth(), 1) &&
        currentDate <=
          new Date(sorted[1].getFullYear(), sorted[1].getMonth(), 1)
      ) {
        that.el.tables.classList.add("before");
      }
    }
  }

  function setDate() {
    const nextMonthNode = that.el.header.childNodes[2];
    const prevMonthNode = that.el.header.childNodes[1];

    if (
      !that.el.tables.childNodes.length ||
      !that.el.tables.childNodes[0].childNodes.length
    )
      return;

    resetCalendar();

    if (currentMonth > 12 || currentMonth < 1) {
      if (currentMonth > 12) {
        currentYear += 1;
        currentMonth = 1;
      } else {
        currentYear -= 1;
        currentMonth = 12;
      }
    }

    // set min/max date boundary

    if (
      maxDate &&
      new Date(currentYear, currentMonth - 1 + months - 1, 1) >=
        new Date(maxDate).setDate(1)
    ) {
      currentYear = maxDate.getFullYear();
      currentMonth = maxDate.getMonth() + 1 - months + 1;
      // nextMonth.setAttribute('style', 'visibility:hidden');
      nextMonthNode.setAttribute("class", "disabled_btn");
      nextMonthNode.setAttribute("disabled", "");
    } else {
      // nextMonthNode.removeAttribute('style');
      nextMonthNode.removeAttribute("class");
      nextMonthNode.removeAttribute("disabled");
    }
    if (
      minDate &&
      new Date(currentYear, currentMonth - 1, 1) <= new Date(minDate).setDate(1)
    ) {
      currentYear = minDate.getFullYear();
      currentMonth = minDate.getMonth() + 1;
      // prevMonthNode.setAttribute('style', 'visibility:hidden');
      prevMonthNode.setAttribute("class", "disabled_btn");
      prevMonthNode.setAttribute("disabled", "");
    } else {
      // prevMonthNode.removeAttribute('style');
      prevMonthNode.removeAttribute("class");
      prevMonthNode.removeAttribute("disabled");
    }

    // Disable Month Picker
    // for (var c = 0; c < months; c++) {
    // 	var index = currentMonth - 1 + c;
    // 	if (index > 11) {
    // 		index -= 12;
    // 	} else if (index < 0) {
    // 		index += 12;
    // 	}

    // 	that.el.monthPicker.childNodes[index].classList.add('current');
    // }

    generateDates(currentYear, currentMonth);
    // generateYears();
    const startMonth = languages[lang].monthNames[currentMonth - 1];
    let endMonth = "";

    const prevMonthName =
      currentMonth > 1
        ? languages[lang].monthNames[currentMonth - 2]
        : languages[lang].monthNames[11];
    const nextMonthName =
      currentMonth < 12
        ? languages[lang].monthNames[currentMonth]
        : languages[lang].monthNames[0];

    if (months > 1) {
      endMonth += " - ";
      let monthInt = currentMonth - 1 + months - 1;
      if (monthInt > 11) {
        monthInt -= 12;
      } else if (monthInt < 0) {
        monthInt += 12;
      }
      endMonth += languages[lang].monthNames[monthInt];
    }
    // var yearName = currentMonth - 1 + months - 1 > 11 ? currentYear.toString().substring(2, 4) + '/' + (currentYear + 1).toString().substring(2, 4) : currentYear.toString().substring(2, 4);
    const yearName =
      currentMonth - 1 + months - 1 > 11
        ? `${currentYear.toString()}/${(currentYear + 1).toString()}`
        : currentYear.toString();

    // populate calendar header :
    that.el.header.childNodes[0].childNodes[0].innerHTML =
      startMonth + endMonth;
    that.el.header.childNodes[0].childNodes[1].innerHTML = yearName;

    prevMonthNode.setAttribute(
      "aria-label",
      `${languages[lang].prevMonth} (${prevMonthName} ${
        currentMonth > 1 ? currentYear.toString() : (currentYear - 1).toString()
      }))`
    );
    nextMonthNode.setAttribute(
      "aria-label",
      `${languages[lang].nextMonth} (${nextMonthName} ${
        currentMonth < 12
          ? currentYear.toString()
          : (currentYear + 1).toString()
      })`
    );

    // that.el.yearPicker.querySelector('[data-year="0"]').classList.add('current');
    // if (currentMonth - 1 + months - 1 > 11) {
    // 	that.el.yearPicker.querySelector('[data-year="1"]').classList.add('current');
    // }

    renderSelectedDates();
    if (onNavigation) onNavigation.call(that);
  }

  const dataForCurrentMonth = [];
  /** TEMPS DISABLED WAITING FOR AJAX CALL */
  let ajaxNow = 0;

  const highlightDateArraySave = [];
  const disableDateArraySave = [];

  function updateDates(Data) {
    let highlightArray;
    if (Data?.Highlight) {
      highlightArray = Data.Highlight;
    }
    let disabledArray;
    if (Data?.Disabled) {
      disabledArray = Data.Disabled;
    }

    const highlightUpdatedData = [];
    const disabledUpdatedData = [];

    if (highlightArray !== undefined) {
      // eslint-disable-next-line vars-on-top, no-var
      for (let i = 0; i < highlightArray.length; i += 1) {
        const highlightItem = highlightArray[i].split(",");
        highlightUpdatedData.push({
          start: new Date(
            parseInt(highlightItem[0], 10),
            parseInt(highlightItem[1] - 1, 10),
            parseInt(highlightItem[2], 10)
          ),
          end: new Date(
            parseInt(highlightItem[0], 10),
            parseInt(highlightItem[1] - 1, 10),
            parseInt(highlightItem[2], 10)
          ),
        });
      }

      highlight[0].dates = highlightUpdatedData;
    }

    if (disabledArray !== undefined) {
      for (let i = 0; i < disabledArray.length; i += 1) {
        const disabledItem = disabledArray[i].split(",");
        disabledUpdatedData.push(
          new Date(
            parseInt(disabledItem[0], 10),
            parseInt(disabledItem[1] - 1, 10),
            parseInt(disabledItem[2], 10)
          ).getTime()
        );
      }

      disabledDates = disabledUpdatedData;
    }

    setDate();
  }

  function nextMonth() {
    // prevent function execution if btn is disabled
    if (document.querySelector("#d-next").classList.contains("disabled_btn"))
      return;

    ajaxNow += 1;

    // // stock current month data
    const highlightDateSave = [];
    for (let j = 0; j < highlight[0].dates.length; j += 1) {
      // eslint-disable-next-line vars-on-top, no-var, block-scoped-var
      var freshDay = parseInt(highlight[0].dates[j].start.getDate(), 10);
      // eslint-disable-next-line vars-on-top, no-var, block-scoped-var
      var freshMonth = parseInt(highlight[0].dates[j].start.getMonth(), 10);
      // eslint-disable-next-line vars-on-top, no-var, block-scoped-var
      var freshYear = parseInt(highlight[0].dates[j].start.getFullYear(), 10);
      // eslint-disable-next-line block-scoped-var
      highlightDateSave[j] = [freshYear, freshMonth, freshDay];
      highlightDateArraySave.push(highlightDateSave[j]);
    }

    for (let k = 0; k < disabledDates.length; k += 1) {
      // eslint-disable-next-line vars-on-top, no-var, no-redeclare, block-scoped-var
      var freshDay = new Date(disabledDates[k]).getDate();
      // eslint-disable-next-line vars-on-top, no-var, no-redeclare, block-scoped-var
      var freshMonth = new Date(disabledDates[k]).getMonth() + 1;
      // eslint-disable-next-line vars-on-top, no-var, no-redeclare, block-scoped-var
      var freshYear = new Date(disabledDates[k]).getFullYear();
      // eslint-disable-next-line block-scoped-var
      disableDateArraySave.push([freshYear, freshMonth, freshDay]);
    }

    // increment current month
    currentMonth += months;

    if (currentMonth > 12) {
      currentMonth = 1;
      currentYear += 1;
    }

    let Data;

    // test if data exist
    if (dataForCurrentMonth[currentMonth]) {
      Data = dataForCurrentMonth[currentMonth];
      updateDates(Data);
    } else {
      // hide next & prev btn during ajax call
      document.querySelector("#d-next").classList.add("disabled_btn");
      document.querySelector("#d-previous").classList.add("disabled_btn");
      document.querySelector(".d-table").classList.add("ajaxloading");

      // AJAX CALL HERE
      callAjax(
        "GET",
        `${window.location.origin}/fr/get-calendar-by-month?year=${currentYear}&month=${currentMonth}`,
        (data) => {
          const json = JSON.parse(data);
          if (
            json instanceof Object &&
            (json?.Disabled.length > 0 || json?.Available.length > 0)
          ) {
            const json = JSON.parse(data);
            // show back next & prev btn on succes
            document.querySelector("#d-next").classList.remove("disabled_btn");
            document
              .querySelector("#d-previous")
              .classList.remove("disabled_btn");
            document.querySelector(".d-table").classList.remove("ajaxloading");
            // stock data
            dataForCurrentMonth[currentMonth] = json;
            // update dates
            updateDates(json);
          } else {
            document.querySelector(".d-table").classList.remove("ajaxloading");
            document.getElementById("calendarContainer").style.minHeight =
              "auto";
            document
              .getElementById("calendarContainer")
              .querySelector(".alert-message").style.display = "flex";
            document
              .getElementById("calendarContainer")
              .querySelector(".alert-message")
              .setAttribute("aria-hidden", "false");
            showNextSubstepAnim({
              stickyElement: "main-header",
              domElement: "alert-message",
            });
            setTimeout(() => {
              document
                .querySelector(".alert-message")
                .setAttribute("role", "alert");
            }, 750);
          }
        }
      );
    }
  }

  /** TEMP - DISABLED WAITING FOR AJAX CALL */
  function prevMonth() {
    // prevent function execution if btn is disabled
    if (
      document.querySelector("#d-previous").classList.contains("disabled_btn")
    )
      return;

    // eslint-disable-next-line no-plusplus
    ajaxNow--;
    currentMonth -= months;

    let windowVisitDate;
    let modificationCurrentMonth;
    if (window.b2cStep1Modification) {
      const windowStep1Values = window.b2cStep1Modification;
      windowVisitDate = windowStep1Values.find(
        (x) => x.name === "visite-date"
      )?.value;
      modificationCurrentMonth = new Date(windowVisitDate).getMonth() + 1;
    }
    const currentDate = new Date();
    const currentDateMonth = currentDate.getMonth() + 1;

    if (currentMonth < 1) {
      currentMonth = 12;
      currentYear -= 1;
    }

    /** is preselected date not in current month */
    if (modificationCurrentMonth > currentDateMonth) {
      // hide next & prev btn during ajax call
      document.querySelector("#d-next").classList.add("disabled_btn");
      document.querySelector("#d-previous").classList.add("disabled_btn");
      document.querySelector(".d-table").classList.add("ajaxloading");
      callAjax(
        "GET",
        `get-calendar-by-month?year=${currentYear}&month=${currentMonth}`,
        (data) => {
          const json = JSON.parse(data);
          // show back next & prev btn on succes
          document.querySelector("#d-next").classList.remove("disabled_btn");
          document
            .querySelector("#d-previous")
            .classList.remove("disabled_btn");
          document.querySelector(".d-table").classList.remove("ajaxloading");
          // stock data
          dataForCurrentMonth[currentMonth] = json;
          // update dates
          updateDates(json);
        }
      );
    }

    if (ajaxNow === 0) {
      // first load data
      const highlightUpdatedData = [];
      for (let i = 0; i < highlightDateArraySave.length; i += 1) {
        highlightUpdatedData.push({
          start: new Date(
            highlightDateArraySave[i][0],
            highlightDateArraySave[i][1],
            highlightDateArraySave[i][2]
          ),
          end: new Date(
            highlightDateArraySave[i][0],
            highlightDateArraySave[i][1],
            highlightDateArraySave[i][2]
          ),
        });
      }

      const disabledUpdatedData = [];
      for (let i = 0; i < disableDateArraySave.length; i += 1) {
        disabledUpdatedData.push(
          new Date(
            disableDateArraySave[i][0],
            parseInt(disableDateArraySave[i][1] - 1, 10),
            disableDateArraySave[i][2]
          ).getTime()
        );
      }

      dataForCurrentMonth[currentMonth] = {
        highlighted: highlightUpdatedData,
        disabled: disabledUpdatedData,
      };

      highlight[0].dates = dataForCurrentMonth[currentMonth].highlighted;
      disabledDates = dataForCurrentMonth[currentMonth].disabled;
    } else {
      const Data = dataForCurrentMonth[currentMonth];
      updateDates(Data);
    }

    setDate();
  }

  function selectDate(date, ignoreOnSelect) {
    // eslint-disable-next-line no-param-reassign
    date = new Date(date);
    date.setHours(0, 0, 0, 0);
    const el = that.el.querySelector(`[data-date="${date.toJSON()}"]`);

    if (range && el && el.checked) {
      el.classList.add("single");
    }

    if (el && !el.checked) {
      el.checked = true;
    }

    selectedDates.push(date);
    // eslint-disable-next-line no-console
    // console.log("selectedDates :>> ", selectedDates);

    if (onSelect && !ignoreOnSelect) {
      onSelect.apply(date, [true]);
    }
  }

  function unselectDate(date, ignoreOnSelect) {
    // eslint-disable-next-line no-param-reassign
    date = new Date(date);
    date.setHours(0, 0, 0, 0);
    const el = that.el.querySelector(`[data-date="${date.toJSON()}"]`);
    if (el) {
      el.classList.remove("single");
      if (el.checked) {
        el.checked = false;
      }
    }

    selectedDates = selectedDates.filter((x) => x.getTime() !== date.getTime());

    if (onSelect && !ignoreOnSelect) {
      onSelect.call(date, false);
    }
  }

  function unselectAll(ignoreOnSelect) {
    selectedDates.forEach((date) => {
      unselectDate(date, ignoreOnSelect);
    });
  }

  function inputChange() {
    const input = this;
    const date = new Date(input.getAttribute("data-date"));
    input.classList.remove("single");
    if (locked) {
      return;
    }
    if (range) {
      that.el.tables.classList.remove("before");
    }
    if (input.checked) {
      if (maxSelections && selectedDates.length > maxSelections - 1) {
        let { length } = selectedDates;
        for (length; length > maxSelections - 1; length -= 1) {
          unselectDate(selectedDates[0]);
        }
      }

      if (range && selectedDates.length) {
        const first = that.el.querySelector(
          `[data-date="${selectedDates[0].toJSON()}"]`
        );
        if (!first && date > selectedDates[0]) {
          that.el.tables.classList.add("before");
        }
      }

      selectedDates.push(date);

      if (closeOnSelect) {
        that.hide();
      }
    } else if (
      range &&
      selectedDates.length === 1 &&
      selectedDates[0].getTime() === date.getTime()
    ) {
      selectDate(date);
      input.classList.add("single");
    } else {
      selectedDates = selectedDates.filter(
        (x) => x.getTime() !== date.getTime()
      );
    }

    if (onSelect) {
      onSelect.call(date, input.checked);
    }
  }

  function setRange(val) {
    if (val) {
      range = true;
      that.el.tables.classList.add("range");
    } else {
      range = false;
      that.el.tables.classList.remove("range");
    }
  }

  function setArgs(x) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in x) {
      if (key in that) {
        that[key] = x[key];
      }
    }
  }

  // eslint-disable-next-line consistent-return
  function whichAnimationEvent() {
    let t;
    const el = document.createElement("fakeelement");
    const transitions = {
      animation: "animationend",
      OAnimation: "oanimationend",
      MozAnimation: "animationend",
      WebkitAnimation: "webkitAnimationEnd",
      "": "MSAnimationEnd",
    };

    // eslint-disable-next-line no-restricted-syntax
    for (t in transitions) {
      if (el.style[t] !== undefined) {
        return transitions[t];
      }
    }
  }

  function show(properties) {
    if (!that.inline && that.container === document.body) {
      document.body.classList.add("d-noscroll");
    }
    setArgs(properties);
    const handler = function handler() {
      that.el.classList.remove("d-show");
      that.el.calendar.removeEventListener(whichAnimationEvent(), handler);
    };
    that.el.calendar.addEventListener(whichAnimationEvent(), handler);
    that.el.classList.add("d-show");
    /**  TEMP */
    container.appendChild(that.el);
    opened = true;
    if (startDate) {
      currentMonth = startDate.getMonth() + 1;
      currentYear = startDate.getFullYear();
    }
    setDate();
  }

  function hide() {
    document.body.classList.remove("d-noscroll");
    const handler = function handler() {
      that.el.parentNode.removeChild(that.el);
      opened = false;
      that.el.classList.remove("d-hide");
      if (typeof onClose === "function") {
        onClose.apply(that);
      }
      that.el.removeEventListener(whichAnimationEvent(), handler);
    };
    that.el.addEventListener(whichAnimationEvent(), handler);
    that.el.classList.add("d-hide");
  }

  function bindEvents() {
    that.el.header.childNodes[1].addEventListener(eventName, prevMonth);
    that.el.header.childNodes[2].addEventListener(eventName, nextMonth);

    that.el.header.childNodes[0].childNodes[0].addEventListener(
      eventName,
      () => {
        // disable month-picker options
        // if (that.el.monthPicker.classList.contains('d-show')) {
        // 	that.el.monthPicker.classList.remove('d-show');
        // } else {
        // 	that.el.monthPicker.classList.add('d-show');
        // }
        // that.el.yearPicker.classList.remove('d-show');
      }
    );
    // disable year-picker options
    that.el.header.childNodes[0].childNodes[1].addEventListener(
      eventName,
      () => {
        // generateYears();
        // if (that.el.yearPicker.classList.contains('d-show')) {
        // 	that.el.yearPicker.classList.remove('d-show');
        // } else {
        // 	that.el.yearPicker.classList.add('d-show');
        // }
        // that.el.monthPicker.classList.remove('d-show');
      }
    );
    that.el.button.addEventListener(eventName, hide);

    that.el.overlay.addEventListener(eventName, () => {
      if (closeOnClick) {
        that.hide();
      }
    });

    // disable montPicker yearPicker
    // [].slice.call(that.el.monthPicker.childNodes).forEach(function (monthPicker) {
    // 	monthPicker.addEventListener(eventName, function () {
    // 		currentMonth = parseInt(this.getAttribute('data-month'));
    // 		setDate();
    // 		that.el.monthPicker.classList.remove('d-show');
    // 	});
    // });

    // [].slice.call(that.el.yearPicker.childNodes).forEach(function (yearPicker) {
    // 	yearPicker.addEventListener(eventName, function () {
    // 		currentYear += parseInt(this.getAttribute('data-year'));
    // 		setDate();
    // 		that.el.yearPicker.classList.remove('d-show');
    // 	});
    // });

    /** possibility to swipe horizontally in order to change month
     * involve capturing touch event and therefore
     * the impossibility of scrolling on the calendar */
    // let startX = 0;
    // let distance = 0;
    // that.el.calendar.addEventListener("touchstart", (e) => {
    //   startX =
    //     e.changedTouches[0].clientX ||
    //     e.originalEvent.changedTouches[0].clientX;
    //   // e.preventDefault();
    // });

    // that.el.calendar.addEventListener("touchmove", (e) => {
    //   distance =
    //     e.changedTouches[0].clientX - startX ||
    //     e.originalEvent.changedTouches[0].clientX - startX;
    //   e.preventDefault();
    // });

    // that.el.calendar.addEventListener("touchend", () => {
    //   if (distance > 50) {
    //     prevMonth();
    //   } else if (distance < -50) {
    //     nextMonth();
    //   }
    //   distance = 0;
    // });

    // prevent form submitting on enter an enable date selection on focused input enter key press
    that.el.calendar.addEventListener("keypress", (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        e.target.click();
        // if (e.target.classList.contains("tabbed")) {
        //   e.preventDefault();
        //   e.target.click();
        // }
      }
    });
  }

  // eslint-disable-next-line vars-on-top, no-var
  var getBrowserVersion = function getBrowserVersion() {
    let browser = {
      type: null,
      version: null,
    };

    const ua = navigator.userAgent;
    let tem;
    let ios;
    let M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
    // eslint-disable-next-line prefer-const
    ios = ua.match(/(iphone|ipad)\s+OS\s+([\d+_]+\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      browser.type = "MSIE";
      browser.version = parseInt(tem[1], 10);
      return browser;
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\bOPR\/(\d+)/);
      if (tem !== null) return `Opera ${tem[1]}`;
    }
    if (ios[1]) {
      // eslint-disable-next-line no-return-assign
      return (browser = {
        type: "iOS",
        version: ios[2],
      });
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    // eslint-disable-next-line no-cond-assign
    if ((tem = ua.match(/version\/(\d+)/i)) !== null) M.splice(1, 1, tem[1]);
    // eslint-disable-next-line prefer-destructuring
    browser.type = M[0];
    browser.version = parseInt(M[1], 10);

    return browser;
  };

  function init() {
    that.el = document.createElement("div");
    that.el.id = "Datepickk";
    // eslint-disable-next-line no-use-before-define
    that.el.classList.add(getBrowserVersion().type);
    // eslint-disable-next-line no-use-before-define
    that.el.innerHTML = template;
    // eslint-disable-next-line prefer-destructuring
    that.el.calendar = that.el.childNodes[1];
    // eslint-disable-next-line prefer-destructuring
    that.el.titleBox = that.el.childNodes[0];
    // eslint-disable-next-line prefer-destructuring
    that.el.button = that.el.childNodes[3];
    // eslint-disable-next-line prefer-destructuring
    that.el.header = that.el.calendar.childNodes[0];
    // that.el.monthPicker = that.el.calendar.childNodes[1];
    // that.el.yearPicker = that.el.calendar.childNodes[2];
    // eslint-disable-next-line prefer-destructuring
    that.el.tables = that.el.calendar.childNodes[2];
    // eslint-disable-next-line prefer-destructuring
    that.el.days = that.el.calendar.childNodes[1];

    // eslint-disable-next-line prefer-destructuring
    that.el.overlay = that.el.childNodes[4];
    // eslint-disable-next-line prefer-destructuring
    that.el.legend = that.el.childNodes[2];
    setArgs(args);

    generateInputs();
    generateDaynames();
    bindEvents();

    if (inline) {
      show();
    }
  }

  that.show = show;
  that.hide = hide;
  that.selectDate = selectDate;
  that.unselectAll = unselectAll;
  that.unselectDate = unselectDate;

  function currentDateGetter() {
    return new Date(currentYear, currentMonth - 1, 1);
  }
  function currentDateSetter(x) {
    // eslint-disable-next-line no-param-reassign
    x = new Date(x);
    currentMonth = x.getMonth() + 1;
    currentYear = x.getFullYear();
    setDate();
  }

  Object.defineProperties(that, {
    selectedDates: {
      get: function get() {
        return selectedDates.sort((a, b) => a.getTime() - b.getTime());
      },
    },
    range: {
      get: function get() {
        return range;
      },
      set: function set(x) {
        setRange(x);
        if (x) {
          maxSelections = 2;
        }
      },
    },
    button: {
      get: function get() {
        return button;
      },
      set: function set(x) {
        if (typeof x === "string") {
          button = x;
        } else {
          button = null;
        }
        that.el.button.innerHTML = button || "";
      },
    },
    title: {
      get: function get() {
        return title;
      },
      set: function set(x) {
        if (typeof x === "string") {
          title = x;
        } else {
          title = null;
        }
        that.el.titleBox.innerText = title || "";
      },
    },
    lang: {
      get: function get() {
        return lang;
      },
      set: function set(x) {
        if (x in languages) {
          lang = x;
          generateDaynames();
          setDate();
        } else {
          // eslint-disable-next-line no-console
          // console.error("Language not found");
          lang = "fr";
          generateDaynames();
          setDate();
        }
      },
    },
    weekStart: {
      get: function get() {
        return weekStart !== null ? weekStart : languages[lang].weekStart;
      },
      set: function set(x) {
        if (typeof x === "number" && x > -1 && x < 7) {
          weekStart = x;
          generateDaynames();
          setDate();
        } else {
          // eslint-disable-next-line no-console
          console.error("weekStart must be a number between 0 and 6");
        }
      },
    },
    months: {
      get: function get() {
        return months;
      },
      set: function set(x) {
        if (typeof x === "number" && x > 0) {
          months = x;
          generateDaynames();
          generateInputs();
          setDate();

          if (months === 1) {
            that.el.classList.remove("multi");
          } else {
            that.el.classList.add("multi");
          }
        } else {
          // eslint-disable-next-line no-console
          console.error("months must be a number > 0");
        }
      },
    },
    isOpen: {
      get: function get() {
        return opened;
      },
    },
    closeOnSelect: {
      get: function get() {
        return closeOnSelect;
      },
      set: function set(x) {
        if (x) {
          closeOnSelect = true;
        } else {
          closeOnSelect = false;
        }
      },
    },
    disabledDays: {
      get: function get() {
        return disabledDays;
      },
      set: function set(x) {
        if (x instanceof Array) {
          for (let i = 0; i < x.length; i += 1) {
            if (typeof x[i] === "number") {
              disabledDays.push(x[i]);
            }
          }
        } else if (typeof x === "number") {
          disabledDays = [x];
        } else if (!x) {
          disabledDays = [];
        }
        setDate();
      },
    },
    disabledDates: {
      get: function get() {
        return disabledDates.map((x) => new Date(x));
      },
      set: function set(x) {
        if (x instanceof Array) {
          x.forEach((date) => {
            if (date instanceof Date) {
              disabledDates.push(
                new Date(
                  date.getFullYear(),
                  date.getMonth(),
                  date.getDate()
                ).getTime()
              );
            }
          });
        } else if (x instanceof Date) {
          disabledDates = [
            new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime(),
          ];
        } else if (!x) {
          disabledDates = [];
        }
        setDate();
      },
    },
    highlight: {
      get: function get() {
        return highlight;
      },
      set: function set(x) {
        if (x instanceof Array) {
          x.forEach((hl) => {
            if (hl instanceof Object) {
              const highlightObj = {};
              highlightObj.dates = [];

              if ("start" in hl) {
                highlightObj.dates.push({
                  start: new Date(
                    hl.start.getFullYear(),
                    hl.start.getMonth(),
                    hl.start.getDate()
                  ),
                  end:
                    "end" in hl
                      ? new Date(
                          hl.end.getFullYear(),
                          hl.end.getMonth(),
                          hl.end.getDate()
                        )
                      : new Date(
                          hl.start.getFullYear(),
                          hl.start.getMonth(),
                          hl.start.getDate()
                        ),
                });
              } else if ("dates" in hl && hl.dates instanceof Array) {
                hl.dates.forEach((hlDate) => {
                  highlightObj.dates.push({
                    start: new Date(
                      hlDate.start.getFullYear(),
                      hlDate.start.getMonth(),
                      hlDate.start.getDate()
                    ),
                    end:
                      "end" in hlDate
                        ? new Date(
                            hlDate.end.getFullYear(),
                            hlDate.end.getMonth(),
                            hlDate.end.getDate()
                          )
                        : new Date(
                            hlDate.start.getFullYear(),
                            hlDate.start.getMonth(),
                            hlDate.start.getDate()
                          ),
                  });
                });
              }

              highlightObj.color = hl.color;
              highlightObj.backgroundColor = hl.backgroundColor;
              highlightObj.legend = "legend" in hl ? hl.legend : null;

              highlight.push(highlightObj);
            }
          });
        } else if (x instanceof Object) {
          const highlightObj = {};
          highlightObj.dates = [];

          if ("start" in x) {
            highlightObj.dates.push({
              start: new Date(
                x.start.getFullYear(),
                x.start.getMonth(),
                x.start.getDate()
              ),
              end:
                "end" in x
                  ? new Date(
                      x.end.getFullYear(),
                      x.end.getMonth(),
                      x.end.getDate()
                    )
                  : new Date(
                      x.start.getFullYear(),
                      x.start.getMonth(),
                      x.start.getDate()
                    ),
            });
          } else if ("dates" in x && x.dates instanceof Array) {
            x.dates.forEach((hlDate) => {
              highlightObj.dates.push({
                start: new Date(
                  hlDate.start.getFullYear(),
                  hlDate.start.getMonth(),
                  hlDate.start.getDate()
                ),
                end:
                  "end" in hlDate
                    ? new Date(
                        hlDate.end.getFullYear(),
                        hlDate.end.getMonth(),
                        hlDate.end.getDate()
                      )
                    : new Date(
                        hlDate.start.getFullYear(),
                        hlDate.start.getMonth(),
                        hlDate.start.getDate()
                      ),
              });
            });
          }

          highlightObj.color = x.color;
          highlightObj.backgroundColor = x.backgroundColor;
          highlightObj.legend = "legend" in x ? x.legend : null;

          highlight.push(highlightObj);
        } else if (!x) {
          highlight = [];
        }

        setDate();
      },
    },
    onClose: {
      set: function set(callback) {
        onClose = callback;
      },
    },
    onSelect: {
      set: function set(callback) {
        onSelect = callback;
      },
    },
    today: {
      get: function get() {
        return today;
      },
      set: function set(x) {
        if (x) {
          today = true;
        } else {
          today = false;
        }
      },
    },
    daynames: {
      get: function get() {
        return daynames;
      },
      set: function set(x) {
        if (x) {
          daynames = true;
        } else {
          daynames = false;
        }
        generateDaynames();
      },
    },
    fullscreen: {
      get: function get() {
        return that.el.classList.contains("fullscreen");
      },
      set: function set(x) {
        if (x) {
          that.el.classList.add("fullscreen");
        } else {
          that.el.classList.remove("fullscreen");
        }
      },
    },
    locked: {
      get: function get() {
        return locked;
      },
      set: function set(x) {
        if (x) {
          locked = true;
          that.el.tables.classList.add("locked");
        } else {
          locked = false;
          that.el.tables.classList.remove("locked");
        }
      },
    },
    maxSelections: {
      get: function get() {
        return maxSelections;
      },
      set: function set(x) {
        if (typeof x === "number" && !range) {
          maxSelections = x;
        } else if (range) {
          maxSelections = 2;
        } else {
          maxSelections = null;
        }
      },
    },
    onConfirm: {
      set: function set(callback) {
        if (typeof callback === "function") {
          onConfirm = callback.bind(that);
          that.el.button.addEventListener(eventName, onConfirm);
        } else if (!callback) {
          that.el.button.removeEventListener(eventName, onConfirm);
          onConfirm = null;
        }
      },
    },
    onNavigation: {
      set: function set(callback) {
        if (typeof callback === "function") {
          onNavigation = callback.bind(that);
        } else if (!callback) {
          onNavigation = null;
        }
      },
    },
    closeOnClick: {
      get: function get() {
        return closeOnClick;
      },
      set: function set(x) {
        if (x) {
          closeOnClick = true;
        } else {
          closeOnClick = false;
        }
      },
    },
    tooltips: {
      get: function get() {
        const ret = [];
        // eslint-disable-next-line no-restricted-syntax, guard-for-in, no-undef
        for (key in tooltips) {
          ret.push({
            // eslint-disable-next-line no-undef
            date: new Date(parseInt(key, 10)),
            // eslint-disable-next-line no-undef
            text: tooltips[key],
          });
        }
        return ret;
      },
      set: function set(x) {
        if (x instanceof Array) {
          x.forEach((item) => {
            if (item.date && item.text && item.date instanceof Date) {
              tooltips[
                new Date(
                  item.date.getFullYear(),
                  item.date.getMonth(),
                  item.date.getDate()
                ).getTime()
              ] = item.text;
            }
          });
        } else if (x instanceof Object) {
          if (x.date && x.text && x.date instanceof Date) {
            tooltips[
              new Date(
                x.date.getFullYear(),
                x.date.getMonth(),
                x.date.getDate()
              ).getTime()
            ] = x.text;
          }
        } else if (!x) {
          tooltips = [];
        }
        setDate();
      },
    },
    currentDate: {
      get: currentDateGetter,
      set: currentDateSetter,
    },
    setDate: {
      set: currentDateSetter,
    },
    startDate: {
      get: function get() {
        return startDate;
      },
      set: function set(x) {
        if (x) {
          startDate = new Date(x);
        } else {
          startDate = null;
          currentYear = new Date().getFullYear();
          currentMonth = new Date().getMonth() + 1;
        }
        setDate();
      },
    },
    minDate: {
      get: function get() {
        return minDate;
      },
      set: function set(x) {
        minDate = x ? new Date(x) : null;
        setDate();
      },
    },
    maxDate: {
      get: function get() {
        return maxDate;
      },
      set: function set(x) {
        maxDate = x ? new Date(x) : null;
        setDate();
      },
    },
    container: {
      get: function get() {
        return container;
      },
      set: function set(x) {
        if (x instanceof String) {
          const y = document.querySelector(x);
          if (y) {
            container = y;
            if (container !== document.body) {
              that.el.classList.add("wrapped");
            } else {
              that.el.classList.remove("wrapped");
            }
          } else {
            // eslint-disable-next-line no-console
            console.error("Container doesn't exist");
          }
        } else if (x instanceof HTMLElement) {
          container = x;
          if (container !== document.body) {
            that.el.classList.add("wrapped");
          } else {
            that.el.classList.remove("wrapped");
          }
        } else {
          // eslint-disable-next-line no-console
          console.error("Invalid type");
        }
      },
    },
    inline: {
      get: function get() {
        return inline;
      },
      set: function set(x) {
        if (x) {
          inline = true;
          that.el.classList.add("inline");
        } else {
          inline = false;
          that.el.classList.remove("inline");
        }
      },
    },
  });

  const prevButton = `<button id="d-previous" type="button"><i aria-hidden="true"></i><span class="visuallyhidden"> < ${languages[lang].prevMonth}</span></button>`;
  const nextButton = `<button id="d-next" type="button"><i aria-hidden="true"></i><span class="visuallyhidden"> > ${languages[lang].nextMonth}</span></button>`;
  // eslint-disable-next-line vars-on-top, no-var
  var template =
    // eslint-disable-next-line prefer-template
    '<div class="d-title"></div>' +
    '<div class="d-calendar">' +
    '<div class="d-header"><p aria-live="polite"><span class="d-month"></span><span class="d-year"></span></p>' +
    prevButton +
    nextButton +
    "</div>" +
    '<div class="d-weekdays"></div>' +
    '<fieldset class="d-tables"></fieldset>' +
    "</div>" +
    '<div class="d-legend"></div>' +
    '<button class="d-confirm"></button>' +
    '<div class="d-overlay"></div>';

  init();
  setDate();

  return Object.freeze(that);
}

//=require ../globals/gsap-register.js

class DisclosureButtonCart {
  constructor(buttonNode) {
    this.buttonNode = buttonNode;
    this.controlledNode = false;
    this.parentNode = buttonNode.parentNode;
    this.mode = "default";

    const id = this.buttonNode.getAttribute("aria-controls");

    if (this.buttonNode.parentNode.classList.contains("popover")) {
      this.mode = "popover";
    }

    if (id) {
      this.controlledNode = document.getElementById(id);
      this.controlledNode.classList.add("disclosure-content");
    }

    this.buttonNode.setAttribute("aria-expanded", "false");
    this.buttonNode.classList.add("disclosure-button");
    this.hideContent();

    this.buttonNode.addEventListener("click", this.onClick.bind(this));
    this.buttonNode.addEventListener("focus", this.onFocus.bind(this));
    this.buttonNode.addEventListener("blur", this.onBlur.bind(this));
  }

  showContent() {
    if (this.controlledNode) {
      const newOverlay = document.createElement("div");
      newOverlay.setAttribute("id", "mobileCartOverlay");
      document
        .querySelector(".customer-journey-form")
        .insertBefore(newOverlay, document.querySelector(".cart-container"));

      document.querySelector("body").classList.add("noOverflow");
      const tl = gsap.timeline({
        onComplete: () => {
          this.buttonNode.setAttribute("aria-expanded", "true");
        },
      });
      tl.to(
        this.parentNode.querySelector(".cart-expandable-content"),
        {
          duration: 0.25,
          height: "auto",
          ease: "power1.out",
        },
        0
      );

      if (document?.querySelector("#mobileCartOverlay")) {
        tl.to(
          document.querySelector("#mobileCartOverlay"),
          {
            duration: 0.1,
            opacity: 1,
            ease: "linear",
          },
          0
        );
      }

      this.controlledNode.setAttribute("aria-hidden", "false");
      this.controlledNode.classList.add("disclosure-content-opened");
      this.parentNode.classList.add("isOpen");
    }
  }

  hideContent() {
    if (this.controlledNode) {
      const footerHeight = this.parentNode.querySelector("footer").offsetHeight;
      const headerHeight = this.parentNode.querySelector("header").offsetHeight;
      const mainVerticalPaddingSum = 32;
      const difHeight =
        footerHeight + headerHeight + mainVerticalPaddingSum + 16;

      this.parentNode
        .querySelector(".cart-content")
        .setAttribute("style", `max-height: calc(100vh - ${difHeight}px)`);
      const tl = gsap.timeline({
        onComplete: () => {
          if (document?.querySelector("#mobileCartOverlay")) {
            document.querySelector("#mobileCartOverlay").remove();
            this.buttonNode.setAttribute("aria-expanded", "false");
          }
        },
      });
      tl.to(
        this.parentNode.querySelector(".cart-expandable-content"),
        {
          duration: 0.25,
          height: 0,
          ease: "power1.out",
        },
        0
      );

      if (document?.querySelector("#mobileCartOverlay")) {
        tl.to(
          document.querySelector("#mobileCartOverlay"),
          {
            duration: 0.1,
            opacity: 1,
            ease: "linear",
          },
          0
        );
      }
      this.controlledNode.setAttribute("aria-hidden", "true");
      this.controlledNode.classList.remove("disclosure-content-opened");
      this.parentNode.classList.remove("isOpen");
      document.querySelector("body").classList.remove("noOverflow");
    }
  }

  toggleExpand() {
    if (this.buttonNode.getAttribute("aria-expanded") === "true") {
      this.hideContent();
    } else {
      this.showContent();
    }
  }
  /* EVENT HANDLERS */

  onClick() {
    this.toggleExpand();
  }

  onFocus() {
    this.buttonNode.classList.add("focus");
  }

  onBlur() {
    this.buttonNode.classList.remove("focus");
  }
}

// window.addEventListener("load", () => {
//   const windowWidth = window.innerWidth;
//   /** initialize cart disclosure */
//   if (windowWidth < 741) {
//     const buttons = document.querySelectorAll(
//       ".disclosure-cart-btn[aria-expanded][aria-controls]"
//     );
//     for (let i = 0; i < buttons.length; i += 1) {
//       (() => new DisclosureButtonCart(buttons[i]))();
//     }
//   }
// });

// window.addEventListener("resize", () => {
//   const windowWidth = window.innerWidth;
//   /** Initialize Hide/Show Buttons */
//   if (windowWidth < 741) {
//     const disclosureCartButtons = document.querySelectorAll(
//       ".disclosure-cart-btn[aria-expanded][aria-controls]"
//     );
//     for (let i = 0; i < disclosureCartButtons.length; i += 1) {
//       (() => new DisclosureButtonCart(disclosureCartButtons[i]))();
//     }
//   } else if (document.getElementById("cart-expandable-content")) {
//     document
//       .getElementById("cart-expandable-content")
//       .removeAttribute("style");
//   }
// });

function displayLiveMessage(dialogId, callback) {
  const elDialog = document.querySelector(dialogId);
  const close = elDialog.querySelector(".close-dialog");

  function closeDialog() {
    elDialog.classList.remove("visible-dialog");
    // eslint-disable-next-line no-use-before-define
    document.removeEventListener("keydown", addESC);
    elDialog.removeEventListener("keydown", closeDialog);

    setTimeout(() => {
      elDialog.style.display = "none";
    }, 250);
  }

  function addESC(e) {
    if (e.keyCode === 27) {
      closeDialog();
    }
  }

  function openDialog() {
    elDialog.style.display = "flex";
    setTimeout(() => {
      elDialog.classList.add("visible-dialog");
    }, 100);

    document.addEventListener("keydown", addESC);
    if (elDialog.querySelector(".focusfirst")) {
      elDialog.querySelector(".focusfirst").focus();
    }
  }

  openDialog();

  close.addEventListener("click", () => {
    closeDialog();
  });

  const dialog = elDialog;
  const focusableElementsArray = [
    "[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])',
  ];
  const keyCodes = {
    tab: 9,
    enter: 13,
    escape: 27,
  };
  const focusableElements = dialog.querySelectorAll(focusableElementsArray);
  const firstFocusableElement = focusableElements[0];

  // firstFocusableElement.focus();
  const lastFocusableElement = focusableElements[focusableElements.length - 1];
  // Garder le focus à l'intérieur de la modale critère 7.1
  focusableElements.forEach((focusableElement) => {
    if (focusableElement.addEventListener) {
      focusableElement.addEventListener("keydown", (event) => {
        const tab = event.which === keyCodes.tab;

        if (!tab) {
          return;
        }

        if (event.shiftKey) {
          if (event.target === firstFocusableElement) {
            // shift + tab
            event.preventDefault();

            lastFocusableElement.focus();
          }
        } else if (event.target === lastFocusableElement) {
          // tab
          event.preventDefault();

          firstFocusableElement.focus();
        }
      });
    }
  });
  if (callback) {
    callback(elDialog);
  }
}

//= require ./b--u-dateFormatOption.js

function getCalendar(
  now,
  disabledDate,
  highlightedDate,
  legend,
  validityPeriodEndDate,
  legendContainer,
  date
) {
  let calendarLang = document.documentElement.lang;
  // exception pour le chinois
  if (calendarLang === "zh-hans") {
    calendarLang = "zh";
  }
  const datepicker = new Datepickk({
    inline: true,
    container: document.querySelector("#calendarContainer"),
    maxSelections: 1,
    today: true,
    lang: calendarLang,
    weekStart: 1,
    minDate: new Date(now.getFullYear(), now.getMonth(), now.getDate()),
    maxDate: new Date(
      // eslint-disable-next-line no-undef
      validityPeriodEndDate.getFullYear(),
      // eslint-disable-next-line no-undef
      validityPeriodEndDate.getMonth(),
      // eslint-disable-next-line no-undef
      validityPeriodEndDate.getDate()
    ),
    disabledDates: disabledDate,
    highlight: {
      dates: highlightedDate,
      backgroundColor: "#ff6347", // to be removed
      color: "#ffffff", // to be removed
      legend, // this is optional
    },
    legendContainer,
  });

  if (date && date !== now) {
    datepicker.selectDate(date);
    datepicker.setDate = date;
    const thisMonth = date.getMonth() + 1;
    const thisYear = date.getFullYear();
    const thisDay = date.getDate();
    initTimeSelection({
      year: thisYear,
      month: thisMonth,
      day: thisDay,
    });
  }

  datepicker.onSelect = function dpSelect(checked) {
    const currentLang = document.querySelector("html").getAttribute("lang");
    const newCartDateTime = document.querySelector(".cart-item-date-time");
    const newCartDate = document
      .querySelector(".cart-item-date-time")
      .querySelector(".cart-item-date");
    const newCartTime = document
      .querySelector(".cart-item-date-time")
      .querySelector(".cart-item-time");

    if (checked) {
      const options = dateFormatOption();
      const formatDate = this.toLocaleDateString(currentLang, options).replace(
        this.getFullYear(),
        ""
      );
      const formatedDate =
        formatDate.charAt(0).toUpperCase() + formatDate.slice(1);

      const thisDay = this.getDate();
      const thisMonth = this.getMonth() + 1;
      const thisYear = this.getFullYear();
      document.querySelector(
        '[name="visite-date"]'
      ).value = `${thisYear}-${zeroLeading(thisMonth)}-${zeroLeading(thisDay)}`;

      // TODO WHEN DATE SELECTED
      if (document?.querySelector('[data-tunnel-type="tunnel_date_heure"]')) {
        document
          .querySelector(".time-selection-container")
          ?.querySelector(".conditional-content:not(.last-tickets-available")
          .classList.add("ajaxloading");
        showNextSubstepAnim({
          stickyElement: "main-header",
          domElement: "time-selection-container",
        });
        initTimeSelection({
          year: thisYear,
          month: thisMonth,
          day: thisDay,
        });
        subStepReminder("time-selection-container");
      }

      newCartDate.innerHTML = formatedDate;
      newCartDateTime.removeAttribute("hidden");
      newCartTime.innerHTML = "";

      // if (!currentLang || currentLang === "fr") {
      //   /** feed cart date */
      //   newCartDate.innerHTML = `${zeroLeading(thisDay)}/${zeroLeading(
      //     thisMonth
      //   )}/${thisYear} `;
      //   newCartDateTime.removeAttribute("hidden");
      //   /** feed cart mobile reminder */
      //   if (
      //     document?.querySelector(".c-value")?.querySelector(".c-date-value")
      //   ) {
      //     document
      //       .querySelector(".c-value")
      //       .querySelector(".c-date-value").innerHTML = `${zeroLeading(
      //       thisDay
      //     )}/${zeroLeading(thisMonth)}/${thisYear} `;
      //   }
      // } else {
      //   /** feed cart date */
      //   newCartDate.innerHTML = `${thisYear}/${zeroLeading(
      //     thisMonth
      //   )}/${zeroLeading(thisDay)} `;
      //   newCartDateTime.removeAttribute("hidden");
      //   /** feed cart mobile reminder */
      //   if (
      //     document.querySelector(".c-value")?.querySelector(".c-date-value")
      //   ) {
      //     document
      //       .querySelector(".c-value")
      //       .querySelector(
      //         ".c-date-value"
      //       ).innerHTML = `${thisYear}/${zeroLeading(thisMonth)}/${zeroLeading(
      //       thisDay
      //     )} `;
      //   }
      // }
    } else {
      newCartDate.innerHTML = "";
      newCartDateTime.setAttribute("hidden", "");
      newCartTime.innerHTML = "";
      document
        .querySelectorAll(".c-at")
        .forEach((x) => x.removeAttribute("style"));
      document.querySelector('[name="visit-time"]').value = "";
      hideNextSubstep("time-selection-container");
      // hideNextSubstep("ticket-selection-container");
      subStepReminder("date-selection-container");

      if (document.querySelector(".c-value")?.querySelector(".c-date-value")) {
        document
          .querySelector(".c-value")
          .querySelector(".c-date-value").innerHTML = "";
      }
      if (document.querySelector(".c-value")?.querySelector(".c-time-value")) {
        document
          .querySelector(".c-value")
          .querySelector(".c-at")
          .setAttribute("style", "display: none");
        document
          .querySelector(".c-value")
          .querySelector(".c-time-value").innerHTML = "";
      }
    }
  };
}

//= require ./b--disclosureCart.js
//= require ../globals/callAjax.js
function zeroLeading(number) {
  if (number < 10 && number[0] !== "0") {
    const string = `0${number.toString()}`;
    return string;
  }
  return number;
}

const pvtDflt = (event) => {
  event.preventDefault();
};

const showNextSubstep = (arg) => {
  document.querySelector(`.${arg.domElement}`).classList.add("visible");
};

//=require ../globals/gsap-register.js
gsap.registerPlugin(ScrollToPlugin);

const showNextSubstepAnim = (arg) => {
  document.querySelector(`.${arg.domElement}`).classList.add("visible");

  const { offsetTop } = document.querySelector(`.${arg.domElement}`);

  let beforeHeight = 0;
  if (document.querySelector(".billetterie-hero")) {
    beforeHeight = document.querySelector(".billetterie-hero").offsetHeight;
  }

  let totalOffset = offsetTop + beforeHeight;

  if (arg?.stickyElement) {
    const stickyElementHeight = document.querySelector(
      `.${arg.stickyElement}`
    ).offsetHeight;

    totalOffset = offsetTop + beforeHeight - stickyElementHeight;
  }
  gsap.to(window, {
    duration: 0.75,
    scrollTo: totalOffset,
    ease: "power1.out",
    onComplete: () => {
      if (
        document
          .querySelector(`.${arg.domElement}`)
          .querySelector(".form-errors")
      ) {
        document
          .querySelector(`.${arg.domElement}`)
          .querySelector(".form-errors")
          ?.querySelector(".message")
          ?.focus();
      }
      // else {
      //   document
      //     .querySelector(`.${arg.domElement}`)
      //     ?.querySelector(".step-title")
      //     ?.focus();
      // }

      // if (arg.callback) {
      //   arg.callback(arg.domElement);
      // }
    },
  });
};

//= require ./b--u-updateCartTotalPrice.js
//= require ./b--getCalendar.js

const initCalendar = () => {
  const now = new Date();
  let date;
  let currentMonth;
  let currentYear;

  /** modification mode */
  // let modificationData;
  // if (window.b2cStep1Modification && window.b2cStep1Modification?.length) {
  //   modificationData = window.b2cStep1Modification.filter(
  //     (section) => section.name === "visite-date"
  //   );
  // } else if (
  //   window.b2bStep1Modification &&
  //   window.b2bStep1Modification?.length
  // ) {
  //   modificationData = window.b2bStep1Modification.filter(
  //     (section) => section.name === "visite-date"
  //   );
  // }
  // if (modificationData) {
  //   const windowStep1Values = modificationData;
  //   const windowVisitDate = windowStep1Values.find(
  //     (x) => x.name === "visite-date"
  //   );
  //   if (windowVisitDate?.value && !windowVisitDate.error) {
  //     if (window.b2cStep1Modification && window.b2cStep1Modification?.length) {
  //       document
  //         .getElementById("customer-journey-step-date-time")
  //         .classList.add("cart-modification-mode");
  //     }
  //     if (window.b2bStep1Modification && window.b2bStep1Modification?.length) {
  //       document
  //         .getElementById("b2b-journey-form-step-1")
  //         .classList.add("cart-modification-mode");
  //     }

  //     date = new Date(windowVisitDate.value);
  //     currentMonth = date.getMonth() + 1;
  //     currentYear = date.getFullYear();
  //     showNextSubstepAnim({
  //       stickyElement: "stepper-container",
  //       domElement: "date-selection-container",
  //     });
  //     showNextSubstep({
  //       stickyElement: "stepper-container",
  //       domElement: "time-selection-container",
  //     });
  //     /** feed hidden input */
  //     document.querySelector('[name="visite-date"]').value =
  //       windowVisitDate.value;
  //     /** clear reminder */
  //     document
  //       .querySelector(".mobile-intra-step")
  //       .querySelector(".c-date-value").innerHTML = "";
  //     document
  //       .querySelector(".mobile-intra-step")
  //       .querySelector(".c-at")
  //       .setAttribute("style", "display: none");
  //     document
  //       .querySelector(".mobile-intra-step")
  //       .querySelector(".c-time-value").innerHTML = "";
  //     /** feed cart */
  //     const thisDay = date.getDate();
  //     const thisMonth = date.getMonth() + 1;
  //     const thisYear = date.getFullYear();
  //     const newCartDate = document
  //       .querySelector(".cart-item-date-time")
  //       .querySelector(".cart-item-date");
  //     const currentLang = document.querySelector("html").getAttribute("lang");

  //     if (!currentLang || currentLang === "fr") {
  //       /** feed cart date */
  //       newCartDate.innerHTML = `${zeroLeading(thisDay)}/${zeroLeading(
  //         thisMonth
  //       )}/${thisYear} `;
  //       /** feed cart mobile reminder */
  //       if (
  //         document.querySelector(".c-value")?.querySelector(".c-date-value")
  //       ) {
  //         document
  //           .querySelector(".c-value")
  //           .querySelector(".c-date-value").innerHTML = `${zeroLeading(
  //           thisDay
  //         )}-${zeroLeading(thisMonth)}-${thisYear} `;
  //       }
  //     } else {
  //       /** feed cart date */
  //       newCartDate.innerHTML = `${thisYear}-${zeroLeading(
  //         thisMonth
  //       )}-${zeroLeading(thisDay)} `;
  //       /** feed cart mobile reminder */
  //       if (
  //         document.querySelector(".c-value")?.querySelector(".c-date-value")
  //       ) {
  //         document
  //           .querySelector(".c-value")
  //           .querySelector(
  //             ".c-date-value"
  //           ).innerHTML = `${thisYear}-${zeroLeading(thisMonth)}-${zeroLeading(
  //           thisDay
  //         )} `;
  //       }
  //     }
  //     /** add loading state to time selection */
  //     document.querySelector(".time-selection").classList.add("ajaxloading");
  //   } else {
  //     currentMonth = now.getMonth() + 1;
  //     currentYear = now.getFullYear();
  //   }

  //   if (windowVisitDate?.error) {
  //     const newErrorContainer = document.createElement("div");
  //     newErrorContainer.classList.add("form-errors");
  //     // newErrorContainer.setAttribute("tabindex", "0");
  //     const newMessageIntro = document.createElement("div");
  //     const errorIntro = document.createElement("p");
  //     errorIntro.classList.add("message");
  //     errorIntro.innerHTML = window?.errorAlertTraduction.intro;
  //     errorIntro.setAttribute("role", "alert");
  //     newMessageIntro.appendChild(errorIntro);
  //     newErrorContainer.appendChild(newMessageIntro);
  //     const newErrorlist = document.createElement("ul");
  //     newErrorlist.classList.add("errors-list");
  //     const errorItem = document.createElement("li");
  //     errorItem.innerHTML = windowVisitDate.error;
  //     newErrorlist.appendChild(errorItem);
  //     newErrorContainer.appendChild(newErrorlist);
  //     document
  //       .querySelector(".date-selection-container")
  //       .querySelector(".error-msg-container")
  //       .appendChild(newErrorContainer);

  //     showNextSubstepAnim({
  //       stickyElement: "stepper-container",
  //       domElement: "date-selection-container",
  //     });
  //     // showNextSubstep({
  //     //   stickyElement: "stepper-container",
  //     //   domElement: "time-selection-container",
  //     // });
  //   }
  // }

  const disabledDate = [];
  const highlightedDate = [];
  const validityPeriod = 365;
  const legendContainer = document.querySelector("#datepickk-legend");
  const validityPeriodEndDate = new Date(
    new Date().getTime() + validityPeriod * 24 * 60 * 60 * 1000
  );
  const originForm = document
    .querySelector('[name="visite-date"]')
    .closest("form");

  document.querySelector("#calendarContainer").classList.add("ajaxloading");
  originForm.addEventListener("submit", pvtDflt);

  const initDate = new Date();
  currentMonth = initDate.getMonth() + 1;
  currentYear = initDate.getFullYear();

  callAjax(
    "GET",
    `${
      window.location.origin
    }/fr/get-calendar-by-month?year=${currentYear}&month=${zeroLeading(
      currentMonth
    )}`,

    (data) => {
      const json = JSON.parse(data);
      // show back next & prev btn on success
      document
        .querySelector("#calendarContainer")
        .classList.remove("ajaxloading");

      if (
        json instanceof Object &&
        (json?.Disabled.length > 0 || json?.Available.length > 0)
      ) {
        if (json.Disabled) {
          for (let i = 0; i < json.Disabled.length; i += 1) {
            const disabledItem = json.Disabled[i].split(",");
            disabledDate.push(
              new Date(
                parseInt(disabledItem[0], 10),
                parseInt(disabledItem[1] - 1, 10),
                parseInt(disabledItem[2], 10),
                10,
                0o0,
                0
              )
            );
          }
        }
        if (json.Highlight) {
          // eslint-disable-next-line vars-on-top, no-var
          for (let i = 0; i < json.Highlight.length; i += 1) {
            const highlightItem = json.Highlight[i].split(",");
            highlightedDate.push({
              start: new Date(
                parseInt(highlightItem[0], 10),
                parseInt(highlightItem[1] - 1, 10),
                parseInt(highlightItem[2], 10),
                10,
                0o0,
                0
              ),
              end: new Date(
                parseInt(highlightItem[0], 10),
                parseInt(highlightItem[1] - 1, 10),
                parseInt(highlightItem[2], 10),
                10,
                0o0,
                0
              ),
            });
          }
        }

        const currentLang = document.querySelector("html").getAttribute("lang");
        const legend = window.datePickkLanguages?.[currentLang]?.lastPlaces
          ?.length
          ? window.datePickkLanguages[currentLang].lastPlaces
          : window.datePickkLanguages.fr.lastPlaces;

        getCalendar(
          now,
          disabledDate,
          highlightedDate,
          legend,
          validityPeriodEndDate,
          legendContainer,
          date
        );
      } else {
        document
          .querySelector("#calendarContainer")
          .classList.remove("ajaxloading");
        document.getElementById("calendarContainer").style.minHeight = "auto";
        document
          .getElementById("calendarContainer")
          .querySelector(".alert-message").style.display = "flex";
        document
          .getElementById("calendarContainer")
          .querySelector(".alert-message")
          .setAttribute("aria-hidden", "false");
        showNextSubstepAnim({
          stickyElement: "main-header",
          domElement: "alert-message",
        });
        setTimeout(() => {
          document
            .querySelector(".alert-message")
            .setAttribute("role", "alert");
        }, 750);
      }
    }
  );

  updateCartTotalPrice();

  // /* reset tickets */
  // if (
  //   (!window.b2cStep1Modification ||
  //     window.b2cStep1Modification?.length === 0) &&
  //   document.querySelector(".ticket-selection-container")
  // ) {
  //   originForm
  //     .querySelectorAll('[type="number"]')
  //     // eslint-disable-next-line no-return-assign, no-param-reassign
  //     .forEach((x) => (x.value = 0));
  //   originForm
  //     .querySelectorAll(".price-value")
  //     // eslint-disable-next-line no-return-assign, no-param-reassign
  //     .forEach((x) => (x.innerHTML = 0));
  // }
};

//= require ./b--initTicketUpdate.js
//= require ./b--cartFromBackendHandling.js
//= require ./b--u-displayDialog.js
//= require ./b--crosscellModalCallback.js

function openProduct(product) {
  displayDialog(`#dialog_${product}`, `#btn-${product}`, isAbleDialogValidate);
}

const initCrossSellModal = () => {
  const container = document.querySelector(".cross-sell-event-container");
  if (container.querySelectorAll("button.reservation")) {
    for (
      let index = 0;
      index < container.querySelectorAll("button.reservation").length;
      index += 1
    ) {
      const element = container.querySelectorAll("button.reservation")[index];
      const { product } = element.dataset;
      element
        .closest(".event-option")
        .addEventListener("click", () => openProduct(product));

      const elDialog = document.querySelector(`#dialog_${product}`);
      crosscellModalCallback(elDialog);
    }
  }

  /** open modal from url */
  let params = new URLSearchParams(document.location.search);
  let productFromUrl = params.get("product");
  if (productFromUrl) {
    document.getElementById(`btn-${productFromUrl}`).click();
  }
};

const microDon = () => {
  const mdList = document.querySelectorAll(".md-checkbox-group-container");
  mdList.forEach((md) => {
    const mdInputList = md.querySelectorAll('input[type="checkbox"]');
    let checkedInput = Array.from(mdInputList).find((ci) => ci.checked);
    md.querySelectorAll('input[type="checkbox"]').forEach((mdInput) => {
      mdInput.addEventListener("change", () => {
        if (checkedInput && checkedInput !== mdInput) {
          checkedInput.click();
        }
        checkedInput = Array.from(mdInputList).find((ci) => ci.checked);

        document
          .querySelector(".recap-container")
          .querySelector(".cart-wrapper")
          .classList.add("ajaxloading");
        document.getElementById("submit_don").click();

        /** feed card */
        // let totalPriceValue;
        // const totalPriceArray = [];
        // const totalPriceInitialValue = document
        //   .querySelector(".recap-total-price-value")
        //   .getAttribute("data-recappricevalue");
        // totalPriceArray.push(parseFloat(totalPriceInitialValue));

        // if (checkedInput) {
        //   const mdLabel = checkedInput
        //     .closest("label")
        //     .getAttribute("data-label");

        //   const template = `<p class="cart-recap-item-price">${mdLabel} <span><span>${checkedInput.value}</span>€</span></p>`;

        //   if (document?.getElementById("micro-don-item")) {
        //     document.getElementById("micro-don-item").innerHTML = template;
        //   } else {
        //     const newItem = document.createElement("div");
        //     newItem.classList.add("cart-recap-item");
        //     newItem.setAttribute("id", "micro-don-item");

        //     newItem.innerHTML = template;
        //     document.querySelector(".calculations").appendChild(newItem);

        //     /** KEEPING REMOVE BUTTON LOGIC IN CASE NEEDED */
        //     // const removeDonBtn = document.createElement("button");
        //     // const removeDonBtnTitle = document
        //     //   .querySelectorAll(".remove-item-btn-ctr")[0]
        //     //   .querySelector(".btn--icon")
        //     //   .getAttribute("title");
        //     // const removeDonBtnIcon = document
        //     //   .querySelectorAll(".remove-item-btn-ctr")[0]
        //     //   .querySelector(".btn--icon img")
        //     //   .cloneNode();
        //     // removeDonBtn.setAttribute("title", removeDonBtnTitle);
        //     // removeDonBtn.appendChild(removeDonBtnIcon);

        //     // newItem
        //     //   .querySelectorAll(".flex-space-between-start")[0]
        //     //   .appendChild(removeDonBtn);

        //     // removeDonBtn.addEventListener("click", () => {
        //     //   // remove the don item
        //     //   document.getElementById("micro-don-item").remove();
        //     //   // eslint-disable-next-line prefer-destructuring
        //     //   totalPriceValue = totalPriceArray[0];
        //     //   document.querySelector(".recap-total-price-value").innerHTML =
        //     //     totalPriceValue;
        //     //   checkedInput = Array.from(mdInputList).find((ci) => ci.checked);
        //     //   checkedInput.click();
        //     // });
        //   }
        //   totalPriceArray.push(parseInt(checkedInput.value, 10));
        //   if (totalPriceArray?.length) {
        //     totalPriceValue = totalPriceArray.reduce(
        //       (accumulator, currentValue) =>
        //         parseFloat(accumulator) + parseFloat(currentValue)
        //     );
        //   }
        // } else {
        //   if (document?.getElementById("micro-don-item")) {
        //     document.getElementById("micro-don-item").remove();
        //   }
        //   // eslint-disable-next-line prefer-destructuring
        //   totalPriceValue = totalPriceArray[0];
        // }
        // document.querySelector(".recap-total-price-value").innerHTML =
        //   parseFloat(totalPriceValue).toFixed(2);
      });
    });
  });
};


function reecapLoader() {
  document
    .querySelector(".recap-container")
    .querySelector(".cart-wrapper")
    .classList.add("ajaxloading");
}

const initRecap = () => {
  microDon();

  document
    .querySelectorAll('[type="submit"]')
    .forEach((x) => x.addEventListener("click", reecapLoader));
};

//= require ./b--communicationCtr.js
//= require ../globals/callAjax.js
const getCookie = (cname) => {
  const name = `${cname}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

//= require ./b--communicationCtr.js

let cartTimerInterval;

function setCookie(cname, exdays) {
  let initialValue;
  if (getCookie(cname).split("-")[1]?.length === 10) {
    initialValue = parseInt(getCookie(cname).split("-")[1], 10) * 1000;
  } else {
    initialValue = parseInt(getCookie(cname).split("-")[1], 10);
  }

  const d = new Date(initialValue);
  d.setTime(d.getTime() + exdays * 60 * 1000);
  const timerNewValue = `2-${d.getTime()}`;

  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${timerNewValue};${expires};path=/`;

  const newValue = timerNewValue.split("-")[1];
  const newDelay = (newValue - initialValue) / 1000 / 60;
  const matches = window.timerElements.description.match(/(\d+)/);
  const newDescription = window.timerElements.description.replace(
    matches[0],
    parseInt(newDelay, 10)
  );

  if (document?.querySelector("#timer-message")) {
    document
      .querySelector("#timer-message")
      .querySelector(".message").innerHTML = newDescription;
  }
}

function countdown(expireTime, indice) {
  const date = new Date();
  const newTimestamp = date.getTime();

  const minimumDelay = window.timerElements.minDelay * 60 * 1000;

  if (newTimestamp >= expireTime - minimumDelay) {
    if (!document.querySelector("#timer-message")) {
      let template;
      const timerAlready = localStorage.getItem("timerAlready");

      if (indice === "1") {
        template =
          '<div id="timer-message" class="alert-message warning" aria-live="alert">' +
          '<div class="icon-wrapper">' +
          `<img src="${window?.timerElements?.infoIconUrl}" alt="" />` +
          "</div>" +
          "<div>" +
          '<p class="message" role="status">' +
          `${window?.timerElements?.description}` +
          "</p>" +
          '<button type="button" class="btn-secondary btn-secondary--light-bg btn-secondary--no-icon btn-secondary--small" id="timerBtn">' +
          `<span>${window?.timerElements?.addTime}</span>` +
          // `<span class="link-icon-wrapper"><img src="${window?.timerElements?.linkIconUrl}" alt="" /></span>` +
          "</button>" +
          "</div>" +
          "</div>";
        if (!timerAlready) {
          const newMessage = document.createElement("div");
          newMessage.classList.add("timer-message-wrapper");
          newMessage.innerHTML = template;

          if (document.querySelector(".communication-container")) {
            document
              .querySelector(".communication-container")
              .appendChild(newMessage);
          }

          localStorage.setItem("timerAlready", "1");
        }
      }
      if (indice === "2") {
        template =
          '<div id="timer-message" class="alert-message info" aria-live="alert">' +
          '<div class="icon-wrapper">' +
          `<img src="${window?.timerElements?.infoIconUrl}" alt="" />` +
          "</div>" +
          "<div>" +
          '<p class="message" role="status">' +
          `${window?.timerElements?.description2}` +
          "</p>" +
          "</div>" +
          "</div>";

        if (timerAlready) {
          if (timerAlready === "1") {
            const newMessage = document.createElement("div");
            newMessage.classList.add("timer-message-wrapper");
            newMessage.innerHTML = template;

            if (document.querySelector(".communication-container")) {
              document
                .querySelector(".communication-container")
                .appendChild(newMessage);
            }

            localStorage.setItem("timerAlready", "2");
          }
          if (timerAlready === "2") {
            localStorage.setItem("timerAlready", "3");
          }
          if (timerAlready === "3") {
            const newMessage = document.createElement("div");
            newMessage.classList.add("timer-message-wrapper");
            newMessage.innerHTML = template;

            if (document.querySelector(".communication-container")) {
              document
                .querySelector(".communication-container")
                .appendChild(newMessage);
            }

            localStorage.setItem("timerAlready", "4");
          }
        }
      }

      if (document.querySelector(".communication-container")) {
        communicationCtr();
      }

      if (document?.querySelector("#timerBtn")) {
        document.querySelector("#timerBtn").addEventListener("click", () => {
          clearInterval(cartTimerInterval);
          // release our intervalID from the variable
          cartTimerInterval = null;
          setCookie("vvt_timer", window.timerElements.timeToAdd);
          // eslint-disable-next-line no-use-before-define
          initTimer();
        });
      }
    }
  }

  if (newTimestamp >= expireTime) {
    // eslint-disable-next-line no-console
    // console.log("panier expiré");
    document.cookie =
      "vvt_timer=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    clearInterval(cartTimerInterval);
    cartTimerInterval = null;

    /** clear localstrorage */
    localStorage.removeItem("timerAlready");
    /** post deletion to backend */
    callAjax("POST", "/cancel_cart", () => {
      window.location.reload();
      window.location.href = window.timerElements.homeUrl;
    });
  }
}

const initTimer = () => {
  const timerCookie = getCookie("vvt_timer");

  if (timerCookie) {
    const cookieSplit = timerCookie.split("-");
    let expireTime;
    if (cookieSplit[1]?.length === 10) {
      expireTime = parseInt(cookieSplit[1], 10) * 1000;
    } else {
      expireTime = parseInt(cookieSplit[1], 10);
    }

    if (cookieSplit[0] === "2") {
      const cookieValue = parseInt(cookieSplit[1], 10);
      const now = new Date();

      const newDelay = (cookieValue - now.getTime()) / 1000 / 60;
      const matches = window.timerElements.description2.match(/(\d+)/);

      const newDescription = window.timerElements.description2.replace(
        matches[0],
        parseInt(newDelay, 10)
      );
      document
        .getElementById("timer-message")
        .classList.replace("warning", "info");
      if (document?.querySelector("#timerBtn")) {
        document.querySelector("#timerBtn").remove();
      }
      if (document?.querySelector("#timer-message")) {
        document
          .querySelector("#timer-message")
          .querySelector(".message").innerHTML = newDescription;
      }
    }

    if (window.timerElements?.minDelay) {
      cartTimerInterval = setInterval(
        countdown,
        1000,
        expireTime,
        cookieSplit[0]
      );
    }
  }
};

//= require ./b--displayLiveMessage.js

const initLiveMessage = () => {
  if (document.querySelectorAll(".live-message")?.length) {
    setTimeout(() => {
      document.querySelectorAll(".live-message").forEach((msg) => {
        displayLiveMessage(`#${msg.getAttribute("id")}`);
      });
    }, 500);
  }
};

//= require ./b--confirm.js
function initSubscriptionForm() {
  function toggleFillCheck(container, originForm, isChecked) {
    const sourceFields = originForm.querySelectorAll('[data-status="source"]');
    const targetFields = container.querySelectorAll('[data-status="target"]');
    const targetFieldsArray = Array.from(targetFields);

    sourceFields.forEach((element) => {
      const fieldType = element.getAttribute("type");
      const dataType = element.getAttribute("data-type");
      const targetField = targetFieldsArray.find(
        (x) => x.getAttribute("data-type") === dataType
      );
      if (fieldType === "radio" && isChecked === "true" && element.checked) {
        const elLabel = container.querySelector(
          `[for="${targetField.getAttribute("id")}"]`
        );
        elLabel.click();
      } else if (fieldType === "radio" && isChecked === "false") {
        const radioContainer = targetField.closest(".radio-container");
        const chbx = radioContainer.querySelectorAll("input[type=radio]");
        for (let i = 0; i < chbx.length; i++) {
          chbx[i].checked = false;
        }
      } else if (
        element.tagName === "SELECT" &&
        element.value &&
        isChecked === "true"
      ) {
        targetField.value = element.value;
      } else if (
        element.tagName === "SELECT" &&
        element.value &&
        isChecked === "false"
      ) {
        targetField.value = "";
      } else if (
        targetField &&
        (fieldType === "text" ||
          fieldType === "email" ||
          fieldType === "tel") &&
        element.value &&
        isChecked === "true"
      ) {
        targetField.value = element.value;
      } else if (
        targetField &&
        (fieldType === "text" ||
          fieldType === "email" ||
          fieldType === "tel") &&
        element.value &&
        isChecked === "false"
      ) {
        targetField.value = "";
      }
    });
  }

  const toggleFillButtons = document.querySelectorAll(".toggle-fill");
  toggleFillButtons.forEach((toggleFill) => {
    const container = toggleFill.closest(".form-section-container");
    const originForm = toggleFill.closest("form");

    toggleFill.addEventListener("click", () => {
      if (toggleFill.classList.contains("checked")) {
        toggleFill.classList.remove("checked");
        toggleFillCheck(container, originForm, "false");
      } else {
        toggleFill.classList.add("checked");
        toggleFillCheck(container, originForm, "true");
      }
    });
  });
}


(function ($) {
  window.addEventListener("load", () => {
    const windowWidth = window.innerWidth;

    /** focus on alert messages */
    if (
      document.querySelector(".alert-message.alert") &&
      document.querySelector(".alert-message.alert").getAttribute("style") !==
        "display: none;"
    ) {
      showNextSubstepAnim({
        stickyElement: "main-header",
        domElement: "alert-message.alert",
      });
      setTimeout(() => {
        document
          .querySelector(".alert-message.alert")
          .setAttribute("role", "alert");
      }, 750);
    }

    /** initialize calendar */
    if (document.querySelector("#calendarContainer")) {
      initCalendar();
      if (
        document.getElementById("cart-content--total") &&
        parseInt(
          document
            .getElementById("cart-content--total")
            .getAttribute("data-totalcart")
        ) === 0 &&
        !window.cartFromBackend
      ) {
        document.getElementById("cart-content--total").style.display = "none";
        document
          .querySelector(".mobile-intra-step")
          .classList.add("desktop-hidden");
      }
    }

    if (document.querySelector(".basic-options-group-compo-container")) {
      showNextSubstepAnim({
        stickyElement: "main-header",
        domElement: "basic-options-group-compo-container",
      });
    }

    /** cart from backend handling */
    if (
      window.cartFromBackend &&
      document.querySelector(".billetterie-tunnel-with-cart")
    ) {
      cartFromBackendHandling();
    }

    /** initialize cart disclosure */
    if (windowWidth < 741) {
      const buttons = document.querySelectorAll(
        ".disclosure-cart-btn[aria-expanded][aria-controls]"
      );
      for (let i = 0; i < buttons.length; i += 1) {
        (() => new DisclosureButtonCart(buttons[i]))();
      }
    }

    /** cart item date */
    if (document.querySelector(".cart-item-date")) {
      if (document.querySelector(".cart-item-date").innerHTML == "") {
        document
          .querySelector(".cart-item-date")
          .parentNode.setAttribute("hidden", "");
      } else {
        document
          .querySelector(".cart-item-date")
          .parentNode.removeAttribute("hidden");
      }
    }

    /** nav toggle class */
    if (document.querySelector(".billetterie-nav")) {
      document
        .querySelector(".billetterie-nav")
        .querySelectorAll("li:not(.isDisabled)")
        .forEach((x) =>
          x.addEventListener("click", (e) => {
            if (x.classList.contains("isDisabled")) {
              e.preventDefault;
            } else {
              document
                .querySelector(".billetterie-nav li.active")
                .classList.remove("active");
              x.classList.toggle("active");
            }
          })
        );
    }

    /** init ticket update */
    if (document.querySelector("#customer-journey-step-billets")) {
      const container = document.querySelector(
        "#customer-journey-step-billets"
      );

      if (container.querySelectorAll(".ticket-detail-container")?.length) {
        initTicketUpdate();
      }
    }


    if (document.querySelector(".subscription-form")) {
      initSubscriptionForm();
    }

    // if (document.querySelector("#customer-journey-step-options")) {
    //   const container = document.querySelector(
    //     "#customer-journey-step-options"
    //   );

    //   if (container.querySelectorAll(".ticket-detail-container")?.length) {
    //     initTicketUpdate();
    //   }
    // }

    // if (document.querySelector("#customer-journey-step-extras")) {
    //   const container = document.querySelector("#customer-journey-step-extras");

    //   if (container.querySelectorAll(".ticket-detail-container")?.length) {
    //     initTicketUpdate();
    //   }
    // }

    /** initialize  cross-sell modal */
    if (document.querySelector(".cross-sell-event-container")) {
      initCrossSellModal();
    }

    /** initialise options */
    if (document.querySelector("#customer-journey-step-options")) {
      const container = document.querySelector(
        "#customer-journey-step-options"
      );

      if (container.querySelectorAll(".ticket-detail-container")?.length) {
        initTicketUpdate();
      }
    }

    /** initialise subscriptions */
    if (document.querySelector("#customer-journey-step-subscriptions")) {
      const container = document.querySelector(
        "#customer-journey-step-subscriptions"
      );

      if (container.querySelectorAll(".ticket-detail-container")?.length) {
        initTicketUpdate();
      }
    }

    /** initialize  recap */
    if (document.querySelector("#customer-journey-step-recap")) {
      initRecap();
    }

    /** if tunnel's .communication-container empty hide it */
    // if (document?.querySelector(".communication-container")) {
    //   // communicationCtr();
    // }

    /** initialize timer */
    if (window.timerElements) {
      initTimer();
    }

    /** live messages display if any */
    initLiveMessage();

    /** init confirmation popin */
    if (document.querySelector(".confirmation")) {
      confirm();
    }

    /** clear localStorage check_adult */
    if (localStorage.getItem("check_adult")) {
      localStorage.removeItem("check_adult");
    }
  });

  window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    /** Initialize Hide/Show Buttons */
    if (windowWidth < 741) {
      const disclosureCartButtons = document.querySelectorAll(
        ".disclosure-cart-btn[aria-expanded][aria-controls]"
      );
      for (let i = 0; i < disclosureCartButtons.length; i += 1) {
        (() => new DisclosureButtonCart(disclosureCartButtons[i]))();
      }
    } else if (document.getElementById("cart-expandable-content")) {
      document
        .getElementById("cart-expandable-content")
        .removeAttribute("style");
    }
  });
})();

//= require ../globals/callAjax.js
//= require ../globals/pvtDflt.js
//= require ../globals/zeroLeading.js
//= require ../globals/pvtDflt.js
const hideNextSubstep = (domElement) => {
  document.querySelector(`.${domElement}`).classList.remove("visible");
};

//= require ./b--u-showNextSubstep.js
//= require ./b--u-showNextSubstepAnim.js
const subStepReminder = (domElement) => {
  const element = document.querySelector(`.${domElement}`);
  const reminder = element.querySelector(".step-title").textContent;
  document.querySelector(".reminder").innerHTML = reminder;
};

//= require ./b--u-ticketFormValidate.js

function updateMax(max) {
  const ticketContainers = document
    .querySelector(".ticket-selection-container")
    .querySelectorAll(".form-section-content");
  for (let i = 0; i < ticketContainers.length; i += 1) {
    const ticketContainer = ticketContainers[i];
    const ticketNumberInput =
      ticketContainer.querySelector("input[type=number]");
    if (ticketNumberInput) {
      ticketNumberInput.setAttribute("max", max);
      ticketNumberInput.setAttribute("data-max", max);
    }
  }
}

const timeSelection = (json) => {
  let windowVisitDate;
  let windowVisitTime;
  if (window.b2cStep1Modification) {
    const windowStep1Values = window.b2cStep1Modification;
    windowVisitDate = windowStep1Values.find((x) => x.name === "visite-date");
    windowVisitTime = windowStep1Values.find((x) => x.name === "visit-time");
  }
  if (window.b2bStep1Modification) {
    const windowStep1Values = window.b2bStep1Modification;
    windowVisitDate = windowStep1Values.find((x) => x.name === "visite-date");
    windowVisitTime = windowStep1Values.find((x) => x.name === "visit-time");
  }
  const timeSelectionList = document.querySelectorAll(".time-selection");
  if (timeSelectionList?.length) {
    timeSelectionList.forEach((timeSelectionBloc) => {
      const tsInputList = timeSelectionBloc.querySelectorAll(
        'input[type="checkbox"]'
      );

      // modification
      if (windowVisitDate?.value && windowVisitTime?.value) {
        if (!windowVisitDate?.error && !windowVisitTime?.error) {
          /** feed hidden input */
          document.querySelector('[name="visit-time"]').value =
            windowVisitTime.value;

          /** click on preselected time input */
          if (tsInputList?.length) {
            const preSelectedInput = Array.from(tsInputList).find(
              (ci) => ci.value === windowVisitTime.value
            );
            if (preSelectedInput) {
              preSelectedInput.click();

              /** if availablilty is in time input, set the input number max to this value */
              const maxValue = preSelectedInput.getAttribute("data-input-max");
              if (maxValue) {
                updateMax(maxValue);
              }
            }
          }
          /** select the right time tab */
          if (timeSelectionBloc.classList.contains("tab-mode")) {
            const result = json.find((item) =>
              item.data.find((item2) => item2.label === windowVisitTime.value)
            );
            const tabs = document.querySelectorAll(".tab-button");
            tabs.forEach((tab) => {
              if (tab.getAttribute("data-name") === result.label) {
                showNextSubstep({
                  stickyElement: "stepper-container",
                  domElement: "time-selection-container",
                });
                tab.click();
              }
            });
          }
          if (
            document?.querySelector(
              '[data-tunnel-type="tunnel_date_heure_billet"]'
            ) ||
            document?.querySelector(
              '[data-tunnel-type="tunnel_date_billet"]'
            ) ||
            document?.querySelector(
              '[data-tunnel-type="tunnel_date_heure_dispo"]'
            )
          ) {
            /** show next step */
            showNextSubstepAnim({
              stickyElement: "stepper-container",
              domElement: "ticket-selection-container",
            });
          }

          /** control fields to enable/disable submit */
          const originForm = timeSelectionBloc.closest("form");
          ticketFormValidate(originForm);
          /** feed cart */
          if (
            document?.querySelector(
              '[data-tunnel-type="tunnel_date_heure_billet"]'
            ) ||
            document?.querySelector(
              '[data-tunnel-type="tunnel_date_billet"]'
            ) ||
            document?.querySelector(
              '[data-tunnel-type="tunnel_date_heure_dispo"]'
            )
          ) {
            subStepReminder("ticket-selection-container");
          }

          if (
            !document?.querySelector('[data-tunnel-type="tunnel_date_billet"]')
          ) {
            const atEl = document
              .querySelector(".c-value")
              .querySelector(".c-at");
            atEl.setAttribute("style", "display: inline");
            // const newAtEl = atEl.cloneNode(true);

            if (document?.querySelector(".cart-item-date-time")) {
              document
                .querySelector(".cart-item-date-time")
                .querySelector(
                  ".cart-item-time"
                ).innerHTML = ` ${windowVisitTime.value.replace(":", "h")}`;
              document
                .querySelector(".cart-item-at")
                .setAttribute("style", "display: inline");
            }
            /** feed cart mobile reminder */
            if (
              document.querySelector(".c-value")?.querySelector(".c-time-value")
            ) {
              document
                .querySelector(".c-value")
                .querySelector(
                  ".c-time-value"
                ).innerHTML = ` ${windowVisitTime.value.replace(":", "h")}`;
            }
          }
          /** enable form submit */
          const elForm = timeSelectionBloc.closest("form");
          elForm.removeEventListener("submit", pvtDflt);
        }
        if (
          windowVisitTime?.error &&
          !document
            .querySelector(".time-selection-container")
            .querySelector(".errors-list")
        ) {
          const newErrorContainer = document.createElement("div");
          newErrorContainer.classList.add("form-errors");
          const newMessageIntro = document.createElement("div");
          const errorIntro = document.createElement("p");
          errorIntro.classList.add("message");
          errorIntro.innerHTML = window.errorAlertTraduction.intro;
          errorIntro.setAttribute("role", "alert");
          newMessageIntro.appendChild(errorIntro);
          newErrorContainer.appendChild(newMessageIntro);
          const newErrorlist = document.createElement("ul");
          newErrorlist.classList.add("errors-list");
          const errorItem = document.createElement("li");
          errorItem.innerHTML = windowVisitTime.error;
          newErrorlist.appendChild(errorItem);
          newErrorContainer.appendChild(newErrorlist);
          document
            .querySelector(".time-selection-container")
            .querySelector(".error-msg-container")
            .appendChild(newErrorContainer);
          document
            .querySelector(".form-errors")
            ?.querySelector(".message")
            ?.setAttribute("role", "alert");
          document
            .querySelector(".form-errors")
            ?.querySelector(".message")
            ?.setAttribute("tabindex", "0");
          document
            .querySelector(".form-errors")
            ?.querySelector(".message")
            ?.focus();
        }
      }

      // global logic
      const elForm = timeSelectionBloc.closest("form");
      let checkedInput = Array.from(tsInputList).find((ci) => ci.checked);
      timeSelectionBloc
        .querySelectorAll('input[type="checkbox"]')
        .forEach((timeInput) => {
          timeInput.addEventListener("keypress", (e) => {
            if (e.keyCode === 13) {
              e.preventDefault();
            }
          });

          timeInput.addEventListener("change", () => {
            if (checkedInput && checkedInput !== timeInput) {
              checkedInput.click();
            }
            checkedInput = Array.from(tsInputList).find((ci) => ci.checked);
            if (checkedInput) {
              document.querySelector('[name="visit-time"]').value =
                checkedInput.value;

              /** if availablilty is in time input, set the input number max to this value */
              const maxValue = checkedInput.getAttribute("data-input-max");
              if (maxValue) {
                updateMax(maxValue);
              }

              // remove submit prevent default if time selected
              elForm.removeEventListener("submit", pvtDflt, false);

              /** ********* */
              /** feed card */
              /** ********* */
              if (
                document
                  .querySelector(".c-value")
                  ?.querySelector(".c-time-value")
              ) {
                document
                  .querySelector(".c-value")
                  .querySelector(".c-at")
                  .setAttribute("style", "display: inline");
                document
                  .querySelector(".cart-item-at")
                  .setAttribute("style", "display: inline");
                document
                  .querySelector(".c-value")
                  .querySelector(".c-time-value").innerHTML =
                  checkedInput.value;
              }

              if (
                !document?.querySelector(
                  '[data-tunnel-type="tunnel_date_billet"]'
                )
              ) {
                if (
                  document
                    .querySelector(".cart-item-date-time")
                    .querySelector(".cart-item-time")
                ) {
                  document.querySelector(".cart-item-date-time").querySelector(
                    ".cart-item-time"
                  ).innerHTML = ` ${checkedInput.value.replace(":", "h")}`;
                }

                if (
                  document?.querySelector(
                    '[data-tunnel-type="tunnel_date_heure_billet"]'
                  ) ||
                  document?.querySelector(
                    '[data-tunnel-type="tunnel_date_billet"]'
                  ) ||
                  document?.querySelector(
                    '[data-tunnel-type="tunnel_date_heure_dispo"]'
                  )
                ) {
                  showNextSubstepAnim({
                    stickyElement: "stepper-container",
                    domElement: "ticket-selection-container",
                  });
                  subStepReminder("ticket-selection-container");
                }

                if (
                  document?.querySelector(
                    '[data-tunnel-type="tunnel_date_heure"]'
                  )
                  //  ||
                  // document?.querySelector(
                  //   '[data-tunnel-type="tunnel_date_heure_dispo"]'
                  // )
                ) {
                  document
                    .querySelector(".reminder")
                    .setAttribute("style", "display: none");
                  elForm
                    .querySelector(".cart-submit-btn")
                    .removeAttribute("disabled");
                }
              }
            } else {
              if (
                document?.querySelector(
                  '[data-tunnel-type="tunnel_date_heure_billet"]'
                ) ||
                document?.querySelector(
                  '[data-tunnel-type="tunnel_date_billet"]'
                ) ||
                document?.querySelector(
                  '[data-tunnel-type="tunnel_date_heure_dispo"]'
                )
              ) {
                hideNextSubstep("ticket-selection-container");
              }
              subStepReminder("time-selection-container");

              document.querySelector('[name="visit-time"]').value = "";

              // add submit prevent default no time selected
              elForm.addEventListener("submit", pvtDflt, false);

              /** clear all tickets infos */
              document.querySelector(".cart-item-person").innerHTML = "";
              document
                .querySelector(".dynamic-front-cart")
                .querySelector(".cart-item-price")
                .querySelector("span").innerHTML = "";
              document
                .querySelector(".dynamic-front-cart")
                .querySelector(".cart-item-price")
                .setAttribute("hidden", "");
              document
                .querySelector(".dynamic-front-cart")
                .querySelector(".cart-item-price")
                .setAttribute("data-price", "0");
              document
                .querySelectorAll(".fieldset-wrapper")
                .forEach((f) => f.remove());
              document.querySelectorAll(".price-value").forEach((priceV) => {
                priceV.setAttribute("data-price", 0);
                // eslint-disable-next-line no-param-reassign
                priceV.innerHTML = "";
              });
              document.querySelectorAll(".input-wrapper").forEach((iw) => {
                // eslint-disable-next-line no-param-reassign
                iw.querySelector(".input--price").value = 0;
              });
              document.getElementById("cart-content--total").innerHTML = "";
              subStepReminder("time-selection-container");
              document.querySelector(".reminder").removeAttribute("hidden");

              /** ********* */
              /** feed card */
              /** ********* */
              if (
                document
                  .querySelector(".c-value")
                  ?.querySelector(".c-time-value")
              ) {
                document
                  .querySelector(".c-value")
                  .querySelector(".c-time-value").innerHTML = "";
              }

              if (
                document
                  .querySelector(".cart-item-date-time")
                  .querySelector(".cart-item-time")
              ) {
                document
                  .querySelector(".cart-item-date-time")
                  .querySelector(".cart-item-time").innerHTML = "";
              }
              document
                .querySelectorAll(".c-at")
                .forEach((cat) => cat.setAttribute("style", "display: none"));
              document
                .querySelector(".cart-item-at")
                .setAttribute("style", "display: none");

              if (
                document?.querySelector(
                  '[data-tunnel-type="tunnel_date_heure"]'
                )
                // ||
                // document?.querySelector(
                //   '[data-tunnel-type="tunnel_date_heure_dispo"]'
                // )
              ) {
                document.querySelector(".reminder").removeAttribute("style");
                elForm
                  .querySelector(".cart-submit-btn")
                  .setAttribute("disabled", "");
              }
            }

            /** clear tickets from modification data */
            if (window.b2cStep1Modification) {
              window.b2cStep1Modification = window.b2cStep1Modification.filter(
                (section) =>
                  section.name === "visite-date" ||
                  section.name === "visit-time"
              );
            }
            if (window.b2bStep1Modification) {
              window.b2bStep1Modification = window.b2bStep1Modification.filter(
                (section) =>
                  section.name === "visite-date" ||
                  section.name === "visit-time"
              );
            }
          });
        });
    });
  }
};

//= require ./b--createTimeTiles.js

const initTimeSelection = (args) => {
  const container = document.querySelector(".time-selection");
  const originForm = container.closest("form");

  // container?.querySelector(".checkbox-group-container")?.classList.add("ajaxloading");
  originForm.querySelector(".cart-submit-btn").setAttribute("disabled", "");
  originForm.addEventListener("submit", pvtDflt);

  /*
   * working with real data
   */
  callAjax(
    "GET",
    `${window.location.origin}/fr/get-hours-for-day?year=${
      args.year
    }&month=${zeroLeading(args.month)}&day=${zeroLeading(args.day)}`,
    (data) => {
      const json = JSON.parse(data);
      const conditionalContent = document
        .querySelector(".time-selection-container")
        .querySelector(".conditional-content:not(.last-tickets-available)");
      conditionalContent?.classList.remove("ajaxloading");
      if (json) {
        createTimeTiles(json, container);
        timeSelection(json);
      }
    }
  );
};

//= require ../globals/pvtDflt.js
//= require ./b--isAbleDialogValidate.js

const modalTimeSelection = (elDialog) => {
  const modalId = elDialog.getAttribute("data-productid");
  let jsonModalData = window.crossSellEvent.find((item) => item.id === modalId);
  const timeSelectionList = elDialog.querySelectorAll(".time-selection");
  if (timeSelectionList?.length) {
    timeSelectionList.forEach((timeSelectionBloc) => {
      const tsInputList = timeSelectionBloc.querySelectorAll(
        'input[type="checkbox"]'
      );
      // global logic
      const elForm = timeSelectionBloc.closest("form");
      let checkedInput = Array.from(tsInputList).find((ci) => ci.checked);
      timeSelectionBloc
        .querySelectorAll('input[type="checkbox"]')
        .forEach((timeInput) => {
          timeInput.addEventListener("keypress", (e) => {
            if (e.keyCode === 13) {
              e.preventDefault();
            }
          });

          timeInput.addEventListener("change", () => {
            if (checkedInput && checkedInput !== timeInput) {
              checkedInput.click();
            }
            checkedInput = Array.from(tsInputList).find((ci) => ci.checked);
            if (checkedInput) {
              document.querySelector(`[name="visit-time_${modalId}"]`).value =
                checkedInput.value;

              if (checkedInput.getAttribute("data-date")) {
                jsonModalData.date = checkedInput.getAttribute("data-date");
                jsonModalData.time = checkedInput.getAttribute("data-time");
              } else {
                jsonModalData.time = checkedInput.value;
              }

              /** rule "suppression-option-adulte" - keeping just in case */
              // const ruleId = window.ticketState?.find((x) => x?.ruleId)?.ruleId;
              // if (ruleId?.includes("suppression-option-adulte")) {
              //   // const adultNumberArray = [];
              //   // const childrenNumberArray = [];
              //   // window.ticketState?.forEach((item) => {
              //   //   if (
              //   //     item.productId === elDialog.getAttribute("data-productid")
              //   //   ) {
              //   //     if (item.isAdult === "true") {
              //   //       adultNumberArray.push(item.number);
              //   //     } else {
              //   //       childrenNumberArray.push(item.number);
              //   //     }
              //   //   }
              //   // });
              //   // const adultNumber = adultNumberArray?.length
              //   //   ? adultNumberArray.reduce(
              //   //       (accumulator, currentValue) => accumulator + currentValue
              //   //     )
              //   //   : 0;
              //   // const childrenNumber = childrenNumberArray?.length
              //   //   ? childrenNumberArray.reduce(
              //   //       (accumulator, currentValue) => accumulator + currentValue
              //   //     )
              //   //   : 0;

              //   // /** disable/enable validate btn */
              //   // if (jsonModalData?.tickets?.length && adultNumber > 0) {
              //   //   // elDialog
              //   //   //   .querySelector(".validate-option")
              //   //   //   .removeAttribute("disabled");
              //   //   isAbleDialogValidate(elDialog);
              //   // } else {
              //   //   elDialog
              //   //     .querySelector(".validate-option")
              //   //     .setAttribute("disabled", "");
              //   // }
              // } else {
              /** disable/enable validate btn */
              if (jsonModalData?.tickets?.length) {
                // elDialog
                //   .querySelector(".validate-option")
                //   .removeAttribute("disabled");
                isAbleDialogValidate(elDialog);
              } else {
                elDialog
                  .querySelector(".validate-option")
                  .setAttribute("disabled", "");
              }
              // }
            } else {
              document.querySelector(`[name="visit-time_${modalId}"]`).value =
                "";

              /** update window.crossSellEvent: clear tickets time infos -> todo */
              delete jsonModalData.time;

              elDialog
                .querySelector(".validate-option")
                .setAttribute("disabled", "");
            }
          });
        });
    });
  }
};

(function ($) {
  if (!!document.querySelectorAll(".offer-swiper")?.length) {
    /* before initialization
     * handling possible multiple occurence of offer-swiper
     */
    const offerSwipers = document.querySelectorAll(".offer-swiper");
    for (i = 0; i < offerSwipers.length; i++) {
      const paginationEl = offerSwipers[i].querySelector(".swiper-pagination");
      const swiperContainer = offerSwipers[i];
      const offerSwiper = new Swiper(offerSwipers[i], {
        slidesPerView: 2,
        spaceBetween: 0,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: swiperContainer.querySelector(".offer-swiper-button-next"),
          prevEl: swiperContainer.querySelector(".offer-swiper-button-prev"),
        },
        pagination: {
          el: paginationEl,
        },
        clickable: true,
      });
    }
  }
})();

(function () {
  // Get all the tooltip buttons
  const tooltips = document.querySelectorAll("[data-tooltip-content]");

  // Iterate over them
  Array.prototype.forEach.call(tooltips, function (tooltip) {
    // Get the message from the data-content element
    const message = tooltip.getAttribute("data-tooltip-content");

    // Get the live region element
    const liveRegion = tooltip.nextElementSibling;

    // Show message
    tooltip.addEventListener("click", function () {
      liveRegion.innerHTML = "";
      liveRegion.classList.remove("tooltip-bubble-wrapper--visible");
      window.setTimeout(function () {
        liveRegion.innerHTML =
          '<span class="tooltip-bubble">' + message + "</span>";
        liveRegion.classList.add("tooltip-bubble-wrapper--visible");
      }, 100);
    });

    tooltip.addEventListener("focus", function () {
      liveRegion.innerHTML = "";
      liveRegion.classList.remove("tooltip-bubble-wrapper--visible");
      window.setTimeout(function () {
        liveRegion.innerHTML =
          '<span class="tooltip-bubble">' + message + "</span>";
        liveRegion.classList.add("tooltip-bubble-wrapper--visible");
      }, 100);
    });

    tooltip.addEventListener("mouseover", function () {
      liveRegion.innerHTML = "";
      liveRegion.classList.remove("tooltip-bubble-wrapper--visible");
      window.setTimeout(function () {
        liveRegion.innerHTML =
          '<span class="tooltip-bubble">' + message + "</span>";
        liveRegion.classList.add("tooltip-bubble-wrapper--visible");
      }, 100);
    });

    // Hide message
    tooltip.addEventListener("focusout", function () {
      liveRegion.innerHTML = "";
      liveRegion.classList.remove("tooltip-bubble-wrapper--visible");
    });

    tooltip.addEventListener("mouseout", function () {
      liveRegion.innerHTML = "";
      liveRegion.classList.remove("tooltip-bubble-wrapper--visible");
    });

    document.addEventListener("click", function (e) {
      if (tooltip !== e.target) {
        liveRegion.innerHTML = "";
        liveRegion.classList.remove("tooltip-bubble-wrapper--visible");
      }
    });

    // Remove tooltip on ESC
    tooltip.addEventListener("keydown", function (e) {
      if ((e.keyCode || e.which) === 27) liveRegion.innerHTML = "";
      liveRegion.classList.remove("tooltip-bubble-wrapper--visible");
    });
  });
})();

/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   File:   tabs-automatic.js
 *
 *   Desc:   Tablist widget that implements ARIA Authoring Practices
 */

class genericTabs {
  constructor(groupNode) {
    this.tablistNode = groupNode;

    this.tabs = [];

    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.tablistNode.querySelectorAll("[role=tab]"));
    this.tabpanels = [];

    for (let i = 0; i < this.tabs.length; i += 1) {
      const tab = this.tabs[i];
      const tabpanel = document.getElementById(
        tab.getAttribute("aria-controls")
      );

      tab.tabIndex = -1;
      tab.setAttribute("aria-selected", "false");
      this.tabpanels.push(tabpanel);

      tab.addEventListener("keydown", this.onKeydown.bind(this));
      tab.addEventListener("click", this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    }

    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(currentTab, setFocus) {
    if (typeof setFocus !== "boolean") {
      // eslint-disable-next-line no-param-reassign
      setFocus = true;
    }
    for (let i = 0; i < this.tabs.length; i += 1) {
      const tab = this.tabs[i];
      if (currentTab === tab) {
        tab.setAttribute("aria-selected", "true");
        tab.removeAttribute("tabindex");
        this.tabpanels[i].classList.remove("is-hidden");
        if (setFocus) {
          tab.focus();
        }
      } else {
        tab.setAttribute("aria-selected", "false");
        tab.tabIndex = -1;
        this.tabpanels[i].classList.add("is-hidden");
      }
    }
  }

  setSelectedToPreviousTab(currentTab) {
    let index;

    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    let index;

    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  onKeydown(event) {
    const tgt = event.currentTarget;
    let flag = false;

    switch (event.key) {
      case "ArrowLeft":
        this.setSelectedToPreviousTab(tgt);
        flag = true;
        break;

      case "ArrowRight":
        this.setSelectedToNextTab(tgt);
        flag = true;
        break;

      case "Home":
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;

      case "End":
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

(function ($) {
  if (!!document.querySelectorAll(".bloc-double-swiper")?.length) {
    /* before initialization
     * handling possible multiple occurence of bloc-double-swiper
     */
    const dblebockSwipers = document.querySelectorAll(".bloc-double-swiper");
    for (i = 0; i < dblebockSwipers.length; i++) {
      const dblebockSwiper = new Swiper(dblebockSwipers[i], {
        slidesPerView: 2,
        spaceBetween: 0,
        breakpoints: {
          320: {
            slidesPerView: 1.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
        },
        clickable: true,
      });
    }
  }
})();

// (function ($) {
//   if (document.querySelector(".breadcrumb")) {
//     const bd = document.querySelector(".breadcrumb");
//     bd.querySelector(".breadcrumb-btn").addEventListener("click", () => {
//       console.log('toto')
//       if (!bd.classList.contains("expanded")) {
//         bd.classList.add('expanded')
//         console.log('tata')
//       }else{
//         console.log('titi')
//       }
//     });
//   }
// })();

(function ($) {
  let cards = document.querySelectorAll(
    ".push-triple-card, .bloc-animal-card, .editorial-content-card, .bloc-resume-card, .article-card, .bloc-info-content, .bloc-le-mag .main-card, .bloc-le-mag .card, .restaurant-push-card, .reasurance-content-card, .time-card, .hero-slide-container, .paragraph-full-img-container, .bloc-img-table"
  );
  if (!!cards?.length) {
    cards.forEach((card) => {
      if (!!card.querySelector("a")) {
        card.setAttribute("style", "cursor: pointer");
        card.classList.add("clickable");
        const link = card.querySelector("a").getAttribute("href");
        card.addEventListener("click", function handleClick() {
          window.location.assign(link);
        });
      }
    });
  }
})();

(function ($) {
  if (!!document.querySelectorAll(".dishes-swiper")?.length) {
    /* before initialization
     * handling possible multiple occurence of dishes-swiper
     */
    const dishesSwipers = document.querySelectorAll(".dishes-swiper");
    for (i = 0; i < dishesSwipers.length; i++) {
      const dishesSwiper = new Swiper(dishesSwipers[i], {
        slidesPerView: 2.5,
        breakpoints: {
          // when window width is >= 480px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          380: {
            slidesPerView: 1.25,
            spaceBetween: 20,
          },
          480: {
            slidesPerView: 1.75,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1.75,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3.5,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
        clickable: true,
      });
    }
  }
})();

let styleSheet = null;

function applyOffset() {
  const layouts = document.querySelectorAll(".drop-section__layout");

  if (!styleSheet) {
    styleSheet = document.createElement("style");
    document.head.appendChild(styleSheet);
  } else {
    // Clear existing rules for resize
    while (styleSheet.sheet.cssRules.length > 0) {
      styleSheet.sheet.deleteRule(0);
    }
  }

  const isTablet = window.innerWidth <= 1024 && window.innerWidth > 768;
  const isMobile = window.innerWidth <= 768;

  layouts.forEach((layout, layoutIdx) => {
    const containers = Array.from(
      layout.querySelectorAll(".drop-section__item")
    );
    // Set min-height based on number of images
    if (isMobile) {
      // Mobile: horizontal scroll if more than 2 items, vertical grid if 2 or fewer
      layout.style.minHeight = "";
      if (containers.length > 2) {
        layout.style.display = "flex";
        layout.style.flexDirection = "row";
        layout.style.overflowX = "auto";
        layout.style.gap = "20px";
        layout.style.padding = "0 20px";
        containers.forEach((container) => {
          container.style.position = "static";
          container.style.width = "80vw";
          container.style.minWidth = "250px";
          container.style.flex = "0 0 auto";
        });
      } else {
        layout.style.display = "grid";
        layout.style.gridTemplateColumns = "1fr";
        layout.style.gap = "30px";
        layout.style.overflowX = "";
        layout.style.padding = "0 20px";
        containers.forEach((container) => {
          container.style.position = "static";
          container.style.width = "100%";
          container.style.minWidth = "";
          container.style.flex = "";
        });
      }
    } else if (isTablet) {
      // Tablet: keep current grid
      // layout.style.display = "grid";
      // layout.style.gridTemplateColumns = "repeat(2, 1fr)";
      // layout.style.gap = "20px";
      layout.style.overflowX = "";
      layout.style.padding = "0 20px";
      containers.forEach((container) => {
        container.style.position = "static";
        container.style.width = "100%";
        container.style.minWidth = "";
        container.style.flex = "";
      });
    } else {
      // Desktop: keep absolute positioning and parallax
      if (layout.classList.contains("highlight-first")) {
        if (containers.length > 5) {
          layout.style.aspectRatio = "1320/2220";
        } else if (containers.length > 4) {
          layout.style.aspectRatio = "1320/1920";
        } else if (containers.length > 3) {
          layout.style.aspectRatio = "1320/1820";
        } else if (containers.length > 2) {
          layout.style.aspectRatio = "1320/1300";
        } else if (containers.length > 1) {
          layout.style.aspectRatio = "1320/1120";
        } else if (!layout.style.aspectRatio) {
          layout.style.aspectRatio = "1320/600";
        }
      } else {
        if (containers.length > 4) {
          layout.style.minHeight = "1650px";
        } else if (containers.length > 3) {
          layout.style.minHeight = "1300px";
        } else if (containers.length > 2) {
          layout.style.minHeight = "1150px";
        } else if (!layout.style.minHeight) {
          layout.style.minHeight = "725px";
        }
      }

      layout.style.display = "block";
      layout.style.overflowX = "";
      layout.style.gridTemplateColumns = "";
      layout.style.gap = "";
      layout.style.padding = "";
      // Clear mobile/tablet styles for each container
      containers.forEach((container) => {
        container.style.position = "";
        container.style.width = "";
        container.style.minWidth = "";
        container.style.flex = "";
      });
    }
    // Find the section title
    const title = layout.parentElement.querySelector(".drop-section__title");
    let titleRect;
    if (title) {
      // Get title position relative to layout
      const layoutRect = layout.getBoundingClientRect();
      const titleAbsRect = title.getBoundingClientRect();
      titleRect = {
        left: titleAbsRect.left - layoutRect.left,
        top: titleAbsRect.top - layoutRect.top,
        width: titleAbsRect.width,
        height: titleAbsRect.height,
      };
    }

    // Define static positions for 2, 3, 4 items (two options for each)
    const staticPositions = {
      1: [[{ top: "0%", left: "5%" }], [{ top: "2%", left: "45%" }]],
      2: [
        [
          { top: "0%", left: "15%" },
          { top: "28%", left: "53%" },
        ],
        [
          { top: "0%", left: "19%" },
          { top: "36%", left: "56%" },
        ],
      ],
      3: [
        [
          { top: "-5%", left: "7%" },
          { top: "52%", left: "27%" },
          { top: "9%", left: "66%" },
        ],
        [
          { top: "-7%", left: "3%" },
          { top: "54%", left: "29%" },
          { top: "8%", left: "70%" },
        ],
      ],
      4: [
        [
          { top: "-2%", left: "2%" },
          { top: "5%", left: "35%" },
          { top: "20%", left: "72%" },
          { top: "60%", left: "20%" },
        ],
        [
          { top: "0%", left: "10%" },
          { top: "0%", left: "60%" },
          { top: "50%", left: "70%" },
          { top: "70%", left: "20%" },
        ],
      ],
      5: [
        [
          { top: "-1%", left: "8%" },
          { top: "38%", left: "25%" },
          { top: "8%", left: "66%" },
          { top: "79%", left: "7%" },
          { top: "52%", left: "63%" },
        ],
        [
          { top: "-1%", left: "2%" },
          { top: "38%", left: "27%" },
          { top: "8%", left: "64%" },
          { top: "66%", left: "10%" },
          { top: "49%", left: "66%" },
        ],
      ],
      6: [
        [
          { top: "-5%", left: "2%" },
          { top: "0%", left: "40%" },
          { top: "10%", left: "75%" },
          { top: "40%", left: "25%" },
          { top: "55%", left: "70%" },
          { top: "75%", left: "20%" },
        ],
        [
          { top: "-2%", left: "5%" },
          { top: "20%", left: "43%" },
          { top: "0%", left: "75%" },
          { top: "35%", left: "70%" },
          { top: "50%", left: "10%" },
          { top: "75%", left: "30%" },
        ],
      ],
    };

    // special case if first article highlited
    // Define static positions for 2, 3, 4 items (one options for each)
    const staticPositionsHf = {
      1: [{ top: "0%", left: "8%" }],
      2: [
        { top: "0%", left: "3%" },
        { top: "68%", left: "53%" },
      ],

      3: [
        { top: "1%", left: "0%" },
        { top: "66%", left: "25%" },
        { top: "61%", left: "66%" },
      ],

      4: [
        { top: "-2%", left: "8%" },
        { top: "40%", left: "0%" },
        { top: "47%", left: "62%" },
        { top: "78%", left: "22%" },
      ],

      5: [
        { top: "-1%", left: "8%" },
        { top: "38%", left: "25%" },
        { top: "43%", left: "66%" },
        { top: "77%", left: "7%" },
        { top: "70%", left: "45%" },
      ],

      6: [
        { top: "-5%", left: "8%" },
        { top: "34%", left: "40%" },
        { top: "33%", left: "75%" },
        { top: "40%", left: "3%" },
        { top: "64%", left: "70%" },
        { top: "68%", left: "20%" },
      ],
    };

    // Use a stable option index for each layout, based on its index in the NodeList
    const count = containers.length;
    let optionIdx = 0;
    if (staticPositions[count]) {
      optionIdx = layoutIdx % 2; // Always 0 or 1, stable for each layout
    }

    containers.forEach((container, i) => {
      console.log("layout :>> ", layout);
      if (!isMobile && !isTablet) {
        // Desktop: absolute positioning and parallax
        let pos;
        if (
          staticPositions[count] &&
          staticPositions[count][optionIdx] &&
          staticPositions[count][optionIdx][i]
        ) {
          if (layout.classList.contains("highlight-first")) {
            pos = staticPositionsHf[count][i];
            container.style.left = pos.left;
            container.style.top = pos.top;
          } else {
            pos = staticPositions[count][optionIdx][i];
            container.style.left = pos.left;
            container.style.top = pos.top;
          }
        } else {
          // fallback: stack vertically
          container.style.left = `${10 + i * 20}%`;
          container.style.top = `${10 + i * 20}%`;
        }

        // PARALLAX EFFECT
        const speed = 0.3 + 0.2 * (i % 4);
        gsap.to(container, {
          y: () => {
            const yVal =
              -speed *
              400 *
              gsap.getProperty(container, "progress", "scrollTrigger");
            container.dataset.parallaxY = yVal;
            return yVal;
          },
          ease: "none",
          scrollTrigger: {
            trigger: layout,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            onUpdate: (self) => {
              container.dataset.parallaxY = -speed * 400 * self.progress;
            },
          },
        });
      } else {
        // Mobile & tablet: clear absolute positions and parallax
        container.style.left = "";
        container.style.top = "";
        container.dataset.parallaxY = "0";
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if (document.body.classList.contains("page-drop")) {
    /*
      -- Title infinite loop animation
    */
    const sliderContainer = document.querySelector(".drop-hero__content-top");
    const sliders = sliderContainer.querySelectorAll(".slider");

    let xPercent = 0;
    const direction = -1;

    function animateSlider() {
      if (xPercent < -100) {
        xPercent = 0;
      } else if (xPercent > 0) {
        xPercent = -100;
      }
      sliders.forEach((slider) => {
        slider.style.transform = `translateX(${xPercent}%)`;
      });
      xPercent += 0.1 * direction;
      requestAnimationFrame(animateSlider);
    }

    requestAnimationFrame(animateSlider);

    /*
      -- IntersectionObserver for nav highlight
    */
    const sections = document.querySelectorAll(".drop-section");
    const navLinks = document.querySelectorAll(".drop-links__item");
    const sectionIdToLink = {};
    navLinks.forEach((link) => {
      const href = link.getAttribute("href");
      if (href && href.startsWith("#")) {
        sectionIdToLink[href.slice(1)] = link;
      }
    });

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const link = sectionIdToLink[entry.target.id];
          if (entry.isIntersecting) {
            for (const otherLink of navLinks) {
              otherLink.classList.remove("drop-links__item--active");
            }
            if (link) {
              link.classList.add("drop-links__item--active");
              // --- NEW: Scroll nav container on mobile if needed ---
              if (window.innerWidth <= 768) {
                const navContainer = link.closest(".drop-links ul");
                if (navContainer) {
                  const linkRect = link.getBoundingClientRect();
                  const containerRect = navContainer.getBoundingClientRect();
                  // Check if link is not fully visible
                  if (
                    linkRect.left < containerRect.left ||
                    linkRect.right > containerRect.right
                  ) {
                    // Calculate the amount to scroll so the link is centered
                    const offset =
                      linkRect.left -
                      containerRect.left -
                      containerRect.width / 2 +
                      linkRect.width / 2;
                    navContainer.scrollTo({
                      left: navContainer.scrollLeft + offset,
                      behavior: "smooth",
                    });
                  }
                }
              }
            }
          }
        }
      },
      {
        root: null,
        threshold: [0.2],
      }
    );
    sections.forEach((section) => observer.observe(section));

    // Disconnect observer when navigating away to avoid memory leaks
    window.addEventListener("beforeunload", () => {
      observer.disconnect();
    });

    const dropLinksToggle = document.querySelector(".drop-links__toggle");
    if (dropLinksToggle) {
      dropLinksToggle.addEventListener("click", () => {
        const dropLinks = document.querySelector(".drop-links");
        if (dropLinks) {
          dropLinks.classList.toggle("drop-links--active");
          dropLinksToggle.classList.toggle("drop-links__toggle--active");
        }
      });
    }

    /*
      -- Apply float and offset to images
    */
    applyOffset();

    let resizeTimer;
    function handleResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        applyOffset();
      }, 250);
    }
    window.addEventListener("resize", handleResize);

    // Cleanup on unload to avoid memory leaks
    window.addEventListener("beforeunload", () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(resizeTimer);
    });

    /*
      -- Move the "previous issue" link dynamically
    */
    const prevLink = document.querySelector(".drop-link-prev");
    const navContainer = document.querySelector(".drop-sticky-content");
    if (prevLink && navContainer) {
      // Create a placeholder to mark the original position
      const placeholder = document.createElement("div");
      prevLink.parentNode.insertBefore(placeholder, prevLink);
      // Move the link into the nav container
      navContainer.appendChild(prevLink);
    }
    /*
        -- Mousemove effect for .drop-section__item elements --
        Each item will translate slightly in the opposite direction of mouse movement.
      */
    const dropItems = document.querySelectorAll(".drop-section__item");
    let mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    let current = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    let animationFrame;

    function handleMouseMove(e) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
    }

    function animateItems() {
      const decay = 0.15;
      current.x += (mouse.x - current.x) * decay;
      current.y += (mouse.y - current.y) * decay;
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      const dx = (current.x - centerX) / centerX;
      const dy = (current.y - centerY) / centerY;
      const maxTranslate = 20; // px
      dropItems.forEach((item) => {
        // Get parallaxY from dataset (default 0)
        const parallaxY = parseFloat(item.dataset.parallaxY || "0");
        const tx = dx * maxTranslate;
        const ty = dy * maxTranslate + parallaxY;
        item.style.transform = `translate(${tx}px, ${ty}px)`;
      });
      animationFrame = window.requestAnimationFrame(animateItems);
    }

    function enableMouseEffect() {
      if (window.innerWidth > 1024) {
        window.addEventListener("mousemove", handleMouseMove);
        if (!animationFrame) animateItems();
      } else {
        dropItems.forEach((item) => {
          item.style.transform = "";
        });
        window.removeEventListener("mousemove", handleMouseMove);
        if (animationFrame) {
          window.cancelAnimationFrame(animationFrame);
          animationFrame = null;
        }
      }
    }
    enableMouseEffect();
    window.addEventListener("resize", enableMouseEffect);

    window.addEventListener("beforeunload", () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("resize", enableMouseEffect);
      if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
      }
    });
  }
});

(function ($) {
  if (!!document.querySelectorAll(".bloc-event-slider-paragraph")?.length) {
    document
      .querySelectorAll(".bloc-event-slider-paragraph")
      .forEach((swiperWraper) => {
        const swiperEl = swiperWraper.querySelector(".event-slider-swiper");
        const navigationEl = swiperWraper.querySelector(".swiper-btn-wrapper");
        const paginationEl = swiperWraper.querySelector(".swiper-pagination");

        const eventSliderSwiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          navigation: {
            nextEl: navigationEl.querySelector(
              ".event-slider-swiper-button-next"
            ),
            prevEl: navigationEl.querySelector(
              ".event-slider-swiper-button-prev"
            ),
          },
          clickable: true,
          pagination: {
            el: paginationEl,
          },
        });
      });
  }
})();

(function ($) {
  if (!!document.querySelectorAll(".exhibition-animation-swiper")?.length) {
    /* before initialization
     * handling possible multiple occurence of exhibition-animation-swiper
     */
    const exhibitionAnimationSwipers = document.querySelectorAll(
      ".exhibition-animation-swiper"
    );
    for (i = 0; i < exhibitionAnimationSwipers.length; i++) {
      const exhibitionAnimationSwiper = new Swiper(
        exhibitionAnimationSwipers[i],
        {
          slidesPerView: 2.5,
          breakpoints: {
            // when window width is >= 480px
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            380: {
              slidesPerView: 1.15,
              spaceBetween: 20,
            },
            480: {
              slidesPerView: 1.5,
              spaceBetween: 40,
            },
            640: {
              slidesPerView: 1.75,
              spaceBetween: 40,
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 3.125,
              spaceBetween: 40,
            },
            // 1200: {
            //   slidesPerView: 3.125,
            // },
          },
          navigation: {
            nextEl: exhibitionAnimationSwipers[
              i
            ].nextElementSibling.querySelector(
              ".exhibition-animation-swiper-button-next"
            ),
            prevEl: exhibitionAnimationSwipers[
              i
            ].nextElementSibling.querySelector(
              ".exhibition-animation-swiper-button-prev"
            ),
          },
          clickable: true,
        }
      );
    }
  }
})();

(function ($) {
  if (document.querySelector(".experience-list-swiper")) {
    let titles = [];
    const articles = document
      .querySelector(".experience-list-swiper")
      .querySelectorAll("article");
    articles.forEach((x) => {
      titles.push(x.getAttribute("data-title"));
    });
    const percentageWidth =
      (1 /
        (document.querySelectorAll(".experience-list-swiper .swiper-slide")
          .length +
          2)) *
      100;

    const swiperWraper = document.querySelector(".bloc-experience-list");
    const paginationEl = swiperWraper.querySelector(".swiper-pagination");
    const experienceListswiper = new Swiper(
      swiperWraper.querySelector(".experience-list-swiper"),
      {
        slidesPerView: 1,
        navigation: {
          nextEl: ".experience-list-swiper-button-next",
          prevEl: ".experience-list-swiper-button-prev",
        },
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
          renderBullet: function (index, className) {
            return (
              '<span class="' +
              className +
              '" style="width:' +
              parseInt(percentageWidth) +
              "%;" +
              '">' +
              "<span>" +
              titles[index] +
              "</span>" +
              "</span>"
            );
          },
        },
        slidesPerView: 1.125,
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 45,
          depth: 120,
          modifier: 3,
          slideShadow: true,
          autoHeight: true,
        },
        breakpoints: {
          480: {
            slidesPerView: 1,
            effect: null,
            grabCursor: true,
            centeredSlides: false,
            coverflowEffect: null,
            clickable: true,
          },
        },
      }
    );
    // hiding navigation & pagination if only one slide
    if (swiperWraper.querySelectorAll(".swiper-slide")?.length < 2) {
      swiperWraper.classList.add("pag-nav-disabled");
    } else {
      swiperWraper.classList.remove("pag-nav-disabled");
    }
  }
})();

const fr = {
  days: [
    "Dimanche",
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
  ],
  daysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
  daysMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
  months: [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ],
  monthsShort: [
    "Jan",
    "Fév",
    "Mars",
    "Avr",
    "Mai",
    "Juin",
    "Juil",
    "Août",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  today: "Aujourd'hui",
  clear: "Effacer",
  dateFormat: "dd/MM/yyyy",
  timeFormat: "HH:mm",
  firstDay: 1,
};

const en = {
  days: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  monthsShort: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  today: "Today",
  clear: "Clear",
  dateFormat: "MM/dd/yyyy",
  timeFormat: "hh:mm aa",
  firstDay: 0,
};

const nl = {
  days: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag",
  ],
  daysShort: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  daysMin: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  months: [
    "Januari",
    "Februari",
    "Maart",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Augustus",
    "September",
    "Oktober",
    "November",
    "December",
  ],
  monthsShort: [
    "Jan",
    "Feb",
    "Mrt",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ],
  today: "Vandaag",
  clear: "Legen",
  dateFormat: "dd-MM-yyyy",
  timeFormat: "HH:mm",
  firstDay: 0,
};

const de = {
  days: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ],
  daysShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
  daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  months: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],
  monthsShort: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez",
  ],
  today: "Heute",
  clear: "Aufräumen",
  dateFormat: "dd.MM.yyyy",
  timeFormat: "HH:mm",
  firstDay: 1,
};


/* 
/* we can add or remove any other lang 
/* that is present in the 
/* datepicker-locale-ref repository 
*/

const airDatePickerLocale = {
  fr,
  en,
  nl,
  de,
};

function debounce(callback, delay) {
  var timer;
  return function () {
    var args = arguments;
    var context = this;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, delay);
  };
}

function optionAsLink(event) {
  const pageLocation = window.location.origin + window.location.pathname;
  let selectParent = event.target;
  const options = selectParent.querySelectorAll("option");
  let choosenOption = Array.prototype.slice
    .call(options)
    .filter((x) => x.value === event.target.value);

  if (choosenOption[0].getAttribute("data-link")) {
    window.location.href = choosenOption[0].getAttribute("data-link");
  } else {
    window.location.href = pageLocation;
  }
}

(function ($) {
  // datepicker - https://air-datepicker.com/
  if (document.querySelector(".datepicker-input")) {
    /*
    /* for more readability
    /* airDatePickerLocale
    /* is imported
    /* from datepicker-locale.js
    */

    // select locale in locale data based on data-locale attribute
    const dataLocale = document
      .querySelector(".datepicker-input")
      .getAttribute("data-locale");

    // datepicker - daily selector
    if (document.querySelector("#animation-daily-selector")) {
      // displaying date on page
      const longEFRFormatter = new Intl.DateTimeFormat(dataLocale, {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
      });

      document.querySelector(".dynamic-readable-date").innerHTML =
        longEFRFormatter.format(Date.now());

      // datepicker - daily selector
      // prepare ajax request
      let httpRequest;
      function makeRequest(dataUrl, selectedDate) {
        httpRequest = new XMLHttpRequest();
        let formattedDate = [
          selectedDate.getFullYear(),
          ("0" + (selectedDate.getMonth() + 1)).slice(-2),
          ("0" + selectedDate.getDate()).slice(-2),
        ].join("-");

        // if (!httpRequest) {
        //   alert(
        //     "Prévoir une petite popin pour prévenir l'utilisateur de l'échec de la requête"
        //   );
        //   return false;
        // }
        httpRequest.onreadystatechange = onSuccessContents;

        // GET example
        httpRequest.open("GET", dataUrl + "/" + formattedDate);
        httpRequest.send();

        // POST example
        // httpRequest.open("POST", dataUrl);
        // httpRequest.setRequestHeader(
        //   "Content-Type",
        //   "application/x-www-form-urlencoded"
        // );
        // httpRequest.send(`selected_date=${encodeURIComponent(formattedDate)}`);
      }
      function onSuccessContents() {
        if (httpRequest.readyState === XMLHttpRequest.DONE) {
          if (httpRequest.status === 200) {
            // console.log(
            //   "JSON.parse(httpRequest.responseText)[0].data; :>> ",
            //   JSON.parse(httpRequest.responseText)[0].data;
            // );
            document.querySelector("#daily-planing-cards-wrapper").innerHTML =
              JSON.parse(httpRequest.responseText)[0].data;
            let cards = document.querySelectorAll(".animation-card");
            if (!!cards?.length) {
              cards.forEach((card) => {
                if (!!card.querySelector("a")) {
                  card.setAttribute("style", "cursor: pointer");
                  card.classList.add("clickable");
                  const link = card.querySelector("a").getAttribute("href");
                  card.addEventListener("click", function handleClick() {
                    window.location.assign(link);
                  });
                }
              });
            }
          } else {
            // alert(
            //   "Prévoir une petite popin pour prévenir l'utilisateur de l'échec de la requête"
            // );
          }
        }
      }
      let dataUrl = document
        .querySelector(".datepicker-input")
        .getAttribute("data-url");

      // first request on load - actual date
      window.addEventListener("load", () => {
        let formattedDate = new Date(Date.now());
        makeRequest(dataUrl, formattedDate);
      });

      // init date picker
      new AirDatepicker("#animation-daily-selector", {
        position: "bottom center",
        isMobile: window.innerWidth < 830 ? true : false,
        onSelect: (date) => {
          document.querySelector(".dynamic-readable-date").innerHTML =
            longEFRFormatter.format(date.date);
          // ajax call concat data-url + date YYYY-MM-JJ
          makeRequest(dataUrl, date.date);
        },
        locale: airDatePickerLocale[dataLocale] || airDatePickerLocale[fr],
        minDate: Date.now(),
        selectedDates: [Date.now()],
      });
    }

    // school & group form
    // step 1
    // datepicker - visit date
    if (document.querySelector("#visit-date")) {
      new AirDatepicker("#visit-date", {
        position: "bottom center",
        isMobile: window.innerWidth < 830 ? true : false,
        locale: airDatePickerLocale[dataLocale] || airDatePickerLocale[fr],
        minDate: Date.now(),
        // selectedDates: [Date.now()],
        selectedDates: !!document
          .querySelector("#visit-date")
          .getAttribute("data-selected-date")
          ? parseInt(
              document
                .querySelector("#visit-date")
                .getAttribute("data-selected-date") * 1000
            )
          : [Date.now()],
        // altField: "#formated-visit-date",
        // altFieldDateFormat: "MM/dd/yyyy",
      });
    }

    // school & group form
    // step 1
    // datepicker - visit start time
    if (document.querySelector("#visit-start-time")) {
      let today = new Date();
      today.setHours(9);
      today.setMinutes(30);
      new AirDatepicker("#visit-start-time", {
        position: "bottom center",
        isMobile: window.innerWidth < 830 ? true : false,
        locale: airDatePickerLocale[dataLocale] || airDatePickerLocale[fr],
        timepicker: true,
        onlyTimepicker: true,
        timeFormat: "H:mm",
        minHours: 9,
        maxHours: 18,
        startDate: today,
        selectedDates: !!document
          .querySelector("#visit-start-time")
          .getAttribute("data-selected-date")
          ? parseInt(
              document
                .querySelector("#visit-start-time")
                .getAttribute("data-selected-date") * 1000
            )
          : today,
        onSelect({ date, formattedDate, datepicker }) {
          const selectedDate = new Date(date);

          if (selectedDate.getHours() === 9 && selectedDate.getMinutes() < 30) {
            selectedDate.setMinutes(30);
            datepicker.selectDate(selectedDate);
          }
        },
      });
    }

    // school & group form
    // step 1
    // datepicker - visit start time
    if (document.querySelector("#visit-end-time")) {
      let today = new Date();
      today.setHours(18);
      today.setMinutes(30);
      new AirDatepicker("#visit-end-time", {
        position: "bottom center",
        isMobile: window.innerWidth < 830 ? true : false,
        locale: airDatePickerLocale[dataLocale] || airDatePickerLocale[fr],
        timepicker: true,
        onlyTimepicker: true,
        timeFormat: "H:mm",
        minHours: 9,
        maxHours: 18,
        endDate: today,
        selectedDates: !!document
          .querySelector("#visit-end-time")
          .getAttribute("data-selected-date")
          ? parseInt(
              document
                .querySelector("#visit-end-time")
                .getAttribute("data-selected-date") * 1000
            )
          : today,
      });
    }
  }

  // school & group form
  // step 1
  // payer structure form part
  if (document.querySelector("#is-payer-structure")) {
    const payerRadios = document.querySelectorAll(
      'input[type=radio][name="payer"]'
    );
    const payerInfoFields = document.querySelectorAll(
      ".non-payer-stucture-info .two-col-form-container .fieldset input"
    );

    function isPayer(radio) {
      if (radio.value === "is-not-payer") {
        document
          .querySelector(".non-payer-stucture-info")
          .removeAttribute("hidden");
        // commented because handled by drupal
        // payerInfoFields.forEach((field) => {
        //   field.setAttribute("required", "");
        // });
      } else {
        document
          .querySelector(".non-payer-stucture-info")
          .setAttribute("hidden", "");
        // commented because handled by drupal
        // payerInfoFields.forEach((field) => {
        //   field.removeAttribute("required", "");
        // });
      }
    }
    payerRadios.forEach((radio) =>
      radio.addEventListener("change", () => isPayer(radio))
    );
  }

  // multi checkbox validation
  if (!!document.querySelectorAll(".multi-checbox-validity")?.length) {
    document
      .querySelectorAll(".multi-checbox-validity")
      .forEach((checkboxGroup) => {
        const checkboxesToValidate = checkboxGroup.querySelectorAll(
          "input[type=checkbox]"
        );
        const dataControlText = checkboxGroup.getAttribute("data-control-text");
        checkboxesToValidate[0].setCustomValidity(dataControlText);

        function setRequired(elements) {
          elements.forEach((el) => el.setAttribute("required", ""));
        }
        function unRequire(elements) {
          elements.forEach((el) => el.removeAttribute("required"));
        }

        checkboxesToValidate.forEach((checkbox) => {
          checkbox.setAttribute("required", "");

          checkbox.addEventListener("change", () => {
            let checkedInputs = Array.prototype.slice
              .call(checkboxesToValidate)
              .filter((x) => x.checked === true);
            if (!!checkedInputs?.length) {
              unRequire(checkboxesToValidate);
              checkboxesToValidate[0].setCustomValidity("");
            } else {
              setRequired(checkboxesToValidate);
              checkboxesToValidate[0].setCustomValidity(dataControlText);
            }
          });
        });
      });
  }

  // school & group form
  // step 3
  // adding audioguide

  // helper function
  function setFormAttributes(element, keys, value) {
    keys.forEach((key) => {
      Object.assign(element, {
        [key]: value,
      });
    });
  }

  // commented because handled by drupal
  // function addAudioguide() {
  //   const audioguideLength = document.querySelectorAll(
  //     ".audioguide-container"
  //   ).length;

  //   document
  //     .querySelectorAll(".audioguide-container")
  //     [audioguideLength - 1].classList.add("fieldset");

  //   const newAudioguide = document
  //     .querySelectorAll(".audioguide-container")[0]
  //     .cloneNode(true);

  //   newAudioguide.classList.remove("fieldset");

  //   const newAudioguideLanguage = newAudioguide.querySelector(
  //     ".audioguide-language-container"
  //   );
  //   const newAudioguideNumber = newAudioguide.querySelector(
  //     ".audioguide-number-container"
  //   );

  //   setFormAttributes(
  //     newAudioguideLanguage.querySelector("label"),
  //     ["htmlFor"],
  //     "audioguide-language-" + audioguideLength
  //   );
  //   setFormAttributes(
  //     newAudioguideLanguage.querySelector("select"),
  //     ["id", "name"],
  //     "audioguide-language-" + audioguideLength
  //   );

  //   setFormAttributes(
  //     newAudioguideNumber.querySelector("label"),
  //     ["htmlFor"],
  //     "audioguide-number-" + audioguideLength
  //   );
  //   setFormAttributes(
  //     newAudioguideNumber.querySelector("input"),
  //     ["id", "name"],
  //     "audioguide-number-" + audioguideLength
  //   );

  //   document.querySelector("#audioguide-fieldset").append(newAudioguide);
  // }
  // if (document.querySelector("#add-audioguide")) {
  //   document
  //     .querySelector("#add-audioguide")
  //     .addEventListener("click", () => addAudioguide());
  // }

  /* dropdown with checkboxes
   * inspired from @RobotsPlay's https://codepen.io/RobotsPlay/pres/pyNLdL
   */
  const CheckboxDropdown = function (el) {
    const _this = this;
    this.isOpen = false;
    this.$el = el;
    this.$label = this.$el.querySelector(".dropdown-label");
    this.$labelWording = this.$label.getAttribute("data-label");
    this.$labelWordingSelected = this.$label.getAttribute("data-selected");
    this.$labelWordingAllSelected =
      this.$label.getAttribute("data-all-selected");
    this.$inputs = this.$el.querySelectorAll('[type="checkbox"]');

    this.onCheckBox();

    this.$label.addEventListener("click", function (e) {
      e.preventDefault();
      _this.toggleOpen();
    });

    this.$inputs.forEach((x) => {
      x.addEventListener("change", function (e) {
        _this.onCheckBox();
      });
    });
  };

  CheckboxDropdown.prototype.onCheckBox = function () {
    this.updateStatus();
  };

  CheckboxDropdown.prototype.updateStatus = function () {
    const dropdownInputs = this.$el.querySelectorAll("input");
    let dropdownCheckedInputsArray = Array.prototype.slice
      .call(dropdownInputs)
      .filter((x) => x.checked === true);
    setTagVisible(dropdownInputs);

    if (dropdownCheckedInputsArray.length <= 0) {
      const newButton = document.createElement("button");
      newButton.innerHTML = this.$labelWording;
      newButton.classList.add("initial-select");
      this.$label.innerHTML = "";
      this.$label.append(newButton);
    } else if (dropdownCheckedInputsArray.length === 1) {
      let textLabel =
        dropdownCheckedInputsArray[0].parentNode.querySelector(
          ".text-label"
        ).innerHTML;
      this.$label.innerHTML = textLabel;
    } else if (dropdownCheckedInputsArray.length === this.$inputs.length) {
      this.$label.innerHTML =
        this.$labelWordingAllSelected ||
        dropdownCheckedInputsArray.length + " " + this.$labelWordingSelected;
      this.areAllChecked = true;
    } else {
      this.$label.innerHTML =
        dropdownCheckedInputsArray.length + " " + this.$labelWordingSelected;
    }
  };

  CheckboxDropdown.prototype.toggleOpen = function () {
    const _this = this;
    function listenOutsideClick(e) {
      if (!e.target.closest("[data-control]") && _this.isOpen) {
        // console.log("outside");
        _this.toggleOpen();
        document.removeEventListener("click", listenOutsideClick);
      }
    }

    if (!this.isOpen) {
      this.isOpen = true;
      this.$el.classList.add("on");
      document.addEventListener("click", listenOutsideClick);
    } else {
      this.isOpen = false;
      this.$el.classList.remove("on");
    }
  };

  var checkboxesDropdowns = document.querySelectorAll(
    '[data-control="checkbox-dropdown"]'
  );
  for (var i = 0, length = checkboxesDropdowns.length; i < length; i++) {
    new CheckboxDropdown(checkboxesDropdowns[i]);
  }

  // filter tags - reveal selected options tags
  if (!!document.querySelectorAll(".filter-tags")?.length) {
    document.querySelectorAll(".filter-tags").forEach((filters) => {
      const filterInputs = filters.querySelectorAll("input");
      setTagVisible(filterInputs);
    });
  }

  function submitParenFormt(e) {
    e.target.closest("form").submit();
  }

  function setTagVisible(elementList) {
    const tags = document.querySelectorAll(".tags li a");
    if (!!elementList?.length) {
      elementList.forEach((element) => {
        element.addEventListener("change", function () {
          const textLabel =
            element.parentNode.querySelector(".text-label").innerHTML;
          let matchingLink = Array.prototype.slice
            .call(tags)
            .filter((x) => x.innerHTML === textLabel);
          if (matchingLink?.length) {
            if (!!element.checked) {
              matchingLink[0].removeAttribute("hidden");
            } else {
              matchingLink[0].setAttribute("hidden", "");
            }
          }
        });
        element.addEventListener("change", debounce(submitParenFormt, 1000));
      });
    }
  }

  if (document.querySelectorAll("[data-link")?.length) {
    const dataLinks = document.querySelectorAll("[data-link");
    dataLinks.forEach((dl) => {
      const selectParent = dl.closest("select");
      selectParent.addEventListener("change", (event) => optionAsLink(event));
    });
  }

  /**
   * Fieldset field File
   */
  if (document.querySelectorAll("fieldset.field-file")?.length) {
    const fields = document.querySelectorAll("fieldset.field-file");

    fields.forEach((field) => {
      const input = field.querySelector('input[type="file"]');
      const currentFile = field.querySelector(".current-file");

      // button selection
      field.querySelector(".btn-uploadFile").addEventListener("click", (e) => {
        input.click();
      });

      // file selected
      field
        .querySelector("#edit-file-upload")
        .addEventListener("change", (e) => {
          const [file] = e.target.files;
          field.querySelector(".file-name").textContent = file.name;
          currentFile.classList.add("active");
        });

      // remove file
      field.querySelector(".btn-remove").addEventListener("click", (e) => {
        input.value = null;
        currentFile.classList.remove("active");
      });
    });
  }
})();

//=require ../globals/gsap-register.js
(function ($) {
  // HANDLING VIDEO SRC BY WINDOW WIDTH - RESPONSIVE
  if (document.querySelector("#home-hero-video")) {
    const homeByTheSeaSource = document.querySelector(
      "#home-hero-video source"
    );
    const homeByTheSeadatSrc = homeByTheSeaSource.getAttribute("data-src");
    const windowWidth = window.innerWidth;

    function selectBestDefinition() {
      if (windowWidth > 1023) {
        homeByTheSeaSource.setAttribute("src", homeByTheSeadatSrc);
        document.querySelector("#home-hero-video").load();
      }
    }
    window.addEventListener("load", () => {
      if (windowWidth > 1023) {
        selectBestDefinition();
        gsap.set(document.querySelector(".hero-wrapper"), { autoAlpha: 1 });
        revealVideoTitle();
      } else {
        gsap.set(document.querySelector(".hero-wrapper"), { autoAlpha: 1 });
        revealVideoTitle();
      }
    });
    window.addEventListener("resize", () => {
      // window.scrollTo({
      //   top: 0,
      //   left: 0,
      //   behavior: "instant",
      // });
      if (window.innerWidth > windowWidth && windowWidth > 1023) {
        selectBestDefinition();
        gsap.set(document.querySelector(".hero-wrapper"), { autoAlpha: 1 });
      } else {
        gsap.set(document.querySelector(".hero-wrapper"), { autoAlpha: 1 });
      }
    });
  }

  // VIDEO TITLE ELEMENTS APPARITION
  function revealVideoTitle() {
    const titleApparition = document.querySelectorAll(
      ".apparition-title-container"
    );
    const infoApparition = document.querySelector(".hero-info-container");
    const textTl = gsap.timeline({
      defaults: { duration: 0.75, ease: "power2.out" },
    });
    titleApparition.forEach(function (elment, i) {
      textTl.from(
        elment,
        {
          y: 40,
          opacity: 0,
        },
        i * 0.25
      );
    });
    textTl.from(
      infoApparition,
      {
        y: infoApparition.offsetHeight / 2,
        opacity: 0,
      },
      titleApparition.length * 0.25 - 0.25
    );
  }

  // ADDITIONAL INFO APPARITION
  function additionalInfoApparition() {
    var additionalInfoTl = gsap.timeline({
      defaults: { duration: 0.5, ease: "power2.out" },
    });

    if (
      document
        .getElementById("additional-info-container")
        .classList.contains("active")
    ) {
      additionalInfoTl.to(
        ".additional-info-container",
        {
          x: document.getElementById("additional-content").offsetWidth,
          onComplete: () =>
            document
              .getElementById("additional-info-container")
              .classList.remove("active"),
        },
        0
      );
      additionalInfoTl.to(
        ".btn-icon",
        {
          rotate: 0,
        },
        0.25
      );
    } else {
      additionalInfoTl.to(
        ".additional-info-container",
        {
          x:
            "100vh" - document.getElementById("additional-content").offsetWidth,
          onComplete: () =>
            document
              .getElementById("additional-info-container")
              .classList.add("active"),
        },
        0
      );
      additionalInfoTl.to(
        ".btn-icon",
        {
          rotate: 180,
        },
        0.15
      );
    }
  }
  if (document.getElementById("additional-trigger")) {
    document
      .getElementById("additional-trigger")
      .addEventListener("click", () => {
        additionalInfoApparition();
      });
  }

  /*
    HOME HERO ANIMATION
   */

  // HOME VIDEO ANIMATION
  if (window.innerWidth > 1023 && document.querySelectorAll(".title-and-video-container")?.length) {
    let videoSections = document.querySelectorAll(".title-and-video-container");
    let allowAnim = true;
    let killAnim = false;
    const videoSectionTl = gsap.timeline({
      defaults: {
        duration: 1,
        ease: "power2.out",
        onStart: () => {
          document.querySelector("body").classList.add("no-scroll");
        },
        onComplete: () => {
          allowAnim = false;
          setTimeout(() => {
            document.querySelector("body").classList.remove("no-scroll");
            killAnim = true;
          }, 500);
        },
        // onReverseComplete: () => {
        // },
      },
    });

    videoSections.forEach(function (element) {
      // TITLE OVER VIDEO ANIMATION
      let titleElements = document.querySelectorAll(".fading-title-element");
      titleElements.forEach(function (titleElement, i) {
        videoSectionTl.to(
          titleElement,
          {
            y: -(
              (document.querySelector(".hero-title").offsetHeight *
                titleElements.length) /
              (titleElements.length + i)
            ),
            opacity: 0,
          },
          0
        );
      });

      // VIDEO SATELITE ANIMALS ANIMATION
      let satelliteElements = element.querySelectorAll(".hero-satellite");
      let mainSatellite = document.querySelector(".satellite-3");
      satelliteElements.forEach(function (satelliteElement) {
        videoSectionTl.to(
          satelliteElement,
          {
            y: -(mainSatellite.offsetHeight / 1.1),
            opacity: 0,
          },
          0
        );
      });

      // MASK OVER VIDEO
      videoSectionTl.to(
        element.querySelectorAll(".video-mask-hero"),
        {
          y: "-200vh",
        },
        0.35
      );
      // Halo OVER VIDEO
      videoSectionTl.to(
        element.querySelectorAll(".title-container"),
        {
          opacity: 0,
        },
        0.35
      );
    });

    // HOME HERO MAIN ANIMATION
    videoSectionTl.pause();
    const wheelListener = (e) => {
      // console.log('allowAnim :>> ', allowAnim);
      // console.log(e.deltaY);
      // console.log("window.scrollY :>> ", window.scrollY);
      // console.log("killAnim :>> ", killAnim);
      if (allowAnim && e.deltaY > 0) {
        videoSectionTl.play();
      }
      if (killAnim && e.deltaY > 0) {
        gsap.to(window, {
          duration: .5,
          scrollTo: document.querySelector("#hero-slider-container"),
          onComplete: () => {
            videoSectionTl.reverse();
          },
        });
          killAnim = false;
      }
    };
    window.addEventListener("wheel", wheelListener);
    window.addEventListener("touchstart", wheelListener);
    window.addEventListener("touchmove", wheelListener);
    window.addEventListener("touchend", wheelListener);

    if (document.querySelector(".home")) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
      // document.querySelector("body").classList.add("no-scroll");
    }
  }
  // HOME HERO SLIDER ANIMATION
  if (document.querySelector(".hero-sliders-container")) {
    if (window.innerWidth > 1023) {
      let sections = gsap.utils.toArray(".hero-slide-container");
      gsap.to(sections, {
        xPercent: -100 * (sections.length - 1),
        ease: "none",
        scrollTrigger: {
          trigger: ".hero-sliders-container",
          pin: true,
          scrub: 1,
          snap: window.innerWidth < 1024 ? 1 / (sections.length - 1) : 0,
          end: () =>
            "+=" +
            document.querySelector(".hero-sliders-container").offsetWidth,
          // invalidateOnRefresh: true,
        },
      });
    } else {
      const heroSwiper = document.querySelector(".hero-slider-container");
      const heroNewSwiper = new Swiper(heroSwiper, {
        slidesPerView: 1.5,
        watchOverflow: true,
        breakpoints: {
          320: {
            slidesPerView: 1,
          },
          380: {
            slidesPerView: 1.05,
          },
          480: {
            slidesPerView: 1.5,
          },
          640: {
            slidesPerView: 1.5,
          },
          768: {
            slidesPerView: 1.5,
          },
        },
        // navigation: {
        //   nextEl: animalPushSwipers[i].nextElementSibling.querySelector(
        //     ".animal-push-swiper-button-next"
        //   ),
        //   prevEl: animalPushSwipers[i].nextElementSibling.querySelector(
        //     ".animal-push-swiper-button-prev"
        //   ),
        // },
        clickable: true,
      });
    }
  }

  // hero info swiper
  if (document.querySelector(".hero-anim-container")) {
    const swiperContainerEl = document.querySelector(".hero-anim-container");
    if (swiperContainerEl.querySelector(".hero-info-swiper")) {
      const heroInfoSwiper = new Swiper(
        swiperContainerEl.querySelector(".hero-info-swiper"),
        {
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: swiperContainerEl.querySelector(
              ".hero-info-swiper-button-next"
            ),
            prevEl: swiperContainerEl.querySelector(
              ".hero-info-swiper-button-prev"
            ),
          },
          clickable: true,
        }
      );
    }
  }
})();

(function ($) {
  // home new article swiper - home
  if (!!document.querySelectorAll(".new-articles-swiper")?.length) {
    /* before initialization
     * handling possible multiple occurence of new-articles-swiper
     */
    const newArticlesSwipers = document.querySelectorAll(
      ".new-articles-swiper"
    );
    for (i = 0; i < newArticlesSwipers.length; i++) {
      const newArticlesSwiper = new Swiper(newArticlesSwipers[i], {
        slidesPerView: 2.5,
        breakpoints: {
          // when window width is >= 480px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          380: {
            slidesPerView: 1.25,
            spaceBetween: 20,
          },
          480: {
            slidesPerView: 1.75,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 1.75,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3.125,
            spaceBetween: 30,
          },
          // 1200: {
          //   slidesPerView: 3.125,
          // },
        },
        navigation: {
          nextEl: newArticlesSwipers[i].nextElementSibling.querySelector(
            ".new-articles-swiper-button-next"
          ),
          prevEl: newArticlesSwipers[i].nextElementSibling.querySelector(
            ".new-articles-swiper-button-prev"
          ),
        },
        clickable: true,
      });
    }
  }
})();

function addSwiperEffect() {
  const currentWidth = window.screen.width;
  let stretch = 300;
  
  if ( currentWidth < 1280 ) stretch = 280;
  if ( currentWidth < 1024 ) stretch = 250;
  if ( currentWidth < 768 ) stretch = 130;
  if ( currentWidth < 550 ) stretch = 100;
  if ( currentWidth < 550 ) stretch = 50;

  if (!!document.querySelectorAll(".paragraph-image-slider")?.length) {
    document
      .querySelectorAll(".paragraph-image-slider")
      .forEach((swiperWraper) => {
        const swiperEl = swiperWraper.querySelector(".image-slider-swiper");
        const paginationEl = swiperWraper.querySelector(".swiper-pagination");

        const imageSliderSwiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          navigation: {
            nextEl: swiperEl.querySelector(
              ".image-slider-swiper-button-next"
            ),
            prevEl: swiperEl.querySelector(
              ".image-slider-swiper-button-prev"
            ),
          },
          clickable: true,
          pagination: {
            el: paginationEl,
          },
          effect: "coverflow",
          coverflowEffect: {
            stretch: stretch,
            rotate: 0,
            depth: 120,
            modifier: 3,
            slideShadows: false,
            autoHeight: true,
          },
        });
      });
  }
}

// init
addSwiperEffect();
// on resize
let prevW = window.screen.width;
let currentW = window.screen.width;
const breakpoints = [1280, 1024, 768, 550, 430];
window.addEventListener('resize', function(event){
  currentW = window.screen.width;
  breakpoints.forEach(function(value, index){
    if ( prevW >= value && currentW < value || prevW < value && currentW >= value ){
      addSwiperEffect();
    }
  });
});
(function ($) {
  if (!!document.querySelectorAll(".bloc-insta-swiper")?.length) {
    /* before initialization
     * handling possible multiple occurence of bloc-insta-swiper
     */
    const newInstaSwipers = document.querySelectorAll(".bloc-insta-swiper");
    for (i = 0; i < newInstaSwipers.length; i++) {
      const newInstaSwiper = new Swiper(newInstaSwipers[i], {
        slidesPerView: 2.5,
        breakpoints: {
          // when window width is >= 480px
          320: {
            slidesPerView: 1.25,
            spaceBetween: 10,
          },
          380: {
            slidesPerView: 2.5,
            spaceBetween: 10,
          },
          480: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3.5,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3.75,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: newInstaSwipers[i].nextElementSibling.querySelector(
            ".insta-swiper-button-next"
          ),
          prevEl: newInstaSwipers[i].nextElementSibling.querySelector(
            ".insta-swiper-button-prev"
          ),
        },
        clickable: true,
      });
    }
  }
})();

//= require ../globals/debounce.js

/**
 * helper function
 *  based on https://greensock.com/docs/v3/HelperFunctions#lottie
 * */
function LottieScrollTrigger(vars, func) {
  // console.log("vars.path :>> ", vars.path);
  let playhead = { frame: 0 },
    target = gsap.utils.toArray(vars.target)[0],
    speeds = {
      xslow: "+=2500",
      slow: "+=2000",
      medium: "+=1000",
      mediumx: "+=800",
      fast: "+=500",
    },
    st = {
      trigger: target.parentNode,
      pin: true,
      start: "top top",
      end: speeds[vars.speed] || "+=1000",
      scrub: 1,
    },
    ctx = gsap.context && gsap.context(),
    animation = lottie.loadAnimation({
      container: target,
      renderer: vars.renderer || "svg",
      loop: false,
      autoplay: false,
      path: vars.path,
      rendererSettings: vars.rendererSettings || {
        preserveAspectRatio: "xMidYMid slice",
      },
    });
  for (let p in vars) {
    // let users override the ScrollTrigger defaults
    st[p] = vars[p];
  }
  animation.addEventListener("DOMLoaded", function () {
    /** adding a function as eye animation for ex */
    if (func) {
      func();
    }
    /** */
    let createTween = function () {
      animation.frameTween = gsap.to(playhead, {
        frame: animation.totalFrames - 1,
        ease: "none",
        onUpdate: () => animation.goToAndStop(playhead.frame, true),
        scrollTrigger: st,
      });
      return () => animation.destroy && animation.destroy();
    };
    ctx && ctx.add ? ctx.add(createTween) : createTween();
    // in case there are any other ScrollTriggers on the page and the loading of this Lottie asset caused layout changes
    ScrollTrigger.sort();
    ScrollTrigger.refresh();
  });
  return animation;
}

/** movin eyes on mouse move */
function animateEyes() {
  if (document.querySelector(".anim-pupil2")) {
    const pupil = document.querySelector(".anim-pupil2");
    const pupilPath1 = document.querySelector(".anim-pupil1 path");
    const pupilPath2 = document.querySelector(".anim-pupil2 path");
    const pupilWidth = pupil.getBoundingClientRect().width;
    /* approximative ratio between pupil and white eye zone */
    const ratio = 1.5;

    document.addEventListener("mousemove", (e) => {
      /**% of window */
      let x = (e.clientX * 100) / window.innerWidth - 50;
      let y = (e.clientY * 100) / window.innerHeight - 50;

      /**% of element width */
      let xPupil = (x * pupilWidth) / 100;
      let yPupil = (y * pupilWidth) / 100;

      pupilPath1.style.cssText +=
        "transform : translate(" +
        xPupil / ratio +
        "px," +
        yPupil / ratio +
        "px)";
      pupilPath2.style.cssText +=
        "transform : translate(" +
        xPupil / ratio +
        "px," +
        yPupil / ratio +
        "px)";
    });
  }
}

/** manta ray animation */
var mantaRayAnim = bodymovin.loadAnimation({
  container: document.getElementById("secondary-bloc-anim-container"), // the dom element that will contain the animation
  renderer: "svg",
  loop: true,
  autoplay: false,
  path: "/themes/custom/nausicaa/assets/lottie-animations/manta-ray.json",
});

/** Title apparition */
if (document.querySelector(".kids-title-1")) {
  var animateTitleIn = gsap.timeline({
    scrollTrigger: {
      trigger: ".kids-title-1",
      start: "top bottom",
      toggleActions: "restart none none reverse",
      onEnter: () => {
        /* play seaweed anim */
        setTimeout(() => {
          lottie.loadAnimation({
            container: document.getElementById("seaweed-animation-wrapper"), // the dom element that will contain the animation
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: "/themes/custom/nausicaa/assets/lottie-animations/seaweed.json",
          });
        }, 500);

        /* play manta ray anim */
        mantaRayAnim.play();
      },
    },
  });
}

if (document.querySelector(".kids-title-1")) {
  animateTitleIn.fromTo(
    ".kids-title-1",
    {
      opacity: 0,
      scale: 0.1,
    },
    {
      opacity: 1,
      scale: 1,
      y: -160,
      duration: 0.75,
      ease: "back",
    }
  );
}

/** swiper on scroll */
if (!!document.querySelectorAll(".kids-animated-swiper")?.length) {
  /* before initialization
   * handling possible multiple occurence of kids-animated-swiper
   */
  const windowWidth = window.innerWidth;
  const kidsAnimatedSwipers = document.querySelectorAll(
    ".kids-animated-swiper"
  );
  for (i = 0; i < kidsAnimatedSwipers.length; i++) {
    const kidsAnimatedSwiper = new Swiper(kidsAnimatedSwipers[i], {
      slidesPerView: 2.5,
      watchOverflow: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        380: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 1.5,
          spaceBetween: 40,
        },
        640: {
          slidesPerView: 1.5,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
      },
      clickable: true,
    });

    const slideLength = kidsAnimatedSwipers[i].querySelectorAll(
      ".kids-animated-slider-bloc .swiper-slide"
    ).length;

    if (windowWidth > 640) {
      ScrollTrigger.create({
        trigger: ".kids-animated-slider-container",
        start: "top top",
        pin: true,
        scrub: 1,
        // snap: 1 / (tata - 1),
        onUpdate: (self) => {
          let baseIndex = parseInt(self.progress * slideLength);
          kidsAnimatedSwiper.slideTo(baseIndex);
        },
      });
    }
  }
}
/** /swiper on scroll */

// animate pinguin
lottie.loadAnimation({
  container: document.getElementById("classic-slider-anim-container"), // the dom element that will contain the animation
  renderer: "svg",
  loop: true,
  autoplay: true,
  path: "/themes/custom/nausicaa/assets/lottie-animations/penguin.json",
});

// animate sea lion
lottie.loadAnimation({
  container: document.getElementById("sea-lion-animation"), // the dom element that will contain the animation
  renderer: "svg",
  loop: true,
  autoplay: true,
  path: "/themes/custom/nausicaa/assets/lottie-animations/sea-lion.json",
});

/**
 * function to animate the introduction
 * with loading a different json file
 * depending on the width of the screen
 */
function animateIntro() {
  // window.scrollTo(0, 0);
  if (document.querySelector("#mobile-intro")) {
    if (document.querySelector("#mobile-intro svg")) {
      document.querySelector("#mobile-intro svg").remove();
    }
    document.querySelector("#mobile-intro").remove();
  }
  if (document.querySelector("#desktop-intro")) {
    document.querySelector("#desktop-intro").remove();
  }

  let parentContainer = document.querySelector(".shark-wrapper");
  if (window.innerWidth > 1023) {
    let newContentElement = document.createElement("div");
    newContentElement.setAttribute("id", "desktop-intro");
    parentContainer.appendChild(newContentElement);
    LottieScrollTrigger(
      {
        target: "#desktop-intro",
        path: "/themes/custom/nausicaa/assets/lottie-animations/intro.json",
        speed: "xslow",
        scrub: 1,
        onUpdate: (self) =>
          (document.querySelector(".incentive").style.cssText +=
            "opacity: " + (1 - self.progress * 2.4)),
        onEnter: () =>
          document
            .querySelector(".shark-container")
            .classList.add("animation-loaded"),
      },
      animateEyes
    );
  } else {
    let newContentElement = document.createElement("div");
    newContentElement.setAttribute("id", "mobile-intro");
    parentContainer.appendChild(newContentElement);
    LottieScrollTrigger(
      {
        target: "#mobile-intro",
        path: "/themes/custom/nausicaa/assets/lottie-animations/intro-mobile.json",
        speed: "medium",
        scrub: 1,
        onUpdate: (self) =>
          (document.querySelector(".incentive").style.cssText +=
            "opacity: " + (1 - self.progress * 2.4)),
        onEnter: () =>
          document
            .querySelector(".shark-container")
            .classList.add("animation-loaded"),
      },
      animateEyes
    );
  }
}

/**
 * function to animate the octopus
 * depending on the width of the screen
 */
function animateOctopus() {
  // window.scrollTo(0, 0);
  if (document.querySelector("#octopus")) {
    document.querySelector("#octopus").remove();
  }
  let parentContainer = document.querySelector("#octopus-wrapper");
  if (window.innerWidth > 1023) {
    let newContentElement = document.createElement("div");
    newContentElement.setAttribute("id", "octopus");
    parentContainer.appendChild(newContentElement);
    LottieScrollTrigger({
      target: "#octopus",
      path: "/themes/custom/nausicaa/assets/lottie-animations/octopus.json",
      speed: "mediumx",
      start: "top 35%",
    });
  }
}

/**
 * loading scrol controlled animations
 */
if (document.querySelector(".kids-academy-container")) {
  /** on load */
  addEventListener("load", (event) => {
    animateIntro();
    animateOctopus();
  });

  /** on resize */
  let windowWidthBeforeResize = window.innerWidth;
  window.addEventListener(
    "resize",
    debounce(function (e) {
      const relativeResizing =
        (Math.abs(windowWidthBeforeResize - window.innerWidth) /
          windowWidthBeforeResize) *
        100;
      // if relative resizing > 20% - arbitrary
      if (relativeResizing > 20) {
        animateIntro();
        animateOctopus();
        window.scrollTo(0, 0);
        windowWidthBeforeResize = window.innerWidth;
      }
    }, 100)
  );
}

(function ($) {
  if (document.querySelector(".partners-footer")) {
    const swipercontainerEl = document.querySelector(".partners-footer");
    if (swipercontainerEl.querySelector(".footer-swiper")) {
      const footerSwiper = new Swiper(
        swipercontainerEl.querySelector(".footer-swiper"),
        {
          slidesPerView: 2.5,
          spaceBetween: 10,
          breakpoints: {
            // when window width is >= 480px
            380: {
              slidesPerView: 3.5,
            },
            640: {
              slidesPerView: 5.5,
            },
            768: {
              slidesPerView: 5.5,
            },
            1024: {
              slidesPerView: 6,
            },
            1200: {
              slidesPerView: 8,
            },
          },
          navigation: {
            nextEl: swipercontainerEl.querySelector(
              ".footer-swiper-button-next"
            ),
            prevEl: swipercontainerEl.querySelector(
              ".footer-swiper-button-prev"
            ),
          },
          clickable: true,
        }
      );
    }
  }
})();

//=require ../globals/gsap-register.js
gsap.registerPlugin(ScrollToPlugin);
(function ($) {
  ScrollTrigger.create({
    start: "top top",
    end: 99999,
    // markers: true,
    onEnter: () => {
      if (window.matchMedia("(min-width: 1200px)").matches) {
        document.querySelector(".main-header").classList.remove("open-menu");
        document.querySelector(".main-header").classList.remove("open-search");
      }
      if (document.querySelector(".main-nav > ul > li.active")) {
        document
          .querySelector(".main-nav > ul > li.active")
          .classList.remove("active");
      }
    },
    onUpdate: (self) => {
      if (self.direction === 1) {
        if (window.matchMedia("(min-width: 1200px)").matches) {
          hideMainMenu();
          hideHeaderSearch();
        }
        setTimeout(() => {
          document.querySelector(".main-header").classList.add("sticky");
        }, 200);
        if (document.querySelector(".breadcrumb-container")) {
          document
            .querySelector(".breadcrumb-container")
            .classList.add("sticky-header");
        }
      }
      if (self.direction === -1) {
        if (self.progress <= 0.001) {
          document.querySelector(".main-header").classList.remove("sticky");
          if (self.progress <= 0.0001) {
            if (document.querySelector(".breadcrumb-container")) {
              document
                .querySelector(".breadcrumb-container")
                .classList.remove("sticky-header");
            }
          }
        } else {
          document.querySelector(".main-header").classList.add("sticky");
        }
      }
    },
  });
  // }

  // MAIN MENU
  function hideMainMenu() {
    document.querySelector(".main-header").classList.remove("open-menu");
    // document.querySelector("body").classList.remove("fixed");
    if (document.querySelector(".main-nav > ul > li.active")) {
      document
        .querySelector(".main-nav > ul > li.active")
        .classList.remove("active");
    }
    document.querySelector(".desktop-menu-container").innerHTML = "";
    document.querySelector(".panel-container").innerHTML = "";
    document
      .querySelector(".visible-menu-container")
      .classList.remove("visible-back-btn");
    // document.querySelector(".mobile-menu-back-btn").setAttribute("hidden", "");
    if (document.querySelector(".visible-menu-container .menu-btn-wrapper")) {
      document
        .querySelector(".visible-menu-container .menu-btn-wrapper")
        .remove();
    }
  }

  function hideHeaderSearch() {
    document.querySelector(".main-header").classList.remove("visible-search");
    // setTimeout(() => {
    document.querySelector(".main-header").classList.remove("open-search");
    // ezmpty js desktop search wrapper
    document.querySelector(
      ".js_header-search-container .content-section"
    ).innerHTML = "";
    // ezmpty js mobile search wrapper
    document.querySelector(".js_mobile-header-search-container").innerHTML = "";
    // }, "500");
  }

  function hideEveryOpenHeader() {
    hideMainMenu();
    hideHeaderSearch();
  }

  function desktopHideEveryOpenHeader() {
    if (window.matchMedia("(min-width: 1200px)").matches) {
      hideEveryOpenHeader();
    }
  }

  // hide menu & search on window resize
  window.addEventListener("resize", desktopHideEveryOpenHeader);

  // SEARCH
  if (document.querySelector(".header-search-btn")) {
    document
      .querySelector(".header-search-btn")
      .addEventListener("click", function () {
        if (
          document
            .querySelector(".main-header")
            .classList.contains("open-search")
        ) {
          hideHeaderSearch();
        } else {
          document.querySelector(".main-header").classList.add("open-search");
          document
            .querySelector(".main-header")
            .classList.add("visible-search");
          if (
            !document.querySelector(
              ".js_header-search-container .search-form-wrapper"
            )
          ) {
            let newSearchForm = document
              .querySelector(".search-form-wrapper")
              .cloneNode(true);
            document
              .querySelector(".js_header-search-container .content-section")
              .append(newSearchForm);
          }

          gsap.from(document.querySelector(".js_header-search-container"), {
            yPercent: -100,
            duration: 0.15,
          });
          hideMainMenu();
        }
      });
  }

  document.addEventListener("DOMContentLoaded", () => {
    // DESKTOP BEHAVIOUR
    document.querySelectorAll(".main-nav > ul > li > a").forEach((x) => {
      x.addEventListener("click", (event) => {
        hideHeaderSearch();
        // set visibility classes
        const hasChildren = x.parentNode.querySelector("ul");
        if (!!hasChildren) {
          event.preventDefault();
          document.querySelector(".main-header").classList.add("open-menu");

          if (x.parentNode.classList.contains("active")) {
            x.parentNode.classList.remove("active");
            document
              .querySelector(".main-header")
              .classList.remove("open-menu");

            // mapulate dom elements
            document.querySelector(".desktop-menu-container").innerHTML = "";
          } else {
            if (document.querySelector(".main-nav > ul > li.active")) {
              document
                .querySelector(".main-nav > ul > li.active")
                .classList.remove("active");
            }
            x.parentNode.classList.add("active");
            x.parentNode;

            // mapulate dom elements
            const jsMenuContainer = document.querySelector(
              ".desktop-menu-container "
            );
            let level1Ul = x.parentNode.querySelector("ul").cloneNode(true);
            level1Ul.className = "main-menu-level1";

            if (!!jsMenuContainer.querySelectorAll("ul").length) {
              jsMenuContainer.replaceChildren(level1Ul);
            } else {
              document
                .querySelector(".desktop-menu-container")
                .prepend(level1Ul);
              gsap.from(document.querySelector(".js_main-menu-container"), {
                yPercent: -100,
                duration: 0.15,
              });
            }
            document
              .querySelector(".btn-close-menu")
              .addEventListener("click", function () {
                hideMainMenu();
              });
          }
        }
      });
    });

    if (document.querySelector(".menu-overlay")) {
      document.querySelector(".menu-overlay").addEventListener("click", () => {
        hideMainMenu();
      });
    }

    // MOBILE BEHAVIOUR
    // init mobile menu
    if (document.querySelector(".toggle-mobile-menu")) {
      document
        .querySelector(".toggle-mobile-menu")
        .addEventListener("click", () => {
          if (
            document
              .querySelector(".main-header")
              .classList.contains("open-menu")
          ) {
            document
              .querySelector(".main-header")
              .classList.remove("open-menu");
            hideMainMenu();
            hideHeaderSearch();
          } else {
            document.querySelector(".main-header").classList.add("open-menu");

            //handle search
            let newSearchForm = document
              .querySelector(".search-form-wrapper")
              .cloneNode(true);
            document
              .querySelector(".js_mobile-header-search-container")
              .append(newSearchForm);

            // handle menu itself
            const jsMenuContainer = document.querySelector(
              ".visible-menu-container .panel-container"
            );

            // init mobile lang selector
            const langSelector = document
              .querySelector(".lang-menu")
              .cloneNode(true);
            const ticketWrapper = document
              .querySelector(".tickets-btn-wrapper")
              .cloneNode(true);
            const menuBtnWrapper = document.createElement("div");
            menuBtnWrapper.classList.add("menu-btn-wrapper");
            menuBtnWrapper.appendChild(ticketWrapper);
            menuBtnWrapper.appendChild(langSelector);

            // init mobile menu
            const mainMenu = document
              .querySelector(".main-nav")
              .cloneNode(true);
            const mainMenuList = mainMenu.querySelector("ul");
            mainMenuList.classList.add("main-menu-level-0");
            const panel = document.createElement("div");
            panel.classList.add("panel-wrapper");
            panel.appendChild(mainMenuList);

            jsMenuContainer.appendChild(panel);
            document
              .querySelector(".visible-menu-container")
              .appendChild(menuBtnWrapper);

            // menu accordion
            let groups = gsap.utils.toArray(mainMenuList.children);
            let menusArray = [];
            groups.map((x) => {
              if (
                childrenMatches(x, "ul")?.length &&
                childrenMatches(x, "a")?.length
              ) {
                menusArray.push(childrenMatches(x, "a")[0]);
              }
            });
            let menus = gsap.utils.toArray(menusArray);
            let menuToggles = groups.map(createAnimation);

            menus.forEach((menu) => {
              menu.addEventListener("click", (event) => {
                event.preventDefault();
                toggleMenu(menu);
              });
            });
            menus[0].click();

            function toggleMenu(clickedMenu) {
              menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
            }

            function createAnimation(element) {
              let menu = element.querySelector("a");
              let box = element.querySelector("ul");
              if (box) {
                element.classList.add("expandable");
              }

              let animation = gsap.timeline().fromTo(
                box,
                {
                  height: 0,
                  duration: 0.5,
                  ease: "power1.inOut",
                },
                {
                  height: "auto",
                  duration: 0.5,
                  ease: "power1.inOut",
                  onStart: () => {
                    menusArray.forEach((x) => {
                      x.setAttribute("aria-expanded", "false");
                      x.classList.remove("active");
                      x.parentNode.classList.remove("active-node");
                    });
                    menu.setAttribute("aria-expanded", "true");
                    if (menu.classList.contains("active")) {
                      menu.classList.remove("active");
                    } else {
                      menu.classList.add("active");
                    }
                    if (menu.parentNode.classList.contains("active-node")) {
                      menu.parentNode.classList.remove("active-node");
                    } else {
                      menu.parentNode.classList.add("active-node");
                    }
                  },
                }
              );
              return function (clickedMenu) {
                gsap.to(document.querySelector(".panel-wrapper"), {
                  scrollTo: clickedMenu.scrollTop,
                  duration: 0.5,
                });
                if (clickedMenu === menu) {
                  animation.reversed(!animation.reversed());
                  if (clickedMenu.classList.contains("active")) {
                    clickedMenu.classList.remove("active");
                  } else {
                    clickedMenu.classList.add("active");
                  }
                  if (
                    clickedMenu.parentNode.classList.contains("active-node")
                  ) {
                    clickedMenu.parentNode.classList.remove("active-node");
                  } else {
                    clickedMenu.parentNode.classList.add("active-node");
                  }
                } else {
                  animation.reverse();
                  menusArray.forEach((x) => {
                    x.setAttribute("aria-expanded", "false");
                    x.classList.remove("active");
                    x.parentNode.classList.remove("active-node");
                  });
                }
              };
            }

            document
              .querySelector(".btn-close-menu")
              .addEventListener("click", function () {
                hideMainMenu();
              });
          }
        });
    }
  });

  // champion sound!
  // sound button effect
  const animateSoundPlayBtn = gsap.to(".bar", {
    transformOrigin: "center bottom",
    scaleY: 0.5,
    duration: 0.15,
    yoyo: true,
    stagger: {
      each: 0.05,
      from: "random",
      // amount:  0.15,
      // ease: "power3.out",
    },
    repeat: -1,
  });
  animateSoundPlayBtn.kill();

  function playAudio() {
    document.querySelector("audio").play();
    localStorage.setItem("sound_check", "checked");
  }
  function pauseAudio() {
    document.querySelector("audio").pause();
  }
  function playOST() {
    if (document.querySelector(".sound-btn").classList.contains("sound-off")) {
      // document.querySelector(".icon-sound-on").removeAttribute("hidden");
      document.querySelector(".sound-btn").classList.add("sound-on");
      document.querySelector(".sound-btn").classList.remove("sound-off");
      playAudio();
      gsap.to(".sound-infotext", {
        alpha: 0,
        duration: 0.25,
      });
      animateSoundPlayBtn.play(0);
    } else {
      document.querySelector(".sound-btn").classList.add("sound-off");
      document.querySelector(".sound-btn").classList.remove("sound-on");
      pauseAudio();
      animateSoundPlayBtn.kill();
    }
  }
  function hideSoundInfotext() {
    document.querySelector(".sound-infotext").setAttribute("hidden", "");
    localStorage.setItem("sound_check", "checked");
  }
  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".sound-btn")) {
      if (localStorage.getItem("sound_check") === "checked") {
        document.querySelector(".sound-infotext").setAttribute("hidden", "");
      } else {
        document.querySelector(".sound-infotext").removeAttribute("hidden");
        gsap.fromTo(
          ".sound-infotext",
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.25,
          }
        );
      }
    }
  });

  if (document.querySelector(".sound-btn")) {
    document.querySelector(".sound-btn").addEventListener("click", playOST);
    document
      .querySelector(".sound-infotext-close-btn")
      .addEventListener("click", hideSoundInfotext);
  }

  /*! UTILs
   * Get all direct descendant elements that match a selector
   * Dependency: the matches() polyfill: https://vanillajstoolkit.com/polyfills/matches/
   * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   elem     The element to get direct descendants for
   * @param  {String} selector The selector to match against
   * @return {Array}           The matching direct descendants
   */
  var childrenMatches = function (elem, selector) {
    return Array.prototype.filter.call(elem.children, function (child) {
      return child.matches(selector);
    });
  };
})();

(function ($) {
  /**
   * Extract the key from a string, in general in ids or classes
   * Examples : id-1, id-2, class-3, class-4 => 1, 2, 3, 4
   * @param {string} ps_string
   * @param {string} ps_separator
   * @returns {string}
   */
  const extractKey = (ps_string, ps_separator = "-") => {
    const strings = ps_string.split(ps_separator);

    return strings.pop();
  };

  // opening popin form url param
  const searchParams = new URLSearchParams(window.location.search);
  const isNewsletterVisible = searchParams.get("newsletter");
  if (isNewsletterVisible) {
    document
      .querySelector(".newsletter-bloc-container")
      .classList.add("newsletter-popin-visible");
    document
      .querySelector(".newsletter-bloc-container")
      .classList.add("newsletter-popin-display");
  }

  // newsletter response popin
  if (document.querySelector(".newsletter-bloc-container")) {
    document
      .querySelector(".btn-newsletter")
      .addEventListener("click", (event) => {
        event.preventDefault();
        document
          .querySelector(".newsletter-bloc-container")
          .classList.add("newsletter-popin-visible");
        document
          .querySelector(".newsletter-bloc-container")
          .classList.add("newsletter-popin-display");

        // set newsletter param in url when opening popin
        searchParams.append("newsletter", "visible");
        const path = window.location.href.split("?")[0];
        let newURL;
        if (searchParams?.size > 0) {
          newURL = `${path}?${searchParams}`;
        } else {
          newURL = `${path}`;
        }
        history.pushState({}, "", newURL);

      });
  }

  if (document.querySelector(".btn-close-newsletter-popin")) {
    const btnClose = document.querySelectorAll(".btn-close-newsletter-popin");
    for (let i = 0; i < btnClose.length; i++) {
      btnClose[i].addEventListener("click", (event) => {
        event.preventDefault();
        document
          .querySelector(".newsletter-bloc-container")
          .classList.remove("newsletter-popin-visible");
        setTimeout(() => {
          document
            .querySelector(".newsletter-bloc-container")
            .classList.remove("newsletter-popin-display");
        }, 100);

        // remove newsletter param in url when closing popin
        searchParams.delete("newsletter");
        const path = window.location.href.split("?")[0];
        let newURL;
        if (searchParams?.size > 0) {
          newURL = `${path}?${searchParams}`;

        } else {
          newURL = `${path}`;
        }
        history.pushState({}, "", newURL);
      });
    }
  }
})();

//=require ../globals/generic-tabs.js
(function ($) {
  if (
    !!document.querySelectorAll(
      ".bloc-other-practical-info .tabs-global-container"
    ).length
  ) {
    document
      .querySelectorAll(".bloc-other-practical-info .tabs-global-container")
      .forEach((tabWrapper) => {
        const wrapper = tabWrapper;
        generictabs(wrapper);
      });
  }
})();

(function ($) {
  if (!!document.querySelectorAll(".reassurance-swiper")?.length) {
    /* before initialization
     * handling possible multiple occurence of reassurance-swiper
     */
    const reassuranceSwipers = document.querySelectorAll(".bloc-reassurance");
    for (i = 0; i < reassuranceSwipers.length; i++) {
      const swiperEl = reassuranceSwipers[i].querySelector(
        ".reassurance-swiper"
      );
      const reassuranceSwiper = new Swiper(swiperEl, {
        spaceBetween: 30,
        breakpoints: {
          // when window width is >= 320px
          slidesPerView: 1,
          380: {
            slidesPerView: 1.25,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2.25,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 2.75,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        },
        clickable: true,
      });
    }
  }
})();

(function ($) {
  if (!!document.querySelectorAll(".restaurant-push-swiper")?.length) {
    /* before initialization
     * handling possible multiple occurence of restaurant-push-swiper
     */
    const restaurantPushSwipers = document.querySelectorAll(
      ".restaurant-push-swiper"
    );
    for (i = 0; i < restaurantPushSwipers.length; i++) {
      const restaurantPushSwiper = new Swiper(restaurantPushSwipers[i], {
        slidesPerView: 2.5,
        breakpoints: {
          // when window width is >= 480px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          380: {
            slidesPerView: 1.1,
            spaceBetween: 20,
          },
          480: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1.75,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 1.85,
            spaceBetween: 30,
          },
          900: {
            slidesPerView: 2.25,
            spaceBetween: 30,
          },
          1180: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
        // navigation: {
        //   nextEl: restaurantPushSwipers[i].nextElementSibling.querySelector(
        //     ".restaurant-push-swiper-button-next"
        //   ),
        //   prevEl: restaurantPushSwipers[i].nextElementSibling.querySelector(
        //     ".restaurant-push-swiper-button-prev"
        //   ),
        // },
        clickable: true,
      });
    }
  }
})();

(function ($) {
  if (document.querySelector(".bloc-slider-immersion")) {
    const swiperContainer = document.querySelector(".bloc-slider-immersion");
    const items = swiperContainer.querySelectorAll(".swiper-slide");
    const paginationEl = swiperContainer.querySelector(".swiper-pagination");

    var enableMobileSwiper = function enableMobileSwiper() {
      items.forEach((item) => {
        const imgTag = item.querySelector(".mobile-img");
        const leftPart = item.querySelector(".left-part-container");
        const swiperImg = item.querySelector(".right-part-container img");
        // if (window.innerWidth < 768) {
        //   imgTag.setAttribute("src", imgTag.getAttribute("data-urlsmall"));
        // } else {
        //   imgTag.setAttribute("src", imgTag.getAttribute("data-urlmedium"));
        // }
        leftPart.removeAttribute("style");
        swiperImg.removeAttribute("style");
      });

      immersionSwiper = new Swiper(
        swiperContainer.querySelector(".immersion-swiper"),
        {
          slidesPerView: 2.5,
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            380: {
              slidesPerView: 1.1,
              spaceBetween: 20,
            },
            480: {
              slidesPerView: 1.5,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 1.75,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 1.85,
              spaceBetween: 30,
            },
            900: {
              slidesPerView: 2.25,
              spaceBetween: 30,
            },
            1180: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
          navigation: {
            nextEl: swiperContainer.querySelector(
              ".immersion-swiper-button-next"
            ),
            prevEl: swiperContainer.querySelector(
              ".immersion-swiper-button-prev"
            ),
          },
          pagination: {
            el: paginationEl,
          },
          // clickable: true,
        }
      );
    };

    var enableDesktopSlider = function enableDesktopSlider() {
      // set iterative z-index
      items.forEach((item, index) => {
        item.setAttribute("style", "z-index: " + (9 - index));
      });

      // set first slide as active
      window.addEventListener("load", (event) => {
        items.forEach((item, i) => {
          if (i === 0) {
            item.querySelector(".overlay").click();
            item.classList.add("active");
          }
        });
      });

      const expand = (item, i) => {
        items.forEach((it, ind) => {
          const leftPart = it.querySelector(".left-part-container")
          const mobileImg = it.querySelector(".mobile-img")
          it.classList.remove("active");
          it.classList.remove("no-overlay");
          gsap.to(leftPart, {
            x: "40%",
            duration: 0.75,
            ease: "power2.out",
          });

          gsap.to(mobileImg, {
            x: "30%",
            scale: 1.1,
            duration: 0.75,
            ease: "power2.out",
          });

          if (i === ind) {
            it.classList.add("active");
            setTimeout(() => {
              it.classList.add("no-overlay");
            }, 250);
            gsap.to(leftPart, {
              x: 0,
              duration: 0.75,
              ease: "power2.out",
            });

            gsap.to(mobileImg, {
              x: 0,
              scale: 1.1,
              duration: 0.75,
              ease: "power2.out",
            });

            return;
          }

          it.clicked = false;
        });

        gsap.to(items, {
          width: item.clicked ? "33.3333%" : "15%",
          duration: 1,
          ease: "power2.out",
        });

        item.clicked = !item.clicked;

        gsap.to(item, {
          width: item.clicked ? "70%" : "33.3333%",
          duration: 1,
          ease: "power2.out"
        });
      };

      items.forEach((item, i) => {
        let itemOverlay = item.querySelector(".overlay");
        item.clicked = false;
        itemOverlay.addEventListener("click", () => expand(item, i));
      });
    };

    window.addEventListener("load", (event) => {
      if (window.innerWidth > 1279) {
        enableDesktopSlider();
        items[0].querySelector(".overlay").click();
        gsap.to(items[0].querySelector(".overlay p"), {
          opacity: 1,
          duration: 0.5,
          ease: "power2.out",
        });
      } else {
        enableMobileSwiper();
      }
    });

    let windowWidthBeforeResize = window.innerWidth;
    window.addEventListener(
      "resize",
      debounce(function (e) {
        const relativeResizing =
          (Math.abs(windowWidthBeforeResize - window.innerWidth) /
            windowWidthBeforeResize) *
          100;

        // if relative resizing > 20% - arbitrary
        if (relativeResizing > 20) {
          var immersionSwiper;
          if (window.matchMedia("(min-width: 1279px)").matches) {
            if (immersionSwiper !== undefined) mySwiper.destroy(true, true); // or/and do nothing
          } else {
            return enableMobileSwiper();
          }

          if (window.innerWidth > 1279) {
            enableDesktopSlider();
          } else {
          }
          window.scrollTo(0, 0);
          windowWidthBeforeResize = window.innerWidth;
        }
        items[0].querySelector(".overlay").click();
      }, 100)
    );
  }
})();

//=require ../globals/generic-tabs.js
(function ($) {
  if (document.querySelector(".bloc-tabs-slider")) {
    const swiperContainerEl = document.querySelector(".bloc-tabs-slider");
    if (swiperContainerEl.querySelector(".tab-xp-swiper-first")) {
      const newTabXpSwiperFirst = new Swiper(
        swiperContainerEl.querySelector(".tab-xp-swiper-first"),
        {
          slidesPerView: 2.5,
          breakpoints: {
            // when window width is >= 480px
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            380: {
              slidesPerView: 1.2,
              spaceBetween: 20,
            },
            480: {
              slidesPerView: 1.75,
              spaceBetween: 30,
            },
            640: {
              slidesPerView: 1.75,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 3.5,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          },
          navigation: {
            nextEl: ".tab-xp-swiper-button-next",
            prevEl: ".tab-xp-swiper-button-prev",
          },
          clickable: true,
          // on: {
          //   init: function () {
          //     console.log("swiper initialized");
          //   },
          // },
        }
      );
    }
    if (swiperContainerEl.querySelector(".tabs-global-container")) {
      const wrapper = swiperContainerEl.querySelector(".tabs-global-container");
      generictabs(wrapper, initTabSwiper);
    }
  }
})();

(function () {
  // Config
  var config = {
    showLogs:
      location.hostname === "localhost" ||
      location.hostname === "nausicaa.loc" ||
      location.hostname.endsWith(".staging42.siaxp.com"),
  };

  function log(...args) {
    if (config.showLogs) {
      console.log(...args);
    }
  }

  function roundPrice(price) {
    return Math.round((price + Number.EPSILON) * 100) / 100;
  }

  // Function to compare cart states
  function compareCartStates(prevState, newState) {
    const prevMap = new Map(prevState.map((item) => [item.item_id, item]));
    const newMap = new Map(newState.map((item) => [item.item_id, item]));

    const added = [];
    const removed = [];

    // Check for removed or quantity-changed items
    prevMap.forEach((prevItem, itemId) => {
      const newItem = newMap.get(itemId);

      if (!newItem) {
        // Item was completely removed
        removed.push(prevItem);
      } else if (prevItem.quantity > newItem.quantity) {
        // Item quantity decreased
        removed.push({
          ...prevItem,
          quantity: prevItem.quantity - newItem.quantity,
        });
      }
    });

    // Check for added or quantity-increased items
    newMap.forEach((newItem, itemId) => {
      const prevItem = prevMap.get(itemId);

      if (!prevItem) {
        // Item was completely added
        added.push(newItem);
      } else if (newItem.quantity > prevItem.quantity) {
        // Item quantity increased
        added.push({
          ...newItem,
          quantity: newItem.quantity - prevItem.quantity,
        });
      }
    });

    return { added, removed };
  }

  // Function to format products array
  function formatProducts(cartData, productsDiscount) {
    const products = [];
    if (cartData) {
      cartData.forEach((category) => {
        if (category.tickets) {
          category.tickets.forEach((ticket) => {
            // Set unique product id from combination of category id and tarif id
            const productId = `${category.id}-${ticket.tarifId}`;
            // Define product object
            const product = {
              item_id: productId,
              item_name: ticket.label,
              item_brand: "nausicaa",
              item_category: ticket.family,
              price: roundPrice(
                parseFloat(ticket.price) / parseInt(ticket.number)
              ),
              quantity: parseInt(ticket.number),
            };
            // Get product discount if it exists
            const productDiscount = productsDiscount?.find(
              (x) => x.id === productId
            );
            // If product has specific discount, add the info to product object
            if (productDiscount) {
              product.discount = parseFloat(productDiscount.discount);
              product.coupon = productDiscount.coupon;
            }
            // Push product object to the list
            products.push(product);
          });
        }
      });
    }
    return products;
  }

  function getEcommerceDiscountInfo(useLocalStorage) {
    let info = {};
    if (
      typeof window.cartDiscount === "object" &&
      window.cartDiscount.code &&
      window.cartDiscount.discount
    ) {
      info.coupon = window.cartDiscount.code;
      info.discount = parseFloat(window.cartDiscount.discount);
      sessionStorage.setItem("cartDiscount", JSON.stringify(info));
    } else if (useLocalStorage && sessionStorage.getItem("cartDiscount")) {
      info = JSON.parse(sessionStorage.getItem("cartDiscount"));
    }
    return info;
  }

  function getUserInfo(useLocalStorage) {
    const info = {};
    if (typeof window.userTicketingId !== "undefined") {
      info.mail_hash = window.userTicketingId;
      sessionStorage.setItem("userTicketingId", window.userTicketingId);
    } else if (useLocalStorage && sessionStorage.getItem("userTicketingId")) {
      info.mail_hash = sessionStorage.getItem("userTicketingId");
    }
    return info;
  }

  function getProductsTotal(productsArray, discount = 0) {
    const startPrice = 0 - parseFloat(discount);
    return productsArray.reduce((total, product) => {
      const { price, quantity, discount = 0 } = product;
      const newTotal = total + (price - discount) * quantity;
      return roundPrice(newTotal);
    }, startPrice);
  }

  // Function to push ecommerce event to the datalayer
  function pushEcommerce(
    eventName,
    products,
    ecommerceOptions = {},
    disabled = false
  ) {
    // Initialize datalayer with existing one OR create new empty one
    window.dataLayer = window.dataLayer || [];

    // Define object to be pushed
    const dataLayerObject = {
      event: eventName,
      ecommerce: {
        currency: "EUR",
        ...ecommerceOptions,
        value: getProductsTotal(products, ecommerceOptions.discount),
        items: products,
      },
    };

    if (!disabled) {
      log("➡️ pushEcommerce :>> ", dataLayerObject);
      window.dataLayer.push(dataLayerObject);
    } else {
      log("🚫 DISABLED EVENT (not pushed to datalayer) :>> ", dataLayerObject);
    }
  }

  // Execute on document ready
  document.addEventListener("DOMContentLoaded", () => {
    const currentStep = window.currentTicketingStep;

    const previousStep = sessionStorage.getItem("previousTicketingStep");
    sessionStorage.setItem("previousTicketingStep", currentStep);

    const isSameStep = previousStep === currentStep;
    const isConfirmation = currentStep === "confirmation";

    const cartData = window.cartFromBackend;
    const productsDiscount = window.cartProductsDiscount;

    const isTicketing = typeof currentStep !== "undefined";
    const hasCartData = typeof cartData !== "undefined";

    log("❓isTicketing :>> ", isTicketing);
    log("❓hasCartData :>> ", hasCartData, cartData);

    if (isTicketing) {
      // If page is a ticketing page

      // 1. First we get the current cart state from sessionStorage
      const storedCartState =
        JSON.parse(sessionStorage.getItem("cartState")) || [];
      log("storedCartState :>> ", storedCartState);

      // 2. Then we format the new cart state from cartData
      const currentCartState = formatProducts(cartData, productsDiscount);
      log("currentCartState :>> ", currentCartState);

      // 3. We store the new cart state in sessionStorage to be used in the next pages
      sessionStorage.setItem("cartState", JSON.stringify(currentCartState));

      const { added, removed } = compareCartStates(
        storedCartState,
        currentCartState
      );

      log("added :>> ", added);
      log("removed :>> ", removed);

      if (added.length && !isConfirmation) {
        pushEcommerce("add_to_cart", added, { ...getUserInfo() });
      }
      if (removed.length && !isConfirmation) {
        pushEcommerce("remove_from_cart", removed, { ...getUserInfo() });
      }

      switch (currentStep) {
        case "contact-details": {
          pushEcommerce(
            "begin_checkout",
            currentCartState,
            {
              ...getEcommerceDiscountInfo(),
              ...getUserInfo(),
            },
            isSameStep
          );
          break;
        }
        case "summary": {
          pushEcommerce(
            "contactdetails_checkout",
            currentCartState,
            {
              ...getEcommerceDiscountInfo(),
              ...getUserInfo(),
            },
            isSameStep
          );

          break;
        }
        case "recap": {
          pushEcommerce(
            "view_cart",
            currentCartState,
            {
              ...getEcommerceDiscountInfo(),
              ...getUserInfo(),
            },
            isSameStep
          );
          document
            .querySelector(".cart-submit-btn")
            .addEventListener("click", () => {
              pushEcommerce("add_payment_info", currentCartState, {
                ...getEcommerceDiscountInfo(),
                ...getUserInfo(),
              });
            });
          break;
        }
        case "confirmation": {
          pushEcommerce(
            "purchase",
            storedCartState,
            {
              ...getEcommerceDiscountInfo(true),
              ...getUserInfo(true),
              transaction_id: window.ticketingOrderCode,
            },
            isSameStep
          );
          sessionStorage.removeItem("cartState");
          break;
        }
      }
    }
  });
})();

(function () {
  // Config
  var config = {
    callbackTimeOutDelay: 6000,
    showLogs:
      location.hostname === "localhost" ||
      location.hostname === "nausicaa.loc" ||
      location.hostname === "nausicaa.staging42.siaxp.com",
  };

  // Initialize datalayer with existing one OR create new empty one
  window.dataLayer = window.dataLayer || [];

  // Event handler that will push event data into the datalayer
  // with a callback to follow link redirection only after the event was registered
  function menuLinkPush(event) {
    event.preventDefault();

    //propriété explicitOriginalTarget existante que sur chrome, fix temporaire potentiellement.
    var contentURL;
    if (event.explicitOriginalTarget) {
      contentURL = event.explicitOriginalTarget.href; //chrome only
    } else {
      contentURL = event.srcElement.href;
    }

    var targetBlank = event.currentTarget.target === "_blank";

    var callbackTimeout;
    var callbackExecuted = false;
    var callback = function (isTimeout) {
      clearTimeout(callbackTimeout);
      // Check if callback wasn't already executed
      // (could happen if the page has multiple GTM containers)
      if (!callbackExecuted) {
        callbackExecuted = true;
        if (targetBlank && isTimeout !== true) {
          // only use window.open in case the callback is not triggered
          // by a timeout to prevent browser blocking
          window.open(contentURL, "_blank");
        } else {
          window.location.href = contentURL;
        }
      }
    };

    if (contentURL) {
      // Prevent link redirect
      event.preventDefault();
      // Add eventCallback to event data
      let clickLabel = event.target.getAttribute("data-click-label");

      let eventData = {
        event: "click_nav_menu",
        event_info: {
          click_label: clickLabel,
        },
      };

      // if node has no childred the link has to be followed after registration,
      // else it is only use for show/hidepurpose
      const mainNav = document.querySelector(".main-nav");
      let links = mainNav.querySelectorAll("a");
      let linksArray = Array.from(links);
      let filteredLink = linksArray.filter(
        (x) => x.getAttribute("data-click-label") === clickLabel
      );
      if (!filteredLink[0].closest("li").querySelector("ul")) {
        eventData.eventCallback = callback;
      }

      // if (config.showLogs) {
      //   console.log("menuLinkPush eventData :>> ", eventData);
      // }

      // Push event data to dataLayer
      dataLayer.push(eventData);

      // force callback execution after a timeout
      callbackTimeout = setTimeout(function () {
        // pass true to callback function to handle "timeout" specific case
        if (!filteredLink[0].closest("li").querySelector("ul")) {
          callback(true);
        }
      }, config.callbackTimeOutDelay);
    }
  }

  if (document.querySelector(".main-header")) {
    const headerContainer = document.querySelector(".main-header");
    headerContainer.addEventListener("click", (event) => {
      if (event.target.classList.contains("menu-item")) {
        menuLinkPush(event);
      }
    });
  }

  document.addEventListener("click", (event) => {
    const navLink = event.target.closest(".language-link");
    if (navLink && !navLink.classList.contains("is-active")) {
      const clickedLanguage = navLink.hreflang;
      const activeLanguage = navLink
        .closest("ul")
        .querySelector(".language-link.is-active").hreflang;
      dataLayer.push({
        event: "language_modification",
        page: {
          first_language: activeLanguage,
          last_language: clickedLanguage,
        },
      });
    }
  });
})();

(function ($) {
  if (
    !!document.querySelector(".bloc-triple-push") &&
    window.innerWidth > 768
  ) {
    document
      .querySelector(".bloc-triple-push")
      .querySelectorAll(".card-title-triple-push-secondary")
      .forEach((bloc) => {
        var module = bloc;
        $clamp(module, { clamp: 2 });
      });
  }
})();

(function ($) {
  /* video vanilla fitvids version */
  // List of Video Vendors embeds you want to support
  var players = [
    'iframe[src*="youtube.com"]',
    'iframe[src*="vimeo.com"]',
    'iframe[src*="tiktok.com"]',
    'iframe[src*="facebook.com"]',
    'iframe[src*="instagram.com"]',
  ];

  // Select videos
  var fitVids = document.querySelectorAll(players.join(","));

  // If there are videos on the page...
  if (fitVids.length) {
    // Loop through videos
    for (var i = 0; i < fitVids.length; i++) {

      var fitVid = fitVids[i];
      // Handling video portrait case
      if (fitVid.getAttribute("name") === "portrait") {
        fitVid.closest(".video-container").classList.add("portrait-wrapper");
      }
      // Handling video lanscape case
      if (fitVid.getAttribute("name") === "landscape") {
        var width = fitVid.getAttribute("width");
        var height = fitVid.getAttribute("height");
        var aspectRatio = height / width;
        var parentDiv = fitVid.parentNode;

        // Wrap it in a DIV
        var div = document.createElement("div");
        div.className = "fitVids-wrapper";
        div.style.paddingBottom = aspectRatio * 100 + "%";
        parentDiv.insertBefore(div, fitVid);
        fitVid.remove();
        div.appendChild(fitVid);

        // Clear height/width from fitVid
        fitVid.removeAttribute("height");
        fitVid.removeAttribute("width");
      }
    }
  }
})();

